(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __esm = (fn2, res) => function __init() {
    return fn2 && (res = (0, fn2[__getOwnPropNames(fn2)[0]])(fn2 = 0)), res;
  };
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // assets-src/js/_0_vendor-gsap.js
  var require_vendor_gsap = __commonJS({
    "assets-src/js/_0_vendor-gsap.js"(exports, module) {
      !(function(t2, e2) {
        "object" == typeof exports && "undefined" != typeof module ? e2(exports) : "function" == typeof define && define.amd ? define(["exports"], e2) : e2((t2 = t2 || self).window = t2.window || {});
      })(exports, function(e2) {
        "use strict";
        function _inheritsLoose(t3, e3) {
          t3.prototype = Object.create(e3.prototype), (t3.prototype.constructor = t3).__proto__ = e3;
        }
        function _assertThisInitialized(t3) {
          if (void 0 === t3) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t3;
        }
        function r2(t3) {
          return "string" == typeof t3;
        }
        function s2(t3) {
          return "function" == typeof t3;
        }
        function t2(t3) {
          return "number" == typeof t3;
        }
        function u(t3) {
          return void 0 === t3;
        }
        function v(t3) {
          return "object" == typeof t3;
        }
        function w(t3) {
          return false !== t3;
        }
        function x() {
          return "undefined" != typeof window;
        }
        function y(t3) {
          return s2(t3) || r2(t3);
        }
        function P(t3) {
          return (i2 = yt2(t3, ot2)) && ze2;
        }
        function Q2(t3, e3) {
          return console.warn("Invalid property", t3, "set to", e3, "Missing plugin? gsap.registerPlugin()");
        }
        function R2(t3, e3) {
          return !e3 && console.warn(t3);
        }
        function S(t3, e3) {
          return t3 && (ot2[t3] = e3) && i2 && (i2[t3] = e3) || ot2;
        }
        function T2() {
          return 0;
        }
        function ea(t3) {
          var e3, r3, i3 = t3[0];
          if (v(i3) || s2(i3) || (t3 = [t3]), !(e3 = (i3._gsap || {}).harness)) {
            for (r3 = gt2.length; r3-- && !gt2[r3].targetTest(i3); ) ;
            e3 = gt2[r3];
          }
          for (r3 = t3.length; r3--; ) t3[r3] && (t3[r3]._gsap || (t3[r3]._gsap = new Zt2(t3[r3], e3))) || t3.splice(r3, 1);
          return t3;
        }
        function fa(t3) {
          return t3._gsap || ea(Ot(t3))[0]._gsap;
        }
        function ga(t3, e3, r3) {
          return (r3 = t3[e3]) && s2(r3) ? t3[e3]() : u(r3) && t3.getAttribute && t3.getAttribute(e3) || r3;
        }
        function ha(t3, e3) {
          return (t3 = t3.split(",")).forEach(e3) || t3;
        }
        function ia(t3) {
          return Math.round(1e5 * t3) / 1e5 || 0;
        }
        function ja(t3) {
          return Math.round(1e7 * t3) / 1e7 || 0;
        }
        function ka(t3, e3) {
          var r3 = e3.charAt(0), i3 = parseFloat(e3.substr(2));
          return t3 = parseFloat(t3), "+" === r3 ? t3 + i3 : "-" === r3 ? t3 - i3 : "*" === r3 ? t3 * i3 : t3 / i3;
        }
        function la(t3, e3) {
          for (var r3 = e3.length, i3 = 0; t3.indexOf(e3[i3]) < 0 && ++i3 < r3; ) ;
          return i3 < r3;
        }
        function ma() {
          var t3, e3, r3 = dt2.length, i3 = dt2.slice(0);
          for (ct2 = {}, t3 = dt2.length = 0; t3 < r3; t3++)
            (e3 = i3[t3]) && e3._lazy && (e3.render(e3._lazy[0], e3._lazy[1], true)._lazy = 0);
        }
        function na(t3) {
          return !!(t3._initted || t3._startAt || t3.add);
        }
        function oa(t3, e3, r3, i3) {
          dt2.length && !L2 && ma(), t3.render(e3, r3, i3 || !!(L2 && e3 < 0 && na(t3))), dt2.length && !L2 && ma();
        }
        function pa(t3) {
          var e3 = parseFloat(t3);
          return (e3 || 0 === e3) && (t3 + "").match(at2).length < 2 ? e3 : r2(t3) ? t3.trim() : t3;
        }
        function qa(t3) {
          return t3;
        }
        function ra(t3, e3) {
          for (var r3 in e3) r3 in t3 || (t3[r3] = e3[r3]);
          return t3;
        }
        function ua(t3, e3) {
          for (var r3 in e3)
            "__proto__" !== r3 && "constructor" !== r3 && "prototype" !== r3 && (t3[r3] = v(e3[r3]) ? ua(t3[r3] || (t3[r3] = {}), e3[r3]) : e3[r3]);
          return t3;
        }
        function va(t3, e3) {
          var r3, i3 = {};
          for (r3 in t3) r3 in e3 || (i3[r3] = t3[r3]);
          return i3;
        }
        function wa(t3) {
          var e3 = t3.parent || I2, r3 = t3.keyframes ? /* @__PURE__ */ (function _setKeyframeDefaults(i3) {
            return function(t4, e4) {
              for (var r4 in e4) r4 in t4 || "duration" === r4 && i3 || "ease" === r4 || (t4[r4] = e4[r4]);
            };
          })($(t3.keyframes)) : ra;
          if (w(t3.inherit)) for (; e3; ) r3(t3, e3.vars.defaults), e3 = e3.parent || e3._dp;
          return t3;
        }
        function ya(t3, e3, r3, i3, n3) {
          void 0 === r3 && (r3 = "_first"), void 0 === i3 && (i3 = "_last");
          var a2, s3 = t3[i3];
          if (n3) for (a2 = e3[n3]; s3 && s3[n3] > a2; ) s3 = s3._prev;
          return s3 ? (e3._next = s3._next, s3._next = e3) : (e3._next = t3[r3], t3[r3] = e3), e3._next ? e3._next._prev = e3 : t3[i3] = e3, e3._prev = s3, e3.parent = e3._dp = t3, e3;
        }
        function za(t3, e3, r3, i3) {
          void 0 === r3 && (r3 = "_first"), void 0 === i3 && (i3 = "_last");
          var n3 = e3._prev, a2 = e3._next;
          n3 ? n3._next = a2 : t3[r3] === e3 && (t3[r3] = a2), a2 ? a2._prev = n3 : t3[i3] === e3 && (t3[i3] = n3), e3._next = e3._prev = e3.parent = null;
        }
        function Aa(t3, e3) {
          t3.parent && (!e3 || t3.parent.autoRemoveChildren) && t3.parent.remove && t3.parent.remove(t3), t3._act = 0;
        }
        function Ba(t3, e3) {
          if (t3 && (!e3 || e3._end > t3._dur || e3._start < 0)) for (var r3 = t3; r3; ) r3._dirty = 1, r3 = r3.parent;
          return t3;
        }
        function Da(t3, e3, r3, i3) {
          return t3._startAt && (L2 ? t3._startAt.revert(ht2) : t3.vars.immediateRender && !t3.vars.autoRevert || t3._startAt.render(e3, true, i3));
        }
        function Fa(t3) {
          return t3._repeat ? Tt2(t3._tTime, t3 = t3.duration() + t3._rDelay) * t3 : 0;
        }
        function Ha(t3, e3) {
          return (t3 - e3._start) * e3._ts + (0 <= e3._ts ? 0 : e3._dirty ? e3.totalDuration() : e3._tDur);
        }
        function Ia(t3) {
          return t3._end = ja(t3._start + (t3._tDur / Math.abs(t3._ts || t3._rts || U2) || 0));
        }
        function Ja(t3, e3) {
          var r3 = t3._dp;
          return r3 && r3.smoothChildTiming && t3._ts && (t3._start = ja(r3._time - (0 < t3._ts ? e3 / t3._ts : ((t3._dirty ? t3.totalDuration() : t3._tDur) - e3) / -t3._ts)), Ia(t3), r3._dirty || Ba(r3, t3)), t3;
        }
        function Ka(t3, e3) {
          var r3;
          if ((e3._time || !e3._dur && e3._initted || e3._start < t3._time && (e3._dur || !e3.add)) && (r3 = Ha(t3.rawTime(), e3), (!e3._dur || Mt2(0, e3.totalDuration(), r3) - e3._tTime > U2) && e3.render(r3, true)), Ba(t3, e3)._dp && t3._initted && t3._time >= t3._dur && t3._ts) {
            if (t3._dur < t3.duration()) for (r3 = t3; r3._dp; ) 0 <= r3.rawTime() && r3.totalTime(r3._tTime), r3 = r3._dp;
            t3._zTime = -U2;
          }
        }
        function La(e3, r3, i3, n3) {
          return r3.parent && Aa(r3), r3._start = ja((t2(i3) ? i3 : i3 || e3 !== I2 ? xt2(e3, i3, r3) : e3._time) + r3._delay), r3._end = ja(r3._start + (r3.totalDuration() / Math.abs(r3.timeScale()) || 0)), ya(e3, r3, "_first", "_last", e3._sort ? "_start" : 0), bt2(r3) || (e3._recent = r3), n3 || Ka(e3, r3), e3._ts < 0 && Ja(e3, e3._tTime), e3;
        }
        function Ma(t3, e3) {
          return (ot2.ScrollTrigger || Q2("scrollTrigger", e3)) && ot2.ScrollTrigger.create(e3, t3);
        }
        function Na(t3, e3, r3, i3, n3) {
          return Wt2(t3, e3, n3), t3._initted ? !r3 && t3._pt && !L2 && (t3._dur && false !== t3.vars.lazy || !t3._dur && t3.vars.lazy) && f !== Rt2.frame ? (dt2.push(t3), t3._lazy = [n3, i3], 1) : void 0 : 1;
        }
        function Sa(t3, e3, r3, i3) {
          var n3 = t3._repeat, a2 = ja(e3) || 0, s3 = t3._tTime / t3._tDur;
          return s3 && !i3 && (t3._time *= a2 / t3._dur), t3._dur = a2, t3._tDur = n3 ? n3 < 0 ? 1e10 : ja(a2 * (n3 + 1) + t3._rDelay * n3) : a2, 0 < s3 && !i3 && Ja(t3, t3._tTime = t3._tDur * s3), t3.parent && Ia(t3), r3 || Ba(t3.parent, t3), t3;
        }
        function Ta(t3) {
          return t3 instanceof Qt2 ? Ba(t3) : Sa(t3, t3._dur);
        }
        function Wa(e3, r3, i3) {
          var n3, a2, s3 = t2(r3[1]), o3 = (s3 ? 2 : 1) + (e3 < 2 ? 0 : 1), u2 = r3[o3];
          if (s3 && (u2.duration = r3[1]), u2.parent = i3, e3) {
            for (n3 = u2, a2 = i3; a2 && !("immediateRender" in n3); )
              n3 = a2.vars.defaults || {}, a2 = w(a2.vars.inherit) && a2.parent;
            u2.immediateRender = w(n3.immediateRender), e3 < 2 ? u2.runBackwards = 1 : u2.startAt = r3[o3 - 1];
          }
          return new Jt2(r3[0], u2, r3[1 + o3]);
        }
        function Xa(t3, e3) {
          return t3 || 0 === t3 ? e3(t3) : e3;
        }
        function Za(t3, e3) {
          return r2(t3) && (e3 = st2.exec(t3)) ? e3[1] : "";
        }
        function ab(t3, e3) {
          return t3 && v(t3) && "length" in t3 && (!e3 && !t3.length || t3.length - 1 in t3 && v(t3[0])) && !t3.nodeType && t3 !== h;
        }
        function db(r3) {
          return r3 = Ot(r3)[0] || R2("Invalid scope") || {}, function(t3) {
            var e3 = r3.current || r3.nativeElement || r3;
            return Ot(t3, e3.querySelectorAll ? e3 : e3 === r3 ? R2("Invalid scope") || a.createElement("div") : r3);
          };
        }
        function eb(t3) {
          return t3.sort(function() {
            return 0.5 - Math.random();
          });
        }
        function fb(t3) {
          if (s2(t3)) return t3;
          var p2 = v(t3) ? t3 : { each: t3 }, _2 = Yt2(p2.ease), m2 = p2.from || 0, g2 = parseFloat(p2.base) || 0, y2 = {}, e3 = 0 < m2 && m2 < 1, T3 = isNaN(m2) || e3, b2 = p2.axis, w2 = m2, x2 = m2;
          return r2(m2) ? w2 = x2 = { center: 0.5, edges: 0.5, end: 1 }[m2] || 0 : !e3 && T3 && (w2 = m2[0], x2 = m2[1]), function(t4, e4, r3) {
            var i3, n3, a2, s3, o3, u2, h2, l3, f2, d3 = (r3 || p2).length, c2 = y2[d3];
            if (!c2) {
              if (!(f2 = "auto" === p2.grid ? 0 : (p2.grid || [1, N2])[1])) {
                for (h2 = -N2; h2 < (h2 = r3[f2++].getBoundingClientRect().left) && f2 < d3; ) ;
                f2 < d3 && f2--;
              }
              for (c2 = y2[d3] = [], i3 = T3 ? Math.min(f2, d3) * w2 - 0.5 : m2 % f2, n3 = f2 === N2 ? 0 : T3 ? d3 * x2 / f2 - 0.5 : m2 / f2 | 0, l3 = N2, u2 = h2 = 0; u2 < d3; u2++)
                a2 = u2 % f2 - i3, s3 = n3 - (u2 / f2 | 0), c2[u2] = o3 = b2 ? Math.abs("y" === b2 ? s3 : a2) : G2(a2 * a2 + s3 * s3), h2 < o3 && (h2 = o3), o3 < l3 && (l3 = o3);
              "random" === m2 && eb(c2), c2.max = h2 - l3, c2.min = l3, c2.v = d3 = (parseFloat(p2.amount) || parseFloat(p2.each) * (d3 < f2 ? d3 - 1 : b2 ? "y" === b2 ? d3 / f2 : f2 : Math.max(f2, d3 / f2)) || 0) * ("edges" === m2 ? -1 : 1), c2.b = d3 < 0 ? g2 - d3 : g2, c2.u = Za(p2.amount || p2.each) || 0, _2 = _2 && d3 < 0 ? jt2(_2) : _2;
            }
            return d3 = (c2[t4] - c2.min) / c2.max || 0, ja(c2.b + (_2 ? _2(d3) : d3) * c2.v) + c2.u;
          };
        }
        function gb(i3) {
          var n3 = Math.pow(10, ((i3 + "").split(".")[1] || "").length);
          return function(e3) {
            var r3 = ja(Math.round(parseFloat(e3) / i3) * i3 * n3);
            return (r3 - r3 % 1) / n3 + (t2(e3) ? 0 : Za(e3));
          };
        }
        function hb(h2, e3) {
          var l3, f2, r3 = $(h2);
          return !r3 && v(h2) && (l3 = r3 = h2.radius || N2, h2.values ? (h2 = Ot(h2.values), (f2 = !t2(h2[0])) && (l3 *= l3)) : h2 = gb(h2.increment)), Xa(
            e3,
            r3 ? s2(h2) ? function(t3) {
              return f2 = h2(t3), Math.abs(f2 - t3) <= l3 ? f2 : t3;
            } : function(e4) {
              for (var r4, i3, n3 = parseFloat(f2 ? e4.x : e4), a2 = parseFloat(f2 ? e4.y : 0), s3 = N2, o3 = 0, u2 = h2.length; u2--; )
                (r4 = f2 ? (r4 = h2[u2].x - n3) * r4 + (i3 = h2[u2].y - a2) * i3 : Math.abs(h2[u2] - n3)) < s3 && (s3 = r4, o3 = u2);
              return o3 = !l3 || s3 <= l3 ? h2[o3] : e4, f2 || o3 === e4 || t2(e4) ? o3 : o3 + Za(e4);
            } : gb(h2)
          );
        }
        function ib(t3, e3, r3, i3) {
          return Xa($(t3) ? !e3 : true === r3 ? !!(r3 = 0) : !i3, function() {
            return $(t3) ? t3[~~(Math.random() * t3.length)] : (r3 = r3 || 1e-5) && (i3 = r3 < 1 ? Math.pow(10, (r3 + "").length - 2) : 1) && Math.floor(Math.round((t3 - r3 / 2 + Math.random() * (e3 - t3 + 0.99 * r3)) / r3) * r3 * i3) / i3;
          });
        }
        function mb(e3, r3, t3) {
          return Xa(t3, function(t4) {
            return e3[~~r3(t4)];
          });
        }
        function pb(t3) {
          for (var e3, r3, i3, n3, a2 = 0, s3 = ""; ~(e3 = t3.indexOf("random(", a2)); )
            i3 = t3.indexOf(")", e3), n3 = "[" === t3.charAt(e3 + 7), r3 = t3.substr(e3 + 7, i3 - e3 - 7).match(n3 ? at2 : tt2), s3 += t3.substr(a2, e3 - a2) + ib(n3 ? r3 : +r3[0], n3 ? 0 : +r3[1], +r3[2] || 1e-5), a2 = i3 + 1;
          return s3 + t3.substr(a2, t3.length - a2);
        }
        function sb(t3, e3, r3) {
          var i3, n3, a2, s3 = t3.labels, o3 = N2;
          for (i3 in s3) (n3 = s3[i3] - e3) < 0 == !!r3 && n3 && o3 > (n3 = Math.abs(n3)) && (a2 = i3, o3 = n3);
          return a2;
        }
        function ub(t3) {
          return Aa(t3), t3.scrollTrigger && t3.scrollTrigger.kill(!!L2), t3.progress() < 1 && Pt2(t3, "onInterrupt"), t3;
        }
        function xb(t3) {
          if (t3)
            if (t3 = !t3.name && t3.default || t3, x() || t3.headless) {
              var e3 = t3.name, r3 = s2(t3), i3 = e3 && !r3 && t3.init ? function() {
                this._props = [];
              } : t3, n3 = { init: T2, render: ue2, add: Vt2, kill: de2, modifier: he2, rawVars: 0 }, a2 = { targetTest: 0, get: 0, getSetter: ie, aliases: {}, register: 0 };
              if (Ft2(), t3 !== i3) {
                if (pt2[e3]) return;
                ra(i3, ra(va(t3, n3), a2)), yt2(i3.prototype, yt2(n3, va(t3, a2))), pt2[i3.prop = e3] = i3, t3.targetTest && (gt2.push(i3), ft2[e3] = 1), e3 = ("css" === e3 ? "CSS" : e3.charAt(0).toUpperCase() + e3.substr(1)) + "Plugin";
              }
              S(e3, i3), t3.register && t3.register(ze2, i3, ge2);
            } else Ct2.push(t3);
        }
        function Ab(t3, e3, r3) {
          return (6 * (t3 += t3 < 0 ? 1 : 1 < t3 ? -1 : 0) < 1 ? e3 + (r3 - e3) * t3 * 6 : t3 < 0.5 ? r3 : 3 * t3 < 2 ? e3 + (r3 - e3) * (2 / 3 - t3) * 6 : e3) * St2 + 0.5 | 0;
        }
        function Bb(e3, r3, i3) {
          var n3, a2, s3, o3, u2, h2, l3, f2, d3, c2, p2 = e3 ? t2(e3) ? [e3 >> 16, e3 >> 8 & St2, e3 & St2] : 0 : Dt2.black;
          if (!p2) {
            if ("," === e3.substr(-1) && (e3 = e3.substr(0, e3.length - 1)), Dt2[e3]) p2 = Dt2[e3];
            else if ("#" === e3.charAt(0)) {
              if (e3.length < 6 && (e3 = "#" + (n3 = e3.charAt(1)) + n3 + (a2 = e3.charAt(2)) + a2 + (s3 = e3.charAt(3)) + s3 + (5 === e3.length ? e3.charAt(4) + e3.charAt(4) : "")), 9 === e3.length)
                return [(p2 = parseInt(e3.substr(1, 6), 16)) >> 16, p2 >> 8 & St2, p2 & St2, parseInt(e3.substr(7), 16) / 255];
              p2 = [(e3 = parseInt(e3.substr(1), 16)) >> 16, e3 >> 8 & St2, e3 & St2];
            } else if ("hsl" === e3.substr(0, 3))
              if (p2 = c2 = e3.match(tt2), r3) {
                if (~e3.indexOf("=")) return p2 = e3.match(et2), i3 && p2.length < 4 && (p2[3] = 1), p2;
              } else
                o3 = +p2[0] % 360 / 360, u2 = p2[1] / 100, n3 = 2 * (h2 = p2[2] / 100) - (a2 = h2 <= 0.5 ? h2 * (u2 + 1) : h2 + u2 - h2 * u2), 3 < p2.length && (p2[3] *= 1), p2[0] = Ab(o3 + 1 / 3, n3, a2), p2[1] = Ab(o3, n3, a2), p2[2] = Ab(o3 - 1 / 3, n3, a2);
            else p2 = e3.match(tt2) || Dt2.transparent;
            p2 = p2.map(Number);
          }
          return r3 && !c2 && (n3 = p2[0] / St2, a2 = p2[1] / St2, s3 = p2[2] / St2, h2 = ((l3 = Math.max(n3, a2, s3)) + (f2 = Math.min(n3, a2, s3))) / 2, l3 === f2 ? o3 = u2 = 0 : (d3 = l3 - f2, u2 = 0.5 < h2 ? d3 / (2 - l3 - f2) : d3 / (l3 + f2), o3 = l3 === n3 ? (a2 - s3) / d3 + (a2 < s3 ? 6 : 0) : l3 === a2 ? (s3 - n3) / d3 + 2 : (n3 - a2) / d3 + 4, o3 *= 60), p2[0] = ~~(o3 + 0.5), p2[1] = ~~(100 * u2 + 0.5), p2[2] = ~~(100 * h2 + 0.5)), i3 && p2.length < 4 && (p2[3] = 1), p2;
        }
        function Cb(t3) {
          var r3 = [], i3 = [], n3 = -1;
          return t3.split(zt2).forEach(function(t4) {
            var e3 = t4.match(rt2) || [];
            r3.push.apply(r3, e3), i3.push(n3 += e3.length + 1);
          }), r3.c = i3, r3;
        }
        function Db(t3, e3, r3) {
          var i3, n3, a2, s3, o3 = "", u2 = (t3 + o3).match(zt2), h2 = e3 ? "hsla(" : "rgba(", l3 = 0;
          if (!u2) return t3;
          if (u2 = u2.map(function(t4) {
            return (t4 = Bb(t4, e3, 1)) && h2 + (e3 ? t4[0] + "," + t4[1] + "%," + t4[2] + "%," + t4[3] : t4.join(",")) + ")";
          }), r3 && (a2 = Cb(t3), (i3 = r3.c).join(o3) !== a2.c.join(o3)))
            for (s3 = (n3 = t3.replace(zt2, "1").split(rt2)).length - 1; l3 < s3; l3++)
              o3 += n3[l3] + (~i3.indexOf(l3) ? u2.shift() || h2 + "0,0,0,0)" : (a2.length ? a2 : u2.length ? u2 : r3).shift());
          if (!n3) for (s3 = (n3 = t3.split(zt2)).length - 1; l3 < s3; l3++) o3 += n3[l3] + u2[l3];
          return o3 + n3[s3];
        }
        function Gb(t3) {
          var e3, r3 = t3.join(" ");
          if (zt2.lastIndex = 0, zt2.test(r3))
            return e3 = Et2.test(r3), t3[1] = Db(t3[1], e3), t3[0] = Db(t3[0], e3, Cb(t3[1])), true;
        }
        function Pb(t3) {
          var e3 = (t3 + "").split("("), r3 = Lt2[e3[0]];
          return r3 && 1 < e3.length && r3.config ? r3.config.apply(
            null,
            ~t3.indexOf("{") ? [
              (function _parseObjectInString(t4) {
                for (var e4, r4, i3, n3 = {}, a2 = t4.substr(1, t4.length - 3).split(":"), s3 = a2[0], o3 = 1, u2 = a2.length; o3 < u2; o3++)
                  r4 = a2[o3], e4 = o3 !== u2 - 1 ? r4.lastIndexOf(",") : r4.length, i3 = r4.substr(0, e4), n3[s3] = isNaN(i3) ? i3.replace(Bt2, "").trim() : +i3, s3 = r4.substr(e4 + 1).trim();
                return n3;
              })(e3[1])
            ] : (function _valueInParentheses(t4) {
              var e4 = t4.indexOf("(") + 1, r4 = t4.indexOf(")"), i3 = t4.indexOf("(", e4);
              return t4.substring(e4, ~i3 && i3 < r4 ? t4.indexOf(")", r4 + 1) : r4);
            })(t3).split(",").map(pa)
          ) : Lt2._CE && It2.test(t3) ? Lt2._CE("", t3) : r3;
        }
        function Rb(t3, e3) {
          for (var r3, i3 = t3._first; i3; )
            i3 instanceof Qt2 ? Rb(i3, e3) : !i3.vars.yoyoEase || i3._yoyo && i3._repeat || i3._yoyo === e3 || (i3.timeline ? Rb(i3.timeline, e3) : (r3 = i3._ease, i3._ease = i3._yEase, i3._yEase = r3, i3._yoyo = e3)), i3 = i3._next;
        }
        function Tb(t3, e3, r3, i3) {
          void 0 === r3 && (r3 = function easeOut(t4) {
            return 1 - e3(1 - t4);
          }), void 0 === i3 && (i3 = function easeInOut(t4) {
            return t4 < 0.5 ? e3(2 * t4) / 2 : 1 - e3(2 * (1 - t4)) / 2;
          });
          var n3, a2 = { easeIn: e3, easeOut: r3, easeInOut: i3 };
          return ha(t3, function(t4) {
            for (var e4 in Lt2[t4] = ot2[t4] = a2, Lt2[n3 = t4.toLowerCase()] = r3, a2)
              Lt2[n3 + ("easeIn" === e4 ? ".in" : "easeOut" === e4 ? ".out" : ".inOut")] = Lt2[t4 + "." + e4] = a2[e4];
          }), a2;
        }
        function Ub(e3) {
          return function(t3) {
            return t3 < 0.5 ? (1 - e3(1 - 2 * t3)) / 2 : 0.5 + e3(2 * (t3 - 0.5)) / 2;
          };
        }
        function Vb(r3, t3, e3) {
          function Lm(t4) {
            return 1 === t4 ? 1 : i3 * Math.pow(2, -10 * t4) * K2((t4 - a2) * n3) + 1;
          }
          var i3 = 1 <= t3 ? t3 : 1, n3 = (e3 || (r3 ? 0.3 : 0.45)) / (t3 < 1 ? t3 : 1), a2 = n3 / q2 * (Math.asin(1 / i3) || 0), s3 = "out" === r3 ? Lm : "in" === r3 ? function(t4) {
            return 1 - Lm(1 - t4);
          } : Ub(Lm);
          return n3 = q2 / n3, s3.config = function(t4, e4) {
            return Vb(r3, t4, e4);
          }, s3;
        }
        function Wb(e3, r3) {
          function Tm(t4) {
            return t4 ? --t4 * t4 * ((r3 + 1) * t4 + r3) + 1 : 0;
          }
          void 0 === r3 && (r3 = 1.70158);
          var t3 = "out" === e3 ? Tm : "in" === e3 ? function(t4) {
            return 1 - Tm(1 - t4);
          } : Ub(Tm);
          return t3.config = function(t4) {
            return Wb(e3, t4);
          }, t3;
        }
        var F2, L2, l2, I2, h, n2, a, i2, o2, f, d2, c, p, _, m, g, b, M2, k2, O2, A2, C2, D, z2, E, B2, j2, Y2, X3 = { autoSleep: 120, force3D: "auto", nullTargetWarn: 1, units: { lineHeight: "" } }, Z2 = { duration: 0.5, overwrite: false, delay: 0 }, N2 = 1e8, U2 = 1 / N2, q2 = 2 * Math.PI, V2 = q2 / 4, W2 = 0, G2 = Math.sqrt, H2 = Math.cos, K2 = Math.sin, J2 = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function() {
        }, $ = Array.isArray, tt2 = /(?:-?\.?\d|\.)+/gi, et2 = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, rt2 = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, it2 = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, nt = /[+-]=-?[.\d]+/, at2 = /[^,'"\[\]\s]+/gi, st2 = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, ot2 = {}, ut2 = { suppressEvents: true, isStart: true, kill: false }, ht2 = { suppressEvents: true, kill: false }, lt2 = { suppressEvents: true }, ft2 = {}, dt2 = [], ct2 = {}, pt2 = {}, _t2 = {}, mt2 = 30, gt2 = [], vt2 = "", yt2 = function _merge(t3, e3) {
          for (var r3 in e3) t3[r3] = e3[r3];
          return t3;
        }, Tt2 = function _animationCycle(t3, e3) {
          var r3 = Math.floor(t3 = ja(t3 / e3));
          return t3 && r3 === t3 ? r3 - 1 : r3;
        }, bt2 = function _isFromOrFromStart(t3) {
          var e3 = t3.data;
          return "isFromStart" === e3 || "isStart" === e3;
        }, wt2 = { _start: 0, endTime: T2, totalDuration: T2 }, xt2 = function _parsePosition(t3, e3, i3) {
          var n3, a2, s3, o3 = t3.labels, u2 = t3._recent || wt2, h2 = t3.duration() >= N2 ? u2.endTime(false) : t3._dur;
          return r2(e3) && (isNaN(e3) || e3 in o3) ? (a2 = e3.charAt(0), s3 = "%" === e3.substr(-1), n3 = e3.indexOf("="), "<" === a2 || ">" === a2 ? (0 <= n3 && (e3 = e3.replace(/=/, "")), ("<" === a2 ? u2._start : u2.endTime(0 <= u2._repeat)) + (parseFloat(e3.substr(1)) || 0) * (s3 ? (n3 < 0 ? u2 : i3).totalDuration() / 100 : 1)) : n3 < 0 ? (e3 in o3 || (o3[e3] = h2), o3[e3]) : (a2 = parseFloat(e3.charAt(n3 - 1) + e3.substr(n3 + 1)), s3 && i3 && (a2 = a2 / 100 * ($(i3) ? i3[0] : i3).totalDuration()), 1 < n3 ? _parsePosition(t3, e3.substr(0, n3 - 1), i3) + a2 : h2 + a2)) : null == e3 ? h2 : +e3;
        }, Mt2 = function _clamp(t3, e3, r3) {
          return r3 < t3 ? t3 : e3 < r3 ? e3 : r3;
        }, kt2 = [].slice, Ot = function toArray(t3, e3, i3) {
          return l2 && !e3 && l2.selector ? l2.selector(t3) : !r2(t3) || i3 || !n2 && Ft2() ? $(t3) ? (function _flatten(t4, e4, i4) {
            return void 0 === i4 && (i4 = []), t4.forEach(function(t5) {
              return r2(t5) && !e4 || ab(t5, 1) ? i4.push.apply(i4, Ot(t5)) : i4.push(t5);
            }) || i4;
          })(t3, i3) : ab(t3) ? kt2.call(t3, 0) : t3 ? [t3] : [] : kt2.call((e3 || a).querySelectorAll(t3), 0);
        }, At2 = function mapRange(e3, t3, r3, i3, n3) {
          var a2 = t3 - e3, s3 = i3 - r3;
          return Xa(n3, function(t4) {
            return r3 + ((t4 - e3) / a2 * s3 || 0);
          });
        }, Pt2 = function _callback(t3, e3, r3) {
          var i3, n3, a2, s3 = t3.vars, o3 = s3[e3], u2 = l2, h2 = t3._ctx;
          if (o3)
            return i3 = s3[e3 + "Params"], n3 = s3.callbackScope || t3, r3 && dt2.length && ma(), h2 && (l2 = h2), a2 = i3 ? o3.apply(n3, i3) : o3.call(n3), l2 = u2, a2;
        }, Ct2 = [], St2 = 255, Dt2 = {
          aqua: [0, St2, St2],
          lime: [0, St2, 0],
          silver: [192, 192, 192],
          black: [0, 0, 0],
          maroon: [128, 0, 0],
          teal: [0, 128, 128],
          blue: [0, 0, St2],
          navy: [0, 0, 128],
          white: [St2, St2, St2],
          olive: [128, 128, 0],
          yellow: [St2, St2, 0],
          orange: [St2, 165, 0],
          gray: [128, 128, 128],
          purple: [128, 0, 128],
          green: [0, 128, 0],
          red: [St2, 0, 0],
          pink: [St2, 192, 203],
          cyan: [0, St2, St2],
          transparent: [St2, St2, St2, 0]
        }, zt2 = (function() {
          var t3, e3 = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
          for (t3 in Dt2) e3 += "|" + t3 + "\\b";
          return new RegExp(e3 + ")", "gi");
        })(), Et2 = /hsl[a]?\(/, Rt2 = (k2 = Date.now, O2 = 500, A2 = 33, C2 = k2(), D = C2, E = z2 = 1e3 / 240, g = {
          time: 0,
          frame: 0,
          tick: function tick() {
            Al(true);
          },
          deltaRatio: function deltaRatio(t3) {
            return b / (1e3 / (t3 || 60));
          },
          wake: function wake() {
            o2 && (!n2 && x() && (h = n2 = window, a = h.document || {}, ot2.gsap = ze2, (h.gsapVersions || (h.gsapVersions = [])).push(ze2.version), P(i2 || h.GreenSockGlobals || !h.gsap && h || {}), Ct2.forEach(xb)), m = "undefined" != typeof requestAnimationFrame && requestAnimationFrame, p && g.sleep(), _ = m || function(t3) {
              return setTimeout(t3, E - 1e3 * g.time + 1 | 0);
            }, c = 1, Al(2));
          },
          sleep: function sleep() {
            (m ? cancelAnimationFrame : clearTimeout)(p), c = 0, _ = T2;
          },
          lagSmoothing: function lagSmoothing(t3, e3) {
            O2 = t3 || 1 / 0, A2 = Math.min(e3 || 33, O2);
          },
          fps: function fps(t3) {
            z2 = 1e3 / (t3 || 240), E = 1e3 * g.time + z2;
          },
          add: function add(n3, t3, e3) {
            var a2 = t3 ? function(t4, e4, r3, i3) {
              n3(t4, e4, r3, i3), g.remove(a2);
            } : n3;
            return g.remove(n3), B2[e3 ? "unshift" : "push"](a2), Ft2(), a2;
          },
          remove: function remove(t3, e3) {
            ~(e3 = B2.indexOf(t3)) && B2.splice(e3, 1) && e3 <= M2 && M2--;
          },
          _listeners: B2 = []
        }), Ft2 = function _wake() {
          return !c && Rt2.wake();
        }, Lt2 = {}, It2 = /^[\d.\-M][\d.\-,\s]/, Bt2 = /["']/g, jt2 = function _invertEase(e3) {
          return function(t3) {
            return 1 - e3(1 - t3);
          };
        }, Yt2 = function _parseEase(t3, e3) {
          return t3 && (s2(t3) ? t3 : Lt2[t3] || Pb(t3)) || e3;
        };
        function Al(t3) {
          var e3, r3, i3, n3, a2 = k2() - D, s3 = true === t3;
          if ((O2 < a2 || a2 < 0) && (C2 += a2 - A2), (0 < (e3 = (i3 = (D += a2) - C2) - E) || s3) && (n3 = ++g.frame, b = i3 - 1e3 * g.time, g.time = i3 /= 1e3, E += e3 + (z2 <= e3 ? 4 : z2 - e3), r3 = 1), s3 || (p = _(Al)), r3)
            for (M2 = 0; M2 < B2.length; M2++) B2[M2](i3, b, n3, t3);
        }
        function jn2(t3) {
          return t3 < Y2 ? j2 * t3 * t3 : t3 < 0.7272727272727273 ? j2 * Math.pow(t3 - 1.5 / 2.75, 2) + 0.75 : t3 < 0.9090909090909092 ? j2 * (t3 -= 2.25 / 2.75) * t3 + 0.9375 : j2 * Math.pow(t3 - 2.625 / 2.75, 2) + 0.984375;
        }
        ha("Linear,Quad,Cubic,Quart,Quint,Strong", function(t3, e3) {
          var r3 = e3 < 5 ? e3 + 1 : e3;
          Tb(
            t3 + ",Power" + (r3 - 1),
            e3 ? function(t4) {
              return Math.pow(t4, r3);
            } : function(t4) {
              return t4;
            },
            function(t4) {
              return 1 - Math.pow(1 - t4, r3);
            },
            function(t4) {
              return t4 < 0.5 ? Math.pow(2 * t4, r3) / 2 : 1 - Math.pow(2 * (1 - t4), r3) / 2;
            }
          );
        }), Lt2.Linear.easeNone = Lt2.none = Lt2.Linear.easeIn, Tb("Elastic", Vb("in"), Vb("out"), Vb()), j2 = 7.5625, Y2 = 1 / 2.75, Tb(
          "Bounce",
          function(t3) {
            return 1 - jn2(1 - t3);
          },
          jn2
        ), Tb("Expo", function(t3) {
          return Math.pow(2, 10 * (t3 - 1)) * t3 + t3 * t3 * t3 * t3 * t3 * t3 * (1 - t3);
        }), Tb("Circ", function(t3) {
          return -(G2(1 - t3 * t3) - 1);
        }), Tb("Sine", function(t3) {
          return 1 === t3 ? 1 : 1 - H2(t3 * V2);
        }), Tb("Back", Wb("in"), Wb("out"), Wb()), Lt2.SteppedEase = Lt2.steps = ot2.SteppedEase = {
          config: function config(t3, e3) {
            void 0 === t3 && (t3 = 1);
            var r3 = 1 / t3, i3 = t3 + (e3 ? 0 : 1), n3 = e3 ? 1 : 0;
            return function(t4) {
              return ((i3 * Mt2(0, 0.99999999, t4) | 0) + n3) * r3;
            };
          }
        }, Z2.ease = Lt2["quad.out"], ha("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(t3) {
          return vt2 += t3 + "," + t3 + "Params,";
        });
        var Xt2, Zt2 = function GSCache(t3, e3) {
          this.id = W2++, (t3._gsap = this).target = t3, this.harness = e3, this.get = e3 ? e3.get : ga, this.set = e3 ? e3.getSetter : ie;
        }, Nt2 = ((Xt2 = Animation.prototype).delay = function delay(t3) {
          return t3 || 0 === t3 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t3 - this._delay), this._delay = t3, this) : this._delay;
        }, Xt2.duration = function duration(t3) {
          return arguments.length ? this.totalDuration(0 < this._repeat ? t3 + (t3 + this._rDelay) * this._repeat : t3) : this.totalDuration() && this._dur;
        }, Xt2.totalDuration = function totalDuration(t3) {
          return arguments.length ? (this._dirty = 0, Sa(this, this._repeat < 0 ? t3 : (t3 - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
        }, Xt2.totalTime = function totalTime(t3, e3) {
          if (Ft2(), !arguments.length) return this._tTime;
          var r3 = this._dp;
          if (r3 && r3.smoothChildTiming && this._ts) {
            for (Ja(this, t3), !r3._dp || r3.parent || Ka(r3, this); r3 && r3.parent; )
              r3.parent._time !== r3._start + (0 <= r3._ts ? r3._tTime / r3._ts : (r3.totalDuration() - r3._tTime) / -r3._ts) && r3.totalTime(r3._tTime, true), r3 = r3.parent;
            !this.parent && this._dp.autoRemoveChildren && (0 < this._ts && t3 < this._tDur || this._ts < 0 && 0 < t3 || !this._tDur && !t3) && La(this._dp, this, this._start - this._delay);
          }
          return (this._tTime !== t3 || !this._dur && !e3 || this._initted && Math.abs(this._zTime) === U2 || !t3 && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = t3), oa(this, t3, e3)), this;
        }, Xt2.time = function time(t3, e3) {
          return arguments.length ? this.totalTime(
            Math.min(this.totalDuration(), t3 + Fa(this)) % (this._dur + this._rDelay) || (t3 ? this._dur : 0),
            e3
          ) : this._time;
        }, Xt2.totalProgress = function totalProgress(t3, e3) {
          return arguments.length ? this.totalTime(this.totalDuration() * t3, e3) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : 0 <= this.rawTime() && this._initted ? 1 : 0;
        }, Xt2.progress = function progress(t3, e3) {
          return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t3 : 1 - t3) + Fa(this), e3) : this.duration() ? Math.min(1, this._time / this._dur) : 0 < this.rawTime() ? 1 : 0;
        }, Xt2.iteration = function iteration(t3, e3) {
          var r3 = this.duration() + this._rDelay;
          return arguments.length ? this.totalTime(this._time + (t3 - 1) * r3, e3) : this._repeat ? Tt2(this._tTime, r3) + 1 : 1;
        }, Xt2.timeScale = function timeScale(t3, e3) {
          if (!arguments.length) return this._rts === -U2 ? 0 : this._rts;
          if (this._rts === t3) return this;
          var r3 = this.parent && this._ts ? Ha(this.parent._time, this) : this._tTime;
          return this._rts = +t3 || 0, this._ts = this._ps || t3 === -U2 ? 0 : this._rts, this.totalTime(Mt2(-Math.abs(this._delay), this.totalDuration(), r3), false !== e3), Ia(this), (function _recacheAncestors(t4) {
            for (var e4 = t4.parent; e4 && e4.parent; ) e4._dirty = 1, e4.totalDuration(), e4 = e4.parent;
            return t4;
          })(this);
        }, Xt2.paused = function paused(t3) {
          return arguments.length ? (this._ps !== t3 && ((this._ps = t3) ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Ft2(), this._ts = this._rts, this.totalTime(
            this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime,
            1 === this.progress() && Math.abs(this._zTime) !== U2 && (this._tTime -= U2)
          ))), this) : this._ps;
        }, Xt2.startTime = function startTime(t3) {
          if (arguments.length) {
            this._start = t3;
            var e3 = this.parent || this._dp;
            return !e3 || !e3._sort && this.parent || La(e3, this, t3 - this._delay), this;
          }
          return this._start;
        }, Xt2.endTime = function endTime(t3) {
          return this._start + (w(t3) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
        }, Xt2.rawTime = function rawTime(t3) {
          var e3 = this.parent || this._dp;
          return e3 ? t3 && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Ha(e3.rawTime(t3), this) : this._tTime : this._tTime;
        }, Xt2.revert = function revert(t3) {
          void 0 === t3 && (t3 = lt2);
          var e3 = L2;
          return L2 = t3, na(this) && (this.timeline && this.timeline.revert(t3), this.totalTime(-0.01, t3.suppressEvents)), "nested" !== this.data && false !== t3.kill && this.kill(), L2 = e3, this;
        }, Xt2.globalTime = function globalTime(t3) {
          for (var e3 = this, r3 = arguments.length ? t3 : e3.rawTime(); e3; )
            r3 = e3._start + r3 / (Math.abs(e3._ts) || 1), e3 = e3._dp;
          return !this.parent && this._sat ? this._sat.globalTime(t3) : r3;
        }, Xt2.repeat = function repeat(t3) {
          return arguments.length ? (this._repeat = t3 === 1 / 0 ? -2 : t3, Ta(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
        }, Xt2.repeatDelay = function repeatDelay(t3) {
          if (arguments.length) {
            var e3 = this._time;
            return this._rDelay = t3, Ta(this), e3 ? this.time(e3) : this;
          }
          return this._rDelay;
        }, Xt2.yoyo = function yoyo(t3) {
          return arguments.length ? (this._yoyo = t3, this) : this._yoyo;
        }, Xt2.seek = function seek(t3, e3) {
          return this.totalTime(xt2(this, t3), w(e3));
        }, Xt2.restart = function restart(t3, e3) {
          return this.play().totalTime(t3 ? -this._delay : 0, w(e3)), this._dur || (this._zTime = -U2), this;
        }, Xt2.play = function play(t3, e3) {
          return null != t3 && this.seek(t3, e3), this.reversed(false).paused(false);
        }, Xt2.reverse = function reverse(t3, e3) {
          return null != t3 && this.seek(t3 || this.totalDuration(), e3), this.reversed(true).paused(false);
        }, Xt2.pause = function pause(t3, e3) {
          return null != t3 && this.seek(t3, e3), this.paused(true);
        }, Xt2.resume = function resume() {
          return this.paused(false);
        }, Xt2.reversed = function reversed(t3) {
          return arguments.length ? (!!t3 !== this.reversed() && this.timeScale(-this._rts || (t3 ? -U2 : 0)), this) : this._rts < 0;
        }, Xt2.invalidate = function invalidate() {
          return this._initted = this._act = 0, this._zTime = -U2, this;
        }, Xt2.isActive = function isActive() {
          var t3, e3 = this.parent || this._dp, r3 = this._start;
          return !(e3 && !(this._ts && this._initted && e3.isActive() && (t3 = e3.rawTime(true)) >= r3 && t3 < this.endTime(true) - U2));
        }, Xt2.eventCallback = function eventCallback(t3, e3, r3) {
          var i3 = this.vars;
          return 1 < arguments.length ? (e3 ? (i3[t3] = e3, r3 && (i3[t3 + "Params"] = r3), "onUpdate" === t3 && (this._onUpdate = e3)) : delete i3[t3], this) : i3[t3];
        }, Xt2.then = function then(t3) {
          var i3 = this;
          return new Promise(function(e3) {
            function Eo2() {
              var t4 = i3.then;
              i3.then = null, s2(r3) && (r3 = r3(i3)) && (r3.then || r3 === i3) && (i3.then = t4), e3(r3), i3.then = t4;
            }
            var r3 = s2(t3) ? t3 : qa;
            i3._initted && 1 === i3.totalProgress() && 0 <= i3._ts || !i3._tTime && i3._ts < 0 ? Eo2() : i3._prom = Eo2;
          });
        }, Xt2.kill = function kill() {
          ub(this);
        }, Animation);
        function Animation(t3) {
          this.vars = t3, this._delay = +t3.delay || 0, (this._repeat = t3.repeat === 1 / 0 ? -2 : t3.repeat || 0) && (this._rDelay = t3.repeatDelay || 0, this._yoyo = !!t3.yoyo || !!t3.yoyoEase), this._ts = 1, Sa(this, +t3.duration, 1, 1), this.data = t3.data, l2 && (this._ctx = l2).data.push(this), c || Rt2.wake();
        }
        ra(Nt2.prototype, {
          _time: 0,
          _start: 0,
          _end: 0,
          _tTime: 0,
          _tDur: 0,
          _dirty: 0,
          _repeat: 0,
          _yoyo: false,
          parent: null,
          _initted: false,
          _rDelay: 0,
          _ts: 1,
          _dp: 0,
          ratio: 0,
          _zTime: -U2,
          _prom: 0,
          _ps: false,
          _rts: 1
        });
        var Qt2 = (function(i3) {
          function Timeline(t3, e4) {
            var r3;
            return void 0 === t3 && (t3 = {}), (r3 = i3.call(this, t3) || this).labels = {}, r3.smoothChildTiming = !!t3.smoothChildTiming, r3.autoRemoveChildren = !!t3.autoRemoveChildren, r3._sort = w(t3.sortChildren), I2 && La(t3.parent || I2, _assertThisInitialized(r3), e4), t3.reversed && r3.reverse(), t3.paused && r3.paused(true), t3.scrollTrigger && Ma(_assertThisInitialized(r3), t3.scrollTrigger), r3;
          }
          _inheritsLoose(Timeline, i3);
          var e3 = Timeline.prototype;
          return e3.to = function to(t3, e4, r3) {
            return Wa(0, arguments, this), this;
          }, e3.from = function from(t3, e4, r3) {
            return Wa(1, arguments, this), this;
          }, e3.fromTo = function fromTo(t3, e4, r3, i4) {
            return Wa(2, arguments, this), this;
          }, e3.set = function set(t3, e4, r3) {
            return e4.duration = 0, e4.parent = this, wa(e4).repeatDelay || (e4.repeat = 0), e4.immediateRender = !!e4.immediateRender, new Jt2(t3, e4, xt2(this, r3), 1), this;
          }, e3.call = function call(t3, e4, r3) {
            return La(this, Jt2.delayedCall(0, t3, e4), r3);
          }, e3.staggerTo = function staggerTo(t3, e4, r3, i4, n3, a2, s3) {
            return r3.duration = e4, r3.stagger = r3.stagger || i4, r3.onComplete = a2, r3.onCompleteParams = s3, r3.parent = this, new Jt2(t3, r3, xt2(this, n3)), this;
          }, e3.staggerFrom = function staggerFrom(t3, e4, r3, i4, n3, a2, s3) {
            return r3.runBackwards = 1, wa(r3).immediateRender = w(r3.immediateRender), this.staggerTo(t3, e4, r3, i4, n3, a2, s3);
          }, e3.staggerFromTo = function staggerFromTo(t3, e4, r3, i4, n3, a2, s3, o3) {
            return i4.startAt = r3, wa(i4).immediateRender = w(i4.immediateRender), this.staggerTo(t3, e4, i4, n3, a2, s3, o3);
          }, e3.render = function render(t3, e4, r3) {
            var i4, n3, a2, s3, o3, u2, h2, l3, f2, d3, c2, p2, _2 = this._time, m2 = this._dirty ? this.totalDuration() : this._tDur, g2 = this._dur, v2 = t3 <= 0 ? 0 : ja(t3), y2 = this._zTime < 0 != t3 < 0 && (this._initted || !g2);
            if (this !== I2 && m2 < v2 && 0 <= t3 && (v2 = m2), v2 !== this._tTime || r3 || y2) {
              if (_2 !== this._time && g2 && (v2 += this._time - _2, t3 += this._time - _2), i4 = v2, f2 = this._start, u2 = !(l3 = this._ts), y2 && (g2 || (_2 = this._zTime), !t3 && e4 || (this._zTime = t3)), this._repeat) {
                if (c2 = this._yoyo, o3 = g2 + this._rDelay, this._repeat < -1 && t3 < 0)
                  return this.totalTime(100 * o3 + t3, e4, r3);
                if (i4 = ja(v2 % o3), v2 === m2 ? (s3 = this._repeat, i4 = g2) : ((s3 = ~~(d3 = ja(v2 / o3))) && s3 === d3 && (i4 = g2, s3--), g2 < i4 && (i4 = g2)), d3 = Tt2(this._tTime, o3), !_2 && this._tTime && d3 !== s3 && this._tTime - d3 * o3 - this._dur <= 0 && (d3 = s3), c2 && 1 & s3 && (i4 = g2 - i4, p2 = 1), s3 !== d3 && !this._lock) {
                  var T3 = c2 && 1 & d3, b2 = T3 === (c2 && 1 & s3);
                  if (s3 < d3 && (T3 = !T3), _2 = T3 ? 0 : v2 % g2 ? g2 : v2, this._lock = 1, this.render(_2 || (p2 ? 0 : ja(s3 * o3)), e4, !g2)._lock = 0, this._tTime = v2, !e4 && this.parent && Pt2(this, "onRepeat"), this.vars.repeatRefresh && !p2 && (this.invalidate()._lock = 1), _2 && _2 !== this._time || u2 != !this._ts || this.vars.onRepeat && !this.parent && !this._act)
                    return this;
                  if (g2 = this._dur, m2 = this._tDur, b2 && (this._lock = 2, _2 = T3 ? g2 : -1e-4, this.render(_2, true), this.vars.repeatRefresh && !p2 && this.invalidate()), this._lock = 0, !this._ts && !u2)
                    return this;
                  Rb(this, p2);
                }
              }
              if (this._hasPause && !this._forcing && this._lock < 2 && (h2 = (function _findNextPauseTween(t4, e5, r4) {
                var i5;
                if (e5 < r4)
                  for (i5 = t4._first; i5 && i5._start <= r4; ) {
                    if ("isPause" === i5.data && i5._start > e5) return i5;
                    i5 = i5._next;
                  }
                else
                  for (i5 = t4._last; i5 && i5._start >= r4; ) {
                    if ("isPause" === i5.data && i5._start < e5) return i5;
                    i5 = i5._prev;
                  }
              })(this, ja(_2), ja(i4))) && (v2 -= i4 - (i4 = h2._start)), this._tTime = v2, this._time = i4, this._act = !l3, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = t3, _2 = 0), !_2 && v2 && !e4 && !d3 && (Pt2(this, "onStart"), this._tTime !== v2))
                return this;
              if (_2 <= i4 && 0 <= t3)
                for (n3 = this._first; n3; ) {
                  if (a2 = n3._next, (n3._act || i4 >= n3._start) && n3._ts && h2 !== n3) {
                    if (n3.parent !== this) return this.render(t3, e4, r3);
                    if (n3.render(
                      0 < n3._ts ? (i4 - n3._start) * n3._ts : (n3._dirty ? n3.totalDuration() : n3._tDur) + (i4 - n3._start) * n3._ts,
                      e4,
                      r3
                    ), i4 !== this._time || !this._ts && !u2) {
                      h2 = 0, a2 && (v2 += this._zTime = -U2);
                      break;
                    }
                  }
                  n3 = a2;
                }
              else {
                n3 = this._last;
                for (var w2 = t3 < 0 ? t3 : i4; n3; ) {
                  if (a2 = n3._prev, (n3._act || w2 <= n3._end) && n3._ts && h2 !== n3) {
                    if (n3.parent !== this) return this.render(t3, e4, r3);
                    if (n3.render(
                      0 < n3._ts ? (w2 - n3._start) * n3._ts : (n3._dirty ? n3.totalDuration() : n3._tDur) + (w2 - n3._start) * n3._ts,
                      e4,
                      r3 || L2 && na(n3)
                    ), i4 !== this._time || !this._ts && !u2) {
                      h2 = 0, a2 && (v2 += this._zTime = w2 ? -U2 : U2);
                      break;
                    }
                  }
                  n3 = a2;
                }
              }
              if (h2 && !e4 && (this.pause(), h2.render(_2 <= i4 ? 0 : -U2)._zTime = _2 <= i4 ? 1 : -1, this._ts))
                return this._start = f2, Ia(this), this.render(t3, e4, r3);
              this._onUpdate && !e4 && Pt2(this, "onUpdate", true), (v2 === m2 && this._tTime >= this.totalDuration() || !v2 && _2) && (f2 !== this._start && Math.abs(l3) === Math.abs(this._ts) || this._lock || (!t3 && g2 || !(v2 === m2 && 0 < this._ts || !v2 && this._ts < 0) || Aa(this, 1), e4 || t3 < 0 && !_2 || !v2 && !_2 && m2 || (Pt2(this, v2 === m2 && 0 <= t3 ? "onComplete" : "onReverseComplete", true), !this._prom || v2 < m2 && 0 < this.timeScale() || this._prom())));
            }
            return this;
          }, e3.add = function add(e4, i4) {
            var n3 = this;
            if (t2(i4) || (i4 = xt2(this, i4, e4)), !(e4 instanceof Nt2)) {
              if ($(e4))
                return e4.forEach(function(t3) {
                  return n3.add(t3, i4);
                }), this;
              if (r2(e4)) return this.addLabel(e4, i4);
              if (!s2(e4)) return this;
              e4 = Jt2.delayedCall(0, e4);
            }
            return this !== e4 ? La(this, e4, i4) : this;
          }, e3.getChildren = function getChildren(t3, e4, r3, i4) {
            void 0 === t3 && (t3 = true), void 0 === e4 && (e4 = true), void 0 === r3 && (r3 = true), void 0 === i4 && (i4 = -N2);
            for (var n3 = [], a2 = this._first; a2; )
              a2._start >= i4 && (a2 instanceof Jt2 ? e4 && n3.push(a2) : (r3 && n3.push(a2), t3 && n3.push.apply(n3, a2.getChildren(true, e4, r3)))), a2 = a2._next;
            return n3;
          }, e3.getById = function getById(t3) {
            for (var e4 = this.getChildren(1, 1, 1), r3 = e4.length; r3--; ) if (e4[r3].vars.id === t3) return e4[r3];
          }, e3.remove = function remove(t3) {
            return r2(t3) ? this.removeLabel(t3) : s2(t3) ? this.killTweensOf(t3) : (t3.parent === this && za(this, t3), t3 === this._recent && (this._recent = this._last), Ba(this));
          }, e3.totalTime = function totalTime(t3, e4) {
            return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = ja(Rt2.time - (0 < this._ts ? t3 / this._ts : (this.totalDuration() - t3) / -this._ts))), i3.prototype.totalTime.call(this, t3, e4), this._forcing = 0, this) : this._tTime;
          }, e3.addLabel = function addLabel(t3, e4) {
            return this.labels[t3] = xt2(this, e4), this;
          }, e3.removeLabel = function removeLabel(t3) {
            return delete this.labels[t3], this;
          }, e3.addPause = function addPause(t3, e4, r3) {
            var i4 = Jt2.delayedCall(0, e4 || T2, r3);
            return i4.data = "isPause", this._hasPause = 1, La(this, i4, xt2(this, t3));
          }, e3.removePause = function removePause(t3) {
            var e4 = this._first;
            for (t3 = xt2(this, t3); e4; ) e4._start === t3 && "isPause" === e4.data && Aa(e4), e4 = e4._next;
          }, e3.killTweensOf = function killTweensOf(t3, e4, r3) {
            for (var i4 = this.getTweensOf(t3, r3), n3 = i4.length; n3--; ) Ut2 !== i4[n3] && i4[n3].kill(t3, e4);
            return this;
          }, e3.getTweensOf = function getTweensOf(e4, r3) {
            for (var i4, n3 = [], a2 = Ot(e4), s3 = this._first, o3 = t2(r3); s3; )
              s3 instanceof Jt2 ? la(s3._targets, a2) && (o3 ? (!Ut2 || s3._initted && s3._ts) && s3.globalTime(0) <= r3 && s3.globalTime(s3.totalDuration()) > r3 : !r3 || s3.isActive()) && n3.push(s3) : (i4 = s3.getTweensOf(a2, r3)).length && n3.push.apply(n3, i4), s3 = s3._next;
            return n3;
          }, e3.tweenTo = function tweenTo(t3, e4) {
            e4 = e4 || {};
            var r3, i4 = this, n3 = xt2(i4, t3), a2 = e4.startAt, s3 = e4.onStart, o3 = e4.onStartParams, u2 = e4.immediateRender, h2 = Jt2.to(
              i4,
              ra(
                {
                  ease: e4.ease || "none",
                  lazy: false,
                  immediateRender: false,
                  time: n3,
                  overwrite: "auto",
                  duration: e4.duration || Math.abs((n3 - (a2 && "time" in a2 ? a2.time : i4._time)) / i4.timeScale()) || U2,
                  onStart: function onStart() {
                    if (i4.pause(), !r3) {
                      var t4 = e4.duration || Math.abs((n3 - (a2 && "time" in a2 ? a2.time : i4._time)) / i4.timeScale());
                      h2._dur !== t4 && Sa(h2, t4, 0, 1).render(h2._time, true, true), r3 = 1;
                    }
                    s3 && s3.apply(h2, o3 || []);
                  }
                },
                e4
              )
            );
            return u2 ? h2.render(0) : h2;
          }, e3.tweenFromTo = function tweenFromTo(t3, e4, r3) {
            return this.tweenTo(e4, ra({ startAt: { time: xt2(this, t3) } }, r3));
          }, e3.recent = function recent() {
            return this._recent;
          }, e3.nextLabel = function nextLabel(t3) {
            return void 0 === t3 && (t3 = this._time), sb(this, xt2(this, t3));
          }, e3.previousLabel = function previousLabel(t3) {
            return void 0 === t3 && (t3 = this._time), sb(this, xt2(this, t3), 1);
          }, e3.currentLabel = function currentLabel(t3) {
            return arguments.length ? this.seek(t3, true) : this.previousLabel(this._time + U2);
          }, e3.shiftChildren = function shiftChildren(t3, e4, r3) {
            void 0 === r3 && (r3 = 0);
            for (var i4, n3 = this._first, a2 = this.labels; n3; )
              n3._start >= r3 && (n3._start += t3, n3._end += t3), n3 = n3._next;
            if (e4) for (i4 in a2) a2[i4] >= r3 && (a2[i4] += t3);
            return Ba(this);
          }, e3.invalidate = function invalidate(t3) {
            var e4 = this._first;
            for (this._lock = 0; e4; ) e4.invalidate(t3), e4 = e4._next;
            return i3.prototype.invalidate.call(this, t3);
          }, e3.clear = function clear(t3) {
            void 0 === t3 && (t3 = true);
            for (var e4, r3 = this._first; r3; ) e4 = r3._next, this.remove(r3), r3 = e4;
            return this._dp && (this._time = this._tTime = this._pTime = 0), t3 && (this.labels = {}), Ba(this);
          }, e3.totalDuration = function totalDuration(t3) {
            var e4, r3, i4, n3 = 0, a2 = this, s3 = a2._last, o3 = N2;
            if (arguments.length)
              return a2.timeScale((a2._repeat < 0 ? a2.duration() : a2.totalDuration()) / (a2.reversed() ? -t3 : t3));
            if (a2._dirty) {
              for (i4 = a2.parent; s3; )
                e4 = s3._prev, s3._dirty && s3.totalDuration(), o3 < (r3 = s3._start) && a2._sort && s3._ts && !a2._lock ? (a2._lock = 1, La(a2, s3, r3 - s3._delay, 1)._lock = 0) : o3 = r3, r3 < 0 && s3._ts && (n3 -= r3, (!i4 && !a2._dp || i4 && i4.smoothChildTiming) && (a2._start += r3 / a2._ts, a2._time -= r3, a2._tTime -= r3), a2.shiftChildren(-r3, false, -Infinity), o3 = 0), s3._end > n3 && s3._ts && (n3 = s3._end), s3 = e4;
              Sa(a2, a2 === I2 && a2._time > n3 ? a2._time : n3, 1, 1), a2._dirty = 0;
            }
            return a2._tDur;
          }, Timeline.updateRoot = function updateRoot(t3) {
            if (I2._ts && (oa(I2, Ha(t3, I2)), f = Rt2.frame), Rt2.frame >= mt2) {
              mt2 += X3.autoSleep || 120;
              var e4 = I2._first;
              if ((!e4 || !e4._ts) && X3.autoSleep && Rt2._listeners.length < 2) {
                for (; e4 && !e4._ts; ) e4 = e4._next;
                e4 || Rt2.sleep();
              }
            }
          }, Timeline;
        })(Nt2);
        ra(Qt2.prototype, { _lock: 0, _hasPause: 0, _forcing: 0 });
        function bc(t3, e3, i3, n3, a2, o3) {
          var u2, h2, l3, f2;
          if (pt2[t3] && false !== (u2 = new pt2[t3]()).init(
            a2,
            u2.rawVars ? e3[t3] : (function _processVars(t4, e4, i4, n4, a3) {
              if (s2(t4) && (t4 = Gt2(t4, a3, e4, i4, n4)), !v(t4) || t4.style && t4.nodeType || $(t4) || J2(t4))
                return r2(t4) ? Gt2(t4, a3, e4, i4, n4) : t4;
              var o4, u3 = {};
              for (o4 in t4) u3[o4] = Gt2(t4[o4], a3, e4, i4, n4);
              return u3;
            })(e3[t3], n3, a2, o3, i3),
            i3,
            n3,
            o3
          ) && (i3._pt = h2 = new ge2(i3._pt, a2, t3, 0, 1, u2.render, u2, 0, u2.priority), i3 !== d2))
            for (l3 = i3._ptLookup[i3._targets.indexOf(a2)], f2 = u2._props.length; f2--; ) l3[u2._props[f2]] = h2;
          return u2;
        }
        function hc(t3, r3, e3, i3) {
          var n3, a2, s3 = r3.ease || i3 || "power1.inOut";
          if ($(r3))
            a2 = e3[t3] || (e3[t3] = []), r3.forEach(function(t4, e4) {
              return a2.push({ t: e4 / (r3.length - 1) * 100, v: t4, e: s3 });
            });
          else for (n3 in r3) a2 = e3[n3] || (e3[n3] = []), "ease" === n3 || a2.push({ t: parseFloat(t3), v: r3[n3], e: s3 });
        }
        var Ut2, qt2, Vt2 = function _addPropTween(t3, e3, i3, n3, a2, o3, u2, h2, l3, f2) {
          s2(n3) && (n3 = n3(a2 || 0, t3, o3));
          var d3, c2 = t3[e3], p2 = "get" !== i3 ? i3 : s2(c2) ? l3 ? t3[e3.indexOf("set") || !s2(t3["get" + e3.substr(3)]) ? e3 : "get" + e3.substr(3)](l3) : t3[e3]() : c2, _2 = s2(c2) ? l3 ? re : te2 : $t2;
          if (r2(n3) && (~n3.indexOf("random(") && (n3 = pb(n3)), "=" === n3.charAt(1) && (!(d3 = ka(p2, n3) + (Za(p2) || 0)) && 0 !== d3 || (n3 = d3))), !f2 || p2 !== n3 || qt2)
            return isNaN(p2 * n3) || "" === n3 ? (c2 || e3 in t3 || Q2(e3, n3), function _addComplexStringPropTween(t4, e4, r3, i4, n4, a3, s3) {
              var o4, u3, h3, l4, f3, d4, c3, p3, _3 = new ge2(this._pt, t4, e4, 0, 1, oe2, null, n4), m2 = 0, g2 = 0;
              for (_3.b = r3, _3.e = i4, r3 += "", (c3 = ~(i4 += "").indexOf("random(")) && (i4 = pb(i4)), a3 && (a3(p3 = [r3, i4], t4, e4), r3 = p3[0], i4 = p3[1]), u3 = r3.match(it2) || []; o4 = it2.exec(i4); )
                l4 = o4[0], f3 = i4.substring(m2, o4.index), h3 ? h3 = (h3 + 1) % 5 : "rgba(" === f3.substr(-5) && (h3 = 1), l4 !== u3[g2++] && (d4 = parseFloat(u3[g2 - 1]) || 0, _3._pt = {
                  _next: _3._pt,
                  p: f3 || 1 === g2 ? f3 : ",",
                  s: d4,
                  c: "=" === l4.charAt(1) ? ka(d4, l4) - d4 : parseFloat(l4) - d4,
                  m: h3 && h3 < 4 ? Math.round : 0
                }, m2 = it2.lastIndex);
              return _3.c = m2 < i4.length ? i4.substring(m2, i4.length) : "", _3.fp = s3, (nt.test(i4) || c3) && (_3.e = 0), this._pt = _3;
            }.call(this, t3, e3, p2, n3, _2, h2 || X3.stringFilter, l3)) : (d3 = new ge2(this._pt, t3, e3, +p2 || 0, n3 - (p2 || 0), "boolean" == typeof c2 ? se2 : ne2, 0, _2), l3 && (d3.fp = l3), u2 && d3.modifier(u2, this, t3), this._pt = d3);
        }, Wt2 = function _initTween(t3, e3, r3) {
          var i3, n3, a2, s3, o3, u2, h2, l3, f2, d3, c2, p2, _2, m2 = t3.vars, g2 = m2.ease, v2 = m2.startAt, y2 = m2.immediateRender, T3 = m2.lazy, b2 = m2.onUpdate, x2 = m2.runBackwards, M3 = m2.yoyoEase, k3 = m2.keyframes, O3 = m2.autoRevert, A3 = t3._dur, P2 = t3._startAt, C3 = t3._targets, S2 = t3.parent, D2 = S2 && "nested" === S2.data ? S2.vars.targets : C3, z3 = "auto" === t3._overwrite && !F2, E2 = t3.timeline;
          if (!E2 || k3 && g2 || (g2 = "none"), t3._ease = Yt2(g2, Z2.ease), t3._yEase = M3 ? jt2(Yt2(true === M3 ? g2 : M3, Z2.ease)) : 0, M3 && t3._yoyo && !t3._repeat && (M3 = t3._yEase, t3._yEase = t3._ease, t3._ease = M3), t3._from = !E2 && !!m2.runBackwards, !E2 || k3 && !m2.stagger) {
            if (p2 = (l3 = C3[0] ? fa(C3[0]).harness : 0) && m2[l3.prop], i3 = va(m2, ft2), P2 && (P2._zTime < 0 && P2.progress(1), e3 < 0 && x2 && y2 && !O3 ? P2.render(-1, true) : P2.revert(x2 && A3 ? ht2 : ut2), P2._lazy = 0), v2) {
              if (Aa(
                t3._startAt = Jt2.set(
                  C3,
                  ra(
                    {
                      data: "isStart",
                      overwrite: false,
                      parent: S2,
                      immediateRender: true,
                      lazy: !P2 && w(T3),
                      startAt: null,
                      delay: 0,
                      onUpdate: b2 && function() {
                        return Pt2(t3, "onUpdate");
                      },
                      stagger: 0
                    },
                    v2
                  )
                )
              ), t3._startAt._dp = 0, t3._startAt._sat = t3, e3 < 0 && (L2 || !y2 && !O3) && t3._startAt.revert(ht2), y2 && A3 && e3 <= 0 && r3 <= 0)
                return void (e3 && (t3._zTime = e3));
            } else if (x2 && A3 && !P2)
              if (e3 && (y2 = false), a2 = ra(
                { overwrite: false, data: "isFromStart", lazy: y2 && !P2 && w(T3), immediateRender: y2, stagger: 0, parent: S2 },
                i3
              ), p2 && (a2[l3.prop] = p2), Aa(t3._startAt = Jt2.set(C3, a2)), t3._startAt._dp = 0, t3._startAt._sat = t3, e3 < 0 && (L2 ? t3._startAt.revert(ht2) : t3._startAt.render(-1, true)), t3._zTime = e3, y2) {
                if (!e3) return;
              } else _initTween(t3._startAt, U2, U2);
            for (t3._pt = t3._ptCache = 0, T3 = A3 && w(T3) || T3 && !A3, n3 = 0; n3 < C3.length; n3++) {
              if (h2 = (o3 = C3[n3])._gsap || ea(C3)[n3]._gsap, t3._ptLookup[n3] = d3 = {}, ct2[h2.id] && dt2.length && ma(), c2 = D2 === C3 ? n3 : D2.indexOf(o3), l3 && false !== (f2 = new l3()).init(o3, p2 || i3, t3, c2, D2) && (t3._pt = s3 = new ge2(t3._pt, o3, f2.name, 0, 1, f2.render, f2, 0, f2.priority), f2._props.forEach(function(t4) {
                d3[t4] = s3;
              }), f2.priority && (u2 = 1)), !l3 || p2)
                for (a2 in i3)
                  pt2[a2] && (f2 = bc(a2, i3, t3, c2, o3, D2)) ? f2.priority && (u2 = 1) : d3[a2] = s3 = Vt2.call(t3, o3, a2, "get", i3[a2], c2, D2, 0, m2.stringFilter);
              t3._op && t3._op[n3] && t3.kill(o3, t3._op[n3]), z3 && t3._pt && (Ut2 = t3, I2.killTweensOf(o3, d3, t3.globalTime(e3)), _2 = !t3.parent, Ut2 = 0), t3._pt && T3 && (ct2[h2.id] = 1);
            }
            u2 && _e2(t3), t3._onInit && t3._onInit(t3);
          }
          t3._onUpdate = b2, t3._initted = (!t3._op || t3._pt) && !_2, k3 && e3 <= 0 && E2.render(N2, true, true);
        }, Gt2 = function _parseFuncOrString(t3, e3, i3, n3, a2) {
          return s2(t3) ? t3.call(e3, i3, n3, a2) : r2(t3) && ~t3.indexOf("random(") ? pb(t3) : t3;
        }, Ht2 = vt2 + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", Kt2 = {};
        ha(Ht2 + ",id,stagger,delay,duration,paused,scrollTrigger", function(t3) {
          return Kt2[t3] = 1;
        });
        var Jt2 = (function(E2) {
          function Tween(e4, r3, i3, n3) {
            var a2;
            "number" == typeof r3 && (i3.duration = r3, r3 = i3, i3 = null);
            var s3, o3, u2, h2, l3, f2, d3, c2, p2 = (a2 = E2.call(this, n3 ? r3 : wa(r3)) || this).vars, _2 = p2.duration, m2 = p2.delay, g2 = p2.immediateRender, T3 = p2.stagger, b2 = p2.overwrite, x2 = p2.keyframes, M3 = p2.defaults, k3 = p2.scrollTrigger, O3 = p2.yoyoEase, A3 = r3.parent || I2, P2 = ($(e4) || J2(e4) ? t2(e4[0]) : "length" in r3) ? [e4] : Ot(e4);
            if (a2._targets = P2.length ? ea(P2) : R2("GSAP target " + e4 + " not found. https://gsap.com", !X3.nullTargetWarn) || [], a2._ptLookup = [], a2._overwrite = b2, x2 || T3 || y(_2) || y(m2)) {
              if (r3 = a2.vars, (s3 = a2.timeline = new Qt2({
                data: "nested",
                defaults: M3 || {},
                targets: A3 && "nested" === A3.data ? A3.vars.targets : P2
              })).kill(), s3.parent = s3._dp = _assertThisInitialized(a2), s3._start = 0, T3 || y(_2) || y(m2)) {
                if (h2 = P2.length, d3 = T3 && fb(T3), v(T3)) for (l3 in T3) ~Ht2.indexOf(l3) && ((c2 = c2 || {})[l3] = T3[l3]);
                for (o3 = 0; o3 < h2; o3++)
                  (u2 = va(r3, Kt2)).stagger = 0, O3 && (u2.yoyoEase = O3), c2 && yt2(u2, c2), f2 = P2[o3], u2.duration = +Gt2(_2, _assertThisInitialized(a2), o3, f2, P2), u2.delay = (+Gt2(m2, _assertThisInitialized(a2), o3, f2, P2) || 0) - a2._delay, !T3 && 1 === h2 && u2.delay && (a2._delay = m2 = u2.delay, a2._start += m2, u2.delay = 0), s3.to(f2, u2, d3 ? d3(o3, f2, P2) : 0), s3._ease = Lt2.none;
                s3.duration() ? _2 = m2 = 0 : a2.timeline = 0;
              } else if (x2) {
                wa(ra(s3.vars.defaults, { ease: "none" })), s3._ease = Yt2(x2.ease || r3.ease || "none");
                var C3, S2, D2, z3 = 0;
                if ($(x2))
                  x2.forEach(function(t3) {
                    return s3.to(P2, t3, ">");
                  }), s3.duration();
                else {
                  for (l3 in u2 = {}, x2) "ease" === l3 || "easeEach" === l3 || hc(l3, x2[l3], u2, x2.easeEach);
                  for (l3 in u2)
                    for (C3 = u2[l3].sort(function(t3, e5) {
                      return t3.t - e5.t;
                    }), o3 = z3 = 0; o3 < C3.length; o3++)
                      (D2 = { ease: (S2 = C3[o3]).e, duration: (S2.t - (o3 ? C3[o3 - 1].t : 0)) / 100 * _2 })[l3] = S2.v, s3.to(P2, D2, z3), z3 += D2.duration;
                  s3.duration() < _2 && s3.to({}, { duration: _2 - s3.duration() });
                }
              }
              _2 || a2.duration(_2 = s3.duration());
            } else a2.timeline = 0;
            return true !== b2 || F2 || (Ut2 = _assertThisInitialized(a2), I2.killTweensOf(P2), Ut2 = 0), La(A3, _assertThisInitialized(a2), i3), r3.reversed && a2.reverse(), r3.paused && a2.paused(true), (g2 || !_2 && !x2 && a2._start === ja(A3._time) && w(g2) && (function _hasNoPausedAncestors(t3) {
              return !t3 || t3._ts && _hasNoPausedAncestors(t3.parent);
            })(_assertThisInitialized(a2)) && "nested" !== A3.data) && (a2._tTime = -U2, a2.render(Math.max(0, -m2) || 0)), k3 && Ma(_assertThisInitialized(a2), k3), a2;
          }
          _inheritsLoose(Tween, E2);
          var e3 = Tween.prototype;
          return e3.render = function render(t3, e4, r3) {
            var i3, n3, a2, s3, o3, u2, h2, l3, f2, d3 = this._time, c2 = this._tDur, p2 = this._dur, _2 = t3 < 0, m2 = c2 - U2 < t3 && !_2 ? c2 : t3 < U2 ? 0 : t3;
            if (p2) {
              if (m2 !== this._tTime || !t3 || r3 || !this._initted && this._tTime || this._startAt && this._zTime < 0 != _2 || this._lazy) {
                if (i3 = m2, l3 = this.timeline, this._repeat) {
                  if (s3 = p2 + this._rDelay, this._repeat < -1 && _2) return this.totalTime(100 * s3 + t3, e4, r3);
                  if (i3 = ja(m2 % s3), m2 === c2 ? (a2 = this._repeat, i3 = p2) : (a2 = ~~(o3 = ja(m2 / s3))) && a2 === o3 ? (i3 = p2, a2--) : p2 < i3 && (i3 = p2), (u2 = this._yoyo && 1 & a2) && (f2 = this._yEase, i3 = p2 - i3), o3 = Tt2(this._tTime, s3), i3 === d3 && !r3 && this._initted && a2 === o3)
                    return this._tTime = m2, this;
                  a2 !== o3 && (l3 && this._yEase && Rb(l3, u2), this.vars.repeatRefresh && !u2 && !this._lock && i3 !== s3 && this._initted && (this._lock = r3 = 1, this.render(ja(s3 * a2), true).invalidate()._lock = 0));
                }
                if (!this._initted) {
                  if (Na(this, _2 ? t3 : i3, r3, e4, m2)) return this._tTime = 0, this;
                  if (!(d3 === this._time || r3 && this.vars.repeatRefresh && a2 !== o3)) return this;
                  if (p2 !== this._dur) return this.render(t3, e4, r3);
                }
                if (this._tTime = m2, this._time = i3, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = h2 = (f2 || this._ease)(i3 / p2), this._from && (this.ratio = h2 = 1 - h2), !d3 && m2 && !e4 && !o3 && (Pt2(this, "onStart"), this._tTime !== m2))
                  return this;
                for (n3 = this._pt; n3; ) n3.r(h2, n3.d), n3 = n3._next;
                l3 && l3.render(t3 < 0 ? t3 : l3._dur * l3._ease(i3 / this._dur), e4, r3) || this._startAt && (this._zTime = t3), this._onUpdate && !e4 && (_2 && Da(this, t3, 0, r3), Pt2(this, "onUpdate")), this._repeat && a2 !== o3 && this.vars.onRepeat && !e4 && this.parent && Pt2(this, "onRepeat"), m2 !== this._tDur && m2 || this._tTime !== m2 || (_2 && !this._onUpdate && Da(this, t3, 0, true), !t3 && p2 || !(m2 === this._tDur && 0 < this._ts || !m2 && this._ts < 0) || Aa(this, 1), e4 || _2 && !d3 || !(m2 || d3 || u2) || (Pt2(this, m2 === c2 ? "onComplete" : "onReverseComplete", true), !this._prom || m2 < c2 && 0 < this.timeScale() || this._prom()));
              }
            } else
              !(function _renderZeroDurationTween(t4, e5, r4, i4) {
                var n4, a3, s4, o4 = t4.ratio, u3 = e5 < 0 || !e5 && (!t4._start && (function _parentPlayheadIsBeforeStart(t5) {
                  var e6 = t5.parent;
                  return e6 && e6._ts && e6._initted && !e6._lock && (e6.rawTime() < 0 || _parentPlayheadIsBeforeStart(e6));
                })(t4) && (t4._initted || !bt2(t4)) || (t4._ts < 0 || t4._dp._ts < 0) && !bt2(t4)) ? 0 : 1, h3 = t4._rDelay, l4 = 0;
                if (h3 && t4._repeat && (l4 = Mt2(0, t4._tDur, e5), a3 = Tt2(l4, h3), t4._yoyo && 1 & a3 && (u3 = 1 - u3), a3 !== Tt2(t4._tTime, h3) && (o4 = 1 - u3, t4.vars.repeatRefresh && t4._initted && t4.invalidate())), u3 !== o4 || L2 || i4 || t4._zTime === U2 || !e5 && t4._zTime) {
                  if (!t4._initted && Na(t4, e5, i4, r4, l4)) return;
                  for (s4 = t4._zTime, t4._zTime = e5 || (r4 ? U2 : 0), r4 = r4 || e5 && !s4, t4.ratio = u3, t4._from && (u3 = 1 - u3), t4._time = 0, t4._tTime = l4, n4 = t4._pt; n4; )
                    n4.r(u3, n4.d), n4 = n4._next;
                  e5 < 0 && Da(t4, e5, 0, true), t4._onUpdate && !r4 && Pt2(t4, "onUpdate"), l4 && t4._repeat && !r4 && t4.parent && Pt2(t4, "onRepeat"), (e5 >= t4._tDur || e5 < 0) && t4.ratio === u3 && (u3 && Aa(t4, 1), r4 || L2 || (Pt2(t4, u3 ? "onComplete" : "onReverseComplete", true), t4._prom && t4._prom()));
                } else t4._zTime || (t4._zTime = e5);
              })(this, t3, e4, r3);
            return this;
          }, e3.targets = function targets() {
            return this._targets;
          }, e3.invalidate = function invalidate(t3) {
            return t3 && this.vars.runBackwards || (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(t3), E2.prototype.invalidate.call(this, t3);
          }, e3.resetTo = function resetTo(t3, e4, r3, i3, n3) {
            c || Rt2.wake(), this._ts || this.play();
            var a2, s3 = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
            return this._initted || Wt2(this, s3), a2 = this._ease(s3 / this._dur), (function _updatePropTweens(t4, e5, r4, i4, n4, a3, s4, o3) {
              var u2, h2, l3, f2, d3 = (t4._pt && t4._ptCache || (t4._ptCache = {}))[e5];
              if (!d3)
                for (d3 = t4._ptCache[e5] = [], l3 = t4._ptLookup, f2 = t4._targets.length; f2--; ) {
                  if ((u2 = l3[f2][e5]) && u2.d && u2.d._pt) for (u2 = u2.d._pt; u2 && u2.p !== e5 && u2.fp !== e5; ) u2 = u2._next;
                  if (!u2)
                    return qt2 = 1, t4.vars[e5] = "+=0", Wt2(t4, s4), qt2 = 0, o3 ? R2(e5 + " not eligible for reset") : 1;
                  d3.push(u2);
                }
              for (f2 = d3.length; f2--; )
                (u2 = (h2 = d3[f2])._pt || h2).s = !i4 && 0 !== i4 || n4 ? u2.s + (i4 || 0) + a3 * u2.c : i4, u2.c = r4 - u2.s, h2.e && (h2.e = ia(r4) + Za(h2.e)), h2.b && (h2.b = u2.s + Za(h2.b));
            })(this, t3, e4, r3, i3, a2, s3, n3) ? this.resetTo(t3, e4, r3, i3, 1) : (Ja(this, 0), this.parent || ya(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
          }, e3.kill = function kill(t3, e4) {
            if (void 0 === e4 && (e4 = "all"), !(t3 || e4 && "all" !== e4))
              return this._lazy = this._pt = 0, this.parent ? ub(this) : this.scrollTrigger && this.scrollTrigger.kill(!!L2), this;
            if (this.timeline) {
              var i3 = this.timeline.totalDuration();
              return this.timeline.killTweensOf(t3, e4, Ut2 && true !== Ut2.vars.overwrite)._first || ub(this), this.parent && i3 !== this.timeline.totalDuration() && Sa(this, this._dur * this.timeline._tDur / i3, 0, 1), this;
            }
            var n3, a2, s3, o3, u2, h2, l3, f2 = this._targets, d3 = t3 ? Ot(t3) : f2, c2 = this._ptLookup, p2 = this._pt;
            if ((!e4 || "all" === e4) && (function _arraysMatch(t4, e5) {
              for (var r3 = t4.length, i4 = r3 === e5.length; i4 && r3-- && t4[r3] === e5[r3]; ) ;
              return r3 < 0;
            })(f2, d3))
              return "all" === e4 && (this._pt = 0), ub(this);
            for (n3 = this._op = this._op || [], "all" !== e4 && (r2(e4) && (u2 = {}, ha(e4, function(t4) {
              return u2[t4] = 1;
            }), e4 = u2), e4 = (function _addAliasesToVars(t4, e5) {
              var r3, i4, n4, a3, s4 = t4[0] ? fa(t4[0]).harness : 0, o4 = s4 && s4.aliases;
              if (!o4) return e5;
              for (i4 in r3 = yt2({}, e5), o4)
                if (i4 in r3) for (n4 = (a3 = o4[i4].split(",")).length; n4--; ) r3[a3[n4]] = r3[i4];
              return r3;
            })(f2, e4)), l3 = f2.length; l3--; )
              if (~d3.indexOf(f2[l3]))
                for (u2 in a2 = c2[l3], "all" === e4 ? (n3[l3] = e4, o3 = a2, s3 = {}) : (s3 = n3[l3] = n3[l3] || {}, o3 = e4), o3)
                  (h2 = a2 && a2[u2]) && ("kill" in h2.d && true !== h2.d.kill(u2) || za(this, h2, "_pt"), delete a2[u2]), "all" !== s3 && (s3[u2] = 1);
            return this._initted && !this._pt && p2 && ub(this), this;
          }, Tween.to = function to(t3, e4, r3) {
            return new Tween(t3, e4, r3);
          }, Tween.from = function from(t3, e4) {
            return Wa(1, arguments);
          }, Tween.delayedCall = function delayedCall(t3, e4, r3, i3) {
            return new Tween(e4, 0, {
              immediateRender: false,
              lazy: false,
              overwrite: false,
              delay: t3,
              onComplete: e4,
              onReverseComplete: e4,
              onCompleteParams: r3,
              onReverseCompleteParams: r3,
              callbackScope: i3
            });
          }, Tween.fromTo = function fromTo(t3, e4, r3) {
            return Wa(2, arguments);
          }, Tween.set = function set(t3, e4) {
            return e4.duration = 0, e4.repeatDelay || (e4.repeat = 0), new Tween(t3, e4);
          }, Tween.killTweensOf = function killTweensOf(t3, e4, r3) {
            return I2.killTweensOf(t3, e4, r3);
          }, Tween;
        })(Nt2);
        ra(Jt2.prototype, { _targets: [], _lazy: 0, _startAt: 0, _op: 0, _onInit: 0 }), ha("staggerTo,staggerFrom,staggerFromTo", function(r3) {
          Jt2[r3] = function() {
            var t3 = new Qt2(), e3 = kt2.call(arguments, 0);
            return e3.splice("staggerFromTo" === r3 ? 5 : 4, 0, 0), t3[r3].apply(t3, e3);
          };
        });
        function pc(t3, e3, r3) {
          return t3.setAttribute(e3, r3);
        }
        function xc(t3, e3, r3, i3) {
          i3.mSet(t3, e3, i3.m.call(i3.tween, r3, i3.mt), i3);
        }
        var $t2 = function _setterPlain(t3, e3, r3) {
          return t3[e3] = r3;
        }, te2 = function _setterFunc(t3, e3, r3) {
          return t3[e3](r3);
        }, re = function _setterFuncWithParam(t3, e3, r3, i3) {
          return t3[e3](i3.fp, r3);
        }, ie = function _getSetter(t3, e3) {
          return s2(t3[e3]) ? te2 : u(t3[e3]) && t3.setAttribute ? pc : $t2;
        }, ne2 = function _renderPlain(t3, e3) {
          return e3.set(e3.t, e3.p, Math.round(1e6 * (e3.s + e3.c * t3)) / 1e6, e3);
        }, se2 = function _renderBoolean(t3, e3) {
          return e3.set(e3.t, e3.p, !!(e3.s + e3.c * t3), e3);
        }, oe2 = function _renderComplexString(t3, e3) {
          var r3 = e3._pt, i3 = "";
          if (!t3 && e3.b) i3 = e3.b;
          else if (1 === t3 && e3.e) i3 = e3.e;
          else {
            for (; r3; )
              i3 = r3.p + (r3.m ? r3.m(r3.s + r3.c * t3) : Math.round(1e4 * (r3.s + r3.c * t3)) / 1e4) + i3, r3 = r3._next;
            i3 += e3.c;
          }
          e3.set(e3.t, e3.p, i3, e3);
        }, ue2 = function _renderPropTweens(t3, e3) {
          for (var r3 = e3._pt; r3; ) r3.r(t3, r3.d), r3 = r3._next;
        }, he2 = function _addPluginModifier(t3, e3, r3, i3) {
          for (var n3, a2 = this._pt; a2; ) n3 = a2._next, a2.p === i3 && a2.modifier(t3, e3, r3), a2 = n3;
        }, de2 = function _killPropTweensOf(t3) {
          for (var e3, r3, i3 = this._pt; i3; )
            r3 = i3._next, i3.p === t3 && !i3.op || i3.op === t3 ? za(this, i3, "_pt") : i3.dep || (e3 = 1), i3 = r3;
          return !e3;
        }, _e2 = function _sortPropTweensByPriority(t3) {
          for (var e3, r3, i3, n3, a2 = t3._pt; a2; ) {
            for (e3 = a2._next, r3 = i3; r3 && r3.pr > a2.pr; ) r3 = r3._next;
            (a2._prev = r3 ? r3._prev : n3) ? a2._prev._next = a2 : i3 = a2, (a2._next = r3) ? r3._prev = a2 : n3 = a2, a2 = e3;
          }
          t3._pt = i3;
        }, ge2 = (PropTween.prototype.modifier = function modifier(t3, e3, r3) {
          this.mSet = this.mSet || this.set, this.set = xc, this.m = t3, this.mt = r3, this.tween = e3;
        }, PropTween);
        function PropTween(t3, e3, r3, i3, n3, a2, s3, o3, u2) {
          this.t = e3, this.s = i3, this.c = n3, this.p = r3, this.r = a2 || ne2, this.d = s3 || this, this.set = o3 || $t2, this.pr = u2 || 0, (this._next = t3) && (t3._prev = this);
        }
        ha(
          vt2 + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger",
          function(t3) {
            return ft2[t3] = 1;
          }
        ), ot2.TweenMax = ot2.TweenLite = Jt2, ot2.TimelineLite = ot2.TimelineMax = Qt2, I2 = new Qt2({ sortChildren: false, defaults: Z2, autoRemoveChildren: true, id: "root", smoothChildTiming: true }), X3.stringFilter = Gb;
        function Fc(t3) {
          return (be2[t3] || Me2).map(function(t4) {
            return t4();
          });
        }
        function Gc() {
          var t3 = Date.now(), o3 = [];
          2 < t3 - Oe2 && (Fc("matchMediaInit"), Te2.forEach(function(t4) {
            var e3, r3, i3, n3, a2 = t4.queries, s3 = t4.conditions;
            for (r3 in a2) (e3 = h.matchMedia(a2[r3]).matches) && (i3 = 1), e3 !== s3[r3] && (s3[r3] = e3, n3 = 1);
            n3 && (t4.revert(), i3 && o3.push(t4));
          }), Fc("matchMediaRevert"), o3.forEach(function(e3) {
            return e3.onMatch(e3, function(t4) {
              return e3.add(null, t4);
            });
          }), Oe2 = t3, Fc("matchMedia"));
        }
        var ve2, Te2 = [], be2 = {}, Me2 = [], Oe2 = 0, Ae2 = 0, Pe2 = ((ve2 = Context.prototype).add = function add(t3, i3, n3) {
          function Iw() {
            var t4, e3 = l2, r3 = a2.selector;
            return e3 && e3 !== a2 && e3.data.push(a2), n3 && (a2.selector = db(n3)), l2 = a2, t4 = i3.apply(a2, arguments), s2(t4) && a2._r.push(t4), l2 = e3, a2.selector = r3, a2.isReverted = false, t4;
          }
          s2(t3) && (n3 = i3, i3 = t3, t3 = s2);
          var a2 = this;
          return a2.last = Iw, t3 === s2 ? Iw(a2, function(t4) {
            return a2.add(null, t4);
          }) : t3 ? a2[t3] = Iw : Iw;
        }, ve2.ignore = function ignore(t3) {
          var e3 = l2;
          l2 = null, t3(this), l2 = e3;
        }, ve2.getTweens = function getTweens() {
          var e3 = [];
          return this.data.forEach(function(t3) {
            return t3 instanceof Context ? e3.push.apply(e3, t3.getTweens()) : t3 instanceof Jt2 && !(t3.parent && "nested" === t3.parent.data) && e3.push(t3);
          }), e3;
        }, ve2.clear = function clear() {
          this._r.length = this.data.length = 0;
        }, ve2.kill = function kill(i3, t3) {
          var n3 = this;
          if (i3 ? (function() {
            for (var t4, e4 = n3.getTweens(), r3 = n3.data.length; r3--; )
              "isFlip" === (t4 = n3.data[r3]).data && (t4.revert(), t4.getChildren(true, true, false).forEach(function(t5) {
                return e4.splice(e4.indexOf(t5), 1);
              }));
            for (e4.map(function(t5) {
              return {
                g: t5._dur || t5._delay || t5._sat && !t5._sat.vars.immediateRender ? t5.globalTime(0) : -1 / 0,
                t: t5
              };
            }).sort(function(t5, e5) {
              return e5.g - t5.g || -1 / 0;
            }).forEach(function(t5) {
              return t5.t.revert(i3);
            }), r3 = n3.data.length; r3--; )
              (t4 = n3.data[r3]) instanceof Qt2 ? "nested" !== t4.data && (t4.scrollTrigger && t4.scrollTrigger.revert(), t4.kill()) : t4 instanceof Jt2 || !t4.revert || t4.revert(i3);
            n3._r.forEach(function(t5) {
              return t5(i3, n3);
            }), n3.isReverted = true;
          })() : this.data.forEach(function(t4) {
            return t4.kill && t4.kill();
          }), this.clear(), t3)
            for (var e3 = Te2.length; e3--; ) Te2[e3].id === this.id && Te2.splice(e3, 1);
        }, ve2.revert = function revert(t3) {
          this.kill(t3 || {});
        }, Context);
        function Context(t3, e3) {
          this.selector = e3 && db(e3), this.data = [], this._r = [], this.isReverted = false, this.id = Ae2++, t3 && this.add(t3);
        }
        var Ce2, Se2 = ((Ce2 = MatchMedia.prototype).add = function add(t3, e3, r3) {
          v(t3) || (t3 = { matches: t3 });
          var i3, n3, a2, s3 = new Pe2(0, r3 || this.scope), o3 = s3.conditions = {};
          for (n3 in l2 && !s3.selector && (s3.selector = l2.selector), this.contexts.push(s3), e3 = s3.add("onMatch", e3), s3.queries = t3)
            "all" === n3 ? a2 = 1 : (i3 = h.matchMedia(t3[n3])) && (Te2.indexOf(s3) < 0 && Te2.push(s3), (o3[n3] = i3.matches) && (a2 = 1), i3.addListener ? i3.addListener(Gc) : i3.addEventListener("change", Gc));
          return a2 && e3(s3, function(t4) {
            return s3.add(null, t4);
          }), this;
        }, Ce2.revert = function revert(t3) {
          this.kill(t3 || {});
        }, Ce2.kill = function kill(e3) {
          this.contexts.forEach(function(t3) {
            return t3.kill(e3, true);
          });
        }, MatchMedia);
        function MatchMedia(t3) {
          this.contexts = [], this.scope = t3, l2 && l2.data.push(this);
        }
        var De2 = {
          registerPlugin: function registerPlugin() {
            for (var t3 = arguments.length, e3 = new Array(t3), r3 = 0; r3 < t3; r3++) e3[r3] = arguments[r3];
            e3.forEach(function(t4) {
              return xb(t4);
            });
          },
          timeline: function timeline(t3) {
            return new Qt2(t3);
          },
          getTweensOf: function getTweensOf(t3, e3) {
            return I2.getTweensOf(t3, e3);
          },
          getProperty: function getProperty(i3, t3, e3, n3) {
            r2(i3) && (i3 = Ot(i3)[0]);
            var a2 = fa(i3 || {}).get, s3 = e3 ? qa : pa;
            return "native" === e3 && (e3 = ""), i3 ? t3 ? s3((pt2[t3] && pt2[t3].get || a2)(i3, t3, e3, n3)) : function(t4, e4, r3) {
              return s3((pt2[t4] && pt2[t4].get || a2)(i3, t4, e4, r3));
            } : i3;
          },
          quickSetter: function quickSetter(r3, e3, i3) {
            if (1 < (r3 = Ot(r3)).length) {
              var n3 = r3.map(function(t3) {
                return ze2.quickSetter(t3, e3, i3);
              }), a2 = n3.length;
              return function(t3) {
                for (var e4 = a2; e4--; ) n3[e4](t3);
              };
            }
            r3 = r3[0] || {};
            var s3 = pt2[e3], o3 = fa(r3), u2 = o3.harness && (o3.harness.aliases || {})[e3] || e3, h2 = s3 ? function(t3) {
              var e4 = new s3();
              d2._pt = 0, e4.init(r3, i3 ? t3 + i3 : t3, d2, 0, [r3]), e4.render(1, e4), d2._pt && ue2(1, d2);
            } : o3.set(r3, u2);
            return s3 ? h2 : function(t3) {
              return h2(r3, u2, i3 ? t3 + i3 : t3, o3, 1);
            };
          },
          quickTo: function quickTo(t3, i3, e3) {
            function ay(t4, e4, r4) {
              return n3.resetTo(i3, t4, e4, r4);
            }
            var r3, n3 = ze2.to(t3, ra(((r3 = {})[i3] = "+=0.1", r3.paused = true, r3.stagger = 0, r3), e3 || {}));
            return ay.tween = n3, ay;
          },
          isTweening: function isTweening(t3) {
            return 0 < I2.getTweensOf(t3, true).length;
          },
          defaults: function defaults2(t3) {
            return t3 && t3.ease && (t3.ease = Yt2(t3.ease, Z2.ease)), ua(Z2, t3 || {});
          },
          config: function config(t3) {
            return ua(X3, t3 || {});
          },
          registerEffect: function registerEffect(t3) {
            var i3 = t3.name, n3 = t3.effect, e3 = t3.plugins, a2 = t3.defaults, r3 = t3.extendTimeline;
            (e3 || "").split(",").forEach(function(t4) {
              return t4 && !pt2[t4] && !ot2[t4] && R2(i3 + " effect requires " + t4 + " plugin.");
            }), _t2[i3] = function(t4, e4, r4) {
              return n3(Ot(t4), ra(e4 || {}, a2), r4);
            }, r3 && (Qt2.prototype[i3] = function(t4, e4, r4) {
              return this.add(_t2[i3](t4, v(e4) ? e4 : (r4 = e4) && {}, this), r4);
            });
          },
          registerEase: function registerEase(t3, e3) {
            Lt2[t3] = Yt2(e3);
          },
          parseEase: function parseEase(t3, e3) {
            return arguments.length ? Yt2(t3, e3) : Lt2;
          },
          getById: function getById(t3) {
            return I2.getById(t3);
          },
          exportRoot: function exportRoot(t3, e3) {
            void 0 === t3 && (t3 = {});
            var r3, i3, n3 = new Qt2(t3);
            for (n3.smoothChildTiming = w(t3.smoothChildTiming), I2.remove(n3), n3._dp = 0, n3._time = n3._tTime = I2._time, r3 = I2._first; r3; )
              i3 = r3._next, !e3 && !r3._dur && r3 instanceof Jt2 && r3.vars.onComplete === r3._targets[0] || La(n3, r3, r3._start - r3._delay), r3 = i3;
            return La(I2, n3, 0), n3;
          },
          context: function context(t3, e3) {
            return t3 ? new Pe2(t3, e3) : l2;
          },
          matchMedia: function matchMedia(t3) {
            return new Se2(t3);
          },
          matchMediaRefresh: function matchMediaRefresh() {
            return Te2.forEach(function(t3) {
              var e3, r3, i3 = t3.conditions;
              for (r3 in i3) i3[r3] && (i3[r3] = false, e3 = 1);
              e3 && t3.revert();
            }) || Gc();
          },
          addEventListener: function addEventListener(t3, e3) {
            var r3 = be2[t3] || (be2[t3] = []);
            ~r3.indexOf(e3) || r3.push(e3);
          },
          removeEventListener: function removeEventListener(t3, e3) {
            var r3 = be2[t3], i3 = r3 && r3.indexOf(e3);
            0 <= i3 && r3.splice(i3, 1);
          },
          utils: {
            wrap: function wrap(e3, t3, r3) {
              var i3 = t3 - e3;
              return $(e3) ? mb(e3, wrap(0, e3.length), t3) : Xa(r3, function(t4) {
                return (i3 + (t4 - e3) % i3) % i3 + e3;
              });
            },
            wrapYoyo: function wrapYoyo(e3, t3, r3) {
              var i3 = t3 - e3, n3 = 2 * i3;
              return $(e3) ? mb(e3, wrapYoyo(0, e3.length - 1), t3) : Xa(r3, function(t4) {
                return e3 + (i3 < (t4 = (n3 + (t4 - e3) % n3) % n3 || 0) ? n3 - t4 : t4);
              });
            },
            distribute: fb,
            random: ib,
            snap: hb,
            normalize: function normalize(t3, e3, r3) {
              return At2(t3, e3, 0, 1, r3);
            },
            getUnit: Za,
            clamp: function clamp(e3, r3, t3) {
              return Xa(t3, function(t4) {
                return Mt2(e3, r3, t4);
              });
            },
            splitColor: Bb,
            toArray: Ot,
            selector: db,
            mapRange: At2,
            pipe: function pipe() {
              for (var t3 = arguments.length, e3 = new Array(t3), r3 = 0; r3 < t3; r3++) e3[r3] = arguments[r3];
              return function(t4) {
                return e3.reduce(function(t5, e4) {
                  return e4(t5);
                }, t4);
              };
            },
            unitize: function unitize(e3, r3) {
              return function(t3) {
                return e3(parseFloat(t3)) + (r3 || Za(t3));
              };
            },
            interpolate: function interpolate(e3, i3, t3, n3) {
              var a2 = isNaN(e3 + i3) ? 0 : function(t4) {
                return (1 - t4) * e3 + t4 * i3;
              };
              if (!a2) {
                var s3, o3, u2, h2, l3, f2 = r2(e3), d3 = {};
                if (true === t3 && (n3 = 1) && (t3 = null), f2) e3 = { p: e3 }, i3 = { p: i3 };
                else if ($(e3) && !$(i3)) {
                  for (u2 = [], h2 = e3.length, l3 = h2 - 2, o3 = 1; o3 < h2; o3++) u2.push(interpolate(e3[o3 - 1], e3[o3]));
                  h2--, a2 = function func(t4) {
                    t4 *= h2;
                    var e4 = Math.min(l3, ~~t4);
                    return u2[e4](t4 - e4);
                  }, t3 = i3;
                } else n3 || (e3 = yt2($(e3) ? [] : {}, e3));
                if (!u2) {
                  for (s3 in i3) Vt2.call(d3, e3, s3, "get", i3[s3]);
                  a2 = function func(t4) {
                    return ue2(t4, d3) || (f2 ? e3.p : e3);
                  };
                }
              }
              return Xa(t3, a2);
            },
            shuffle: eb
          },
          install: P,
          effects: _t2,
          ticker: Rt2,
          updateRoot: Qt2.updateRoot,
          plugins: pt2,
          globalTimeline: I2,
          core: {
            PropTween: ge2,
            globals: S,
            Tween: Jt2,
            Timeline: Qt2,
            Animation: Nt2,
            getCache: fa,
            _removeLinkedListItem: za,
            reverting: function reverting() {
              return L2;
            },
            context: function context(t3) {
              return t3 && l2 && (l2.data.push(t3), t3._ctx = l2), l2;
            },
            suppressOverwrites: function suppressOverwrites(t3) {
              return F2 = t3;
            }
          }
        };
        ha("to,from,fromTo,delayedCall,set,killTweensOf", function(t3) {
          return De2[t3] = Jt2[t3];
        }), Rt2.add(Qt2.updateRoot), d2 = De2.to({}, { duration: 0 });
        function Kc(t3, e3) {
          for (var r3 = t3._pt; r3 && r3.p !== e3 && r3.op !== e3 && r3.fp !== e3; ) r3 = r3._next;
          return r3;
        }
        function Mc(t3, a2) {
          return {
            name: t3,
            headless: 1,
            rawVars: 1,
            init: function init(t4, n3, e3) {
              e3._onInit = function(t5) {
                var e4, i3;
                if (r2(n3) && (e4 = {}, ha(n3, function(t6) {
                  return e4[t6] = 1;
                }), n3 = e4), a2) {
                  for (i3 in e4 = {}, n3) e4[i3] = a2(n3[i3]);
                  n3 = e4;
                }
                !(function _addModifiers(t6, e5) {
                  var r3, i4, n4, a3 = t6._targets;
                  for (r3 in e5)
                    for (i4 = a3.length; i4--; )
                      (n4 = (n4 = t6._ptLookup[i4][r3]) && n4.d) && (n4._pt && (n4 = Kc(n4, r3)), n4 && n4.modifier && n4.modifier(e5[r3], t6, a3[i4], r3));
                })(t5, n3);
              };
            }
          };
        }
        var ze2 = De2.registerPlugin(
          {
            name: "attr",
            init: function init(t3, e3, r3, i3, n3) {
              var a2, s3, o3;
              for (a2 in this.tween = r3, e3)
                o3 = t3.getAttribute(a2) || "", (s3 = this.add(t3, "setAttribute", (o3 || 0) + "", e3[a2], i3, n3, 0, 0, a2)).op = a2, s3.b = o3, this._props.push(a2);
            },
            render: function render(t3, e3) {
              for (var r3 = e3._pt; r3; ) L2 ? r3.set(r3.t, r3.p, r3.b, r3) : r3.r(t3, r3.d), r3 = r3._next;
            }
          },
          {
            name: "endArray",
            headless: 1,
            init: function init(t3, e3) {
              for (var r3 = e3.length; r3--; ) this.add(t3, r3, t3[r3] || 0, e3[r3], 0, 0, 0, 0, 0, 1);
            }
          },
          Mc("roundProps", gb),
          Mc("modifiers"),
          Mc("snap", hb)
        ) || De2;
        Jt2.version = Qt2.version = ze2.version = "3.13.0", o2 = 1, x() && Ft2();
        function wd(t3, e3) {
          return e3.set(e3.t, e3.p, Math.round(1e4 * (e3.s + e3.c * t3)) / 1e4 + e3.u, e3);
        }
        function xd(t3, e3) {
          return e3.set(e3.t, e3.p, 1 === t3 ? e3.e : Math.round(1e4 * (e3.s + e3.c * t3)) / 1e4 + e3.u, e3);
        }
        function yd(t3, e3) {
          return e3.set(e3.t, e3.p, t3 ? Math.round(1e4 * (e3.s + e3.c * t3)) / 1e4 + e3.u : e3.b, e3);
        }
        function zd(t3, e3) {
          var r3 = e3.s + e3.c * t3;
          e3.set(e3.t, e3.p, ~~(r3 + (r3 < 0 ? -0.5 : 0.5)) + e3.u, e3);
        }
        function Ad(t3, e3) {
          return e3.set(e3.t, e3.p, t3 ? e3.e : e3.b, e3);
        }
        function Bd(t3, e3) {
          return e3.set(e3.t, e3.p, 1 !== t3 ? e3.b : e3.e, e3);
        }
        function Cd(t3, e3, r3) {
          return t3.style[e3] = r3;
        }
        function Dd(t3, e3, r3) {
          return t3.style.setProperty(e3, r3);
        }
        function Ed(t3, e3, r3) {
          return t3._gsap[e3] = r3;
        }
        function Fd(t3, e3, r3) {
          return t3._gsap.scaleX = t3._gsap.scaleY = r3;
        }
        function Gd(t3, e3, r3, i3, n3) {
          var a2 = t3._gsap;
          a2.scaleX = a2.scaleY = r3, a2.renderTransform(n3, a2);
        }
        function Hd(t3, e3, r3, i3, n3) {
          var a2 = t3._gsap;
          a2[e3] = r3, a2.renderTransform(n3, a2);
        }
        function Kd(t3, e3) {
          var r3 = this, i3 = this.target, n3 = i3.style, a2 = i3._gsap;
          if (t3 in sr2 && n3) {
            if (this.tfm = this.tfm || {}, "transform" === t3)
              return cr2.transform.split(",").forEach(function(t4) {
                return Kd.call(r3, t4, e3);
              });
            if (~(t3 = cr2[t3] || t3).indexOf(",") ? t3.split(",").forEach(function(t4) {
              return r3.tfm[t4] = Tr2(i3, t4);
            }) : this.tfm[t3] = a2.x ? a2[t3] : Tr2(i3, t3), t3 === _r && (this.tfm.zOrigin = a2.zOrigin), 0 <= this.props.indexOf(pr2))
              return;
            a2.svg && (this.svgo = i3.getAttribute("data-svg-origin"), this.props.push(_r, e3, "")), t3 = pr2;
          }
          (n3 || e3) && this.props.push(t3, e3, n3[t3]);
        }
        function Ld(t3) {
          t3.translate && (t3.removeProperty("translate"), t3.removeProperty("scale"), t3.removeProperty("rotate"));
        }
        function Md() {
          var t3, e3, r3 = this.props, i3 = this.target, n3 = i3.style, a2 = i3._gsap;
          for (t3 = 0; t3 < r3.length; t3 += 3)
            r3[t3 + 1] ? 2 === r3[t3 + 1] ? i3[r3[t3]](r3[t3 + 2]) : i3[r3[t3]] = r3[t3 + 2] : r3[t3 + 2] ? n3[r3[t3]] = r3[t3 + 2] : n3.removeProperty("--" === r3[t3].substr(0, 2) ? r3[t3] : r3[t3].replace(lr2, "-$1").toLowerCase());
          if (this.tfm) {
            for (e3 in this.tfm) a2[e3] = this.tfm[e3];
            a2.svg && (a2.renderTransform(), i3.setAttribute("data-svg-origin", this.svgo || "")), (t3 = Ye2()) && t3.isStart || n3[pr2] || (Ld(n3), a2.zOrigin && n3[_r] && (n3[_r] += " " + a2.zOrigin + "px", a2.zOrigin = 0, a2.renderTransform()), a2.uncache = 1);
          }
        }
        function Nd(t3, e3) {
          var r3 = { target: t3, props: [], revert: Md, save: Kd };
          return t3._gsap || ze2.core.getCache(t3), e3 && t3.style && t3.nodeType && e3.split(",").forEach(function(t4) {
            return r3.save(t4);
          }), r3;
        }
        function Pd(t3, e3) {
          var r3 = Re2.createElementNS ? Re2.createElementNS((e3 || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t3) : Re2.createElement(t3);
          return r3 && r3.style ? r3 : Re2.createElement(t3);
        }
        function Qd(t3, e3, r3) {
          var i3 = getComputedStyle(t3);
          return i3[e3] || i3.getPropertyValue(e3.replace(lr2, "-$1").toLowerCase()) || i3.getPropertyValue(e3) || !r3 && Qd(t3, gr2(e3) || e3, 1) || "";
        }
        function Td() {
          /* @__PURE__ */ (function _windowExists() {
            return "undefined" != typeof window;
          })() && window.document && (Ee2 = window, Re2 = Ee2.document, Fe = Re2.documentElement, Ie2 = Pd("div") || { style: {} }, Pd("div"), pr2 = gr2(pr2), _r = pr2 + "Origin", Ie2.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", Xe2 = !!gr2("perspective"), Ye2 = ze2.core.reverting, Le2 = 1);
        }
        function Ud(t3) {
          var e3, r3 = t3.ownerSVGElement, i3 = Pd("svg", r3 && r3.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), n3 = t3.cloneNode(true);
          n3.style.display = "block", i3.appendChild(n3), Fe.appendChild(i3);
          try {
            e3 = n3.getBBox();
          } catch (t4) {
          }
          return i3.removeChild(n3), Fe.removeChild(i3), e3;
        }
        function Vd(t3, e3) {
          for (var r3 = e3.length; r3--; ) if (t3.hasAttribute(e3[r3])) return t3.getAttribute(e3[r3]);
        }
        function Wd(e3) {
          var r3, i3;
          try {
            r3 = e3.getBBox();
          } catch (t3) {
            r3 = Ud(e3), i3 = 1;
          }
          return r3 && (r3.width || r3.height) || i3 || (r3 = Ud(e3)), !r3 || r3.width || r3.x || r3.y ? r3 : { x: +Vd(e3, ["x", "cx", "x1"]) || 0, y: +Vd(e3, ["y", "cy", "y1"]) || 0, width: 0, height: 0 };
        }
        function Xd(t3) {
          return !(!t3.getCTM || t3.parentNode && !t3.ownerSVGElement || !Wd(t3));
        }
        function Yd(t3, e3) {
          if (e3) {
            var r3, i3 = t3.style;
            e3 in sr2 && e3 !== _r && (e3 = pr2), i3.removeProperty ? ("ms" !== (r3 = e3.substr(0, 2)) && "webkit" !== e3.substr(0, 6) || (e3 = "-" + e3), i3.removeProperty("--" === r3 ? e3 : e3.replace(lr2, "-$1").toLowerCase())) : i3.removeAttribute(e3);
          }
        }
        function Zd(t3, e3, r3, i3, n3, a2) {
          var s3 = new ge2(t3._pt, e3, r3, 0, 1, a2 ? Bd : Ad);
          return (t3._pt = s3).b = i3, s3.e = n3, t3._props.push(r3), s3;
        }
        function ae2(t3, e3, r3, i3) {
          var n3, a2, s3, o3, u2 = parseFloat(r3) || 0, h2 = (r3 + "").trim().substr((u2 + "").length) || "px", l3 = Ie2.style, f2 = fr2.test(e3), d3 = "svg" === t3.tagName.toLowerCase(), c2 = (d3 ? "client" : "offset") + (f2 ? "Width" : "Height"), p2 = "px" === i3, _2 = "%" === i3;
          if (i3 === h2 || !u2 || vr2[i3] || vr2[h2]) return u2;
          if ("px" === h2 || p2 || (u2 = ae2(t3, e3, r3, "px")), o3 = t3.getCTM && Xd(t3), (_2 || "%" === h2) && (sr2[e3] || ~e3.indexOf("adius")))
            return n3 = o3 ? t3.getBBox()[f2 ? "width" : "height"] : t3[c2], ia(_2 ? u2 / n3 * 100 : u2 / 100 * n3);
          if (l3[f2 ? "width" : "height"] = 100 + (p2 ? h2 : i3), a2 = "rem" !== i3 && ~e3.indexOf("adius") || "em" === i3 && t3.appendChild && !d3 ? t3 : t3.parentNode, o3 && (a2 = (t3.ownerSVGElement || {}).parentNode), a2 && a2 !== Re2 && a2.appendChild || (a2 = Re2.body), (s3 = a2._gsap) && _2 && s3.width && f2 && s3.time === Rt2.time && !s3.uncache)
            return ia(u2 / s3.width * 100);
          if (!_2 || "height" !== e3 && "width" !== e3)
            !_2 && "%" !== h2 || yr2[Qd(a2, "display")] || (l3.position = Qd(t3, "position")), a2 === t3 && (l3.position = "static"), a2.appendChild(Ie2), n3 = Ie2[c2], a2.removeChild(Ie2), l3.position = "absolute";
          else {
            var m2 = t3.style[e3];
            t3.style[e3] = 100 + i3, n3 = t3[c2], m2 ? t3.style[e3] = m2 : Yd(t3, e3);
          }
          return f2 && _2 && ((s3 = fa(a2)).time = Rt2.time, s3.width = a2[c2]), ia(p2 ? n3 * u2 / 100 : n3 && u2 ? 100 / n3 * u2 : 0);
        }
        function ce(t3, e3, r3, i3) {
          if (!r3 || "none" === r3) {
            var n3 = gr2(e3, t3, 1), a2 = n3 && Qd(t3, n3, 1);
            a2 && a2 !== r3 ? (e3 = n3, r3 = a2) : "borderColor" === e3 && (r3 = Qd(t3, "borderTopColor"));
          }
          var s3, o3, u2, h2, l3, f2, d3, c2, p2, _2, m2, g2 = new ge2(this._pt, t3.style, e3, 0, 1, oe2), v2 = 0, y2 = 0;
          if (g2.b = r3, g2.e = i3, r3 += "", "var(--" === (i3 += "").substring(0, 6) && (i3 = Qd(t3, i3.substring(4, i3.indexOf(")")))), "auto" === i3 && (f2 = t3.style[e3], t3.style[e3] = i3, i3 = Qd(t3, e3) || i3, f2 ? t3.style[e3] = f2 : Yd(t3, e3)), Gb(s3 = [r3, i3]), i3 = s3[1], u2 = (r3 = s3[0]).match(rt2) || [], (i3.match(rt2) || []).length) {
            for (; o3 = rt2.exec(i3); )
              d3 = o3[0], p2 = i3.substring(v2, o3.index), l3 ? l3 = (l3 + 1) % 5 : "rgba(" !== p2.substr(-5) && "hsla(" !== p2.substr(-5) || (l3 = 1), d3 !== (f2 = u2[y2++] || "") && (h2 = parseFloat(f2) || 0, m2 = f2.substr((h2 + "").length), "=" === d3.charAt(1) && (d3 = ka(h2, d3) + m2), c2 = parseFloat(d3), _2 = d3.substr((c2 + "").length), v2 = rt2.lastIndex - _2.length, _2 || (_2 = _2 || X3.units[e3] || m2, v2 === i3.length && (i3 += _2, g2.e += _2)), m2 !== _2 && (h2 = ae2(t3, e3, f2, _2) || 0), g2._pt = {
                _next: g2._pt,
                p: p2 || 1 === y2 ? p2 : ",",
                s: h2,
                c: c2 - h2,
                m: l3 && l3 < 4 || "zIndex" === e3 ? Math.round : 0
              });
            g2.c = v2 < i3.length ? i3.substring(v2, i3.length) : "";
          } else g2.r = "display" === e3 && "none" === i3 ? Bd : Ad;
          return nt.test(i3) && (g2.e = 0), this._pt = g2;
        }
        function ee2(t3) {
          var e3 = t3.split(" "), r3 = e3[0], i3 = e3[1] || "50%";
          return "top" !== r3 && "bottom" !== r3 && "left" !== i3 && "right" !== i3 || (t3 = r3, r3 = i3, i3 = t3), e3[0] = br2[r3] || r3, e3[1] = br2[i3] || i3, e3.join(" ");
        }
        function fe(t3, e3) {
          if (e3.tween && e3.tween._time === e3.tween._dur) {
            var r3, i3, n3, a2 = e3.t, s3 = a2.style, o3 = e3.u, u2 = a2._gsap;
            if ("all" === o3 || true === o3) s3.cssText = "", i3 = 1;
            else
              for (n3 = (o3 = o3.split(",")).length; -1 < --n3; )
                r3 = o3[n3], sr2[r3] && (i3 = 1, r3 = "transformOrigin" === r3 ? _r : pr2), Yd(a2, r3);
            i3 && (Yd(a2, pr2), u2 && (u2.svg && a2.removeAttribute("transform"), s3.scale = s3.rotate = s3.translate = "none", kr2(a2, 1), u2.uncache = 1, Ld(s3)));
          }
        }
        function je2(t3) {
          return "matrix(1, 0, 0, 1, 0, 0)" === t3 || "none" === t3 || !t3;
        }
        function ke2(t3) {
          var e3 = Qd(t3, pr2);
          return je2(e3) ? xr2 : e3.substr(7).match(et2).map(ia);
        }
        function le2(t3, e3) {
          var r3, i3, n3, a2, s3 = t3._gsap || fa(t3), o3 = t3.style, u2 = ke2(t3);
          return s3.svg && t3.getAttribute("transform") ? "1,0,0,1,0,0" === (u2 = [(n3 = t3.transform.baseVal.consolidate().matrix).a, n3.b, n3.c, n3.d, n3.e, n3.f]).join(",") ? xr2 : u2 : (u2 !== xr2 || t3.offsetParent || t3 === Fe || s3.svg || (n3 = o3.display, o3.display = "block", (r3 = t3.parentNode) && (t3.offsetParent || t3.getBoundingClientRect().width) || (a2 = 1, i3 = t3.nextElementSibling, Fe.appendChild(t3)), u2 = ke2(t3), n3 ? o3.display = n3 : Yd(t3, "display"), a2 && (i3 ? r3.insertBefore(t3, i3) : r3 ? r3.appendChild(t3) : Fe.removeChild(t3))), e3 && 6 < u2.length ? [u2[0], u2[1], u2[4], u2[5], u2[12], u2[13]] : u2);
        }
        function me2(t3, e3, r3, i3, n3, a2) {
          var s3, o3, u2, h2 = t3._gsap, l3 = n3 || le2(t3, true), f2 = h2.xOrigin || 0, d3 = h2.yOrigin || 0, c2 = h2.xOffset || 0, p2 = h2.yOffset || 0, _2 = l3[0], m2 = l3[1], g2 = l3[2], v2 = l3[3], y2 = l3[4], T3 = l3[5], b2 = e3.split(" "), w2 = parseFloat(b2[0]) || 0, x2 = parseFloat(b2[1]) || 0;
          r3 ? l3 !== xr2 && (o3 = _2 * v2 - m2 * g2) && (u2 = w2 * (-m2 / o3) + x2 * (_2 / o3) - (_2 * T3 - m2 * y2) / o3, w2 = w2 * (v2 / o3) + x2 * (-g2 / o3) + (g2 * T3 - v2 * y2) / o3, x2 = u2) : (w2 = (s3 = Wd(t3)).x + (~b2[0].indexOf("%") ? w2 / 100 * s3.width : w2), x2 = s3.y + (~(b2[1] || b2[0]).indexOf("%") ? x2 / 100 * s3.height : x2)), i3 || false !== i3 && h2.smooth ? (y2 = w2 - f2, T3 = x2 - d3, h2.xOffset = c2 + (y2 * _2 + T3 * g2) - y2, h2.yOffset = p2 + (y2 * m2 + T3 * v2) - T3) : h2.xOffset = h2.yOffset = 0, h2.xOrigin = w2, h2.yOrigin = x2, h2.smooth = !!i3, h2.origin = e3, h2.originIsAbsolute = !!r3, t3.style[_r] = "0px 0px", a2 && (Zd(a2, h2, "xOrigin", f2, w2), Zd(a2, h2, "yOrigin", d3, x2), Zd(a2, h2, "xOffset", c2, h2.xOffset), Zd(a2, h2, "yOffset", p2, h2.yOffset)), t3.setAttribute("data-svg-origin", w2 + " " + x2);
        }
        function pe2(t3, e3, r3) {
          var i3 = Za(e3);
          return ia(parseFloat(e3) + parseFloat(ae2(t3, "x", r3 + "px", i3))) + i3;
        }
        function we2(t3, e3, i3, n3, a2) {
          var s3, o3, u2 = 360, h2 = r2(a2), l3 = parseFloat(a2) * (h2 && ~a2.indexOf("rad") ? or2 : 1) - n3, f2 = n3 + l3 + "deg";
          return h2 && ("short" === (s3 = a2.split("_")[1]) && (l3 %= u2) !== l3 % 180 && (l3 += l3 < 0 ? u2 : -u2), "cw" === s3 && l3 < 0 ? l3 = (l3 + 36e9) % u2 - ~~(l3 / u2) * u2 : "ccw" === s3 && 0 < l3 && (l3 = (l3 - 36e9) % u2 - ~~(l3 / u2) * u2)), t3._pt = o3 = new ge2(t3._pt, e3, i3, n3, l3, xd), o3.e = f2, o3.u = "deg", t3._props.push(i3), o3;
        }
        function xe2(t3, e3) {
          for (var r3 in e3) t3[r3] = e3[r3];
          return t3;
        }
        function ye2(t3, e3, r3) {
          var i3, n3, a2, s3, o3, u2, h2, l3 = xe2({}, r3._gsap), f2 = r3.style;
          for (n3 in l3.svg ? (a2 = r3.getAttribute("transform"), r3.setAttribute("transform", ""), f2[pr2] = e3, i3 = kr2(r3, 1), Yd(r3, pr2), r3.setAttribute("transform", a2)) : (a2 = getComputedStyle(r3)[pr2], f2[pr2] = e3, i3 = kr2(r3, 1), f2[pr2] = a2), sr2)
            (a2 = l3[n3]) !== (s3 = i3[n3]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(n3) < 0 && (o3 = Za(a2) !== (h2 = Za(s3)) ? ae2(r3, n3, a2, h2) : parseFloat(a2), u2 = parseFloat(s3), t3._pt = new ge2(t3._pt, i3, n3, o3, u2 - o3, wd), t3._pt.u = h2 || 0, t3._props.push(n3));
          xe2(i3, l3);
        }
        var Ee2, Re2, Fe, Le2, Ie2, Be2, Ye2, Xe2, Ze2 = Lt2.Power0, Ne2 = Lt2.Power1, Qe2 = Lt2.Power2, Ue2 = Lt2.Power3, qe2 = Lt2.Power4, Ve2 = Lt2.Linear, We2 = Lt2.Quad, Ge2 = Lt2.Cubic, He2 = Lt2.Quart, Ke2 = Lt2.Quint, Je2 = Lt2.Strong, $e2 = Lt2.Elastic, tr2 = Lt2.Back, er2 = Lt2.SteppedEase, rr2 = Lt2.Bounce, ir2 = Lt2.Sine, nr2 = Lt2.Expo, ar2 = Lt2.Circ, sr2 = {}, or2 = 180 / Math.PI, ur2 = Math.PI / 180, hr2 = Math.atan2, lr2 = /([A-Z])/g, fr2 = /(left|right|width|margin|padding|x)/i, dr2 = /[\s,\(]\S/, cr2 = { autoAlpha: "opacity,visibility", scale: "scaleX,scaleY", alpha: "opacity" }, pr2 = "transform", _r = pr2 + "Origin", mr2 = "O,Moz,ms,Ms,Webkit".split(","), gr2 = function _checkPropPrefix(t3, e3, r3) {
          var i3 = (e3 || Ie2).style, n3 = 5;
          if (t3 in i3 && !r3) return t3;
          for (t3 = t3.charAt(0).toUpperCase() + t3.substr(1); n3-- && !(mr2[n3] + t3 in i3); ) ;
          return n3 < 0 ? null : (3 === n3 ? "ms" : 0 <= n3 ? mr2[n3] : "") + t3;
        }, vr2 = { deg: 1, rad: 1, turn: 1 }, yr2 = { grid: 1, flex: 1 }, Tr2 = function _get(t3, e3, r3, i3) {
          var n3;
          return Le2 || Td(), e3 in cr2 && "transform" !== e3 && ~(e3 = cr2[e3]).indexOf(",") && (e3 = e3.split(",")[0]), sr2[e3] && "transform" !== e3 ? (n3 = kr2(t3, i3), n3 = "transformOrigin" !== e3 ? n3[e3] : n3.svg ? n3.origin : Or2(Qd(t3, _r)) + " " + n3.zOrigin + "px") : (n3 = t3.style[e3]) && "auto" !== n3 && !i3 && !~(n3 + "").indexOf("calc(") || (n3 = wr2[e3] && wr2[e3](t3, e3, r3) || Qd(t3, e3) || ga(t3, e3) || ("opacity" === e3 ? 1 : 0)), r3 && !~(n3 + "").trim().indexOf(" ") ? ae2(t3, e3, n3, r3) + r3 : n3;
        }, br2 = { top: "0%", bottom: "100%", left: "0%", right: "100%", center: "50%" }, wr2 = {
          clearProps: function clearProps(t3, e3, r3, i3, n3) {
            if ("isFromStart" !== n3.data) {
              var a2 = t3._pt = new ge2(t3._pt, e3, r3, 0, 0, fe);
              return a2.u = i3, a2.pr = -10, a2.tween = n3, t3._props.push(r3), 1;
            }
          }
        }, xr2 = [1, 0, 0, 1, 0, 0], Mr = {}, kr2 = function _parseTransform(t3, e3) {
          var r3 = t3._gsap || new Zt2(t3);
          if ("x" in r3 && !e3 && !r3.uncache) return r3;
          var i3, n3, a2, s3, o3, u2, h2, l3, f2, d3, c2, p2, _2, m2, g2, v2, y2, T3, b2, w2, x2, M3, k3, O3, A3, P2, C3, S2, D2, z3, E2, R3, F3 = t3.style, L3 = r3.scaleX < 0, I3 = "deg", B3 = getComputedStyle(t3), j3 = Qd(t3, _r) || "0";
          return i3 = n3 = a2 = u2 = h2 = l3 = f2 = d3 = c2 = 0, s3 = o3 = 1, r3.svg = !(!t3.getCTM || !Xd(t3)), B3.translate && ("none" === B3.translate && "none" === B3.scale && "none" === B3.rotate || (F3[pr2] = ("none" !== B3.translate ? "translate3d(" + (B3.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + ("none" !== B3.rotate ? "rotate(" + B3.rotate + ") " : "") + ("none" !== B3.scale ? "scale(" + B3.scale.split(" ").join(",") + ") " : "") + ("none" !== B3[pr2] ? B3[pr2] : "")), F3.scale = F3.rotate = F3.translate = "none"), m2 = le2(t3, r3.svg), r3.svg && (O3 = r3.uncache ? (A3 = t3.getBBox(), j3 = r3.xOrigin - A3.x + "px " + (r3.yOrigin - A3.y) + "px", "") : !e3 && t3.getAttribute("data-svg-origin"), me2(t3, O3 || j3, !!O3 || r3.originIsAbsolute, false !== r3.smooth, m2)), p2 = r3.xOrigin || 0, _2 = r3.yOrigin || 0, m2 !== xr2 && (T3 = m2[0], b2 = m2[1], w2 = m2[2], x2 = m2[3], i3 = M3 = m2[4], n3 = k3 = m2[5], 6 === m2.length ? (s3 = Math.sqrt(T3 * T3 + b2 * b2), o3 = Math.sqrt(x2 * x2 + w2 * w2), u2 = T3 || b2 ? hr2(b2, T3) * or2 : 0, (f2 = w2 || x2 ? hr2(w2, x2) * or2 + u2 : 0) && (o3 *= Math.abs(Math.cos(f2 * ur2))), r3.svg && (i3 -= p2 - (p2 * T3 + _2 * w2), n3 -= _2 - (p2 * b2 + _2 * x2))) : (R3 = m2[6], z3 = m2[7], C3 = m2[8], S2 = m2[9], D2 = m2[10], E2 = m2[11], i3 = m2[12], n3 = m2[13], a2 = m2[14], h2 = (g2 = hr2(R3, D2)) * or2, g2 && (O3 = M3 * (v2 = Math.cos(-g2)) + C3 * (y2 = Math.sin(-g2)), A3 = k3 * v2 + S2 * y2, P2 = R3 * v2 + D2 * y2, C3 = M3 * -y2 + C3 * v2, S2 = k3 * -y2 + S2 * v2, D2 = R3 * -y2 + D2 * v2, E2 = z3 * -y2 + E2 * v2, M3 = O3, k3 = A3, R3 = P2), l3 = (g2 = hr2(-w2, D2)) * or2, g2 && (v2 = Math.cos(-g2), E2 = x2 * (y2 = Math.sin(-g2)) + E2 * v2, T3 = O3 = T3 * v2 - C3 * y2, b2 = A3 = b2 * v2 - S2 * y2, w2 = P2 = w2 * v2 - D2 * y2), u2 = (g2 = hr2(b2, T3)) * or2, g2 && (O3 = T3 * (v2 = Math.cos(g2)) + b2 * (y2 = Math.sin(g2)), A3 = M3 * v2 + k3 * y2, b2 = b2 * v2 - T3 * y2, k3 = k3 * v2 - M3 * y2, T3 = O3, M3 = A3), h2 && 359.9 < Math.abs(h2) + Math.abs(u2) && (h2 = u2 = 0, l3 = 180 - l3), s3 = ia(Math.sqrt(T3 * T3 + b2 * b2 + w2 * w2)), o3 = ia(Math.sqrt(k3 * k3 + R3 * R3)), g2 = hr2(M3, k3), f2 = 2e-4 < Math.abs(g2) ? g2 * or2 : 0, c2 = E2 ? 1 / (E2 < 0 ? -E2 : E2) : 0), r3.svg && (O3 = t3.getAttribute("transform"), r3.forceCSS = t3.setAttribute("transform", "") || !je2(Qd(t3, pr2)), O3 && t3.setAttribute("transform", O3))), 90 < Math.abs(f2) && Math.abs(f2) < 270 && (L3 ? (s3 *= -1, f2 += u2 <= 0 ? 180 : -180, u2 += u2 <= 0 ? 180 : -180) : (o3 *= -1, f2 += f2 <= 0 ? 180 : -180)), e3 = e3 || r3.uncache, r3.x = i3 - ((r3.xPercent = i3 && (!e3 && r3.xPercent || (Math.round(t3.offsetWidth / 2) === Math.round(-i3) ? -50 : 0))) ? t3.offsetWidth * r3.xPercent / 100 : 0) + "px", r3.y = n3 - ((r3.yPercent = n3 && (!e3 && r3.yPercent || (Math.round(t3.offsetHeight / 2) === Math.round(-n3) ? -50 : 0))) ? t3.offsetHeight * r3.yPercent / 100 : 0) + "px", r3.z = a2 + "px", r3.scaleX = ia(s3), r3.scaleY = ia(o3), r3.rotation = ia(u2) + I3, r3.rotationX = ia(h2) + I3, r3.rotationY = ia(l3) + I3, r3.skewX = f2 + I3, r3.skewY = d3 + I3, r3.transformPerspective = c2 + "px", (r3.zOrigin = parseFloat(j3.split(" ")[2]) || !e3 && r3.zOrigin || 0) && (F3[_r] = Or2(j3)), r3.xOffset = r3.yOffset = 0, r3.force3D = X3.force3D, r3.renderTransform = r3.svg ? zr : Xe2 ? Dr2 : Ar2, r3.uncache = 0, r3;
        }, Or2 = function _firstTwoOnly(t3) {
          return (t3 = t3.split(" "))[0] + " " + t3[1];
        }, Ar2 = function _renderNon3DTransforms(t3, e3) {
          e3.z = "0px", e3.rotationY = e3.rotationX = "0deg", e3.force3D = 0, Dr2(t3, e3);
        }, Pr2 = "0deg", Cr2 = "0px", Sr2 = ") ", Dr2 = function _renderCSSTransforms(t3, e3) {
          var r3 = e3 || this, i3 = r3.xPercent, n3 = r3.yPercent, a2 = r3.x, s3 = r3.y, o3 = r3.z, u2 = r3.rotation, h2 = r3.rotationY, l3 = r3.rotationX, f2 = r3.skewX, d3 = r3.skewY, c2 = r3.scaleX, p2 = r3.scaleY, _2 = r3.transformPerspective, m2 = r3.force3D, g2 = r3.target, v2 = r3.zOrigin, y2 = "", T3 = "auto" === m2 && t3 && 1 !== t3 || true === m2;
          if (v2 && (l3 !== Pr2 || h2 !== Pr2)) {
            var b2, w2 = parseFloat(h2) * ur2, x2 = Math.sin(w2), M3 = Math.cos(w2);
            w2 = parseFloat(l3) * ur2, b2 = Math.cos(w2), a2 = pe2(g2, a2, x2 * b2 * -v2), s3 = pe2(g2, s3, -Math.sin(w2) * -v2), o3 = pe2(g2, o3, M3 * b2 * -v2 + v2);
          }
          _2 !== Cr2 && (y2 += "perspective(" + _2 + Sr2), (i3 || n3) && (y2 += "translate(" + i3 + "%, " + n3 + "%) "), !T3 && a2 === Cr2 && s3 === Cr2 && o3 === Cr2 || (y2 += o3 !== Cr2 || T3 ? "translate3d(" + a2 + ", " + s3 + ", " + o3 + ") " : "translate(" + a2 + ", " + s3 + Sr2), u2 !== Pr2 && (y2 += "rotate(" + u2 + Sr2), h2 !== Pr2 && (y2 += "rotateY(" + h2 + Sr2), l3 !== Pr2 && (y2 += "rotateX(" + l3 + Sr2), f2 === Pr2 && d3 === Pr2 || (y2 += "skew(" + f2 + ", " + d3 + Sr2), 1 === c2 && 1 === p2 || (y2 += "scale(" + c2 + ", " + p2 + Sr2), g2.style[pr2] = y2 || "translate(0, 0)";
        }, zr = function _renderSVGTransforms(t3, e3) {
          var r3, i3, n3, a2, s3, o3 = e3 || this, u2 = o3.xPercent, h2 = o3.yPercent, l3 = o3.x, f2 = o3.y, d3 = o3.rotation, c2 = o3.skewX, p2 = o3.skewY, _2 = o3.scaleX, m2 = o3.scaleY, g2 = o3.target, v2 = o3.xOrigin, y2 = o3.yOrigin, T3 = o3.xOffset, b2 = o3.yOffset, w2 = o3.forceCSS, x2 = parseFloat(l3), M3 = parseFloat(f2);
          d3 = parseFloat(d3), c2 = parseFloat(c2), (p2 = parseFloat(p2)) && (c2 += p2 = parseFloat(p2), d3 += p2), d3 || c2 ? (d3 *= ur2, c2 *= ur2, r3 = Math.cos(d3) * _2, i3 = Math.sin(d3) * _2, n3 = Math.sin(d3 - c2) * -m2, a2 = Math.cos(d3 - c2) * m2, c2 && (p2 *= ur2, s3 = Math.tan(c2 - p2), n3 *= s3 = Math.sqrt(1 + s3 * s3), a2 *= s3, p2 && (s3 = Math.tan(p2), r3 *= s3 = Math.sqrt(1 + s3 * s3), i3 *= s3)), r3 = ia(r3), i3 = ia(i3), n3 = ia(n3), a2 = ia(a2)) : (r3 = _2, a2 = m2, i3 = n3 = 0), (x2 && !~(l3 + "").indexOf("px") || M3 && !~(f2 + "").indexOf("px")) && (x2 = ae2(g2, "x", l3, "px"), M3 = ae2(g2, "y", f2, "px")), (v2 || y2 || T3 || b2) && (x2 = ia(x2 + v2 - (v2 * r3 + y2 * n3) + T3), M3 = ia(M3 + y2 - (v2 * i3 + y2 * a2) + b2)), (u2 || h2) && (s3 = g2.getBBox(), x2 = ia(x2 + u2 / 100 * s3.width), M3 = ia(M3 + h2 / 100 * s3.height)), s3 = "matrix(" + r3 + "," + i3 + "," + n3 + "," + a2 + "," + x2 + "," + M3 + ")", g2.setAttribute("transform", s3), w2 && (g2.style[pr2] = s3);
        };
        ha("padding,margin,Width,Radius", function(e3, r3) {
          var t3 = "Right", i3 = "Bottom", n3 = "Left", o3 = (r3 < 3 ? ["Top", t3, i3, n3] : ["Top" + n3, "Top" + t3, i3 + t3, i3 + n3]).map(function(t4) {
            return r3 < 2 ? e3 + t4 : "border" + t4 + e3;
          });
          wr2[1 < r3 ? "border" + e3 : e3] = function(e4, t4, r4, i4, n4) {
            var a2, s3;
            if (arguments.length < 4)
              return a2 = o3.map(function(t5) {
                return Tr2(e4, t5, r4);
              }), 5 === (s3 = a2.join(" ")).split(a2[0]).length ? a2[0] : s3;
            a2 = (i4 + "").split(" "), s3 = {}, o3.forEach(function(t5, e5) {
              return s3[t5] = a2[e5] = a2[e5] || a2[(e5 - 1) / 2 | 0];
            }), e4.init(t4, s3, n4);
          };
        });
        var Er, Rr, Fr, Lr2 = {
          name: "css",
          register: Td,
          targetTest: function targetTest(t3) {
            return t3.style && t3.nodeType;
          },
          init: function init(t3, e3, i3, n3, a2) {
            var s3, o3, u2, h2, l3, f2, d3, c2, p2, _2, m2, g2, v2, y2, T3, b2, w2 = this._props, x2 = t3.style, M3 = i3.vars.startAt;
            for (d3 in Le2 || Td(), this.styles = this.styles || Nd(t3), b2 = this.styles.props, this.tween = i3, e3)
              if ("autoRound" !== d3 && (o3 = e3[d3], !pt2[d3] || !bc(d3, e3, i3, n3, t3, a2))) {
                if (l3 = typeof o3, f2 = wr2[d3], "function" === l3 && (l3 = typeof (o3 = o3.call(i3, n3, t3, a2))), "string" === l3 && ~o3.indexOf("random(") && (o3 = pb(o3)), f2)
                  f2(this, t3, d3, o3, i3) && (T3 = 1);
                else if ("--" === d3.substr(0, 2))
                  s3 = (getComputedStyle(t3).getPropertyValue(d3) + "").trim(), o3 += "", zt2.lastIndex = 0, zt2.test(s3) || (c2 = Za(s3), p2 = Za(o3)), p2 ? c2 !== p2 && (s3 = ae2(t3, d3, s3, p2) + p2) : c2 && (o3 += c2), this.add(x2, "setProperty", s3, o3, n3, a2, 0, 0, d3), w2.push(d3), b2.push(d3, 0, x2[d3]);
                else if ("undefined" !== l3) {
                  if (M3 && d3 in M3 ? (s3 = "function" == typeof M3[d3] ? M3[d3].call(i3, n3, t3, a2) : M3[d3], r2(s3) && ~s3.indexOf("random(") && (s3 = pb(s3)), Za(s3 + "") || "auto" === s3 || (s3 += X3.units[d3] || Za(Tr2(t3, d3)) || ""), "=" === (s3 + "").charAt(1) && (s3 = Tr2(t3, d3))) : s3 = Tr2(t3, d3), h2 = parseFloat(s3), (_2 = "string" === l3 && "=" === o3.charAt(1) && o3.substr(0, 2)) && (o3 = o3.substr(2)), u2 = parseFloat(o3), d3 in cr2 && ("autoAlpha" === d3 && (1 === h2 && "hidden" === Tr2(t3, "visibility") && u2 && (h2 = 0), b2.push("visibility", 0, x2.visibility), Zd(this, x2, "visibility", h2 ? "inherit" : "hidden", u2 ? "inherit" : "hidden", !u2)), "scale" !== d3 && "transform" !== d3 && ~(d3 = cr2[d3]).indexOf(",") && (d3 = d3.split(",")[0])), m2 = d3 in sr2)
                    if (this.styles.save(d3), "string" === l3 && "var(--" === o3.substring(0, 6) && (o3 = Qd(t3, o3.substring(4, o3.indexOf(")"))), u2 = parseFloat(o3)), g2 || ((v2 = t3._gsap).renderTransform && !e3.parseTransform || kr2(t3, e3.parseTransform), y2 = false !== e3.smoothOrigin && v2.smooth, (g2 = this._pt = new ge2(this._pt, x2, pr2, 0, 1, v2.renderTransform, v2, 0, -1)).dep = 1), "scale" === d3)
                      this._pt = new ge2(
                        this._pt,
                        v2,
                        "scaleY",
                        v2.scaleY,
                        (_2 ? ka(v2.scaleY, _2 + u2) : u2) - v2.scaleY || 0,
                        wd
                      ), this._pt.u = 0, w2.push("scaleY", d3), d3 += "X";
                    else {
                      if ("transformOrigin" === d3) {
                        b2.push(_r, 0, x2[_r]), o3 = ee2(o3), v2.svg ? me2(t3, o3, 0, y2, 0, this) : ((p2 = parseFloat(o3.split(" ")[2]) || 0) !== v2.zOrigin && Zd(this, v2, "zOrigin", v2.zOrigin, p2), Zd(this, x2, d3, Or2(s3), Or2(o3)));
                        continue;
                      }
                      if ("svgOrigin" === d3) {
                        me2(t3, o3, 1, y2, 0, this);
                        continue;
                      }
                      if (d3 in Mr) {
                        we2(this, v2, d3, h2, _2 ? ka(h2, _2 + o3) : o3);
                        continue;
                      }
                      if ("smoothOrigin" === d3) {
                        Zd(this, v2, "smooth", v2.smooth, o3);
                        continue;
                      }
                      if ("force3D" === d3) {
                        v2[d3] = o3;
                        continue;
                      }
                      if ("transform" === d3) {
                        ye2(this, o3, t3);
                        continue;
                      }
                    }
                  else d3 in x2 || (d3 = gr2(d3) || d3);
                  if (m2 || (u2 || 0 === u2) && (h2 || 0 === h2) && !dr2.test(o3) && d3 in x2)
                    u2 = u2 || 0, (c2 = (s3 + "").substr((h2 + "").length)) !== (p2 = Za(o3) || (d3 in X3.units ? X3.units[d3] : c2)) && (h2 = ae2(t3, d3, s3, p2)), this._pt = new ge2(
                      this._pt,
                      m2 ? v2 : x2,
                      d3,
                      h2,
                      (_2 ? ka(h2, _2 + u2) : u2) - h2,
                      m2 || "px" !== p2 && "zIndex" !== d3 || false === e3.autoRound ? wd : zd
                    ), this._pt.u = p2 || 0, c2 !== p2 && "%" !== p2 && (this._pt.b = s3, this._pt.r = yd);
                  else if (d3 in x2) ce.call(this, t3, d3, s3, _2 ? _2 + o3 : o3);
                  else if (d3 in t3) this.add(t3, d3, s3 || t3[d3], _2 ? _2 + o3 : o3, n3, a2);
                  else if ("parseTransform" !== d3) {
                    Q2(d3, o3);
                    continue;
                  }
                  m2 || (d3 in x2 ? b2.push(d3, 0, x2[d3]) : "function" == typeof t3[d3] ? b2.push(d3, 2, t3[d3]()) : b2.push(d3, 1, s3 || t3[d3])), w2.push(d3);
                }
              }
            T3 && _e2(this);
          },
          render: function render(t3, e3) {
            if (e3.tween._time || !Ye2()) for (var r3 = e3._pt; r3; ) r3.r(t3, r3.d), r3 = r3._next;
            else e3.styles.revert();
          },
          get: Tr2,
          aliases: cr2,
          getSetter: function getSetter(t3, e3, r3) {
            var i3 = cr2[e3];
            return i3 && i3.indexOf(",") < 0 && (e3 = i3), e3 in sr2 && e3 !== _r && (t3._gsap.x || Tr2(t3, "x")) ? r3 && Be2 === r3 ? "scale" === e3 ? Fd : Ed : (Be2 = r3 || {}) && ("scale" === e3 ? Gd : Hd) : t3.style && !u(t3.style[e3]) ? Cd : ~e3.indexOf("-") ? Dd : ie(t3, e3);
          },
          core: { _removeProperty: Yd, _getMatrix: le2 }
        };
        ze2.utils.checkPrefix = gr2, ze2.core.getStyleSaver = Nd, Fr = ha(
          (Er = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent") + "," + (Rr = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective",
          function(t3) {
            sr2[t3] = 1;
          }
        ), ha(Rr, function(t3) {
          X3.units[t3] = "deg", Mr[t3] = 1;
        }), cr2[Fr[13]] = Er + "," + Rr, ha("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function(t3) {
          var e3 = t3.split(":");
          cr2[e3[1]] = Fr[e3[0]];
        }), ha("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(t3) {
          X3.units[t3] = "px";
        }), ze2.registerPlugin(Lr2);
        var Ir2 = ze2.registerPlugin(Lr2) || ze2, Br = Ir2.core.Tween;
        e2.Back = tr2, e2.Bounce = rr2, e2.CSSPlugin = Lr2, e2.Circ = ar2, e2.Cubic = Ge2, e2.Elastic = $e2, e2.Expo = nr2, e2.Linear = Ve2, e2.Power0 = Ze2, e2.Power1 = Ne2, e2.Power2 = Qe2, e2.Power3 = Ue2, e2.Power4 = qe2, e2.Quad = We2, e2.Quart = He2, e2.Quint = Ke2, e2.Sine = ir2, e2.SteppedEase = er2, e2.Strong = Je2, e2.TimelineLite = Qt2, e2.TimelineMax = Qt2, e2.TweenLite = Jt2, e2.TweenMax = Br, e2.default = Ir2, e2.gsap = Ir2;
        if (typeof window === "undefined" || window !== e2) {
          Object.defineProperty(e2, "__esModule", { value: true });
        } else {
          delete e2.default;
        }
      });
      !(function(e2, t2) {
        "object" == typeof exports && "undefined" != typeof module ? t2(exports) : "function" == typeof define && define.amd ? define(["exports"], t2) : t2((e2 = e2 || self).window = e2.window || {});
      })(exports, function(e2) {
        "use strict";
        function _defineProperties(e3, t3) {
          for (var r3 = 0; r3 < t3.length; r3++) {
            var n3 = t3[r3];
            n3.enumerable = n3.enumerable || false, n3.configurable = true, "value" in n3 && (n3.writable = true), Object.defineProperty(e3, n3.key, n3);
          }
        }
        function r2() {
          return Se2 || "undefined" != typeof window && (Se2 = window.gsap) && Se2.registerPlugin && Se2;
        }
        function z2(e3, t3) {
          return ~Ye2.indexOf(e3) && Ye2[Ye2.indexOf(e3) + 1][t3];
        }
        function A2(e3) {
          return !!~t2.indexOf(e3);
        }
        function B2(e3, t3, r3, n3, i3) {
          return e3.addEventListener(t3, r3, { passive: false !== n3, capture: !!i3 });
        }
        function C2(e3, t3, r3, n3) {
          return e3.removeEventListener(t3, r3, !!n3);
        }
        function F2() {
          return Re2 && Re2.isPressed || ze2.cache++;
        }
        function G2(r3, n3) {
          function ed(e3) {
            if (e3 || 0 === e3) {
              i2 && (Te2.history.scrollRestoration = "manual");
              var t3 = Re2 && Re2.isPressed;
              e3 = ed.v = Math.round(e3) || (Re2 && Re2.iOS ? 1 : 0), r3(e3), ed.cacheID = ze2.cache, t3 && o2("ss", e3);
            } else (n3 || ze2.cache !== ed.cacheID || o2("ref")) && (ed.cacheID = ze2.cache, ed.v = r3());
            return ed.v + ed.offset;
          }
          return ed.offset = 0, r3 && ed;
        }
        function J2(e3, t3) {
          return (t3 && t3._ctx && t3._ctx.selector || Se2.utils.toArray)(e3)[0] || ("string" == typeof e3 && false !== Se2.config().nullTargetWarn ? console.warn("Element not found:", e3) : null);
        }
        function L2(t3, e3) {
          var r3 = e3.s, n3 = e3.sc;
          A2(t3) && (t3 = Ce2.scrollingElement || Me2);
          var i3 = ze2.indexOf(t3), o3 = n3 === qe2.sc ? 1 : 2;
          ~i3 || (i3 = ze2.push(t3) - 1), ze2[i3 + o3] || B2(t3, "scroll", F2);
          var a2 = ze2[i3 + o3], s3 = a2 || (ze2[i3 + o3] = G2(z2(t3, r3), true) || (A2(t3) ? n3 : G2(function(e4) {
            return arguments.length ? t3[r3] = e4 : t3[r3];
          })));
          return s3.target = t3, a2 || (s3.smooth = "smooth" === Se2.getProperty(t3, "scrollBehavior")), s3;
        }
        function M2(e3, t3, i3) {
          function Gd(e4, t4) {
            var r3 = Le2();
            t4 || n3 < r3 - s3 ? (a2 = o3, o3 = e4, l3 = s3, s3 = r3) : i3 ? o3 += e4 : o3 = a2 + (e4 - a2) / (r3 - l3) * (s3 - l3);
          }
          var o3 = e3, a2 = e3, s3 = Le2(), l3 = s3, n3 = t3 || 50, c2 = Math.max(500, 3 * n3);
          return {
            update: Gd,
            reset: function reset() {
              a2 = o3 = i3 ? 0 : o3, l3 = s3 = 0;
            },
            getVelocity: function getVelocity(e4) {
              var t4 = l3, r3 = a2, n4 = Le2();
              return !e4 && 0 !== e4 || e4 === o3 || Gd(e4), s3 === l3 || c2 < n4 - l3 ? 0 : (o3 + (i3 ? r3 : -r3)) / ((i3 ? n4 : s3) - t4) * 1e3;
            }
          };
        }
        function N2(e3, t3) {
          return t3 && !e3._gsapAllow && e3.preventDefault(), e3.changedTouches ? e3.changedTouches[0] : e3;
        }
        function O2(e3) {
          var t3 = Math.max.apply(Math, e3), r3 = Math.min.apply(Math, e3);
          return Math.abs(t3) >= Math.abs(r3) ? t3 : r3;
        }
        function P() {
          (Ae2 = Se2.core.globals().ScrollTrigger) && Ae2.core && (function _integrate() {
            var e3 = Ae2.core, r3 = e3.bridge || {}, t3 = e3._scrollers, n3 = e3._proxies;
            t3.push.apply(t3, ze2), n3.push.apply(n3, Ye2), ze2 = t3, Ye2 = n3, o2 = function _bridge(e4, t4) {
              return r3[e4](t4);
            };
          })();
        }
        function Q2(e3) {
          return Se2 = e3 || r2(), !ke2 && Se2 && "undefined" != typeof document && document.body && (Te2 = window, Me2 = (Ce2 = document).documentElement, Ee2 = Ce2.body, t2 = [Te2, Ce2, Me2, Ee2], Se2.utils.clamp, Be2 = Se2.core.context || function() {
          }, Oe2 = "onpointerenter" in Ee2 ? "pointer" : "mouse", Pe2 = E.isTouch = Te2.matchMedia && Te2.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in Te2 || 0 < navigator.maxTouchPoints || 0 < navigator.msMaxTouchPoints ? 2 : 0, De2 = E.eventTypes = ("ontouchstart" in Me2 ? "touchstart,touchmove,touchcancel,touchend" : "onpointerdown" in Me2 ? "pointerdown,pointermove,pointercancel,pointerup" : "mousedown,mousemove,mouseup,mouseup").split(","), setTimeout(function() {
            return i2 = 0;
          }, 500), P(), ke2 = 1), ke2;
        }
        var Se2, ke2, Te2, Ce2, Me2, Ee2, Pe2, Oe2, Ae2, t2, Re2, De2, Be2, i2 = 1, Ie2 = [], ze2 = [], Ye2 = [], Le2 = Date.now, o2 = function _bridge(e3, t3) {
          return t3;
        }, n2 = "scrollLeft", a = "scrollTop", He2 = {
          s: n2,
          p: "left",
          p2: "Left",
          os: "right",
          os2: "Right",
          d: "width",
          d2: "Width",
          a: "x",
          sc: G2(function(e3) {
            return arguments.length ? Te2.scrollTo(e3, qe2.sc()) : Te2.pageXOffset || Ce2[n2] || Me2[n2] || Ee2[n2] || 0;
          })
        }, qe2 = {
          s: a,
          p: "top",
          p2: "Top",
          os: "bottom",
          os2: "Bottom",
          d: "height",
          d2: "Height",
          a: "y",
          op: He2,
          sc: G2(function(e3) {
            return arguments.length ? Te2.scrollTo(He2.sc(), e3) : Te2.pageYOffset || Ce2[a] || Me2[a] || Ee2[a] || 0;
          })
        };
        He2.op = qe2, ze2.cache = 0;
        var E = (Observer2.prototype.init = function init(e3) {
          ke2 || Q2(Se2) || console.warn("Please gsap.registerPlugin(Observer)"), Ae2 || P();
          var i3 = e3.tolerance, a2 = e3.dragMinimum, t3 = e3.type, o3 = e3.target, r3 = e3.lineHeight, n3 = e3.debounce, s3 = e3.preventDefault, l3 = e3.onStop, c2 = e3.onStopDelay, u2 = e3.ignore, f2 = e3.wheelSpeed, d3 = e3.event, p2 = e3.onDragStart, g2 = e3.onDragEnd, h2 = e3.onDrag, v2 = e3.onPress, b2 = e3.onRelease, m2 = e3.onRight, y2 = e3.onLeft, x2 = e3.onUp, _2 = e3.onDown, w2 = e3.onChangeX, S2 = e3.onChangeY, k3 = e3.onChange, T3 = e3.onToggleX, E2 = e3.onToggleY, R3 = e3.onHover, D2 = e3.onHoverEnd, I3 = e3.onMove, z3 = e3.ignoreCheck, Y3 = e3.isNormalizer, H3 = e3.onGestureStart, q3 = e3.onGestureEnd, X4 = e3.onWheel, U3 = e3.onEnable, W3 = e3.onDisable, G3 = e3.onClick, V3 = e3.scrollSpeed, K3 = e3.capture, j3 = e3.allowClicks, Z3 = e3.lockAxis, $2 = e3.onLockAxis;
          function gf() {
            return xe2 = Le2();
          }
          function hf(e4, t4) {
            return (se3.event = e4) && u2 && (function _isWithin(e5, t5) {
              for (var r4 = t5.length; r4--; ) if (t5[r4] === e5 || t5[r4].contains(e5)) return true;
              return false;
            })(e4.target, u2) || t4 && he2 && "touch" !== e4.pointerType || z3 && z3(e4, t4);
          }
          function kf() {
            var e4 = se3.deltaX = O2(me2), t4 = se3.deltaY = O2(ye2), r4 = Math.abs(e4) >= i3, n4 = Math.abs(t4) >= i3;
            k3 && (r4 || n4) && k3(se3, e4, t4, me2, ye2), r4 && (m2 && 0 < se3.deltaX && m2(se3), y2 && se3.deltaX < 0 && y2(se3), w2 && w2(se3), T3 && se3.deltaX < 0 != le2 < 0 && T3(se3), le2 = se3.deltaX, me2[0] = me2[1] = me2[2] = 0), n4 && (_2 && 0 < se3.deltaY && _2(se3), x2 && se3.deltaY < 0 && x2(se3), S2 && S2(se3), E2 && se3.deltaY < 0 != ce < 0 && E2(se3), ce = se3.deltaY, ye2[0] = ye2[1] = ye2[2] = 0), (ne3 || re2) && (I3 && I3(se3), re2 && (p2 && 1 === re2 && p2(se3), h2 && h2(se3), re2 = 0), ne3 = false), oe3 && !(oe3 = false) && $2 && $2(se3), ie2 && (X4(se3), ie2 = false), ee3 = 0;
          }
          function lf(e4, t4, r4) {
            me2[r4] += e4, ye2[r4] += t4, se3._vx.update(e4), se3._vy.update(t4), n3 ? ee3 = ee3 || requestAnimationFrame(kf) : kf();
          }
          function mf(e4, t4) {
            Z3 && !ae3 && (se3.axis = ae3 = Math.abs(e4) > Math.abs(t4) ? "x" : "y", oe3 = true), "y" !== ae3 && (me2[2] += e4, se3._vx.update(e4, true)), "x" !== ae3 && (ye2[2] += t4, se3._vy.update(t4, true)), n3 ? ee3 = ee3 || requestAnimationFrame(kf) : kf();
          }
          function nf(e4) {
            if (!hf(e4, 1)) {
              var t4 = (e4 = N2(e4, s3)).clientX, r4 = e4.clientY, n4 = t4 - se3.x, i4 = r4 - se3.y, o4 = se3.isDragging;
              se3.x = t4, se3.y = r4, (o4 || (n4 || i4) && (Math.abs(se3.startX - t4) >= a2 || Math.abs(se3.startY - r4) >= a2)) && (re2 = o4 ? 2 : 1, o4 || (se3.isDragging = true), mf(n4, i4));
            }
          }
          function qf(e4) {
            return e4.touches && 1 < e4.touches.length && (se3.isGesturing = true) && H3(e4, se3.isDragging);
          }
          function rf() {
            return (se3.isGesturing = false) || q3(se3);
          }
          function sf(e4) {
            if (!hf(e4)) {
              var t4 = fe(), r4 = de2();
              lf((t4 - pe2) * V3, (r4 - ge2) * V3, 1), pe2 = t4, ge2 = r4, l3 && te3.restart(true);
            }
          }
          function tf(e4) {
            if (!hf(e4)) {
              e4 = N2(e4, s3), X4 && (ie2 = true);
              var t4 = (1 === e4.deltaMode ? r3 : 2 === e4.deltaMode ? Te2.innerHeight : 1) * f2;
              lf(e4.deltaX * t4, e4.deltaY * t4, 0), l3 && !Y3 && te3.restart(true);
            }
          }
          function uf(e4) {
            if (!hf(e4)) {
              var t4 = e4.clientX, r4 = e4.clientY, n4 = t4 - se3.x, i4 = r4 - se3.y;
              se3.x = t4, se3.y = r4, ne3 = true, l3 && te3.restart(true), (n4 || i4) && mf(n4, i4);
            }
          }
          function vf(e4) {
            se3.event = e4, R3(se3);
          }
          function wf(e4) {
            se3.event = e4, D2(se3);
          }
          function xf(e4) {
            return hf(e4) || N2(e4, s3) && G3(se3);
          }
          this.target = o3 = J2(o3) || Me2, this.vars = e3, u2 = u2 && Se2.utils.toArray(u2), i3 = i3 || 1e-9, a2 = a2 || 0, f2 = f2 || 1, V3 = V3 || 1, t3 = t3 || "wheel,touch,pointer", n3 = false !== n3, r3 = r3 || parseFloat(Te2.getComputedStyle(Ee2).lineHeight) || 22;
          var ee3, te3, re2, ne3, ie2, oe3, ae3, se3 = this, le2 = 0, ce = 0, ue2 = e3.passive || !s3 && false !== e3.passive, fe = L2(o3, He2), de2 = L2(o3, qe2), pe2 = fe(), ge2 = de2(), he2 = ~t3.indexOf("touch") && !~t3.indexOf("pointer") && "pointerdown" === De2[0], ve2 = A2(o3), be2 = o3.ownerDocument || Ce2, me2 = [0, 0, 0], ye2 = [0, 0, 0], xe2 = 0, _e2 = se3.onPress = function(e4) {
            hf(e4, 1) || e4 && e4.button || (se3.axis = ae3 = null, te3.pause(), se3.isPressed = true, e4 = N2(e4), le2 = ce = 0, se3.startX = se3.x = e4.clientX, se3.startY = se3.y = e4.clientY, se3._vx.reset(), se3._vy.reset(), B2(Y3 ? o3 : be2, De2[1], nf, ue2, true), se3.deltaX = se3.deltaY = 0, v2 && v2(se3));
          }, we2 = se3.onRelease = function(t4) {
            if (!hf(t4, 1)) {
              C2(Y3 ? o3 : be2, De2[1], nf, true);
              var e4 = !isNaN(se3.y - se3.startY), r4 = se3.isDragging, n4 = r4 && (3 < Math.abs(se3.x - se3.startX) || 3 < Math.abs(se3.y - se3.startY)), i4 = N2(t4);
              !n4 && e4 && (se3._vx.reset(), se3._vy.reset(), s3 && j3 && Se2.delayedCall(0.08, function() {
                if (300 < Le2() - xe2 && !t4.defaultPrevented) {
                  if (t4.target.click) t4.target.click();
                  else if (be2.createEvent) {
                    var e5 = be2.createEvent("MouseEvents");
                    e5.initMouseEvent(
                      "click",
                      true,
                      true,
                      Te2,
                      1,
                      i4.screenX,
                      i4.screenY,
                      i4.clientX,
                      i4.clientY,
                      false,
                      false,
                      false,
                      false,
                      0,
                      null
                    ), t4.target.dispatchEvent(e5);
                  }
                }
              })), se3.isDragging = se3.isGesturing = se3.isPressed = false, l3 && r4 && !Y3 && te3.restart(true), re2 && kf(), g2 && r4 && g2(se3), b2 && b2(se3, n4);
            }
          };
          te3 = se3._dc = Se2.delayedCall(c2 || 0.25, function onStopFunc() {
            se3._vx.reset(), se3._vy.reset(), te3.pause(), l3 && l3(se3);
          }).pause(), se3.deltaX = se3.deltaY = 0, se3._vx = M2(0, 50, true), se3._vy = M2(0, 50, true), se3.scrollX = fe, se3.scrollY = de2, se3.isDragging = se3.isGesturing = se3.isPressed = false, Be2(this), se3.enable = function(e4) {
            return se3.isEnabled || (B2(ve2 ? be2 : o3, "scroll", F2), 0 <= t3.indexOf("scroll") && B2(ve2 ? be2 : o3, "scroll", sf, ue2, K3), 0 <= t3.indexOf("wheel") && B2(o3, "wheel", tf, ue2, K3), (0 <= t3.indexOf("touch") && Pe2 || 0 <= t3.indexOf("pointer")) && (B2(o3, De2[0], _e2, ue2, K3), B2(be2, De2[2], we2), B2(be2, De2[3], we2), j3 && B2(o3, "click", gf, true, true), G3 && B2(o3, "click", xf), H3 && B2(be2, "gesturestart", qf), q3 && B2(be2, "gestureend", rf), R3 && B2(o3, Oe2 + "enter", vf), D2 && B2(o3, Oe2 + "leave", wf), I3 && B2(o3, Oe2 + "move", uf)), se3.isEnabled = true, se3.isDragging = se3.isGesturing = se3.isPressed = ne3 = re2 = false, se3._vx.reset(), se3._vy.reset(), pe2 = fe(), ge2 = de2(), e4 && e4.type && _e2(e4), U3 && U3(se3)), se3;
          }, se3.disable = function() {
            se3.isEnabled && (Ie2.filter(function(e4) {
              return e4 !== se3 && A2(e4.target);
            }).length || C2(ve2 ? be2 : o3, "scroll", F2), se3.isPressed && (se3._vx.reset(), se3._vy.reset(), C2(Y3 ? o3 : be2, De2[1], nf, true)), C2(ve2 ? be2 : o3, "scroll", sf, K3), C2(o3, "wheel", tf, K3), C2(o3, De2[0], _e2, K3), C2(be2, De2[2], we2), C2(be2, De2[3], we2), C2(o3, "click", gf, true), C2(o3, "click", xf), C2(be2, "gesturestart", qf), C2(be2, "gestureend", rf), C2(o3, Oe2 + "enter", vf), C2(o3, Oe2 + "leave", wf), C2(o3, Oe2 + "move", uf), se3.isEnabled = se3.isPressed = se3.isDragging = false, W3 && W3(se3));
          }, se3.kill = se3.revert = function() {
            se3.disable();
            var e4 = Ie2.indexOf(se3);
            0 <= e4 && Ie2.splice(e4, 1), Re2 === se3 && (Re2 = 0);
          }, Ie2.push(se3), Y3 && A2(o3) && (Re2 = se3), se3.enable(d3);
        }, (function _createClass(e3, t3, r3) {
          return t3 && _defineProperties(e3.prototype, t3), r3 && _defineProperties(e3, r3), e3;
        })(Observer2, [
          {
            key: "velocityX",
            get: function get() {
              return this._vx.getVelocity();
            }
          },
          {
            key: "velocityY",
            get: function get() {
              return this._vy.getVelocity();
            }
          }
        ]), Observer2);
        function Observer2(e3) {
          this.init(e3);
        }
        E.version = "3.13.0", E.create = function(e3) {
          return new E(e3);
        }, E.register = Q2, E.getAll = function() {
          return Ie2.slice();
        }, E.getById = function(t3) {
          return Ie2.filter(function(e3) {
            return e3.vars.id === t3;
          })[0];
        }, r2() && Se2.registerPlugin(E);
        function Da(e3, t3, r3) {
          var n3 = ct2(e3) && ("clamp(" === e3.substr(0, 6) || -1 < e3.indexOf("max"));
          return (r3["_" + t3 + "Clamp"] = n3) ? e3.substr(6, e3.length - 7) : e3;
        }
        function Ea(e3, t3) {
          return !t3 || ct2(e3) && "clamp(" === e3.substr(0, 6) ? e3 : "clamp(" + e3 + ")";
        }
        function Ga() {
          return Qe2 = 1;
        }
        function Ha() {
          return Qe2 = 0;
        }
        function Ia(e3) {
          return e3;
        }
        function Ja(e3) {
          return Math.round(1e5 * e3) / 1e5 || 0;
        }
        function Ka() {
          return "undefined" != typeof window;
        }
        function La() {
          return Ne2 || Ka() && (Ne2 = window.gsap) && Ne2.registerPlugin && Ne2;
        }
        function Ma(e3) {
          return !!~l2.indexOf(e3);
        }
        function Na(e3) {
          return ("Height" === e3 ? S : Xe2["inner" + e3]) || Ue2["client" + e3] || We2["client" + e3];
        }
        function Oa(e3) {
          return z2(e3, "getBoundingClientRect") || (Ma(e3) ? function() {
            return Ot.width = Xe2.innerWidth, Ot.height = S, Ot;
          } : function() {
            return _t2(e3);
          });
        }
        function Ra(e3, t3) {
          var r3 = t3.s, n3 = t3.d2, i3 = t3.d, o3 = t3.a;
          return Math.max(
            0,
            (r3 = "scroll" + n3) && (o3 = z2(e3, r3)) ? o3() - Oa(e3)()[i3] : Ma(e3) ? (Ue2[r3] || We2[r3]) - Na(n3) : e3[r3] - e3["offset" + n3]
          );
        }
        function Sa(e3, t3) {
          for (var r3 = 0; r3 < g.length; r3 += 3) t3 && !~t3.indexOf(g[r3 + 1]) || e3(g[r3], g[r3 + 1], g[r3 + 2]);
        }
        function Ua(e3) {
          return "function" == typeof e3;
        }
        function Va(e3) {
          return "number" == typeof e3;
        }
        function Wa(e3) {
          return "object" == typeof e3;
        }
        function Xa(e3, t3, r3) {
          return e3 && e3.progress(t3 ? 0 : 1) && r3 && e3.pause();
        }
        function Ya(e3, t3) {
          if (e3.enabled) {
            var r3 = e3._ctx ? e3._ctx.add(function() {
              return t3(e3);
            }) : t3(e3);
            r3 && r3.totalTime && (e3.callbackAnimation = r3);
          }
        }
        function nb(e3) {
          return Xe2.getComputedStyle(e3);
        }
        function pb(e3, t3) {
          for (var r3 in t3) r3 in e3 || (e3[r3] = t3[r3]);
          return e3;
        }
        function rb(e3, t3) {
          var r3 = t3.d2;
          return e3["offset" + r3] || e3["client" + r3] || 0;
        }
        function sb(e3) {
          var t3, r3 = [], n3 = e3.labels, i3 = e3.duration();
          for (t3 in n3) r3.push(n3[t3] / i3);
          return r3;
        }
        function ub(i3) {
          var o3 = Ne2.utils.snap(i3), a2 = Array.isArray(i3) && i3.slice(0).sort(function(e3, t3) {
            return e3 - t3;
          });
          return a2 ? function(e3, t3, r3) {
            var n3;
            if (void 0 === r3 && (r3 = 1e-3), !t3) return o3(e3);
            if (0 < t3) {
              for (e3 -= r3, n3 = 0; n3 < a2.length; n3++) if (a2[n3] >= e3) return a2[n3];
              return a2[n3 - 1];
            }
            for (n3 = a2.length, e3 += r3; n3--; ) if (a2[n3] <= e3) return a2[n3];
            return a2[0];
          } : function(e3, t3, r3) {
            void 0 === r3 && (r3 = 1e-3);
            var n3 = o3(e3);
            return !t3 || Math.abs(n3 - e3) < r3 || n3 - e3 < 0 == t3 < 0 ? n3 : o3(t3 < 0 ? e3 - i3 : e3 + i3);
          };
        }
        function wb(t3, r3, e3, n3) {
          return e3.split(",").forEach(function(e4) {
            return t3(r3, e4, n3);
          });
        }
        function xb(e3, t3, r3, n3, i3) {
          return e3.addEventListener(t3, r3, { passive: !n3, capture: !!i3 });
        }
        function yb(e3, t3, r3, n3) {
          return e3.removeEventListener(t3, r3, !!n3);
        }
        function zb(e3, t3, r3) {
          (r3 = r3 && r3.wheelHandler) && (e3(t3, "wheel", r3), e3(t3, "touchmove", r3));
        }
        function Db(e3, t3) {
          if (ct2(e3)) {
            var r3 = e3.indexOf("="), n3 = ~r3 ? (e3.charAt(r3 - 1) + 1) * parseFloat(e3.substr(r3 + 1)) : 0;
            ~r3 && (e3.indexOf("%") > r3 && (n3 *= t3 / 100), e3 = e3.substr(0, r3 - 1)), e3 = n3 + (e3 in q2 ? q2[e3] * t3 : ~e3.indexOf("%") ? parseFloat(e3) * t3 / 100 : parseFloat(e3) || 0);
          }
          return e3;
        }
        function Eb(e3, t3, r3, n3, i3, o3, a2, s3) {
          var l3 = i3.startColor, c2 = i3.endColor, u2 = i3.fontSize, f2 = i3.indent, d3 = i3.fontWeight, p2 = Fe.createElement("div"), g2 = Ma(r3) || "fixed" === z2(r3, "pinType"), h2 = -1 !== e3.indexOf("scroller"), v2 = g2 ? We2 : r3, b2 = -1 !== e3.indexOf("start"), m2 = b2 ? l3 : c2, y2 = "border-color:" + m2 + ";font-size:" + u2 + ";color:" + m2 + ";font-weight:" + d3 + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
          return y2 += "position:" + ((h2 || s3) && g2 ? "fixed;" : "absolute;"), !h2 && !s3 && g2 || (y2 += (n3 === qe2 ? I2 : Y2) + ":" + (o3 + parseFloat(f2)) + "px;"), a2 && (y2 += "box-sizing:border-box;text-align:left;width:" + a2.offsetWidth + "px;"), p2._isStart = b2, p2.setAttribute("class", "gsap-marker-" + e3 + (t3 ? " marker-" + t3 : "")), p2.style.cssText = y2, p2.innerText = t3 || 0 === t3 ? e3 + "-" + t3 : e3, v2.children[0] ? v2.insertBefore(p2, v2.children[0]) : v2.appendChild(p2), p2._offset = p2["offset" + n3.op.d2], X3(p2, 0, n3, b2), p2;
        }
        function Jb() {
          return 34 < at2() - st2 && (T2 = T2 || requestAnimationFrame(Z2));
        }
        function Kb() {
          v && v.isPressed && !(v.startX > We2.clientWidth) || (ze2.cache++, v ? T2 = T2 || requestAnimationFrame(Z2) : Z2(), st2 || V2("scrollStart"), st2 = at2());
        }
        function Lb() {
          y = Xe2.innerWidth, m = Xe2.innerHeight;
        }
        function Mb(e3) {
          ze2.cache++, true !== e3 && (Ke2 || h || Fe.fullscreenElement || Fe.webkitFullscreenElement || b && y === Xe2.innerWidth && !(Math.abs(Xe2.innerHeight - m) > 0.25 * Xe2.innerHeight)) || c.restart(true);
        }
        function Pb() {
          return yb(ne2, "scrollEnd", Pb) || Mt2(true);
        }
        function Sb(e3) {
          for (var t3 = 0; t3 < K2.length; t3 += 5)
            (!e3 || K2[t3 + 4] && K2[t3 + 4].query === e3) && (K2[t3].style.cssText = K2[t3 + 1], K2[t3].getBBox && K2[t3].setAttribute("transform", K2[t3 + 2] || ""), K2[t3 + 3].uncache = 1);
        }
        function Tb(e3, t3) {
          var r3;
          for (je2 = 0; je2 < kt2.length; je2++) !(r3 = kt2[je2]) || t3 && r3._ctx !== t3 || (e3 ? r3.kill(1) : r3.revert(true, true));
          k2 = true, t3 && Sb(t3), t3 || V2("revert");
        }
        function Ub(e3, t3) {
          ze2.cache++, !t3 && rt2 || ze2.forEach(function(e4) {
            return Ua(e4) && e4.cacheID++ && (e4.rec = 0);
          }), ct2(e3) && (Xe2.history.scrollRestoration = _ = e3);
        }
        function Zb() {
          We2.appendChild(w), S = !v && w.offsetHeight || Xe2.innerHeight, We2.removeChild(w);
        }
        function $b(t3) {
          return Je2(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(
            function(e3) {
              return e3.style.display = t3 ? "none" : "block";
            }
          );
        }
        function hc(e3, t3, r3, n3) {
          if (!e3._gsap.swappedIn) {
            for (var i3, o3 = $.length, a2 = t3.style, s3 = e3.style; o3--; ) a2[i3 = $[o3]] = r3[i3];
            a2.position = "absolute" === r3.position ? "absolute" : "relative", "inline" === r3.display && (a2.display = "inline-block"), s3[Y2] = s3[I2] = "auto", a2.flexBasis = r3.flexBasis || "auto", a2.overflow = "visible", a2.boxSizing = "border-box", a2[ft2] = rb(e3, He2) + xt2, a2[dt2] = rb(e3, qe2) + xt2, a2[bt2] = s3[mt2] = s3.top = s3.left = "0", Pt2(n3), s3[ft2] = s3.maxWidth = r3[ft2], s3[dt2] = s3.maxHeight = r3[dt2], s3[bt2] = r3[bt2], e3.parentNode !== t3 && (e3.parentNode.insertBefore(t3, e3), t3.appendChild(e3)), e3._gsap.swappedIn = true;
          }
        }
        function kc(e3) {
          for (var t3 = ee2.length, r3 = e3.style, n3 = [], i3 = 0; i3 < t3; i3++) n3.push(ee2[i3], r3[ee2[i3]]);
          return n3.t = e3, n3;
        }
        function nc(e3, t3, r3, n3, i3, o3, a2, s3, l3, c2, u2, f2, d3, p2) {
          Ua(e3) && (e3 = e3(s3)), ct2(e3) && "max" === e3.substr(0, 3) && (e3 = f2 + ("=" === e3.charAt(4) ? Db("0" + e3.substr(3), r3) : 0));
          var g2, h2, v2, b2 = d3 ? d3.time() : 0;
          if (d3 && d3.seek(0), isNaN(e3) || (e3 = +e3), Va(e3))
            d3 && (e3 = Ne2.utils.mapRange(d3.scrollTrigger.start, d3.scrollTrigger.end, 0, f2, e3)), a2 && X3(a2, r3, n3, true);
          else {
            Ua(t3) && (t3 = t3(s3));
            var m2, y2, x2, _2, w2 = (e3 || "0").split(" ");
            v2 = J2(t3, s3) || We2, (m2 = _t2(v2) || {}) && (m2.left || m2.top) || "none" !== nb(v2).display || (_2 = v2.style.display, v2.style.display = "block", m2 = _t2(v2), _2 ? v2.style.display = _2 : v2.style.removeProperty("display")), y2 = Db(w2[0], m2[n3.d]), x2 = Db(w2[1] || "0", r3), e3 = m2[n3.p] - l3[n3.p] - c2 + y2 + i3 - x2, a2 && X3(a2, x2, n3, r3 - x2 < 20 || a2._isStart && 20 < x2), r3 -= r3 - x2;
          }
          if (p2 && (s3[p2] = e3 || -1e-3, e3 < 0 && (e3 = 0)), o3) {
            var S2 = e3 + r3, k3 = o3._isStart;
            g2 = "scroll" + n3.d2, X3(o3, S2, n3, k3 && 20 < S2 || !k3 && (u2 ? Math.max(We2[g2], Ue2[g2]) : o3.parentNode[g2]) <= S2 + 1), u2 && (l3 = _t2(a2), u2 && (o3.style[n3.op.p] = l3[n3.op.p] - n3.op.m - o3._offset + xt2));
          }
          return d3 && v2 && (g2 = _t2(v2), d3.seek(f2), h2 = _t2(v2), d3._caScrollDist = g2[n3.p] - h2[n3.p], e3 = e3 / d3._caScrollDist * f2), d3 && d3.seek(b2), d3 ? e3 : Math.round(e3);
        }
        function pc(e3, t3, r3, n3) {
          if (e3.parentNode !== t3) {
            var i3, o3, a2 = e3.style;
            if (t3 === We2) {
              for (i3 in e3._stOrig = a2.cssText, o3 = nb(e3))
                +i3 || re.test(i3) || !o3[i3] || "string" != typeof a2[i3] || "0" === i3 || (a2[i3] = o3[i3]);
              a2.top = r3, a2.left = n3;
            } else a2.cssText = e3._stOrig;
            Ne2.core.getCache(e3).uncache = 1, t3.appendChild(e3);
          }
        }
        function qc(r3, e3, n3) {
          var i3 = e3, o3 = i3;
          return function(e4) {
            var t3 = Math.round(r3());
            return t3 !== i3 && t3 !== o3 && 3 < Math.abs(t3 - i3) && 3 < Math.abs(t3 - o3) && (e4 = t3, n3 && n3()), o3 = i3, i3 = Math.round(e4);
          };
        }
        function rc(e3, t3, r3) {
          var n3 = {};
          n3[t3.p] = "+=" + r3, Ne2.set(e3, n3);
        }
        function sc(c2, e3) {
          function Hk(e4, t3, r3, n3, i3) {
            var o3 = Hk.tween, a2 = t3.onComplete, s3 = {};
            r3 = r3 || u2();
            var l3 = qc(u2, r3, function() {
              o3.kill(), Hk.tween = 0;
            });
            return i3 = n3 && i3 || 0, n3 = n3 || e4 - r3, o3 && o3.kill(), t3[f2] = e4, t3.inherit = false, (t3.modifiers = s3)[f2] = function() {
              return l3(r3 + n3 * o3.ratio + i3 * o3.ratio * o3.ratio);
            }, t3.onUpdate = function() {
              ze2.cache++, Hk.tween && Z2();
            }, t3.onComplete = function() {
              Hk.tween = 0, a2 && a2.call(o3);
            }, o3 = Hk.tween = Ne2.to(c2, t3);
          }
          var u2 = L2(c2, e3), f2 = "_scroll" + e3.p2;
          return (c2[f2] = u2).wheelHandler = function() {
            return Hk.tween && Hk.tween.kill() && (Hk.tween = 0);
          }, xb(c2, "wheel", u2.wheelHandler), ne2.isTouch && xb(c2, "touchmove", u2.wheelHandler), Hk;
        }
        var Ne2, s2, Xe2, Fe, Ue2, We2, l2, c, Je2, Ge2, Ve2, u, Ke2, Qe2, f, je2, d2, p, g, Ze2, $e2, h, v, b, m, y, R2, x, _, w, S, k2, et2, tt2, T2, rt2, nt, it2, ot2 = 1, at2 = Date.now, D = at2(), st2 = 0, lt2 = 0, ct2 = function _isString(e3) {
          return "string" == typeof e3;
        }, ut2 = Math.abs, I2 = "right", Y2 = "bottom", ft2 = "width", dt2 = "height", pt2 = "Right", gt2 = "Left", ht2 = "Top", vt2 = "Bottom", bt2 = "padding", mt2 = "margin", yt2 = "Width", H2 = "Height", xt2 = "px", _t2 = function _getBounds(e3, t3) {
          var r3 = t3 && "matrix(1, 0, 0, 1, 0, 0)" !== nb(e3)[f] && Ne2.to(e3, {
            x: 0,
            y: 0,
            xPercent: 0,
            yPercent: 0,
            rotation: 0,
            rotationX: 0,
            rotationY: 0,
            scale: 1,
            skewX: 0,
            skewY: 0
          }).progress(1), n3 = e3.getBoundingClientRect();
          return r3 && r3.progress(0).kill(), n3;
        }, wt2 = { startColor: "green", endColor: "red", indent: 0, fontSize: "16px", fontWeight: "normal" }, St2 = { toggleActions: "play", anticipatePin: 0 }, q2 = { top: 0, left: 0, center: 0.5, bottom: 1, right: 1 }, X3 = function _positionMarker(e3, t3, r3, n3) {
          var i3 = { display: "block" }, o3 = r3[n3 ? "os2" : "p2"], a2 = r3[n3 ? "p2" : "os2"];
          e3._isFlipped = n3, i3[r3.a + "Percent"] = n3 ? -100 : 0, i3[r3.a] = n3 ? "1px" : 0, i3["border" + o3 + yt2] = 1, i3["border" + a2 + yt2] = 0, i3[r3.p] = t3 + "px", Ne2.set(e3, i3);
        }, kt2 = [], Tt2 = {}, U2 = {}, W2 = [], V2 = function _dispatch(e3) {
          return U2[e3] && U2[e3].map(function(e4) {
            return e4();
          }) || W2;
        }, K2 = [], Ct2 = 0, Mt2 = function _refreshAll(e3, t3) {
          if (Ue2 = Fe.documentElement, We2 = Fe.body, l2 = [Xe2, Fe, Ue2, We2], !st2 || e3 || k2) {
            Zb(), rt2 = ne2.isRefreshing = true, ze2.forEach(function(e4) {
              return Ua(e4) && ++e4.cacheID && (e4.rec = e4());
            });
            var r3 = V2("refreshInit");
            Ze2 && ne2.sort(), t3 || Tb(), ze2.forEach(function(e4) {
              Ua(e4) && (e4.smooth && (e4.target.style.scrollBehavior = "auto"), e4(0));
            }), kt2.slice(0).forEach(function(e4) {
              return e4.refresh();
            }), k2 = false, kt2.forEach(function(e4) {
              if (e4._subPinOffset && e4.pin) {
                var t4 = e4.vars.horizontal ? "offsetWidth" : "offsetHeight", r4 = e4.pin[t4];
                e4.revert(true, 1), e4.adjustPinSpacing(e4.pin[t4] - r4), e4.refresh();
              }
            }), et2 = 1, $b(true), kt2.forEach(function(e4) {
              var t4 = Ra(e4.scroller, e4._dir), r4 = "max" === e4.vars.end || e4._endClamp && e4.end > t4, n3 = e4._startClamp && e4.start >= t4;
              (r4 || n3) && e4.setPositions(n3 ? t4 - 1 : e4.start, r4 ? Math.max(n3 ? t4 : e4.start + 1, t4) : e4.end, true);
            }), $b(false), et2 = 0, r3.forEach(function(e4) {
              return e4 && e4.render && e4.render(-1);
            }), ze2.forEach(function(e4) {
              Ua(e4) && (e4.smooth && requestAnimationFrame(function() {
                return e4.target.style.scrollBehavior = "smooth";
              }), e4.rec && e4(e4.rec));
            }), Ub(_, 1), c.pause(), Ct2++, Z2(rt2 = 2), kt2.forEach(function(e4) {
              return Ua(e4.vars.onRefresh) && e4.vars.onRefresh(e4);
            }), rt2 = ne2.isRefreshing = false, V2("refresh");
          } else xb(ne2, "scrollEnd", Pb);
        }, j2 = 0, Et2 = 1, Z2 = function _updateAll(e3) {
          if (2 === e3 || !rt2 && !k2) {
            ne2.isUpdating = true, it2 && it2.update(0);
            var t3 = kt2.length, r3 = at2(), n3 = 50 <= r3 - D, i3 = t3 && kt2[0].scroll();
            if (Et2 = i3 < j2 ? -1 : 1, rt2 || (j2 = i3), n3 && (st2 && !Qe2 && 200 < r3 - st2 && (st2 = 0, V2("scrollEnd")), Ve2 = D, D = r3), Et2 < 0) {
              for (je2 = t3; 0 < je2--; ) kt2[je2] && kt2[je2].update(0, n3);
              Et2 = 1;
            } else for (je2 = 0; je2 < t3; je2++) kt2[je2] && kt2[je2].update(0, n3);
            ne2.isUpdating = false;
          }
          T2 = 0;
        }, $ = [
          "left",
          "top",
          Y2,
          I2,
          mt2 + vt2,
          mt2 + pt2,
          mt2 + ht2,
          mt2 + gt2,
          "display",
          "flexShrink",
          "float",
          "zIndex",
          "gridColumnStart",
          "gridColumnEnd",
          "gridRowStart",
          "gridRowEnd",
          "gridArea",
          "justifySelf",
          "alignSelf",
          "placeSelf",
          "order"
        ], ee2 = $.concat([ft2, dt2, "boxSizing", "max" + yt2, "max" + H2, "position", mt2, bt2, bt2 + ht2, bt2 + pt2, bt2 + vt2, bt2 + gt2]), te2 = /([A-Z])/g, Pt2 = function _setState(e3) {
          if (e3) {
            var t3, r3, n3 = e3.t.style, i3 = e3.length, o3 = 0;
            for ((e3.t._gsap || Ne2.core.getCache(e3.t)).uncache = 1; o3 < i3; o3 += 2)
              r3 = e3[o3 + 1], t3 = e3[o3], r3 ? n3[t3] = r3 : n3[t3] && n3.removeProperty(t3.replace(te2, "-$1").toLowerCase());
          }
        }, Ot = { left: 0, top: 0 }, re = /(webkit|moz|length|cssText|inset)/i, ne2 = (ScrollTrigger2.prototype.init = function init(P2, O3) {
          if (this.progress = this.start = 0, this.vars && this.kill(true, true), lt2) {
            var A3, n3, p2, R3, D2, B3, I3, Y3, H3, q3, N3, e3, X4, F3, U3, W3, G3, V3, t3, K3, b2, Q3, j3, m2, Z3, y2, $2, x2, r3, _2, w2, ee3, i3, g2, te3, re2, ne3, S2, o3, k3 = (P2 = pb(ct2(P2) || Va(P2) || P2.nodeType ? { trigger: P2 } : P2, St2)).onUpdate, T3 = P2.toggleClass, a2 = P2.id, C3 = P2.onToggle, ie2 = P2.onRefresh, M3 = P2.scrub, oe3 = P2.trigger, ae3 = P2.pin, se3 = P2.pinSpacing, le2 = P2.invalidateOnRefresh, E2 = P2.anticipatePin, s3 = P2.onScrubComplete, h2 = P2.onSnapComplete, ce = P2.once, ue2 = P2.snap, fe = P2.pinReparent, l3 = P2.pinSpacer, de2 = P2.containerAnimation, pe2 = P2.fastScrollEnd, ge2 = P2.preventOverlaps, he2 = P2.horizontal || P2.containerAnimation && false !== P2.horizontal ? He2 : qe2, ve2 = !M3 && 0 !== M3, be2 = J2(P2.scroller || Xe2), c2 = Ne2.core.getCache(be2), me2 = Ma(be2), ye2 = "fixed" === ("pinType" in P2 ? P2.pinType : z2(be2, "pinType") || me2 && "fixed"), xe2 = [P2.onEnter, P2.onLeave, P2.onEnterBack, P2.onLeaveBack], _e2 = ve2 && P2.toggleActions.split(" "), we2 = "markers" in P2 ? P2.markers : St2.markers, Se3 = me2 ? 0 : parseFloat(nb(be2)["border" + he2.p2 + yt2]) || 0, ke3 = this, Te3 = P2.onRefreshInit && function() {
              return P2.onRefreshInit(ke3);
            }, Ce3 = (function _getSizeFunc(e4, t4, r4) {
              var n4 = r4.d, i4 = r4.d2, o4 = r4.a;
              return (o4 = z2(e4, "getBoundingClientRect")) ? function() {
                return o4()[n4];
              } : function() {
                return (t4 ? Na(i4) : e4["client" + i4]) || 0;
              };
            })(be2, me2, he2), Me3 = (function _getOffsetsFunc(e4, t4) {
              return !t4 || ~Ye2.indexOf(e4) ? Oa(e4) : function() {
                return Ot;
              };
            })(be2, me2), Ee3 = 0, Pe3 = 0, Oe3 = 0, Ae3 = L2(be2, he2);
            if (ke3._startClamp = ke3._endClamp = false, ke3._dir = he2, E2 *= 45, ke3.scroller = be2, ke3.scroll = de2 ? de2.time.bind(de2) : Ae3, R3 = Ae3(), ke3.vars = P2, O3 = O3 || P2.animation, "refreshPriority" in P2 && (Ze2 = 1, -9999 === P2.refreshPriority && (it2 = ke3)), c2.tweenScroll = c2.tweenScroll || { top: sc(be2, qe2), left: sc(be2, He2) }, ke3.tweenTo = A3 = c2.tweenScroll[he2.p], ke3.scrubDuration = function(e4) {
              (i3 = Va(e4) && e4) ? ee3 ? ee3.duration(e4) : ee3 = Ne2.to(O3, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: i3,
                paused: true,
                onComplete: function onComplete() {
                  return s3 && s3(ke3);
                }
              }) : (ee3 && ee3.progress(1).kill(), ee3 = 0);
            }, O3 && (O3.vars.lazy = false, O3._initted && !ke3.isReverted || false !== O3.vars.immediateRender && false !== P2.immediateRender && O3.duration() && O3.render(0, true, true), ke3.animation = O3.pause(), (O3.scrollTrigger = ke3).scrubDuration(M3), _2 = 0, a2 = a2 || O3.vars.id), ue2 && (Wa(ue2) && !ue2.push || (ue2 = { snapTo: ue2 }), "scrollBehavior" in We2.style && Ne2.set(me2 ? [We2, Ue2] : be2, { scrollBehavior: "auto" }), ze2.forEach(function(e4) {
              return Ua(e4) && e4.target === (me2 ? Fe.scrollingElement || Ue2 : be2) && (e4.smooth = false);
            }), p2 = Ua(ue2.snapTo) ? ue2.snapTo : "labels" === ue2.snapTo ? /* @__PURE__ */ (function _getClosestLabel(t4) {
              return function(e4) {
                return Ne2.utils.snap(sb(t4), e4);
              };
            })(O3) : "labelsDirectional" === ue2.snapTo ? /* @__PURE__ */ (function _getLabelAtDirection(r4) {
              return function(e4, t4) {
                return ub(sb(r4))(e4, t4.direction);
              };
            })(O3) : false !== ue2.directional ? function(e4, t4) {
              return ub(ue2.snapTo)(e4, at2() - Pe3 < 500 ? 0 : t4.direction);
            } : Ne2.utils.snap(ue2.snapTo), g2 = ue2.duration || { min: 0.1, max: 2 }, g2 = Wa(g2) ? Ge2(g2.min, g2.max) : Ge2(g2, g2), te3 = Ne2.delayedCall(ue2.delay || i3 / 2 || 0.1, function() {
              var e4 = Ae3(), t4 = at2() - Pe3 < 500, r4 = A3.tween;
              if (!(t4 || Math.abs(ke3.getVelocity()) < 10) || r4 || Qe2 || Ee3 === e4)
                ke3.isActive && Ee3 !== e4 && te3.restart(true);
              else {
                var n4, i4, o4 = (e4 - B3) / F3, a3 = O3 && !ve2 ? O3.totalProgress() : o4, s4 = t4 ? 0 : (a3 - w2) / (at2() - Ve2) * 1e3 || 0, l4 = Ne2.utils.clamp(-o4, 1 - o4, ut2(s4 / 2) * s4 / 0.185), c3 = o4 + (false === ue2.inertia ? 0 : l4), u3 = ue2.onStart, f3 = ue2.onInterrupt, d4 = ue2.onComplete;
                if (n4 = p2(c3, ke3), Va(n4) || (n4 = c3), i4 = Math.max(0, Math.round(B3 + n4 * F3)), e4 <= I3 && B3 <= e4 && i4 !== e4) {
                  if (r4 && !r4._initted && r4.data <= ut2(i4 - e4)) return;
                  false === ue2.inertia && (l4 = n4 - o4), A3(
                    i4,
                    {
                      duration: g2(ut2(0.185 * Math.max(ut2(c3 - a3), ut2(n4 - a3)) / s4 / 0.05 || 0)),
                      ease: ue2.ease || "power3",
                      data: ut2(i4 - e4),
                      onInterrupt: function onInterrupt() {
                        return te3.restart(true) && f3 && f3(ke3);
                      },
                      onComplete: function onComplete() {
                        ke3.update(), Ee3 = Ae3(), O3 && !ve2 && (ee3 ? ee3.resetTo("totalProgress", n4, O3._tTime / O3._tDur) : O3.progress(n4)), _2 = w2 = O3 && !ve2 ? O3.totalProgress() : ke3.progress, h2 && h2(ke3), d4 && d4(ke3);
                      }
                    },
                    e4,
                    l4 * F3,
                    i4 - e4 - l4 * F3
                  ), u3 && u3(ke3, A3.tween);
                }
              }
            }).pause()), a2 && (Tt2[a2] = ke3), o3 = (o3 = (oe3 = ke3.trigger = J2(oe3 || true !== ae3 && ae3)) && oe3._gsap && oe3._gsap.stRevert) && o3(ke3), ae3 = true === ae3 ? oe3 : J2(ae3), ct2(T3) && (T3 = { targets: oe3, className: T3 }), ae3 && (false === se3 || se3 === mt2 || (se3 = !(!se3 && ae3.parentNode && ae3.parentNode.style && "flex" === nb(ae3.parentNode).display) && bt2), ke3.pin = ae3, (n3 = Ne2.core.getCache(ae3)).spacer ? U3 = n3.pinState : (l3 && ((l3 = J2(l3)) && !l3.nodeType && (l3 = l3.current || l3.nativeElement), n3.spacerIsNative = !!l3, l3 && (n3.spacerState = kc(l3))), n3.spacer = V3 = l3 || Fe.createElement("div"), V3.classList.add("pin-spacer"), a2 && V3.classList.add("pin-spacer-" + a2), n3.pinState = U3 = kc(ae3)), false !== P2.force3D && Ne2.set(ae3, { force3D: true }), ke3.spacer = V3 = n3.spacer, r3 = nb(ae3), m2 = r3[se3 + he2.os2], K3 = Ne2.getProperty(ae3), b2 = Ne2.quickSetter(ae3, he2.a, xt2), hc(ae3, V3, r3), G3 = kc(ae3)), we2) {
              e3 = Wa(we2) ? pb(we2, wt2) : wt2, q3 = Eb("scroller-start", a2, be2, he2, e3, 0), N3 = Eb("scroller-end", a2, be2, he2, e3, 0, q3), t3 = q3["offset" + he2.op.d2];
              var u2 = J2(z2(be2, "content") || be2);
              Y3 = this.markerStart = Eb("start", a2, u2, he2, e3, t3, 0, de2), H3 = this.markerEnd = Eb("end", a2, u2, he2, e3, t3, 0, de2), de2 && (S2 = Ne2.quickSetter([Y3, H3], he2.a, xt2)), ye2 || Ye2.length && true === z2(be2, "fixedMarkers") || ((function _makePositionable(e4) {
                var t4 = nb(e4).position;
                e4.style.position = "absolute" === t4 || "fixed" === t4 ? t4 : "relative";
              })(me2 ? We2 : be2), Ne2.set([q3, N3], { force3D: true }), y2 = Ne2.quickSetter(q3, he2.a, xt2), x2 = Ne2.quickSetter(N3, he2.a, xt2));
            }
            if (de2) {
              var f2 = de2.vars.onUpdate, d3 = de2.vars.onUpdateParams;
              de2.eventCallback("onUpdate", function() {
                ke3.update(0, 0, 1), f2 && f2.apply(de2, d3 || []);
              });
            }
            if (ke3.previous = function() {
              return kt2[kt2.indexOf(ke3) - 1];
            }, ke3.next = function() {
              return kt2[kt2.indexOf(ke3) + 1];
            }, ke3.revert = function(e4, t4) {
              if (!t4) return ke3.kill(true);
              var r4 = false !== e4 || !ke3.enabled, n4 = Ke2;
              r4 !== ke3.isReverted && (r4 && (re2 = Math.max(Ae3(), ke3.scroll.rec || 0), Oe3 = ke3.progress, ne3 = O3 && O3.progress()), Y3 && [Y3, H3, q3, N3].forEach(function(e5) {
                return e5.style.display = r4 ? "none" : "block";
              }), r4 && (Ke2 = ke3).update(r4), !ae3 || fe && ke3.isActive || (r4 ? (function _swapPinOut(e5, t5, r5) {
                Pt2(r5);
                var n5 = e5._gsap;
                if (n5.spacerIsNative) Pt2(n5.spacerState);
                else if (e5._gsap.swappedIn) {
                  var i4 = t5.parentNode;
                  i4 && (i4.insertBefore(e5, t5), i4.removeChild(t5));
                }
                e5._gsap.swappedIn = false;
              })(ae3, V3, U3) : hc(ae3, V3, nb(ae3), Z3)), r4 || ke3.update(r4), Ke2 = n4, ke3.isReverted = r4);
            }, ke3.refresh = function(e4, t4, r4, n4) {
              if (!Ke2 && ke3.enabled || t4)
                if (ae3 && e4 && st2) xb(ScrollTrigger2, "scrollEnd", Pb);
                else {
                  !rt2 && Te3 && Te3(ke3), Ke2 = ke3, A3.tween && !r4 && (A3.tween.kill(), A3.tween = 0), ee3 && ee3.pause(), le2 && O3 && (O3.revert({ kill: false }).invalidate(), O3.getChildren && O3.getChildren(true, true, false).forEach(function(e5) {
                    return e5.vars.immediateRender && e5.render(0, true, true);
                  })), ke3.isReverted || ke3.revert(true, true), ke3._subPinOffset = false;
                  var i4, o4, a3, s4, l4, c3, u3, f3, d4, p3, g3, h3, v3, b3 = Ce3(), m3 = Me3(), y3 = de2 ? de2.duration() : Ra(be2, he2), x3 = F3 <= 0.01 || !F3, _3 = 0, w3 = n4 || 0, S3 = Wa(r4) ? r4.end : P2.end, k4 = P2.endTrigger || oe3, T4 = Wa(r4) ? r4.start : P2.start || (0 !== P2.start && oe3 ? ae3 ? "0 0" : "0 100%" : 0), C4 = ke3.pinnedContainer = P2.pinnedContainer && J2(P2.pinnedContainer, ke3), M4 = oe3 && Math.max(0, kt2.indexOf(ke3)) || 0, E3 = M4;
                  for (we2 && Wa(r4) && (h3 = Ne2.getProperty(q3, he2.p), v3 = Ne2.getProperty(N3, he2.p)); 0 < E3--; )
                    (c3 = kt2[E3]).end || c3.refresh(0, 1) || (Ke2 = ke3), !(u3 = c3.pin) || u3 !== oe3 && u3 !== ae3 && u3 !== C4 || c3.isReverted || ((p3 = p3 || []).unshift(c3), c3.revert(true, true)), c3 !== kt2[E3] && (M4--, E3--);
                  for (Ua(T4) && (T4 = T4(ke3)), T4 = Da(T4, "start", ke3), B3 = nc(T4, oe3, b3, he2, Ae3(), Y3, q3, ke3, m3, Se3, ye2, y3, de2, ke3._startClamp && "_startClamp") || (ae3 ? -1e-3 : 0), Ua(S3) && (S3 = S3(ke3)), ct2(S3) && !S3.indexOf("+=") && (~S3.indexOf(" ") ? S3 = (ct2(T4) ? T4.split(" ")[0] : "") + S3 : (_3 = Db(S3.substr(2), b3), S3 = ct2(T4) ? T4 : (de2 ? Ne2.utils.mapRange(0, de2.duration(), de2.scrollTrigger.start, de2.scrollTrigger.end, B3) : B3) + _3, k4 = oe3)), S3 = Da(S3, "end", ke3), I3 = Math.max(
                    B3,
                    nc(
                      S3 || (k4 ? "100% 0" : y3),
                      k4,
                      b3,
                      he2,
                      Ae3() + _3,
                      H3,
                      N3,
                      ke3,
                      m3,
                      Se3,
                      ye2,
                      y3,
                      de2,
                      ke3._endClamp && "_endClamp"
                    )
                  ) || -1e-3, _3 = 0, E3 = M4; E3--; )
                    (u3 = (c3 = kt2[E3]).pin) && c3.start - c3._pinPush <= B3 && !de2 && 0 < c3.end && (i4 = c3.end - (ke3._startClamp ? Math.max(0, c3.start) : c3.start), (u3 === oe3 && c3.start - c3._pinPush < B3 || u3 === C4) && isNaN(T4) && (_3 += i4 * (1 - c3.progress)), u3 === ae3 && (w3 += i4));
                  if (B3 += _3, I3 += _3, ke3._startClamp && (ke3._startClamp += _3), ke3._endClamp && !rt2 && (ke3._endClamp = I3 || -1e-3, I3 = Math.min(I3, Ra(be2, he2))), F3 = I3 - B3 || (B3 -= 0.01) && 1e-3, x3 && (Oe3 = Ne2.utils.clamp(0, 1, Ne2.utils.normalize(B3, I3, re2))), ke3._pinPush = w3, Y3 && _3 && ((i4 = {})[he2.a] = "+=" + _3, C4 && (i4[he2.p] = "-=" + Ae3()), Ne2.set([Y3, H3], i4)), !ae3 || et2 && ke3.end >= Ra(be2, he2)) {
                    if (oe3 && Ae3() && !de2)
                      for (o4 = oe3.parentNode; o4 && o4 !== We2; )
                        o4._pinOffset && (B3 -= o4._pinOffset, I3 -= o4._pinOffset), o4 = o4.parentNode;
                  } else
                    i4 = nb(ae3), s4 = he2 === qe2, a3 = Ae3(), Q3 = parseFloat(K3(he2.a)) + w3, !y3 && 1 < I3 && (g3 = {
                      style: g3 = (me2 ? Fe.scrollingElement || Ue2 : be2).style,
                      value: g3["overflow" + he2.a.toUpperCase()]
                    }, me2 && "scroll" !== nb(We2)["overflow" + he2.a.toUpperCase()] && (g3.style["overflow" + he2.a.toUpperCase()] = "scroll")), hc(ae3, V3, i4), G3 = kc(ae3), o4 = _t2(ae3, true), f3 = ye2 && L2(be2, s4 ? He2 : qe2)(), se3 ? ((Z3 = [se3 + he2.os2, F3 + w3 + xt2]).t = V3, (E3 = se3 === bt2 ? rb(ae3, he2) + F3 + w3 : 0) && (Z3.push(he2.d, E3 + xt2), "auto" !== V3.style.flexBasis && (V3.style.flexBasis = E3 + xt2)), Pt2(Z3), C4 && kt2.forEach(function(e5) {
                      e5.pin === C4 && false !== e5.vars.pinSpacing && (e5._subPinOffset = true);
                    }), ye2 && Ae3(re2)) : (E3 = rb(ae3, he2)) && "auto" !== V3.style.flexBasis && (V3.style.flexBasis = E3 + xt2), ye2 && ((l4 = {
                      top: o4.top + (s4 ? a3 - B3 : f3) + xt2,
                      left: o4.left + (s4 ? f3 : a3 - B3) + xt2,
                      boxSizing: "border-box",
                      position: "fixed"
                    })[ft2] = l4.maxWidth = Math.ceil(o4.width) + xt2, l4[dt2] = l4.maxHeight = Math.ceil(o4.height) + xt2, l4[mt2] = l4[mt2 + ht2] = l4[mt2 + pt2] = l4[mt2 + vt2] = l4[mt2 + gt2] = "0", l4[bt2] = i4[bt2], l4[bt2 + ht2] = i4[bt2 + ht2], l4[bt2 + pt2] = i4[bt2 + pt2], l4[bt2 + vt2] = i4[bt2 + vt2], l4[bt2 + gt2] = i4[bt2 + gt2], W3 = (function _copyState(e5, t5, r5) {
                      for (var n5, i5 = [], o5 = e5.length, a4 = r5 ? 8 : 0; a4 < o5; a4 += 2)
                        n5 = e5[a4], i5.push(n5, n5 in t5 ? t5[n5] : e5[a4 + 1]);
                      return i5.t = e5.t, i5;
                    })(U3, l4, fe), rt2 && Ae3(0)), O3 ? (d4 = O3._initted, $e2(1), O3.render(O3.duration(), true, true), j3 = K3(he2.a) - Q3 + F3 + w3, $2 = 1 < Math.abs(F3 - j3), ye2 && $2 && W3.splice(W3.length - 2, 2), O3.render(0, true, true), d4 || O3.invalidate(true), O3.parent || O3.totalTime(O3.totalTime()), $e2(0)) : j3 = F3, g3 && (g3.value ? g3.style["overflow" + he2.a.toUpperCase()] = g3.value : g3.style.removeProperty("overflow-" + he2.a));
                  p3 && p3.forEach(function(e5) {
                    return e5.revert(false, true);
                  }), ke3.start = B3, ke3.end = I3, R3 = D2 = rt2 ? re2 : Ae3(), de2 || rt2 || (R3 < re2 && Ae3(re2), ke3.scroll.rec = 0), ke3.revert(false, true), Pe3 = at2(), te3 && (Ee3 = -1, te3.restart(true)), Ke2 = 0, O3 && ve2 && (O3._initted || ne3) && O3.progress() !== ne3 && O3.progress(ne3 || 0, true).render(O3.time(), true, true), (x3 || Oe3 !== ke3.progress || de2 || le2 || O3 && !O3._initted) && (O3 && !ve2 && (O3._initted || Oe3 || false !== O3.vars.immediateRender) && O3.totalProgress(de2 && B3 < -1e-3 && !Oe3 ? Ne2.utils.normalize(B3, I3, 0) : Oe3, true), ke3.progress = x3 || (R3 - B3) / F3 === Oe3 ? 0 : Oe3), ae3 && se3 && (V3._pinOffset = Math.round(ke3.progress * j3)), ee3 && ee3.invalidate(), isNaN(h3) || (h3 -= Ne2.getProperty(q3, he2.p), v3 -= Ne2.getProperty(N3, he2.p), rc(q3, he2, h3), rc(Y3, he2, h3 - (n4 || 0)), rc(N3, he2, v3), rc(H3, he2, v3 - (n4 || 0))), x3 && !rt2 && ke3.update(), !ie2 || rt2 || X4 || (X4 = true, ie2(ke3), X4 = false);
                }
            }, ke3.getVelocity = function() {
              return (Ae3() - D2) / (at2() - Ve2) * 1e3 || 0;
            }, ke3.endAnimation = function() {
              Xa(ke3.callbackAnimation), O3 && (ee3 ? ee3.progress(1) : O3.paused() ? ve2 || Xa(O3, ke3.direction < 0, 1) : Xa(O3, O3.reversed()));
            }, ke3.labelToScroll = function(e4) {
              return O3 && O3.labels && (B3 || ke3.refresh() || B3) + O3.labels[e4] / O3.duration() * F3 || 0;
            }, ke3.getTrailing = function(t4) {
              var e4 = kt2.indexOf(ke3), r4 = 0 < ke3.direction ? kt2.slice(0, e4).reverse() : kt2.slice(e4 + 1);
              return (ct2(t4) ? r4.filter(function(e5) {
                return e5.vars.preventOverlaps === t4;
              }) : r4).filter(function(e5) {
                return 0 < ke3.direction ? e5.end <= B3 : e5.start >= I3;
              });
            }, ke3.update = function(e4, t4, r4) {
              if (!de2 || r4 || e4) {
                var n4, i4, o4, a3, s4, l4, c3, u3 = true === rt2 ? re2 : ke3.scroll(), f3 = e4 ? 0 : (u3 - B3) / F3, d4 = f3 < 0 ? 0 : 1 < f3 ? 1 : f3 || 0, p3 = ke3.progress;
                if (t4 && (D2 = R3, R3 = de2 ? Ae3() : u3, ue2 && (w2 = _2, _2 = O3 && !ve2 ? O3.totalProgress() : d4)), E2 && ae3 && !Ke2 && !ot2 && st2 && (!d4 && B3 < u3 + (u3 - D2) / (at2() - Ve2) * E2 ? d4 = 1e-4 : 1 === d4 && I3 > u3 + (u3 - D2) / (at2() - Ve2) * E2 && (d4 = 0.9999)), d4 !== p3 && ke3.enabled) {
                  if (a3 = (s4 = (n4 = ke3.isActive = !!d4 && d4 < 1) != (!!p3 && p3 < 1)) || !!d4 != !!p3, ke3.direction = p3 < d4 ? 1 : -1, ke3.progress = d4, a3 && !Ke2 && (i4 = d4 && !p3 ? 0 : 1 === d4 ? 1 : 1 === p3 ? 2 : 3, ve2 && (o4 = !s4 && "none" !== _e2[i4 + 1] && _e2[i4 + 1] || _e2[i4], c3 = O3 && ("complete" === o4 || "reset" === o4 || o4 in O3))), ge2 && (s4 || c3) && (c3 || M3 || !O3) && (Ua(ge2) ? ge2(ke3) : ke3.getTrailing(ge2).forEach(function(e5) {
                    return e5.endAnimation();
                  })), ve2 || (!ee3 || Ke2 || ot2 ? O3 && O3.totalProgress(d4, !(!Ke2 || !Pe3 && !e4)) : (ee3._dp._time - ee3._start !== ee3._time && ee3.render(ee3._dp._time - ee3._start), ee3.resetTo ? ee3.resetTo("totalProgress", d4, O3._tTime / O3._tDur) : (ee3.vars.totalProgress = d4, ee3.invalidate().restart()))), ae3)
                    if (e4 && se3 && (V3.style[se3 + he2.os2] = m2), ye2) {
                      if (a3) {
                        if (l4 = !e4 && p3 < d4 && u3 < I3 + 1 && u3 + 1 >= Ra(be2, he2), fe)
                          if (e4 || !n4 && !l4) pc(ae3, V3);
                          else {
                            var g3 = _t2(ae3, true), h3 = u3 - B3;
                            pc(ae3, We2, g3.top + (he2 === qe2 ? h3 : 0) + xt2, g3.left + (he2 === qe2 ? 0 : h3) + xt2);
                          }
                        Pt2(n4 || l4 ? W3 : G3), $2 && d4 < 1 && n4 || b2(Q3 + (1 !== d4 || l4 ? 0 : j3));
                      }
                    } else b2(Ja(Q3 + j3 * d4));
                  !ue2 || A3.tween || Ke2 || ot2 || te3.restart(true), T3 && (s4 || ce && d4 && (d4 < 1 || !tt2)) && Je2(T3.targets).forEach(function(e5) {
                    return e5.classList[n4 || ce ? "add" : "remove"](T3.className);
                  }), !k3 || ve2 || e4 || k3(ke3), a3 && !Ke2 ? (ve2 && (c3 && ("complete" === o4 ? O3.pause().totalProgress(1) : "reset" === o4 ? O3.restart(true).pause() : "restart" === o4 ? O3.restart(true) : O3[o4]()), k3 && k3(ke3)), !s4 && tt2 || (C3 && s4 && Ya(ke3, C3), xe2[i4] && Ya(ke3, xe2[i4]), ce && (1 === d4 ? ke3.kill(false, 1) : xe2[i4] = 0), s4 || xe2[i4 = 1 === d4 ? 1 : 3] && Ya(ke3, xe2[i4])), pe2 && !n4 && Math.abs(ke3.getVelocity()) > (Va(pe2) ? pe2 : 2500) && (Xa(ke3.callbackAnimation), ee3 ? ee3.progress(1) : Xa(O3, "reverse" === o4 ? 1 : !d4, 1))) : ve2 && k3 && !Ke2 && k3(ke3);
                }
                if (x2) {
                  var v3 = de2 ? u3 / de2.duration() * (de2._caScrollDist || 0) : u3;
                  y2(v3 + (q3._isFlipped ? 1 : 0)), x2(v3);
                }
                S2 && S2(-u3 / de2.duration() * (de2._caScrollDist || 0));
              }
            }, ke3.enable = function(e4, t4) {
              ke3.enabled || (ke3.enabled = true, xb(be2, "resize", Mb), me2 || xb(be2, "scroll", Kb), Te3 && xb(ScrollTrigger2, "refreshInit", Te3), false !== e4 && (ke3.progress = Oe3 = 0, R3 = D2 = Ee3 = Ae3()), false !== t4 && ke3.refresh());
            }, ke3.getTween = function(e4) {
              return e4 && A3 ? A3.tween : ee3;
            }, ke3.setPositions = function(e4, t4, r4, n4) {
              if (de2) {
                var i4 = de2.scrollTrigger, o4 = de2.duration(), a3 = i4.end - i4.start;
                e4 = i4.start + a3 * e4 / o4, t4 = i4.start + a3 * t4 / o4;
              }
              ke3.refresh(false, false, { start: Ea(e4, r4 && !!ke3._startClamp), end: Ea(t4, r4 && !!ke3._endClamp) }, n4), ke3.update();
            }, ke3.adjustPinSpacing = function(e4) {
              if (Z3 && e4) {
                var t4 = Z3.indexOf(he2.d) + 1;
                Z3[t4] = parseFloat(Z3[t4]) + e4 + xt2, Z3[1] = parseFloat(Z3[1]) + e4 + xt2, Pt2(Z3);
              }
            }, ke3.disable = function(e4, t4) {
              if (ke3.enabled && (false !== e4 && ke3.revert(true, true), ke3.enabled = ke3.isActive = false, t4 || ee3 && ee3.pause(), re2 = 0, n3 && (n3.uncache = 1), Te3 && yb(ScrollTrigger2, "refreshInit", Te3), te3 && (te3.pause(), A3.tween && A3.tween.kill() && (A3.tween = 0)), !me2)) {
                for (var r4 = kt2.length; r4--; ) if (kt2[r4].scroller === be2 && kt2[r4] !== ke3) return;
                yb(be2, "resize", Mb), me2 || yb(be2, "scroll", Kb);
              }
            }, ke3.kill = function(e4, t4) {
              ke3.disable(e4, t4), ee3 && !t4 && ee3.kill(), a2 && delete Tt2[a2];
              var r4 = kt2.indexOf(ke3);
              0 <= r4 && kt2.splice(r4, 1), r4 === je2 && 0 < Et2 && je2--, r4 = 0, kt2.forEach(function(e5) {
                return e5.scroller === ke3.scroller && (r4 = 1);
              }), r4 || rt2 || (ke3.scroll.rec = 0), O3 && (O3.scrollTrigger = null, e4 && O3.revert({ kill: false }), t4 || O3.kill()), Y3 && [Y3, H3, q3, N3].forEach(function(e5) {
                return e5.parentNode && e5.parentNode.removeChild(e5);
              }), it2 === ke3 && (it2 = 0), ae3 && (n3 && (n3.uncache = 1), r4 = 0, kt2.forEach(function(e5) {
                return e5.pin === ae3 && r4++;
              }), r4 || (n3.spacer = 0)), P2.onKill && P2.onKill(ke3);
            }, kt2.push(ke3), ke3.enable(false, false), o3 && o3(ke3), O3 && O3.add && !F3) {
              var v2 = ke3.update;
              ke3.update = function() {
                ke3.update = v2, ze2.cache++, B3 || I3 || ke3.refresh();
              }, Ne2.delayedCall(0.01, ke3.update), F3 = 0.01, B3 = I3 = 0;
            } else ke3.refresh();
            ae3 && (function _queueRefreshAll() {
              if (nt !== Ct2) {
                var e4 = nt = Ct2;
                requestAnimationFrame(function() {
                  return e4 === Ct2 && Mt2(true);
                });
              }
            })();
          } else this.update = this.refresh = this.kill = Ia;
        }, ScrollTrigger2.register = function register(e3) {
          return s2 || (Ne2 = e3 || La(), Ka() && window.document && ScrollTrigger2.enable(), s2 = lt2), s2;
        }, ScrollTrigger2.defaults = function defaults2(e3) {
          if (e3) for (var t3 in e3) St2[t3] = e3[t3];
          return St2;
        }, ScrollTrigger2.disable = function disable(t3, r3) {
          lt2 = 0, kt2.forEach(function(e4) {
            return e4[r3 ? "kill" : "disable"](t3);
          }), yb(Xe2, "wheel", Kb), yb(Fe, "scroll", Kb), clearInterval(u), yb(Fe, "touchcancel", Ia), yb(We2, "touchstart", Ia), wb(yb, Fe, "pointerdown,touchstart,mousedown", Ga), wb(yb, Fe, "pointerup,touchend,mouseup", Ha), c.kill(), Sa(yb);
          for (var e3 = 0; e3 < ze2.length; e3 += 3) zb(yb, ze2[e3], ze2[e3 + 1]), zb(yb, ze2[e3], ze2[e3 + 2]);
        }, ScrollTrigger2.enable = function enable() {
          if (Xe2 = window, Fe = document, Ue2 = Fe.documentElement, We2 = Fe.body, Ne2 && (Je2 = Ne2.utils.toArray, Ge2 = Ne2.utils.clamp, x = Ne2.core.context || Ia, $e2 = Ne2.core.suppressOverwrites || Ia, _ = Xe2.history.scrollRestoration || "auto", j2 = Xe2.pageYOffset || 0, Ne2.core.globals("ScrollTrigger", ScrollTrigger2), We2)) {
            lt2 = 1, (w = document.createElement("div")).style.height = "100vh", w.style.position = "absolute", Zb(), (function _rafBugFix() {
              return lt2 && requestAnimationFrame(_rafBugFix);
            })(), E.register(Ne2), ScrollTrigger2.isTouch = E.isTouch, R2 = E.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent), b = 1 === E.isTouch, xb(Xe2, "wheel", Kb), l2 = [Xe2, Fe, Ue2, We2], Ne2.matchMedia ? (ScrollTrigger2.matchMedia = function(e4) {
              var t4, r4 = Ne2.matchMedia();
              for (t4 in e4) r4.add(t4, e4[t4]);
              return r4;
            }, Ne2.addEventListener("matchMediaInit", function() {
              return Tb();
            }), Ne2.addEventListener("matchMediaRevert", function() {
              return Sb();
            }), Ne2.addEventListener("matchMedia", function() {
              Mt2(0, 1), V2("matchMedia");
            }), Ne2.matchMedia().add("(orientation: portrait)", function() {
              return Lb(), Lb;
            })) : console.warn("Requires GSAP 3.11.0 or later"), Lb(), xb(Fe, "scroll", Kb);
            var e3, t3, r3 = We2.hasAttribute("style"), n3 = We2.style, i3 = n3.borderTopStyle, o3 = Ne2.core.Animation.prototype;
            for (o3.revert || Object.defineProperty(o3, "revert", {
              value: function value() {
                return this.time(-0.01, true);
              }
            }), n3.borderTopStyle = "solid", e3 = _t2(We2), qe2.m = Math.round(e3.top + qe2.sc()) || 0, He2.m = Math.round(e3.left + He2.sc()) || 0, i3 ? n3.borderTopStyle = i3 : n3.removeProperty("border-top-style"), r3 || (We2.setAttribute("style", ""), We2.removeAttribute("style")), u = setInterval(Jb, 250), Ne2.delayedCall(0.5, function() {
              return ot2 = 0;
            }), xb(Fe, "touchcancel", Ia), xb(We2, "touchstart", Ia), wb(xb, Fe, "pointerdown,touchstart,mousedown", Ga), wb(xb, Fe, "pointerup,touchend,mouseup", Ha), f = Ne2.utils.checkPrefix("transform"), ee2.push(f), s2 = at2(), c = Ne2.delayedCall(0.2, Mt2).pause(), g = [
              Fe,
              "visibilitychange",
              function() {
                var e4 = Xe2.innerWidth, t4 = Xe2.innerHeight;
                Fe.hidden ? (d2 = e4, p = t4) : d2 === e4 && p === t4 || Mb();
              },
              Fe,
              "DOMContentLoaded",
              Mt2,
              Xe2,
              "load",
              Mt2,
              Xe2,
              "resize",
              Mb
            ], Sa(xb), kt2.forEach(function(e4) {
              return e4.enable(0, 1);
            }), t3 = 0; t3 < ze2.length; t3 += 3)
              zb(yb, ze2[t3], ze2[t3 + 1]), zb(yb, ze2[t3], ze2[t3 + 2]);
          }
        }, ScrollTrigger2.config = function config(e3) {
          "limitCallbacks" in e3 && (tt2 = !!e3.limitCallbacks);
          var t3 = e3.syncInterval;
          t3 && clearInterval(u) || (u = t3) && setInterval(Jb, t3), "ignoreMobileResize" in e3 && (b = 1 === ScrollTrigger2.isTouch && e3.ignoreMobileResize), "autoRefreshEvents" in e3 && (Sa(yb) || Sa(xb, e3.autoRefreshEvents || "none"), h = -1 === (e3.autoRefreshEvents + "").indexOf("resize"));
        }, ScrollTrigger2.scrollerProxy = function scrollerProxy(e3, t3) {
          var r3 = J2(e3), n3 = ze2.indexOf(r3), i3 = Ma(r3);
          ~n3 && ze2.splice(n3, i3 ? 6 : 2), t3 && (i3 ? Ye2.unshift(Xe2, t3, We2, t3, Ue2, t3) : Ye2.unshift(r3, t3));
        }, ScrollTrigger2.clearMatchMedia = function clearMatchMedia(t3) {
          kt2.forEach(function(e3) {
            return e3._ctx && e3._ctx.query === t3 && e3._ctx.kill(true, true);
          });
        }, ScrollTrigger2.isInViewport = function isInViewport(e3, t3, r3) {
          var n3 = (ct2(e3) ? J2(e3) : e3).getBoundingClientRect(), i3 = n3[r3 ? ft2 : dt2] * t3 || 0;
          return r3 ? 0 < n3.right - i3 && n3.left + i3 < Xe2.innerWidth : 0 < n3.bottom - i3 && n3.top + i3 < Xe2.innerHeight;
        }, ScrollTrigger2.positionInViewport = function positionInViewport(e3, t3, r3) {
          ct2(e3) && (e3 = J2(e3));
          var n3 = e3.getBoundingClientRect(), i3 = n3[r3 ? ft2 : dt2], o3 = null == t3 ? i3 / 2 : t3 in q2 ? q2[t3] * i3 : ~t3.indexOf("%") ? parseFloat(t3) * i3 / 100 : parseFloat(t3) || 0;
          return r3 ? (n3.left + o3) / Xe2.innerWidth : (n3.top + o3) / Xe2.innerHeight;
        }, ScrollTrigger2.killAll = function killAll(e3) {
          if (kt2.slice(0).forEach(function(e4) {
            return "ScrollSmoother" !== e4.vars.id && e4.kill();
          }), true !== e3) {
            var t3 = U2.killAll || [];
            U2 = {}, t3.forEach(function(e4) {
              return e4();
            });
          }
        }, ScrollTrigger2);
        function ScrollTrigger2(e3, t3) {
          s2 || ScrollTrigger2.register(Ne2) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), x(this), this.init(e3, t3);
        }
        ne2.version = "3.13.0", ne2.saveStyles = function(e3) {
          return e3 ? Je2(e3).forEach(function(e4) {
            if (e4 && e4.style) {
              var t3 = K2.indexOf(e4);
              0 <= t3 && K2.splice(t3, 5), K2.push(e4, e4.style.cssText, e4.getBBox && e4.getAttribute("transform"), Ne2.core.getCache(e4), x());
            }
          }) : K2;
        }, ne2.revert = function(e3, t3) {
          return Tb(!e3, t3);
        }, ne2.create = function(e3, t3) {
          return new ne2(e3, t3);
        }, ne2.refresh = function(e3) {
          return e3 ? Mb(true) : (s2 || ne2.register()) && Mt2(true);
        }, ne2.update = function(e3) {
          return ++ze2.cache && Z2(true === e3 ? 2 : 0);
        }, ne2.clearScrollMemory = Ub, ne2.maxScroll = function(e3, t3) {
          return Ra(e3, t3 ? He2 : qe2);
        }, ne2.getScrollFunc = function(e3, t3) {
          return L2(J2(e3), t3 ? He2 : qe2);
        }, ne2.getById = function(e3) {
          return Tt2[e3];
        }, ne2.getAll = function() {
          return kt2.filter(function(e3) {
            return "ScrollSmoother" !== e3.vars.id;
          });
        }, ne2.isScrolling = function() {
          return !!st2;
        }, ne2.snapDirectional = ub, ne2.addEventListener = function(e3, t3) {
          var r3 = U2[e3] || (U2[e3] = []);
          ~r3.indexOf(t3) || r3.push(t3);
        }, ne2.removeEventListener = function(e3, t3) {
          var r3 = U2[e3], n3 = r3 && r3.indexOf(t3);
          0 <= n3 && r3.splice(n3, 1);
        }, ne2.batch = function(e3, t3) {
          function Jp(e4, t4) {
            var r4 = [], n4 = [], i4 = Ne2.delayedCall(o3, function() {
              t4(r4, n4), r4 = [], n4 = [];
            }).pause();
            return function(e5) {
              r4.length || i4.restart(true), r4.push(e5.trigger), n4.push(e5), a2 <= r4.length && i4.progress(1);
            };
          }
          var r3, n3 = [], i3 = {}, o3 = t3.interval || 0.016, a2 = t3.batchMax || 1e9;
          for (r3 in t3) i3[r3] = "on" === r3.substr(0, 2) && Ua(t3[r3]) && "onRefreshInit" !== r3 ? Jp(0, t3[r3]) : t3[r3];
          return Ua(a2) && (a2 = a2(), xb(ne2, "refresh", function() {
            return a2 = t3.batchMax();
          })), Je2(e3).forEach(function(e4) {
            var t4 = {};
            for (r3 in i3) t4[r3] = i3[r3];
            t4.trigger = e4, n3.push(ne2.create(t4));
          }), n3;
        };
        function uc(e3, t3, r3, n3) {
          return n3 < t3 ? e3(n3) : t3 < 0 && e3(0), n3 < r3 ? (n3 - t3) / (r3 - t3) : r3 < 0 ? t3 / (t3 - r3) : 1;
        }
        function vc(e3, t3) {
          true === t3 ? e3.style.removeProperty("touch-action") : e3.style.touchAction = true === t3 ? "auto" : t3 ? "pan-" + t3 + (E.isTouch ? " pinch-zoom" : "") : "none", e3 === Ue2 && vc(We2, t3);
        }
        function xc(e3) {
          var t3, r3 = e3.event, n3 = e3.target, i3 = e3.axis, o3 = (r3.changedTouches ? r3.changedTouches[0] : r3).target, a2 = o3._gsap || Ne2.core.getCache(o3), s3 = at2();
          if (!a2._isScrollT || 2e3 < s3 - a2._isScrollT) {
            for (; o3 && o3 !== We2 && (o3.scrollHeight <= o3.clientHeight && o3.scrollWidth <= o3.clientWidth || !oe2[(t3 = nb(o3)).overflowY] && !oe2[t3.overflowX]); )
              o3 = o3.parentNode;
            a2._isScroll = o3 && o3 !== n3 && !Ma(o3) && (oe2[(t3 = nb(o3)).overflowY] || oe2[t3.overflowX]), a2._isScrollT = s3;
          }
          !a2._isScroll && "x" !== i3 || (r3.stopPropagation(), r3._gsapAllow = true);
        }
        function yc(e3, t3, r3, n3) {
          return E.create({
            target: e3,
            capture: true,
            debounce: false,
            lockAxis: true,
            type: t3,
            onWheel: n3 = n3 && xc,
            onPress: n3,
            onDrag: n3,
            onScroll: n3,
            onEnable: function onEnable() {
              return r3 && xb(Fe, E.eventTypes[0], se2, false, true);
            },
            onDisable: function onDisable() {
              return yb(Fe, E.eventTypes[0], se2, true);
            }
          });
        }
        function Cc(e3) {
          function Gq() {
            return i3 = false;
          }
          function Jq() {
            o3 = Ra(p2, qe2), T3 = Ge2(R2 ? 1 : 0, o3), f2 && (k3 = Ge2(0, Ra(p2, He2))), l3 = Ct2;
          }
          function Kq() {
            v2._gsap.y = Ja(parseFloat(v2._gsap.y) + b2.offset) + "px", v2.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(v2._gsap.y) + ", 0, 1)", b2.offset = b2.cacheID = 0;
          }
          function Qq() {
            Jq(), a2.isActive() && a2.vars.scrollY > o3 && (b2() > o3 ? a2.progress(1) && b2(o3) : a2.resetTo("scrollY", o3));
          }
          Wa(e3) || (e3 = {}), e3.preventDefault = e3.isNormalizer = e3.allowClicks = true, e3.type || (e3.type = "wheel,touch"), e3.debounce = !!e3.debounce, e3.id = e3.id || "normalizer";
          var n3, o3, l3, i3, a2, c2, u2, s3, f2 = e3.normalizeScrollX, t3 = e3.momentum, r3 = e3.allowNestedScroll, d3 = e3.onRelease, p2 = J2(e3.target) || Ue2, g2 = Ne2.core.globals().ScrollSmoother, h2 = g2 && g2.get(), v2 = R2 && (e3.content && J2(e3.content) || h2 && false !== e3.content && !h2.smooth() && h2.content()), b2 = L2(p2, qe2), m2 = L2(p2, He2), y2 = 1, x2 = (E.isTouch && Xe2.visualViewport ? Xe2.visualViewport.scale * Xe2.visualViewport.width : Xe2.outerWidth) / Xe2.innerWidth, _2 = 0, w2 = Ua(t3) ? function() {
            return t3(n3);
          } : function() {
            return t3 || 2.8;
          }, S2 = yc(p2, e3.type, true, r3), k3 = Ia, T3 = Ia;
          return v2 && Ne2.set(v2, { y: "+=0" }), e3.ignoreCheck = function(e4) {
            return R2 && "touchmove" === e4.type && (function ignoreDrag() {
              if (i3) {
                requestAnimationFrame(Gq);
                var e5 = Ja(n3.deltaY / 2), t4 = T3(b2.v - e5);
                if (v2 && t4 !== b2.v + b2.offset) {
                  b2.offset = t4 - b2.v;
                  var r4 = Ja((parseFloat(v2 && v2._gsap.y) || 0) - b2.offset);
                  v2.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + r4 + ", 0, 1)", v2._gsap.y = r4 + "px", b2.cacheID = ze2.cache, Z2();
                }
                return true;
              }
              b2.offset && Kq(), i3 = true;
            })() || 1.05 < y2 && "touchstart" !== e4.type || n3.isGesturing || e4.touches && 1 < e4.touches.length;
          }, e3.onPress = function() {
            i3 = false;
            var e4 = y2;
            y2 = Ja((Xe2.visualViewport && Xe2.visualViewport.scale || 1) / x2), a2.pause(), e4 !== y2 && vc(p2, 1.01 < y2 || !f2 && "x"), c2 = m2(), u2 = b2(), Jq(), l3 = Ct2;
          }, e3.onRelease = e3.onGestureStart = function(e4, t4) {
            if (b2.offset && Kq(), t4) {
              ze2.cache++;
              var r4, n4, i4 = w2();
              f2 && (n4 = (r4 = m2()) + 0.05 * i4 * -e4.velocityX / 0.227, i4 *= uc(m2, r4, n4, Ra(p2, He2)), a2.vars.scrollX = k3(n4)), n4 = (r4 = b2()) + 0.05 * i4 * -e4.velocityY / 0.227, i4 *= uc(b2, r4, n4, Ra(p2, qe2)), a2.vars.scrollY = T3(n4), a2.invalidate().duration(i4).play(0.01), (R2 && a2.vars.scrollY >= o3 || o3 - 1 <= r4) && Ne2.to({}, { onUpdate: Qq, duration: i4 });
            } else s3.restart(true);
            d3 && d3(e4);
          }, e3.onWheel = function() {
            a2._ts && a2.pause(), 1e3 < at2() - _2 && (l3 = 0, _2 = at2());
          }, e3.onChange = function(e4, t4, r4, n4, i4) {
            if (Ct2 !== l3 && Jq(), t4 && f2 && m2(k3(n4[2] === t4 ? c2 + (e4.startX - e4.x) : m2() + t4 - n4[1])), r4) {
              b2.offset && Kq();
              var o4 = i4[2] === r4, a3 = o4 ? u2 + e4.startY - e4.y : b2() + r4 - i4[1], s4 = T3(a3);
              o4 && a3 !== s4 && (u2 += s4 - a3), b2(s4);
            }
            (r4 || t4) && Z2();
          }, e3.onEnable = function() {
            vc(p2, !f2 && "x"), ne2.addEventListener("refresh", Qq), xb(Xe2, "resize", Qq), b2.smooth && (b2.target.style.scrollBehavior = "auto", b2.smooth = m2.smooth = false), S2.enable();
          }, e3.onDisable = function() {
            vc(p2, true), yb(Xe2, "resize", Qq), ne2.removeEventListener("refresh", Qq), S2.kill();
          }, e3.lockAxis = false !== e3.lockAxis, ((n3 = new E(e3)).iOS = R2) && !b2() && b2(1), R2 && Ne2.ticker.add(Ia), s3 = n3._dc, a2 = Ne2.to(n3, {
            ease: "power4",
            paused: true,
            inherit: false,
            scrollX: f2 ? "+=0.1" : "+=0",
            scrollY: "+=0.1",
            modifiers: {
              scrollY: qc(b2, b2(), function() {
                return a2.pause();
              })
            },
            onUpdate: Z2,
            onComplete: s3.vars.onComplete
          }), n3;
        }
        var ie, oe2 = { auto: 1, scroll: 1 }, ae2 = /(input|label|select|textarea)/i, se2 = function _captureInputs(e3) {
          var t3 = ae2.test(e3.target.tagName);
          (t3 || ie) && (e3._gsapAllow = true, ie = t3);
        };
        ne2.sort = function(e3) {
          if (Ua(e3)) return kt2.sort(e3);
          var t3 = Xe2.pageYOffset || 0;
          return ne2.getAll().forEach(function(e4) {
            return e4._sortY = e4.trigger ? t3 + e4.trigger.getBoundingClientRect().top : e4.start + Xe2.innerHeight;
          }), kt2.sort(
            e3 || function(e4, t4) {
              return -1e6 * (e4.vars.refreshPriority || 0) + (e4.vars.containerAnimation ? 1e6 : e4._sortY) - ((t4.vars.containerAnimation ? 1e6 : t4._sortY) + -1e6 * (t4.vars.refreshPriority || 0));
            }
          );
        }, ne2.observe = function(e3) {
          return new E(e3);
        }, ne2.normalizeScroll = function(e3) {
          if (void 0 === e3) return v;
          if (true === e3 && v) return v.enable();
          if (false === e3) return v && v.kill(), void (v = e3);
          var t3 = e3 instanceof E ? e3 : Cc(e3);
          return v && v.target === t3.target && v.kill(), Ma(t3.target) && (v = t3), t3;
        }, ne2.core = {
          _getVelocityProp: M2,
          _inputObserver: yc,
          _scrollers: ze2,
          _proxies: Ye2,
          bridge: {
            ss: function ss() {
              st2 || V2("scrollStart"), st2 = at2();
            },
            ref: function ref() {
              return Ke2;
            }
          }
        }, La() && Ne2.registerPlugin(ne2), e2.ScrollTrigger = ne2, e2.default = ne2;
        if (typeof window === "undefined" || window !== e2) {
          Object.defineProperty(e2, "__esModule", { value: true });
        } else {
          delete e2.default;
        }
      });
      !(function(e2, t2) {
        "object" == typeof exports && "undefined" != typeof module ? t2(exports) : "function" == typeof define && define.amd ? define(["exports"], t2) : t2((e2 = e2 || self).window = e2.window || {});
      })(exports, function(a) {
        "use strict";
        function _defineProperties(e2, t3) {
          for (var n3 = 0; n3 < t3.length; n3++) {
            var r3 = t3[n3];
            r3.enumerable = r3.enumerable || false, r3.configurable = true, "value" in r3 && (r3.writable = true), Object.defineProperty(e2, r3.key, r3);
          }
        }
        function r2() {
          return Me2 || "undefined" != typeof window && (Me2 = window.gsap) && Me2.registerPlugin && Me2;
        }
        var Me2, De2, Ee2, Pe2, Oe2, Ae2, ze2, Ye2, Xe2, t2, Te2, ke2, Ce2, o2 = 1, He2 = [];
        a._scrollers = [], a._proxies = [];
        function x(e2, t3) {
          return ~a._proxies.indexOf(e2) && a._proxies[a._proxies.indexOf(e2) + 1][t3];
        }
        function y(e2) {
          return !!~t2.indexOf(e2);
        }
        function z2(e2, t3, n3, r3, o3) {
          return e2.addEventListener(t3, n3, { passive: false !== r3, capture: !!o3 });
        }
        function A2(e2, t3, n3, r3) {
          return e2.removeEventListener(t3, n3, !!r3);
        }
        function D() {
          return Te2 && Te2.isPressed || a._scrollers.cache++;
        }
        function E(n3, r3) {
          function ra(e2) {
            if (e2 || 0 === e2) {
              o2 && (Ee2.history.scrollRestoration = "manual");
              var t3 = Te2 && Te2.isPressed;
              e2 = ra.v = Math.round(e2) || (Te2 && Te2.iOS ? 1 : 0), n3(e2), ra.cacheID = a._scrollers.cache, t3 && i2("ss", e2);
            } else (r3 || a._scrollers.cache !== ra.cacheID || i2("ref")) && (ra.cacheID = a._scrollers.cache, ra.v = n3());
            return ra.v + ra.offset;
          }
          return ra.offset = 0, n3 && ra;
        }
        function H2(e2, t3) {
          return (t3 && t3._ctx && t3._ctx.selector || Me2.utils.toArray)(e2)[0] || ("string" == typeof e2 && false !== Me2.config().nullTargetWarn ? console.warn("Element not found:", e2) : null);
        }
        function J2(t3, e2) {
          var n3 = e2.s, r3 = e2.sc;
          y(t3) && (t3 = Pe2.scrollingElement || Oe2);
          var o3 = a._scrollers.indexOf(t3), i3 = r3 === Ge2.sc ? 1 : 2;
          ~o3 || (o3 = a._scrollers.push(t3) - 1), a._scrollers[o3 + i3] || z2(t3, "scroll", D);
          var s3 = a._scrollers[o3 + i3], c2 = s3 || (a._scrollers[o3 + i3] = E(x(t3, n3), true) || (y(t3) ? r3 : E(function(e3) {
            return arguments.length ? t3[n3] = e3 : t3[n3];
          })));
          return c2.target = t3, s3 || (c2.smooth = "smooth" === Me2.getProperty(t3, "scrollBehavior")), c2;
        }
        function K2(e2, t3, o3) {
          function Ta(e3, t4) {
            var n3 = Le2();
            t4 || r3 < n3 - c2 ? (s3 = i3, i3 = e3, a2 = c2, c2 = n3) : o3 ? i3 += e3 : i3 = s3 + (e3 - s3) / (n3 - a2) * (c2 - a2);
          }
          var i3 = e2, s3 = e2, c2 = Le2(), a2 = c2, r3 = t3 || 50, l2 = Math.max(500, 3 * r3);
          return {
            update: Ta,
            reset: function reset() {
              s3 = i3 = o3 ? 0 : i3, a2 = c2 = 0;
            },
            getVelocity: function getVelocity(e3) {
              var t4 = a2, n3 = s3, r4 = Le2();
              return !e3 && 0 !== e3 || e3 === i3 || Ta(e3), c2 === a2 || l2 < r4 - a2 ? 0 : (i3 + (o3 ? n3 : -n3)) / ((o3 ? r4 : c2) - t4) * 1e3;
            }
          };
        }
        function L2(e2, t3) {
          return t3 && !e2._gsapAllow && e2.preventDefault(), e2.changedTouches ? e2.changedTouches[0] : e2;
        }
        function M2(e2) {
          var t3 = Math.max.apply(Math, e2), n3 = Math.min.apply(Math, e2);
          return Math.abs(t3) >= Math.abs(n3) ? t3 : n3;
        }
        function N2() {
          (Xe2 = Me2.core.globals().ScrollTrigger) && Xe2.core && (function _integrate() {
            var e2 = Xe2.core, n3 = e2.bridge || {}, t3 = e2._scrollers, r3 = e2._proxies;
            t3.push.apply(t3, a._scrollers), r3.push.apply(r3, a._proxies), a._scrollers = t3, a._proxies = r3, i2 = function _bridge(e3, t4) {
              return n3[e3](t4);
            };
          })();
        }
        function O2(e2) {
          return Me2 = e2 || r2(), !De2 && Me2 && "undefined" != typeof document && document.body && (Ee2 = window, Oe2 = (Pe2 = document).documentElement, Ae2 = Pe2.body, t2 = [Ee2, Pe2, Oe2, Ae2], Me2.utils.clamp, Ce2 = Me2.core.context || function() {
          }, Ye2 = "onpointerenter" in Ae2 ? "pointer" : "mouse", ze2 = c.isTouch = Ee2.matchMedia && Ee2.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in Ee2 || 0 < navigator.maxTouchPoints || 0 < navigator.msMaxTouchPoints ? 2 : 0, ke2 = c.eventTypes = ("ontouchstart" in Oe2 ? "touchstart,touchmove,touchcancel,touchend" : "onpointerdown" in Oe2 ? "pointerdown,pointermove,pointercancel,pointerup" : "mousedown,mousemove,mouseup,mouseup").split(","), setTimeout(function() {
            return o2 = 0;
          }, 500), N2(), De2 = 1), De2;
        }
        var Le2 = Date.now, i2 = function _bridge(e2, t3) {
          return t3;
        }, n2 = "scrollLeft", s2 = "scrollTop", Se2 = {
          s: n2,
          p: "left",
          p2: "Left",
          os: "right",
          os2: "Right",
          d: "width",
          d2: "Width",
          a: "x",
          sc: E(function(e2) {
            return arguments.length ? Ee2.scrollTo(e2, Ge2.sc()) : Ee2.pageXOffset || Pe2[n2] || Oe2[n2] || Ae2[n2] || 0;
          })
        }, Ge2 = {
          s: s2,
          p: "top",
          p2: "Top",
          os: "bottom",
          os2: "Bottom",
          d: "height",
          d2: "Height",
          a: "y",
          op: Se2,
          sc: E(function(e2) {
            return arguments.length ? Ee2.scrollTo(Se2.sc(), e2) : Ee2.pageYOffset || Pe2[s2] || Oe2[s2] || Ae2[s2] || 0;
          })
        };
        Se2.op = Ge2, a._scrollers.cache = 0;
        var c = (Observer2.prototype.init = function init(e2) {
          De2 || O2(Me2) || console.warn("Please gsap.registerPlugin(Observer)"), Xe2 || N2();
          var o3 = e2.tolerance, s3 = e2.dragMinimum, t3 = e2.type, i3 = e2.target, n3 = e2.lineHeight, r3 = e2.debounce, c2 = e2.preventDefault, a2 = e2.onStop, l2 = e2.onStopDelay, u = e2.ignore, f = e2.wheelSpeed, d2 = e2.event, g = e2.onDragStart, p = e2.onDragEnd, h = e2.onDrag, v = e2.onPress, _ = e2.onRelease, x2 = e2.onRight, m = e2.onLeft, b = e2.onUp, w = e2.onDown, E2 = e2.onChangeX, P = e2.onChangeY, Y2 = e2.onChange, X3 = e2.onToggleX, T2 = e2.onToggleY, k2 = e2.onHover, C2 = e2.onHoverEnd, S = e2.onMove, G2 = e2.ignoreCheck, F2 = e2.isNormalizer, I2 = e2.onGestureStart, V2 = e2.onGestureEnd, R2 = e2.onWheel, W2 = e2.onEnable, j2 = e2.onDisable, B2 = e2.onClick, q2 = e2.scrollSpeed, U2 = e2.capture, Q2 = e2.allowClicks, Z2 = e2.lockAxis, $ = e2.onLockAxis;
          function tc() {
            return me2 = Le2();
          }
          function uc(e3, t4) {
            return (ce.event = e3) && u && (function _isWithin(e4, t5) {
              for (var n4 = t5.length; n4--; ) if (t5[n4] === e4 || t5[n4].contains(e4)) return true;
              return false;
            })(e3.target, u) || t4 && he2 && "touch" !== e3.pointerType || G2 && G2(e3, t4);
          }
          function wc() {
            var e3 = ce.deltaX = M2(_e2), t4 = ce.deltaY = M2(xe2), n4 = Math.abs(e3) >= o3, r4 = Math.abs(t4) >= o3;
            Y2 && (n4 || r4) && Y2(ce, e3, t4, _e2, xe2), n4 && (x2 && 0 < ce.deltaX && x2(ce), m && ce.deltaX < 0 && m(ce), E2 && E2(ce), X3 && ce.deltaX < 0 != ae2 < 0 && X3(ce), ae2 = ce.deltaX, _e2[0] = _e2[1] = _e2[2] = 0), r4 && (w && 0 < ce.deltaY && w(ce), b && ce.deltaY < 0 && b(ce), P && P(ce), T2 && ce.deltaY < 0 != le2 < 0 && T2(ce), le2 = ce.deltaY, xe2[0] = xe2[1] = xe2[2] = 0), (re || ne2) && (S && S(ce), ne2 && (g && 1 === ne2 && g(ce), h && h(ce), ne2 = 0), re = false), ie && !(ie = false) && $ && $(ce), oe2 && (R2(ce), oe2 = false), ee2 = 0;
          }
          function xc(e3, t4, n4) {
            _e2[n4] += e3, xe2[n4] += t4, ce._vx.update(e3), ce._vy.update(t4), r3 ? ee2 = ee2 || requestAnimationFrame(wc) : wc();
          }
          function yc(e3, t4) {
            Z2 && !se2 && (ce.axis = se2 = Math.abs(e3) > Math.abs(t4) ? "x" : "y", ie = true), "y" !== se2 && (_e2[2] += e3, ce._vx.update(e3, true)), "x" !== se2 && (xe2[2] += t4, ce._vy.update(t4, true)), r3 ? ee2 = ee2 || requestAnimationFrame(wc) : wc();
          }
          function zc(e3) {
            if (!uc(e3, 1)) {
              var t4 = (e3 = L2(e3, c2)).clientX, n4 = e3.clientY, r4 = t4 - ce.x, o4 = n4 - ce.y, i4 = ce.isDragging;
              ce.x = t4, ce.y = n4, (i4 || (r4 || o4) && (Math.abs(ce.startX - t4) >= s3 || Math.abs(ce.startY - n4) >= s3)) && (ne2 = i4 ? 2 : 1, i4 || (ce.isDragging = true), yc(r4, o4));
            }
          }
          function Cc(e3) {
            return e3.touches && 1 < e3.touches.length && (ce.isGesturing = true) && I2(e3, ce.isDragging);
          }
          function Dc() {
            return (ce.isGesturing = false) || V2(ce);
          }
          function Ec(e3) {
            if (!uc(e3)) {
              var t4 = fe(), n4 = de2();
              xc((t4 - ge2) * q2, (n4 - pe2) * q2, 1), ge2 = t4, pe2 = n4, a2 && te2.restart(true);
            }
          }
          function Fc(e3) {
            if (!uc(e3)) {
              e3 = L2(e3, c2), R2 && (oe2 = true);
              var t4 = (1 === e3.deltaMode ? n3 : 2 === e3.deltaMode ? Ee2.innerHeight : 1) * f;
              xc(e3.deltaX * t4, e3.deltaY * t4, 0), a2 && !F2 && te2.restart(true);
            }
          }
          function Gc(e3) {
            if (!uc(e3)) {
              var t4 = e3.clientX, n4 = e3.clientY, r4 = t4 - ce.x, o4 = n4 - ce.y;
              ce.x = t4, ce.y = n4, re = true, a2 && te2.restart(true), (r4 || o4) && yc(r4, o4);
            }
          }
          function Hc(e3) {
            ce.event = e3, k2(ce);
          }
          function Ic(e3) {
            ce.event = e3, C2(ce);
          }
          function Jc(e3) {
            return uc(e3) || L2(e3, c2) && B2(ce);
          }
          this.target = i3 = H2(i3) || Oe2, this.vars = e2, u = u && Me2.utils.toArray(u), o3 = o3 || 1e-9, s3 = s3 || 0, f = f || 1, q2 = q2 || 1, t3 = t3 || "wheel,touch,pointer", r3 = false !== r3, n3 = n3 || parseFloat(Ee2.getComputedStyle(Ae2).lineHeight) || 22;
          var ee2, te2, ne2, re, oe2, ie, se2, ce = this, ae2 = 0, le2 = 0, ue2 = e2.passive || !c2 && false !== e2.passive, fe = J2(i3, Se2), de2 = J2(i3, Ge2), ge2 = fe(), pe2 = de2(), he2 = ~t3.indexOf("touch") && !~t3.indexOf("pointer") && "pointerdown" === ke2[0], ve2 = y(i3), ye2 = i3.ownerDocument || Pe2, _e2 = [0, 0, 0], xe2 = [0, 0, 0], me2 = 0, be2 = ce.onPress = function(e3) {
            uc(e3, 1) || e3 && e3.button || (ce.axis = se2 = null, te2.pause(), ce.isPressed = true, e3 = L2(e3), ae2 = le2 = 0, ce.startX = ce.x = e3.clientX, ce.startY = ce.y = e3.clientY, ce._vx.reset(), ce._vy.reset(), z2(F2 ? i3 : ye2, ke2[1], zc, ue2, true), ce.deltaX = ce.deltaY = 0, v && v(ce));
          }, we2 = ce.onRelease = function(t4) {
            if (!uc(t4, 1)) {
              A2(F2 ? i3 : ye2, ke2[1], zc, true);
              var e3 = !isNaN(ce.y - ce.startY), n4 = ce.isDragging, r4 = n4 && (3 < Math.abs(ce.x - ce.startX) || 3 < Math.abs(ce.y - ce.startY)), o4 = L2(t4);
              !r4 && e3 && (ce._vx.reset(), ce._vy.reset(), c2 && Q2 && Me2.delayedCall(0.08, function() {
                if (300 < Le2() - me2 && !t4.defaultPrevented) {
                  if (t4.target.click) t4.target.click();
                  else if (ye2.createEvent) {
                    var e4 = ye2.createEvent("MouseEvents");
                    e4.initMouseEvent(
                      "click",
                      true,
                      true,
                      Ee2,
                      1,
                      o4.screenX,
                      o4.screenY,
                      o4.clientX,
                      o4.clientY,
                      false,
                      false,
                      false,
                      false,
                      0,
                      null
                    ), t4.target.dispatchEvent(e4);
                  }
                }
              })), ce.isDragging = ce.isGesturing = ce.isPressed = false, a2 && n4 && !F2 && te2.restart(true), ne2 && wc(), p && n4 && p(ce), _ && _(ce, r4);
            }
          };
          te2 = ce._dc = Me2.delayedCall(l2 || 0.25, function onStopFunc() {
            ce._vx.reset(), ce._vy.reset(), te2.pause(), a2 && a2(ce);
          }).pause(), ce.deltaX = ce.deltaY = 0, ce._vx = K2(0, 50, true), ce._vy = K2(0, 50, true), ce.scrollX = fe, ce.scrollY = de2, ce.isDragging = ce.isGesturing = ce.isPressed = false, Ce2(this), ce.enable = function(e3) {
            return ce.isEnabled || (z2(ve2 ? ye2 : i3, "scroll", D), 0 <= t3.indexOf("scroll") && z2(ve2 ? ye2 : i3, "scroll", Ec, ue2, U2), 0 <= t3.indexOf("wheel") && z2(i3, "wheel", Fc, ue2, U2), (0 <= t3.indexOf("touch") && ze2 || 0 <= t3.indexOf("pointer")) && (z2(i3, ke2[0], be2, ue2, U2), z2(ye2, ke2[2], we2), z2(ye2, ke2[3], we2), Q2 && z2(i3, "click", tc, true, true), B2 && z2(i3, "click", Jc), I2 && z2(ye2, "gesturestart", Cc), V2 && z2(ye2, "gestureend", Dc), k2 && z2(i3, Ye2 + "enter", Hc), C2 && z2(i3, Ye2 + "leave", Ic), S && z2(i3, Ye2 + "move", Gc)), ce.isEnabled = true, ce.isDragging = ce.isGesturing = ce.isPressed = re = ne2 = false, ce._vx.reset(), ce._vy.reset(), ge2 = fe(), pe2 = de2(), e3 && e3.type && be2(e3), W2 && W2(ce)), ce;
          }, ce.disable = function() {
            ce.isEnabled && (He2.filter(function(e3) {
              return e3 !== ce && y(e3.target);
            }).length || A2(ve2 ? ye2 : i3, "scroll", D), ce.isPressed && (ce._vx.reset(), ce._vy.reset(), A2(F2 ? i3 : ye2, ke2[1], zc, true)), A2(ve2 ? ye2 : i3, "scroll", Ec, U2), A2(i3, "wheel", Fc, U2), A2(i3, ke2[0], be2, U2), A2(ye2, ke2[2], we2), A2(ye2, ke2[3], we2), A2(i3, "click", tc, true), A2(i3, "click", Jc), A2(ye2, "gesturestart", Cc), A2(ye2, "gestureend", Dc), A2(i3, Ye2 + "enter", Hc), A2(i3, Ye2 + "leave", Ic), A2(i3, Ye2 + "move", Gc), ce.isEnabled = ce.isPressed = ce.isDragging = false, j2 && j2(ce));
          }, ce.kill = ce.revert = function() {
            ce.disable();
            var e3 = He2.indexOf(ce);
            0 <= e3 && He2.splice(e3, 1), Te2 === ce && (Te2 = 0);
          }, He2.push(ce), F2 && y(i3) && (Te2 = ce), ce.enable(d2);
        }, (function _createClass(e2, t3, n3) {
          return t3 && _defineProperties(e2.prototype, t3), n3 && _defineProperties(e2, n3), e2;
        })(Observer2, [
          {
            key: "velocityX",
            get: function get() {
              return this._vx.getVelocity();
            }
          },
          {
            key: "velocityY",
            get: function get() {
              return this._vy.getVelocity();
            }
          }
        ]), Observer2);
        function Observer2(e2) {
          this.init(e2);
        }
        c.version = "3.13.0", c.create = function(e2) {
          return new c(e2);
        }, c.register = O2, c.getAll = function() {
          return He2.slice();
        }, c.getById = function(t3) {
          return He2.filter(function(e2) {
            return e2.vars.id === t3;
          })[0];
        }, r2() && Me2.registerPlugin(c), a.Observer = c, a._getProxyProp = x, a._getScrollFunc = J2, a._getTarget = H2, a._getVelocityProp = K2, a._horizontal = Se2, a._isViewport = y, a._vertical = Ge2, a.default = c;
        if (typeof window === "undefined" || window !== a) {
          Object.defineProperty(a, "__esModule", { value: true });
        } else {
          delete a.default;
        }
      });
      !(function(e2, t2) {
        "object" == typeof exports && "undefined" != typeof module ? t2(exports) : "function" == typeof define && define.amd ? define(["exports"], t2) : t2((e2 = e2 || self).window = e2.window || {});
      })(exports, function(e2) {
        "use strict";
        function j2() {
          return t2 || "undefined" != typeof window && (t2 = window.gsap) && t2.registerPlugin && t2;
        }
        function k2(e3) {
          return Math.round(1e4 * e3) / 1e4;
        }
        function l2(e3) {
          t2 = e3 || j2(), v || (o2 = t2.utils.getUnit, f = t2.core.getStyleSaver, w = t2.core.reverting || function() {
          }, v = 1);
        }
        function m(e3, t3, i3, s2, n2) {
          var r2 = e3._gsap, a = r2.get(e3, t3);
          this.p = t3, this.set = r2.set(e3, t3), this.s = this.val = parseFloat(a), this.u = o2(a) || 0, this.vel = i3 || 0, this.v = this.vel / n2, s2 || 0 === s2 ? (this.acc = s2, this.a = this.acc / (n2 * n2)) : this.acc = this.a = 0;
        }
        var t2, v, o2, f, w, u = Math.PI / 180, i2 = {
          version: "3.13.0",
          name: "physics2D",
          register: l2,
          init: function init(e3, t3, i3) {
            v || l2();
            var s2 = this, n2 = +t3.angle || 0, r2 = +t3.velocity || 0, a = +t3.acceleration || 0, o3 = t3.xProp || "x", p = t3.yProp || "y", c = t3.accelerationAngle || 0 === t3.accelerationAngle ? +t3.accelerationAngle : n2;
            s2.styles = f && f(e3, t3.xProp && "x" !== t3.xProp ? t3.xProp + "," + t3.yProp : "transform"), s2.target = e3, s2.tween = i3, s2.step = 0, s2.sps = 30, t3.gravity && (a = +t3.gravity, c = 90), n2 *= u, c *= u, s2.fr = 1 - (+t3.friction || 0), s2._props.push(o3, p), s2.xp = new m(e3, o3, Math.cos(n2) * r2, Math.cos(c) * a, s2.sps), s2.yp = new m(e3, p, Math.sin(n2) * r2, Math.sin(c) * a, s2.sps), s2.skipX = s2.skipY = 0;
          },
          render: function render(e3, t3) {
            var i3, s2, n2, r2, a, o3, p = t3.xp, l3 = t3.yp, c = t3.tween, v2 = t3.target, f2 = t3.step, u2 = t3.sps, h = t3.fr, d2 = t3.skipX, g = t3.skipY, y = c._from ? c._dur - c._time : c._time;
            if (c._time || !w()) {
              if (1 === h) n2 = y * y * 0.5, i3 = p.s + p.vel * y + p.acc * n2, s2 = l3.s + l3.vel * y + l3.acc * n2;
              else {
                for (r2 = o3 = (0 | (y *= u2)) - f2, o3 < 0 && (p.v = p.vel / u2, l3.v = l3.vel / u2, p.val = p.s, l3.val = l3.s, r2 = o3 = (t3.step = 0) | y), a = y % 1 * h; o3--; )
                  p.v += p.a, l3.v += l3.a, p.v *= h, l3.v *= h, p.val += p.v, l3.val += l3.v;
                i3 = p.val + p.v * a, s2 = l3.val + l3.v * a, t3.step += r2;
              }
              d2 || p.set(v2, p.p, k2(i3) + p.u), g || l3.set(v2, l3.p, k2(s2) + l3.u);
            } else t3.styles.revert();
          },
          kill: function kill(e3) {
            this.xp.p === e3 && (this.skipX = 1), this.yp.p === e3 && (this.skipY = 1);
          }
        };
        j2() && t2.registerPlugin(i2), e2.Physics2DPlugin = i2, e2.default = i2;
        if (typeof window === "undefined" || window !== e2) {
          Object.defineProperty(e2, "__esModule", { value: true });
        } else {
          delete e2.default;
        }
      });
      !(function(t2, e2) {
        "object" == typeof exports && "undefined" != typeof module ? e2(exports) : "function" == typeof define && define.amd ? define(["exports"], e2) : e2((t2 = t2 || self).window = t2.window || {});
      })(exports, function(e2) {
        "use strict";
        function m() {
          return i2 || "undefined" != typeof window && (i2 = window.gsap);
        }
        function p(t3) {
          return c(t3).id;
        }
        function q2(t3) {
          return f[p("string" == typeof t3 ? g(t3)[0] : t3)];
        }
        function r2(t3) {
          var e3, r3 = o2;
          if (0.05 <= t3 - s2)
            for (s2 = t3; r3; )
              ((e3 = r3.g(r3.t, r3.p)) !== r3.v1 || 0.2 < t3 - r3.t1) && (r3.v2 = r3.v1, r3.v1 = e3, r3.t2 = r3.t1, r3.t1 = t3), r3 = r3._next;
        }
        function t2() {
          (i2 = m()) && (g = i2.utils.toArray, n2 = i2.utils.getUnit, c = i2.core.getCache, a = i2.ticker, l2 = 1);
        }
        function u(t3, e3, r3, i3) {
          this.t = t3, this.p = e3, this.g = t3._gsap.get, this.rCap = v[r3 || n2(this.g(t3, e3))], this.v1 = this.v2 = this.g(t3, e3), this.t1 = this.t2 = a.time, i3 && ((this._next = i3)._prev = this);
        }
        var i2, l2, g, n2, o2, a, s2, c, f = {}, v = { deg: 360, rad: 2 * Math.PI }, d2 = (function() {
          function VelocityTracker(e4, r3) {
            l2 || t2(), this.target = g(e4)[0], (f[p(this.target)] = this)._props = {}, r3 && this.add(r3);
          }
          VelocityTracker.register = function register(e4) {
            i2 = e4, t2();
          };
          var e3 = VelocityTracker.prototype;
          return e3.get = function get(t3, e4) {
            var r3, i3, n3 = this._props[t3] || console.warn("Not tracking " + t3 + " velocity.");
            return r3 = parseFloat(e4 ? n3.v1 : n3.g(n3.t, n3.p)) - parseFloat(n3.v2), (i3 = n3.rCap) && (r3 %= i3) !== r3 % (i3 / 2) && (r3 = r3 < 0 ? r3 + i3 : r3 - i3), (function _round(t4) {
              return Math.round(1e4 * t4) / 1e4;
            })(r3 / ((e4 ? n3.t1 : a.time) - n3.t2));
          }, e3.getAll = function getAll() {
            var t3, e4 = {}, r3 = this._props;
            for (t3 in r3) e4[t3] = this.get(t3);
            return e4;
          }, e3.isTracking = function isTracking(t3) {
            return t3 in this._props;
          }, e3.add = function add(t3, e4) {
            var i3 = this._props[t3];
            i3 ? (i3.v1 = i3.v2 = i3.g(i3.t, i3.p), i3.t1 = i3.t2 = a.time) : (o2 || (a.add(r2), s2 = a.time), o2 = this._props[t3] = new u(this.target, t3, e4, o2));
          }, e3.remove = function remove(t3) {
            var e4, i3, n3 = this._props[t3];
            n3 && (e4 = n3._prev, i3 = n3._next, e4 && (e4._next = i3), i3 ? i3._prev = e4 : o2 === n3 && (a.remove(r2), o2 = 0), delete this._props[t3]);
          }, e3.kill = function kill(t3) {
            for (var e4 in this._props) this.remove(e4);
            t3 || delete f[p(this.target)];
          }, VelocityTracker.track = function track(e4, r3, i3) {
            l2 || t2();
            for (var n3, o3, a2 = [], s3 = g(e4), c2 = r3.split(","), u2 = (i3 || "").split(","), f2 = s3.length; f2--; ) {
              for (n3 = q2(s3[f2]) || new VelocityTracker(s3[f2]), o3 = c2.length; o3--; ) n3.add(c2[o3], u2[o3] || u2[0]);
              a2.push(n3);
            }
            return a2;
          }, VelocityTracker.untrack = function untrack(t3, e4) {
            var r3 = e4 && e4.split(",");
            g(t3).forEach(function(t4) {
              var e5 = q2(t4);
              e5 && (r3 ? r3.forEach(function(t5) {
                return e5.remove(t5);
              }) : e5.kill(1));
            });
          }, VelocityTracker.isTracking = function isTracking(t3, e4) {
            var r3 = q2(t3);
            return r3 && r3.isTracking(e4);
          }, VelocityTracker.getVelocity = function getVelocity(t3, e4) {
            var r3 = q2(t3);
            return r3 && r3.isTracking(e4) ? r3.get(e4) : console.warn("Not tracking velocity of " + e4);
          }, VelocityTracker;
        })();
        d2.getByTarget = q2, m() && i2.registerPlugin(d2);
        function L2() {
          return h || "undefined" != typeof window && (h = window.gsap) && h.registerPlugin && h;
        }
        function N2(t3) {
          return "number" == typeof t3;
        }
        function O2(t3) {
          return "object" == typeof t3;
        }
        function P(t3) {
          return "function" == typeof t3;
        }
        function S(t3) {
          return t3;
        }
        function W2(t3) {
          return Math.round(1e4 * t3) / 1e4;
        }
        function X3(t3, e3, r3) {
          for (var i3 in e3) i3 in t3 || i3 === r3 || (t3[i3] = e3[i3]);
          return t3;
        }
        function Y2(t3) {
          var e3, r3, i3 = {};
          for (e3 in t3) i3[e3] = O2(r3 = t3[e3]) && !I2(r3) ? Y2(r3) : r3;
          return i3;
        }
        function Z2(t3, e3, r3, i3, n3) {
          var o3, a2, s3, c2, u2 = e3.length, f2 = 0, l3 = R2;
          if (O2(t3)) {
            for (; u2--; ) {
              for (s3 in o3 = e3[u2], a2 = 0, t3) a2 += (c2 = o3[s3] - t3[s3]) * c2;
              a2 < l3 && (f2 = u2, l3 = a2);
            }
            if ((n3 || R2) < R2 && n3 < Math.sqrt(l3)) return t3;
          } else for (; u2--; ) (a2 = (o3 = e3[u2]) - t3) < 0 && (a2 = -a2), a2 < l3 && i3 <= o3 && o3 <= r3 && (f2 = u2, l3 = a2);
          return e3[f2];
        }
        function $(t3, e3, r3, i3, n3, o3, a2) {
          if ("auto" === t3.end) return t3;
          var s3, c2, u2 = t3.end;
          if (r3 = isNaN(r3) ? R2 : r3, i3 = isNaN(i3) ? -R2 : i3, O2(e3)) {
            if (s3 = e3.calculated ? e3 : (P(u2) ? u2(e3, a2) : Z2(e3, u2, r3, i3, o3)) || e3, !e3.calculated) {
              for (c2 in s3) e3[c2] = s3[c2];
              e3.calculated = true;
            }
            s3 = s3[n3];
          } else s3 = P(u2) ? u2(e3, a2) : I2(u2) ? Z2(e3, u2, r3, i3, o3) : parseFloat(u2);
          return r3 < s3 ? s3 = r3 : s3 < i3 && (s3 = i3), { max: s3, min: s3, unitFactor: t3.unitFactor };
        }
        function _(t3, e3, r3) {
          return isNaN(t3[e3]) ? r3 : +t3[e3];
        }
        function aa(t3, e3) {
          return 0.05 * e3 * t3 / T2;
        }
        function ba(t3, e3, r3) {
          return Math.abs((e3 - t3) * T2 / r3 / 0.05);
        }
        function da(t3, e3, r3, i3) {
          if (e3.linkedProps) {
            var n3, o3, a2, s3, c2, u2, f2 = e3.linkedProps.split(","), l3 = {};
            for (n3 = 0; n3 < f2.length; n3++)
              (a2 = e3[o3 = f2[n3]]) && (s3 = N2(a2.velocity) ? a2.velocity : (c2 = c2 || B2(t3)) && c2.isTracking(o3) ? c2.get(o3) : 0, u2 = Math.abs(s3 / _(a2, "resistance", i3)), l3[o3] = parseFloat(r3(t3, o3)) + aa(s3, u2));
            return l3;
          }
        }
        function fa() {
          (h = L2()) && (y = h.parseEase, F2 = h.utils.toArray, b = h.utils.getUnit, A2 = h.core.getCache, E = h.utils.clamp, C2 = h.core.getStyleSaver, w = h.core.reverting || function() {
          }, k2 = y("power3"), T2 = k2(0.05), M2 = h.core.PropTween, h.config({ resistance: 100, unitFactors: { time: 1e3, totalTime: 1e3, progress: 1e3, totalProgress: 1e3 } }), V2 = h.config(), h.registerPlugin(d2), x = 1);
        }
        var h, x, y, F2, k2, V2, b, M2, A2, T2, E, j2, C2, w, B2 = d2.getByTarget, I2 = Array.isArray, R2 = 1e10, U2 = { resistance: 1, checkpoint: 1, preventOvershoot: 1, linkedProps: 1, radius: 1, duration: 1 }, D = {
          version: "3.14.1",
          name: "inertia",
          register: function register(t3) {
            h = t3, fa();
          },
          init: function init(t3, e3, r3, i3, n3) {
            x || fa();
            var o3 = B2(t3);
            if ("auto" === e3) {
              if (!o3) return void console.warn("No inertia tracking on " + t3 + ". InertiaPlugin.track(target) first.");
              e3 = o3.getAll();
            }
            this.styles = C2 && "object" == typeof t3.style && C2(t3), this.target = t3, this.tween = r3, j2 = e3;
            var a2, s3, c2, u2, f2, l3, p2, g2, v2, d3 = t3._gsap, h2 = d3.get, y2 = e3.duration, m2 = O2(y2), k3 = e3.preventOvershoot || m2 && 0 === y2.overshoot, T3 = _(e3, "resistance", V2.resistance), w2 = N2(y2) ? y2 : (function _calculateTweenDuration(t4, e4, r4, i4, n4, o4) {
              if (void 0 === r4 && (r4 = 10), void 0 === i4 && (i4 = 0.2), void 0 === n4 && (n4 = 1), void 0 === o4 && (o4 = 0), /* @__PURE__ */ (function _isString(t5) {
                return "string" == typeof t5;
              })(t4) && (t4 = F2(t4)[0]), !t4)
                return 0;
              var a3, s4, c3, u3, f3, l4, p3, g3, v3, d4, h3 = 0, y3 = R2, m3 = e4.inertia || e4, k4 = A2(t4).get, T4 = _(m3, "resistance", V2.resistance);
              for (a3 in d4 = da(t4, m3, k4, T4), m3)
                U2[a3] || (s4 = m3[a3], O2(s4) || ((g3 = g3 || B2(t4)) && g3.isTracking(a3) ? s4 = N2(s4) ? { velocity: s4 } : { velocity: g3.get(a3) } : (u3 = +s4 || 0, c3 = Math.abs(u3 / T4))), O2(s4) && (u3 = N2(s4.velocity) ? s4.velocity : (g3 = g3 || B2(t4)) && g3.isTracking(a3) ? g3.get(a3) : 0, c3 = E(i4, r4, Math.abs(u3 / _(s4, "resistance", T4))), l4 = (f3 = parseFloat(k4(t4, a3)) || 0) + aa(u3, c3), "end" in s4 && (s4 = $(s4, d4 && a3 in d4 ? d4 : l4, s4.max, s4.min, a3, m3.radius, u3), o4 && (j2 === e4 && (j2 = m3 = Y2(e4)), m3[a3] = X3(s4, m3[a3], "end"))), "max" in s4 && l4 > +s4.max + 1e-10 ? (v3 = s4.unitFactor || V2.unitFactors[a3] || 1, (p3 = f3 > s4.max && s4.min !== s4.max || -15 < u3 * v3 && u3 * v3 < 45 ? i4 + 0.1 * (r4 - i4) : ba(f3, s4.max, u3)) + n4 < y3 && (y3 = p3 + n4)) : "min" in s4 && l4 < s4.min - 1e-10 && (v3 = s4.unitFactor || V2.unitFactors[a3] || 1, (p3 = f3 < s4.min && s4.min !== s4.max || -45 < u3 * v3 && u3 * v3 < 15 ? i4 + 0.1 * (r4 - i4) : ba(f3, s4.min, u3)) + n4 < y3 && (y3 = p3 + n4)), h3 < p3 && (h3 = p3)), h3 < c3 && (h3 = c3));
              return y3 < h3 && (h3 = y3), r4 < h3 ? r4 : h3 < i4 ? i4 : h3;
            })(t3, e3, m2 && y2.max || 10, m2 && y2.min || 0.2, m2 && "overshoot" in y2 ? +y2.overshoot : k3 ? 0 : 1, true);
            for (a2 in e3 = j2, j2 = 0, v2 = da(t3, e3, h2, T3), e3)
              U2[a2] || (s3 = e3[a2], P(s3) && (s3 = s3(i3, t3, n3)), N2(s3) ? f2 = s3 : O2(s3) && !isNaN(s3.velocity) ? f2 = +s3.velocity : o3 && o3.isTracking(a2) ? f2 = o3.get(a2) : console.warn("ERROR: No velocity was defined for " + t3 + " property: " + a2), l3 = aa(f2, w2), g2 = 0, c2 = h2(t3, a2), u2 = b(c2), c2 = parseFloat(c2), O2(s3) && (p2 = c2 + l3, "end" in s3 && (s3 = $(s3, v2 && a2 in v2 ? v2 : p2, s3.max, s3.min, a2, e3.radius, f2)), "max" in s3 && +s3.max < p2 ? k3 || s3.preventOvershoot ? l3 = s3.max - c2 : g2 = s3.max - c2 - l3 : "min" in s3 && +s3.min > p2 && (k3 || s3.preventOvershoot ? l3 = s3.min - c2 : g2 = s3.min - c2 - l3)), this._props.push(a2), this.styles && this.styles.save(a2), this._pt = new M2(this._pt, t3, a2, c2, 0, S, 0, d3.set(t3, a2, this)), this._pt.u = u2 || 0, this._pt.c1 = l3, this._pt.c2 = g2);
            return r3.duration(w2), 1;
          },
          render: function render(t3, e3) {
            var r3 = e3._pt;
            if ((t3 = k2(e3.tween._time / e3.tween._dur)) || !w())
              for (; r3; ) r3.set(r3.t, r3.p, W2(r3.s + r3.c1 * t3 + r3.c2 * t3 * t3) + r3.u, r3.d, t3), r3 = r3._next;
            else e3.styles.revert();
          }
        };
        "track,untrack,isTracking,getVelocity,getByTarget".split(",").forEach(function(t3) {
          return D[t3] = d2[t3];
        }), L2() && h.registerPlugin(D), e2.InertiaPlugin = D, e2.VelocityTracker = d2, e2.default = D;
        if (typeof window === "undefined" || window !== e2) {
          Object.defineProperty(e2, "__esModule", { value: true });
        } else {
          delete e2.default;
        }
      });
      !(function(e2, t2) {
        "object" == typeof exports && "undefined" != typeof module ? t2(exports) : "function" == typeof define && define.amd ? define(["exports"], t2) : t2((e2 = e2 || self).window = e2.window || {});
      })(exports, function(e2) {
        "use strict";
        function m(e3) {
          return Math.round(1e5 * e3) / 1e5 || 0;
        }
        var b = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi, w = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/gi, Y2 = Math.PI / 180, k2 = Math.sin, B2 = Math.cos, F2 = Math.abs, J2 = Math.sqrt;
        function arcToSegment(e3, t3, n3, s3, a2, r2, i2, o2, h) {
          if (e3 !== o2 || t3 !== h) {
            n3 = F2(n3), s3 = F2(s3);
            var u = a2 % 360 * Y2, c = B2(u), f = k2(u), l2 = Math.PI, g = 2 * l2, x2 = (e3 - o2) / 2, d2 = (t3 - h) / 2, m2 = c * x2 + f * d2, p2 = -f * x2 + c * d2, y2 = m2 * m2, M3 = p2 * p2, v2 = y2 / (n3 * n3) + M3 / (s3 * s3);
            1 < v2 && (n3 = J2(v2) * n3, s3 = J2(v2) * s3);
            var C2 = n3 * n3, E = s3 * s3, b2 = (C2 * E - C2 * M3 - E * y2) / (C2 * M3 + E * y2);
            b2 < 0 && (b2 = 0);
            var w2 = (r2 === i2 ? -1 : 1) * J2(b2), P = n3 * p2 / s3 * w2, S = -s3 * m2 / n3 * w2, N2 = c * P - f * S + (e3 + o2) / 2, D = f * P + c * S + (t3 + h) / 2, T2 = (m2 - P) / n3, V2 = (p2 - S) / s3, _ = (-m2 - P) / n3, q3 = (-p2 - S) / s3, A2 = T2 * T2 + V2 * V2, R2 = (V2 < 0 ? -1 : 1) * Math.acos(T2 / J2(A2)), G2 = (T2 * q3 - V2 * _ < 0 ? -1 : 1) * Math.acos((T2 * _ + V2 * q3) / J2(A2 * (_ * _ + q3 * q3)));
            isNaN(G2) && (G2 = l2), !i2 && 0 < G2 ? G2 -= g : i2 && G2 < 0 && (G2 += g), R2 %= g, G2 %= g;
            var L2, O2 = Math.ceil(F2(G2) / (g / 4)), j2 = [], z2 = G2 / O2, I2 = 4 / 3 * k2(z2 / 2) / (1 + B2(z2 / 2)), H2 = c * n3, Q2 = f * n3, Z2 = f * -s3, U2 = c * s3;
            for (L2 = 0; L2 < O2; L2++)
              m2 = B2(a2 = R2 + L2 * z2), p2 = k2(a2), T2 = B2(a2 += z2), V2 = k2(a2), j2.push(m2 - I2 * p2, p2 + I2 * m2, T2 + I2 * V2, V2 - I2 * T2, T2, V2);
            for (L2 = 0; L2 < j2.length; L2 += 2)
              m2 = j2[L2], p2 = j2[L2 + 1], j2[L2] = m2 * H2 + p2 * Z2 + N2, j2[L2 + 1] = m2 * Q2 + p2 * U2 + D;
            return j2[L2 - 2] = o2, j2[L2 - 1] = h, j2;
          }
        }
        function stringToRawPath(e3) {
          function db(e4, t4, n4, s4) {
            c = (n4 - e4) / 3, f = (s4 - t4) / 3, o2.push(e4 + c, t4 + f, n4 - c, s4 - f, n4, s4);
          }
          var t3, n3, s3, a2, r2, i2, o2, h, u, c, f, l2, g, x2, d2, m2 = (e3 + "").replace(w, function(e4) {
            var t4 = +e4;
            return t4 < 1e-4 && -1e-4 < t4 ? 0 : t4;
          }).match(b) || [], p2 = [], y2 = 0, M3 = 0, v2 = m2.length, C2 = 0, E = "ERROR: malformed path: " + e3;
          if (!e3 || !isNaN(m2[0]) || isNaN(m2[1])) return console.log(E), p2;
          for (t3 = 0; t3 < v2; t3++)
            if (g = r2, isNaN(m2[t3]) ? i2 = (r2 = m2[t3].toUpperCase()) !== m2[t3] : t3--, s3 = +m2[t3 + 1], a2 = +m2[t3 + 2], i2 && (s3 += y2, a2 += M3), t3 || (h = s3, u = a2), "M" === r2)
              o2 && (o2.length < 8 ? --p2.length : C2 += o2.length), y2 = h = s3, M3 = u = a2, o2 = [s3, a2], p2.push(o2), t3 += 2, r2 = "L";
            else if ("C" === r2)
              i2 || (y2 = M3 = 0), (o2 = o2 || [0, 0]).push(s3, a2, y2 + 1 * m2[t3 + 3], M3 + 1 * m2[t3 + 4], y2 += 1 * m2[t3 + 5], M3 += 1 * m2[t3 + 6]), t3 += 6;
            else if ("S" === r2)
              c = y2, f = M3, "C" !== g && "S" !== g || (c += y2 - o2[o2.length - 4], f += M3 - o2[o2.length - 3]), i2 || (y2 = M3 = 0), o2.push(c, f, s3, a2, y2 += 1 * m2[t3 + 3], M3 += 1 * m2[t3 + 4]), t3 += 4;
            else if ("Q" === r2)
              c = y2 + 2 / 3 * (s3 - y2), f = M3 + 2 / 3 * (a2 - M3), i2 || (y2 = M3 = 0), y2 += 1 * m2[t3 + 3], M3 += 1 * m2[t3 + 4], o2.push(c, f, y2 + 2 / 3 * (s3 - y2), M3 + 2 / 3 * (a2 - M3), y2, M3), t3 += 4;
            else if ("T" === r2)
              c = y2 - o2[o2.length - 4], f = M3 - o2[o2.length - 3], o2.push(y2 + c, M3 + f, s3 + 2 / 3 * (y2 + 1.5 * c - s3), a2 + 2 / 3 * (M3 + 1.5 * f - a2), y2 = s3, M3 = a2), t3 += 2;
            else if ("H" === r2) db(y2, M3, y2 = s3, M3), t3 += 1;
            else if ("V" === r2) db(y2, M3, y2, M3 = s3 + (i2 ? M3 - y2 : 0)), t3 += 1;
            else if ("L" === r2 || "Z" === r2)
              "Z" === r2 && (s3 = h, a2 = u, o2.closed = true), ("L" === r2 || 0.5 < F2(y2 - s3) || 0.5 < F2(M3 - a2)) && (db(y2, M3, s3, a2), "L" === r2 && (t3 += 2)), y2 = s3, M3 = a2;
            else if ("A" === r2) {
              if (x2 = m2[t3 + 4], d2 = m2[t3 + 5], c = m2[t3 + 6], f = m2[t3 + 7], n3 = 7, 1 < x2.length && (x2.length < 3 ? (f = c, c = d2, n3--) : (f = d2, c = x2.substr(2), n3 -= 2), d2 = x2.charAt(1), x2 = x2.charAt(0)), l2 = arcToSegment(y2, M3, +m2[t3 + 1], +m2[t3 + 2], +m2[t3 + 3], +x2, +d2, (i2 ? y2 : 0) + 1 * c, (i2 ? M3 : 0) + 1 * f), t3 += n3, l2)
                for (n3 = 0; n3 < l2.length; n3++) o2.push(l2[n3]);
              y2 = o2[o2.length - 2], M3 = o2[o2.length - 1];
            } else console.log(E);
          return (t3 = o2.length) < 6 ? (p2.pop(), t3 = 0) : o2[0] === o2[t3 - 2] && o2[1] === o2[t3 - 1] && (o2.closed = true), p2.totalPoints = C2 + t3, p2;
        }
        function p() {
          return M2 || "undefined" != typeof window && (M2 = window.gsap) && M2.registerPlugin && M2;
        }
        function q2() {
          (M2 = p()) ? (M2.registerEase("_CE", n2.create), a = 1) : console.warn("Please gsap.registerPlugin(CustomEase)");
        }
        function s2(e3) {
          return ~~(1e3 * e3 + (e3 < 0 ? -0.5 : 0.5)) / 1e3;
        }
        function x(e3, t3, n3, s3, a2, r2, i2, o2, h, u, c) {
          var f, l2 = (e3 + n3) / 2, g = (t3 + s3) / 2, d2 = (n3 + a2) / 2, m2 = (s3 + r2) / 2, p2 = (a2 + i2) / 2, y2 = (r2 + o2) / 2, M3 = (l2 + d2) / 2, v2 = (g + m2) / 2, C2 = (d2 + p2) / 2, E = (m2 + y2) / 2, b2 = (M3 + C2) / 2, w2 = (v2 + E) / 2, P = i2 - e3, S = o2 - t3, N2 = Math.abs((n3 - i2) * S - (s3 - o2) * P), D = Math.abs((a2 - i2) * S - (r2 - o2) * P);
          return u || (u = [
            { x: e3, y: t3 },
            { x: i2, y: o2 }
          ], c = 1), u.splice(c || u.length - 1, 0, { x: b2, y: w2 }), h * (P * P + S * S) < (N2 + D) * (N2 + D) && (f = u.length, x(e3, t3, l2, g, M3, v2, b2, w2, h, u, c), x(b2, w2, C2, E, p2, y2, i2, o2, h, u, c + 1 + (u.length - f))), u;
        }
        var M2, a, t2, y = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/gi, v = /[cLlsSaAhHvVtTqQ]/g, n2 = ((t2 = CustomEase.prototype).setData = function setData(e3, t3) {
          t3 = t3 || {};
          var n3, s3, a2, r2, i2, o2, h, u, c, f = (e3 = e3 || "0,0,1,1").match(y), l2 = 1, g = [], d2 = [], m2 = t3.precision || 1, p2 = m2 <= 1;
          if (this.data = e3, (v.test(e3) || ~e3.indexOf("M") && e3.indexOf("C") < 0) && (f = stringToRawPath(e3)[0]), 4 === (n3 = f.length))
            f.unshift(0, 0), f.push(1, 1), n3 = 8;
          else if ((n3 - 2) % 6) throw "Invalid CustomEase";
          for (0 == +f[0] && 1 == +f[n3 - 2] || (function _normalize(e4, t4, n4) {
            n4 || 0 === n4 || (n4 = Math.max(+e4[e4.length - 1], +e4[1]));
            var s4, a3 = -1 * e4[0], r3 = -n4, i3 = e4.length, o3 = 1 / (+e4[i3 - 2] + a3), h2 = -t4 || (Math.abs(e4[i3 - 1] - e4[1]) < 0.01 * (e4[i3 - 2] - e4[0]) ? (function _findMinimum(e5) {
              var t5, n5 = e5.length, s5 = 1e20;
              for (t5 = 1; t5 < n5; t5 += 6) +e5[t5] < s5 && (s5 = +e5[t5]);
              return s5;
            })(e4) + r3 : +e4[i3 - 1] + r3);
            for (h2 = h2 ? 1 / h2 : -o3, s4 = 0; s4 < i3; s4 += 2)
              e4[s4] = (+e4[s4] + a3) * o3, e4[s4 + 1] = (+e4[s4 + 1] + r3) * h2;
          })(f, t3.height, t3.originY), this.segment = f, r2 = 2; r2 < n3; r2 += 6)
            s3 = { x: +f[r2 - 2], y: +f[r2 - 1] }, a2 = { x: +f[r2 + 4], y: +f[r2 + 5] }, g.push(s3, a2), x(s3.x, s3.y, +f[r2], +f[r2 + 1], +f[r2 + 2], +f[r2 + 3], a2.x, a2.y, 1 / (2e5 * m2), g, g.length - 1);
          for (n3 = g.length, r2 = 0; r2 < n3; r2++)
            h = g[r2], u = g[r2 - 1] || h, (h.x > u.x || u.y !== h.y && u.x === h.x || h === u) && h.x <= 1 ? (u.cx = h.x - u.x, u.cy = h.y - u.y, u.n = h, u.nx = h.x, p2 && 1 < r2 && 2 < Math.abs(u.cy / u.cx - g[r2 - 2].cy / g[r2 - 2].cx) && (p2 = 0), u.cx < l2 && (u.cx ? l2 = u.cx : (u.cx = 1e-3, r2 === n3 - 1 && (u.x -= 1e-3, l2 = Math.min(l2, 1e-3), p2 = 0)))) : (g.splice(r2--, 1), n3--);
          if (i2 = 1 / (n3 = 1 / l2 + 1 | 0), h = g[o2 = 0], p2) {
            for (r2 = 0; r2 < n3; r2++)
              c = r2 * i2, h.nx < c && (h = g[++o2]), s3 = h.y + (c - h.x) / h.cx * h.cy, d2[r2] = { x: c, cx: i2, y: s3, cy: 0, nx: 9 }, r2 && (d2[r2 - 1].cy = s3 - d2[r2 - 1].y);
            o2 = g[g.length - 1], d2[n3 - 1].cy = o2.y - s3, d2[n3 - 1].cx = o2.x - d2[d2.length - 1].x;
          } else {
            for (r2 = 0; r2 < n3; r2++) h.nx < r2 * i2 && (h = g[++o2]), d2[r2] = h;
            o2 < g.length - 1 && (d2[r2 - 1] = g[g.length - 2]);
          }
          return this.ease = function(e4) {
            var t4 = d2[e4 * n3 | 0] || d2[n3 - 1];
            return t4.nx < e4 && (t4 = t4.n), t4.y + (e4 - t4.x) / t4.cx * t4.cy;
          }, (this.ease.custom = this).id && M2 && M2.registerEase(this.id, this.ease), this;
        }, t2.getSVGData = function getSVGData(e3) {
          return CustomEase.getSVGData(this, e3);
        }, CustomEase.create = function create(e3, t3, n3) {
          return new CustomEase(e3, t3, n3).ease;
        }, CustomEase.register = function register(e3) {
          M2 = e3, q2();
        }, CustomEase.get = function get(e3) {
          return M2.parseEase(e3);
        }, CustomEase.getSVGData = function getSVGData(e3, t3) {
          var n3, a2, r2, i2, o2, h, u, c, f, l2, g = (t3 = t3 || {}).width || 100, x2 = t3.height || 100, d2 = t3.x || 0, p2 = (t3.y || 0) + x2, y2 = M2.utils.toArray(t3.path)[0];
          if (t3.invert && (x2 = -x2, p2 = 0), "string" == typeof e3 && (e3 = M2.parseEase(e3)), e3.custom && (e3 = e3.custom), e3 instanceof CustomEase)
            n3 = (function rawPathToString(e4) {
              !/* @__PURE__ */ (function _isNumber(e5) {
                return "number" == typeof e5;
              })(e4[0]) || (e4 = [e4]);
              var t4, n4, s3, a3, r3 = "", i3 = e4.length;
              for (n4 = 0; n4 < i3; n4++) {
                for (a3 = e4[n4], r3 += "M" + m(a3[0]) + "," + m(a3[1]) + " C", t4 = a3.length, s3 = 2; s3 < t4; s3++)
                  r3 += m(a3[s3++]) + "," + m(a3[s3++]) + " " + m(a3[s3++]) + "," + m(a3[s3++]) + " " + m(a3[s3++]) + "," + m(a3[s3]) + " ";
                a3.closed && (r3 += "z");
              }
              return r3;
            })(
              (function transformRawPath(e4, t4, n4, s3, a3, r3, i3) {
                for (var o3, h2, u2, c2, f2, l3 = e4.length; -1 < --l3; )
                  for (h2 = (o3 = e4[l3]).length, u2 = 0; u2 < h2; u2 += 2)
                    c2 = o3[u2], f2 = o3[u2 + 1], o3[u2] = c2 * t4 + f2 * s3 + r3, o3[u2 + 1] = c2 * n4 + f2 * a3 + i3;
                return e4._dirty = 1, e4;
              })([e3.segment], g, 0, 0, -x2, d2, p2)
            );
          else {
            for (n3 = [d2, p2], i2 = 1 / (u = Math.max(5, 200 * (t3.precision || 1))), c = 5 / (u += 2), f = s2(d2 + i2 * g), a2 = ((l2 = s2(p2 + e3(i2) * -x2)) - p2) / (f - d2), r2 = 2; r2 < u; r2++)
              o2 = s2(d2 + r2 * i2 * g), h = s2(p2 + e3(r2 * i2) * -x2), (Math.abs((h - l2) / (o2 - f) - a2) > c || r2 === u - 1) && (n3.push(f, l2), a2 = (h - l2) / (o2 - f)), f = o2, l2 = h;
            n3 = "M" + n3.join(",");
          }
          return y2 && y2.setAttribute("d", n3), n3;
        }, CustomEase);
        function CustomEase(e3, t3, n3) {
          a || q2(), this.id = e3, this.setData(t3, n3);
        }
        n2.version = "3.12.7", n2.headless = true, p() && M2.registerPlugin(n2), e2.CustomEase = n2, e2.default = n2;
        if (typeof window === "undefined" || window !== e2) {
          Object.defineProperty(e2, "__esModule", { value: true });
        } else {
          delete e2.default;
        }
      });
      !(function(t2, e2) {
        "object" == typeof exports && "undefined" != typeof module ? e2(exports) : "function" == typeof define && define.amd ? define(["exports"], e2) : e2((t2 = t2 || self).window = t2.window || {});
      })(exports, function(e2) {
        "use strict";
        function p(t3) {
          var e3 = t3.ownerDocument || t3;
          !(k2 in t3.style) && "msTransform" in t3.style && (C2 = (k2 = "msTransform") + "Origin");
          for (; e3.parentNode && (e3 = e3.parentNode); ) ;
          if (y = window, m = new F2(), e3) {
            a = (g = e3).documentElement, b = e3.body, (s2 = g.createElementNS("http://www.w3.org/2000/svg", "g")).style.transform = "none";
            var i3 = e3.createElement("div"), n3 = e3.createElement("div"), r3 = e3 && (e3.body || e3.firstElementChild);
            r3 && r3.appendChild && (r3.appendChild(i3), i3.appendChild(n3), i3.setAttribute("style", "position:static;transform:translate3d(0,0,1px)"), w = n3.offsetParent !== i3, r3.removeChild(i3));
          }
          return e3;
        }
        function t2() {
          return y.pageYOffset || g.scrollTop || a.scrollTop || b.scrollTop || 0;
        }
        function u() {
          return y.pageXOffset || g.scrollLeft || a.scrollLeft || b.scrollLeft || 0;
        }
        function v(t3) {
          return t3.ownerSVGElement || ("svg" === (t3.tagName + "").toLowerCase() ? t3 : null);
        }
        function x(t3, e3) {
          if (t3.parentNode && (g || p(t3))) {
            var i3 = v(t3), n3 = i3 ? i3.getAttribute("xmlns") || "http://www.w3.org/2000/svg" : "http://www.w3.org/1999/xhtml", r3 = i3 ? e3 ? "rect" : "g" : "div", a2 = 2 !== e3 ? 0 : 100, s3 = 3 === e3 ? 100 : 0, o3 = "position:absolute;display:block;pointer-events:none;margin:0;padding:0;", l3 = g.createElementNS ? g.createElementNS(n3.replace(/^https/, "http"), r3) : g.createElement(r3);
            return e3 && (i3 ? (d2 = d2 || x(t3), l3.setAttribute("width", 0.01), l3.setAttribute("height", 0.01), l3.setAttribute("transform", "translate(" + a2 + "," + s3 + ")"), d2.appendChild(l3)) : (f || ((f = x(t3)).style.cssText = o3), l3.style.cssText = o3 + "width:0.1px;height:0.1px;top:" + s3 + "px;left:" + a2 + "px", f.appendChild(l3))), l3;
          }
          throw "Need document and parent.";
        }
        function z2(t3) {
          var e3, i3 = t3.getCTM();
          return i3 || (e3 = t3.style[k2], t3.style[k2] = "none", t3.appendChild(s2), i3 = s2.getCTM(), t3.removeChild(s2), e3 ? t3.style[k2] = e3 : t3.style.removeProperty(k2.replace(/([A-Z])/g, "-$1").toLowerCase())), i3 || m.clone();
        }
        function A2(t3, e3) {
          var i3, n3, r3, a2, s3, o3, l3 = v(t3), u2 = t3 === l3, h2 = l3 ? E : M2, p2 = t3.parentNode, c2 = p2 && !l3 && p2.shadowRoot && p2.shadowRoot.appendChild ? p2.shadowRoot : p2;
          if (t3 === y) return t3;
          if (h2.length || h2.push(x(t3, 1), x(t3, 2), x(t3, 3)), i3 = l3 ? d2 : f, l3)
            u2 ? (a2 = -(r3 = z2(t3)).e / r3.a, s3 = -r3.f / r3.d, n3 = m) : t3.getBBox ? (r3 = t3.getBBox(), a2 = (n3 = (n3 = t3.transform ? t3.transform.baseVal : {}).numberOfItems ? 1 < n3.numberOfItems ? (function _consolidate(t4) {
              for (var e4 = new F2(), i4 = 0; i4 < t4.numberOfItems; i4++) e4.multiply(t4.getItem(i4).matrix);
              return e4;
            })(n3) : n3.getItem(0).matrix : m).a * r3.x + n3.c * r3.y, s3 = n3.b * r3.x + n3.d * r3.y) : (n3 = new F2(), a2 = s3 = 0), e3 && "g" === t3.tagName.toLowerCase() && (a2 = s3 = 0), (u2 ? l3 : p2).appendChild(i3), i3.setAttribute(
              "transform",
              "matrix(" + n3.a + "," + n3.b + "," + n3.c + "," + n3.d + "," + (n3.e + a2) + "," + (n3.f + s3) + ")"
            );
          else {
            if (a2 = s3 = 0, w)
              for (n3 = t3.offsetParent, r3 = t3; (r3 = r3 && r3.parentNode) && r3 !== n3 && r3.parentNode; )
                4 < (y.getComputedStyle(r3)[k2] + "").length && (a2 = r3.offsetLeft, s3 = r3.offsetTop, r3 = 0);
            if ("absolute" !== (o3 = y.getComputedStyle(t3)).position && "fixed" !== o3.position)
              for (n3 = t3.offsetParent; p2 && p2 !== n3; )
                a2 += p2.scrollLeft || 0, s3 += p2.scrollTop || 0, p2 = p2.parentNode;
            (r3 = i3.style).top = t3.offsetTop - s3 + "px", r3.left = t3.offsetLeft - a2 + "px", r3[k2] = o3[k2], r3[C2] = o3[C2], r3.position = "fixed" === o3.position ? "fixed" : "absolute", c2.appendChild(i3);
          }
          return i3;
        }
        function B2(t3, e3, i3, n3, r3, a2, s3) {
          return t3.a = e3, t3.b = i3, t3.c = n3, t3.d = r3, t3.e = a2, t3.f = s3, t3;
        }
        var g, y, a, b, f, d2, m, s2, w, i2, k2 = "transform", C2 = k2 + "Origin", E = [], M2 = [], F2 = ((i2 = Matrix2D.prototype).inverse = function inverse() {
          var t3 = this.a, e3 = this.b, i3 = this.c, n3 = this.d, r3 = this.e, a2 = this.f, s3 = t3 * n3 - e3 * i3 || 1e-10;
          return B2(this, n3 / s3, -e3 / s3, -i3 / s3, t3 / s3, (i3 * a2 - n3 * r3) / s3, -(t3 * a2 - e3 * r3) / s3);
        }, i2.multiply = function multiply(t3) {
          var e3 = this.a, i3 = this.b, n3 = this.c, r3 = this.d, a2 = this.e, s3 = this.f, o3 = t3.a, l3 = t3.c, u2 = t3.b, h2 = t3.d, p2 = t3.e, c2 = t3.f;
          return B2(
            this,
            o3 * e3 + u2 * n3,
            o3 * i3 + u2 * r3,
            l3 * e3 + h2 * n3,
            l3 * i3 + h2 * r3,
            a2 + p2 * e3 + c2 * n3,
            s3 + p2 * i3 + c2 * r3
          );
        }, i2.clone = function clone() {
          return new Matrix2D(this.a, this.b, this.c, this.d, this.e, this.f);
        }, i2.equals = function equals(t3) {
          var e3 = this.a, i3 = this.b, n3 = this.c, r3 = this.d, a2 = this.e, s3 = this.f;
          return e3 === t3.a && i3 === t3.b && n3 === t3.c && r3 === t3.d && a2 === t3.e && s3 === t3.f;
        }, i2.apply = function apply(t3, e3) {
          void 0 === e3 && (e3 = {});
          var i3 = t3.x, n3 = t3.y, r3 = this.a, a2 = this.b, s3 = this.c, o3 = this.d, l3 = this.e, u2 = this.f;
          return e3.x = i3 * r3 + n3 * s3 + l3 || 0, e3.y = i3 * a2 + n3 * o3 + u2 || 0, e3;
        }, Matrix2D);
        function Matrix2D(t3, e3, i3, n3, r3, a2) {
          void 0 === t3 && (t3 = 1), void 0 === e3 && (e3 = 0), void 0 === i3 && (i3 = 0), void 0 === n3 && (n3 = 1), void 0 === r3 && (r3 = 0), void 0 === a2 && (a2 = 0), B2(this, t3, e3, i3, n3, r3, a2);
        }
        function getGlobalMatrix(e3, i3, n3, r3) {
          if (!e3 || !e3.parentNode || (g || p(e3)).documentElement === e3) return new F2();
          var a2 = (function _forceNonZeroScale(t3) {
            for (var e4, i4; t3 && t3 !== b; )
              (i4 = t3._gsap) && i4.uncache && i4.get(t3, "x"), i4 && !i4.scaleX && !i4.scaleY && i4.renderTransform && (i4.scaleX = i4.scaleY = 1e-4, i4.renderTransform(1, i4), e4 ? e4.push(i4) : e4 = [i4]), t3 = t3.parentNode;
            return e4;
          })(e3), s3 = v(e3) ? E : M2, o3 = A2(e3, n3), l3 = s3[0].getBoundingClientRect(), h2 = s3[1].getBoundingClientRect(), c2 = s3[2].getBoundingClientRect(), f2 = o3.parentNode, d3 = !r3 && (function _isFixed(t3) {
            return "fixed" === y.getComputedStyle(t3).position || ((t3 = t3.parentNode) && 1 === t3.nodeType ? _isFixed(t3) : void 0);
          })(e3), m2 = new F2(
            (h2.left - l3.left) / 100,
            (h2.top - l3.top) / 100,
            (c2.left - l3.left) / 100,
            (c2.top - l3.top) / 100,
            l3.left + (d3 ? 0 : u()),
            l3.top + (d3 ? 0 : t2())
          );
          if (f2.removeChild(o3), a2) for (l3 = a2.length; l3--; ) (h2 = a2[l3]).scaleX = h2.scaleY = 0, h2.renderTransform(1, h2);
          return i3 ? m2.inverse() : m2;
        }
        function L2(t3, e3) {
          return t3.actions.forEach(function(t4) {
            return t4.vars[e3] && t4.vars[e3](t4);
          });
        }
        function S(t3) {
          return "string" == typeof t3 ? t3.split(" ").join("").split(",") : t3;
        }
        function V2(t3) {
          return I2(t3)[0] || console.warn("Element not found:", t3);
        }
        function W2(t3) {
          return Math.round(1e4 * t3) / 1e4 || 0;
        }
        function X3(t3, e3, i3) {
          return t3.forEach(function(t4) {
            return t4.classList[i3](e3);
          });
        }
        function $(t3) {
          return t3.replace(/([A-Z])/g, "-$1").toLowerCase();
        }
        function _(t3, e3) {
          var i3, n3 = {};
          for (i3 in t3) e3[i3] || (n3[i3] = t3[i3]);
          return n3;
        }
        function ba(t3) {
          var e3 = st2[t3] = S(t3);
          return et2[t3] = e3.concat(nt), e3;
        }
        function ea(t3, e3, i3) {
          return t3.forEach(function(t4) {
            return t4.d = (function _getDOMDepth(t5, e4, i4) {
              void 0 === i4 && (i4 = 0);
              for (var n3 = t5.parentNode, r3 = 1e3 * Math.pow(10, i4) * (e4 ? -1 : 1), a2 = e4 ? 900 * -r3 : 0; t5; )
                a2 += r3, t5 = t5.previousSibling;
              return n3 ? a2 + _getDOMDepth(n3, e4, i4 + 1) : a2;
            })(i3 ? t4.element : t4.t, e3);
          }), t3.sort(function(t4, e4) {
            return t4.d - e4.d;
          }), t3;
        }
        function fa(t3, e3) {
          for (var i3, n3, r3 = t3.element.style, a2 = t3.css = t3.css || [], s3 = e3.length; s3--; )
            n3 = r3[i3 = e3[s3]] || r3.getPropertyValue(i3), a2.push(n3 ? i3 : Y2[i3] || (Y2[i3] = $(i3)), n3);
          return r3;
        }
        function ga(t3) {
          var e3 = t3.css, i3 = t3.element.style, n3 = 0;
          for (t3.cache.uncache = 1; n3 < e3.length; n3 += 2) e3[n3 + 1] ? i3[e3[n3]] = e3[n3 + 1] : i3.removeProperty(e3[n3]);
          !e3[e3.indexOf("transform") + 1] && i3.translate && (i3.removeProperty("translate"), i3.removeProperty("scale"), i3.removeProperty("rotate"));
        }
        function ha(t3, e3) {
          t3.forEach(function(t4) {
            return t4.a.cache.uncache = 1;
          }), e3 || t3.finalStates.forEach(ga);
        }
        function ja(e3, i3, n3) {
          var r3, a2, s3, o3 = e3.element, l3 = e3.width, h2 = e3.height, p2 = e3.uncache, c2 = e3.getProp, f2 = o3.style, d3 = 4;
          if ("object" != typeof i3 && (i3 = e3), tt2 && 1 !== n3)
            return tt2._abs.push({ t: o3, b: e3, a: e3, sd: 0 }), tt2._final.push(function() {
              return (e3.cache.uncache = 1) && ga(e3);
            }), o3;
          for (a2 = "none" === c2("display"), e3.isVisible && !a2 || (a2 && (fa(e3, ["display"]).display = i3.display), e3.matrix = i3.matrix, e3.width = l3 = e3.width || i3.width, e3.height = h2 = e3.height || i3.height), fa(e3, R2), s3 = window.getComputedStyle(o3); d3--; )
            f2[R2[d3]] = s3[R2[d3]];
          if (f2.gridArea = "1 / 1 / 1 / 1", f2.transition = "none", f2.position = "absolute", f2.width = l3 + "px", f2.height = h2 + "px", f2.top || (f2.top = "0px"), f2.left || (f2.left = "0px"), p2)
            r3 = new ht2(o3);
          else if ((r3 = _(e3, D)).position = "absolute", e3.simple) {
            var m2 = o3.getBoundingClientRect();
            r3.matrix = new F2(1, 0, 0, 1, m2.left + u(), m2.top + t2());
          } else r3.matrix = getGlobalMatrix(o3, false, false, true);
          return r3 = ot2(r3, e3, true), e3.x = P(r3.x, 0.01), e3.y = P(r3.y, 0.01), o3;
        }
        function ka(t3, e3) {
          return true !== e3 && (e3 = I2(e3), t3 = t3.filter(function(t4) {
            if (-1 !== e3.indexOf((t4.sd < 0 ? t4.b : t4.a).element)) return true;
            t4.t._gsap.renderTransform(1), t4.b.isVisible && (t4.t.style.width = t4.b.width + "px", t4.t.style.height = t4.b.height + "px");
          })), t3;
        }
        function la(t3) {
          return ea(t3, true).forEach(function(t4) {
            return (t4.a.isVisible || t4.b.isVisible) && ja(t4.sd < 0 ? t4.b : t4.a, t4.b, 1);
          });
        }
        function pa(t3, e3) {
          var i3, n3 = t3.style || t3;
          for (i3 in e3) n3[i3] = e3[i3];
        }
        function ra(t3) {
          return t3.map(function(t4) {
            return t4.element;
          });
        }
        function sa(t3, e3, i3) {
          return t3 && e3.length && i3.add(t3(ra(e3), i3, new ut2(e3, 0, true)), 0);
        }
        function ua(t3, e3) {
          return t3 instanceof ut2 ? t3 : new ut2(t3, e3);
        }
        function va(t3, e3, i3) {
          var n3 = t3.idLookup[i3], r3 = t3.alt[i3];
          return !r3.isVisible || (e3.getElementState(r3.element) || r3).isVisible && n3.isVisible ? n3 : r3;
        }
        function za(t3) {
          if (t3 !== l2) {
            var e3 = o2.style, i3 = o2.clientWidth === window.outerWidth, n3 = o2.clientHeight === window.outerHeight, r3 = 4;
            if (t3 && (i3 || n3)) {
              for (; r3--; ) j2[r3] = e3[H2[r3]];
              i3 && (e3.width = o2.clientWidth + "px", e3.overflowY = "hidden"), n3 && (e3.height = o2.clientHeight + "px", e3.overflowX = "hidden"), l2 = t3;
            } else if (l2) {
              for (; r3--; ) j2[r3] ? e3[H2[r3]] = j2[r3] : e3.removeProperty($(H2[r3]));
              l2 = t3;
            }
          }
        }
        function Aa(t3, e3, r3, i3) {
          t3 instanceof ut2 && e3 instanceof ut2 || console.warn("Not a valid state object.");
          var a2, s3, o3, l3, u2, h2, p2, c2, f2, n3, d3, m2, g2, v2, y2, x2 = (r3 = r3 || {}).clearProps, b2 = r3.onEnter, w2 = r3.onLeave, S2 = r3.absolute, k3 = r3.absoluteOnLeave, C3 = r3.custom, V3 = r3.delay, E2 = r3.paused, M3 = r3.repeat, B3 = r3.repeatDelay, F3 = r3.yoyo, I3 = r3.toggleClass, L3 = r3.nested, P2 = r3.zIndex, A3 = r3.scale, T3 = r3.fade, O3 = r3.stagger, N3 = r3.spin, D2 = r3.prune, z3 = ("props" in r3 ? r3 : t3).props, Y3 = _(r3, rt2), R3 = Q2.timeline({ delay: V3, paused: E2, repeat: M3, repeatDelay: B3, yoyo: F3, data: "isFlip" }), W3 = Y3, G3 = [], j3 = [], H3 = [], q3 = [], $2 = true === N3 ? 1 : N3 || 0, Z3 = "function" == typeof N3 ? N3 : function() {
            return $2;
          }, J3 = t3.interrupted || e3.interrupted, U3 = R3[1 !== i3 ? "to" : "from"];
          for (s3 in e3.idLookup)
            d3 = e3.alt[s3] ? va(e3, t3, s3) : e3.idLookup[s3], u2 = d3.element, n3 = t3.idLookup[s3], !t3.alt[s3] || u2 !== n3.element || !t3.alt[s3].isVisible && d3.isVisible || (n3 = t3.alt[s3]), n3 ? (h2 = { t: u2, b: n3, a: d3, sd: n3.element === u2 ? 0 : d3.isVisible ? 1 : -1 }, H3.push(h2), h2.sd && (h2.sd < 0 && (h2.b = d3, h2.a = n3), J3 && fa(h2.b, z3 ? et2[z3] : nt), T3 && H3.push(h2.swap = { t: n3.element, b: h2.b, a: h2.a, sd: -h2.sd, swap: h2 })), u2._flip = n3.element._flip = tt2 ? tt2.timeline : R3) : d3.isVisible && (H3.push({ t: u2, b: _(d3, { isVisible: 1 }), a: d3, sd: 0, entering: 1 }), u2._flip = tt2 ? tt2.timeline : R3);
          z3 && (st2[z3] || ba(z3)).forEach(function(e4) {
            return Y3[e4] = function(t4) {
              return H3[t4].a.props[e4];
            };
          }), H3.finalStates = f2 = [], m2 = function run() {
            for (ea(H3), za(true), l3 = 0; l3 < H3.length; l3++)
              h2 = H3[l3], g2 = h2.a, v2 = h2.b, !D2 || g2.isDifferent(v2) || h2.entering ? (u2 = h2.t, !L3 || h2.sd < 0 || !l3 || (g2.matrix = getGlobalMatrix(u2, false, false, true)), v2.isVisible && g2.isVisible ? (h2.sd < 0 ? (p2 = new ht2(u2, z3, t3.simple), ot2(p2, g2, A3, 0, 0, p2), p2.matrix = getGlobalMatrix(u2, false, false, true), p2.css = h2.b.css, h2.a = g2 = p2, T3 && (u2.style.opacity = J3 ? v2.opacity : g2.opacity), O3 && q3.push(u2)) : 0 < h2.sd && T3 && (u2.style.opacity = J3 ? g2.opacity - v2.opacity : "0"), ot2(g2, v2, A3, z3)) : v2.isVisible !== g2.isVisible && (v2.isVisible ? g2.isVisible || (v2.css = g2.css, j3.push(v2), H3.splice(l3--, 1), S2 && L3 && ot2(g2, v2, A3, z3)) : (g2.isVisible && G3.push(g2), H3.splice(l3--, 1))), A3 || (u2.style.maxWidth = Math.max(g2.width, v2.width) + "px", u2.style.maxHeight = Math.max(g2.height, v2.height) + "px", u2.style.minWidth = Math.min(g2.width, v2.width) + "px", u2.style.minHeight = Math.min(g2.height, v2.height) + "px"), L3 && I3 && u2.classList.add(I3)) : H3.splice(l3--, 1), f2.push(g2);
            var e4;
            if (I3 && (e4 = f2.map(function(t4) {
              return t4.element;
            }), L3 && e4.forEach(function(t4) {
              return t4.classList.remove(I3);
            })), za(false), A3 ? (Y3.scaleX = function(t4) {
              return H3[t4].a.scaleX;
            }, Y3.scaleY = function(t4) {
              return H3[t4].a.scaleY;
            }) : (Y3.width = function(t4) {
              return H3[t4].a.width + "px";
            }, Y3.height = function(t4) {
              return H3[t4].a.height + "px";
            }, Y3.autoRound = r3.autoRound || false), Y3.x = function(t4) {
              return H3[t4].a.x + "px";
            }, Y3.y = function(t4) {
              return H3[t4].a.y + "px";
            }, Y3.rotation = function(t4) {
              return H3[t4].a.rotation + (N3 ? 360 * Z3(t4, c2[t4], c2) : 0);
            }, Y3.skewX = function(t4) {
              return H3[t4].a.skewX;
            }, c2 = H3.map(function(t4) {
              return t4.t;
            }), !P2 && 0 !== P2 || (Y3.modifiers = {
              zIndex: function zIndex() {
                return P2;
              }
            }, Y3.zIndex = P2, Y3.immediateRender = false !== r3.immediateRender), T3 && (Y3.opacity = function(t4) {
              return H3[t4].sd < 0 ? 0 : 0 < H3[t4].sd ? H3[t4].a.opacity : "+=0";
            }), q3.length) {
              O3 = Q2.utils.distribute(O3);
              var i4 = c2.slice(q3.length);
              Y3.stagger = function(t4, e5) {
                return O3(~q3.indexOf(e5) ? c2.indexOf(H3[t4].swap.t) : t4, e5, i4);
              };
            }
            if (it2.forEach(function(t4) {
              return r3[t4] && R3.eventCallback(t4, r3[t4], r3[t4 + "Params"]);
            }), C3 && c2.length)
              for (s3 in W3 = _(Y3, rt2), "scale" in C3 && (C3.scaleX = C3.scaleY = C3.scale, delete C3.scale), C3)
                (a2 = _(C3[s3], at2))[s3] = Y3[s3], !("duration" in a2) && "duration" in Y3 && (a2.duration = Y3.duration), a2.stagger = Y3.stagger, U3.call(R3, c2, a2, 0), delete W3[s3];
            (c2.length || j3.length || G3.length) && (I3 && R3.add(function() {
              return X3(e4, I3, R3._zTime < 0 ? "remove" : "add");
            }, 0) && !E2 && X3(e4, I3, "add"), c2.length && U3.call(R3, c2, W3, 0)), sa(b2, G3, R3), sa(w2, j3, R3);
            var n4 = tt2 && tt2.timeline;
            n4 && (n4.add(R3, 0), tt2._final.push(function() {
              return ha(H3, !x2);
            })), o3 = R3.duration(), R3.call(function() {
              var t4 = R3.time() >= o3;
              t4 && !n4 && ha(H3, !x2), I3 && X3(e4, I3, t4 ? "remove" : "add");
            });
          }, k3 && (S2 = H3.filter(function(t4) {
            return !t4.sd && !t4.a.isVisible && t4.b.isVisible;
          }).map(function(t4) {
            return t4.a.element;
          })), tt2 ? (S2 && (y2 = tt2._abs).push.apply(y2, ka(H3, S2)), tt2._run.push(m2)) : (S2 && la(ka(H3, S2)), m2());
          var K3 = tt2 ? tt2.timeline : R3;
          return K3.revert = function() {
            return lt2(K3, 1, 1);
          }, K3;
        }
        function Da(t3) {
          for (var e3, i3 = t3.idLookup = {}, n3 = t3.alt = {}, r3 = t3.elementStates, a2 = r3.length; a2--; )
            i3[(e3 = r3[a2]).id] ? n3[e3.id] = e3 : i3[e3.id] = e3;
        }
        var I2, Q2, tt2, r2, o2, P, T2, l2, n2, c = 1, h = {}, O2 = 180 / Math.PI, N2 = Math.PI / 180, D = {}, Y2 = {}, et2 = {}, it2 = S("onStart,onUpdate,onComplete,onReverseComplete,onInterrupt"), nt = S(
          "transform,transformOrigin,width,height,position,top,left,opacity,zIndex,maxWidth,maxHeight,minWidth,minHeight"
        ), rt2 = {
          zIndex: 1,
          kill: 1,
          simple: 1,
          spin: 1,
          clearProps: 1,
          targets: 1,
          toggleClass: 1,
          onComplete: 1,
          onUpdate: 1,
          onInterrupt: 1,
          onStart: 1,
          delay: 1,
          repeat: 1,
          repeatDelay: 1,
          yoyo: 1,
          scale: 1,
          fade: 1,
          absolute: 1,
          props: 1,
          onEnter: 1,
          onLeave: 1,
          custom: 1,
          paused: 1,
          nested: 1,
          prune: 1,
          absoluteOnLeave: 1
        }, at2 = { zIndex: 1, simple: 1, clearProps: 1, scale: 1, absolute: 1, fitChild: 1, getVars: 1, props: 1 }, st2 = {}, R2 = "paddingTop,paddingRight,paddingBottom,paddingLeft,gridArea,transition".split(","), G2 = function _parseElementState(t3, e3, i3, n3) {
          return t3 instanceof ht2 ? t3 : t3 instanceof ut2 ? (function _findElStateInState(t4, e4) {
            return e4 && t4.idLookup[G2(e4).id] || t4.elementStates[0];
          })(t3, n3) : new ht2("string" == typeof t3 ? V2(t3) || console.warn(t3 + " not found") : t3, e3, i3);
        }, ot2 = function _fit(t3, e3, i3, n3, r3, a2) {
          var s3, o3, l3, u2, h2, p2, c2, f2 = t3.element, d3 = t3.cache, m2 = t3.parent, g2 = t3.x, v2 = t3.y, y2 = e3.width, x2 = e3.height, b2 = e3.scaleX, w2 = e3.scaleY, S2 = e3.rotation, k3 = e3.bounds, _2 = a2 && T2 && T2(f2, "transform,width,height"), C3 = t3, V3 = e3.matrix, E2 = V3.e, M3 = V3.f, B3 = t3.bounds.width !== k3.width || t3.bounds.height !== k3.height || t3.scaleX !== b2 || t3.scaleY !== w2 || t3.rotation !== S2, F3 = !B3 && t3.simple && e3.simple && !r3;
          return F3 || !m2 ? (b2 = w2 = 1, S2 = s3 = 0) : (p2 = (h2 = (function _getInverseGlobalMatrix(t4) {
            var e4 = t4._gsap || Q2.core.getCache(t4);
            return e4.gmCache === Q2.ticker.frame ? e4.gMatrix : (e4.gmCache = Q2.ticker.frame, e4.gMatrix = getGlobalMatrix(t4, true, false, true));
          })(m2)).clone().multiply(e3.ctm ? e3.matrix.clone().multiply(e3.ctm) : e3.matrix), S2 = W2(Math.atan2(p2.b, p2.a) * O2), s3 = W2(Math.atan2(p2.c, p2.d) * O2 + S2) % 360, b2 = Math.sqrt(Math.pow(p2.a, 2) + Math.pow(p2.b, 2)), w2 = Math.sqrt(Math.pow(p2.c, 2) + Math.pow(p2.d, 2)) * Math.cos(s3 * N2), r3 && (r3 = I2(r3)[0], u2 = Q2.getProperty(r3), c2 = r3.getBBox && "function" == typeof r3.getBBox && r3.getBBox(), C3 = {
            scaleX: u2("scaleX"),
            scaleY: u2("scaleY"),
            width: c2 ? c2.width : Math.ceil(parseFloat(u2("width", "px"))),
            height: c2 ? c2.height : parseFloat(u2("height", "px"))
          }), d3.rotation = S2 + "deg", d3.skewX = s3 + "deg"), i3 ? (b2 *= y2 !== C3.width && C3.width ? y2 / C3.width : 1, w2 *= x2 !== C3.height && C3.height ? x2 / C3.height : 1, d3.scaleX = b2, d3.scaleY = w2) : (y2 = P(y2 * b2 / C3.scaleX, 0), x2 = P(x2 * w2 / C3.scaleY, 0), f2.style.width = y2 + "px", f2.style.height = x2 + "px"), n3 && pa(f2, e3.props), F3 || !m2 ? (g2 += E2 - t3.matrix.e, v2 += M3 - t3.matrix.f) : B3 || m2 !== e3.parent ? (d3.renderTransform(1, d3), p2 = getGlobalMatrix(r3 || f2, false, false, true), o3 = h2.apply({ x: p2.e, y: p2.f }), g2 += (l3 = h2.apply({ x: E2, y: M3 })).x - o3.x, v2 += l3.y - o3.y) : (h2.e = h2.f = 0, g2 += (l3 = h2.apply({ x: E2 - t3.matrix.e, y: M3 - t3.matrix.f })).x, v2 += l3.y), g2 = P(g2, 0.02), v2 = P(v2, 0.02), !a2 || a2 instanceof ht2 ? (d3.x = g2 + "px", d3.y = v2 + "px", d3.renderTransform(1, d3)) : _2 && _2.revert(), a2 && (a2.x = g2, a2.y = v2, a2.rotation = S2, a2.skewX = s3, i3 ? (a2.scaleX = b2, a2.scaleY = w2) : (a2.width = y2, a2.height = x2)), a2 || d3;
        }, j2 = [], H2 = "width,height,overflowX,overflowY".split(","), lt2 = function _killFlip(t3, e3, i3) {
          if (t3 && t3.progress() < 1 && (!t3.paused() || i3))
            return e3 && ((function _interrupt(t4) {
              t4.vars.onInterrupt && t4.vars.onInterrupt.apply(t4, t4.vars.onInterruptParams || []), t4.getChildren(true, false, true).forEach(_interrupt);
            })(t3), e3 < 2 && t3.progress(1), t3.kill()), true;
        }, ut2 = ((n2 = FlipState.prototype).update = function update2(t3) {
          var e3 = this;
          return this.elementStates = this.targets.map(function(t4) {
            return new ht2(t4, e3.props, e3.simple);
          }), Da(this), this.interrupt(t3), this.recordInlineStyles(), this;
        }, n2.clear = function clear() {
          return this.targets.length = this.elementStates.length = 0, Da(this), this;
        }, n2.fit = function fit(t3, e3, i3) {
          for (var n3, r3, a2 = ea(this.elementStates.slice(0), false, true), s3 = (t3 || this).idLookup, o3 = 0; o3 < a2.length; o3++)
            n3 = a2[o3], i3 && (n3.matrix = getGlobalMatrix(n3.element, false, false, true)), (r3 = s3[n3.id]) && ot2(n3, r3, e3, true, 0, n3), n3.matrix = getGlobalMatrix(n3.element, false, false, true);
          return this;
        }, n2.getProperty = function getProperty(t3, e3) {
          var i3 = this.getElementState(t3) || D;
          return (e3 in i3 ? i3 : i3.props || D)[e3];
        }, n2.add = function add(t3) {
          for (var e3, i3, n3, r3 = t3.targets.length, a2 = this.idLookup, s3 = this.alt; r3--; )
            (n3 = a2[(i3 = t3.elementStates[r3]).id]) && (i3.element === n3.element || s3[i3.id] && s3[i3.id].element === i3.element) ? (e3 = this.elementStates.indexOf(i3.element === n3.element ? n3 : s3[i3.id]), this.targets.splice(e3, 1, t3.targets[r3]), this.elementStates.splice(e3, 1, i3)) : (this.targets.push(t3.targets[r3]), this.elementStates.push(i3));
          return t3.interrupted && (this.interrupted = true), t3.simple || (this.simple = false), Da(this), this;
        }, n2.compare = function compare(t3) {
          function lh(t4, e4, i4) {
            return (t4.isVisible !== e4.isVisible ? t4.isVisible ? f2 : d3 : t4.isVisible ? c2 : p2).push(i4) && m2.push(i4);
          }
          function mh(t4, e4, i4) {
            return m2.indexOf(i4) < 0 && lh(t4, e4, i4);
          }
          var e3, i3, n3, r3, a2, s3, o3, l3, u2 = t3.idLookup, h2 = this.idLookup, p2 = [], c2 = [], f2 = [], d3 = [], m2 = [], g2 = t3.alt, v2 = this.alt;
          for (n3 in u2)
            a2 = g2[n3], s3 = v2[n3], r3 = (e3 = a2 ? va(t3, this, n3) : u2[n3]).element, i3 = h2[n3], s3 ? (l3 = i3.isVisible || !s3.isVisible && r3 === i3.element ? i3 : s3, (o3 = !a2 || e3.isVisible || a2.isVisible || l3.element !== a2.element ? e3 : a2).isVisible && l3.isVisible && o3.element !== l3.element ? ((o3.isDifferent(l3) ? c2 : p2).push(o3.element, l3.element), m2.push(o3.element, l3.element)) : lh(o3, l3, o3.element), a2 && o3.element === a2.element && (a2 = u2[n3]), mh(o3.element !== i3.element && a2 ? a2 : o3, i3, i3.element), mh(a2 && a2.element === s3.element ? a2 : o3, s3, s3.element), a2 && mh(a2, s3.element === a2.element ? s3 : i3, a2.element)) : (i3 ? i3.isDifferent(e3) ? lh(e3, i3, r3) : p2.push(r3) : f2.push(r3), a2 && mh(a2, i3, a2.element));
          for (n3 in h2) u2[n3] || (d3.push(h2[n3].element), v2[n3] && d3.push(v2[n3].element));
          return { changed: c2, unchanged: p2, enter: f2, leave: d3 };
        }, n2.recordInlineStyles = function recordInlineStyles() {
          for (var t3 = et2[this.props] || nt, e3 = this.elementStates.length; e3--; ) fa(this.elementStates[e3], t3);
        }, n2.interrupt = function interrupt(n3) {
          var r3 = this, a2 = [];
          this.targets.forEach(function(t3) {
            var e3 = t3._flip, i3 = lt2(e3, n3 ? 0 : 1);
            n3 && i3 && a2.indexOf(e3) < 0 && e3.add(function() {
              return r3.updateVisibility();
            }), i3 && a2.push(e3);
          }), !n3 && a2.length && this.updateVisibility(), this.interrupted || (this.interrupted = !!a2.length);
        }, n2.updateVisibility = function updateVisibility() {
          this.elementStates.forEach(function(t3) {
            var e3 = t3.element.getBoundingClientRect();
            t3.isVisible = !!(e3.width || e3.height || e3.top || e3.left), t3.uncache = 1;
          });
        }, n2.getElementState = function getElementState(t3) {
          return this.elementStates[this.targets.indexOf(V2(t3))];
        }, n2.makeAbsolute = function makeAbsolute() {
          return ea(this.elementStates.slice(0), true, true).map(ja);
        }, FlipState);
        function FlipState(t3, e3, i3) {
          if (this.props = e3 && e3.props, this.simple = !(!e3 || !e3.simple), i3)
            this.targets = ra(t3), this.elementStates = t3, Da(this);
          else {
            this.targets = I2(t3);
            var n3 = e3 && (false === e3.kill || e3.batch && !e3.kill);
            tt2 && !n3 && tt2._kill.push(this), this.update(n3 || !!tt2);
          }
        }
        var q2, ht2 = ((q2 = ElementState.prototype).isDifferent = function isDifferent(t3) {
          var e3 = this.bounds, i3 = t3.bounds;
          return e3.top !== i3.top || e3.left !== i3.left || e3.width !== i3.width || e3.height !== i3.height || !this.matrix.equals(t3.matrix) || this.opacity !== t3.opacity || this.props && t3.props && JSON.stringify(this.props) !== JSON.stringify(t3.props);
        }, q2.update = function update2(e3, i3) {
          var n3 = this, r3 = n3.element, a2 = Q2.getProperty(r3), s3 = Q2.core.getCache(r3), o3 = r3.getBoundingClientRect(), l3 = r3.getBBox && "function" == typeof r3.getBBox && "svg" !== r3.nodeName.toLowerCase() && r3.getBBox(), h2 = i3 ? new F2(1, 0, 0, 1, o3.left + u(), o3.top + t2()) : getGlobalMatrix(r3, false, false, true);
          s3.uncache = 1, n3.getProp = a2, n3.element = r3, n3.id = (function _getID(t3) {
            var e4 = t3.getAttribute("data-flip-id");
            return e4 || t3.setAttribute("data-flip-id", e4 = "auto-" + c++), e4;
          })(r3), n3.matrix = h2, n3.cache = s3, n3.bounds = o3, n3.isVisible = !!(o3.width || o3.height || o3.left || o3.top), n3.display = a2("display"), n3.position = a2("position"), n3.parent = r3.parentNode, n3.x = a2("x"), n3.y = a2("y"), n3.scaleX = s3.scaleX, n3.scaleY = s3.scaleY, n3.rotation = a2("rotation"), n3.skewX = a2("skewX"), n3.opacity = a2("opacity"), n3.width = l3 ? l3.width : P(a2("width", "px"), 0.04), n3.height = l3 ? l3.height : P(a2("height", "px"), 0.04), e3 && (function _recordProps(t3, e4) {
            for (var i4 = Q2.getProperty(t3.element, null, "native"), n4 = t3.props = {}, r4 = e4.length; r4--; )
              n4[e4[r4]] = (i4(e4[r4]) + "").trim();
            n4.zIndex && (n4.zIndex = parseFloat(n4.zIndex) || 0);
          })(n3, st2[e3] || ba(e3)), n3.ctm = r3.getCTM && "svg" === r3.nodeName.toLowerCase() && z2(r3).inverse(), n3.simple = i3 || 1 === W2(h2.a) && !W2(h2.b) && !W2(h2.c) && 1 === W2(h2.d), n3.uncache = 0;
        }, ElementState);
        function ElementState(t3, e3, i3) {
          this.element = t3, this.update(e3, i3);
        }
        var Z2, J2 = ((Z2 = FlipAction.prototype).getStateById = function getStateById(t3) {
          for (var e3 = this.states.length; e3--; ) if (this.states[e3].idLookup[t3]) return this.states[e3];
        }, Z2.kill = function kill() {
          this.batch.remove(this);
        }, FlipAction);
        function FlipAction(t3, e3) {
          this.vars = t3, this.batch = e3, this.states = [], this.timeline = e3.timeline;
        }
        var U2, K2 = ((U2 = FlipBatch.prototype).add = function add(e3) {
          var t3 = this.actions.filter(function(t4) {
            return t4.vars === e3;
          });
          return t3.length ? t3[0] : (t3 = new J2("function" == typeof e3 ? { animate: e3 } : e3, this), this.actions.push(t3), t3);
        }, U2.remove = function remove(t3) {
          var e3 = this.actions.indexOf(t3);
          return 0 <= e3 && this.actions.splice(e3, 1), this;
        }, U2.getState = function getState(e3) {
          var i3 = this, t3 = tt2, n3 = r2;
          return (tt2 = this).state.clear(), this._kill.length = 0, this.actions.forEach(function(t4) {
            t4.vars.getState && (t4.states.length = 0, (r2 = t4).state = t4.vars.getState(t4)), e3 && t4.states.forEach(function(t5) {
              return i3.state.add(t5);
            });
          }), r2 = n3, tt2 = t3, this.killConflicts(), this;
        }, U2.animate = function animate() {
          var t3, e3, i3 = this, n3 = tt2, r3 = this.timeline, a2 = this.actions.length;
          for (tt2 = this, r3.clear(), this._abs.length = this._final.length = this._run.length = 0, this.actions.forEach(function(t4) {
            t4.vars.animate && t4.vars.animate(t4);
            var e4, i4, n4 = t4.vars.onEnter, r4 = t4.vars.onLeave, a3 = t4.targets;
            a3 && a3.length && (n4 || r4) && (e4 = new ut2(), t4.states.forEach(function(t5) {
              return e4.add(t5);
            }), (i4 = e4.compare(pt2.getState(a3))).enter.length && n4 && n4(i4.enter), i4.leave.length && r4 && r4(i4.leave));
          }), la(this._abs), this._run.forEach(function(t4) {
            return t4();
          }), e3 = r3.duration(), t3 = this._final.slice(0), r3.add(function() {
            e3 <= r3.time() && (t3.forEach(function(t4) {
              return t4();
            }), L2(i3, "onComplete"));
          }), tt2 = n3; a2--; )
            this.actions[a2].vars.once && this.actions[a2].kill();
          return L2(this, "onStart"), r3.restart(), this;
        }, U2.loadState = function loadState(n3) {
          n3 = n3 || function done() {
            return 0;
          };
          var r3 = [];
          return this.actions.forEach(function(e3) {
            if (e3.vars.loadState) {
              var i3, t3 = function f2(t4) {
                t4 && (e3.targets = t4), ~(i3 = r3.indexOf(f2)) && (r3.splice(i3, 1), r3.length || n3());
              };
              r3.push(t3), e3.vars.loadState(t3);
            }
          }), r3.length || n3(), this;
        }, U2.setState = function setState() {
          return this.actions.forEach(function(t3) {
            return t3.targets = t3.vars.setState && t3.vars.setState(t3);
          }), this;
        }, U2.killConflicts = function killConflicts(e3) {
          return this.state.interrupt(e3), this._kill.forEach(function(t3) {
            return t3.interrupt(e3);
          }), this;
        }, U2.run = function run(t3, e3) {
          var i3 = this;
          return this !== tt2 && (t3 || this.getState(e3), this.loadState(function() {
            i3._killed || (i3.setState(), i3.animate());
          })), this;
        }, U2.clear = function clear(t3) {
          this.state.clear(), t3 || (this.actions.length = 0);
        }, U2.getStateById = function getStateById(t3) {
          for (var e3, i3 = this.actions.length; i3--; ) if (e3 = this.actions[i3].getStateById(t3)) return e3;
          return this.state.idLookup[t3] && this.state;
        }, U2.kill = function kill() {
          this._killed = 1, this.clear(), delete h[this.id];
        }, FlipBatch);
        function FlipBatch(t3) {
          this.id = t3, this.actions = [], this._kill = [], this._final = [], this._abs = [], this._run = [], this.data = {}, this.state = new ut2(), this.timeline = Q2.timeline();
        }
        var pt2 = (Flip.getState = function getState(t3, e3) {
          var i3 = ua(t3, e3);
          return r2 && r2.states.push(i3), e3 && e3.batch && Flip.batch(e3.batch).state.add(i3), i3;
        }, Flip.from = function from(t3, e3) {
          return "clearProps" in (e3 = e3 || {}) || (e3.clearProps = true), Aa(t3, ua(e3.targets || t3.targets, { props: e3.props || t3.props, simple: e3.simple, kill: !!e3.kill }), e3, -1);
        }, Flip.to = function to(t3, e3) {
          return Aa(t3, ua(e3.targets || t3.targets, { props: e3.props || t3.props, simple: e3.simple, kill: !!e3.kill }), e3, 1);
        }, Flip.fromTo = function fromTo(t3, e3, i3) {
          return Aa(t3, e3, i3);
        }, Flip.fit = function fit(t3, e3, i3) {
          var n3 = i3 ? _(i3, at2) : {}, r3 = i3 || n3, a2 = r3.absolute, s3 = r3.scale, o3 = r3.getVars, l3 = r3.props, u2 = r3.runBackwards, h2 = r3.onComplete, p2 = r3.simple, c2 = i3 && i3.fitChild && V2(i3.fitChild), f2 = G2(e3, l3, p2, t3), d3 = G2(t3, 0, p2, f2), m2 = l3 ? et2[l3] : nt, g2 = Q2.context();
          return l3 && pa(n3, f2.props), fa(d3, m2), u2 && ("immediateRender" in n3 || (n3.immediateRender = true), n3.onComplete = function() {
            ga(d3), h2 && h2.apply(this, arguments);
          }), a2 && ja(d3, f2), n3 = ot2(d3, f2, s3 || c2, !n3.duration && l3, c2, n3.duration || o3 ? n3 : 0), "object" == typeof i3 && "zIndex" in i3 && (n3.zIndex = i3.zIndex), g2 && !o3 && g2.add(function() {
            return function() {
              return ga(d3);
            };
          }), o3 ? n3 : n3.duration ? Q2.to(d3.element, n3) : null;
        }, Flip.makeAbsolute = function makeAbsolute(t3, e3) {
          return (t3 instanceof ut2 ? t3 : new ut2(t3, e3)).makeAbsolute();
        }, Flip.batch = function batch(t3) {
          return h[t3 = t3 || "default"] || (h[t3] = new K2(t3));
        }, Flip.killFlipsOf = function killFlipsOf(t3, e3) {
          (t3 instanceof ut2 ? t3.targets : I2(t3)).forEach(function(t4) {
            return t4 && lt2(t4._flip, false !== e3 ? 1 : 2);
          });
        }, Flip.isFlipping = function isFlipping(t3) {
          var e3 = Flip.getByTarget(t3);
          return !!e3 && e3.isActive();
        }, Flip.getByTarget = function getByTarget(t3) {
          return (V2(t3) || D)._flip;
        }, Flip.getElementState = function getElementState(t3, e3) {
          return new ht2(V2(t3), e3);
        }, Flip.convertCoordinates = function convertCoordinates(t3, e3, i3) {
          var n3 = getGlobalMatrix(e3, true, true).multiply(getGlobalMatrix(t3));
          return i3 ? n3.apply(i3) : n3;
        }, Flip.register = function register(t3) {
          if (o2 = "undefined" != typeof document && document.body) {
            Q2 = t3, p(o2), I2 = Q2.utils.toArray, T2 = Q2.core.getStyleSaver;
            var i3 = Q2.utils.snap(0.1);
            P = function _closestTenth(t4, e3) {
              return i3(parseFloat(t4) + e3);
            };
          }
        }, Flip);
        function Flip() {
        }
        pt2.version = "3.13.0", "undefined" != typeof window && window.gsap && window.gsap.registerPlugin(pt2), e2.Flip = pt2, e2.default = pt2;
        if (typeof window === "undefined" || window !== e2) {
          Object.defineProperty(e2, "__esModule", { value: true });
        } else {
          delete e2.default;
        }
      });
      (function(B2, A2) {
        typeof exports == "object" && typeof module != "undefined" ? A2(exports) : typeof define == "function" && define.amd ? define(["exports"], A2) : (B2 = typeof globalThis != "undefined" ? globalThis : B2 || self, A2(B2.window = B2.window || {}));
      })(exports, function(B2) {
        "use strict";
        let A2, _, G2, re = () => G2 || U2.register(window.gsap), V2 = typeof Intl != "undefined" ? new Intl.Segmenter() : 0, P = (e2) => typeof e2 == "string" ? P(document.querySelectorAll(e2)) : "length" in e2 ? Array.from(e2) : [e2], X3 = (e2) => P(e2).filter((t2) => t2 instanceof HTMLElement), J2 = [], K2 = function() {
        }, oe2 = /\s+/g, Y2 = new RegExp(
          "\\p{RI}\\p{RI}|\\p{Emoji}(\\p{EMod}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Emoji}(\\p{EMod}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*|.",
          "gu"
        ), Z2 = { left: 0, top: 0, width: 0, height: 0 }, ee2 = (e2, t2) => {
          if (t2) {
            let s2 = new Set(e2.join("").match(t2) || J2), i2 = e2.length, o2, c, n2, a;
            if (s2.size)
              for (; --i2 > -1; ) {
                c = e2[i2];
                for (n2 of s2)
                  if (n2.startsWith(c) && n2.length > c.length) {
                    for (o2 = 0, a = c; n2.startsWith(a += e2[i2 + ++o2]) && a.length < n2.length; ) ;
                    if (o2 && a.length === n2.length) {
                      e2[i2] = n2, e2.splice(i2 + 1, o2);
                      break;
                    }
                  }
              }
          }
          return e2;
        }, te2 = (e2) => window.getComputedStyle(e2).display === "inline" && (e2.style.display = "inline-block"), z2 = (e2, t2, s2) => t2.insertBefore(typeof e2 == "string" ? document.createTextNode(e2) : e2, s2), Q2 = (e2, t2, s2) => {
          let i2 = t2[e2 + "sClass"] || "", { tag: o2 = "div", aria: c = "auto", propIndex: n2 = false } = t2, a = e2 === "line" ? "block" : "inline-block", h = i2.indexOf("++") > -1, b = (x) => {
            let g = document.createElement(o2), C2 = s2.length + 1;
            return i2 && (g.className = i2 + (h ? " " + i2 + C2 : "")), n2 && g.style.setProperty("--" + e2, C2 + ""), c !== "none" && g.setAttribute("aria-hidden", "true"), o2 !== "span" && (g.style.position = "relative", g.style.display = a), g.textContent = x, s2.push(g), g;
          };
          return h && (i2 = i2.replace("++", "")), b.collection = s2, b;
        }, ae2 = (e2, t2, s2, i2) => {
          let o2 = Q2("line", s2, i2), c = window.getComputedStyle(e2).textAlign || "left";
          return (n2, a) => {
            let h = o2("");
            for (h.style.textAlign = c, e2.insertBefore(h, t2[n2]); n2 < a; n2++) h.appendChild(t2[n2]);
            h.normalize();
          };
        }, ie = (e2, t2, s2, i2, o2, c, n2, a, h, b) => {
          var x;
          let g = Array.from(e2.childNodes), C2 = 0, { wordDelimiter: R2, reduceWhiteSpace: L2 = true, prepareText: $ } = t2, q2 = e2.getBoundingClientRect(), j2 = q2, D = !L2 && window.getComputedStyle(e2).whiteSpace.substring(0, 3) === "pre", E = 0, v = s2.collection, r2, f, H2, l2, m, y, I2, d2, u, W2, S, O2, T2, F2, w, p, k2, N2;
          for (typeof R2 == "object" ? (H2 = R2.delimiter || R2, f = R2.replaceWith || "") : f = R2 === "" ? "" : R2 || " ", r2 = f !== " "; C2 < g.length; C2++)
            if (l2 = g[C2], l2.nodeType === 3) {
              for (w = l2.textContent || "", L2 ? w = w.replace(oe2, " ") : D && (w = w.replace(
                /\n/g,
                f + `
`
              )), $ && (w = $(w, e2)), l2.textContent = w, m = f || H2 ? w.split(H2 || f) : w.match(a) || J2, k2 = m[m.length - 1], d2 = r2 ? k2.slice(-1) === " " : !k2, k2 || m.pop(), j2 = q2, I2 = r2 ? m[0].charAt(0) === " " : !m[0], I2 && z2(" ", e2, l2), m[0] || m.shift(), ee2(m, h), c && b || (l2.textContent = ""), u = 1; u <= m.length; u++)
                if (p = m[u - 1], !L2 && D && p.charAt(0) === `
` && ((x = l2.previousSibling) == null || x.remove(), z2(document.createElement("br"), e2, l2), p = p.slice(1)), !L2 && p === "")
                  z2(f, e2, l2);
                else if (p === " ") e2.insertBefore(document.createTextNode(" "), l2);
                else {
                  if (r2 && p.charAt(0) === " " && z2(" ", e2, l2), E && u === 1 && !I2 && v.indexOf(E.parentNode) > -1 ? (y = v[v.length - 1], y.appendChild(document.createTextNode(i2 ? "" : p))) : (y = s2(i2 ? "" : p), z2(y, e2, l2), E && u === 1 && !I2 && y.insertBefore(E, y.firstChild)), i2)
                    for (S = V2 ? ee2(
                      [...V2.segment(p)].map((M2) => M2.segment),
                      h
                    ) : p.match(a) || J2, N2 = 0; N2 < S.length; N2++)
                      y.appendChild(S[N2] === " " ? document.createTextNode(" ") : i2(S[N2]));
                  if (c && b) {
                    if (w = l2.textContent = w.substring(p.length + 1, w.length), W2 = y.getBoundingClientRect(), W2.top > j2.top && W2.left <= j2.left) {
                      for (O2 = e2.cloneNode(), T2 = e2.childNodes[0]; T2 && T2 !== y; )
                        F2 = T2, T2 = T2.nextSibling, O2.appendChild(F2);
                      e2.parentNode.insertBefore(O2, e2), o2 && te2(O2);
                    }
                    j2 = W2;
                  }
                  (u < m.length || d2) && z2(u >= m.length ? " " : r2 && p.slice(-1) === " " ? " " + f : f, e2, l2);
                }
              e2.removeChild(l2), E = 0;
            } else
              l2.nodeType === 1 && (n2 && n2.indexOf(l2) > -1 ? (v.indexOf(l2.previousSibling) > -1 && v[v.length - 1].appendChild(l2), E = l2) : (ie(l2, t2, s2, i2, o2, c, n2, a, h, true), E = 0), o2 && te2(l2));
        };
        const ne2 = class se2 {
          constructor(t2, s2) {
            this.isSplit = false, re(), this.elements = X3(t2), this.chars = [], this.words = [], this.lines = [], this.masks = [], this.vars = s2, this._split = () => this.isSplit && this.split(this.vars);
            let i2 = [], o2, c = () => {
              let n2 = i2.length, a;
              for (; n2--; ) {
                a = i2[n2];
                let h = a.element.offsetWidth;
                if (h !== a.width) {
                  a.width = h, this._split();
                  return;
                }
              }
            };
            this._data = {
              orig: i2,
              obs: typeof ResizeObserver != "undefined" && new ResizeObserver(() => {
                clearTimeout(o2), o2 = setTimeout(c, 200);
              })
            }, K2(this), this.split(s2);
          }
          split(t2) {
            this.isSplit && this.revert(), this.vars = t2 = t2 || this.vars || {};
            let {
              type: s2 = "chars,words,lines",
              aria: i2 = "auto",
              deepSlice: o2 = true,
              smartWrap: c,
              onSplit: n2,
              autoSplit: a = false,
              specialChars: h,
              mask: b
            } = this.vars, x = s2.indexOf("lines") > -1, g = s2.indexOf("chars") > -1, C2 = s2.indexOf("words") > -1, R2 = g && !C2 && !x, L2 = h && ("push" in h ? new RegExp("(?:" + h.join("|") + ")", "gu") : h), $ = L2 ? new RegExp(L2.source + "|" + Y2.source, "gu") : Y2, q2 = !!t2.ignore && X3(t2.ignore), { orig: j2, animTime: D, obs: E } = this._data, v;
            return (g || C2 || x) && (this.elements.forEach((r2, f) => {
              j2[f] = {
                element: r2,
                html: r2.innerHTML,
                ariaL: r2.getAttribute("aria-label"),
                ariaH: r2.getAttribute("aria-hidden")
              }, i2 === "auto" ? r2.setAttribute("aria-label", (r2.textContent || "").trim()) : i2 === "hidden" && r2.setAttribute("aria-hidden", "true");
              let H2 = [], l2 = [], m = [], y = g ? Q2("char", t2, H2) : null, I2 = Q2("word", t2, l2), d2, u, W2, S;
              if (ie(r2, t2, I2, y, R2, o2 && (x || R2), q2, $, L2, false), x) {
                let O2 = P(r2.childNodes), T2 = ae2(r2, O2, t2, m), F2, w = [], p = 0, k2 = O2.map((M2) => M2.nodeType === 1 ? M2.getBoundingClientRect() : Z2), N2 = Z2;
                for (d2 = 0; d2 < O2.length; d2++)
                  F2 = O2[d2], F2.nodeType === 1 && (F2.nodeName === "BR" ? (w.push(F2), T2(p, d2 + 1), p = d2 + 1, N2 = k2[p]) : (d2 && k2[d2].top > N2.top && k2[d2].left <= N2.left && (T2(p, d2), p = d2), N2 = k2[d2]));
                p < d2 && T2(p, d2), w.forEach((M2) => {
                  var le2;
                  return (le2 = M2.parentNode) == null ? void 0 : le2.removeChild(M2);
                });
              }
              if (!C2) {
                for (d2 = 0; d2 < l2.length; d2++)
                  if (u = l2[d2], g || !u.nextSibling || u.nextSibling.nodeType !== 3)
                    if (c && !x) {
                      for (W2 = document.createElement("span"), W2.style.whiteSpace = "nowrap"; u.firstChild; )
                        W2.appendChild(u.firstChild);
                      u.replaceWith(W2);
                    } else u.replaceWith(...u.childNodes);
                  else
                    S = u.nextSibling, S && S.nodeType === 3 && (S.textContent = (u.textContent || "") + (S.textContent || ""), u.remove());
                l2.length = 0, r2.normalize();
              }
              this.lines.push(...m), this.words.push(...l2), this.chars.push(...H2);
            }), b && this[b] && this.masks.push(
              ...this[b].map((r2) => {
                let f = r2.cloneNode();
                return r2.replaceWith(f), f.appendChild(r2), r2.className && (f.className = r2.className.replace(/(\b\w+\b)/g, "$1-mask")), f.style.overflow = "clip", f;
              })
            )), this.isSplit = true, _ && (a ? _.addEventListener("loadingdone", this._split) : _.status === "loading" && console.warn("SplitText called before fonts loaded")), (v = n2 && n2(this)) && v.totalTime && (this._data.anim = D ? v.totalTime(D) : v), x && a && this.elements.forEach((r2, f) => {
              j2[f].width = r2.offsetWidth, E && E.observe(r2);
            }), this;
          }
          revert() {
            var t2, s2;
            let { orig: i2, anim: o2, obs: c } = this._data;
            return c && c.disconnect(), i2.forEach(({ element: n2, html: a, ariaL: h, ariaH: b }) => {
              n2.innerHTML = a, h ? n2.setAttribute("aria-label", h) : n2.removeAttribute("aria-label"), b ? n2.setAttribute("aria-hidden", b) : n2.removeAttribute("aria-hidden");
            }), this.chars.length = this.words.length = this.lines.length = i2.length = this.masks.length = 0, this.isSplit = false, _ == null || _.removeEventListener("loadingdone", this._split), o2 && (this._data.animTime = o2.totalTime(), o2.revert()), (s2 = (t2 = this.vars).onRevert) == null || s2.call(t2, this), this;
          }
          static create(t2, s2) {
            return new se2(t2, s2);
          }
          static register(t2) {
            A2 = A2 || t2 || window.gsap, A2 && (P = A2.utils.toArray, K2 = A2.core.context || K2), !G2 && window.innerWidth > 0 && (_ = document.fonts, G2 = true);
          }
        };
        ne2.version = "3.13.0";
        let U2 = ne2;
        B2.SplitText = U2, B2.default = U2, Object.defineProperty(B2, "__esModule", { value: true });
        if (typeof window !== "undefined") {
          window.SplitText = U2;
        }
      });
      if (typeof window !== "undefined" && window.SplitText && window.gsap) {
        window.SplitText.register(window.gsap);
      }
    }
  });

  // node_modules/lucide/dist/esm/defaultAttributes.js
  var defaultAttributes;
  var init_defaultAttributes = __esm({
    "node_modules/lucide/dist/esm/defaultAttributes.js"() {
      defaultAttributes = {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": 2,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      };
    }
  });

  // node_modules/lucide/dist/esm/createElement.js
  var createSVGElement, createElement;
  var init_createElement = __esm({
    "node_modules/lucide/dist/esm/createElement.js"() {
      init_defaultAttributes();
      createSVGElement = ([tag, attrs, children]) => {
        const element = document.createElementNS("http://www.w3.org/2000/svg", tag);
        Object.keys(attrs).forEach((name) => {
          element.setAttribute(name, String(attrs[name]));
        });
        if (children?.length) {
          children.forEach((child) => {
            const childElement = createSVGElement(child);
            element.appendChild(childElement);
          });
        }
        return element;
      };
      createElement = (iconNode, customAttrs = {}) => {
        const tag = "svg";
        const attrs = {
          ...defaultAttributes,
          ...customAttrs
        };
        return createSVGElement([tag, attrs, iconNode]);
      };
    }
  });

  // node_modules/lucide/dist/esm/replaceElement.js
  var getAttrs, getClassNames, combineClassNames, toPascalCase, replaceElement;
  var init_replaceElement = __esm({
    "node_modules/lucide/dist/esm/replaceElement.js"() {
      init_createElement();
      init_defaultAttributes();
      getAttrs = (element) => Array.from(element.attributes).reduce((attrs, attr) => {
        attrs[attr.name] = attr.value;
        return attrs;
      }, {});
      getClassNames = (attrs) => {
        if (typeof attrs === "string") return attrs;
        if (!attrs || !attrs.class) return "";
        if (attrs.class && typeof attrs.class === "string") {
          return attrs.class.split(" ");
        }
        if (attrs.class && Array.isArray(attrs.class)) {
          return attrs.class;
        }
        return "";
      };
      combineClassNames = (arrayOfClassnames) => {
        const classNameArray = arrayOfClassnames.flatMap(getClassNames);
        return classNameArray.map((classItem) => classItem.trim()).filter(Boolean).filter((value, index, self2) => self2.indexOf(value) === index).join(" ");
      };
      toPascalCase = (string) => string.replace(/(\w)(\w*)(_|-|\s*)/g, (g0, g1, g2) => g1.toUpperCase() + g2.toLowerCase());
      replaceElement = (element, { nameAttr, icons, attrs }) => {
        const iconName = element.getAttribute(nameAttr);
        if (iconName == null) return;
        const ComponentName = toPascalCase(iconName);
        const iconNode = icons[ComponentName];
        if (!iconNode) {
          return console.warn(
            `${element.outerHTML} icon name was not found in the provided icons object.`
          );
        }
        const elementAttrs = getAttrs(element);
        const iconAttrs = {
          ...defaultAttributes,
          "data-lucide": iconName,
          ...attrs,
          ...elementAttrs
        };
        const classNames = combineClassNames(["lucide", `lucide-${iconName}`, elementAttrs, attrs]);
        if (classNames) {
          Object.assign(iconAttrs, {
            class: classNames
          });
        }
        const svgElement = createElement(iconNode, iconAttrs);
        return element.parentNode?.replaceChild(svgElement, element);
      };
    }
  });

  // node_modules/lucide/dist/esm/icons/arrow-left.js
  var ArrowLeft;
  var init_arrow_left = __esm({
    "node_modules/lucide/dist/esm/icons/arrow-left.js"() {
      ArrowLeft = [
        ["path", { d: "m12 19-7-7 7-7" }],
        ["path", { d: "M19 12H5" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/arrow-right.js
  var ArrowRight;
  var init_arrow_right = __esm({
    "node_modules/lucide/dist/esm/icons/arrow-right.js"() {
      ArrowRight = [
        ["path", { d: "M5 12h14" }],
        ["path", { d: "m12 5 7 7-7 7" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/check.js
  var Check;
  var init_check = __esm({
    "node_modules/lucide/dist/esm/icons/check.js"() {
      Check = [["path", { d: "M20 6 9 17l-5-5" }]];
    }
  });

  // node_modules/lucide/dist/esm/icons/chevron-down.js
  var ChevronDown;
  var init_chevron_down = __esm({
    "node_modules/lucide/dist/esm/icons/chevron-down.js"() {
      ChevronDown = [["path", { d: "m6 9 6 6 6-6" }]];
    }
  });

  // node_modules/lucide/dist/esm/icons/chevron-left.js
  var ChevronLeft;
  var init_chevron_left = __esm({
    "node_modules/lucide/dist/esm/icons/chevron-left.js"() {
      ChevronLeft = [["path", { d: "m15 18-6-6 6-6" }]];
    }
  });

  // node_modules/lucide/dist/esm/icons/chevron-right.js
  var ChevronRight;
  var init_chevron_right = __esm({
    "node_modules/lucide/dist/esm/icons/chevron-right.js"() {
      ChevronRight = [["path", { d: "m9 18 6-6-6-6" }]];
    }
  });

  // node_modules/lucide/dist/esm/icons/circle-alert.js
  var CircleAlert;
  var init_circle_alert = __esm({
    "node_modules/lucide/dist/esm/icons/circle-alert.js"() {
      CircleAlert = [
        ["circle", { cx: "12", cy: "12", r: "10" }],
        ["line", { x1: "12", x2: "12", y1: "8", y2: "12" }],
        ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/circle-check.js
  var CircleCheck;
  var init_circle_check = __esm({
    "node_modules/lucide/dist/esm/icons/circle-check.js"() {
      CircleCheck = [
        ["circle", { cx: "12", cy: "12", r: "10" }],
        ["path", { d: "m9 12 2 2 4-4" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/gift.js
  var Gift;
  var init_gift = __esm({
    "node_modules/lucide/dist/esm/icons/gift.js"() {
      Gift = [
        ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1" }],
        ["path", { d: "M12 8v13" }],
        ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" }],
        ["path", { d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/grid-2x2.js
  var Grid2x2;
  var init_grid_2x2 = __esm({
    "node_modules/lucide/dist/esm/icons/grid-2x2.js"() {
      Grid2x2 = [
        ["path", { d: "M12 3v18" }],
        ["path", { d: "M3 12h18" }],
        ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/grid-3x3.js
  var Grid3x3;
  var init_grid_3x3 = __esm({
    "node_modules/lucide/dist/esm/icons/grid-3x3.js"() {
      Grid3x3 = [
        ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }],
        ["path", { d: "M3 9h18" }],
        ["path", { d: "M3 15h18" }],
        ["path", { d: "M9 3v18" }],
        ["path", { d: "M15 3v18" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/image.js
  var Image;
  var init_image = __esm({
    "node_modules/lucide/dist/esm/icons/image.js"() {
      Image = [
        ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
        ["circle", { cx: "9", cy: "9", r: "2" }],
        ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/info.js
  var Info;
  var init_info = __esm({
    "node_modules/lucide/dist/esm/icons/info.js"() {
      Info = [
        ["circle", { cx: "12", cy: "12", r: "10" }],
        ["path", { d: "M12 16v-4" }],
        ["path", { d: "M12 8h.01" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/menu.js
  var Menu;
  var init_menu = __esm({
    "node_modules/lucide/dist/esm/icons/menu.js"() {
      Menu = [
        ["path", { d: "M4 5h16" }],
        ["path", { d: "M4 12h16" }],
        ["path", { d: "M4 19h16" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/move-left.js
  var MoveLeft;
  var init_move_left = __esm({
    "node_modules/lucide/dist/esm/icons/move-left.js"() {
      MoveLeft = [
        ["path", { d: "M6 8L2 12L6 16" }],
        ["path", { d: "M2 12H22" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/move-right.js
  var MoveRight;
  var init_move_right = __esm({
    "node_modules/lucide/dist/esm/icons/move-right.js"() {
      MoveRight = [
        ["path", { d: "M18 8L22 12L18 16" }],
        ["path", { d: "M2 12H22" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/search-x.js
  var SearchX;
  var init_search_x = __esm({
    "node_modules/lucide/dist/esm/icons/search-x.js"() {
      SearchX = [
        ["path", { d: "m13.5 8.5-5 5" }],
        ["path", { d: "m8.5 8.5 5 5" }],
        ["circle", { cx: "11", cy: "11", r: "8" }],
        ["path", { d: "m21 21-4.3-4.3" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/search.js
  var Search;
  var init_search = __esm({
    "node_modules/lucide/dist/esm/icons/search.js"() {
      Search = [
        ["path", { d: "m21 21-4.34-4.34" }],
        ["circle", { cx: "11", cy: "11", r: "8" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/shopping-bag.js
  var ShoppingBag;
  var init_shopping_bag = __esm({
    "node_modules/lucide/dist/esm/icons/shopping-bag.js"() {
      ShoppingBag = [
        ["path", { d: "M16 10a4 4 0 0 1-8 0" }],
        ["path", { d: "M3.103 6.034h17.794" }],
        [
          "path",
          {
            d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"
          }
        ]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/tag.js
  var Tag;
  var init_tag = __esm({
    "node_modules/lucide/dist/esm/icons/tag.js"() {
      Tag = [
        [
          "path",
          {
            d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"
          }
        ],
        ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/trash-2.js
  var Trash2;
  var init_trash_2 = __esm({
    "node_modules/lucide/dist/esm/icons/trash-2.js"() {
      Trash2 = [
        ["path", { d: "M10 11v6" }],
        ["path", { d: "M14 11v6" }],
        ["path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }],
        ["path", { d: "M3 6h18" }],
        ["path", { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/truck.js
  var Truck;
  var init_truck = __esm({
    "node_modules/lucide/dist/esm/icons/truck.js"() {
      Truck = [
        ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" }],
        ["path", { d: "M15 18H9" }],
        [
          "path",
          { d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" }
        ],
        ["circle", { cx: "17", cy: "18", r: "2" }],
        ["circle", { cx: "7", cy: "18", r: "2" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/user.js
  var User;
  var init_user = __esm({
    "node_modules/lucide/dist/esm/icons/user.js"() {
      User = [
        ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }],
        ["circle", { cx: "12", cy: "7", r: "4" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/icons/x.js
  var X2;
  var init_x = __esm({
    "node_modules/lucide/dist/esm/icons/x.js"() {
      X2 = [
        ["path", { d: "M18 6 6 18" }],
        ["path", { d: "m6 6 12 12" }]
      ];
    }
  });

  // node_modules/lucide/dist/esm/lucide.js
  var createIcons;
  var init_lucide = __esm({
    "node_modules/lucide/dist/esm/lucide.js"() {
      init_replaceElement();
      init_arrow_left();
      init_arrow_right();
      init_check();
      init_chevron_down();
      init_chevron_left();
      init_chevron_right();
      init_circle_alert();
      init_circle_check();
      init_gift();
      init_grid_2x2();
      init_grid_3x3();
      init_image();
      init_info();
      init_menu();
      init_move_left();
      init_move_right();
      init_search_x();
      init_search();
      init_shopping_bag();
      init_tag();
      init_trash_2();
      init_truck();
      init_user();
      init_x();
      createIcons = ({
        icons = {},
        nameAttr = "data-lucide",
        attrs = {},
        root = document,
        inTemplates
      } = {}) => {
        if (!Object.values(icons).length) {
          throw new Error(
            "Please provide an icons object.\nIf you want to use all the icons you can import it like:\n `import { createIcons, icons } from 'lucide';\nlucide.createIcons({icons});`"
          );
        }
        if (typeof root === "undefined") {
          throw new Error("`createIcons()` only works in a browser environment.");
        }
        const elementsToReplace = Array.from(root.querySelectorAll(`[${nameAttr}]`));
        elementsToReplace.forEach((element) => replaceElement(element, { nameAttr, icons, attrs }));
        if (inTemplates) {
          const templates = Array.from(root.querySelectorAll("template"));
          templates.forEach(
            (template) => createIcons({
              icons,
              nameAttr,
              attrs,
              root: template.content,
              inTemplates
            })
          );
        }
        if (nameAttr === "data-lucide") {
          const deprecatedElements = root.querySelectorAll("[icon-name]");
          if (deprecatedElements.length > 0) {
            console.warn(
              "[Lucide] Some icons were found with the now deprecated icon-name attribute. These will still be replaced for backwards compatibility, but will no longer be supported in v1.0 and you should switch to data-lucide"
            );
            Array.from(deprecatedElements).forEach(
              (element) => replaceElement(element, { nameAttr: "icon-name", icons, attrs })
            );
          }
        }
      };
    }
  });

  // assets-src/js/_c_lucide-icons.js
  function initLucide() {
    createIcons({
      icons: {
        AlertCircle: CircleAlert,
        ArrowRight,
        ArrowLeft,
        Check,
        ChevronDown,
        ChevronRight,
        ChevronLeft,
        CircleCheck,
        Gift,
        Grid2X2: Grid2x2,
        Grid3X3: Grid3x3,
        Image,
        Info,
        Menu,
        MoveLeft,
        MoveRight,
        Search,
        SearchX,
        ShoppingBag,
        Tag,
        Trash2,
        Truck,
        User,
        X: X2
      },
      attrs: {
        "stroke-width": "1"
        // Default is 2
      }
    });
  }
  var init_c_lucide_icons = __esm({
    "assets-src/js/_c_lucide-icons.js"() {
      init_lucide();
    }
  });

  // assets-src/js/_c_cart-free-shipping.js
  function showFreeShippingNotification(message) {
    const cartPanel = document.querySelector("el-dialog-panel");
    if (!cartPanel) return;
    const notification = document.createElement("div");
    notification.className = "absolute top-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 rounded-lg bg-emerald-600 px-5 py-2.5 text-white shadow-lg transition-all duration-300 ease-in-out max-w-xl";
    notification.style.transform = "translateY(-100px)";
    notification.style.opacity = "0";
    notification.innerHTML = `
    <i class="size-5 shrink-0" data-lucide="truck"></i>
    <span class="font-medium">${message}</span>
  `;
    cartPanel.appendChild(notification);
    initLucide();
    requestAnimationFrame(() => {
      notification.style.transform = "translateY(0)";
      notification.style.opacity = "1";
    });
    setTimeout(() => {
      notification.style.opacity = "0";
      notification.style.transform = "translateY(-100px)";
      setTimeout(() => notification.remove(), 300);
    }, 5e3);
  }
  function updateFreeShipping(parsedDoc, cartItemCount, cartTotalPrice = null) {
    const currentFreeShipping = document.querySelector(".cart-free-shipping");
    if (!currentFreeShipping) {
      return;
    }
    const thresholdCents = parseInt(currentFreeShipping.dataset.threshold) * 100;
    const showNotification = currentFreeShipping.dataset.showNotification === "true";
    const notificationMessage = currentFreeShipping.dataset.notificationMessage || "Your order qualifies for free shipping!";
    const successMessage = currentFreeShipping.dataset.successMessage || "Congratulations! Your order qualifies for free shipping!";
    if (cartTotalPrice !== null) {
      const totalDollars = cartTotalPrice / 100;
      const progress = Math.min(100, totalDollars * 100 / (thresholdCents / 100));
      const neededAmount = Math.max(0, thresholdCents / 100 - totalDollars);
      const qualified = progress >= 100;
      const progressBar = currentFreeShipping.querySelector('[style*="width"]');
      if (progressBar) {
        progressBar.style.width = `${progress}%`;
      }
      const messageContainer = currentFreeShipping.querySelector(".text-xs.font-medium.text-emerald-900");
      if (messageContainer) {
        if (qualified) {
          messageContainer.textContent = successMessage;
        } else {
          const formattedAmount = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD"
          }).format(neededAmount);
          messageContainer.textContent = `Add ${formattedAmount} more to qualify for free shipping`;
        }
      }
      if (qualified && !previouslyQualified && showNotification && cartItemCount > 0) {
        showFreeShippingNotification(notificationMessage);
      }
      previouslyQualified = qualified;
      currentFreeShipping.dataset.total = totalDollars.toString();
      currentFreeShipping.dataset.progress = progress.toString();
    } else {
      const newFreeShipping = parsedDoc.querySelector(".cart-free-shipping");
      if (newFreeShipping) {
        currentFreeShipping.innerHTML = newFreeShipping.innerHTML;
        currentFreeShipping.dataset.total = newFreeShipping.dataset.total;
        currentFreeShipping.dataset.threshold = newFreeShipping.dataset.threshold;
        currentFreeShipping.dataset.progress = newFreeShipping.dataset.progress;
      }
    }
    if (cartItemCount === 0) {
      currentFreeShipping.classList.add("hidden");
      previouslyQualified = false;
    } else {
      currentFreeShipping.classList.remove("hidden");
    }
  }
  var previouslyQualified;
  var init_c_cart_free_shipping = __esm({
    "assets-src/js/_c_cart-free-shipping.js"() {
      init_c_lucide_icons();
      previouslyQualified = false;
    }
  });

  // assets-src/js/_c_cart-discounts.js
  function getAutomaticDiscounts(cartData) {
    const discounts = [];
    if (cartData.discount_applications) {
      const cartLevelDiscounts = cartData.discount_applications.filter(
        (discount) => discount.type === "automatic" || discount.type === ""
      );
      discounts.push(...cartLevelDiscounts);
    }
    const lineLevelDiscounts = /* @__PURE__ */ new Map();
    if (cartData.items) {
      cartData.items.forEach((item) => {
        if (item.line_level_discount_allocations) {
          item.line_level_discount_allocations.forEach((allocation) => {
            const discount = allocation.discount_application;
            if (discount.type === "automatic" || discount.type === "") {
              if (lineLevelDiscounts.has(discount.key)) {
                const existing = lineLevelDiscounts.get(discount.key);
                existing.total_allocated_amount += discount.total_allocated_amount;
              } else {
                lineLevelDiscounts.set(discount.key, { ...discount });
              }
            }
          });
        }
      });
    }
    discounts.push(...Array.from(lineLevelDiscounts.values()));
    return discounts;
  }
  function formatDiscountValue(discount) {
    if (discount.value_type === "percentage") {
      return `${discount.value}% off`;
    } else if (discount.value_type === "fixed_amount") {
      const amount = (discount.value / 100).toFixed(2);
      return `$${amount} off`;
    }
    return "";
  }
  function updateDiscountDisplay(cartData) {
    const container = document.querySelector(".cart-discounts-container");
    if (!container) return;
    const automaticDiscounts = getAutomaticDiscounts(cartData);
    if (automaticDiscounts.length > 0) {
      const html = automaticDiscounts.map((discount) => {
        const formattedValue = formatDiscountValue(discount);
        return `
        <div class="flex items-center justify-between rounded-lg bg-emerald-50 px-3 py-2 text-sm">
          <div class="flex items-center gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-emerald-600">
              <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
              <line x1="7" y1="7" x2="7.01" y2="7"></line>
            </svg>
            <span class="font-medium text-emerald-900">${discount.title}</span>
          </div>
          <span class="font-semibold text-emerald-600">${formattedValue}</span>
        </div>
      `;
      }).join("");
      container.innerHTML = html;
      container.classList.remove("hidden");
    } else {
      container.innerHTML = "";
      container.classList.add("hidden");
    }
  }
  var init_c_cart_discounts = __esm({
    "assets-src/js/_c_cart-discounts.js"() {
    }
  });

  // assets-src/js/_c_cart.js
  var c_cart_exports = {};
  __export(c_cart_exports, {
    initCart: () => initCart,
    updateCartUI: () => updateCartUI
  });
  function initCart() {
    const quantitySelectors = document.querySelectorAll(".cart-quantity-selector");
    quantitySelectors.forEach((select) => {
      select.addEventListener("change", handleQuantityChange);
    });
    const removeButtons = document.querySelectorAll(".cart-remove-item");
    removeButtons.forEach((button) => {
      button.addEventListener("click", handleRemoveItem);
    });
  }
  async function handleQuantityChange(event2) {
    const select = event2.target;
    const lineIndex = parseInt(select.dataset.lineIndex);
    const quantity = parseInt(select.value);
    const payload = {
      line: lineIndex,
      quantity
    };
    console.log("Updating cart with payload:", payload);
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      console.log("Response status:", response.status);
      console.log("Response data:", data);
      if (response.ok) {
        await updateCartUI(data);
      } else {
        console.error("Failed to update cart:", data);
        select.selectedIndex = select.dataset.previousIndex || 0;
      }
    } catch (error) {
      console.error("Error updating cart:", error);
      select.selectedIndex = select.dataset.previousIndex || 0;
    }
  }
  async function handleRemoveItem(event2) {
    const button = event2.currentTarget;
    const lineIndex = parseInt(button.dataset.lineIndex);
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          line: lineIndex,
          quantity: 0
        })
      });
      if (response.ok) {
        const data = await response.json();
        await updateCartUI(data);
      } else {
        console.error("Failed to remove item");
      }
    } catch (error) {
      console.error("Error removing item:", error);
    }
  }
  async function updateCartUI(cartData) {
    const cartCountElements = document.querySelectorAll(".cart-count");
    cartCountElements.forEach((el) => {
      el.textContent = cartData.item_count;
    });
    const currentCartContent = document.querySelector(".cart-items-container");
    if (cartData.item_count === 0 && currentCartContent) {
      const emptyMessage = currentCartContent.dataset.emptyMessage || "Your cart is currently empty.";
      const collectionHandles = currentCartContent.dataset.collections?.split(",").filter(Boolean) || [];
      if (collectionHandles.length > 0) {
        try {
          const collectionPromises = collectionHandles.map(
            (handle) => fetch(`/collections/${handle}.json`).then((r2) => r2.json())
          );
          const collections = await Promise.all(collectionPromises);
          currentCartContent.innerHTML = renderEmptyCartWithCollections(emptyMessage, collections);
          initLucide();
        } catch (error) {
          console.error("Error fetching collections:", error);
          currentCartContent.innerHTML = `<div class="cart-empty-state"><p class="text-sm text-neutral-500">${emptyMessage}</p></div>`;
        }
      } else {
        currentCartContent.innerHTML = `<div class="cart-empty-state"><p class="text-sm text-neutral-500">${emptyMessage}</p></div>`;
      }
    } else if (currentCartContent) {
      const isDrawer = document.getElementById("cart-drawer") !== null;
      const sectionId = isDrawer ? "cart-drawer" : "cart";
      const response = await fetch(`/?section_id=${sectionId}`);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newCartContent = doc.querySelector(".cart-items-container");
      if (newCartContent) {
        currentCartContent.innerHTML = newCartContent.innerHTML;
      }
      const newSubtotal = doc.querySelector(".cart-subtotal");
      const currentSubtotal = document.querySelector(".cart-subtotal");
      if (newSubtotal && currentSubtotal) {
        currentSubtotal.textContent = newSubtotal.textContent;
      }
      updateFreeShipping(doc, cartData.item_count, cartData.total_price);
      updateDiscountDisplay(cartData);
      initCart();
      initLucide();
    }
    const checkoutButton = document.querySelector(".checkout-button");
    if (checkoutButton) {
      checkoutButton.disabled = cartData.item_count === 0;
    }
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: cartData }));
  }
  function renderEmptyCartWithCollections(message, collections) {
    let html = `<div class="cart-empty-state"><p class="text-sm text-neutral-500">${message}</p>`;
    if (collections.length > 0) {
      html += '<h3 class="mt-6 text-2xl font-bold">Check out these great collections!</h3>';
      html += '<ul role="list" class="divide-y divide-gray-200">';
      collections.forEach((data) => {
        const collection = data.collection || data;
        const imageUrl = collection.image?.src || "";
        const description = collection.body_html ? collection.body_html.replace(/<[^>]*>/g, "").split(" ").slice(0, 11).join(" ") : "";
        html += `
        <li class="py-4">
          <a href="/collections/${collection.handle}" class="group grid grid-cols-12 gap-6">
            <div class="col-span-4">
              ${imageUrl ? `<img src="${imageUrl}" alt="${collection.title}" class="aspect-square w-full rounded-lg object-cover group-hover:opacity-75 transition-opacity duration-300 ease-in-out" />` : '<div class="aspect-3/2 w-full rounded-lg bg-neutral-200 lg:aspect-5/6"></div>'}
            </div>
            <div class="col-span-6 flex flex-col items-start justify-center">
              <h3 class="text-base font-semibold text-neutral-900">${collection.title}</h3>
              ${description ? `<div class="prose mt-2 text-xs text-neutral-500">${description}</div>` : ""}
            </div>
            <div class="col-span-2 flex items-center justify-end">
              <div class="flex size-8 items-center justify-center rounded-full bg-emerald-600 text-emerald-50 transition-colors duration-300 ease-in-out group-hover:bg-emerald-500 group-hover:text-emerald-100">
                <i class="size-5" data-lucide="chevron-right"></i>
              </div>
            </div>
          </a>
        </li>
      `;
      });
      html += "</ul>";
    }
    html += "</div>";
    return html;
  }
  var init_c_cart = __esm({
    "assets-src/js/_c_cart.js"() {
      init_c_lucide_icons();
      init_c_cart_free_shipping();
      init_c_cart_discounts();
    }
  });

  // node_modules/@tailwindplus/elements/dist/index.js
  var Pn = Object.defineProperty;
  var To = (e2) => {
    throw TypeError(e2);
  };
  var kn = (e2, o2, t2) => o2 in e2 ? Pn(e2, o2, { enumerable: true, configurable: true, writable: true, value: t2 }) : e2[o2] = t2;
  var M = (e2, o2, t2) => kn(e2, typeof o2 != "symbol" ? o2 + "" : o2, t2);
  var Ct = (e2, o2, t2) => o2.has(e2) || To("Cannot " + t2);
  var d = (e2, o2, t2) => (Ct(e2, o2, "read from private field"), t2 ? t2.call(e2) : o2.get(e2));
  var L = (e2, o2, t2) => o2.has(e2) ? To("Cannot add the same private member more than once") : o2 instanceof WeakSet ? o2.add(e2) : o2.set(e2, t2);
  var I = (e2, o2, t2, n2) => (Ct(e2, o2, "write to private field"), n2 ? n2.call(e2, t2) : o2.set(e2, t2), t2);
  var H = (e2, o2, t2) => (Ct(e2, o2, "access private method"), t2);
  if (typeof globalThis.window < "u") {
    let e2 = false;
    document.addEventListener("submit", (o2) => {
      if (e2) {
        e2 = false;
        return;
      }
      let t2 = o2.target;
      if (t2 && t2.method === "dialog") {
        let n2 = t2.closest("el-dialog");
        if (!n2 || !("beforeClose" in n2)) return;
        let r2 = n2.beforeClose();
        if (r2 === true || (o2.preventDefault(), o2.stopImmediatePropagation(), r2 === false)) return;
        r2.then((i2) => {
          i2 && (e2 = true, t2.dispatchEvent(o2));
        }).catch(console.error);
      }
    }, true);
  }
  var at = class extends Event {
    constructor(o2, { oldState: t2 = "", newState: n2 = "", ...r2 } = {}) {
      super(o2, r2);
      M(this, "oldState");
      M(this, "newState");
      this.oldState = String(t2 || ""), this.newState = String(n2 || "");
    }
  };
  var So = /* @__PURE__ */ new WeakMap();
  function Do(e2, o2, t2) {
    So.set(e2, setTimeout(() => {
      So.has(e2) && e2.dispatchEvent(new at("toggle", { cancelable: false, oldState: o2, newState: t2 }));
    }, 0));
  }
  var Nt = globalThis.ShadowRoot || function() {
  };
  var On = globalThis.HTMLDialogElement || function() {
  };
  var rt = /* @__PURE__ */ new WeakMap();
  var X = /* @__PURE__ */ new WeakMap();
  var q = /* @__PURE__ */ new WeakMap();
  var xe = /* @__PURE__ */ new WeakMap();
  function it(e2) {
    return xe.get(e2) || "hidden";
  }
  var st = /* @__PURE__ */ new WeakMap();
  function qe(e2) {
    return [...e2].pop();
  }
  function Cn(e2) {
    let o2 = e2.popoverTargetElement;
    if (!(o2 instanceof HTMLElement)) return;
    let t2 = it(o2);
    e2.popoverTargetAction === "show" && t2 === "showing" || e2.popoverTargetAction === "hide" && t2 === "hidden" || (t2 === "showing" ? Se(o2, true, true) : pe(o2, false) && (st.set(o2, e2), Rt(o2)));
  }
  function pe(e2, o2) {
    return !(e2.popover !== "auto" && e2.popover !== "manual" && e2.popover !== "hint" || !e2.isConnected || o2 && it(e2) !== "showing" || !o2 && it(e2) !== "hidden" || e2 instanceof On && e2.hasAttribute("open") || document.fullscreenElement === e2);
  }
  function Lo(e2) {
    if (!e2) return 0;
    let o2 = X.get(document) || /* @__PURE__ */ new Set(), t2 = q.get(document) || /* @__PURE__ */ new Set();
    return t2.has(e2) ? [...t2].indexOf(e2) + o2.size + 1 : o2.has(e2) ? [...o2].indexOf(e2) + 1 : 0;
  }
  function Dn(e2) {
    let o2 = Mo(e2), t2 = Mn(e2);
    return Lo(o2) > Lo(t2) ? o2 : t2;
  }
  function Ve(e2) {
    let o2, t2 = q.get(e2) || /* @__PURE__ */ new Set(), n2 = X.get(e2) || /* @__PURE__ */ new Set(), r2 = t2.size > 0 ? t2 : n2.size > 0 ? n2 : null;
    return r2 ? (o2 = qe(r2), o2.isConnected ? o2 : (r2.delete(o2), Ve(e2))) : null;
  }
  function Io(e2) {
    for (let o2 of e2 || []) if (!o2.isConnected) e2.delete(o2);
    else return o2;
    return null;
  }
  function Te(e2) {
    return typeof e2.getRootNode == "function" ? e2.getRootNode() : e2.parentNode ? Te(e2.parentNode) : e2;
  }
  function Mo(e2) {
    for (; e2; ) {
      if (e2 instanceof HTMLElement && e2.popover === "auto" && xe.get(e2) === "showing") return e2;
      if (e2 = e2 instanceof Element && e2.assignedSlot || e2.parentElement || Te(e2), e2 instanceof Nt && (e2 = e2.host), e2 instanceof Document) return;
    }
  }
  function Mn(e2) {
    for (; e2; ) {
      let o2 = e2.popoverTargetElement;
      if (o2 instanceof HTMLElement) return o2;
      if (e2 = e2.parentElement || Te(e2), e2 instanceof Nt && (e2 = e2.host), e2 instanceof Document) return;
    }
  }
  function Po(e2, o2) {
    let t2 = /* @__PURE__ */ new Map(), n2 = 0;
    for (let s2 of o2 || []) t2.set(s2, n2), n2 += 1;
    t2.set(e2, n2), n2 += 1;
    let r2 = null;
    function i2(s2) {
      if (!s2) return;
      let a = false, l2 = null, u = null;
      for (; !a; ) {
        if (l2 = Mo(s2) || null, l2 === null || !t2.has(l2)) return;
        (e2.popover === "hint" || l2.popover === "auto") && (a = true), a || (s2 = l2.parentElement);
      }
      u = t2.get(l2), (r2 === null || t2.get(r2) < u) && (r2 = l2);
    }
    return i2(e2.parentElement || Te(e2)), r2;
  }
  function Hn(e2) {
    return e2.hidden || e2 instanceof Nt || (e2 instanceof HTMLButtonElement || e2 instanceof HTMLInputElement || e2 instanceof HTMLSelectElement || e2 instanceof HTMLTextAreaElement || e2 instanceof HTMLOptGroupElement || e2 instanceof HTMLOptionElement || e2 instanceof HTMLFieldSetElement) && e2.disabled || e2 instanceof HTMLInputElement && e2.type === "hidden" || e2 instanceof HTMLAnchorElement && e2.href === "" ? false : typeof e2.tabIndex == "number" && e2.tabIndex !== -1;
  }
  function Rn(e2) {
    if (e2.shadowRoot && e2.shadowRoot.delegatesFocus !== true) return null;
    let o2 = e2;
    o2.shadowRoot && (o2 = o2.shadowRoot);
    let t2 = o2.querySelector("[autofocus]");
    if (t2) return t2;
    {
      let i2 = o2.querySelectorAll("slot");
      for (let s2 of i2) {
        let a = s2.assignedElements({ flatten: true });
        for (let l2 of a) {
          if (l2.hasAttribute("autofocus")) return l2;
          if (t2 = l2.querySelector("[autofocus]"), t2) return t2;
        }
      }
    }
    let n2 = e2.ownerDocument.createTreeWalker(o2, NodeFilter.SHOW_ELEMENT), r2 = n2.currentNode;
    for (; r2; ) {
      if (Hn(r2)) return r2;
      r2 = n2.nextNode();
    }
  }
  function Bn(e2) {
    var o2;
    (o2 = Rn(e2)) == null || o2.focus();
  }
  var lt = /* @__PURE__ */ new WeakMap();
  function Rt(e2) {
    if (!pe(e2, false)) return;
    let o2 = e2.ownerDocument;
    if (!e2.dispatchEvent(new at("beforetoggle", { cancelable: true, oldState: "closed", newState: "open" })) || !pe(e2, false)) return;
    let t2 = false, n2 = e2.popover, r2 = null, i2 = Po(e2, X.get(o2) || /* @__PURE__ */ new Set()), s2 = Po(e2, q.get(o2) || /* @__PURE__ */ new Set());
    if (n2 === "auto" && (Bt(q.get(o2) || /* @__PURE__ */ new Set(), t2, true), me(i2 || o2, t2, true), r2 = "auto"), n2 === "hint" && (s2 ? (me(s2, t2, true), r2 = "hint") : (Bt(q.get(o2) || /* @__PURE__ */ new Set(), t2, true), i2 ? (me(i2, t2, true), r2 = "auto") : r2 = "hint")), n2 === "auto" || n2 === "hint") {
      if (n2 !== e2.popover || !pe(e2, false)) return;
      Ve(o2) || (t2 = true), r2 === "auto" ? (X.has(o2) || X.set(o2, /* @__PURE__ */ new Set()), X.get(o2).add(e2)) : r2 === "hint" && (q.has(o2) || q.set(o2, /* @__PURE__ */ new Set()), q.get(o2).add(e2));
    }
    lt.delete(e2);
    let a = o2.activeElement;
    e2.classList.add(":popover-open"), xe.set(e2, "showing"), rt.has(o2) || rt.set(o2, /* @__PURE__ */ new Set()), rt.get(o2).add(e2), Ho(st.get(e2), true), Bn(e2), t2 && a && e2.popover === "auto" && lt.set(e2, a), Do(e2, "closed", "open");
  }
  function Se(e2, o2 = false, t2 = false) {
    var n2, r2;
    if (!pe(e2, true)) return;
    let i2 = e2.ownerDocument;
    if (["auto", "hint"].includes(e2.popover) && (me(e2, o2, t2), !pe(e2, true))) return;
    let s2 = X.get(i2) || /* @__PURE__ */ new Set(), a = s2.has(e2) && qe(s2) === e2;
    if (Ho(st.get(e2), false), st.delete(e2), t2 && (e2.dispatchEvent(new at("beforetoggle", { oldState: "open", newState: "closed" })), a && qe(s2) !== e2 && me(e2, o2, t2), !pe(e2, true))) return;
    (n2 = rt.get(i2)) == null || n2.delete(e2), s2.delete(e2), (r2 = q.get(i2)) == null || r2.delete(e2), e2.classList.remove(":popover-open"), xe.set(e2, "hidden"), t2 && Do(e2, "open", "closed");
    let l2 = lt.get(e2);
    l2 && (lt.delete(e2), o2 && l2.focus());
  }
  function Nn(e2, o2 = false, t2 = false) {
    let n2 = Ve(e2);
    for (; n2; ) Se(n2, o2, t2), n2 = Ve(e2);
  }
  function Bt(e2, o2 = false, t2 = false) {
    let n2 = Io(e2);
    for (; n2; ) Se(n2, o2, t2), n2 = Io(e2);
  }
  function ko(e2, o2, t2, n2) {
    let r2 = false, i2 = false;
    for (; r2 || !i2; ) {
      i2 = true;
      let s2 = null, a = false;
      for (let l2 of o2) if (l2 === e2) a = true;
      else if (a) {
        s2 = l2;
        break;
      }
      if (!s2) return;
      for (; it(s2) === "showing" && o2.size; ) Se(qe(o2), t2, n2);
      o2.has(e2) && qe(o2) !== e2 && (r2 = true), r2 && (n2 = false);
    }
  }
  function me(e2, o2, t2) {
    var n2, r2;
    let i2 = e2.ownerDocument || e2;
    if (e2 instanceof Document) return Nn(i2, o2, t2);
    if ((n2 = q.get(i2)) != null && n2.has(e2)) {
      ko(e2, q.get(i2), o2, t2);
      return;
    }
    Bt(q.get(i2) || /* @__PURE__ */ new Set(), o2, t2), (r2 = X.get(i2)) != null && r2.has(e2) && ko(e2, X.get(i2), o2, t2);
  }
  var Dt = /* @__PURE__ */ new WeakMap();
  function Oo(e2) {
    if (!e2.isTrusted) return;
    let o2 = e2.composedPath()[0];
    if (!o2) return;
    let t2 = o2.ownerDocument;
    if (!Ve(t2)) return;
    let r2 = Dn(o2);
    if (r2 && e2.type === "pointerdown") Dt.set(t2, r2);
    else if (e2.type === "pointerup") {
      let i2 = Dt.get(t2) === r2;
      Dt.delete(t2), i2 && me(r2 || t2, false, true);
    }
  }
  var Mt = /* @__PURE__ */ new WeakMap();
  function Ho(e2, o2 = false) {
    if (!e2) return;
    Mt.has(e2) || Mt.set(e2, e2.getAttribute("aria-expanded"));
    let t2 = e2.popoverTargetElement;
    if (t2 instanceof HTMLElement && t2.popover === "auto") e2.setAttribute("aria-expanded", String(o2));
    else {
      let n2 = Mt.get(e2);
      n2 ? e2.setAttribute("aria-expanded", n2) : e2.removeAttribute("aria-expanded");
    }
  }
  var Co = globalThis.ShadowRoot || function() {
  };
  function Ro() {
    return typeof HTMLElement < "u" && typeof HTMLElement.prototype == "object" && "popover" in HTMLElement.prototype;
  }
  function de(e2, o2, t2) {
    let n2 = e2[o2];
    Object.defineProperty(e2, o2, { value(r2) {
      return n2.call(this, t2(r2));
    } });
  }
  var Fn = /(^|[^\\]):popover-open\b/g;
  function qn() {
    return typeof globalThis.CSSLayerBlockRule == "function";
  }
  function Vn() {
    let e2 = qn();
    return `
${e2 ? "@layer popover-polyfill {" : ""}
  :where([popover]) {
    position: fixed;
    z-index: 2147483647;
    inset: 0;
    padding: 0.25em;
    width: fit-content;
    height: fit-content;
    border-width: initial;
    border-color: initial;
    border-image: initial;
    border-style: solid;
    background-color: canvas;
    color: canvastext;
    overflow: auto;
    margin: auto;
  }

  :where([popover]:not(.\\:popover-open)) {
    display: none;
  }

  :where(dialog[popover].\\:popover-open) {
    display: block;
  }

  :where(dialog[popover][open]) {
    display: revert;
  }

  :where([anchor].\\:popover-open) {
    inset: auto;
  }

  :where([anchor]:popover-open) {
    inset: auto;
  }

  @supports not (background-color: canvas) {
    :where([popover]) {
      background-color: white;
      color: black;
    }
  }

  @supports (width: -moz-fit-content) {
    :where([popover]) {
      width: -moz-fit-content;
      height: -moz-fit-content;
    }
  }

  @supports not (inset: 0) {
    :where([popover]) {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
${e2 ? "}" : ""}
`;
  }
  var Ae = null;
  function Ht(e2) {
    let o2 = Vn();
    if (Ae === null) try {
      Ae = new CSSStyleSheet(), Ae.replaceSync(o2);
    } catch {
      Ae = false;
    }
    if (Ae === false) {
      let t2 = document.createElement("style");
      t2.textContent = o2, e2 instanceof Document ? e2.head.prepend(t2) : e2.prepend(t2);
    } else e2.adoptedStyleSheets = [Ae, ...e2.adoptedStyleSheets];
  }
  function Bo() {
    if (typeof window > "u") return;
    window.ToggleEvent = window.ToggleEvent || at;
    function e2(l2) {
      return l2?.includes(":popover-open") && (l2 = l2.replace(Fn, "$1.\\:popover-open")), l2;
    }
    de(Document.prototype, "querySelector", e2), de(Document.prototype, "querySelectorAll", e2), de(Element.prototype, "querySelector", e2), de(Element.prototype, "querySelectorAll", e2), de(Element.prototype, "matches", e2), de(Element.prototype, "closest", e2), de(DocumentFragment.prototype, "querySelectorAll", e2), Object.defineProperties(HTMLElement.prototype, { popover: { enumerable: true, configurable: true, get() {
      if (!this.hasAttribute("popover")) return null;
      let l2 = (this.getAttribute("popover") || "").toLowerCase();
      return l2 === "" || l2 == "auto" ? "auto" : l2 == "hint" ? "hint" : "manual";
    }, set(l2) {
      l2 === null ? this.removeAttribute("popover") : this.setAttribute("popover", l2);
    } }, showPopover: { enumerable: true, configurable: true, value(l2 = {}) {
      Rt(this);
    } }, hidePopover: { enumerable: true, configurable: true, value() {
      Se(this, true, true);
    } }, togglePopover: { enumerable: true, configurable: true, value(l2 = {}) {
      return typeof l2 == "boolean" && (l2 = { force: l2 }), xe.get(this) === "showing" && l2.force === void 0 || l2.force === false ? Se(this, true, true) : (l2.force === void 0 || l2.force === true) && Rt(this), xe.get(this) === "showing";
    } } });
    let o2 = Element.prototype.attachShadow;
    o2 && Object.defineProperties(Element.prototype, { attachShadow: { enumerable: true, configurable: true, writable: true, value(l2) {
      let u = o2.call(this, l2);
      return Ht(u), u;
    } } });
    let t2 = HTMLElement.prototype.attachInternals;
    t2 && Object.defineProperties(HTMLElement.prototype, { attachInternals: { enumerable: true, configurable: true, writable: true, value() {
      let l2 = t2.call(this);
      return l2.shadowRoot && Ht(l2.shadowRoot), l2;
    } } });
    let n2 = /* @__PURE__ */ new WeakMap();
    function r2(l2) {
      Object.defineProperties(l2.prototype, { popoverTargetElement: { enumerable: true, configurable: true, set(u) {
        if (u === null) this.removeAttribute("popovertarget"), n2.delete(this);
        else if (u instanceof Element) this.setAttribute("popovertarget", ""), n2.set(this, u);
        else throw new TypeError("popoverTargetElement must be an element or null");
      }, get() {
        if (this.localName !== "button" && this.localName !== "input" || this.localName === "input" && this.type !== "reset" && this.type !== "image" && this.type !== "button" || this.disabled || this.form && this.type === "submit") return null;
        let u = n2.get(this);
        if (u && u.isConnected) return u;
        if (u && !u.isConnected) return n2.delete(this), null;
        let g = Te(this), m = this.getAttribute("popovertarget");
        return (g instanceof Document || g instanceof Co) && m && g.getElementById(m) || null;
      } }, popoverTargetAction: { enumerable: true, configurable: true, get() {
        let u = (this.getAttribute("popovertargetaction") || "").toLowerCase();
        return u === "show" || u === "hide" ? u : "toggle";
      }, set(u) {
        this.setAttribute("popovertargetaction", u);
      } } });
    }
    r2(HTMLButtonElement), r2(HTMLInputElement);
    let i2 = (l2) => {
      if (l2.defaultPrevented) return;
      let u = l2.composedPath(), g = u[0];
      if (!(g instanceof Element) || g?.shadowRoot) return;
      let m = Te(g);
      if (!(m instanceof Co || m instanceof Document)) return;
      let c = u.find((b) => {
        var f;
        return (f = b.matches) == null ? void 0 : f.call(b, "[popovertargetaction],[popovertarget]");
      });
      if (c) {
        Cn(c), l2.preventDefault();
        return;
      }
    }, s2 = (l2) => {
      let u = l2.key, g = l2.target;
      !l2.defaultPrevented && g && (u === "Escape" || u === "Esc") && me(g.ownerDocument, true, true);
    };
    ((l2) => {
      l2.addEventListener("click", i2), l2.addEventListener("keydown", s2), l2.addEventListener("pointerdown", Oo), l2.addEventListener("pointerup", Oo);
    })(document), Ht(document);
  }
  function No() {
    return typeof HTMLButtonElement < "u" && "command" in HTMLButtonElement.prototype && "source" in ((globalThis.CommandEvent || {}).prototype || {});
  }
  function Fo() {
    document.addEventListener("invoke", (f) => {
      f.type == "invoke" && f.isTrusted && (f.stopImmediatePropagation(), f.preventDefault());
    }, true), document.addEventListener("command", (f) => {
      f.type == "command" && f.isTrusted && (f.stopImmediatePropagation(), f.preventDefault());
    }, true);
    function e2(f, h, p = true) {
      Object.defineProperty(f, h, { ...Object.getOwnPropertyDescriptor(f, h), enumerable: p });
    }
    function o2(f) {
      return f && typeof f.getRootNode == "function" ? f.getRootNode() : f && f.parentNode ? o2(f.parentNode) : f;
    }
    let t2 = /* @__PURE__ */ new WeakMap(), n2 = /* @__PURE__ */ new WeakMap();
    class r2 extends Event {
      constructor(h, p = {}) {
        super(h, p);
        let { source: v, command: y } = p;
        if (v != null && !(v instanceof Element)) throw new TypeError("source must be an element");
        t2.set(this, v || null), n2.set(this, y !== void 0 ? String(y) : "");
      }
      get [Symbol.toStringTag]() {
        return "CommandEvent";
      }
      get source() {
        if (!t2.has(this)) throw new TypeError("illegal invocation");
        let h = t2.get(this);
        if (!(h instanceof Element)) return null;
        let p = o2(h);
        return p !== o2(this.target || document) ? p.host : h;
      }
      get command() {
        if (!n2.has(this)) throw new TypeError("illegal invocation");
        return n2.get(this);
      }
      get action() {
        throw new Error("CommandEvent#action was renamed to CommandEvent#command");
      }
      get invoker() {
        throw new Error("CommandEvent#invoker was renamed to CommandEvent#source");
      }
    }
    e2(r2.prototype, "source"), e2(r2.prototype, "command");
    class i2 extends Event {
      constructor(h, p = {}) {
        throw super(h, p), new Error("InvokeEvent has been deprecated, it has been renamed to `CommandEvent`");
      }
    }
    let s2 = /* @__PURE__ */ new WeakMap();
    function a(f) {
      Object.defineProperties(f.prototype, { commandForElement: { enumerable: true, configurable: true, set(h) {
        if (this.hasAttribute("invokeaction")) throw new TypeError("Element has deprecated `invokeaction` attribute, replace with `command`");
        if (this.hasAttribute("invoketarget")) throw new TypeError("Element has deprecated `invoketarget` attribute, replace with `commandfor`");
        if (h === null) this.removeAttribute("commandfor"), s2.delete(this);
        else if (h instanceof Element) {
          this.setAttribute("commandfor", "");
          let p = o2(h);
          o2(this) === p || p === this.ownerDocument ? s2.set(this, h) : s2.delete(this);
        } else throw new TypeError("commandForElement must be an element or null");
      }, get() {
        if (this.localName !== "button") return null;
        if (this.hasAttribute("invokeaction") || this.hasAttribute("invoketarget")) return console.warn("Element has deprecated `invoketarget` or `invokeaction` attribute, use `commandfor` and `command` instead"), null;
        if (this.disabled) return null;
        if (this.form && this.getAttribute("type") !== "button") return console.warn("Element with `commandFor` is a form participant. It should explicitly set `type=button` in order for `commandFor` to work"), null;
        let h = s2.get(this);
        if (h) return h.isConnected ? h : (s2.delete(this), null);
        let p = o2(this), v = this.getAttribute("commandfor");
        return (p instanceof Document || p instanceof ShadowRoot) && v && p.getElementById(v) || null;
      } }, command: { enumerable: true, configurable: true, get() {
        let h = this.getAttribute("command") || "";
        if (h.startsWith("--")) return h;
        let p = h.toLowerCase();
        switch (p) {
          case "show-modal":
          case "close":
          case "toggle-popover":
          case "hide-popover":
          case "show-popover":
            return p;
        }
        return "";
      }, set(h) {
        this.setAttribute("command", h);
      } }, invokeAction: { enumerable: false, configurable: true, get() {
        throw new Error("invokeAction is deprecated. It has been renamed to command");
      }, set(h) {
        throw new Error("invokeAction is deprecated. It has been renamed to command");
      } }, invokeTargetElement: { enumerable: false, configurable: true, get() {
        throw new Error("invokeTargetElement is deprecated. It has been renamed to command");
      }, set(h) {
        throw new Error("invokeTargetElement is deprecated. It has been renamed to command");
      } } });
    }
    let l2 = /* @__PURE__ */ new WeakMap();
    Object.defineProperties(HTMLElement.prototype, { oncommand: { enumerable: true, configurable: true, get() {
      return g.takeRecords(), l2.get(this) || null;
    }, set(f) {
      let h = l2.get(this) || null;
      h && this.removeEventListener("command", h), l2.set(this, typeof f == "object" || typeof f == "function" ? f : null), typeof f == "function" && this.addEventListener("command", f);
    } } });
    function u(f) {
      for (let h of f) h.oncommand = new Function("event", h.getAttribute("oncommand"));
    }
    let g = new MutationObserver((f) => {
      for (let h of f) {
        let { target: p } = h;
        h.type === "childList" ? u(p.querySelectorAll("[oncommand]")) : u([p]);
      }
    });
    g.observe(document, { subtree: true, childList: true, attributeFilter: ["oncommand"] }), u(document.querySelectorAll("[oncommand]"));
    function m(f) {
      if (f.defaultPrevented || f.type !== "click") return;
      let h = f.target.closest("button[invoketarget], button[invokeaction], input[invoketarget], input[invokeaction]");
      if (h && (console.warn("Elements with `invoketarget` or `invokeaction` are deprecated and should be renamed to use `commandfor` and `command` respectively"), h.matches("input"))) throw new Error("Input elements no longer support `commandfor`");
      let p = f.target.closest("button[commandfor], button[command]");
      if (!p) return;
      if (p.form && p.getAttribute("type") !== "button") throw f.preventDefault(), new Error("Element with `commandFor` is a form participant. It should explicitly set `type=button` in order for `commandFor` to work. In order for it to act as a Submit button, it must not have command or commandfor attributes");
      if (p.hasAttribute("command") !== p.hasAttribute("commandfor")) {
        let w = p.hasAttribute("command") ? "command" : "commandfor", E = p.hasAttribute("command") ? "commandfor" : "command";
        throw new Error(`Element with ${w} attribute must also have a ${E} attribute to function.`);
      }
      if (p.command !== "show-popover" && p.command !== "hide-popover" && p.command !== "toggle-popover" && p.command !== "show-modal" && p.command !== "close" && !p.command.startsWith("--")) {
        console.warn(`"${p.command}" is not a valid command value. Custom commands must begin with --`);
        return;
      }
      let v = p.commandForElement;
      if (!v) return;
      let y = new r2("command", { command: p.command, source: p, cancelable: true });
      if (v.dispatchEvent(y), y.defaultPrevented) return;
      let x = y.command.toLowerCase();
      if (v.popover) {
        let w = !v.matches(":popover-open");
        w && (x === "toggle-popover" || x === "show-popover") ? v.showPopover({ source: p }) : !w && x === "hide-popover" && v.hidePopover();
      } else if (v.localName === "dialog") {
        let w = !v.hasAttribute("open");
        w && x === "show-modal" ? v.showModal() : !w && x === "close" && v.close();
      }
    }
    function c(f) {
      f.addEventListener("click", m, true);
    }
    function b(f, h) {
      let p = f.prototype.attachShadow;
      f.prototype.attachShadow = function(y) {
        let x = p.call(this, y);
        return h(x), x;
      };
      let v = f.prototype.attachInternals;
      f.prototype.attachInternals = function() {
        let y = v.call(this);
        return y.shadowRoot && h(y.shadowRoot), y;
      };
    }
    a(HTMLButtonElement), b(HTMLElement, (f) => {
      c(f), g.observe(f, { attributeFilter: ["oncommand"] }), u(f.querySelectorAll("[oncommand]"));
    }), c(document), Object.assign(globalThis, { CommandEvent: r2, InvokeEvent: i2 });
  }
  function qo() {
    if (typeof HTMLDialogElement != "function") return false;
    let e2 = false, o2 = document.createElement("dialog");
    return o2.addEventListener("beforetoggle", (t2) => {
      e2 = true, t2.preventDefault();
    }), o2.show(), e2;
  }
  function Vo() {
    let e2 = /* @__PURE__ */ new WeakMap();
    function o2(s2) {
      let a = s2.open ? "closed" : "open", l2 = s2.open ? "open" : "closed";
      if (e2.has(s2)) {
        let u = e2.get(s2);
        l2 = u.oldState, clearTimeout(u.id);
      }
      e2.set(s2, { oldState: l2, id: setTimeout(() => {
        s2.dispatchEvent(new ToggleEvent("toggle", { newState: a, oldState: l2 }));
      }) });
    }
    let t2 = HTMLDialogElement.prototype.show, n2 = HTMLDialogElement.prototype.showModal, r2 = HTMLDialogElement.prototype.close;
    function i2(s2) {
      let a = new ToggleEvent("beforetoggle", { newState: "closed", oldState: "open", cancelable: false });
      s2.dispatchEvent(a), s2.open && o2(s2);
    }
    document.addEventListener("submit", (s2) => {
      let a = s2.target;
      if (a.method === "dialog") {
        let l2 = a.closest("dialog");
        l2 instanceof HTMLDialogElement && i2(l2);
      }
    }, true), Object.defineProperties(HTMLDialogElement.prototype, { show: { value() {
      if (this.open || this.matches(":popover-open, :modal") || !this.ownerDocument) return t2.apply(this, arguments);
      let s2 = new ToggleEvent("beforetoggle", { newState: "open", oldState: "closed", cancelable: true });
      this.dispatchEvent(s2) && (o2(this), t2.apply(this, arguments));
    } }, showModal: { value() {
      if (this.open || this.matches(":popover-open, :modal") || !this.isConnected || !this.ownerDocument) return n2.apply(this, arguments);
      let s2 = new ToggleEvent("beforetoggle", { newState: "open", oldState: "closed", cancelable: true });
      if (this.dispatchEvent(s2)) return o2(this), n2.apply(this, arguments);
    } }, close: { value() {
      return !this.open && !this.matches(":popover-open, :modal") ? r2.apply(this, arguments) : (i2(this), r2.apply(this, arguments));
    } } });
  }
  function ut(e2) {
    function o2() {
      document.readyState !== "loading" && (e2(), document.removeEventListener("DOMContentLoaded", o2));
    }
    typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", o2), o2());
  }
  typeof globalThis.window < "u" && (Ro() || (Bo(), ut(async () => {
    if (await Wn("popover-polyfill")) return;
    let e2 = document.createElement("style");
    e2.textContent = "@layer popover-polyfill;", e2.setAttribute("suppressHydrationWarning", ""), e2.addEventListener("securitypolicyviolation", () => {
      console.log("CSP rules on this website prevented @tailwindplus/elements from defining `popover-polyfill` as the first CSS layer. This is necessary to ensure the popover polyfill behaves correctly with CSS layers. To fix this, please manually add the following CSS to the top of your first stylesheet:\n\n```\n@layer popover-polyfill;\n```");
    }), document.documentElement.prepend(e2);
  })), No() || Fo(), qo() || Vo());
  async function Wn(e2) {
    await $n();
    for (let o2 of document.styleSheets) try {
      for (let t2 of o2.rules) if (t2.constructor.name === "CSSLayerStatementRule" && "nameList" in t2 && t2.nameList.includes(e2)) return true;
    } catch {
    }
    return false;
  }
  async function $n() {
    await Promise.all(Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map((e2) => e2.sheet ? Promise.resolve() : new Promise((o2) => {
      e2.addEventListener("load", () => o2(), { once: true }), e2.addEventListener("error", () => o2(), { once: true });
    })));
  }
  function Le(e2) {
    "focus" in e2 && e2.focus({ focusVisible: ct });
  }
  var ct = false;
  if (typeof globalThis.window < "u") {
    let e2;
    ((n2) => (n2[n2.Keyboard = 0] = "Keyboard", n2[n2.Mouse = 1] = "Mouse"))(e2 || (e2 = {})), document.addEventListener("keydown", (o2) => {
      o2.metaKey || o2.altKey || o2.ctrlKey || (ct = true, document.documentElement.dataset.focusVisible = "");
    }, true), document.addEventListener("click", (o2) => {
      o2.detail === 1 ? (ct = false, delete document.documentElement.dataset.focusVisible) : o2.detail === 0 && (ct = true, document.documentElement.dataset.focusVisible = "");
    }, true);
  }
  typeof globalThis.HTMLElement > "u" && (globalThis.HTMLElement = class {
  });
  var Ie;
  var We;
  var se;
  var A = class extends HTMLElement {
    constructor() {
      super(...arguments);
      L(this, Ie, new AbortController());
      L(this, We, false);
      L(this, se, false);
    }
    connectedCallback() {
      if ("observedAttributes" in this.constructor && typeof this.constructor.observedAttributes == "object" && Array.isArray(this.constructor.observedAttributes)) for (let n2 of this.constructor.observedAttributes) typeof n2 == "string" && (n2 in this || Object.defineProperty(this, n2, { get() {
        return this.getAttribute(n2);
      }, set(r2) {
        if (r2 == null || r2 === false) {
          this.removeAttribute(n2);
          return;
        }
        this.setAttribute(n2, r2.toString());
      } }));
      I(this, We, true);
      let t2 = d(this, Ie).signal;
      queueMicrotask(() => {
        if (!t2.aborted) try {
          this.mount?.(t2);
        } catch (n2) {
          console.error(n2);
        }
      });
    }
    disconnectedCallback() {
      d(this, Ie).abort(), I(this, Ie, new AbortController());
    }
    setAttributeNoCallbacks(t2, n2) {
      try {
        I(this, se, true), this.setAttribute(t2, n2);
      } finally {
        I(this, se, false);
      }
    }
    removeAttributeNoCallbacks(t2) {
      try {
        I(this, se, true), this.removeAttribute(t2);
      } finally {
        I(this, se, false);
      }
    }
    attributeChangedCallback(t2, n2, r2) {
      d(this, We) && (d(this, se) || n2 !== r2 && this.onAttributeChange?.(t2, n2, r2));
    }
  };
  Ie = /* @__PURE__ */ new WeakMap(), We = /* @__PURE__ */ new WeakMap(), se = /* @__PURE__ */ new WeakMap();
  function T(e2, o2) {
    typeof globalThis.customElements > "u" || customElements.get(e2) === o2 || customElements.define(e2, o2);
  }
  function J() {
    let e2 = [], o2 = { addEventListener(t2, n2, r2, i2) {
      return t2.addEventListener(n2, r2, i2), o2.add(() => t2.removeEventListener(n2, r2, i2));
    }, requestAnimationFrame(...t2) {
      let n2 = requestAnimationFrame(...t2);
      return o2.add(() => cancelAnimationFrame(n2));
    }, nextFrame(...t2) {
      return o2.requestAnimationFrame(() => o2.requestAnimationFrame(...t2));
    }, setTimeout(...t2) {
      let n2 = setTimeout(...t2);
      return o2.add(() => clearTimeout(n2));
    }, microTask(...t2) {
      let n2 = { current: true };
      return queueMicrotask(() => {
        n2.current && t2[0]();
      }), o2.add(() => {
        n2.current = false;
      });
    }, style(t2, n2, r2) {
      let i2 = t2.style.getPropertyValue(n2);
      return n2.startsWith("--") ? t2.style.setProperty(n2, r2) : Object.assign(t2.style, { [n2]: r2 }), this.add(() => {
        n2.startsWith("--") ? t2.style.setProperty(n2, i2) : Object.assign(t2.style, { [n2]: i2 });
      });
    }, add(t2) {
      return e2.includes(t2) || e2.push(t2), () => {
        let n2 = e2.indexOf(t2);
        if (n2 >= 0) for (let r2 of e2.splice(n2, 1)) r2();
      };
    }, dispose() {
      for (let t2 of e2.splice(0)) t2();
    } };
    return o2;
  }
  function Pe(e2, o2 = () => []) {
    let t2 = false, n2 = null, r2 = J();
    return { start(i2, s2) {
      let a = [e2, ...o2()];
      t2 ? t2 = false : t2 = n2 !== null && n2 !== i2, n2 = i2;
      for (let l2 of a) _n(l2, () => {
        t2 || (i2 === "in" ? (l2.dataset.transition = "", l2.dataset.enter = "", l2.dataset.closed = "", delete l2.dataset.leave) : i2 === "out" && (l2.dataset.transition = "", l2.dataset.leave = "", delete l2.dataset.enter));
      }, n2 !== null);
      r2.nextFrame(() => {
        for (let l2 of a) t2 ? i2 === "in" ? (delete l2.dataset.enter, delete l2.dataset.closed, l2.dataset.leave = "") : i2 === "out" && (delete l2.dataset.leave, l2.dataset.enter = "", l2.dataset.closed = "") : i2 === "in" ? delete l2.dataset.closed : i2 === "out" && (l2.dataset.closed = "");
        r2.requestAnimationFrame(() => {
          r2.add(Ft(e2, () => {
            if (!(t2 && a.some((l2) => qt(l2)))) {
              for (let l2 of a) delete l2.dataset.transition, delete l2.dataset.enter, delete l2.dataset.closed, delete l2.dataset.leave;
              n2 = null, s2?.();
            }
          }));
        });
      });
    }, abort() {
      r2.dispose(), t2 = false, n2 = null;
    } };
  }
  function _n(e2, o2, t2 = false) {
    if (t2) {
      o2();
      return;
    }
    let n2 = e2.style.transition;
    e2.style.transition = "none", o2(), e2.offsetHeight, e2.style.transition = n2;
  }
  function Ft(e2, o2) {
    let t2 = J();
    if (!e2) return t2.dispose;
    let n2 = false;
    t2.add(() => {
      n2 = true;
    });
    let r2 = e2.getAnimations?.({ subtree: true }).filter((i2) => i2 instanceof CSSTransition) ?? [];
    return r2.length === 0 ? (o2(), t2.dispose) : (Promise.allSettled(r2.map((i2) => i2.finished)).then(() => {
      n2 || o2();
    }), t2.dispose);
  }
  function qt(e2) {
    return (e2.getAnimations?.() ?? []).some((t2) => t2 instanceof CSSTransition && t2.playState !== "finished");
  }
  var ke = Math.min;
  var Z = Math.max;
  var _e = Math.round;
  var Ke = Math.floor;
  var K = (e2) => ({ x: e2, y: e2 });
  var Kn = { left: "right", right: "left", bottom: "top", top: "bottom" };
  var Un = { start: "end", end: "start" };
  function Vt(e2, o2, t2) {
    return Z(e2, ke(o2, t2));
  }
  function dt(e2, o2) {
    return typeof e2 == "function" ? e2(o2) : e2;
  }
  function he(e2) {
    return e2.split("-")[0];
  }
  function pt(e2) {
    return e2.split("-")[1];
  }
  function Wt(e2) {
    return e2 === "x" ? "y" : "x";
  }
  function $t(e2) {
    return e2 === "y" ? "height" : "width";
  }
  var jn = /* @__PURE__ */ new Set(["top", "bottom"]);
  function le(e2) {
    return jn.has(he(e2)) ? "y" : "x";
  }
  function _t(e2) {
    return Wt(le(e2));
  }
  function _o(e2, o2, t2) {
    t2 === void 0 && (t2 = false);
    let n2 = pt(e2), r2 = _t(e2), i2 = $t(r2), s2 = r2 === "x" ? n2 === (t2 ? "end" : "start") ? "right" : "left" : n2 === "start" ? "bottom" : "top";
    return o2.reference[i2] > o2.floating[i2] && (s2 = $e(s2)), [s2, $e(s2)];
  }
  function Ko(e2) {
    let o2 = $e(e2);
    return [ft(e2), o2, ft(o2)];
  }
  function ft(e2) {
    return e2.replace(/start|end/g, (o2) => Un[o2]);
  }
  var Wo = ["left", "right"];
  var $o = ["right", "left"];
  var zn = ["top", "bottom"];
  var Gn = ["bottom", "top"];
  function Yn(e2, o2, t2) {
    switch (e2) {
      case "top":
      case "bottom":
        return t2 ? o2 ? $o : Wo : o2 ? Wo : $o;
      case "left":
      case "right":
        return o2 ? zn : Gn;
      default:
        return [];
    }
  }
  function Uo(e2, o2, t2, n2) {
    let r2 = pt(e2), i2 = Yn(he(e2), t2 === "start", n2);
    return r2 && (i2 = i2.map((s2) => s2 + "-" + r2), o2 && (i2 = i2.concat(i2.map(ft)))), i2;
  }
  function $e(e2) {
    return e2.replace(/left|right|bottom|top/g, (o2) => Kn[o2]);
  }
  function Qn(e2) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...e2 };
  }
  function jo(e2) {
    return typeof e2 != "number" ? Qn(e2) : { top: e2, right: e2, bottom: e2, left: e2 };
  }
  function ge(e2) {
    let { x: o2, y: t2, width: n2, height: r2 } = e2;
    return { width: n2, height: r2, top: t2, left: o2, right: o2 + n2, bottom: t2 + r2, x: o2, y: t2 };
  }
  function zo(e2, o2, t2) {
    let { reference: n2, floating: r2 } = e2, i2 = le(o2), s2 = _t(o2), a = $t(s2), l2 = he(o2), u = i2 === "y", g = n2.x + n2.width / 2 - r2.width / 2, m = n2.y + n2.height / 2 - r2.height / 2, c = n2[a] / 2 - r2[a] / 2, b;
    switch (l2) {
      case "top":
        b = { x: g, y: n2.y - r2.height };
        break;
      case "bottom":
        b = { x: g, y: n2.y + n2.height };
        break;
      case "right":
        b = { x: n2.x + n2.width, y: m };
        break;
      case "left":
        b = { x: n2.x - r2.width, y: m };
        break;
      default:
        b = { x: n2.x, y: n2.y };
    }
    switch (pt(o2)) {
      case "start":
        b[s2] -= c * (t2 && u ? -1 : 1);
        break;
      case "end":
        b[s2] += c * (t2 && u ? -1 : 1);
        break;
    }
    return b;
  }
  var Go = async (e2, o2, t2) => {
    let { placement: n2 = "bottom", strategy: r2 = "absolute", middleware: i2 = [], platform: s2 } = t2, a = i2.filter(Boolean), l2 = await (s2.isRTL == null ? void 0 : s2.isRTL(o2)), u = await s2.getElementRects({ reference: e2, floating: o2, strategy: r2 }), { x: g, y: m } = zo(u, n2, l2), c = n2, b = {}, f = 0;
    for (let h = 0; h < a.length; h++) {
      let { name: p, fn: v } = a[h], { x: y, y: x, data: w, reset: E } = await v({ x: g, y: m, initialPlacement: n2, placement: c, strategy: r2, middlewareData: b, rects: u, platform: s2, elements: { reference: e2, floating: o2 } });
      g = y ?? g, m = x ?? m, b = { ...b, [p]: { ...b[p], ...w } }, E && f <= 50 && (f++, typeof E == "object" && (E.placement && (c = E.placement), E.rects && (u = E.rects === true ? await s2.getElementRects({ reference: e2, floating: o2, strategy: r2 }) : E.rects), { x: g, y: m } = zo(u, c, l2)), h = -1);
    }
    return { x: g, y: m, placement: c, strategy: r2, middlewareData: b };
  };
  async function Kt(e2, o2) {
    var t2;
    o2 === void 0 && (o2 = {});
    let { x: n2, y: r2, platform: i2, rects: s2, elements: a, strategy: l2 } = e2, { boundary: u = "clippingAncestors", rootBoundary: g = "viewport", elementContext: m = "floating", altBoundary: c = false, padding: b = 0 } = dt(o2, e2), f = jo(b), p = a[c ? m === "floating" ? "reference" : "floating" : m], v = ge(await i2.getClippingRect({ element: (t2 = await (i2.isElement == null ? void 0 : i2.isElement(p))) == null || t2 ? p : p.contextElement || await (i2.getDocumentElement == null ? void 0 : i2.getDocumentElement(a.floating)), boundary: u, rootBoundary: g, strategy: l2 })), y = m === "floating" ? { x: n2, y: r2, width: s2.floating.width, height: s2.floating.height } : s2.reference, x = await (i2.getOffsetParent == null ? void 0 : i2.getOffsetParent(a.floating)), w = await (i2.isElement == null ? void 0 : i2.isElement(x)) ? await (i2.getScale == null ? void 0 : i2.getScale(x)) || { x: 1, y: 1 } : { x: 1, y: 1 }, E = ge(i2.convertOffsetParentRelativeRectToViewportRelativeRect ? await i2.convertOffsetParentRelativeRectToViewportRelativeRect({ elements: a, rect: y, offsetParent: x, strategy: l2 }) : y);
    return { top: (v.top - E.top + f.top) / w.y, bottom: (E.bottom - v.bottom + f.bottom) / w.y, left: (v.left - E.left + f.left) / w.x, right: (E.right - v.right + f.right) / w.x };
  }
  var Yo = function(e2) {
    return e2 === void 0 && (e2 = {}), { name: "flip", options: e2, async fn(o2) {
      var t2, n2;
      let { placement: r2, middlewareData: i2, rects: s2, initialPlacement: a, platform: l2, elements: u } = o2, { mainAxis: g = true, crossAxis: m = true, fallbackPlacements: c, fallbackStrategy: b = "bestFit", fallbackAxisSideDirection: f = "none", flipAlignment: h = true, ...p } = dt(e2, o2);
      if ((t2 = i2.arrow) != null && t2.alignmentOffset) return {};
      let v = he(r2), y = le(a), x = he(a) === a, w = await (l2.isRTL == null ? void 0 : l2.isRTL(u.floating)), E = c || (x || !h ? [$e(a)] : Ko(a)), P = f !== "none";
      !c && P && E.push(...Uo(a, h, f, w));
      let S = [a, ...E], $ = await Kt(o2, p), re = [], D = ((n2 = i2.flip) == null ? void 0 : n2.overflows) || [];
      if (g && re.push($[v]), m) {
        let ce = _o(r2, s2, w);
        re.push($[ce[0]], $[ce[1]]);
      }
      if (D = [...D, { placement: r2, overflows: re }], !re.every((ce) => ce <= 0)) {
        var nt, Ao;
        let ce = (((nt = i2.flip) == null ? void 0 : nt.index) || 0) + 1, Ot = S[ce];
        if (Ot && (!(m === "alignment" ? y !== le(Ot) : false) || D.every((_) => le(_.placement) === y ? _.overflows[0] > 0 : true))) return { data: { index: ce, overflows: D }, reset: { placement: Ot } };
        let Fe = (Ao = D.filter((fe) => fe.overflows[0] <= 0).sort((fe, _) => fe.overflows[1] - _.overflows[1])[0]) == null ? void 0 : Ao.placement;
        if (!Fe) switch (b) {
          case "bestFit": {
            var xo;
            let fe = (xo = D.filter((_) => {
              if (P) {
                let ie = le(_.placement);
                return ie === y || ie === "y";
              }
              return true;
            }).map((_) => [_.placement, _.overflows.filter((ie) => ie > 0).reduce((ie, In) => ie + In, 0)]).sort((_, ie) => _[1] - ie[1])[0]) == null ? void 0 : xo[0];
            fe && (Fe = fe);
            break;
          }
          case "initialPlacement":
            Fe = a;
            break;
        }
        if (r2 !== Fe) return { reset: { placement: Fe } };
      }
      return {};
    } };
  };
  var Qo = function(e2) {
    return e2 === void 0 && (e2 = {}), { name: "shift", options: e2, async fn(o2) {
      let { x: t2, y: n2, placement: r2 } = o2, { mainAxis: i2 = true, crossAxis: s2 = false, limiter: a = { fn: (p) => {
        let { x: v, y } = p;
        return { x: v, y };
      } }, ...l2 } = dt(e2, o2), u = { x: t2, y: n2 }, g = await Kt(o2, l2), m = le(he(r2)), c = Wt(m), b = u[c], f = u[m];
      if (i2) {
        let p = c === "y" ? "top" : "left", v = c === "y" ? "bottom" : "right", y = b + g[p], x = b - g[v];
        b = Vt(y, b, x);
      }
      if (s2) {
        let p = m === "y" ? "top" : "left", v = m === "y" ? "bottom" : "right", y = f + g[p], x = f - g[v];
        f = Vt(y, f, x);
      }
      let h = a.fn({ ...o2, [c]: b, [m]: f });
      return { ...h, data: { x: h.x - t2, y: h.y - n2, enabled: { [c]: i2, [m]: s2 } } };
    } };
  };
  function mt() {
    return typeof window < "u";
  }
  function be(e2) {
    return Jo(e2) ? (e2.nodeName || "").toLowerCase() : "#document";
  }
  function R(e2) {
    var o2;
    return (e2 == null || (o2 = e2.ownerDocument) == null ? void 0 : o2.defaultView) || window;
  }
  function U(e2) {
    var o2;
    return (o2 = (Jo(e2) ? e2.ownerDocument : e2.document) || window.document) == null ? void 0 : o2.documentElement;
  }
  function Jo(e2) {
    return mt() ? e2 instanceof Node || e2 instanceof R(e2).Node : false;
  }
  function V(e2) {
    return mt() ? e2 instanceof Element || e2 instanceof R(e2).Element : false;
  }
  function j(e2) {
    return mt() ? e2 instanceof HTMLElement || e2 instanceof R(e2).HTMLElement : false;
  }
  function Xo(e2) {
    return !mt() || typeof ShadowRoot > "u" ? false : e2 instanceof ShadowRoot || e2 instanceof R(e2).ShadowRoot;
  }
  var Xn = /* @__PURE__ */ new Set(["inline", "contents"]);
  function Ce(e2) {
    let { overflow: o2, overflowX: t2, overflowY: n2, display: r2 } = W(e2);
    return /auto|scroll|overlay|hidden|clip/.test(o2 + n2 + t2) && !Xn.has(r2);
  }
  var Jn = /* @__PURE__ */ new Set(["table", "td", "th"]);
  function Zo(e2) {
    return Jn.has(be(e2));
  }
  var Zn = [":popover-open", ":modal"];
  function Ue(e2) {
    return Zn.some((o2) => {
      try {
        return e2.matches(o2);
      } catch {
        return false;
      }
    });
  }
  var er = ["transform", "translate", "scale", "rotate", "perspective"];
  var tr = ["transform", "translate", "scale", "rotate", "perspective", "filter"];
  var or = ["paint", "layout", "strict", "content"];
  function ht(e2) {
    let o2 = gt(), t2 = V(e2) ? W(e2) : e2;
    return er.some((n2) => t2[n2] ? t2[n2] !== "none" : false) || (t2.containerType ? t2.containerType !== "normal" : false) || !o2 && (t2.backdropFilter ? t2.backdropFilter !== "none" : false) || !o2 && (t2.filter ? t2.filter !== "none" : false) || tr.some((n2) => (t2.willChange || "").includes(n2)) || or.some((n2) => (t2.contain || "").includes(n2));
  }
  function en(e2) {
    let o2 = ee(e2);
    for (; j(o2) && !ve(o2); ) {
      if (ht(o2)) return o2;
      if (Ue(o2)) return null;
      o2 = ee(o2);
    }
    return null;
  }
  function gt() {
    return typeof CSS > "u" || !CSS.supports ? false : CSS.supports("-webkit-backdrop-filter", "none");
  }
  var nr = /* @__PURE__ */ new Set(["html", "body", "#document"]);
  function ve(e2) {
    return nr.has(be(e2));
  }
  function W(e2) {
    return R(e2).getComputedStyle(e2);
  }
  function je(e2) {
    return V(e2) ? { scrollLeft: e2.scrollLeft, scrollTop: e2.scrollTop } : { scrollLeft: e2.scrollX, scrollTop: e2.scrollY };
  }
  function ee(e2) {
    if (be(e2) === "html") return e2;
    let o2 = e2.assignedSlot || e2.parentNode || Xo(e2) && e2.host || U(e2);
    return Xo(o2) ? o2.host : o2;
  }
  function tn(e2) {
    let o2 = ee(e2);
    return ve(o2) ? e2.ownerDocument ? e2.ownerDocument.body : e2.body : j(o2) && Ce(o2) ? o2 : tn(o2);
  }
  function Oe(e2, o2, t2) {
    var n2;
    o2 === void 0 && (o2 = []), t2 === void 0 && (t2 = true);
    let r2 = tn(e2), i2 = r2 === ((n2 = e2.ownerDocument) == null ? void 0 : n2.body), s2 = R(r2);
    if (i2) {
      let a = bt(s2);
      return o2.concat(s2, s2.visualViewport || [], Ce(r2) ? r2 : [], a && t2 ? Oe(a) : []);
    }
    return o2.concat(r2, Oe(r2, [], t2));
  }
  function bt(e2) {
    return e2.parent && Object.getPrototypeOf(e2.parent) ? e2.frameElement : null;
  }
  function rn(e2) {
    let o2 = W(e2), t2 = parseFloat(o2.width) || 0, n2 = parseFloat(o2.height) || 0, r2 = j(e2), i2 = r2 ? e2.offsetWidth : t2, s2 = r2 ? e2.offsetHeight : n2, a = _e(t2) !== i2 || _e(n2) !== s2;
    return a && (t2 = i2, n2 = s2), { width: t2, height: n2, $: a };
  }
  function jt(e2) {
    return V(e2) ? e2 : e2.contextElement;
  }
  function De(e2) {
    let o2 = jt(e2);
    if (!j(o2)) return K(1);
    let t2 = o2.getBoundingClientRect(), { width: n2, height: r2, $: i2 } = rn(o2), s2 = (i2 ? _e(t2.width) : t2.width) / n2, a = (i2 ? _e(t2.height) : t2.height) / r2;
    return (!s2 || !Number.isFinite(s2)) && (s2 = 1), (!a || !Number.isFinite(a)) && (a = 1), { x: s2, y: a };
  }
  var rr = K(0);
  function sn(e2) {
    let o2 = R(e2);
    return !gt() || !o2.visualViewport ? rr : { x: o2.visualViewport.offsetLeft, y: o2.visualViewport.offsetTop };
  }
  function ir(e2, o2, t2) {
    return o2 === void 0 && (o2 = false), !t2 || o2 && t2 !== R(e2) ? false : o2;
  }
  function we(e2, o2, t2, n2) {
    o2 === void 0 && (o2 = false), t2 === void 0 && (t2 = false);
    let r2 = e2.getBoundingClientRect(), i2 = jt(e2), s2 = K(1);
    o2 && (n2 ? V(n2) && (s2 = De(n2)) : s2 = De(e2));
    let a = ir(i2, t2, n2) ? sn(i2) : K(0), l2 = (r2.left + a.x) / s2.x, u = (r2.top + a.y) / s2.y, g = r2.width / s2.x, m = r2.height / s2.y;
    if (i2) {
      let c = R(i2), b = n2 && V(n2) ? R(n2) : n2, f = c, h = bt(f);
      for (; h && n2 && b !== f; ) {
        let p = De(h), v = h.getBoundingClientRect(), y = W(h), x = v.left + (h.clientLeft + parseFloat(y.paddingLeft)) * p.x, w = v.top + (h.clientTop + parseFloat(y.paddingTop)) * p.y;
        l2 *= p.x, u *= p.y, g *= p.x, m *= p.y, l2 += x, u += w, f = R(h), h = bt(f);
      }
    }
    return ge({ width: g, height: m, x: l2, y: u });
  }
  function zt(e2, o2) {
    let t2 = je(e2).scrollLeft;
    return o2 ? o2.left + t2 : we(U(e2)).left + t2;
  }
  function ln(e2, o2, t2) {
    t2 === void 0 && (t2 = false);
    let n2 = e2.getBoundingClientRect(), r2 = n2.left + o2.scrollLeft - (t2 ? 0 : zt(e2, n2)), i2 = n2.top + o2.scrollTop;
    return { x: r2, y: i2 };
  }
  function sr(e2) {
    let { elements: o2, rect: t2, offsetParent: n2, strategy: r2 } = e2, i2 = r2 === "fixed", s2 = U(n2), a = o2 ? Ue(o2.floating) : false;
    if (n2 === s2 || a && i2) return t2;
    let l2 = { scrollLeft: 0, scrollTop: 0 }, u = K(1), g = K(0), m = j(n2);
    if ((m || !m && !i2) && ((be(n2) !== "body" || Ce(s2)) && (l2 = je(n2)), j(n2))) {
      let b = we(n2);
      u = De(n2), g.x = b.x + n2.clientLeft, g.y = b.y + n2.clientTop;
    }
    let c = s2 && !m && !i2 ? ln(s2, l2, true) : K(0);
    return { width: t2.width * u.x, height: t2.height * u.y, x: t2.x * u.x - l2.scrollLeft * u.x + g.x + c.x, y: t2.y * u.y - l2.scrollTop * u.y + g.y + c.y };
  }
  function lr(e2) {
    return Array.from(e2.getClientRects());
  }
  function ar(e2) {
    let o2 = U(e2), t2 = je(e2), n2 = e2.ownerDocument.body, r2 = Z(o2.scrollWidth, o2.clientWidth, n2.scrollWidth, n2.clientWidth), i2 = Z(o2.scrollHeight, o2.clientHeight, n2.scrollHeight, n2.clientHeight), s2 = -t2.scrollLeft + zt(e2), a = -t2.scrollTop;
    return W(n2).direction === "rtl" && (s2 += Z(o2.clientWidth, n2.clientWidth) - r2), { width: r2, height: i2, x: s2, y: a };
  }
  function ur(e2, o2) {
    let t2 = R(e2), n2 = U(e2), r2 = t2.visualViewport, i2 = n2.clientWidth, s2 = n2.clientHeight, a = 0, l2 = 0;
    if (r2) {
      i2 = r2.width, s2 = r2.height;
      let u = gt();
      (!u || u && o2 === "fixed") && (a = r2.offsetLeft, l2 = r2.offsetTop);
    }
    return { width: i2, height: s2, x: a, y: l2 };
  }
  var cr = /* @__PURE__ */ new Set(["absolute", "fixed"]);
  function fr(e2, o2) {
    let t2 = we(e2, true, o2 === "fixed"), n2 = t2.top + e2.clientTop, r2 = t2.left + e2.clientLeft, i2 = j(e2) ? De(e2) : K(1), s2 = e2.clientWidth * i2.x, a = e2.clientHeight * i2.y, l2 = r2 * i2.x, u = n2 * i2.y;
    return { width: s2, height: a, x: l2, y: u };
  }
  function on(e2, o2, t2) {
    let n2;
    if (o2 === "viewport") n2 = ur(e2, t2);
    else if (o2 === "document") n2 = ar(U(e2));
    else if (V(o2)) n2 = fr(o2, t2);
    else {
      let r2 = sn(e2);
      n2 = { x: o2.x - r2.x, y: o2.y - r2.y, width: o2.width, height: o2.height };
    }
    return ge(n2);
  }
  function an(e2, o2) {
    let t2 = ee(e2);
    return t2 === o2 || !V(t2) || ve(t2) ? false : W(t2).position === "fixed" || an(t2, o2);
  }
  function dr(e2, o2) {
    let t2 = o2.get(e2);
    if (t2) return t2;
    let n2 = Oe(e2, [], false).filter((a) => V(a) && be(a) !== "body"), r2 = null, i2 = W(e2).position === "fixed", s2 = i2 ? ee(e2) : e2;
    for (; V(s2) && !ve(s2); ) {
      let a = W(s2), l2 = ht(s2);
      !l2 && a.position === "fixed" && (r2 = null), (i2 ? !l2 && !r2 : !l2 && a.position === "static" && !!r2 && cr.has(r2.position) || Ce(s2) && !l2 && an(e2, s2)) ? n2 = n2.filter((g) => g !== s2) : r2 = a, s2 = ee(s2);
    }
    return o2.set(e2, n2), n2;
  }
  function pr(e2) {
    let { element: o2, boundary: t2, rootBoundary: n2, strategy: r2 } = e2, s2 = [...t2 === "clippingAncestors" ? Ue(o2) ? [] : dr(o2, this._c) : [].concat(t2), n2], a = s2[0], l2 = s2.reduce((u, g) => {
      let m = on(o2, g, r2);
      return u.top = Z(m.top, u.top), u.right = ke(m.right, u.right), u.bottom = ke(m.bottom, u.bottom), u.left = Z(m.left, u.left), u;
    }, on(o2, a, r2));
    return { width: l2.right - l2.left, height: l2.bottom - l2.top, x: l2.left, y: l2.top };
  }
  function mr(e2) {
    let { width: o2, height: t2 } = rn(e2);
    return { width: o2, height: t2 };
  }
  function hr(e2, o2, t2) {
    let n2 = j(o2), r2 = U(o2), i2 = t2 === "fixed", s2 = we(e2, true, i2, o2), a = { scrollLeft: 0, scrollTop: 0 }, l2 = K(0);
    function u() {
      l2.x = zt(r2);
    }
    if (n2 || !n2 && !i2) if ((be(o2) !== "body" || Ce(r2)) && (a = je(o2)), n2) {
      let b = we(o2, true, i2, o2);
      l2.x = b.x + o2.clientLeft, l2.y = b.y + o2.clientTop;
    } else r2 && u();
    i2 && !n2 && r2 && u();
    let g = r2 && !n2 && !i2 ? ln(r2, a) : K(0), m = s2.left + a.scrollLeft - l2.x - g.x, c = s2.top + a.scrollTop - l2.y - g.y;
    return { x: m, y: c, width: s2.width, height: s2.height };
  }
  function Ut(e2) {
    return W(e2).position === "static";
  }
  function nn(e2, o2) {
    if (!j(e2) || W(e2).position === "fixed") return null;
    if (o2) return o2(e2);
    let t2 = e2.offsetParent;
    return U(e2) === t2 && (t2 = t2.ownerDocument.body), t2;
  }
  function un(e2, o2) {
    let t2 = R(e2);
    if (Ue(e2)) return t2;
    if (!j(e2)) {
      let r2 = ee(e2);
      for (; r2 && !ve(r2); ) {
        if (V(r2) && !Ut(r2)) return r2;
        r2 = ee(r2);
      }
      return t2;
    }
    let n2 = nn(e2, o2);
    for (; n2 && Zo(n2) && Ut(n2); ) n2 = nn(n2, o2);
    return n2 && ve(n2) && Ut(n2) && !ht(n2) ? t2 : n2 || en(e2) || t2;
  }
  var gr = async function(e2) {
    let o2 = this.getOffsetParent || un, t2 = this.getDimensions, n2 = await t2(e2.floating);
    return { reference: hr(e2.reference, await o2(e2.floating), e2.strategy), floating: { x: 0, y: 0, width: n2.width, height: n2.height } };
  };
  function br(e2) {
    return W(e2).direction === "rtl";
  }
  var Gt = { convertOffsetParentRelativeRectToViewportRelativeRect: sr, getDocumentElement: U, getClippingRect: pr, getOffsetParent: un, getElementRects: gr, getClientRects: lr, getDimensions: mr, getScale: De, isElement: V, isRTL: br };
  function cn(e2, o2) {
    return e2.x === o2.x && e2.y === o2.y && e2.width === o2.width && e2.height === o2.height;
  }
  function vr(e2, o2) {
    let t2 = null, n2, r2 = U(e2);
    function i2() {
      var a;
      clearTimeout(n2), (a = t2) == null || a.disconnect(), t2 = null;
    }
    function s2(a, l2) {
      a === void 0 && (a = false), l2 === void 0 && (l2 = 1), i2();
      let u = e2.getBoundingClientRect(), { left: g, top: m, width: c, height: b } = u;
      if (a || o2(), !c || !b) return;
      let f = Ke(m), h = Ke(r2.clientWidth - (g + c)), p = Ke(r2.clientHeight - (m + b)), v = Ke(g), x = { rootMargin: -f + "px " + -h + "px " + -p + "px " + -v + "px", threshold: Z(0, ke(1, l2)) || 1 }, w = true;
      function E(P) {
        let S = P[0].intersectionRatio;
        if (S !== l2) {
          if (!w) return s2();
          S ? s2(false, S) : n2 = setTimeout(() => {
            s2(false, 1e-7);
          }, 1e3);
        }
        S === 1 && !cn(u, e2.getBoundingClientRect()) && s2(), w = false;
      }
      try {
        t2 = new IntersectionObserver(E, { ...x, root: r2.ownerDocument });
      } catch {
        t2 = new IntersectionObserver(E, x);
      }
      t2.observe(e2);
    }
    return s2(true), i2;
  }
  function fn(e2, o2, t2, n2) {
    n2 === void 0 && (n2 = {});
    let { ancestorScroll: r2 = true, ancestorResize: i2 = true, elementResize: s2 = typeof ResizeObserver == "function", layoutShift: a = typeof IntersectionObserver == "function", animationFrame: l2 = false } = n2, u = jt(e2), g = r2 || i2 ? [...u ? Oe(u) : [], ...Oe(o2)] : [];
    g.forEach((v) => {
      r2 && v.addEventListener("scroll", t2, { passive: true }), i2 && v.addEventListener("resize", t2);
    });
    let m = u && a ? vr(u, t2) : null, c = -1, b = null;
    s2 && (b = new ResizeObserver((v) => {
      let [y] = v;
      y && y.target === u && b && (b.unobserve(o2), cancelAnimationFrame(c), c = requestAnimationFrame(() => {
        var x;
        (x = b) == null || x.observe(o2);
      })), t2();
    }), u && !l2 && b.observe(u), b.observe(o2));
    let f, h = l2 ? we(e2) : null;
    l2 && p();
    function p() {
      let v = we(e2);
      h && !cn(h, v) && t2(), h = v, f = requestAnimationFrame(p);
    }
    return t2(), () => {
      var v;
      g.forEach((y) => {
        r2 && y.removeEventListener("scroll", t2), i2 && y.removeEventListener("resize", t2);
      }), m?.(), (v = b) == null || v.disconnect(), b = null, l2 && cancelAnimationFrame(f);
    };
  }
  var dn = Qo;
  var pn = Yo;
  var mn = (e2, o2, t2) => {
    let n2 = /* @__PURE__ */ new Map(), r2 = { platform: Gt, ...t2 }, i2 = { ...r2.platform, _c: n2 };
    return Go(e2, o2, { ...r2, platform: i2 });
  };
  function gn(e2) {
    let o2 = () => {
    };
    return function(n2, r2) {
      if (o2(), !n2) {
        requestAnimationFrame(() => {
          qt(e2) ? Ft(e2, () => {
            e2.style.removeProperty("position");
          }) : e2.style.removeProperty("position");
        });
        return;
      }
      if (!r2 || !e2.hasAttribute("anchor")) return;
      let i2 = e2.getAttribute("anchor"), s2 = e2.getAttribute("anchor-strategy") || "absolute";
      s2 !== "absolute" && s2 !== "fixed" && (console.warn(`[createAnchorUpdater] Invalid anchor strategy "${s2}" for element:`, e2), s2 = "absolute"), o2 = fn(r2, e2, () => {
        let a = hn(window.getComputedStyle(e2).getPropertyValue("--anchor-gap"), e2), l2 = hn(window.getComputedStyle(e2).getPropertyValue("--anchor-offset"), e2), u = i2.split(" ")[0], g = {};
        switch (u) {
          case "top":
          case "bottom":
            g = { top: a, left: -1 * l2, right: l2, bottom: a };
            break;
          case "left":
          case "right":
            g = { top: -1 * l2, bottom: l2, left: a, right: a };
            break;
        }
        mn(r2, e2, { strategy: s2, placement: i2.replace(" ", "-"), middleware: [pn({ padding: g }), dn({ padding: g })] }).then(async ({ x: m, y: c, placement: b }) => {
          if (!wr() && s2 === "absolute") {
            let p = null;
            for (let v = e2.parentElement; v; v = v.parentElement) {
              let y = getComputedStyle(v).position;
              if (y === "relative" || y === "absolute" || y === "fixed" || y === "sticky") {
                p = v;
                break;
              }
            }
            if (p) {
              let v = p.getBoundingClientRect();
              m -= v.left + window.scrollX, c -= v.top + window.scrollY;
            }
          }
          let f = `${m}px`, h = `${c}px`;
          switch (b.split("-")[0]) {
            case "top":
              h = `calc(${c}px - var(--anchor-gap, 0px))`, f = `calc(${m}px + var(--anchor-offset, 0px))`;
              break;
            case "right":
              f = `calc(${m}px + var(--anchor-gap, 0px))`, h = `calc(${c}px + var(--anchor-offset, 0px))`;
              break;
            case "bottom":
              h = `calc(${c}px + var(--anchor-gap, 0px))`, f = `calc(${m}px + var(--anchor-offset, 0px))`;
              break;
            case "left":
              f = `calc(${m}px - var(--anchor-gap, 0px))`, h = `calc(${c}px + var(--anchor-offset, 0px))`;
              break;
          }
          {
            let p = e2.getBoundingClientRect();
            if (p.x === 0 && p.y === 0 && p.width === 0 && p.height === 0) return;
          }
          Object.assign(e2.style, { left: f, top: h, position: s2 }), await Gt.isRTL?.(e2) && Object.assign(e2.style, { right: "unset", bottom: "unset" });
        });
      });
    };
  }
  function wr() {
    return "showPopover" in HTMLElement.prototype && HTMLElement.prototype.showPopover.toString().includes("[native code]");
  }
  function hn(e2, o2) {
    let t2 = document.createElement("div");
    o2.appendChild(t2), t2.style.setProperty("margin-top", "0px", "important"), t2.style.setProperty("margin-top", e2, "important");
    let n2 = parseFloat(window.getComputedStyle(t2).marginTop) || 0;
    return o2.removeChild(t2), n2;
  }
  function ze(e2) {
    return Yt(e2) && "tabIndex" in e2;
  }
  function Yt(e2) {
    return yr(e2) && "tagName" in e2;
  }
  function Qt(e2) {
    return Yt(e2) && "accessKey" in e2;
  }
  function yr(e2) {
    return typeof e2 != "object" || e2 === null ? false : "nodeType" in e2;
  }
  function bn(e2) {
    return Yt(e2) && "style" in e2;
  }
  function vn(e2) {
    return Qt(e2) && e2.nodeName === "INPUT";
  }
  function B(e2) {
    let o2 = e2.getBoundingClientRect();
    return !(!(o2.x !== 0 || o2.y !== 0 || o2.width !== 0 || o2.height !== 0) || (e2.ownerDocument.defaultView || window).getComputedStyle(e2).visibility === "hidden");
  }
  var wn = { get selectRequired() {
    let e2 = document.createElement("select");
    e2.setAttribute("required", "true");
    let o2 = e2.validationMessage;
    return Object.defineProperty(this, "selectRequired", { value: o2 }), o2;
  } };
  function Ge(e2, o2, t2) {
    function n2() {
      if (!B(e2)) {
        for (let r2 of e2.children) if (B(r2)) return;
        t2();
      }
    }
    if (typeof ResizeObserver < "u") {
      let r2 = new ResizeObserver(n2);
      r2.observe(e2), o2.addEventListener("abort", () => r2.disconnect());
    }
    if (typeof IntersectionObserver < "u") {
      let r2 = new IntersectionObserver(n2);
      r2.observe(e2), o2.addEventListener("abort", () => r2.disconnect());
    }
  }
  var ae = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e2) => `${e2}:not([tabindex='-1'])`).join(",");
  function Y(e2, o2, t2) {
    let n2 = o2 ? e2.indexOf(o2) : null;
    switch (n2 === -1 && (n2 = null), t2) {
      case 0: {
        for (let r2 = 0; r2 < e2.length; r2++) if (B(e2[r2])) return e2[r2];
        return null;
      }
      case 1: {
        for (let r2 = e2.length - 1; r2 >= 0; r2--) if (B(e2[r2])) return e2[r2];
        return null;
      }
      case 2: {
        if (n2 === null) return Y(e2, o2, 1);
        for (let r2 = n2 - 1; r2 >= 0; r2--) if (B(e2[r2])) return e2[r2];
        return null;
      }
      case 3: {
        if (n2 === null) return Y(e2, o2, 0);
        for (let r2 = n2 + 1; r2 < e2.length; r2++) if (B(e2[r2])) return e2[r2];
        return null;
      }
      case 4:
        return null;
    }
  }
  var N = [];
  ut(() => {
    function e2(o2) {
      if (o2.target === document.body || N[0] === o2.target) return;
      let t2 = o2.target;
      t2 && "closest" in t2 && (t2 = t2.closest(ae), N.unshift(t2 ?? o2.target), N = N.filter((n2) => n2 != null && n2.isConnected), N.splice(10));
    }
    window.addEventListener("click", e2, { capture: true }), window.addEventListener("pointerdown", e2, { capture: true }), window.addEventListener("focus", e2, { capture: true }), document.body.addEventListener("click", e2, { capture: true }), document.body.addEventListener("pointerdown", e2, { capture: true }), document.body.addEventListener("focus", e2, { capture: true });
  });
  var Ye = false;
  var Xt = false;
  typeof navigator < "u" && (Ye = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), Xt = navigator.userAgent.toLowerCase().includes("firefox"));
  var Jt = false;
  function Me(e2, o2, t2, n2, r2, i2) {
    Ar(e2.ownerDocument);
    let s2 = Pe(e2), a = gn(e2), l2 = J();
    e2.hasAttribute("popover") || e2.setAttribute("popover", "");
    let u = t2();
    for (let c of u) c.setAttribute("type", "button"), c.setAttribute("aria-haspopup", "true"), c.setAttribute("aria-controls", e2.id), c.setAttribute("aria-expanded", "false");
    e2.hasAttribute("open") && queueMicrotask(() => e2.showPopover());
    function g() {
      e2.hasAttribute("open") && e2.hidePopover();
    }
    let m = new AbortController();
    o2.addEventListener("abort", () => m.abort()), e2.addEventListener("beforetoggle", (c) => {
      let b = vt(c, u);
      a(c.newState === "open", n2?.() ?? b), c.newState === "open" ? b && (Ge(b, m.signal, g), Ge(e2, m.signal, g)) : (m.abort(), m = new AbortController());
      let f = e2.hasAttribute("open");
      c.newState === "open" && !f ? e2.setAttributeNoCallbacks("open", "") : c.newState === "closed" && f && e2.removeAttributeNoCallbacks("open"), c.newState === "open" ? (b?.setAttribute("aria-expanded", "true"), b?.id && e2.setAttribute("aria-labelledby", b.id), r2?.(), Jt = e2.getAttribute("popover") === "") : (b?.setAttribute("aria-expanded", "false"), e2.removeAttribute("aria-labelledby"), i2?.(), Jt = false), c.oldState === "closed" && c.newState === "open" ? (Ye && (l2.dispose(), l2 = J()), s2.start("in")) : c.oldState === "open" && c.newState === "closed" && (Ye && l2.style(e2, "transition-property", "none"), s2.start("out"));
    }, { signal: o2 }), o2.addEventListener("abort", () => s2.abort());
  }
  function vt(e2, o2) {
    return e2.source ?? N.find((t2) => o2.includes(t2)) ?? o2[0] ?? null;
  }
  var yn = /* @__PURE__ */ new WeakSet();
  function Ar(e2) {
    if (Xt || Ye || yn.has(e2)) return;
    yn.add(e2);
    let o2 = null;
    e2.addEventListener("mousedown", () => {
      Jt && (e2.body.setAttribute("tabindex", "-1"), o2 && clearTimeout(o2), o2 = setTimeout(() => e2.body.removeAttribute("tabindex")));
    }, { capture: true });
  }
  function z(e2, o2, t2, n2) {
    function r2() {
      let a = e2.getBoundingClientRect();
      n2.style.setProperty(o2, a.width + "px");
    }
    let i2 = e2.ownerDocument, s2 = new ResizeObserver(r2);
    s2.observe(e2), i2.addEventListener("transitionend", r2, { signal: t2 }), t2.addEventListener("abort", () => s2.disconnect());
  }
  var xr = 0;
  function k(e2) {
    return `${e2}-${xr++}`;
  }
  var Tr = 200;
  function ue(e2, o2, t2, n2) {
    Sr(), e2.addEventListener(o2, (r2) => {
      Zt !== null && Date.now() - Zt < Tr || n2(r2);
    }, { passive: true, signal: t2 });
  }
  var Zt = null;
  var An = false;
  function Sr() {
    An || (An = true, document.addEventListener("keydown", () => {
      Zt = Date.now();
    }, { capture: true }));
  }
  var wt = class extends Map {
    constructor(t2) {
      super();
      this.factory = t2;
    }
    get(t2) {
      let n2 = super.get(t2);
      return n2 === void 0 && (n2 = this.factory(t2, this), this.set(t2, n2)), n2;
    }
  };
  var xn = new wt(() => ({ referenceCounter: 0, d: J() }));
  function yt(e2) {
    let o2 = xn.get(e2);
    if (o2.referenceCounter++, o2.referenceCounter === 1) {
      let n2 = [kr(), Ir(), Lr()];
      n2.forEach(({ before: r2 }) => r2({ doc: e2, d: o2.d })), n2.forEach(({ after: r2 }) => r2({ doc: e2, d: o2.d }));
    }
    let t2 = false;
    return () => {
      t2 || (t2 = true, o2.referenceCounter--, !(o2.referenceCounter > 0) && (o2.d.dispose(), xn.delete(e2)));
    };
  }
  function Lr() {
    return { before({ doc: e2, d: o2 }) {
      o2.style(e2.documentElement, "overflow", "hidden");
    }, after() {
    } };
  }
  function Ir() {
    let e2;
    return { before({ doc: o2 }) {
      let t2 = o2.documentElement, n2 = o2.defaultView ?? window;
      e2 = Math.max(0, n2.innerWidth - t2.clientWidth), t2.style.setProperty("--el-top-layer-scrollbar-offset", "0px");
    }, after({ doc: o2, d: t2 }) {
      let n2 = o2.documentElement, r2 = Math.max(0, n2.clientWidth - n2.offsetWidth), i2 = Math.max(0, e2 - r2);
      t2.style(n2, "paddingRight", `${i2}px`), t2.add(() => {
        n2.style.setProperty("--el-top-layer-scrollbar-offset", `-${i2}px`);
      });
    } };
  }
  function Pr() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
  }
  function kr() {
    return Pr() ? { before({ doc: e2, d: o2 }) {
      function t2(n2) {
        return !!n2.closest("[popover], dialog > *");
      }
      o2.microTask(() => {
        if (window.getComputedStyle(e2.documentElement).scrollBehavior !== "auto") {
          let i2 = J();
          i2.style(e2.documentElement, "scrollBehavior", "auto"), o2.add(() => o2.microTask(() => i2.dispose()));
        }
        let n2 = window.scrollY ?? window.pageYOffset, r2 = null;
        o2.addEventListener(e2, "click", (i2) => {
          if (ze(i2.target)) try {
            let s2 = i2.target.closest("a");
            if (!s2) return;
            let { hash: a } = new URL(s2.href), l2 = e2.querySelector(a);
            ze(l2) && !t2(l2) && (r2 = l2);
          } catch {
          }
        }, true), o2.addEventListener(e2, "touchstart", (i2) => {
          if (ze(i2.target) && bn(i2.target)) if (t2(i2.target)) {
            let s2 = i2.target;
            for (; s2.parentElement && t2(s2.parentElement); ) s2 = s2.parentElement;
            o2.style(s2, "overscrollBehavior", "contain");
          } else o2.style(i2.target, "touchAction", "none");
        }), o2.addEventListener(e2, "touchmove", (i2) => {
          if (ze(i2.target)) {
            if (vn(i2.target)) return;
            if (t2(i2.target)) {
              let s2 = i2.target;
              for (; s2.parentElement && s2.dataset.tailwindplusPortal !== "" && !(s2.scrollHeight > s2.clientHeight || s2.scrollWidth > s2.clientWidth); ) s2 = s2.parentElement;
              s2.dataset.tailwindplusPortal === "" && i2.preventDefault();
            } else i2.preventDefault();
          }
        }, { passive: false }), o2.add(() => {
          let i2 = window.scrollY ?? window.pageYOffset;
          n2 !== i2 && window.scrollTo(0, n2), r2 && r2.isConnected && (r2.scrollIntoView({ block: "nearest" }), r2 = null);
        });
      });
    }, after() {
    } } : { before() {
    }, after() {
    } };
  }
  function Et(e2, o2) {
    let t2 = null;
    e2.addEventListener("toggle", (n2) => {
      n2.newState === "open" ? t2 || (t2 = yt(e2.ownerDocument)) : t2 && (t2(), t2 = null);
    }, { signal: o2 }), o2.addEventListener("abort", () => {
      t2 && (t2(), t2 = null);
    });
  }
  var Tn = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
  function At(e2) {
    let o2 = e2.innerText ?? "", t2 = e2.cloneNode(true);
    if (!Qt(t2)) return o2;
    let n2 = false;
    for (let i2 of t2.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) i2.remove(), n2 = true;
    let r2 = n2 ? t2.innerText ?? "" : o2;
    return Tn.test(r2) && (r2 = r2.replace(Tn, "")), r2;
  }
  function Sn(e2) {
    let o2 = e2.getAttribute("aria-label");
    if (typeof o2 == "string") return o2.trim();
    let t2 = e2.getAttribute("aria-labelledby");
    if (t2) {
      let n2 = t2.split(" ").map((r2) => {
        let i2 = document.getElementById(r2);
        if (i2) {
          let s2 = i2.getAttribute("aria-label");
          return typeof s2 == "string" ? s2.trim() : At(i2).trim();
        }
        return null;
      }).filter(Boolean);
      if (n2.length > 0) return n2.join(", ");
    }
    return At(e2).trim();
  }
  var F;
  var Qe;
  var eo = class extends A {
    constructor() {
      super(...arguments);
      L(this, F, []);
      L(this, Qe, null);
    }
    mount(t2) {
      let n2 = this.getInput(), r2 = this.getButton(), i2 = this.getOptions();
      n2.id || (n2.id = k("autocomplete-input")), r2 && (r2.id || (r2.id = k("autocomplete-button"))), i2.id || (i2.id = k("autocomplete-listbox")), Me(i2, t2, () => {
        let c = this.getButton();
        return c ? [c] : [];
      }, () => this.getInput(), () => this.onBeforeOpen(), () => this.onBeforeClose()), Et(i2, t2), n2.setAttribute("role", "combobox"), n2.setAttribute("aria-autocomplete", "list"), n2.setAttribute("aria-expanded", "false"), n2.setAttribute("aria-controls", i2.id), n2.setAttribute("aria-activedescendant", ""), n2.setAttribute("autocomplete", "off"), r2 && (r2.setAttribute("type", "button"), r2.setAttribute("tabindex", "-1"), r2.setAttribute("aria-expanded", "false"), r2.setAttribute("aria-haspopup", "listbox"), r2.setAttribute("popovertarget", i2.id)), i2.setAttribute("role", "listbox"), i2.setAttribute("popover", "manual");
      let s2 = this, a = /* @__PURE__ */ new WeakSet();
      function l2() {
        for (let c of i2.getItems()) a.has(c) || (a.add(c), c.id || (c.id = k("option")), c.setAttribute("role", "option"), c.setAttribute("aria-selected", "false"), c.setAttribute("tabIndex", "-1"), c.addEventListener("mousedown", (b) => {
          b.button === 0 && (b.preventDefault(), s2.selectOption(c));
        }, { signal: t2 }), ue(c, "mouseover", t2, () => s2.setActiveItem(c, false)), ue(c, "mouseout", t2, () => s2.clearActiveItem()));
        s2.filterOptions();
      }
      l2();
      let u = new MutationObserver(l2);
      u.observe(this, { attributes: false, childList: true, subtree: true }), r2 && z(r2, "--button-width", t2, this), z(n2, "--input-width", t2, this), n2.addEventListener("input", () => {
        n2.matches(":disabled") || (this.filterOptions(), d(this, F).length > 0 ? i2.hasAttribute("open") || i2.showPopover() : i2.hidePopover());
      }, { signal: t2 });
      let g = () => {
        n2.matches(":disabled") || (n2.focus(), i2.hasAttribute("open") ? i2.hidePopover() : (this.filterOptions(), d(this, F).length > 0 && i2.showPopover()));
      };
      n2.addEventListener("pointerdown", g, { signal: t2 }), r2 && (r2.addEventListener("pointerdown", (c) => {
        c.preventDefault(), g();
      }, { signal: t2 }), r2.addEventListener("click", (c) => {
        c.preventDefault(), c.stopImmediatePropagation();
      }, { signal: t2 })), n2.addEventListener("blur", ({ relatedTarget: c }) => {
        c && this.contains(c) || i2.hidePopover();
      }, { signal: t2 }), n2.addEventListener("keydown", (c) => {
        if (!n2.matches(":disabled")) switch (c.key) {
          case "ArrowDown": {
            c.preventDefault(), i2.hasAttribute("open") || (d(this, F).length === 0 && this.filterOptions(), d(this, F).length > 0 && i2.showPopover()), this.goToItem(3);
            break;
          }
          case "ArrowUp": {
            c.preventDefault(), i2.hasAttribute("open") || (d(this, F).length === 0 && this.filterOptions(), d(this, F).length > 0 && i2.showPopover()), this.goToItem(2);
            break;
          }
          case "Home":
          case "PageUp":
            return i2.hasAttribute("open") ? (c.preventDefault(), c.stopPropagation(), this.goToItem(0)) : void 0;
          case "End":
          case "PageDown":
            return i2.hasAttribute("open") ? (c.preventDefault(), c.stopPropagation(), this.goToItem(1)) : void 0;
          case "Enter": {
            let b = this.getActiveItem();
            b && (c.preventDefault(), this.selectOption(b)), i2.hasAttribute("open") && (c.preventDefault(), i2.hidePopover());
            break;
          }
          case "Escape": {
            if (!i2.hasAttribute("open")) return;
            c.preventDefault(), i2.hidePopover();
            break;
          }
          case "Tab": {
            i2.hidePopover();
            break;
          }
        }
      }, { signal: t2 });
      let m = Array.from(i2.querySelectorAll("el-option[disabled]"));
      for (let c of m) c.setAttribute("aria-disabled", "true"), c.setAttribute("aria-selected", "false");
      t2.addEventListener("abort", () => {
        u.disconnect();
      });
    }
    getInput() {
      let t2 = this.querySelector("input");
      if (!t2) throw new Error("`<el-autocomplete>` must contain an input element.");
      return t2;
    }
    getButton() {
      return this.querySelector("button");
    }
    getOptions() {
      let t2 = this.querySelector("el-options");
      if (!t2) throw new Error("`<el-autocomplete>` must contain a `<el-options>` element.");
      return t2;
    }
    filterOptions() {
      let t2 = this.getInput().value.toLowerCase();
      d(this, Qe) !== t2 && (this.clearActiveItem(), I(this, Qe, t2)), I(this, F, []);
      for (let n2 of this.getOptions().getItems()) {
        let r2 = n2.getAttribute("value")?.toLowerCase() || "", i2 = At(n2)?.trim().toLowerCase() ?? "";
        t2 === "" || r2.includes(t2) || i2.includes(t2) ? (d(this, F).push(n2), n2.removeAttribute("hidden"), n2.removeAttribute("aria-hidden")) : (n2.setAttribute("hidden", ""), n2.setAttribute("aria-hidden", "true"));
      }
    }
    getActiveItem() {
      let n2 = this.getInput().getAttribute("aria-activedescendant");
      return n2 ? document.getElementById(n2) : null;
    }
    goToItem(t2) {
      if (d(this, F).length === 0) return;
      let n2 = this.getActiveItem(), r2 = Y(d(this, F), n2, t2);
      r2 && this.setActiveItem(r2);
    }
    setActiveItem(t2, n2 = true) {
      let r2 = this.getInput(), i2 = this.getActiveItem();
      i2 !== null && i2.setAttribute("aria-selected", "false"), t2.setAttribute("aria-selected", "true"), r2.setAttribute("aria-activedescendant", t2.id), n2 && t2.scrollIntoView({ block: "nearest" });
    }
    clearActiveItem() {
      let t2 = this.getInput(), n2 = this.getActiveItem();
      n2 !== null && n2.setAttribute("aria-selected", "false"), t2.setAttribute("aria-activedescendant", "");
    }
    selectOption(t2) {
      let n2 = this.getInput(), r2 = t2.getAttribute("value");
      r2 && (n2.value = r2, n2.dispatchEvent(new Event("input", { bubbles: true, cancelable: true })), n2.dispatchEvent(new Event("change", { bubbles: true, cancelable: true })), this.getOptions().hidePopover());
    }
    onBeforeOpen() {
      let t2 = this.getInput(), n2 = this.getButton();
      t2.setAttribute("aria-expanded", "true"), n2?.setAttribute("aria-expanded", "true");
    }
    onBeforeClose() {
      let t2 = this.getInput(), n2 = this.getButton();
      t2.setAttribute("aria-expanded", "false"), n2?.setAttribute("aria-expanded", "false"), this.clearActiveItem();
    }
  };
  F = /* @__PURE__ */ new WeakMap(), Qe = /* @__PURE__ */ new WeakMap();
  T("el-autocomplete", eo);
  var G;
  var Xe;
  var Je;
  var te;
  var xt;
  var no;
  var oo = class extends A {
    constructor() {
      super(...arguments);
      L(this, te);
      L(this, G, []);
      L(this, Xe, null);
      L(this, Je, ({ query: t2, content: n2 }) => n2.toLocaleLowerCase().includes(t2.toLocaleLowerCase().trim()));
    }
    mount(t2) {
      let n2 = this.getInput(), r2 = this.getItems();
      n2.id || (n2.id = k("command-input")), r2.id || (r2.id = k("command-items")), n2.setAttribute("role", "combobox"), n2.setAttribute("aria-autocomplete", "list"), n2.setAttribute("autocomplete", "off"), n2.setAttribute("aria-controls", r2.id), r2.setAttribute("role", "listbox");
      let i2 = this, s2 = /* @__PURE__ */ new WeakSet();
      function a(u = false) {
        var g;
        for (let m of r2.getItems()) s2.has(m) || (s2.add(m), m.id || (m.id = k("item")), m.setAttribute("role", "option"), m.setAttribute("tabIndex", "-1"), m.setAttribute("aria-selected", "false"), m.hasAttribute("disabled") && m.setAttribute("aria-disabled", "true"), ue(m, "mouseover", t2, () => {
          var c;
          return H(c = i2, te, no).call(c, m, false);
        }));
        H(g = i2, te, xt).call(g, u), u || i2.goToItem(0);
      }
      a(true);
      let l2 = new MutationObserver(() => a(false));
      l2.observe(this, { attributes: false, childList: true, subtree: true }), z(n2, "--input-width", t2, this), n2.addEventListener("input", () => H(this, te, xt).call(this), { signal: t2 }), n2.addEventListener("keydown", (u) => {
        switch (u.key) {
          case "ArrowDown": {
            u.preventDefault(), this.goToItem(3);
            break;
          }
          case "ArrowUp": {
            u.preventDefault(), this.goToItem(2);
            break;
          }
          case "Home":
          case "PageUp":
            return u.preventDefault(), u.stopPropagation(), this.goToItem(0);
          case "End":
          case "PageDown":
            return u.preventDefault(), u.stopPropagation(), this.goToItem(1);
          case "Enter": {
            let g = this.getActiveItem();
            g && (u.preventDefault(), g.click());
            break;
          }
          case "Tab":
            break;
        }
      }, { signal: t2 }), t2.addEventListener("abort", () => {
        l2.disconnect();
      });
    }
    getInput() {
      let t2 = this.querySelector("input");
      if (!t2) throw new Error("`<el-command-palette>` must contain an input element.");
      return t2;
    }
    getItems() {
      let t2 = this.querySelector("el-command-list");
      if (!t2) throw new Error("`<el-command-palette>` must contain a `<el-command-list>` element.");
      return t2;
    }
    getGroups() {
      return this.getItems().querySelectorAll("el-command-group");
    }
    getSuggestions() {
      return this.querySelector("el-defaults");
    }
    getActiveItem() {
      let n2 = this.getInput().getAttribute("aria-activedescendant");
      return n2 ? document.getElementById(n2) : null;
    }
    goToItem(t2) {
      if (d(this, G).length === 0) return;
      let n2 = this.getActiveItem(), r2 = Y(d(this, G), n2, t2);
      r2 && H(this, te, no).call(this, r2);
    }
    clearActiveItem() {
      let t2 = this.getInput(), n2 = this.getActiveItem();
      if (n2 !== null) {
        n2.setAttribute("aria-selected", "false");
        let r2 = this.querySelector(`el-command-preview[for="${n2.id}"]`);
        r2 && r2.setAttribute("hidden", "");
      }
      t2.removeAttribute("aria-activedescendant"), this.dispatchEvent(new CustomEvent("change", { detail: { relatedTarget: null }, bubbles: false, cancelable: false }));
    }
    reset() {
      let t2 = this.getInput();
      t2.value = "", t2.dispatchEvent(new Event("input", { bubbles: true, cancelable: true })), t2.dispatchEvent(new Event("change", { bubbles: true, cancelable: true })), H(this, te, xt).call(this, true), this.clearActiveItem();
    }
    setFilterCallback(t2) {
      I(this, Je, t2);
    }
  };
  G = /* @__PURE__ */ new WeakMap(), Xe = /* @__PURE__ */ new WeakMap(), Je = /* @__PURE__ */ new WeakMap(), te = /* @__PURE__ */ new WeakSet(), xt = function(t2 = false) {
    let n2 = this.getItems(), r2 = this.getInput().value ?? "";
    I(this, G, []);
    for (let a of n2.getItems()) {
      if (a.closest("el-defaults")) continue;
      let l2 = Sn(a) ?? "";
      r2 === "" || !d(this, Je).call(this, { query: r2, node: a, content: l2 }) ? (a.setAttribute("hidden", ""), a.setAttribute("aria-hidden", "true")) : (d(this, G).push(a), a.removeAttribute("hidden"), a.removeAttribute("aria-hidden"));
    }
    for (let a of this.getGroups()) a.getItems().some((u) => !u.hasAttribute("hidden")) ? a.removeAttribute("hidden") : a.setAttribute("hidden", "");
    let i2 = this.getSuggestions();
    i2 && (r2 === "" ? (i2.removeAttribute("hidden"), I(this, G, i2.getItems())) : i2.setAttribute("hidden", ""));
    let s2 = this.querySelector("el-no-results");
    s2 && (r2 === "" || d(this, G).length > 0 ? s2.setAttribute("hidden", "") : s2.removeAttribute("hidden")), d(this, G).length === 0 ? n2.setAttribute("hidden", "") : n2.removeAttribute("hidden"), !(t2 && r2 === "") && (d(this, G).length === 0 ? this.clearActiveItem() : d(this, Xe) !== r2 && this.goToItem(0), I(this, Xe, r2));
  }, no = function(t2, n2 = true) {
    let r2 = this.getInput(), i2 = this.getActiveItem();
    if (t2 === i2) return;
    if (i2 !== null) {
      i2.setAttribute("aria-selected", "false");
      let a = this.querySelector(`el-command-preview[for="${i2.id}"]`);
      a && a.setAttribute("hidden", "");
    }
    t2.setAttribute("aria-selected", "true"), r2.setAttribute("aria-activedescendant", t2.id);
    let s2 = this.querySelector(`el-command-preview[for="${t2.id}"]`);
    s2 && s2.removeAttribute("hidden"), n2 && t2.scrollIntoView({ block: "nearest" }), this.dispatchEvent(new CustomEvent("change", { detail: { relatedTarget: t2 }, bubbles: false, cancelable: false }));
  };
  var ro = class extends A {
    getItems() {
      return Array.from(this.querySelectorAll(`${ae},[role="option"]`));
    }
  };
  var io = class extends A {
    getItems() {
      return Array.from(this.querySelectorAll(`${ae},[role="option"]`));
    }
  };
  var so = class extends A {
  };
  var lo = class extends A {
  };
  var ao = class extends A {
    getItems() {
      return Array.from(this.querySelectorAll(`${ae},[role="option"]`));
    }
  };
  T("el-command-palette", oo);
  T("el-command-list", ro);
  T("el-defaults", io);
  T("el-no-results", so);
  T("el-command-group", ao);
  T("el-command-preview", lo);
  var He = null;
  typeof globalThis.window < "u" && (He = HTMLDialogElement.prototype.close, Object.defineProperties(HTMLDialogElement.prototype, { close: { value() {
    let e2 = this.closest("el-dialog");
    if (!(e2 instanceof Re)) return He?.apply(this, arguments);
    let o2 = e2.beforeClose();
    if (o2 === true) return He?.apply(this, arguments);
    o2 !== false && o2.then((t2) => t2 ? He?.apply(this, arguments) : null).catch(console.error);
  } } }), document.addEventListener("command", (e2) => {
    let o2 = e2.target;
    if (!(o2 instanceof HTMLDialogElement) || !("command" in e2) || e2.command !== "close") return;
    let t2 = o2.closest("el-dialog");
    if (!(t2 instanceof Re)) return;
    let n2 = t2.beforeClose();
    n2 !== true && (e2.stopImmediatePropagation(), e2.preventDefault(), n2 !== false && n2.then((r2) => r2 ? He?.apply(o2) : null).catch(console.error));
  }, true));
  var Q;
  var oe;
  var Be;
  var ye;
  var Ze;
  var uo;
  var Re = class extends A {
    constructor() {
      super(...arguments);
      L(this, Ze);
      L(this, Q, null);
      L(this, oe, null);
      L(this, Be, true);
      L(this, ye, Pe(this, () => Array.from(this.querySelectorAll("el-dialog-panel,el-dialog-backdrop"))));
    }
    mount(t2) {
      let n2 = this.getNativeDialog();
      n2.removeAttribute("open"), n2.style.setProperty("right", "var(--el-top-layer-scrollbar-offset, 0px)");
      let r2 = this.hasAttribute("open");
      for (let a of H(this, Ze, uo).call(this)) a.setAttribute("aria-expanded", r2.toString());
      Cr(n2, t2, (a) => {
        a.preventDefault();
        let l2 = new Event("cancel", { bubbles: false, cancelable: true });
        !this.dispatchEvent(l2) || n2.close();
      });
      let i2 = this.querySelector("el-dialog-panel");
      Ge(i2 ?? n2, t2, () => {
        this.hasAttribute("open") && n2.close();
      });
      let s2 = null;
      n2.addEventListener("beforetoggle", (a) => {
        let l2 = a;
        l2.newState === "open" && l2.oldState === "closed" && this.beforeOpen();
        let u = this.hasAttribute("open");
        if (l2.newState === "open" && !u ? (this.dispatchEvent(new CustomEvent("open", { bubbles: false, cancelable: false })), this.setAttribute("open", "")) : l2.newState === "closed" && u && (this.dispatchEvent(new CustomEvent("close", { bubbles: false, cancelable: false })), this.removeAttribute("open")), l2.newState === "open" && l2.oldState === "closed") N.length > 0 && !s2 && (s2 = N[0]);
        else if (l2.newState === "closed" && l2.oldState === "open") {
          let g = d(this, Be);
          setTimeout(() => {
            if (!g) {
              s2 && s2 === document.activeElement && s2.isConnected && "blur" in s2 && typeof s2.blur == "function" && s2.blur();
              return;
            }
            s2 && s2 !== document.activeElement && s2.isConnected && Le(s2), s2 = null;
          });
        }
      }, { signal: t2 }), n2.addEventListener("focusout", (a) => {
        a.relatedTarget === null && queueMicrotask(() => {
          n2.contains(n2.ownerDocument.activeElement) || n2.focus();
        });
      }, { signal: t2 }), t2.addEventListener("abort", () => {
        var a;
        d(this, ye).abort(), (a = d(this, oe)) == null || a.call(this);
      }), this.hasAttribute("open") && n2.showModal();
    }
    onAttributeChange(t2, n2, r2) {
      switch (t2) {
        case "open": {
          let i2 = this.getNativeDialog();
          for (let s2 of H(this, Ze, uo).call(this)) s2.setAttribute("aria-expanded", r2 !== null ? "true" : "false");
          r2 === null ? i2.close() : i2.showModal();
          break;
        }
      }
    }
    getNativeDialog() {
      let t2 = this.querySelector("dialog");
      if (!t2) throw new Error("[ElDialog] No `<dialog>` element found");
      return t2;
    }
    beforeOpen() {
      I(this, Be, true), d(this, Q) && (d(this, Q).abort(), I(this, Q, null)), d(this, oe) || I(this, oe, yt(this.ownerDocument)), d(this, ye) && d(this, ye).start("in");
    }
    beforeClose() {
      if (d(this, oe) && (d(this, oe).call(this), I(this, oe, null)), d(this, Q)) return false;
      I(this, Q, new AbortController());
      let t2 = d(this, Q).signal;
      return new Promise((n2) => {
        d(this, ye)?.start("out", () => {
          t2.aborted || (I(this, Q, null), requestAnimationFrame(() => {
            let r2 = this.getNativeDialog(), i2 = r2.style.cssText;
            r2.style.cssText = i2 + "transition-duration: 0 !important;", He?.apply(r2), requestAnimationFrame(() => {
              r2.style.cssText = i2;
            });
          }), n2(true));
        });
      });
    }
    show() {
      this.getNativeDialog().showModal();
    }
    hide({ restoreFocus: t2 = true } = {}) {
      I(this, Be, t2), this.getNativeDialog().close();
    }
  };
  Q = /* @__PURE__ */ new WeakMap(), oe = /* @__PURE__ */ new WeakMap(), Be = /* @__PURE__ */ new WeakMap(), ye = /* @__PURE__ */ new WeakMap(), Ze = /* @__PURE__ */ new WeakSet(), uo = function() {
    return document.querySelectorAll(`[commandfor="${this.getNativeDialog().id}"]`);
  }, M(Re, "observedAttributes", ["open"]);
  var co = class extends A {
    mount(o2) {
      Or(this, o2, () => {
        let t2 = this.getDialog(), n2 = t2.getNativeDialog();
        if (!n2.hasAttribute("open")) return;
        let r2 = new Event("cancel", { bubbles: false, cancelable: true });
        !t2.dispatchEvent(r2) || n2.close();
      });
    }
    getDialog() {
      let o2 = this.closest("el-dialog");
      if (!o2) throw new Error("[ElDialogPanel] No `<el-dialog>` parent found");
      return o2;
    }
  };
  var fo = class extends A {
    mount() {
      this.setAttribute("inert", "");
    }
  };
  T("el-dialog", Re);
  T("el-dialog-panel", co);
  T("el-dialog-backdrop", fo);
  function Or(e2, o2, t2) {
    let n2 = null;
    document.addEventListener("pointerdown", (r2) => {
      n2 = r2.composedPath()[0] || r2.target;
    }, true), document.addEventListener("click", (r2) => {
      if (n2 !== r2.target) return;
      if (r2.target === e2) {
        let { clientX: s2, clientY: a } = r2, l2 = e2.getBoundingClientRect();
        if (s2 >= l2.left && s2 <= l2.right && a >= l2.top && a <= l2.bottom) return;
        t2(r2);
        return;
      }
      let i2 = e2.closest("dialog");
      if (i2 && i2.contains(r2.target) && !e2.contains(r2.target)) {
        t2(r2);
        return;
      }
      if (r2.target === r2.target.ownerDocument.documentElement) {
        t2(r2);
        return;
      }
    }, { signal: o2, capture: true });
  }
  function Cr(e2, o2, t2) {
    e2.addEventListener("keydown", (n2) => {
      n2.key === "Escape" && (n2.defaultPrevented || t2(n2));
    }, { signal: o2 });
  }
  var Ne;
  var et;
  var po;
  var Tt = class extends A {
    constructor() {
      super(...arguments);
      L(this, et);
      L(this, Ne, Pe(this));
    }
    mount(t2) {
      this.id || (this.id = k("disclosure")), this.hasAttribute("hidden") ? this.removeAttributeNoCallbacks("open") : this.setAttributeNoCallbacks("open", "");
      let n2 = !this.hasAttribute("hidden");
      for (let r2 of H(this, et, po).call(this)) r2.setAttribute("aria-expanded", n2.toString()), r2.setAttribute("aria-controls", this.id);
      this.addEventListener("command", (r2) => {
        if (r2.target instanceof HTMLElement && "command" in r2) switch (r2.command) {
          case "--show": {
            this.show(), r2.preventDefault();
            break;
          }
          case "--hide": {
            this.hide(), r2.preventDefault();
            break;
          }
          case "--toggle": {
            this.toggle(), r2.preventDefault();
            break;
          }
        }
      }, { signal: t2 }), t2.addEventListener("abort", () => d(this, Ne).abort());
    }
    onAttributeChange(t2, n2, r2) {
      switch (t2) {
        case "hidden": {
          r2 === null ? this.setAttributeNoCallbacks("open", "") : this.removeAttributeNoCallbacks("open");
          for (let i2 of H(this, et, po).call(this)) i2.setAttribute("aria-expanded", r2 === null ? "true" : "false");
          r2 === null ? d(this, Ne).start("in") : d(this, Ne).start("out");
          break;
        }
        case "open": {
          r2 === null ? this.hide() : this.show();
          break;
        }
      }
    }
    show() {
      this.removeAttribute("hidden");
    }
    hide() {
      this.setAttribute("hidden", "");
    }
    toggle() {
      this.hasAttribute("hidden") ? this.show() : this.hide();
    }
  };
  Ne = /* @__PURE__ */ new WeakMap(), et = /* @__PURE__ */ new WeakSet(), po = function() {
    return document.querySelectorAll(`[commandfor="${this.id}"]`);
  }, M(Tt, "observedAttributes", ["hidden", "open"]);
  T("el-disclosure", Tt);
  function St(e2, o2, t2, n2, r2) {
    let i2 = null;
    for (let a of o2) a.addEventListener("pointerdown", (l2) => {
      l2.button === 0 && e2.classList.contains(":popover-open") && (i2 = Date.now() + 100);
    }, { signal: n2, capture: true });
    e2.ownerDocument.addEventListener("focusin", (a) => {
      if (!t2.hasAttribute("open")) return;
      let l2 = a.target, u = a.relatedTarget;
      l2 !== null && (i2 && Date.now() < i2 || e2.contains(l2) || o2.some((g) => g.contains(l2)) || r2(u));
    }, { signal: n2 });
  }
  var Dr = 200;
  function Lt(e2, o2, t2) {
    let n2 = null, r2 = "", i2 = null, s2 = null;
    e2.id || (e2.id = k(o2.role));
    let a = o2.getButton();
    a.id || (a.id = k(`${o2.role}-button`)), Me(e2, t2, () => [o2.getButton()], () => o2.getButton(), () => o2.onBeforeOpen(), () => {
      o2.onBeforeClose(), h(), r2 = "", i2 && (clearTimeout(i2), i2 = null);
    }), Et(e2, t2), e2.setAttribute("popover", "manual"), e2.setAttribute("role", o2.role), a.setAttribute("popovertarget", e2.id), a.setAttribute("aria-haspopup", o2.role);
    let l2 = /* @__PURE__ */ new WeakSet();
    function u() {
      let w = o2.getItems(), E = { passive: true, signal: t2 }, P = o2.role === "menu" ? "menuitem" : "option";
      for (let S of w) l2.has(S) || (l2.add(S), S.id || (S.id = k("item")), S.setAttribute("role", P), S.setAttribute("tabIndex", "-1"), S.addEventListener("click", () => o2.onItemClick(S), E), ue(S, "mouseover", t2, () => f(S, false)), ue(S, "mouseout", t2, () => h()));
    }
    u();
    let g = new MutationObserver(u);
    g.observe(e2, { attributes: false, childList: true, subtree: true }), St(e2, [a], e2, t2, (w) => {
      w === null && (s2 = Date.now() + 100), e2.hidePopover();
    });
    let m = null, c = false;
    a.addEventListener("pointerdown", (w) => {
      if (w.button === 0 && !a.matches(":disabled")) {
        if (w.pointerType === "touch") {
          c = true;
          return;
        }
        e2.togglePopover(), m = Date.now();
      }
    }, { signal: t2 }), document.addEventListener("pointerup", (w) => {
      if (w.button !== 0 || a.matches(":disabled") || !e2.hasAttribute("open")) return;
      if (Date.now() - (m ?? 0) > Dr) {
        let P = w.composedPath();
        if (P.includes(e2)) {
          if (m !== null) {
            let S = p();
            S && S.click();
          }
          return;
        }
        for (let S of P) {
          if (!(S instanceof Element)) continue;
          if ((S.getAttribute("commandfor") || S.getAttribute("popovertarget")) === e2.id) return;
        }
        e2.hidePopover();
      }
      m = null;
    }, { signal: t2, capture: true }), a.addEventListener("click", (w) => {
      if (c) {
        c = false;
        return;
      }
      w.preventDefault(), w.stopPropagation();
    }, { signal: t2 });
    let b = null;
    e2.addEventListener("beforetoggle", (w) => {
      let E = w;
      E.newState === "open" && E.oldState === "closed" && N.length > 0 && !b && (b = N[0]);
    }, { signal: t2 }), e2.addEventListener("toggle", (w) => {
      let E = w;
      E.newState === "closed" && E.oldState === "open" && setTimeout(() => {
        !e2.contains(document.activeElement) && document.activeElement !== document.body || s2 && Date.now() < s2 || (b && b !== document.activeElement && b.isConnected && Le(b), b = null);
      });
    }, { signal: t2 }), t2.addEventListener("abort", () => {
      i2 && (clearTimeout(i2), i2 = null), g.disconnect();
    });
    function f(w, E = true) {
      let P = p();
      P !== null && P.setAttribute("tabIndex", "-1"), e2.removeAttribute("tabIndex"), w.setAttribute("tabIndex", "0"), w.focus({ preventScroll: true }), n2 = w, E && w.scrollIntoView({ block: "nearest" });
    }
    function h() {
      let w = p();
      w !== null && w.setAttribute("tabIndex", "-1"), n2 = null, e2.hasAttribute("open") && (e2.setAttribute("tabIndex", "0"), e2.focus());
    }
    function p() {
      return n2;
    }
    function v(w, E = false) {
      if (w === "") return null;
      let P = o2.getItems(), S = w.toLowerCase(), $ = p(), re = $ ? P.indexOf($) : -1;
      if (!E && $ && re !== -1 && B($) && ($.textContent?.trim().toLowerCase() || "").startsWith(S)) return $;
      for (let D = re + 1; D < P.length; D++) if ((P[D].textContent?.trim().toLowerCase() || "").startsWith(S) && B(P[D])) return P[D];
      for (let D = 0; D <= re; D++) if ((P[D].textContent?.trim().toLowerCase() || "").startsWith(S) && B(P[D])) return P[D];
      return null;
    }
    function y(w) {
      let E = r2 === "";
      i2 && (clearTimeout(i2), i2 = null), r2 += w.toLowerCase();
      let P = v(r2, E);
      P && f(P, true), i2 = setTimeout(() => {
        r2 = "", i2 = null;
      }, 350);
    }
    function x() {
      return r2 !== "";
    }
    return { ignoreNextFocusRestoration: () => s2 = Date.now() + 100, setActiveItem: f, clearActiveItem: h, getActiveItem: p, findItemBySearchQuery: v, handleSearchKey: y, hasActiveSearchQuery: x };
  }
  var ne;
  var Ee;
  var O;
  var ot;
  var mo;
  var tt = class extends A {
    constructor() {
      super(...arguments);
      L(this, ot);
      L(this, ne, this.attachInternals());
      L(this, Ee, "");
      L(this, O, null);
    }
    mount(t2) {
      let n2 = this.getOptions();
      this.value = this.getAttribute("value") ?? this.value ?? "";
      let r2 = this.getButton();
      r2.id || (r2.id = k("select-button")), z(r2, "--button-width", t2, this), r2.addEventListener("keydown", (s2) => {
        if (!r2.matches(":disabled")) switch (s2.key) {
          case "ArrowUp": {
            n2.showPopover(), this.goToItem("selected"), s2.preventDefault();
            break;
          }
          case "ArrowDown": {
            n2.showPopover(), this.goToItem("selected"), s2.preventDefault();
            break;
          }
          case "Enter": {
            s2.preventDefault(), d(this, ne).form && d(this, ne).form.requestSubmit();
            break;
          }
          case " ": {
            if (n2.hasAttribute("open") && d(this, O) && d(this, O).hasActiveSearchQuery()) {
              s2.preventDefault(), s2.stopPropagation(), d(this, O).handleSearchKey(s2.key);
              break;
            }
            s2.preventDefault(), n2.hasAttribute("open") ? n2.hidePopover() : (n2.showPopover(), this.goToItem("selected"));
            break;
          }
          default: {
            n2.hasAttribute("open") && s2.key.length === 1 && !s2.ctrlKey && !s2.altKey && !s2.metaKey && (s2.preventDefault(), s2.stopPropagation(), this.handleSearchKey(s2.key));
            break;
          }
        }
      }, { signal: t2 });
      for (let s2 of d(this, ne).labels) s2.setAttribute("for", r2.id);
      I(this, O, Lt(n2, { role: "listbox", getItems: () => this.getItems(), onItemClick: (s2) => this.setSelectedOption(s2), getButton: () => this.getButton(), onBeforeOpen: () => this.onBeforeOpen(), onBeforeClose: () => this.onBeforeClose() }, t2)), n2.addEventListener("keydown", (s2) => {
        switch (s2.key) {
          case "ArrowDown":
            return s2.preventDefault(), s2.stopPropagation(), this.goToItem(3);
          case "ArrowUp":
            return s2.preventDefault(), s2.stopPropagation(), this.goToItem(2);
          case "Home":
          case "PageUp":
            return s2.preventDefault(), s2.stopPropagation(), this.goToItem(0);
          case "End":
          case "PageDown":
            return s2.preventDefault(), s2.stopPropagation(), this.goToItem(1);
          case " ":
            if (d(this, O) && d(this, O).hasActiveSearchQuery()) {
              s2.preventDefault(), s2.stopPropagation(), d(this, O).handleSearchKey(s2.key);
              return;
            }
          case "Enter": {
            s2.preventDefault(), s2.stopPropagation();
            let a = this.getActiveItem();
            a ? a.click() : n2.hidePopover();
            return;
          }
          case "Tab": {
            d(this, O) && d(this, O).ignoreNextFocusRestoration();
            break;
          }
          case "Escape": {
            s2.preventDefault(), s2.stopPropagation(), n2.hidePopover(), r2.focus();
            break;
          }
          default: {
            s2.key.length === 1 && !s2.ctrlKey && !s2.altKey && !s2.metaKey && (s2.preventDefault(), s2.stopPropagation(), d(this, O) && d(this, O).handleSearchKey(s2.key));
            break;
          }
        }
      }, { signal: t2 }), n2.addEventListener("toggle", (s2) => {
        s2.newState === "open" && this.onOpen();
      }, { signal: t2 });
      let i2 = Array.from(n2.querySelectorAll("el-option[disabled]"));
      for (let s2 of i2) s2.setAttribute("aria-disabled", "true"), s2.setAttribute("aria-selected", "false");
    }
    onAttributeChange(t2, n2, r2) {
      switch (t2) {
        case "value": {
          r2 !== null && (this.value = r2);
          break;
        }
        case "required": {
          H(this, ot, mo).call(this);
          break;
        }
      }
    }
    getButton() {
      let t2 = this.querySelector("button");
      if (!t2) throw new Error("`<el-select>` must contain a button element.");
      return t2;
    }
    getOptions() {
      let t2 = this.querySelector("el-options");
      if (!t2) throw new Error("`<el-select>` must contain a `<el-options>` element.");
      return t2;
    }
    setSelectedOption(t2) {
      this.value = t2.getAttribute("value"), this.dispatchEvent(new Event("input", { bubbles: true, cancelable: true })), this.dispatchEvent(new Event("change", { bubbles: true, cancelable: true })), this.getOptions().hidePopover();
    }
    getOptionByName(t2) {
      return this.getOptions().getOptionByName(t2);
    }
    getItems() {
      return this.getOptions().getItems();
    }
    getActiveItem() {
      return d(this, O)?.getActiveItem();
    }
    getSelectedOption() {
      return this.getOptionByName(d(this, Ee));
    }
    goToItem(t2 = 4) {
      let n2 = this.getItems();
      if (n2.length === 0) return;
      let r2 = this.getActiveItem();
      if (r2 === null && (t2 === 2 || t2 === 3)) {
        this.goToItem("selected");
        return;
      }
      if (t2 === "selected") {
        let s2 = this.getSelectedOption();
        s2 && B(s2) ? this.setActiveItem(s2) : this.goToItem(0);
        return;
      }
      let i2 = Y(n2, r2, t2);
      i2 && this.setActiveItem(i2);
    }
    setActiveItem(t2) {
      d(this, O) && d(this, O).setActiveItem(t2);
    }
    clearActiveItem() {
      d(this, O) && d(this, O).clearActiveItem();
    }
    onBeforeOpen() {
      let t2 = this.getButton(), n2 = t2.dataset.originalTabIndex;
      n2 && (t2.dataset.originalTabIndex = n2), t2.setAttribute("tabIndex", "-1");
    }
    onOpen() {
      this.getActiveItem() === null && this.goToItem("selected");
    }
    onBeforeClose() {
      let t2 = this.getButton(), n2 = t2.dataset.originalTabIndex;
      delete t2.dataset.originalTabIndex, n2 !== void 0 ? t2.setAttribute("tabIndex", n2) : t2.removeAttribute("tabIndex");
      let r2 = this.getActiveItem();
      r2 !== null && r2.setAttribute("tabIndex", "-1");
    }
    handleSearchKey(t2) {
      d(this, O) && d(this, O).handleSearchKey(t2);
    }
    set value(t2) {
      I(this, Ee, t2), d(this, ne).setFormValue(t2), H(this, ot, mo).call(this);
      let n2 = this.getSelectedOption();
      if (n2) {
        for (let r2 of this.getItems()) r2.setAttribute("aria-selected", "false");
        n2.setAttribute("aria-selected", "true");
        try {
          this.querySelectorAll("el-selectedcontent").forEach((r2) => r2.update());
        } catch {
        }
      }
    }
    get value() {
      return d(this, Ee);
    }
  };
  ne = /* @__PURE__ */ new WeakMap(), Ee = /* @__PURE__ */ new WeakMap(), O = /* @__PURE__ */ new WeakMap(), ot = /* @__PURE__ */ new WeakSet(), mo = function() {
    if (!this.hasAttribute("required") || d(this, Ee)) {
      d(this, ne).setValidity({});
      return;
    }
    d(this, ne).setValidity({ valueMissing: true }, wn.selectRequired, this.getButton());
  }, M(tt, "formAssociated", true), M(tt, "observedAttributes", ["required"]);
  var ho = class extends A {
    mount() {
      this.update();
    }
    update() {
      let t2 = this.getSelect().getSelectedOption();
      if (!t2) return;
      let n2 = document.createDocumentFragment();
      for (let r2 of t2.childNodes) n2.append(r2.cloneNode(true));
      this.replaceChildren(n2);
    }
    getSelect() {
      let o2 = this.closest("el-select");
      if (!o2) throw new Error("`<el-selectedcontent>` must be inside of a `<el-select>` element.");
      return o2;
    }
  };
  T("el-select", tt);
  T("el-selectedcontent", ho);
  var go = class extends A {
    getButton() {
      let o2 = this.querySelector("button");
      if (!o2) throw new Error("[ElDropdown] No `<button>` element found");
      return o2;
    }
    mount(o2) {
      let t2 = this.getButton();
      t2.id || (t2.id = k("dropdown-button")), z(t2, "--button-width", o2, this);
      let n2 = this.querySelectorAll("label");
      for (let r2 of n2) r2.setAttribute("for", t2.id);
    }
  };
  var C;
  var It = class extends A {
    constructor() {
      super(...arguments);
      L(this, C, null);
    }
    mount(t2) {
      I(this, C, Lt(this, { role: "menu", getItems: () => this.getItems(), onItemClick: () => this.hidePopover(), getButton: () => this.getDropdown().getButton(), onBeforeOpen: () => this.onBeforeOpen(), onBeforeClose: () => this.onBeforeClose() }, t2));
      let r2 = this.getDropdown().getButton();
      r2.addEventListener("keydown", (i2) => {
        if (!r2.disabled) switch (i2.key) {
          case "ArrowDown": {
            this.showPopover(), this.goToItem(0), i2.preventDefault();
            break;
          }
          case "ArrowUp": {
            this.showPopover(), this.goToItem(1), i2.preventDefault();
            break;
          }
          case " ":
            if (this.hasAttribute("open") && d(this, C) && d(this, C).hasActiveSearchQuery()) {
              i2.preventDefault(), i2.stopPropagation(), d(this, C).handleSearchKey(i2.key);
              break;
            }
          case "Enter": {
            i2.preventDefault(), this.hasAttribute("open") ? this.hidePopover() : (this.showPopover(), this.goToItem(0));
            break;
          }
          default: {
            this.hasAttribute("open") && i2.key.length === 1 && !i2.ctrlKey && !i2.altKey && !i2.metaKey && (i2.preventDefault(), i2.stopPropagation(), d(this, C) && d(this, C).handleSearchKey(i2.key));
            break;
          }
        }
      }, { signal: t2 }), this.addEventListener("keydown", (i2) => {
        switch (i2.key) {
          case "ArrowDown":
            return i2.preventDefault(), i2.stopPropagation(), this.goToItem(3);
          case "ArrowUp":
            return i2.preventDefault(), i2.stopPropagation(), this.goToItem(2);
          case "Home":
          case "PageUp":
            return i2.preventDefault(), i2.stopPropagation(), this.goToItem(0);
          case "End":
          case "PageDown":
            return i2.preventDefault(), i2.stopPropagation(), this.goToItem(1);
          case " ":
            if (d(this, C) && d(this, C).hasActiveSearchQuery()) {
              i2.preventDefault(), i2.stopPropagation(), d(this, C).handleSearchKey(i2.key);
              return;
            }
          case "Enter": {
            i2.preventDefault(), i2.stopPropagation();
            let s2 = this.getActiveItem();
            s2 ? s2.click() : this.hidePopover();
            return;
          }
          case "Tab": {
            d(this, C) && d(this, C).ignoreNextFocusRestoration();
            break;
          }
          case "Escape": {
            i2.preventDefault(), i2.stopPropagation(), this.hidePopover(), r2.focus();
            break;
          }
          default: {
            i2.key.length === 1 && !i2.ctrlKey && !i2.altKey && !i2.metaKey && (i2.preventDefault(), i2.stopPropagation(), d(this, C) && d(this, C).handleSearchKey(i2.key));
            break;
          }
        }
      }, { signal: t2 });
    }
    onBeforeOpen() {
      let n2 = this.getDropdown().getButton(), r2 = n2.dataset.originalTabIndex;
      r2 && (n2.dataset.originalTabIndex = r2), n2.setAttribute("tabIndex", "-1"), this.getActiveItem() === null && (this.setAttribute("tabIndex", "0"), setTimeout(() => this.focus({ preventScroll: true })));
    }
    onBeforeClose() {
      let n2 = this.getDropdown().getButton(), r2 = n2.dataset.originalTabIndex;
      delete n2.dataset.originalTabIndex, r2 !== void 0 ? n2.setAttribute("tabIndex", r2) : n2.removeAttribute("tabIndex");
      let i2 = this.getActiveItem();
      i2 !== null && i2.setAttribute("tabIndex", "-1");
    }
    goToItem(t2 = 4) {
      let n2 = this.getItems();
      if (n2.length === 0) return;
      let r2 = this.getActiveItem(), i2 = Y(n2, r2, t2);
      i2 && this.setActiveItem(i2);
    }
    setActiveItem(t2) {
      d(this, C) && d(this, C).setActiveItem(t2);
    }
    clearActiveItem() {
      d(this, C) && d(this, C).clearActiveItem();
    }
    getDropdown() {
      let t2 = this.closest("el-dropdown");
      if (!t2) throw new Error("[ElMenu] No `<el-dropdown>` element found");
      return t2;
    }
    getItems() {
      return Array.from(this.querySelectorAll(`${ae},[role="menuitem"]`));
    }
    getActiveItem() {
      return d(this, C)?.getActiveItem() || null;
    }
    onAttributeChange(t2, n2, r2) {
      switch (t2) {
        case "open": {
          r2 === null ? this.hidePopover() : this.showPopover();
          break;
        }
      }
    }
  };
  C = /* @__PURE__ */ new WeakMap(), M(It, "observedAttributes", ["anchor", "open"]);
  T("el-menu", It);
  T("el-dropdown", go);
  var Pt = class extends A {
    onAttributeChange(o2, t2, n2) {
      switch (o2) {
        case "open": {
          n2 === null ? this.hidePopover() : this.showPopover();
          break;
        }
      }
    }
    getOptionByName(o2) {
      let t2 = this.querySelector(`el-option[value="${o2}"]`);
      return t2 || null;
    }
    getItems() {
      return Array.from(this.querySelectorAll("el-option:not([disabled])"));
    }
  };
  M(Pt, "observedAttributes", ["anchor", "open"]);
  var bo = class extends A {
  };
  T("el-options", Pt);
  T("el-option", bo);
  var vo = class extends A {
    getPopovers() {
      return Array.from(this.querySelectorAll("* > el-popover"));
    }
  };
  var kt = class extends A {
    mount(o2) {
      if (!this.id) throw new Error("[ElPopover] No id found for popover (ensure `id` is set)");
      let n2 = this.getButtons();
      for (let a of n2) a.id || (a.id = k("popover-button")), a.addEventListener("keydown", (l2) => {
        (l2.key === "Enter" || l2.key === " ") && (l2.preventDefault(), this.togglePopover());
      }, { signal: o2 });
      Me(this, o2, () => this.getButtons()), this.setAttribute("tabindex", "-1");
      let r2 = this, i2 = this.closest("el-popover-group");
      i2 && i2.getPopovers().includes(this) && (r2 = i2), St(r2, n2, this, o2, () => this.hidePopover());
      let s2 = new AbortController();
      o2.addEventListener("abort", () => s2.abort()), this.addEventListener("beforetoggle", (a) => {
        if (a.newState === "open") {
          let l2 = vt(a, n2);
          l2 && z(l2, "--button-width", s2.signal, this);
        } else s2.abort(), s2 = new AbortController();
      }), this.addEventListener("toggle", (a) => {
        a.newState === "closed" && a.oldState === "open" && setTimeout(() => {
          if (!this.contains(document.activeElement) && document.activeElement !== document.body) return;
          let l2 = vt(a, n2);
          l2 && l2 !== document.activeElement && l2.isConnected && Le(l2);
        });
      }, { signal: o2 });
    }
    getButtons() {
      let o2 = this.id, t2 = Array.from(document.querySelectorAll(`[popovertarget="${o2}"]`));
      if (!t2) throw new Error('[ElPopover] No button found for popover (ensure you add a `<button popovertarget="${id}">` on the page)');
      return t2;
    }
    onAttributeChange(o2, t2, n2) {
      switch (o2) {
        case "open": {
          n2 === null ? this.hidePopover() : this.showPopover();
          break;
        }
      }
    }
  };
  M(kt, "observedAttributes", ["anchor", "open"]);
  T("el-popover", kt);
  T("el-popover-group", vo);
  var wo = class extends A {
    mount(o2) {
      let t2 = this.getList(), n2 = this.getPanels(), r2 = t2.getTabButtons(), i2 = n2.getPanels();
      if (r2.length !== i2.length) {
        console.warn("[ElTabGroup] Mismatch between number of tabs and panels");
        return;
      }
      for (let a = 0; a < i2.length; a++) {
        let l2 = i2[a], u = r2[a];
        u.id || (u.id = k("tailwindplus-tab")), l2.id || (l2.id = k("tailwindplus-tab-panel")), l2.setAttribute("aria-labelledby", u.id), u.setAttribute("aria-controls", l2.id), u.setAttribute("role", "tab");
      }
      let s2 = this.getActiveTab();
      s2 === -1 && (s2 = 0), t2.setActiveTab(s2), n2.setActivePanel(s2), t2.addEventListener("keydown", (a) => {
        switch (a.key) {
          case "ArrowLeft": {
            a.preventDefault();
            let u = this.getActiveTab() - 1;
            u < 0 && (u = r2.length - 1), this.setActiveTab(u), r2[u].focus();
            break;
          }
          case "ArrowRight": {
            a.preventDefault();
            let u = this.getActiveTab() + 1;
            u >= r2.length && (u = 0), this.setActiveTab(u), r2[u].focus();
            break;
          }
          case "Home":
          case "PageUp": {
            a.preventDefault(), this.setActiveTab(0), r2[0].focus();
            break;
          }
          case "End":
          case "PageDown": {
            a.preventDefault(), this.setActiveTab(r2.length - 1), r2[r2.length - 1].focus();
            break;
          }
        }
      }, { signal: o2 });
      for (let a = 0; a < r2.length; a++) r2[a].addEventListener("click", (u) => {
        u.preventDefault(), this.setActiveTab(a);
      }, { signal: o2 });
    }
    getActiveTab() {
      let o2 = this.querySelector("el-tab-panels"), t2 = o2.getPanels().find((n2) => !n2.hasAttribute("hidden"));
      return t2 ? o2.getPanels().indexOf(t2) : -1;
    }
    getList() {
      let o2 = this.querySelector("el-tab-list");
      if (!o2) throw new Error("[ElTabGroup] No `<el-tab-list>` element found");
      return o2;
    }
    getPanels() {
      let o2 = this.querySelector("el-tab-panels");
      if (!o2) throw new Error("[ElTabGroup] No `<el-tab-panels>` element found");
      return o2;
    }
    setActiveTab(o2) {
      if (this.getActiveTab() === o2) return;
      let n2 = this.getList(), r2 = this.getPanels(), i2 = n2.getTabButtons();
      o2 < 0 || o2 >= i2.length || (n2.setActiveTab(o2), r2.setActivePanel(o2));
    }
  };
  var yo = class extends A {
    mount() {
      this.setAttribute("role", "tablist"), this.setAttribute("aria-orientation", "horizontal");
    }
    getTabButtons() {
      let o2 = this.querySelectorAll("button");
      return Array.from(o2);
    }
    setActiveTab(o2) {
      this.getTabButtons().forEach((n2, r2) => {
        let i2 = r2 === o2;
        n2.setAttribute("tabindex", i2 ? "0" : "-1"), n2.setAttribute("aria-selected", i2 ? "true" : "false");
      });
    }
  };
  var Eo = class extends A {
    mount() {
      let t2 = this.getTabGroup().getList(), n2 = this.getPanels(), r2 = new MutationObserver((i2) => {
        for (let s2 of i2) {
          let a = s2.target;
          switch (s2.attributeName) {
            case "hidden":
              if (!a.hasAttribute(s2.attributeName)) {
                let l2 = n2.indexOf(a);
                t2.setActiveTab(l2), this.setActivePanel(l2);
              }
          }
        }
      });
      for (let i2 of n2) i2.setAttribute("role", "tabpanel"), i2.setAttribute("tabindex", "0"), r2.observe(i2, { attributeFilter: ["hidden"], attributes: true });
    }
    getTabGroup() {
      let o2 = this.closest("el-tab-group");
      if (!o2) throw new Error("`<el-tab-panels>` must be inside of a `<el-tab-group>` element.");
      return o2;
    }
    getPanels() {
      return Array.from(this.children);
    }
    setActivePanel(o2) {
      this.getPanels().forEach((n2, r2) => {
        n2.toggleAttribute("hidden", r2 !== o2);
      });
    }
  };
  T("el-tab-list", yo);
  T("el-tab-panels", Eo);
  T("el-tab-group", wo);
  typeof globalThis.window < "u" && setTimeout(() => window.dispatchEvent(new Event("elements:ready")));

  // assets-src/js/_0_shopify-forms.js
  document.addEventListener("DOMContentLoaded", () => {
    const selector = "shopify-forms-embed";
    const css = `
  /* Fix dropdown arrow locaiton */
  ._arrowDownIcon_12thd_19 { 
    margin: 0 !important; 
  }
  
  /* Fix Focus Border */
  ._formFieldContainer_1mxsl_5:has(textarea)::before {
    background-color: transparent !important;
  }

  /* Slight adjustment to text area */
  ._formFieldContainer_1mxsl_5 textarea {
    padding-top: var(--form-field-padding) !important;
  }

  /* Fix error border */
  div._withError_1mxsl_17 > input,
  ._selectorError_12thd_53,
  ._invalid_17mgw_14 {
    box-shadow: 0 0 0 2px var(--form-error-color) inset !important;
  }

  /* Add border to dropdowns when expanded */
  ._selectToggle_12thd_25[aria-expanded=true] {
    box-shadow: 0 0 0 2px #7c6a4d inset;
  } 

  /* Adjust isze of Submit Button */
  button._formSubmitButton_cit2d_96 {
    width: fit-content !important;
    align-self: start !important;
    padding: 1rem !important;
  }

  /* Add a bit more spacing between element */
  form._formFieldset_cit2d_82 > * {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
  }

  /* Make radio layout more responsive */
  @media (width <= 48rem) {
    ._horizontalLayout_nw6va_12 {
      grid-template-columns: 1fr !important;
    }
  }

  /* Fix Phone number region select */
  ._selectToggle_12thd_25 {
    max-height: 200px !important;
  }

  /* Custom radio styles */
  ._horizontalLayout_nw6va_12 {
    --max-cols: 4;
    grid-template-columns: repeat(auto-fit, minmax(max(100px, calc(100% / var(--max-cols) - 1rem)), 1fr)) !important;
  }

  .radio-option,
  .checkbox-option {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    padding: 1rem;
    cursor: pointer;
    flex-grow: 1;
    text-align: center;
  }

  .radio-option.active,
  .checkbox-option.active {
    background-color: #dacebc; 
    box-shadow: 0 0 0 2px #7c6a4d inset;
  }
  `;
    const radioOnClick = (div, parent, grandparent) => {
      const optionGroup = div.getAttribute("data-option-group");
      grandparent.querySelectorAll('[data-option-group="' + optionGroup + '"]').forEach((opt) => {
        opt.classList.remove("active");
        const optField = opt.parentElement.querySelector("input");
        optField.checked = false;
      });
      div.classList.add("active");
      const field = parent.querySelector("input");
      field.checked = false;
    };
    const addRadioButtons = (root) => {
      const radioButtons = root.querySelectorAll("._radioField_nw6va_1");
      radioButtons.forEach((radioButton) => {
        const parent = radioButton.parentElement;
        const input = radioButton.querySelector("input");
        const label = input.getAttribute("aria-label");
        const newDiv = document.createElement("div");
        newDiv.className = "radio-option";
        newDiv.setAttribute("data-option-field", input.id);
        newDiv.setAttribute("data-option-group", input.name);
        newDiv.innerHTML = label;
        newDiv.addEventListener("click", () => {
          radioOnClick(newDiv, radioButton, parent);
        });
        radioButton.style.display = "flex";
        radioButton.style.alignItems = "stretch";
        radioButton.querySelectorAll("*").forEach((child) => {
          child.style.display = "none";
        });
        radioButton.appendChild(newDiv);
      });
    };
    const checkboxOnClick = (div, parent) => {
      const wasChecked = div.classList.contains("active");
      if (wasChecked) {
        div.classList.remove("active");
      } else {
        div.classList.add("active");
      }
      const field = parent.querySelector("input");
      field.checked = !wasChecked;
    };
    const addCheckboxButtons = (root) => {
      const checkboxButtons = root.querySelectorAll("._checkboxField_1hja3_3");
      checkboxButtons.forEach((checkboxButton) => {
        const input = checkboxButton.querySelector("input");
        const label = input.getAttribute("aria-label");
        const newDiv = document.createElement("div");
        newDiv.className = "checkbox-option";
        newDiv.setAttribute("data-option-field", input.id);
        newDiv.innerHTML = label;
        newDiv.addEventListener("click", () => {
          checkboxOnClick(newDiv, checkboxButton);
        });
        checkboxButton.style.display = "flex";
        checkboxButton.style.alignItems = "stretch";
        checkboxButton.querySelectorAll("*").forEach((child) => {
          child.style.display = "none";
        });
        checkboxButton.appendChild(newDiv);
      });
    };
    const inject = (host) => {
      const root = host.shadowRoot;
      if (!root || root.querySelector('style[data-shadow-inject="forms"]')) return;
      const style = document.createElement("style");
      style.dataset.shadowInject = "forms";
      style.textContent = css;
      root.appendChild(style);
      addRadioButtons(root);
      addCheckboxButtons(root);
    };
    const scan = () => document.querySelectorAll(selector).forEach(inject);
    scan();
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  });
  document.addEventListener("DOMContentLoaded", () => {
    const selector = ".newsletter-signup shopify-forms-embed";
    let css = `
    /* Custom classes for Newsletter signup form */    
    form._formFieldset_cit2d_82 {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row !important;
      gap: 0.5rem !important;
      width: 100%;
      padding: 0 !important;
    }

    ._formInputField_nag3b_7 {
      padding-right: 2px !important;
      padding-left: 2px !important;
      width: 75%;
    }

    ._formInputFieldLabel_1mxsl_38  {
      left: 2px !important; 
    }
  `;
    const inject = (host) => {
      const root = host.shadowRoot;
      if (!root || root.querySelector('style[data-shadow-inject="newsletter-forms"]')) return;
      const newsletter = host.closest(".newsletter-signup");
      if (newsletter.classList.contains("newsletter-signup--footer")) {
        css = `
      ${css}

      button._formSubmitButton_cit2d_96 {
        font: normal 100 1rem 'thermal-variable', sans-serif !important;
        padding: 0.75rem !important;
        margin-top: 1.75rem !important;
      }
      `;
      } else {
        css = `
      ${css}
      
      button._formSubmitButton_cit2d_96 {
        font: normal 100 1.25rem 'thermal-variable', sans-serif !important;
        padding: 1rem !important;
        margin-top: 1rem !important;
      }
      `;
      }
      const style = document.createElement("style");
      style.dataset.shadowInject = "newsletter-forms";
      style.textContent = css;
      root.appendChild(style);
      const form = root.querySelector("form._formFieldset_cit2d_82");
      const wrapper = document.createElement("div");
      wrapper.style.display = "flex";
      wrapper.style.gap = "0.5rem";
      const button = form.querySelector("button._formSubmitButton_cit2d_96");
      Array.from(form.children).forEach((child) => {
        if (child !== button) {
          wrapper.appendChild(child);
        }
      });
      form.appendChild(wrapper);
      if (button) form.appendChild(button);
    };
    const scan = () => document.querySelectorAll(selector).forEach(inject);
    scan();
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  });

  // assets-src/js/input.js
  var import_vendor_gsap = __toESM(require_vendor_gsap());

  // assets-src/js/_0_vendor-lenis.js
  function t(t2, e2, i2) {
    return Math.max(t2, Math.min(e2, i2));
  }
  var e = class {
    isRunning = false;
    value = 0;
    from = 0;
    to = 0;
    currentTime = 0;
    lerp;
    duration;
    easing;
    onUpdate;
    advance(e2) {
      if (!this.isRunning) return;
      let i2 = false;
      if (this.duration && this.easing) {
        this.currentTime += e2;
        const s2 = t(0, this.currentTime / this.duration, 1);
        i2 = s2 >= 1;
        const o2 = i2 ? 1 : this.easing(s2);
        this.value = this.from + (this.to - this.from) * o2;
      } else
        this.lerp ? (this.value = (function(t2, e3, i3, s2) {
          return (function(t3, e4, i4) {
            return (1 - i4) * t3 + i4 * e4;
          })(t2, e3, 1 - Math.exp(-i3 * s2));
        })(this.value, this.to, 60 * this.lerp, e2), Math.round(this.value) === this.to && (this.value = this.to, i2 = true)) : (this.value = this.to, i2 = true);
      i2 && this.stop(), this.onUpdate?.(this.value, i2);
    }
    stop() {
      this.isRunning = false;
    }
    fromTo(t2, e2, { lerp: i2, duration: s2, easing: o2, onStart: n2, onUpdate: r2 }) {
      this.from = this.value = t2, this.to = e2, this.lerp = i2, this.duration = s2, this.easing = o2, this.currentTime = 0, this.isRunning = true, n2?.(), this.onUpdate = r2;
    }
  };
  var i = class {
    constructor(t2, e2, { autoResize: i2 = true, debounce: s2 = 250 } = {}) {
      this.wrapper = t2, this.content = e2, i2 && (this.debouncedResize = /* @__PURE__ */ (function(t3, e3) {
        let i3;
        return function(...s3) {
          let o2 = this;
          clearTimeout(i3), i3 = setTimeout(() => {
            i3 = void 0, t3.apply(o2, s3);
          }, e3);
        };
      })(this.resize, s2), this.wrapper instanceof Window ? window.addEventListener("resize", this.debouncedResize, false) : (this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize), this.wrapperResizeObserver.observe(this.wrapper)), this.contentResizeObserver = new ResizeObserver(this.debouncedResize), this.contentResizeObserver.observe(this.content)), this.resize();
    }
    width = 0;
    height = 0;
    scrollHeight = 0;
    scrollWidth = 0;
    debouncedResize;
    wrapperResizeObserver;
    contentResizeObserver;
    destroy() {
      this.wrapperResizeObserver?.disconnect(), this.contentResizeObserver?.disconnect(), this.wrapper === window && this.debouncedResize && window.removeEventListener("resize", this.debouncedResize, false);
    }
    resize = () => {
      this.onWrapperResize(), this.onContentResize();
    };
    onWrapperResize = () => {
      this.wrapper instanceof Window ? (this.width = window.innerWidth, this.height = window.innerHeight) : (this.width = this.wrapper.clientWidth, this.height = this.wrapper.clientHeight);
    };
    onContentResize = () => {
      this.wrapper instanceof Window ? (this.scrollHeight = this.content.scrollHeight, this.scrollWidth = this.content.scrollWidth) : (this.scrollHeight = this.wrapper.scrollHeight, this.scrollWidth = this.wrapper.scrollWidth);
    };
    get limit() {
      return { x: this.scrollWidth - this.width, y: this.scrollHeight - this.height };
    }
  };
  var s = class {
    events = {};
    emit(t2, ...e2) {
      let i2 = this.events[t2] || [];
      for (let t3 = 0, s2 = i2.length; t3 < s2; t3++) i2[t3]?.(...e2);
    }
    on(t2, e2) {
      return this.events[t2]?.push(e2) || (this.events[t2] = [e2]), () => {
        this.events[t2] = this.events[t2]?.filter((t3) => e2 !== t3);
      };
    }
    off(t2, e2) {
      this.events[t2] = this.events[t2]?.filter((t3) => e2 !== t3);
    }
    destroy() {
      this.events = {};
    }
  };
  var o = 100 / 6;
  var n = { passive: false };
  var r = class {
    constructor(t2, e2 = { wheelMultiplier: 1, touchMultiplier: 1 }) {
      this.element = t2, this.options = e2, window.addEventListener("resize", this.onWindowResize, false), this.onWindowResize(), this.element.addEventListener("wheel", this.onWheel, n), this.element.addEventListener("touchstart", this.onTouchStart, n), this.element.addEventListener("touchmove", this.onTouchMove, n), this.element.addEventListener("touchend", this.onTouchEnd, n);
    }
    touchStart = { x: 0, y: 0 };
    lastDelta = { x: 0, y: 0 };
    window = { width: 0, height: 0 };
    emitter = new s();
    on(t2, e2) {
      return this.emitter.on(t2, e2);
    }
    destroy() {
      this.emitter.destroy(), window.removeEventListener("resize", this.onWindowResize, false), this.element.removeEventListener("wheel", this.onWheel, n), this.element.removeEventListener("touchstart", this.onTouchStart, n), this.element.removeEventListener("touchmove", this.onTouchMove, n), this.element.removeEventListener("touchend", this.onTouchEnd, n);
    }
    onTouchStart = (t2) => {
      const { clientX: e2, clientY: i2 } = t2.targetTouches ? t2.targetTouches[0] : t2;
      this.touchStart.x = e2, this.touchStart.y = i2, this.lastDelta = { x: 0, y: 0 }, this.emitter.emit("scroll", { deltaX: 0, deltaY: 0, event: t2 });
    };
    onTouchMove = (t2) => {
      const { clientX: e2, clientY: i2 } = t2.targetTouches ? t2.targetTouches[0] : t2, s2 = -(e2 - this.touchStart.x) * this.options.touchMultiplier, o2 = -(i2 - this.touchStart.y) * this.options.touchMultiplier;
      this.touchStart.x = e2, this.touchStart.y = i2, this.lastDelta = { x: s2, y: o2 }, this.emitter.emit("scroll", { deltaX: s2, deltaY: o2, event: t2 });
    };
    onTouchEnd = (t2) => {
      this.emitter.emit("scroll", { deltaX: this.lastDelta.x, deltaY: this.lastDelta.y, event: t2 });
    };
    onWheel = (t2) => {
      let { deltaX: e2, deltaY: i2, deltaMode: s2 } = t2;
      e2 *= 1 === s2 ? o : 2 === s2 ? this.window.width : 1, i2 *= 1 === s2 ? o : 2 === s2 ? this.window.height : 1, e2 *= this.options.wheelMultiplier, i2 *= this.options.wheelMultiplier, this.emitter.emit("scroll", { deltaX: e2, deltaY: i2, event: t2 });
    };
    onWindowResize = () => {
      this.window = { width: window.innerWidth, height: window.innerHeight };
    };
  };
  var l = (t2) => Math.min(1, 1.001 - Math.pow(2, -10 * t2));
  var Lenis2 = class {
    _isScrolling = false;
    _isStopped = false;
    _isLocked = false;
    _preventNextNativeScrollEvent = false;
    _resetVelocityTimeout = null;
    _rafId = null;
    isTouching;
    time = 0;
    userData = {};
    lastVelocity = 0;
    velocity = 0;
    direction = 0;
    options;
    targetScroll;
    animatedScroll;
    animate = new e();
    emitter = new s();
    dimensions;
    virtualScroll;
    constructor({
      wrapper: t2 = window,
      content: e2 = document.documentElement,
      eventsTarget: s2 = t2,
      smoothWheel: o2 = true,
      syncTouch: n2 = false,
      syncTouchLerp: h = 0.075,
      touchInertiaExponent: a = 1.7,
      duration: c,
      easing: p,
      lerp: d2 = 0.1,
      infinite: u = false,
      orientation: m = "vertical",
      gestureOrientation: v = "horizontal" === m ? "both" : "vertical",
      touchMultiplier: g = 1,
      wheelMultiplier: S = 1,
      autoResize: f = true,
      prevent: w,
      virtualScroll: y,
      overscroll: E = true,
      autoRaf: T2 = false,
      anchors: z2 = false,
      autoToggle: b = false,
      allowNestedScroll: L2 = false,
      __experimental__naiveDimensions: N2 = false,
      naiveDimensions: R2 = N2,
      stopInertiaOnNavigate: M2 = false
    } = {}) {
      window.lenisVersion = "1.3.17", t2 && t2 !== document.documentElement || (t2 = window), "number" == typeof c && "function" != typeof p ? p = l : "function" == typeof p && "number" != typeof c && (c = 1), this.options = {
        wrapper: t2,
        content: e2,
        eventsTarget: s2,
        smoothWheel: o2,
        syncTouch: n2,
        syncTouchLerp: h,
        touchInertiaExponent: a,
        duration: c,
        easing: p,
        lerp: d2,
        infinite: u,
        gestureOrientation: v,
        orientation: m,
        touchMultiplier: g,
        wheelMultiplier: S,
        autoResize: f,
        prevent: w,
        virtualScroll: y,
        overscroll: E,
        autoRaf: T2,
        anchors: z2,
        autoToggle: b,
        allowNestedScroll: L2,
        naiveDimensions: R2,
        stopInertiaOnNavigate: M2
      }, this.dimensions = new i(t2, e2, { autoResize: f }), this.updateClassName(), this.targetScroll = this.animatedScroll = this.actualScroll, this.options.wrapper.addEventListener("scroll", this.onNativeScroll, false), this.options.wrapper.addEventListener("scrollend", this.onScrollEnd, { capture: true }), (this.options.anchors || this.options.stopInertiaOnNavigate) && this.options.wrapper.addEventListener("click", this.onClick, false), this.options.wrapper.addEventListener("pointerdown", this.onPointerDown, false), this.virtualScroll = new r(s2, { touchMultiplier: g, wheelMultiplier: S }), this.virtualScroll.on("scroll", this.onVirtualScroll), this.options.autoToggle && (this.checkOverflow(), this.rootElement.addEventListener("transitionend", this.onTransitionEnd, { passive: true })), this.options.autoRaf && (this._rafId = requestAnimationFrame(this.raf));
    }
    destroy() {
      this.emitter.destroy(), this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, false), this.options.wrapper.removeEventListener("scrollend", this.onScrollEnd, { capture: true }), this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown, false), (this.options.anchors || this.options.stopInertiaOnNavigate) && this.options.wrapper.removeEventListener("click", this.onClick, false), this.virtualScroll.destroy(), this.dimensions.destroy(), this.cleanUpClassName(), this._rafId && cancelAnimationFrame(this._rafId);
    }
    on(t2, e2) {
      return this.emitter.on(t2, e2);
    }
    off(t2, e2) {
      return this.emitter.off(t2, e2);
    }
    onScrollEnd = (t2) => {
      t2 instanceof CustomEvent || "smooth" !== this.isScrolling && false !== this.isScrolling || t2.stopPropagation();
    };
    dispatchScrollendEvent = () => {
      this.options.wrapper.dispatchEvent(
        new CustomEvent("scrollend", { bubbles: this.options.wrapper === window, detail: { lenisScrollEnd: true } })
      );
    };
    get overflow() {
      const t2 = this.isHorizontal ? "overflow-x" : "overflow-y";
      return getComputedStyle(this.rootElement)[t2];
    }
    checkOverflow() {
      ["hidden", "clip"].includes(this.overflow) ? this.internalStop() : this.internalStart();
    }
    onTransitionEnd = (t2) => {
      t2.propertyName.includes("overflow") && this.checkOverflow();
    };
    setScroll(t2) {
      this.isHorizontal ? this.options.wrapper.scrollTo({ left: t2, behavior: "instant" }) : this.options.wrapper.scrollTo({ top: t2, behavior: "instant" });
    }
    onClick = (t2) => {
      const e2 = t2.composedPath().filter((t3) => t3 instanceof HTMLAnchorElement && t3.getAttribute("href"));
      if (this.options.anchors) {
        const t3 = e2.find((t4) => t4.getAttribute("href")?.includes("#"));
        if (t3) {
          const e3 = t3.getAttribute("href");
          if (e3) {
            const t4 = "object" == typeof this.options.anchors && this.options.anchors ? this.options.anchors : void 0, i2 = `#${e3.split("#")[1]}`;
            this.scrollTo(i2, t4);
          }
        }
      }
      if (this.options.stopInertiaOnNavigate) {
        e2.find((t3) => t3.host === window.location.host) && this.reset();
      }
    };
    onPointerDown = (t2) => {
      1 === t2.button && this.reset();
    };
    onVirtualScroll = (t2) => {
      if ("function" == typeof this.options.virtualScroll && false === this.options.virtualScroll(t2)) return;
      const { deltaX: e2, deltaY: i2, event: s2 } = t2;
      if (this.emitter.emit("virtual-scroll", { deltaX: e2, deltaY: i2, event: s2 }), s2.ctrlKey) return;
      if (s2.lenisStopPropagation) return;
      const o2 = s2.type.includes("touch"), n2 = s2.type.includes("wheel");
      this.isTouching = "touchstart" === s2.type || "touchmove" === s2.type;
      const r2 = 0 === e2 && 0 === i2;
      if (this.options.syncTouch && o2 && "touchstart" === s2.type && r2 && !this.isStopped && !this.isLocked)
        return void this.reset();
      const l2 = "vertical" === this.options.gestureOrientation && 0 === i2 || "horizontal" === this.options.gestureOrientation && 0 === e2;
      if (r2 || l2) return;
      let h = s2.composedPath();
      h = h.slice(0, h.indexOf(this.rootElement));
      const a = this.options.prevent;
      if (h.find(
        (t3) => t3 instanceof HTMLElement && ("function" == typeof a && a?.(t3) || t3.hasAttribute?.("data-lenis-prevent") || o2 && t3.hasAttribute?.("data-lenis-prevent-touch") || n2 && t3.hasAttribute?.("data-lenis-prevent-wheel") || this.options.allowNestedScroll && this.checkNestedScroll(t3, { deltaX: e2, deltaY: i2 }))
      ))
        return;
      if (this.isStopped || this.isLocked) return void (s2.cancelable && s2.preventDefault());
      if (!(this.options.syncTouch && o2 || this.options.smoothWheel && n2))
        return this.isScrolling = "native", this.animate.stop(), void (s2.lenisStopPropagation = true);
      let c = i2;
      "both" === this.options.gestureOrientation ? c = Math.abs(i2) > Math.abs(e2) ? i2 : e2 : "horizontal" === this.options.gestureOrientation && (c = e2), (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && this.limit > 0 && (this.animatedScroll > 0 && this.animatedScroll < this.limit || 0 === this.animatedScroll && i2 > 0 || this.animatedScroll === this.limit && i2 < 0)) && (s2.lenisStopPropagation = true), s2.cancelable && s2.preventDefault();
      const p = o2 && this.options.syncTouch, d2 = o2 && "touchend" === s2.type;
      d2 && (c = Math.sign(this.velocity) * Math.pow(Math.abs(this.velocity), this.options.touchInertiaExponent)), this.scrollTo(this.targetScroll + c, {
        programmatic: false,
        ...p ? { lerp: d2 ? this.options.syncTouchLerp : 1 } : { lerp: this.options.lerp, duration: this.options.duration, easing: this.options.easing }
      });
    };
    resize() {
      this.dimensions.resize(), this.animatedScroll = this.targetScroll = this.actualScroll, this.emit();
    }
    emit() {
      this.emitter.emit("scroll", this);
    }
    onNativeScroll = () => {
      if (null !== this._resetVelocityTimeout && (clearTimeout(this._resetVelocityTimeout), this._resetVelocityTimeout = null), this._preventNextNativeScrollEvent)
        this._preventNextNativeScrollEvent = false;
      else if (false === this.isScrolling || "native" === this.isScrolling) {
        const t2 = this.animatedScroll;
        this.animatedScroll = this.targetScroll = this.actualScroll, this.lastVelocity = this.velocity, this.velocity = this.animatedScroll - t2, this.direction = Math.sign(this.animatedScroll - t2), this.isStopped || (this.isScrolling = "native"), this.emit(), 0 !== this.velocity && (this._resetVelocityTimeout = setTimeout(() => {
          this.lastVelocity = this.velocity, this.velocity = 0, this.isScrolling = false, this.emit();
        }, 400));
      }
    };
    reset() {
      this.isLocked = false, this.isScrolling = false, this.animatedScroll = this.targetScroll = this.actualScroll, this.lastVelocity = this.velocity = 0, this.animate.stop();
    }
    start() {
      this.isStopped && (this.options.autoToggle ? this.rootElement.style.removeProperty("overflow") : this.internalStart());
    }
    internalStart() {
      this.isStopped && (this.reset(), this.isStopped = false, this.emit());
    }
    stop() {
      this.isStopped || (this.options.autoToggle ? this.rootElement.style.setProperty("overflow", "clip") : this.internalStop());
    }
    internalStop() {
      this.isStopped || (this.reset(), this.isStopped = true, this.emit());
    }
    raf = (t2) => {
      const e2 = t2 - (this.time || t2);
      this.time = t2, this.animate.advance(1e-3 * e2), this.options.autoRaf && (this._rafId = requestAnimationFrame(this.raf));
    };
    scrollTo(e2, {
      offset: i2 = 0,
      immediate: s2 = false,
      lock: o2 = false,
      programmatic: n2 = true,
      lerp: r2 = n2 ? this.options.lerp : void 0,
      duration: h = n2 ? this.options.duration : void 0,
      easing: a = n2 ? this.options.easing : void 0,
      onStart: c,
      onComplete: p,
      force: d2 = false,
      userData: u
    } = {}) {
      if (!this.isStopped && !this.isLocked || d2) {
        if ("string" == typeof e2 && ["top", "left", "start", "#"].includes(e2)) e2 = 0;
        else if ("string" == typeof e2 && ["bottom", "right", "end"].includes(e2)) e2 = this.limit;
        else {
          let t2;
          if ("string" == typeof e2 ? (t2 = document.querySelector(e2), t2 || ("#top" === e2 ? e2 = 0 : console.warn("Lenis: Target not found", e2))) : e2 instanceof HTMLElement && e2?.nodeType && (t2 = e2), t2) {
            if (this.options.wrapper !== window) {
              const t3 = this.rootElement.getBoundingClientRect();
              i2 -= this.isHorizontal ? t3.left : t3.top;
            }
            const s3 = t2.getBoundingClientRect();
            e2 = (this.isHorizontal ? s3.left : s3.top) + this.animatedScroll;
          }
        }
        if ("number" == typeof e2) {
          if (e2 += i2, e2 = Math.round(e2), this.options.infinite) {
            if (n2) {
              this.targetScroll = this.animatedScroll = this.scroll;
              const t2 = e2 - this.animatedScroll;
              t2 > this.limit / 2 ? e2 -= this.limit : t2 < -this.limit / 2 && (e2 += this.limit);
            }
          } else e2 = t(0, e2, this.limit);
          if (e2 === this.targetScroll) return c?.(this), void p?.(this);
          if (this.userData = u ?? {}, s2)
            return this.animatedScroll = this.targetScroll = e2, this.setScroll(this.scroll), this.reset(), this.preventNextNativeScrollEvent(), this.emit(), p?.(this), this.userData = {}, void requestAnimationFrame(() => {
              this.dispatchScrollendEvent();
            });
          n2 || (this.targetScroll = e2), "number" == typeof h && "function" != typeof a ? a = l : "function" == typeof a && "number" != typeof h && (h = 1), this.animate.fromTo(this.animatedScroll, e2, {
            duration: h,
            easing: a,
            lerp: r2,
            onStart: () => {
              o2 && (this.isLocked = true), this.isScrolling = "smooth", c?.(this);
            },
            onUpdate: (t2, e3) => {
              this.isScrolling = "smooth", this.lastVelocity = this.velocity, this.velocity = t2 - this.animatedScroll, this.direction = Math.sign(this.velocity), this.animatedScroll = t2, this.setScroll(this.scroll), n2 && (this.targetScroll = t2), e3 || this.emit(), e3 && (this.reset(), this.emit(), p?.(this), this.userData = {}, requestAnimationFrame(() => {
                this.dispatchScrollendEvent();
              }), this.preventNextNativeScrollEvent());
            }
          });
        }
      }
    }
    preventNextNativeScrollEvent() {
      this._preventNextNativeScrollEvent = true, requestAnimationFrame(() => {
        this._preventNextNativeScrollEvent = false;
      });
    }
    checkNestedScroll(t2, { deltaX: e2, deltaY: i2 }) {
      const s2 = Date.now(), o2 = t2._lenis ??= {};
      let n2, r2, l2, h, a, c, p, d2;
      const u = this.options.gestureOrientation;
      if (s2 - (o2.time ?? 0) > 2e3) {
        o2.time = Date.now();
        const e3 = window.getComputedStyle(t2);
        o2.computedStyle = e3;
        const i3 = e3.overflowX, s3 = e3.overflowY;
        if (n2 = ["auto", "overlay", "scroll"].includes(i3), r2 = ["auto", "overlay", "scroll"].includes(s3), o2.hasOverflowX = n2, o2.hasOverflowY = r2, !n2 && !r2)
          return false;
        if ("vertical" === u && !r2) return false;
        if ("horizontal" === u && !n2) return false;
        a = t2.scrollWidth, c = t2.scrollHeight, p = t2.clientWidth, d2 = t2.clientHeight, l2 = a > p, h = c > d2, o2.isScrollableX = l2, o2.isScrollableY = h, o2.scrollWidth = a, o2.scrollHeight = c, o2.clientWidth = p, o2.clientHeight = d2;
      } else
        l2 = o2.isScrollableX, h = o2.isScrollableY, n2 = o2.hasOverflowX, r2 = o2.hasOverflowY, a = o2.scrollWidth, c = o2.scrollHeight, p = o2.clientWidth, d2 = o2.clientHeight;
      if (!n2 && !r2 || !l2 && !h) return false;
      if (!("vertical" !== u || r2 && h)) return false;
      if (!("horizontal" !== u || n2 && l2)) return false;
      let m, v, g, S, f, w;
      if ("horizontal" === u) m = "x";
      else if ("vertical" === u) m = "y";
      else {
        0 !== e2 && n2 && l2 && (m = "x"), 0 !== i2 && r2 && h && (m = "y");
      }
      if (!m) return false;
      if ("x" === m) v = t2.scrollLeft, g = a - p, S = e2, f = n2, w = l2;
      else {
        if ("y" !== m) return false;
        v = t2.scrollTop, g = c - d2, S = i2, f = r2, w = h;
      }
      return (S > 0 ? v < g : v > 0) && f && w;
    }
    get rootElement() {
      return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    get limit() {
      return this.options.naiveDimensions ? this.isHorizontal ? this.rootElement.scrollWidth - this.rootElement.clientWidth : this.rootElement.scrollHeight - this.rootElement.clientHeight : this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    get isHorizontal() {
      return "horizontal" === this.options.orientation;
    }
    get actualScroll() {
      const t2 = this.options.wrapper;
      return this.isHorizontal ? t2.scrollX ?? t2.scrollLeft : t2.scrollY ?? t2.scrollTop;
    }
    get scroll() {
      return this.options.infinite ? (t2 = this.animatedScroll, e2 = this.limit, (t2 % e2 + e2) % e2) : this.animatedScroll;
      var t2, e2;
    }
    get progress() {
      return 0 === this.limit ? 1 : this.scroll / this.limit;
    }
    get isScrolling() {
      return this._isScrolling;
    }
    set isScrolling(t2) {
      this._isScrolling !== t2 && (this._isScrolling = t2, this.updateClassName());
    }
    get isStopped() {
      return this._isStopped;
    }
    set isStopped(t2) {
      this._isStopped !== t2 && (this._isStopped = t2, this.updateClassName());
    }
    get isLocked() {
      return this._isLocked;
    }
    set isLocked(t2) {
      this._isLocked !== t2 && (this._isLocked = t2, this.updateClassName());
    }
    get isSmooth() {
      return "smooth" === this.isScrolling;
    }
    get className() {
      let t2 = "lenis";
      return this.options.autoToggle && (t2 += " lenis-autoToggle"), this.isStopped && (t2 += " lenis-stopped"), this.isLocked && (t2 += " lenis-locked"), this.isScrolling && (t2 += " lenis-scrolling"), "smooth" === this.isScrolling && (t2 += " lenis-smooth"), t2;
    }
    updateClassName() {
      this.cleanUpClassName(), this.rootElement.className = `${this.rootElement.className} ${this.className}`.trim();
    }
    cleanUpClassName() {
      this.rootElement.className = this.rootElement.className.replace(/lenis(-\w+)?/g, "").trim();
    }
  };
  globalThis.Lenis = Lenis2, globalThis.Lenis.prototype = Lenis2.prototype;

  // assets-src/js/_0_vendor-init-lenis.js
  var lenis = new Lenis({ anchors: true });
  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add((time) => {
    if (window.lenis) {
      window.lenis.raf(time * 1e3);
    }
  });
  gsap.ticker.lagSmoothing(0);
  window.lenis = lenis;

  // assets-src/js/_0_vendor-swiper.js
  var Swiper2 = (function() {
    "use strict";
    function e2(e3) {
      return null !== e3 && "object" == typeof e3 && "constructor" in e3 && e3.constructor === Object;
    }
    function t2(s3 = {}, a2 = {}) {
      const i3 = ["__proto__", "constructor", "prototype"];
      Object.keys(a2).filter((e3) => i3.indexOf(e3) < 0).forEach((i4) => {
        void 0 === s3[i4] ? s3[i4] = a2[i4] : e2(a2[i4]) && e2(s3[i4]) && Object.keys(a2[i4]).length > 0 && t2(s3[i4], a2[i4]);
      });
    }
    const s2 = {
      body: {},
      addEventListener() {
      },
      removeEventListener() {
      },
      activeElement: { blur() {
      }, nodeName: "" },
      querySelector: () => null,
      querySelectorAll: () => [],
      getElementById: () => null,
      createEvent: () => ({ initEvent() {
      } }),
      createElement: () => ({
        children: [],
        childNodes: [],
        style: {},
        setAttribute() {
        },
        getElementsByTagName: () => []
      }),
      createElementNS: () => ({}),
      importNode: () => null,
      location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" }
    };
    function a() {
      const e3 = "undefined" != typeof document ? document : {};
      return t2(e3, s2), e3;
    }
    const i2 = {
      document: s2,
      navigator: { userAgent: "" },
      location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" },
      history: { replaceState() {
      }, pushState() {
      }, go() {
      }, back() {
      } },
      CustomEvent: function() {
        return this;
      },
      addEventListener() {
      },
      removeEventListener() {
      },
      getComputedStyle: () => ({ getPropertyValue: () => "" }),
      Image() {
      },
      Date() {
      },
      screen: {},
      setTimeout() {
      },
      clearTimeout() {
      },
      matchMedia: () => ({}),
      requestAnimationFrame: (e3) => "undefined" == typeof setTimeout ? (e3(), null) : setTimeout(e3, 0),
      cancelAnimationFrame(e3) {
        "undefined" != typeof setTimeout && clearTimeout(e3);
      }
    };
    function r2() {
      const e3 = "undefined" != typeof window ? window : {};
      return t2(e3, i2), e3;
    }
    function n2(e3 = "") {
      return e3.trim().split(" ").filter((e4) => !!e4.trim());
    }
    function l2(e3, t3 = 0) {
      return setTimeout(e3, t3);
    }
    function o2() {
      return Date.now();
    }
    function d2(e3, t3 = "x") {
      const s3 = r2();
      let a2, i3, n3;
      const l3 = (function(e4) {
        const t4 = r2();
        let s4;
        return t4.getComputedStyle && (s4 = t4.getComputedStyle(e4, null)), !s4 && e4.currentStyle && (s4 = e4.currentStyle), s4 || (s4 = e4.style), s4;
      })(e3);
      return s3.WebKitCSSMatrix ? (i3 = l3.transform || l3.webkitTransform, i3.split(",").length > 6 && (i3 = i3.split(", ").map((e4) => e4.replace(",", ".")).join(", ")), n3 = new s3.WebKitCSSMatrix("none" === i3 ? "" : i3)) : (n3 = l3.MozTransform || l3.OTransform || l3.MsTransform || l3.msTransform || l3.transform || l3.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), a2 = n3.toString().split(",")), "x" === t3 && (i3 = s3.WebKitCSSMatrix ? n3.m41 : 16 === a2.length ? parseFloat(a2[12]) : parseFloat(a2[4])), "y" === t3 && (i3 = s3.WebKitCSSMatrix ? n3.m42 : 16 === a2.length ? parseFloat(a2[13]) : parseFloat(a2[5])), i3 || 0;
    }
    function c(e3) {
      return "object" == typeof e3 && null !== e3 && e3.constructor && "Object" === Object.prototype.toString.call(e3).slice(8, -1);
    }
    function p(e3) {
      return "undefined" != typeof window && void 0 !== window.HTMLElement ? e3 instanceof HTMLElement : e3 && (1 === e3.nodeType || 11 === e3.nodeType);
    }
    function u(...e3) {
      const t3 = Object(e3[0]), s3 = ["__proto__", "constructor", "prototype"];
      for (let a2 = 1; a2 < e3.length; a2 += 1) {
        const i3 = e3[a2];
        if (null != i3 && !p(i3)) {
          const e4 = Object.keys(Object(i3)).filter((e5) => s3.indexOf(e5) < 0);
          for (let s4 = 0, a3 = e4.length; s4 < a3; s4 += 1) {
            const a4 = e4[s4], r3 = Object.getOwnPropertyDescriptor(i3, a4);
            void 0 !== r3 && r3.enumerable && (c(t3[a4]) && c(i3[a4]) ? i3[a4].__swiper__ ? t3[a4] = i3[a4] : u(t3[a4], i3[a4]) : !c(t3[a4]) && c(i3[a4]) ? (t3[a4] = {}, i3[a4].__swiper__ ? t3[a4] = i3[a4] : u(t3[a4], i3[a4])) : t3[a4] = i3[a4]);
          }
        }
      }
      return t3;
    }
    function m(e3, t3, s3) {
      e3.style.setProperty(t3, s3);
    }
    function h({ swiper: e3, targetPosition: t3, side: s3 }) {
      const a2 = r2(), i3 = -e3.translate;
      let n3, l3 = null;
      const o3 = e3.params.speed;
      e3.wrapperEl.style.scrollSnapType = "none", a2.cancelAnimationFrame(e3.cssModeFrameID);
      const d3 = t3 > i3 ? "next" : "prev", c2 = (e4, t4) => "next" === d3 && e4 >= t4 || "prev" === d3 && e4 <= t4, p2 = () => {
        n3 = (/* @__PURE__ */ new Date()).getTime(), null === l3 && (l3 = n3);
        const r3 = Math.max(Math.min((n3 - l3) / o3, 1), 0), d4 = 0.5 - Math.cos(r3 * Math.PI) / 2;
        let u2 = i3 + d4 * (t3 - i3);
        if (c2(u2, t3) && (u2 = t3), e3.wrapperEl.scrollTo({ [s3]: u2 }), c2(u2, t3))
          return e3.wrapperEl.style.overflow = "hidden", e3.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
            e3.wrapperEl.style.overflow = "", e3.wrapperEl.scrollTo({ [s3]: u2 });
          }), void a2.cancelAnimationFrame(e3.cssModeFrameID);
        e3.cssModeFrameID = a2.requestAnimationFrame(p2);
      };
      p2();
    }
    function f(e3) {
      return e3.querySelector(".swiper-slide-transform") || e3.shadowRoot && e3.shadowRoot.querySelector(".swiper-slide-transform") || e3;
    }
    function g(e3, t3 = "") {
      const s3 = r2(), a2 = [...e3.children];
      return s3.HTMLSlotElement && e3 instanceof HTMLSlotElement && a2.push(...e3.assignedElements()), t3 ? a2.filter((e4) => e4.matches(t3)) : a2;
    }
    function v(e3) {
      try {
        return void console.warn(e3);
      } catch (e4) {
      }
    }
    function w(e3, t3 = []) {
      const s3 = document.createElement(e3);
      return s3.classList.add(...Array.isArray(t3) ? t3 : n2(t3)), s3;
    }
    function b(e3) {
      const t3 = r2(), s3 = a(), i3 = e3.getBoundingClientRect(), n3 = s3.body, l3 = e3.clientTop || n3.clientTop || 0, o3 = e3.clientLeft || n3.clientLeft || 0, d3 = e3 === t3 ? t3.scrollY : e3.scrollTop, c2 = e3 === t3 ? t3.scrollX : e3.scrollLeft;
      return { top: i3.top + d3 - l3, left: i3.left + c2 - o3 };
    }
    function y(e3, t3) {
      return r2().getComputedStyle(e3, null).getPropertyValue(t3);
    }
    function E(e3) {
      let t3, s3 = e3;
      if (s3) {
        for (t3 = 0; null !== (s3 = s3.previousSibling); ) 1 === s3.nodeType && (t3 += 1);
        return t3;
      }
    }
    function x(e3, t3) {
      const s3 = [];
      let a2 = e3.parentElement;
      for (; a2; ) t3 ? a2.matches(t3) && s3.push(a2) : s3.push(a2), a2 = a2.parentElement;
      return s3;
    }
    function S(e3, t3) {
      t3 && e3.addEventListener("transitionend", function s3(a2) {
        a2.target === e3 && (t3.call(e3, a2), e3.removeEventListener("transitionend", s3));
      });
    }
    function T2(e3, t3, s3) {
      const a2 = r2();
      return s3 ? e3["width" === t3 ? "offsetWidth" : "offsetHeight"] + parseFloat(a2.getComputedStyle(e3, null).getPropertyValue("width" === t3 ? "margin-right" : "margin-top")) + parseFloat(a2.getComputedStyle(e3, null).getPropertyValue("width" === t3 ? "margin-left" : "margin-bottom")) : e3.offsetWidth;
    }
    function M2(e3) {
      return (Array.isArray(e3) ? e3 : [e3]).filter((e4) => !!e4);
    }
    function C2(e3) {
      return (t3) => Math.abs(t3) > 0 && e3.browser && e3.browser.need3dFix && Math.abs(t3) % 90 == 0 ? t3 + 1e-3 : t3;
    }
    function P(e3, t3 = "") {
      "undefined" != typeof trustedTypes ? e3.innerHTML = trustedTypes.createPolicy("html", { createHTML: (e4) => e4 }).createHTML(t3) : e3.innerHTML = t3;
    }
    let L2, z2, I2;
    function A2() {
      return L2 || (L2 = (function() {
        const e3 = r2(), t3 = a();
        return {
          smoothScroll: t3.documentElement && t3.documentElement.style && "scrollBehavior" in t3.documentElement.style,
          touch: !!("ontouchstart" in e3 || e3.DocumentTouch && t3 instanceof e3.DocumentTouch)
        };
      })()), L2;
    }
    function $(e3 = {}) {
      return z2 || (z2 = (function({ userAgent: e4 } = {}) {
        const t3 = A2(), s3 = r2(), a2 = s3.navigator.platform, i3 = e4 || s3.navigator.userAgent, n3 = { ios: false, android: false }, l3 = s3.screen.width, o3 = s3.screen.height, d3 = i3.match(/(Android);?[\s\/]+([\d.]+)?/);
        let c2 = i3.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
        const p2 = i3.match(/(iPod)(.*OS\s([\d_]+))?/), u2 = !c2 && i3.match(/(iPhone\sOS|iOS)\s([\d_]+)/), m2 = "Win32" === a2;
        let h2 = "MacIntel" === a2;
        return !c2 && h2 && t3.touch && [
          "1024x1366",
          "1366x1024",
          "834x1194",
          "1194x834",
          "834x1112",
          "1112x834",
          "768x1024",
          "1024x768",
          "820x1180",
          "1180x820",
          "810x1080",
          "1080x810"
        ].indexOf(`${l3}x${o3}`) >= 0 && (c2 = i3.match(/(Version)\/([\d.]+)/), c2 || (c2 = [0, 1, "13_0_0"]), h2 = false), d3 && !m2 && (n3.os = "android", n3.android = true), (c2 || u2 || p2) && (n3.os = "ios", n3.ios = true), n3;
      })(e3)), z2;
    }
    function k2() {
      return I2 || (I2 = (function() {
        const e3 = r2(), t3 = $();
        let s3 = false;
        function a2() {
          const t4 = e3.navigator.userAgent.toLowerCase();
          return t4.indexOf("safari") >= 0 && t4.indexOf("chrome") < 0 && t4.indexOf("android") < 0;
        }
        if (a2()) {
          const t4 = String(e3.navigator.userAgent);
          if (t4.includes("Version/")) {
            const [e4, a3] = t4.split("Version/")[1].split(" ")[0].split(".").map((e5) => Number(e5));
            s3 = e4 < 16 || 16 === e4 && a3 < 2;
          }
        }
        const i3 = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e3.navigator.userAgent), n3 = a2();
        return { isSafari: s3 || n3, needPerspectiveFix: s3, need3dFix: n3 || i3 && t3.ios, isWebView: i3 };
      })()), I2;
    }
    var O2 = {
      on(e3, t3, s3) {
        const a2 = this;
        if (!a2.eventsListeners || a2.destroyed) return a2;
        if ("function" != typeof t3) return a2;
        const i3 = s3 ? "unshift" : "push";
        return e3.split(" ").forEach((e4) => {
          a2.eventsListeners[e4] || (a2.eventsListeners[e4] = []), a2.eventsListeners[e4][i3](t3);
        }), a2;
      },
      once(e3, t3, s3) {
        const a2 = this;
        if (!a2.eventsListeners || a2.destroyed) return a2;
        if ("function" != typeof t3) return a2;
        function i3(...s4) {
          a2.off(e3, i3), i3.__emitterProxy && delete i3.__emitterProxy, t3.apply(a2, s4);
        }
        return i3.__emitterProxy = t3, a2.on(e3, i3, s3);
      },
      onAny(e3, t3) {
        const s3 = this;
        if (!s3.eventsListeners || s3.destroyed) return s3;
        if ("function" != typeof e3) return s3;
        const a2 = t3 ? "unshift" : "push";
        return s3.eventsAnyListeners.indexOf(e3) < 0 && s3.eventsAnyListeners[a2](e3), s3;
      },
      offAny(e3) {
        const t3 = this;
        if (!t3.eventsListeners || t3.destroyed) return t3;
        if (!t3.eventsAnyListeners) return t3;
        const s3 = t3.eventsAnyListeners.indexOf(e3);
        return s3 >= 0 && t3.eventsAnyListeners.splice(s3, 1), t3;
      },
      off(e3, t3) {
        const s3 = this;
        return !s3.eventsListeners || s3.destroyed ? s3 : s3.eventsListeners ? (e3.split(" ").forEach((e4) => {
          void 0 === t3 ? s3.eventsListeners[e4] = [] : s3.eventsListeners[e4] && s3.eventsListeners[e4].forEach((a2, i3) => {
            (a2 === t3 || a2.__emitterProxy && a2.__emitterProxy === t3) && s3.eventsListeners[e4].splice(i3, 1);
          });
        }), s3) : s3;
      },
      emit(...e3) {
        const t3 = this;
        if (!t3.eventsListeners || t3.destroyed) return t3;
        if (!t3.eventsListeners) return t3;
        let s3, a2, i3;
        "string" == typeof e3[0] || Array.isArray(e3[0]) ? (s3 = e3[0], a2 = e3.slice(1, e3.length), i3 = t3) : (s3 = e3[0].events, a2 = e3[0].data, i3 = e3[0].context || t3), a2.unshift(i3);
        return (Array.isArray(s3) ? s3 : s3.split(" ")).forEach((e4) => {
          t3.eventsAnyListeners && t3.eventsAnyListeners.length && t3.eventsAnyListeners.forEach((t4) => {
            t4.apply(i3, [e4, ...a2]);
          }), t3.eventsListeners && t3.eventsListeners[e4] && t3.eventsListeners[e4].forEach((e5) => {
            e5.apply(i3, a2);
          });
        }), t3;
      }
    };
    const D = (e3, t3, s3) => {
      t3 && !e3.classList.contains(s3) ? e3.classList.add(s3) : !t3 && e3.classList.contains(s3) && e3.classList.remove(s3);
    };
    const G2 = (e3, t3, s3) => {
      t3 && !e3.classList.contains(s3) ? e3.classList.add(s3) : !t3 && e3.classList.contains(s3) && e3.classList.remove(s3);
    };
    const X3 = (e3, t3) => {
      if (!e3 || e3.destroyed || !e3.params) return;
      const s3 = t3.closest(e3.isElement ? "swiper-slide" : `.${e3.params.slideClass}`);
      if (s3) {
        let t4 = s3.querySelector(`.${e3.params.lazyPreloaderClass}`);
        !t4 && e3.isElement && (s3.shadowRoot ? t4 = s3.shadowRoot.querySelector(`.${e3.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
          s3.shadowRoot && (t4 = s3.shadowRoot.querySelector(`.${e3.params.lazyPreloaderClass}`), t4 && !t4.lazyPreloaderManaged && t4.remove());
        })), t4 && !t4.lazyPreloaderManaged && t4.remove();
      }
    }, B2 = (e3, t3) => {
      if (!e3.slides[t3]) return;
      const s3 = e3.slides[t3].querySelector('[loading="lazy"]');
      s3 && s3.removeAttribute("loading");
    }, Y2 = (e3) => {
      if (!e3 || e3.destroyed || !e3.params) return;
      let t3 = e3.params.lazyPreloadPrevNext;
      const s3 = e3.slides.length;
      if (!s3 || !t3 || t3 < 0) return;
      t3 = Math.min(t3, s3);
      const a2 = "auto" === e3.params.slidesPerView ? e3.slidesPerViewDynamic() : Math.ceil(e3.params.slidesPerView), i3 = e3.activeIndex;
      if (e3.params.grid && e3.params.grid.rows > 1) {
        const s4 = i3, r4 = [s4 - t3];
        return r4.push(...Array.from({ length: t3 }).map((e4, t4) => s4 + a2 + t4)), void e3.slides.forEach((t4, s5) => {
          r4.includes(t4.column) && B2(e3, s5);
        });
      }
      const r3 = i3 + a2 - 1;
      if (e3.params.rewind || e3.params.loop)
        for (let a3 = i3 - t3; a3 <= r3 + t3; a3 += 1) {
          const t4 = (a3 % s3 + s3) % s3;
          (t4 < i3 || t4 > r3) && B2(e3, t4);
        }
      else for (let a3 = Math.max(i3 - t3, 0); a3 <= Math.min(r3 + t3, s3 - 1); a3 += 1) a3 !== i3 && (a3 > r3 || a3 < i3) && B2(e3, a3);
    };
    var H2 = {
      updateSize: function() {
        const e3 = this;
        let t3, s3;
        const a2 = e3.el;
        t3 = void 0 !== e3.params.width && null !== e3.params.width ? e3.params.width : a2.clientWidth, s3 = void 0 !== e3.params.height && null !== e3.params.height ? e3.params.height : a2.clientHeight, 0 === t3 && e3.isHorizontal() || 0 === s3 && e3.isVertical() || (t3 = t3 - parseInt(y(a2, "padding-left") || 0, 10) - parseInt(y(a2, "padding-right") || 0, 10), s3 = s3 - parseInt(y(a2, "padding-top") || 0, 10) - parseInt(y(a2, "padding-bottom") || 0, 10), Number.isNaN(t3) && (t3 = 0), Number.isNaN(s3) && (s3 = 0), Object.assign(e3, { width: t3, height: s3, size: e3.isHorizontal() ? t3 : s3 }));
      },
      updateSlides: function() {
        const e3 = this;
        function t3(t4, s4) {
          return parseFloat(t4.getPropertyValue(e3.getDirectionLabel(s4)) || 0);
        }
        const s3 = e3.params, { wrapperEl: a2, slidesEl: i3, rtlTranslate: r3, wrongRTL: n3 } = e3, l3 = e3.virtual && s3.virtual.enabled, o3 = l3 ? e3.virtual.slides.length : e3.slides.length, d3 = g(i3, `.${e3.params.slideClass}, swiper-slide`), c2 = l3 ? e3.virtual.slides.length : d3.length;
        let p2 = [];
        const u2 = [], h2 = [];
        let f2 = s3.slidesOffsetBefore;
        "function" == typeof f2 && (f2 = s3.slidesOffsetBefore.call(e3));
        let v2 = s3.slidesOffsetAfter;
        "function" == typeof v2 && (v2 = s3.slidesOffsetAfter.call(e3));
        const w2 = e3.snapGrid.length, b2 = e3.slidesGrid.length, E2 = e3.size - f2 - v2;
        let x2 = s3.spaceBetween, S2 = -f2, M3 = 0, C3 = 0;
        if (void 0 === E2) return;
        "string" == typeof x2 && x2.indexOf("%") >= 0 ? x2 = parseFloat(x2.replace("%", "")) / 100 * E2 : "string" == typeof x2 && (x2 = parseFloat(x2)), e3.virtualSize = -x2 - f2 - v2, d3.forEach((e4) => {
          r3 ? e4.style.marginLeft = "" : e4.style.marginRight = "", e4.style.marginBottom = "", e4.style.marginTop = "";
        }), s3.centeredSlides && s3.cssMode && (m(a2, "--swiper-centered-offset-before", ""), m(a2, "--swiper-centered-offset-after", "")), s3.cssMode && (m(a2, "--swiper-slides-offset-before", `${f2}px`), m(a2, "--swiper-slides-offset-after", `${v2}px`));
        const P2 = s3.grid && s3.grid.rows > 1 && e3.grid;
        let L3;
        P2 ? e3.grid.initSlides(d3) : e3.grid && e3.grid.unsetSlides();
        const z3 = "auto" === s3.slidesPerView && s3.breakpoints && Object.keys(s3.breakpoints).filter((e4) => void 0 !== s3.breakpoints[e4].slidesPerView).length > 0;
        for (let a3 = 0; a3 < c2; a3 += 1) {
          L3 = 0;
          const i4 = d3[a3];
          if (!i4 || (P2 && e3.grid.updateSlide(a3, i4, d3), "none" !== y(i4, "display"))) {
            if (l3 && "auto" === s3.slidesPerView)
              s3.virtual.slidesPerViewAutoSlideSize && (L3 = s3.virtual.slidesPerViewAutoSlideSize), L3 && i4 && (s3.roundLengths && (L3 = Math.floor(L3)), i4.style[e3.getDirectionLabel("width")] = `${L3}px`);
            else if ("auto" === s3.slidesPerView) {
              z3 && (i4.style[e3.getDirectionLabel("width")] = "");
              const a4 = getComputedStyle(i4), r4 = i4.style.transform, n4 = i4.style.webkitTransform;
              if (r4 && (i4.style.transform = "none"), n4 && (i4.style.webkitTransform = "none"), s3.roundLengths)
                L3 = e3.isHorizontal() ? T2(i4, "width", true) : T2(i4, "height", true);
              else {
                const e4 = t3(a4, "width"), s4 = t3(a4, "padding-left"), r5 = t3(a4, "padding-right"), n5 = t3(a4, "margin-left"), l4 = t3(a4, "margin-right"), o4 = a4.getPropertyValue("box-sizing");
                if (o4 && "border-box" === o4) L3 = e4 + n5 + l4;
                else {
                  const { clientWidth: t4, offsetWidth: a5 } = i4;
                  L3 = e4 + s4 + r5 + n5 + l4 + (a5 - t4);
                }
              }
              r4 && (i4.style.transform = r4), n4 && (i4.style.webkitTransform = n4), s3.roundLengths && (L3 = Math.floor(L3));
            } else
              L3 = (E2 - (s3.slidesPerView - 1) * x2) / s3.slidesPerView, s3.roundLengths && (L3 = Math.floor(L3)), i4 && (i4.style[e3.getDirectionLabel("width")] = `${L3}px`);
            i4 && (i4.swiperSlideSize = L3), h2.push(L3), s3.centeredSlides ? (S2 = S2 + L3 / 2 + M3 / 2 + x2, 0 === M3 && 0 !== a3 && (S2 = S2 - E2 / 2 - x2), 0 === a3 && (S2 = S2 - E2 / 2 - x2), Math.abs(S2) < 1e-3 && (S2 = 0), s3.roundLengths && (S2 = Math.floor(S2)), C3 % s3.slidesPerGroup === 0 && p2.push(S2), u2.push(S2)) : (s3.roundLengths && (S2 = Math.floor(S2)), (C3 - Math.min(e3.params.slidesPerGroupSkip, C3)) % e3.params.slidesPerGroup === 0 && p2.push(S2), u2.push(S2), S2 = S2 + L3 + x2), e3.virtualSize += L3 + x2, M3 = L3, C3 += 1;
          }
        }
        if (e3.virtualSize = Math.max(e3.virtualSize, E2) + v2, r3 && n3 && ("slide" === s3.effect || "coverflow" === s3.effect) && (a2.style.width = `${e3.virtualSize + x2}px`), s3.setWrapperSize && (a2.style[e3.getDirectionLabel("width")] = `${e3.virtualSize + x2}px`), P2 && e3.grid.updateWrapperSize(L3, p2), !s3.centeredSlides) {
          const t4 = "auto" !== s3.slidesPerView && s3.slidesPerView % 1 != 0, a3 = s3.snapToSlideEdge && !s3.loop && ("auto" === s3.slidesPerView || t4);
          let i4 = p2.length;
          if (a3) {
            let e4;
            if ("auto" === s3.slidesPerView) {
              e4 = 1;
              let t5 = 0;
              for (let s4 = h2.length - 1; s4 >= 0 && (t5 += h2[s4] + (s4 < h2.length - 1 ? x2 : 0), t5 <= E2); s4 -= 1)
                e4 = h2.length - s4;
            } else e4 = Math.floor(s3.slidesPerView);
            i4 = Math.max(c2 - e4, 0);
          }
          const r4 = [];
          for (let t5 = 0; t5 < p2.length; t5 += 1) {
            let n4 = p2[t5];
            s3.roundLengths && (n4 = Math.floor(n4)), a3 ? t5 <= i4 && r4.push(n4) : p2[t5] <= e3.virtualSize - E2 && r4.push(n4);
          }
          p2 = r4, Math.floor(e3.virtualSize - E2) - Math.floor(p2[p2.length - 1]) > 1 && (a3 || p2.push(e3.virtualSize - E2));
        }
        if (l3 && s3.loop) {
          const t4 = h2[0] + x2;
          if (s3.slidesPerGroup > 1) {
            const a3 = Math.ceil((e3.virtual.slidesBefore + e3.virtual.slidesAfter) / s3.slidesPerGroup), i4 = t4 * s3.slidesPerGroup;
            for (let e4 = 0; e4 < a3; e4 += 1) p2.push(p2[p2.length - 1] + i4);
          }
          for (let a3 = 0; a3 < e3.virtual.slidesBefore + e3.virtual.slidesAfter; a3 += 1)
            1 === s3.slidesPerGroup && p2.push(p2[p2.length - 1] + t4), u2.push(u2[u2.length - 1] + t4), e3.virtualSize += t4;
        }
        if (0 === p2.length && (p2 = [0]), 0 !== x2) {
          const t4 = e3.isHorizontal() && r3 ? "marginLeft" : e3.getDirectionLabel("marginRight");
          d3.filter((e4, t5) => !(s3.cssMode && !s3.loop) || t5 !== d3.length - 1).forEach((e4) => {
            e4.style[t4] = `${x2}px`;
          });
        }
        if (s3.centeredSlides && s3.centeredSlidesBounds) {
          let e4 = 0;
          h2.forEach((t5) => {
            e4 += t5 + (x2 || 0);
          }), e4 -= x2;
          const t4 = e4 > E2 ? e4 - E2 : 0;
          p2 = p2.map((e5) => e5 <= 0 ? -f2 : e5 > t4 ? t4 + v2 : e5);
        }
        if (s3.centerInsufficientSlides) {
          let e4 = 0;
          h2.forEach((t5) => {
            e4 += t5 + (x2 || 0);
          }), e4 -= x2;
          const t4 = (f2 || 0) + (v2 || 0);
          if (e4 + t4 < E2) {
            const s4 = (E2 - e4 - t4) / 2;
            p2.forEach((e5, t5) => {
              p2[t5] = e5 - s4;
            }), u2.forEach((e5, t5) => {
              u2[t5] = e5 + s4;
            });
          }
        }
        if (Object.assign(e3, { slides: d3, snapGrid: p2, slidesGrid: u2, slidesSizesGrid: h2 }), s3.centeredSlides && s3.cssMode && !s3.centeredSlidesBounds) {
          m(a2, "--swiper-centered-offset-before", -p2[0] + "px"), m(a2, "--swiper-centered-offset-after", e3.size / 2 - h2[h2.length - 1] / 2 + "px");
          const t4 = -e3.snapGrid[0], s4 = -e3.slidesGrid[0];
          e3.snapGrid = e3.snapGrid.map((e4) => e4 + t4), e3.slidesGrid = e3.slidesGrid.map((e4) => e4 + s4);
        }
        if (c2 !== o3 && e3.emit("slidesLengthChange"), p2.length !== w2 && (e3.params.watchOverflow && e3.checkOverflow(), e3.emit("snapGridLengthChange")), u2.length !== b2 && e3.emit("slidesGridLengthChange"), s3.watchSlidesProgress && e3.updateSlidesOffset(), e3.emit("slidesUpdated"), !(l3 || s3.cssMode || "slide" !== s3.effect && "fade" !== s3.effect)) {
          const t4 = `${s3.containerModifierClass}backface-hidden`, a3 = e3.el.classList.contains(t4);
          c2 <= s3.maxBackfaceHiddenSlides ? a3 || e3.el.classList.add(t4) : a3 && e3.el.classList.remove(t4);
        }
      },
      updateAutoHeight: function(e3) {
        const t3 = this, s3 = [], a2 = t3.virtual && t3.params.virtual.enabled;
        let i3, r3 = 0;
        "number" == typeof e3 ? t3.setTransition(e3) : true === e3 && t3.setTransition(t3.params.speed);
        const n3 = (e4) => a2 ? t3.slides[t3.getSlideIndexByData(e4)] : t3.slides[e4];
        if ("auto" !== t3.params.slidesPerView && t3.params.slidesPerView > 1)
          if (t3.params.centeredSlides)
            (t3.visibleSlides || []).forEach((e4) => {
              s3.push(e4);
            });
          else
            for (i3 = 0; i3 < Math.ceil(t3.params.slidesPerView); i3 += 1) {
              const e4 = t3.activeIndex + i3;
              if (e4 > t3.slides.length && !a2) break;
              s3.push(n3(e4));
            }
        else s3.push(n3(t3.activeIndex));
        for (i3 = 0; i3 < s3.length; i3 += 1)
          if (void 0 !== s3[i3]) {
            const e4 = s3[i3].offsetHeight;
            r3 = e4 > r3 ? e4 : r3;
          }
        (r3 || 0 === r3) && (t3.wrapperEl.style.height = `${r3}px`);
      },
      updateSlidesOffset: function() {
        const e3 = this, t3 = e3.slides, s3 = e3.isElement ? e3.isHorizontal() ? e3.wrapperEl.offsetLeft : e3.wrapperEl.offsetTop : 0;
        for (let a2 = 0; a2 < t3.length; a2 += 1)
          t3[a2].swiperSlideOffset = (e3.isHorizontal() ? t3[a2].offsetLeft : t3[a2].offsetTop) - s3 - e3.cssOverflowAdjustment();
      },
      updateSlidesProgress: function(e3 = this && this.translate || 0) {
        const t3 = this, s3 = t3.params, { slides: a2, rtlTranslate: i3, snapGrid: r3 } = t3;
        if (0 === a2.length) return;
        void 0 === a2[0].swiperSlideOffset && t3.updateSlidesOffset();
        let n3 = -e3;
        i3 && (n3 = e3), t3.visibleSlidesIndexes = [], t3.visibleSlides = [];
        let l3 = s3.spaceBetween;
        "string" == typeof l3 && l3.indexOf("%") >= 0 ? l3 = parseFloat(l3.replace("%", "")) / 100 * t3.size : "string" == typeof l3 && (l3 = parseFloat(l3));
        for (let e4 = 0; e4 < a2.length; e4 += 1) {
          const o3 = a2[e4];
          let d3 = o3.swiperSlideOffset;
          s3.cssMode && s3.centeredSlides && (d3 -= a2[0].swiperSlideOffset);
          const c2 = (n3 + (s3.centeredSlides ? t3.minTranslate() : 0) - d3) / (o3.swiperSlideSize + l3), p2 = (n3 - r3[0] + (s3.centeredSlides ? t3.minTranslate() : 0) - d3) / (o3.swiperSlideSize + l3), u2 = -(n3 - d3), m2 = u2 + t3.slidesSizesGrid[e4], h2 = u2 >= 0 && u2 <= t3.size - t3.slidesSizesGrid[e4], f2 = u2 >= 0 && u2 < t3.size - 1 || m2 > 1 && m2 <= t3.size || u2 <= 0 && m2 >= t3.size;
          f2 && (t3.visibleSlides.push(o3), t3.visibleSlidesIndexes.push(e4)), D(o3, f2, s3.slideVisibleClass), D(o3, h2, s3.slideFullyVisibleClass), o3.progress = i3 ? -c2 : c2, o3.originalProgress = i3 ? -p2 : p2;
        }
      },
      updateProgress: function(e3) {
        const t3 = this;
        if (void 0 === e3) {
          const s4 = t3.rtlTranslate ? -1 : 1;
          e3 = t3 && t3.translate && t3.translate * s4 || 0;
        }
        const s3 = t3.params, a2 = t3.maxTranslate() - t3.minTranslate();
        let { progress: i3, isBeginning: r3, isEnd: n3, progressLoop: l3 } = t3;
        const o3 = r3, d3 = n3;
        if (0 === a2) i3 = 0, r3 = true, n3 = true;
        else {
          i3 = (e3 - t3.minTranslate()) / a2;
          const s4 = Math.abs(e3 - t3.minTranslate()) < 1, l4 = Math.abs(e3 - t3.maxTranslate()) < 1;
          r3 = s4 || i3 <= 0, n3 = l4 || i3 >= 1, s4 && (i3 = 0), l4 && (i3 = 1);
        }
        if (s3.loop) {
          const s4 = t3.getSlideIndexByData(0), a3 = t3.getSlideIndexByData(t3.slides.length - 1), i4 = t3.slidesGrid[s4], r4 = t3.slidesGrid[a3], n4 = t3.slidesGrid[t3.slidesGrid.length - 1], o4 = Math.abs(e3);
          l3 = o4 >= i4 ? (o4 - i4) / n4 : (o4 + n4 - r4) / n4, l3 > 1 && (l3 -= 1);
        }
        Object.assign(t3, { progress: i3, progressLoop: l3, isBeginning: r3, isEnd: n3 }), (s3.watchSlidesProgress || s3.centeredSlides && s3.autoHeight) && t3.updateSlidesProgress(e3), r3 && !o3 && t3.emit("reachBeginning toEdge"), n3 && !d3 && t3.emit("reachEnd toEdge"), (o3 && !r3 || d3 && !n3) && t3.emit("fromEdge"), t3.emit("progress", i3);
      },
      updateSlidesClasses: function() {
        const e3 = this, { slides: t3, params: s3, slidesEl: a2, activeIndex: i3 } = e3, r3 = e3.virtual && s3.virtual.enabled, n3 = e3.grid && s3.grid && s3.grid.rows > 1, l3 = (e4) => g(a2, `.${s3.slideClass}${e4}, swiper-slide${e4}`)[0];
        let o3, d3, c2;
        if (r3)
          if (s3.loop) {
            let t4 = i3 - e3.virtual.slidesBefore;
            t4 < 0 && (t4 = e3.virtual.slides.length + t4), t4 >= e3.virtual.slides.length && (t4 -= e3.virtual.slides.length), o3 = l3(`[data-swiper-slide-index="${t4}"]`);
          } else o3 = l3(`[data-swiper-slide-index="${i3}"]`);
        else
          n3 ? (o3 = t3.find((e4) => e4.column === i3), c2 = t3.find((e4) => e4.column === i3 + 1), d3 = t3.find((e4) => e4.column === i3 - 1)) : o3 = t3[i3];
        o3 && (n3 || (c2 = (function(e4, t4) {
          const s4 = [];
          for (; e4.nextElementSibling; ) {
            const a3 = e4.nextElementSibling;
            t4 ? a3.matches(t4) && s4.push(a3) : s4.push(a3), e4 = a3;
          }
          return s4;
        })(o3, `.${s3.slideClass}, swiper-slide`)[0], s3.loop && !c2 && (c2 = t3[0]), d3 = (function(e4, t4) {
          const s4 = [];
          for (; e4.previousElementSibling; ) {
            const a3 = e4.previousElementSibling;
            t4 ? a3.matches(t4) && s4.push(a3) : s4.push(a3), e4 = a3;
          }
          return s4;
        })(o3, `.${s3.slideClass}, swiper-slide`)[0], s3.loop && 0 === !d3 && (d3 = t3[t3.length - 1]))), t3.forEach((e4) => {
          G2(e4, e4 === o3, s3.slideActiveClass), G2(e4, e4 === c2, s3.slideNextClass), G2(e4, e4 === d3, s3.slidePrevClass);
        }), e3.emitSlidesClasses();
      },
      updateActiveIndex: function(e3) {
        const t3 = this, s3 = t3.rtlTranslate ? t3.translate : -t3.translate, { snapGrid: a2, params: i3, activeIndex: r3, realIndex: n3, snapIndex: l3 } = t3;
        let o3, d3 = e3;
        const c2 = (e4) => {
          let s4 = e4 - t3.virtual.slidesBefore;
          return s4 < 0 && (s4 = t3.virtual.slides.length + s4), s4 >= t3.virtual.slides.length && (s4 -= t3.virtual.slides.length), s4;
        };
        if (void 0 === d3 && (d3 = (function(e4) {
          const { slidesGrid: t4, params: s4 } = e4, a3 = e4.rtlTranslate ? e4.translate : -e4.translate;
          let i4;
          for (let e5 = 0; e5 < t4.length; e5 += 1)
            void 0 !== t4[e5 + 1] ? a3 >= t4[e5] && a3 < t4[e5 + 1] - (t4[e5 + 1] - t4[e5]) / 2 ? i4 = e5 : a3 >= t4[e5] && a3 < t4[e5 + 1] && (i4 = e5 + 1) : a3 >= t4[e5] && (i4 = e5);
          return s4.normalizeSlideIndex && (i4 < 0 || void 0 === i4) && (i4 = 0), i4;
        })(t3)), a2.indexOf(s3) >= 0)
          o3 = a2.indexOf(s3);
        else {
          const e4 = Math.min(i3.slidesPerGroupSkip, d3);
          o3 = e4 + Math.floor((d3 - e4) / i3.slidesPerGroup);
        }
        if (o3 >= a2.length && (o3 = a2.length - 1), d3 === r3 && !t3.params.loop)
          return void (o3 !== l3 && (t3.snapIndex = o3, t3.emit("snapIndexChange")));
        if (d3 === r3 && t3.params.loop && t3.virtual && t3.params.virtual.enabled) return void (t3.realIndex = c2(d3));
        const p2 = t3.grid && i3.grid && i3.grid.rows > 1;
        let u2;
        if (t3.virtual && i3.virtual.enabled) u2 = i3.loop ? c2(d3) : d3;
        else if (p2) {
          const e4 = t3.slides.find((e5) => e5.column === d3);
          let s4 = parseInt(e4.getAttribute("data-swiper-slide-index"), 10);
          Number.isNaN(s4) && (s4 = Math.max(t3.slides.indexOf(e4), 0)), u2 = Math.floor(s4 / i3.grid.rows);
        } else if (t3.slides[d3]) {
          const e4 = t3.slides[d3].getAttribute("data-swiper-slide-index");
          u2 = e4 ? parseInt(e4, 10) : d3;
        } else u2 = d3;
        Object.assign(t3, {
          previousSnapIndex: l3,
          snapIndex: o3,
          previousRealIndex: n3,
          realIndex: u2,
          previousIndex: r3,
          activeIndex: d3
        }), t3.initialized && Y2(t3), t3.emit("activeIndexChange"), t3.emit("snapIndexChange"), (t3.initialized || t3.params.runCallbacksOnInit) && (n3 !== u2 && t3.emit("realIndexChange"), t3.emit("slideChange"));
      },
      updateClickedSlide: function(e3, t3) {
        const s3 = this, a2 = s3.params;
        let i3 = e3.closest(`.${a2.slideClass}, swiper-slide`);
        !i3 && s3.isElement && t3 && t3.length > 1 && t3.includes(e3) && [...t3.slice(t3.indexOf(e3) + 1, t3.length)].forEach((e4) => {
          !i3 && e4.matches && e4.matches(`.${a2.slideClass}, swiper-slide`) && (i3 = e4);
        });
        let r3, n3 = false;
        if (i3) {
          for (let e4 = 0; e4 < s3.slides.length; e4 += 1)
            if (s3.slides[e4] === i3) {
              n3 = true, r3 = e4;
              break;
            }
        }
        if (!i3 || !n3) return s3.clickedSlide = void 0, void (s3.clickedIndex = void 0);
        s3.clickedSlide = i3, s3.virtual && s3.params.virtual.enabled ? s3.clickedIndex = parseInt(i3.getAttribute("data-swiper-slide-index"), 10) : s3.clickedIndex = r3, a2.slideToClickedSlide && void 0 !== s3.clickedIndex && s3.clickedIndex !== s3.activeIndex && s3.slideToClickedSlide();
      }
    };
    var N2 = {
      getTranslate: function(e3 = this.isHorizontal() ? "x" : "y") {
        const { params: t3, rtlTranslate: s3, translate: a2, wrapperEl: i3 } = this;
        if (t3.virtualTranslate) return s3 ? -a2 : a2;
        if (t3.cssMode) return a2;
        let r3 = d2(i3, e3);
        return r3 += this.cssOverflowAdjustment(), s3 && (r3 = -r3), r3 || 0;
      },
      setTranslate: function(e3, t3) {
        const s3 = this, { rtlTranslate: a2, params: i3, wrapperEl: r3, progress: n3 } = s3;
        let l3, o3 = 0, d3 = 0;
        s3.isHorizontal() ? o3 = a2 ? -e3 : e3 : d3 = e3, i3.roundLengths && (o3 = Math.floor(o3), d3 = Math.floor(d3)), s3.previousTranslate = s3.translate, s3.translate = s3.isHorizontal() ? o3 : d3, i3.cssMode ? r3[s3.isHorizontal() ? "scrollLeft" : "scrollTop"] = s3.isHorizontal() ? -o3 : -d3 : i3.virtualTranslate || (s3.isHorizontal() ? o3 -= s3.cssOverflowAdjustment() : d3 -= s3.cssOverflowAdjustment(), r3.style.transform = `translate3d(${o3}px, ${d3}px, 0px)`);
        const c2 = s3.maxTranslate() - s3.minTranslate();
        l3 = 0 === c2 ? 0 : (e3 - s3.minTranslate()) / c2, l3 !== n3 && s3.updateProgress(e3), s3.emit("setTranslate", s3.translate, t3);
      },
      minTranslate: function() {
        return -this.snapGrid[0];
      },
      maxTranslate: function() {
        return -this.snapGrid[this.snapGrid.length - 1];
      },
      translateTo: function(e3 = 0, t3 = this.params.speed, s3 = true, a2 = true, i3) {
        const r3 = this, { params: n3, wrapperEl: l3 } = r3;
        if (r3.animating && n3.preventInteractionOnTransition) return false;
        const o3 = r3.minTranslate(), d3 = r3.maxTranslate();
        let c2;
        if (c2 = a2 && e3 > o3 ? o3 : a2 && e3 < d3 ? d3 : e3, r3.updateProgress(c2), n3.cssMode) {
          const e4 = r3.isHorizontal();
          if (0 === t3) l3[e4 ? "scrollLeft" : "scrollTop"] = -c2;
          else {
            if (!r3.support.smoothScroll) return h({ swiper: r3, targetPosition: -c2, side: e4 ? "left" : "top" }), true;
            l3.scrollTo({ [e4 ? "left" : "top"]: -c2, behavior: "smooth" });
          }
          return true;
        }
        return 0 === t3 ? (r3.setTransition(0), r3.setTranslate(c2), s3 && (r3.emit("beforeTransitionStart", t3, i3), r3.emit("transitionEnd"))) : (r3.setTransition(t3), r3.setTranslate(c2), s3 && (r3.emit("beforeTransitionStart", t3, i3), r3.emit("transitionStart")), r3.animating || (r3.animating = true, r3.onTranslateToWrapperTransitionEnd || (r3.onTranslateToWrapperTransitionEnd = function(e4) {
          r3 && !r3.destroyed && e4.target === this && (r3.wrapperEl.removeEventListener("transitionend", r3.onTranslateToWrapperTransitionEnd), r3.onTranslateToWrapperTransitionEnd = null, delete r3.onTranslateToWrapperTransitionEnd, r3.animating = false, s3 && r3.emit("transitionEnd"));
        }), r3.wrapperEl.addEventListener("transitionend", r3.onTranslateToWrapperTransitionEnd))), true;
      }
    };
    function R2({ swiper: e3, runCallbacks: t3, direction: s3, step: a2 }) {
      const { activeIndex: i3, previousIndex: r3 } = e3;
      let n3 = s3;
      n3 || (n3 = i3 > r3 ? "next" : i3 < r3 ? "prev" : "reset"), e3.emit(`transition${a2}`), t3 && "reset" === n3 ? e3.emit(`slideResetTransition${a2}`) : t3 && i3 !== r3 && (e3.emit(`slideChangeTransition${a2}`), "next" === n3 ? e3.emit(`slideNextTransition${a2}`) : e3.emit(`slidePrevTransition${a2}`));
    }
    var V2 = {
      slideTo: function(e3 = 0, t3, s3 = true, a2, i3) {
        "string" == typeof e3 && (e3 = parseInt(e3, 10));
        const r3 = this;
        let n3 = e3;
        n3 < 0 && (n3 = 0);
        const {
          params: l3,
          snapGrid: o3,
          slidesGrid: d3,
          previousIndex: c2,
          activeIndex: p2,
          rtlTranslate: u2,
          wrapperEl: m2,
          enabled: f2
        } = r3;
        if (!f2 && !a2 && !i3 || r3.destroyed || r3.animating && l3.preventInteractionOnTransition) return false;
        void 0 === t3 && (t3 = r3.params.speed);
        const g2 = Math.min(r3.params.slidesPerGroupSkip, n3);
        let v2 = g2 + Math.floor((n3 - g2) / r3.params.slidesPerGroup);
        v2 >= o3.length && (v2 = o3.length - 1);
        const w2 = -o3[v2];
        if (l3.normalizeSlideIndex)
          for (let e4 = 0; e4 < d3.length; e4 += 1) {
            const t4 = -Math.floor(100 * w2), s4 = Math.floor(100 * d3[e4]), a3 = Math.floor(100 * d3[e4 + 1]);
            void 0 !== d3[e4 + 1] ? t4 >= s4 && t4 < a3 - (a3 - s4) / 2 ? n3 = e4 : t4 >= s4 && t4 < a3 && (n3 = e4 + 1) : t4 >= s4 && (n3 = e4);
          }
        if (r3.initialized && n3 !== p2) {
          if (!r3.allowSlideNext && (u2 ? w2 > r3.translate && w2 > r3.minTranslate() : w2 < r3.translate && w2 < r3.minTranslate()))
            return false;
          if (!r3.allowSlidePrev && w2 > r3.translate && w2 > r3.maxTranslate() && (p2 || 0) !== n3) return false;
        }
        let b2;
        n3 !== (c2 || 0) && s3 && r3.emit("beforeSlideChangeStart"), r3.updateProgress(w2), b2 = n3 > p2 ? "next" : n3 < p2 ? "prev" : "reset";
        const y2 = r3.virtual && r3.params.virtual.enabled;
        if (!(y2 && i3) && (u2 && -w2 === r3.translate || !u2 && w2 === r3.translate))
          return r3.updateActiveIndex(n3), l3.autoHeight && r3.updateAutoHeight(), r3.updateSlidesClasses(), "slide" !== l3.effect && r3.setTranslate(w2), "reset" !== b2 && (r3.transitionStart(s3, b2), r3.transitionEnd(s3, b2)), false;
        if (l3.cssMode) {
          const e4 = r3.isHorizontal(), s4 = u2 ? w2 : -w2;
          if (0 === t3)
            y2 && (r3.wrapperEl.style.scrollSnapType = "none", r3._immediateVirtual = true), y2 && !r3._cssModeVirtualInitialSet && r3.params.initialSlide > 0 ? (r3._cssModeVirtualInitialSet = true, requestAnimationFrame(() => {
              m2[e4 ? "scrollLeft" : "scrollTop"] = s4;
            })) : m2[e4 ? "scrollLeft" : "scrollTop"] = s4, y2 && requestAnimationFrame(() => {
              r3.wrapperEl.style.scrollSnapType = "", r3._immediateVirtual = false;
            });
          else {
            if (!r3.support.smoothScroll) return h({ swiper: r3, targetPosition: s4, side: e4 ? "left" : "top" }), true;
            m2.scrollTo({ [e4 ? "left" : "top"]: s4, behavior: "smooth" });
          }
          return true;
        }
        const E2 = k2().isSafari;
        return y2 && !i3 && E2 && r3.isElement && r3.virtual.update(false, false, n3), r3.setTransition(t3), r3.setTranslate(w2), r3.updateActiveIndex(n3), r3.updateSlidesClasses(), r3.emit("beforeTransitionStart", t3, a2), r3.transitionStart(s3, b2), 0 === t3 ? r3.transitionEnd(s3, b2) : r3.animating || (r3.animating = true, r3.onSlideToWrapperTransitionEnd || (r3.onSlideToWrapperTransitionEnd = function(e4) {
          r3 && !r3.destroyed && e4.target === this && (r3.wrapperEl.removeEventListener("transitionend", r3.onSlideToWrapperTransitionEnd), r3.onSlideToWrapperTransitionEnd = null, delete r3.onSlideToWrapperTransitionEnd, r3.transitionEnd(s3, b2));
        }), r3.wrapperEl.addEventListener("transitionend", r3.onSlideToWrapperTransitionEnd)), true;
      },
      slideToLoop: function(e3 = 0, t3, s3 = true, a2) {
        if ("string" == typeof e3) {
          e3 = parseInt(e3, 10);
        }
        const i3 = this;
        if (i3.destroyed) return;
        void 0 === t3 && (t3 = i3.params.speed);
        const r3 = i3.grid && i3.params.grid && i3.params.grid.rows > 1;
        let n3 = e3;
        if (i3.params.loop)
          if (i3.virtual && i3.params.virtual.enabled) n3 += i3.virtual.slidesBefore;
          else {
            let e4;
            if (r3) {
              const t5 = n3 * i3.params.grid.rows;
              e4 = i3.slides.find((e5) => 1 * e5.getAttribute("data-swiper-slide-index") === t5).column;
            } else e4 = i3.getSlideIndexByData(n3);
            const t4 = r3 ? Math.ceil(i3.slides.length / i3.params.grid.rows) : i3.slides.length, { centeredSlides: s4, slidesOffsetBefore: l3, slidesOffsetAfter: o3 } = i3.params, d3 = s4 || !!l3 || !!o3;
            let c2 = i3.params.slidesPerView;
            "auto" === c2 ? c2 = i3.slidesPerViewDynamic() : (c2 = Math.ceil(parseFloat(i3.params.slidesPerView, 10)), d3 && c2 % 2 == 0 && (c2 += 1));
            let p2 = t4 - e4 < c2;
            if (d3 && (p2 = p2 || e4 < Math.ceil(c2 / 2)), a2 && d3 && "auto" !== i3.params.slidesPerView && !r3 && (p2 = false), p2) {
              const s5 = d3 ? e4 < i3.activeIndex ? "prev" : "next" : e4 - i3.activeIndex - 1 < i3.params.slidesPerView ? "next" : "prev";
              i3.loopFix({
                direction: s5,
                slideTo: true,
                activeSlideIndex: "next" === s5 ? e4 + 1 : e4 - t4 + 1,
                slideRealIndex: "next" === s5 ? i3.realIndex : void 0
              });
            }
            if (r3) {
              const e5 = n3 * i3.params.grid.rows;
              n3 = i3.slides.find((t5) => 1 * t5.getAttribute("data-swiper-slide-index") === e5).column;
            } else n3 = i3.getSlideIndexByData(n3);
          }
        return requestAnimationFrame(() => {
          i3.slideTo(n3, t3, s3, a2);
        }), i3;
      },
      slideNext: function(e3, t3 = true, s3) {
        const a2 = this, { enabled: i3, params: r3, animating: n3 } = a2;
        if (!i3 || a2.destroyed) return a2;
        void 0 === e3 && (e3 = a2.params.speed);
        let l3 = r3.slidesPerGroup;
        "auto" === r3.slidesPerView && 1 === r3.slidesPerGroup && r3.slidesPerGroupAuto && (l3 = Math.max(a2.slidesPerViewDynamic("current", true), 1));
        const o3 = a2.activeIndex < r3.slidesPerGroupSkip ? 1 : l3, d3 = a2.virtual && r3.virtual.enabled;
        if (r3.loop) {
          if (n3 && !d3 && r3.loopPreventsSliding) return false;
          if (a2.loopFix({ direction: "next" }), a2._clientLeft = a2.wrapperEl.clientLeft, a2.activeIndex === a2.slides.length - 1 && r3.cssMode)
            return requestAnimationFrame(() => {
              a2.slideTo(a2.activeIndex + o3, e3, t3, s3);
            }), true;
        }
        return r3.rewind && a2.isEnd ? a2.slideTo(0, e3, t3, s3) : a2.slideTo(a2.activeIndex + o3, e3, t3, s3);
      },
      slidePrev: function(e3, t3 = true, s3) {
        const a2 = this, { params: i3, snapGrid: r3, slidesGrid: n3, rtlTranslate: l3, enabled: o3, animating: d3 } = a2;
        if (!o3 || a2.destroyed) return a2;
        void 0 === e3 && (e3 = a2.params.speed);
        const c2 = a2.virtual && i3.virtual.enabled;
        if (i3.loop) {
          if (d3 && !c2 && i3.loopPreventsSliding) return false;
          a2.loopFix({ direction: "prev" }), a2._clientLeft = a2.wrapperEl.clientLeft;
        }
        function p2(e4) {
          return e4 < 0 ? -Math.floor(Math.abs(e4)) : Math.floor(e4);
        }
        const u2 = p2(l3 ? a2.translate : -a2.translate), m2 = r3.map((e4) => p2(e4)), h2 = i3.freeMode && i3.freeMode.enabled;
        let f2 = r3[m2.indexOf(u2) - 1];
        if (void 0 === f2 && (i3.cssMode || h2)) {
          let e4;
          r3.forEach((t4, s4) => {
            u2 >= t4 && (e4 = s4);
          }), void 0 !== e4 && (f2 = h2 ? r3[e4] : r3[e4 > 0 ? e4 - 1 : e4]);
        }
        let g2 = 0;
        if (void 0 !== f2 && (g2 = n3.indexOf(f2), g2 < 0 && (g2 = a2.activeIndex - 1), "auto" === i3.slidesPerView && 1 === i3.slidesPerGroup && i3.slidesPerGroupAuto && (g2 = g2 - a2.slidesPerViewDynamic("previous", true) + 1, g2 = Math.max(g2, 0))), i3.rewind && a2.isBeginning) {
          const i4 = a2.params.virtual && a2.params.virtual.enabled && a2.virtual ? a2.virtual.slides.length - 1 : a2.slides.length - 1;
          return a2.slideTo(i4, e3, t3, s3);
        }
        return i3.loop && 0 === a2.activeIndex && i3.cssMode ? (requestAnimationFrame(() => {
          a2.slideTo(g2, e3, t3, s3);
        }), true) : a2.slideTo(g2, e3, t3, s3);
      },
      slideReset: function(e3, t3 = true, s3) {
        const a2 = this;
        if (!a2.destroyed) return void 0 === e3 && (e3 = a2.params.speed), a2.slideTo(a2.activeIndex, e3, t3, s3);
      },
      slideToClosest: function(e3, t3 = true, s3, a2 = 0.5) {
        const i3 = this;
        if (i3.destroyed) return;
        void 0 === e3 && (e3 = i3.params.speed);
        let r3 = i3.activeIndex;
        const n3 = Math.min(i3.params.slidesPerGroupSkip, r3), l3 = n3 + Math.floor((r3 - n3) / i3.params.slidesPerGroup), o3 = i3.rtlTranslate ? i3.translate : -i3.translate;
        if (o3 >= i3.snapGrid[l3]) {
          const e4 = i3.snapGrid[l3];
          o3 - e4 > (i3.snapGrid[l3 + 1] - e4) * a2 && (r3 += i3.params.slidesPerGroup);
        } else {
          const e4 = i3.snapGrid[l3 - 1];
          o3 - e4 <= (i3.snapGrid[l3] - e4) * a2 && (r3 -= i3.params.slidesPerGroup);
        }
        return r3 = Math.max(r3, 0), r3 = Math.min(r3, i3.slidesGrid.length - 1), i3.slideTo(r3, e3, t3, s3);
      },
      slideToClickedSlide: function() {
        const e3 = this;
        if (e3.destroyed) return;
        const { params: t3, slidesEl: s3 } = e3, a2 = "auto" === t3.slidesPerView ? e3.slidesPerViewDynamic() : t3.slidesPerView;
        let i3, r3 = e3.getSlideIndexWhenGrid(e3.clickedIndex);
        const n3 = e3.isElement ? "swiper-slide" : `.${t3.slideClass}`, o3 = e3.grid && e3.params.grid && e3.params.grid.rows > 1;
        if (t3.loop) {
          if (e3.animating) return;
          i3 = parseInt(e3.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t3.centeredSlides ? e3.slideToLoop(i3) : r3 > (o3 ? (e3.slides.length - a2) / 2 - (e3.params.grid.rows - 1) : e3.slides.length - a2) ? (e3.loopFix(), r3 = e3.getSlideIndex(g(s3, `${n3}[data-swiper-slide-index="${i3}"]`)[0]), l2(() => {
            e3.slideTo(r3);
          })) : e3.slideTo(r3);
        } else e3.slideTo(r3);
      }
    };
    var q2 = {
      loopCreate: function(e3, t3) {
        const s3 = this, { params: a2, slidesEl: i3 } = s3;
        if (!a2.loop || s3.virtual && s3.params.virtual.enabled) return;
        const r3 = () => {
          g(i3, `.${a2.slideClass}, swiper-slide`).forEach((e4, t4) => {
            e4.setAttribute("data-swiper-slide-index", t4);
          });
        }, n3 = s3.grid && a2.grid && a2.grid.rows > 1;
        a2.loopAddBlankSlides && (a2.slidesPerGroup > 1 || n3) && (() => {
          const e4 = g(i3, `.${a2.slideBlankClass}`);
          e4.forEach((e5) => {
            e5.remove();
          }), e4.length > 0 && (s3.recalcSlides(), s3.updateSlides());
        })();
        const l3 = a2.slidesPerGroup * (n3 ? a2.grid.rows : 1), o3 = s3.slides.length % l3 !== 0, d3 = n3 && s3.slides.length % a2.grid.rows !== 0, c2 = (e4) => {
          for (let t4 = 0; t4 < e4; t4 += 1) {
            const e5 = s3.isElement ? w("swiper-slide", [a2.slideBlankClass]) : w("div", [a2.slideClass, a2.slideBlankClass]);
            s3.slidesEl.append(e5);
          }
        };
        if (o3) {
          if (a2.loopAddBlankSlides) {
            c2(l3 - s3.slides.length % l3), s3.recalcSlides(), s3.updateSlides();
          } else
            v(
              "Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"
            );
          r3();
        } else if (d3) {
          if (a2.loopAddBlankSlides) {
            c2(a2.grid.rows - s3.slides.length % a2.grid.rows), s3.recalcSlides(), s3.updateSlides();
          } else
            v(
              "Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"
            );
          r3();
        } else r3();
        const p2 = a2.centeredSlides || !!a2.slidesOffsetBefore || !!a2.slidesOffsetAfter;
        s3.loopFix({ slideRealIndex: e3, direction: p2 ? void 0 : "next", initial: t3 });
      },
      loopFix: function({
        slideRealIndex: e3,
        slideTo: t3 = true,
        direction: s3,
        setTranslate: a2,
        activeSlideIndex: i3,
        initial: r3,
        byController: n3,
        byMousewheel: l3
      } = {}) {
        const o3 = this;
        if (!o3.params.loop) return;
        o3.emit("beforeLoopFix");
        const { slides: d3, allowSlidePrev: c2, allowSlideNext: p2, slidesEl: u2, params: m2 } = o3, { centeredSlides: h2, slidesOffsetBefore: f2, slidesOffsetAfter: g2, initialSlide: w2 } = m2, b2 = h2 || !!f2 || !!g2;
        if (o3.allowSlidePrev = true, o3.allowSlideNext = true, o3.virtual && m2.virtual.enabled)
          return t3 && (b2 || 0 !== o3.snapIndex ? b2 && o3.snapIndex < m2.slidesPerView ? o3.slideTo(o3.virtual.slides.length + o3.snapIndex, 0, false, true) : o3.snapIndex === o3.snapGrid.length - 1 && o3.slideTo(o3.virtual.slidesBefore, 0, false, true) : o3.slideTo(o3.virtual.slides.length, 0, false, true)), o3.allowSlidePrev = c2, o3.allowSlideNext = p2, void o3.emit("loopFix");
        let y2 = m2.slidesPerView;
        "auto" === y2 ? y2 = o3.slidesPerViewDynamic() : (y2 = Math.ceil(parseFloat(m2.slidesPerView, 10)), b2 && y2 % 2 == 0 && (y2 += 1));
        const E2 = m2.slidesPerGroupAuto ? y2 : m2.slidesPerGroup;
        let x2 = b2 ? Math.max(E2, Math.ceil(y2 / 2)) : E2;
        x2 % E2 !== 0 && (x2 += E2 - x2 % E2), x2 += m2.loopAdditionalSlides, o3.loopedSlides = x2;
        const S2 = o3.grid && m2.grid && m2.grid.rows > 1;
        d3.length < y2 + x2 || "cards" === o3.params.effect && d3.length < y2 + 2 * x2 ? v(
          "Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"
        ) : S2 && "row" === m2.grid.fill && v("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
        const T3 = [], M3 = [], C3 = S2 ? Math.ceil(d3.length / m2.grid.rows) : d3.length, P2 = r3 && C3 - w2 < y2 && !b2;
        let L3 = P2 ? w2 : o3.activeIndex;
        void 0 === i3 ? i3 = o3.getSlideIndex(d3.find((e4) => e4.classList.contains(m2.slideActiveClass))) : L3 = i3;
        const z3 = "next" === s3 || !s3, I3 = "prev" === s3 || !s3;
        let A3 = 0, $2 = 0;
        const k3 = (S2 ? d3[i3].column : i3) + (b2 && void 0 === a2 ? -y2 / 2 + 0.5 : 0);
        if (k3 < x2) {
          A3 = Math.max(x2 - k3, E2);
          for (let e4 = 0; e4 < x2 - k3; e4 += 1) {
            const t4 = e4 - Math.floor(e4 / C3) * C3;
            if (S2) {
              const e5 = C3 - t4 - 1;
              for (let t5 = d3.length - 1; t5 >= 0; t5 -= 1) d3[t5].column === e5 && T3.push(t5);
            } else T3.push(C3 - t4 - 1);
          }
        } else if (k3 + y2 > C3 - x2) {
          $2 = Math.max(k3 - (C3 - 2 * x2), E2), P2 && ($2 = Math.max($2, y2 - C3 + w2 + 1));
          for (let e4 = 0; e4 < $2; e4 += 1) {
            const t4 = e4 - Math.floor(e4 / C3) * C3;
            S2 ? d3.forEach((e5, s4) => {
              e5.column === t4 && M3.push(s4);
            }) : M3.push(t4);
          }
        }
        if (o3.__preventObserver__ = true, requestAnimationFrame(() => {
          o3.__preventObserver__ = false;
        }), "cards" === o3.params.effect && d3.length < y2 + 2 * x2 && (M3.includes(i3) && M3.splice(M3.indexOf(i3), 1), T3.includes(i3) && T3.splice(T3.indexOf(i3), 1)), I3 && T3.forEach((e4) => {
          d3[e4].swiperLoopMoveDOM = true, u2.prepend(d3[e4]), d3[e4].swiperLoopMoveDOM = false;
        }), z3 && M3.forEach((e4) => {
          d3[e4].swiperLoopMoveDOM = true, u2.append(d3[e4]), d3[e4].swiperLoopMoveDOM = false;
        }), o3.recalcSlides(), "auto" === m2.slidesPerView ? o3.updateSlides() : S2 && (T3.length > 0 && I3 || M3.length > 0 && z3) && o3.slides.forEach((e4, t4) => {
          o3.grid.updateSlide(t4, e4, o3.slides);
        }), m2.watchSlidesProgress && o3.updateSlidesOffset(), t3) {
          if (T3.length > 0 && I3) {
            if (void 0 === e3) {
              const e4 = o3.slidesGrid[L3], t4 = o3.slidesGrid[L3 + A3] - e4;
              l3 ? o3.setTranslate(o3.translate - t4) : (o3.slideTo(L3 + Math.ceil(A3), 0, false, true), a2 && (o3.touchEventsData.startTranslate = o3.touchEventsData.startTranslate - t4, o3.touchEventsData.currentTranslate = o3.touchEventsData.currentTranslate - t4));
            } else if (a2) {
              const e4 = S2 ? T3.length / m2.grid.rows : T3.length;
              o3.slideTo(o3.activeIndex + e4, 0, false, true), o3.touchEventsData.currentTranslate = o3.translate;
            }
          } else if (M3.length > 0 && z3)
            if (void 0 === e3) {
              const e4 = o3.slidesGrid[L3], t4 = o3.slidesGrid[L3 - $2] - e4;
              l3 ? o3.setTranslate(o3.translate - t4) : (o3.slideTo(L3 - $2, 0, false, true), a2 && (o3.touchEventsData.startTranslate = o3.touchEventsData.startTranslate - t4, o3.touchEventsData.currentTranslate = o3.touchEventsData.currentTranslate - t4));
            } else {
              const e4 = S2 ? M3.length / m2.grid.rows : M3.length;
              o3.slideTo(o3.activeIndex - e4, 0, false, true);
            }
        }
        if (o3.allowSlidePrev = c2, o3.allowSlideNext = p2, o3.controller && o3.controller.control && !n3) {
          const r4 = { slideRealIndex: e3, direction: s3, setTranslate: a2, activeSlideIndex: i3, byController: true };
          Array.isArray(o3.controller.control) ? o3.controller.control.forEach((e4) => {
            !e4.destroyed && e4.params.loop && e4.loopFix({ ...r4, slideTo: e4.params.slidesPerView === m2.slidesPerView && t3 });
          }) : o3.controller.control instanceof o3.constructor && o3.controller.control.params.loop && o3.controller.control.loopFix({
            ...r4,
            slideTo: o3.controller.control.params.slidesPerView === m2.slidesPerView && t3
          });
        }
        o3.emit("loopFix");
      },
      loopDestroy: function() {
        const e3 = this, { params: t3, slidesEl: s3 } = e3;
        if (!t3.loop || !s3 || e3.virtual && e3.params.virtual.enabled) return;
        e3.recalcSlides();
        const a2 = [];
        e3.slides.forEach((e4) => {
          const t4 = void 0 === e4.swiperSlideIndex ? 1 * e4.getAttribute("data-swiper-slide-index") : e4.swiperSlideIndex;
          a2[t4] = e4;
        }), e3.slides.forEach((e4) => {
          e4.removeAttribute("data-swiper-slide-index");
        }), a2.forEach((e4) => {
          s3.append(e4);
        }), e3.recalcSlides(), e3.slideTo(e3.realIndex, 0);
      }
    };
    function _(e3, t3, s3) {
      const a2 = r2(), { params: i3 } = e3, n3 = i3.edgeSwipeDetection, l3 = i3.edgeSwipeThreshold;
      return !n3 || !(s3 <= l3 || s3 >= a2.innerWidth - l3) || "prevent" === n3 && (t3.preventDefault(), true);
    }
    function F2(e3) {
      const t3 = this, s3 = a();
      let i3 = e3;
      i3.originalEvent && (i3 = i3.originalEvent);
      const n3 = t3.touchEventsData;
      if ("pointerdown" === i3.type) {
        if (null !== n3.pointerId && n3.pointerId !== i3.pointerId) return;
        n3.pointerId = i3.pointerId;
      } else "touchstart" === i3.type && 1 === i3.targetTouches.length && (n3.touchId = i3.targetTouches[0].identifier);
      if ("touchstart" === i3.type) return void _(t3, i3, i3.targetTouches[0].pageX);
      const { params: l3, touches: d3, enabled: c2 } = t3;
      if (!c2) return;
      if (!l3.simulateTouch && "mouse" === i3.pointerType) return;
      if (t3.animating && l3.preventInteractionOnTransition) return;
      !t3.animating && l3.cssMode && l3.loop && t3.loopFix();
      let p2 = i3.target;
      if ("wrapper" === l3.touchEventsTarget && !(function(e4, t4) {
        const s4 = r2();
        let a2 = t4.contains(e4);
        !a2 && s4.HTMLSlotElement && t4 instanceof HTMLSlotElement && (a2 = [...t4.assignedElements()].includes(e4), a2 || (a2 = (function(e5, t5) {
          const s5 = [t5];
          for (; s5.length > 0; ) {
            const t6 = s5.shift();
            if (e5 === t6) return true;
            s5.push(
              ...t6.children,
              ...t6.shadowRoot ? t6.shadowRoot.children : [],
              ...t6.assignedElements ? t6.assignedElements() : []
            );
          }
        })(e4, t4)));
        return a2;
      })(p2, t3.wrapperEl))
        return;
      if ("which" in i3 && 3 === i3.which) return;
      if ("button" in i3 && i3.button > 0) return;
      if (n3.isTouched && n3.isMoved) return;
      const u2 = !!l3.noSwipingClass && "" !== l3.noSwipingClass, m2 = i3.composedPath ? i3.composedPath() : i3.path;
      u2 && i3.target && i3.target.shadowRoot && m2 && (p2 = m2[0]);
      const h2 = l3.noSwipingSelector ? l3.noSwipingSelector : `.${l3.noSwipingClass}`, f2 = !(!i3.target || !i3.target.shadowRoot);
      if (l3.noSwiping && (f2 ? (function(e4, t4 = this) {
        return (function t5(s4) {
          if (!s4 || s4 === a() || s4 === r2()) return null;
          s4.assignedSlot && (s4 = s4.assignedSlot);
          const i4 = s4.closest(e4);
          return i4 || s4.getRootNode ? i4 || t5(s4.getRootNode().host) : null;
        })(t4);
      })(h2, p2) : p2.closest(h2)))
        return void (t3.allowClick = true);
      if (l3.swipeHandler && !p2.closest(l3.swipeHandler)) return;
      d3.currentX = i3.pageX, d3.currentY = i3.pageY;
      const g2 = d3.currentX, v2 = d3.currentY;
      if (!_(t3, i3, g2)) return;
      Object.assign(n3, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: void 0,
        startMoving: void 0
      }), d3.startX = g2, d3.startY = v2, n3.touchStartTime = o2(), t3.allowClick = true, t3.updateSize(), t3.swipeDirection = void 0, l3.threshold > 0 && (n3.allowThresholdMove = false);
      let w2 = true;
      p2.matches(n3.focusableElements) && (w2 = false, "SELECT" === p2.nodeName && (n3.isTouched = false)), s3.activeElement && s3.activeElement.matches(n3.focusableElements) && s3.activeElement !== p2 && ("mouse" === i3.pointerType || "mouse" !== i3.pointerType && !p2.matches(n3.focusableElements)) && s3.activeElement.blur();
      const b2 = w2 && t3.allowTouchMove && l3.touchStartPreventDefault;
      !l3.touchStartForcePreventDefault && !b2 || p2.isContentEditable || i3.preventDefault(), l3.freeMode && l3.freeMode.enabled && t3.freeMode && t3.animating && !l3.cssMode && t3.freeMode.onTouchStart(), t3.emit("touchStart", i3);
    }
    function W2(e3) {
      const t3 = a(), s3 = this, i3 = s3.touchEventsData, { params: r3, touches: n3, rtlTranslate: l3, enabled: d3 } = s3;
      if (!d3) return;
      if (!r3.simulateTouch && "mouse" === e3.pointerType) return;
      let c2, p2 = e3;
      if (p2.originalEvent && (p2 = p2.originalEvent), "pointermove" === p2.type) {
        if (null !== i3.touchId) return;
        if (p2.pointerId !== i3.pointerId) return;
      }
      if ("touchmove" === p2.type) {
        if (c2 = [...p2.changedTouches].find((e4) => e4.identifier === i3.touchId), !c2 || c2.identifier !== i3.touchId)
          return;
      } else c2 = p2;
      if (!i3.isTouched) return void (i3.startMoving && i3.isScrolling && s3.emit("touchMoveOpposite", p2));
      const u2 = c2.pageX, m2 = c2.pageY;
      if (p2.preventedByNestedSwiper) return n3.startX = u2, void (n3.startY = m2);
      if (!s3.allowTouchMove)
        return p2.target.matches(i3.focusableElements) || (s3.allowClick = false), void (i3.isTouched && (Object.assign(n3, { startX: u2, startY: m2, currentX: u2, currentY: m2 }), i3.touchStartTime = o2()));
      if (r3.touchReleaseOnEdges && !r3.loop)
        if (s3.isVertical()) {
          if (m2 < n3.startY && s3.translate <= s3.maxTranslate() || m2 > n3.startY && s3.translate >= s3.minTranslate())
            return i3.isTouched = false, void (i3.isMoved = false);
        } else {
          if (l3 && (u2 > n3.startX && -s3.translate <= s3.maxTranslate() || u2 < n3.startX && -s3.translate >= s3.minTranslate()))
            return;
          if (!l3 && (u2 < n3.startX && s3.translate <= s3.maxTranslate() || u2 > n3.startX && s3.translate >= s3.minTranslate()))
            return;
        }
      if (t3.activeElement && t3.activeElement.matches(i3.focusableElements) && t3.activeElement !== p2.target && "mouse" !== p2.pointerType && t3.activeElement.blur(), t3.activeElement && p2.target === t3.activeElement && p2.target.matches(i3.focusableElements))
        return i3.isMoved = true, void (s3.allowClick = false);
      i3.allowTouchCallbacks && s3.emit("touchMove", p2), n3.previousX = n3.currentX, n3.previousY = n3.currentY, n3.currentX = u2, n3.currentY = m2;
      const h2 = n3.currentX - n3.startX, f2 = n3.currentY - n3.startY;
      if (s3.params.threshold && Math.sqrt(h2 ** 2 + f2 ** 2) < s3.params.threshold) return;
      if (void 0 === i3.isScrolling) {
        let e4;
        s3.isHorizontal() && n3.currentY === n3.startY || s3.isVertical() && n3.currentX === n3.startX ? i3.isScrolling = false : h2 * h2 + f2 * f2 >= 25 && (e4 = 180 * Math.atan2(Math.abs(f2), Math.abs(h2)) / Math.PI, i3.isScrolling = s3.isHorizontal() ? e4 > r3.touchAngle : 90 - e4 > r3.touchAngle);
      }
      if (i3.isScrolling && s3.emit("touchMoveOpposite", p2), void 0 === i3.startMoving && (n3.currentX === n3.startX && n3.currentY === n3.startY || (i3.startMoving = true)), i3.isScrolling || "touchmove" === p2.type && i3.preventTouchMoveFromPointerMove)
        return void (i3.isTouched = false);
      if (!i3.startMoving) return;
      s3.allowClick = false, !r3.cssMode && p2.cancelable && p2.preventDefault(), r3.touchMoveStopPropagation && !r3.nested && p2.stopPropagation();
      let g2 = s3.isHorizontal() ? h2 : f2, v2 = s3.isHorizontal() ? n3.currentX - n3.previousX : n3.currentY - n3.previousY;
      r3.oneWayMovement && (g2 = Math.abs(g2) * (l3 ? 1 : -1), v2 = Math.abs(v2) * (l3 ? 1 : -1)), n3.diff = g2, g2 *= r3.touchRatio, l3 && (g2 = -g2, v2 = -v2);
      const w2 = s3.touchesDirection;
      s3.swipeDirection = g2 > 0 ? "prev" : "next", s3.touchesDirection = v2 > 0 ? "prev" : "next";
      const b2 = s3.params.loop && !r3.cssMode, y2 = "next" === s3.touchesDirection && s3.allowSlideNext || "prev" === s3.touchesDirection && s3.allowSlidePrev;
      if (!i3.isMoved) {
        if (b2 && y2 && s3.loopFix({ direction: s3.swipeDirection }), i3.startTranslate = s3.getTranslate(), s3.setTransition(0), s3.animating) {
          const e4 = new window.CustomEvent("transitionend", {
            bubbles: true,
            cancelable: true,
            detail: { bySwiperTouchMove: true }
          });
          s3.wrapperEl.dispatchEvent(e4);
        }
        i3.allowMomentumBounce = false, !r3.grabCursor || true !== s3.allowSlideNext && true !== s3.allowSlidePrev || s3.setGrabCursor(true), s3.emit("sliderFirstMove", p2);
      }
      if ((/* @__PURE__ */ new Date()).getTime(), false !== r3._loopSwapReset && i3.isMoved && i3.allowThresholdMove && w2 !== s3.touchesDirection && b2 && y2 && Math.abs(g2) >= 1)
        return Object.assign(n3, { startX: u2, startY: m2, currentX: u2, currentY: m2, startTranslate: i3.currentTranslate }), i3.loopSwapReset = true, void (i3.startTranslate = i3.currentTranslate);
      s3.emit("sliderMove", p2), i3.isMoved = true, i3.currentTranslate = g2 + i3.startTranslate;
      let E2 = true, x2 = r3.resistanceRatio;
      if (r3.touchReleaseOnEdges && (x2 = 0), g2 > 0 ? (b2 && y2 && i3.allowThresholdMove && i3.currentTranslate > (r3.centeredSlides ? s3.minTranslate() - s3.slidesSizesGrid[s3.activeIndex + 1] - ("auto" !== r3.slidesPerView && s3.slides.length - r3.slidesPerView >= 2 ? s3.slidesSizesGrid[s3.activeIndex + 1] + s3.params.spaceBetween : 0) - s3.params.spaceBetween : s3.minTranslate()) && s3.loopFix({ direction: "prev", setTranslate: true, activeSlideIndex: 0 }), i3.currentTranslate > s3.minTranslate() && (E2 = false, r3.resistance && (i3.currentTranslate = s3.minTranslate() - 1 + (-s3.minTranslate() + i3.startTranslate + g2) ** x2))) : g2 < 0 && (b2 && y2 && i3.allowThresholdMove && i3.currentTranslate < (r3.centeredSlides ? s3.maxTranslate() + s3.slidesSizesGrid[s3.slidesSizesGrid.length - 1] + s3.params.spaceBetween + ("auto" !== r3.slidesPerView && s3.slides.length - r3.slidesPerView >= 2 ? s3.slidesSizesGrid[s3.slidesSizesGrid.length - 1] + s3.params.spaceBetween : 0) : s3.maxTranslate()) && s3.loopFix({
        direction: "next",
        setTranslate: true,
        activeSlideIndex: s3.slides.length - ("auto" === r3.slidesPerView ? s3.slidesPerViewDynamic() : Math.ceil(parseFloat(r3.slidesPerView, 10)))
      }), i3.currentTranslate < s3.maxTranslate() && (E2 = false, r3.resistance && (i3.currentTranslate = s3.maxTranslate() + 1 - (s3.maxTranslate() - i3.startTranslate - g2) ** x2))), E2 && (p2.preventedByNestedSwiper = true), !s3.allowSlideNext && "next" === s3.swipeDirection && i3.currentTranslate < i3.startTranslate && (i3.currentTranslate = i3.startTranslate), !s3.allowSlidePrev && "prev" === s3.swipeDirection && i3.currentTranslate > i3.startTranslate && (i3.currentTranslate = i3.startTranslate), s3.allowSlidePrev || s3.allowSlideNext || (i3.currentTranslate = i3.startTranslate), r3.threshold > 0) {
        if (!(Math.abs(g2) > r3.threshold || i3.allowThresholdMove)) return void (i3.currentTranslate = i3.startTranslate);
        if (!i3.allowThresholdMove)
          return i3.allowThresholdMove = true, n3.startX = n3.currentX, n3.startY = n3.currentY, i3.currentTranslate = i3.startTranslate, void (n3.diff = s3.isHorizontal() ? n3.currentX - n3.startX : n3.currentY - n3.startY);
      }
      r3.followFinger && !r3.cssMode && ((r3.freeMode && r3.freeMode.enabled && s3.freeMode || r3.watchSlidesProgress) && (s3.updateActiveIndex(), s3.updateSlidesClasses()), r3.freeMode && r3.freeMode.enabled && s3.freeMode && s3.freeMode.onTouchMove(), s3.updateProgress(i3.currentTranslate), s3.setTranslate(i3.currentTranslate));
    }
    function j2(e3) {
      const t3 = this, s3 = t3.touchEventsData;
      let a2, i3 = e3;
      i3.originalEvent && (i3 = i3.originalEvent);
      if ("touchend" === i3.type || "touchcancel" === i3.type) {
        if (a2 = [...i3.changedTouches].find((e4) => e4.identifier === s3.touchId), !a2 || a2.identifier !== s3.touchId)
          return;
      } else {
        if (null !== s3.touchId) return;
        if (i3.pointerId !== s3.pointerId) return;
        a2 = i3;
      }
      if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(i3.type)) {
        if (!(["pointercancel", "contextmenu"].includes(i3.type) && (t3.browser.isSafari || t3.browser.isWebView))) return;
      }
      s3.pointerId = null, s3.touchId = null;
      const { params: r3, touches: n3, rtlTranslate: d3, slidesGrid: c2, enabled: p2 } = t3;
      if (!p2) return;
      if (!r3.simulateTouch && "mouse" === i3.pointerType) return;
      if (s3.allowTouchCallbacks && t3.emit("touchEnd", i3), s3.allowTouchCallbacks = false, !s3.isTouched)
        return s3.isMoved && r3.grabCursor && t3.setGrabCursor(false), s3.isMoved = false, void (s3.startMoving = false);
      r3.grabCursor && s3.isMoved && s3.isTouched && (true === t3.allowSlideNext || true === t3.allowSlidePrev) && t3.setGrabCursor(false);
      const u2 = o2(), m2 = u2 - s3.touchStartTime;
      if (t3.allowClick) {
        const e4 = i3.path || i3.composedPath && i3.composedPath();
        t3.updateClickedSlide(e4 && e4[0] || i3.target, e4), t3.emit("tap click", i3), m2 < 300 && u2 - s3.lastClickTime < 300 && t3.emit("doubleTap doubleClick", i3);
      }
      if (s3.lastClickTime = o2(), l2(() => {
        t3.destroyed || (t3.allowClick = true);
      }), !s3.isTouched || !s3.isMoved || !t3.swipeDirection || 0 === n3.diff && !s3.loopSwapReset || s3.currentTranslate === s3.startTranslate && !s3.loopSwapReset)
        return s3.isTouched = false, s3.isMoved = false, void (s3.startMoving = false);
      let h2;
      if (s3.isTouched = false, s3.isMoved = false, s3.startMoving = false, h2 = r3.followFinger ? d3 ? t3.translate : -t3.translate : -s3.currentTranslate, r3.cssMode)
        return;
      if (r3.freeMode && r3.freeMode.enabled) return void t3.freeMode.onTouchEnd({ currentPos: h2 });
      const f2 = h2 >= -t3.maxTranslate() && !t3.params.loop;
      let g2 = 0, v2 = t3.slidesSizesGrid[0];
      for (let e4 = 0; e4 < c2.length; e4 += e4 < r3.slidesPerGroupSkip ? 1 : r3.slidesPerGroup) {
        const t4 = e4 < r3.slidesPerGroupSkip - 1 ? 1 : r3.slidesPerGroup;
        void 0 !== c2[e4 + t4] ? (f2 || h2 >= c2[e4] && h2 < c2[e4 + t4]) && (g2 = e4, v2 = c2[e4 + t4] - c2[e4]) : (f2 || h2 >= c2[e4]) && (g2 = e4, v2 = c2[c2.length - 1] - c2[c2.length - 2]);
      }
      let w2 = null, b2 = null;
      r3.rewind && (t3.isBeginning ? b2 = r3.virtual && r3.virtual.enabled && t3.virtual ? t3.virtual.slides.length - 1 : t3.slides.length - 1 : t3.isEnd && (w2 = 0));
      const y2 = (h2 - c2[g2]) / v2, E2 = g2 < r3.slidesPerGroupSkip - 1 ? 1 : r3.slidesPerGroup;
      if (m2 > r3.longSwipesMs) {
        if (!r3.longSwipes) return void t3.slideTo(t3.activeIndex);
        "next" === t3.swipeDirection && (y2 >= r3.longSwipesRatio ? t3.slideTo(r3.rewind && t3.isEnd ? w2 : g2 + E2) : t3.slideTo(g2)), "prev" === t3.swipeDirection && (y2 > 1 - r3.longSwipesRatio ? t3.slideTo(g2 + E2) : null !== b2 && y2 < 0 && Math.abs(y2) > r3.longSwipesRatio ? t3.slideTo(b2) : t3.slideTo(g2));
      } else {
        if (!r3.shortSwipes) return void t3.slideTo(t3.activeIndex);
        t3.navigation && (i3.target === t3.navigation.nextEl || i3.target === t3.navigation.prevEl) ? i3.target === t3.navigation.nextEl ? t3.slideTo(g2 + E2) : t3.slideTo(g2) : ("next" === t3.swipeDirection && t3.slideTo(null !== w2 ? w2 : g2 + E2), "prev" === t3.swipeDirection && t3.slideTo(null !== b2 ? b2 : g2));
      }
    }
    function U2() {
      const e3 = this, { params: t3, el: s3 } = e3;
      if (s3 && 0 === s3.offsetWidth) return;
      t3.breakpoints && e3.setBreakpoint();
      const { allowSlideNext: a2, allowSlidePrev: i3, snapGrid: r3 } = e3, n3 = e3.virtual && e3.params.virtual.enabled;
      e3.allowSlideNext = true, e3.allowSlidePrev = true, e3.updateSize(), e3.updateSlides(), e3.updateSlidesClasses();
      const l3 = n3 && t3.loop;
      !("auto" === t3.slidesPerView || t3.slidesPerView > 1) || !e3.isEnd || e3.isBeginning || e3.params.centeredSlides || l3 ? e3.params.loop && !n3 ? e3.slideToLoop(e3.realIndex, 0, false, true) : e3.slideTo(e3.activeIndex, 0, false, true) : e3.slideTo(e3.slides.length - 1, 0, false, true), e3.autoplay && e3.autoplay.running && e3.autoplay.paused && (clearTimeout(e3.autoplay.resizeTimeout), e3.autoplay.resizeTimeout = setTimeout(() => {
        e3.autoplay && e3.autoplay.running && e3.autoplay.paused && e3.autoplay.resume();
      }, 500)), e3.allowSlidePrev = i3, e3.allowSlideNext = a2, e3.params.watchOverflow && r3 !== e3.snapGrid && e3.checkOverflow();
    }
    function K2(e3) {
      const t3 = this;
      t3.enabled && (t3.allowClick || (t3.params.preventClicks && e3.preventDefault(), t3.params.preventClicksPropagation && t3.animating && (e3.stopPropagation(), e3.stopImmediatePropagation())));
    }
    function Z2() {
      const e3 = this, { wrapperEl: t3, rtlTranslate: s3, enabled: a2 } = e3;
      if (!a2) return;
      let i3;
      e3.previousTranslate = e3.translate, e3.isHorizontal() ? e3.translate = -t3.scrollLeft : e3.translate = -t3.scrollTop, 0 === e3.translate && (e3.translate = 0), e3.updateActiveIndex(), e3.updateSlidesClasses();
      const r3 = e3.maxTranslate() - e3.minTranslate();
      i3 = 0 === r3 ? 0 : (e3.translate - e3.minTranslate()) / r3, i3 !== e3.progress && e3.updateProgress(s3 ? -e3.translate : e3.translate), e3.emit("setTranslate", e3.translate, false);
    }
    function Q2(e3) {
      const t3 = this;
      X3(t3, e3.target), t3.params.cssMode || "auto" !== t3.params.slidesPerView && !t3.params.autoHeight || t3.update();
    }
    function J2() {
      const e3 = this;
      e3.documentTouchHandlerProceeded || (e3.documentTouchHandlerProceeded = true, e3.params.touchReleaseOnEdges && (e3.el.style.touchAction = "auto"));
    }
    const ee2 = (e3, t3) => {
      const s3 = a(), { params: i3, el: r3, wrapperEl: n3, device: l3 } = e3, o3 = !!i3.nested, d3 = "on" === t3 ? "addEventListener" : "removeEventListener", c2 = t3;
      r3 && "string" != typeof r3 && (s3[d3]("touchstart", e3.onDocumentTouchStart, { passive: false, capture: o3 }), r3[d3]("touchstart", e3.onTouchStart, { passive: false }), r3[d3]("pointerdown", e3.onTouchStart, { passive: false }), s3[d3]("touchmove", e3.onTouchMove, { passive: false, capture: o3 }), s3[d3]("pointermove", e3.onTouchMove, { passive: false, capture: o3 }), s3[d3]("touchend", e3.onTouchEnd, { passive: true }), s3[d3]("pointerup", e3.onTouchEnd, { passive: true }), s3[d3]("pointercancel", e3.onTouchEnd, { passive: true }), s3[d3]("touchcancel", e3.onTouchEnd, { passive: true }), s3[d3]("pointerout", e3.onTouchEnd, { passive: true }), s3[d3]("pointerleave", e3.onTouchEnd, { passive: true }), s3[d3]("contextmenu", e3.onTouchEnd, { passive: true }), (i3.preventClicks || i3.preventClicksPropagation) && r3[d3]("click", e3.onClick, true), i3.cssMode && n3[d3]("scroll", e3.onScroll), i3.updateOnWindowResize ? e3[c2](l3.ios || l3.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", U2, true) : e3[c2]("observerUpdate", U2, true), r3[d3]("load", e3.onLoad, { capture: true }));
    };
    const te2 = (e3, t3) => e3.grid && t3.grid && t3.grid.rows > 1;
    var se2 = {
      init: true,
      direction: "horizontal",
      oneWayMovement: false,
      swiperElementNodeName: "SWIPER-CONTAINER",
      touchEventsTarget: "wrapper",
      initialSlide: 0,
      speed: 300,
      cssMode: false,
      updateOnWindowResize: true,
      resizeObserver: true,
      nested: false,
      createElements: false,
      eventsPrefix: "swiper",
      enabled: true,
      focusableElements: "input, select, option, textarea, button, video, label",
      width: null,
      height: null,
      preventInteractionOnTransition: false,
      userAgent: null,
      url: null,
      edgeSwipeDetection: false,
      edgeSwipeThreshold: 20,
      autoHeight: false,
      setWrapperSize: false,
      virtualTranslate: false,
      effect: "slide",
      breakpoints: void 0,
      breakpointsBase: "window",
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      slidesPerGroupAuto: false,
      centeredSlides: false,
      centeredSlidesBounds: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      normalizeSlideIndex: true,
      centerInsufficientSlides: false,
      snapToSlideEdge: false,
      watchOverflow: true,
      roundLengths: false,
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: true,
      allowTouchMove: true,
      threshold: 5,
      touchMoveStopPropagation: false,
      touchStartPreventDefault: true,
      touchStartForcePreventDefault: false,
      touchReleaseOnEdges: false,
      uniqueNavElements: true,
      resistance: true,
      resistanceRatio: 0.85,
      watchSlidesProgress: false,
      grabCursor: false,
      preventClicks: true,
      preventClicksPropagation: true,
      slideToClickedSlide: false,
      loop: false,
      loopAddBlankSlides: true,
      loopAdditionalSlides: 0,
      loopPreventsSliding: true,
      rewind: false,
      allowSlidePrev: true,
      allowSlideNext: true,
      swipeHandler: null,
      noSwiping: true,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: null,
      passiveListeners: true,
      maxBackfaceHiddenSlides: 10,
      containerModifierClass: "swiper-",
      slideClass: "swiper-slide",
      slideBlankClass: "swiper-slide-blank",
      slideActiveClass: "swiper-slide-active",
      slideVisibleClass: "swiper-slide-visible",
      slideFullyVisibleClass: "swiper-slide-fully-visible",
      slideNextClass: "swiper-slide-next",
      slidePrevClass: "swiper-slide-prev",
      wrapperClass: "swiper-wrapper",
      lazyPreloaderClass: "swiper-lazy-preloader",
      lazyPreloadPrevNext: 0,
      runCallbacksOnInit: true,
      _emitClasses: false
    };
    function ae2(e3, t3) {
      return function(s3 = {}) {
        const a2 = Object.keys(s3)[0], i3 = s3[a2];
        "object" == typeof i3 && null !== i3 ? (true === e3[a2] && (e3[a2] = { enabled: true }), "navigation" === a2 && e3[a2] && e3[a2].enabled && !e3[a2].prevEl && !e3[a2].nextEl && (e3[a2].auto = true), ["pagination", "scrollbar"].indexOf(a2) >= 0 && e3[a2] && e3[a2].enabled && !e3[a2].el && (e3[a2].auto = true), a2 in e3 && "enabled" in i3 ? ("object" != typeof e3[a2] || "enabled" in e3[a2] || (e3[a2].enabled = true), e3[a2] || (e3[a2] = { enabled: false }), u(t3, s3)) : u(t3, s3)) : u(t3, s3);
      };
    }
    const ie = {
      eventsEmitter: O2,
      update: H2,
      translate: N2,
      transition: {
        setTransition: function(e3, t3) {
          const s3 = this;
          s3.params.cssMode || (s3.wrapperEl.style.transitionDuration = `${e3}ms`, s3.wrapperEl.style.transitionDelay = 0 === e3 ? "0ms" : ""), s3.emit("setTransition", e3, t3);
        },
        transitionStart: function(e3 = true, t3) {
          const s3 = this, { params: a2 } = s3;
          a2.cssMode || (a2.autoHeight && s3.updateAutoHeight(), R2({ swiper: s3, runCallbacks: e3, direction: t3, step: "Start" }));
        },
        transitionEnd: function(e3 = true, t3) {
          const s3 = this, { params: a2 } = s3;
          s3.animating = false, a2.cssMode || (s3.setTransition(0), R2({ swiper: s3, runCallbacks: e3, direction: t3, step: "End" }));
        }
      },
      slide: V2,
      loop: q2,
      grabCursor: {
        setGrabCursor: function(e3) {
          const t3 = this;
          if (!t3.params.simulateTouch || t3.params.watchOverflow && t3.isLocked || t3.params.cssMode) return;
          const s3 = "container" === t3.params.touchEventsTarget ? t3.el : t3.wrapperEl;
          t3.isElement && (t3.__preventObserver__ = true), s3.style.cursor = "move", s3.style.cursor = e3 ? "grabbing" : "grab", t3.isElement && requestAnimationFrame(() => {
            t3.__preventObserver__ = false;
          });
        },
        unsetGrabCursor: function() {
          const e3 = this;
          e3.params.watchOverflow && e3.isLocked || e3.params.cssMode || (e3.isElement && (e3.__preventObserver__ = true), e3["container" === e3.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "", e3.isElement && requestAnimationFrame(() => {
            e3.__preventObserver__ = false;
          }));
        }
      },
      events: {
        attachEvents: function() {
          const e3 = this, { params: t3 } = e3;
          e3.onTouchStart = F2.bind(e3), e3.onTouchMove = W2.bind(e3), e3.onTouchEnd = j2.bind(e3), e3.onDocumentTouchStart = J2.bind(e3), t3.cssMode && (e3.onScroll = Z2.bind(e3)), e3.onClick = K2.bind(e3), e3.onLoad = Q2.bind(e3), ee2(e3, "on");
        },
        detachEvents: function() {
          ee2(this, "off");
        }
      },
      breakpoints: {
        setBreakpoint: function() {
          const e3 = this, { realIndex: t3, initialized: s3, params: i3, el: r3 } = e3, n3 = i3.breakpoints;
          if (!n3 || n3 && 0 === Object.keys(n3).length) return;
          const l3 = a(), o3 = "window" !== i3.breakpointsBase && i3.breakpointsBase ? "container" : i3.breakpointsBase, d3 = ["window", "container"].includes(i3.breakpointsBase) || !i3.breakpointsBase ? e3.el : l3.querySelector(i3.breakpointsBase), c2 = e3.getBreakpoint(n3, o3, d3);
          if (!c2 || e3.currentBreakpoint === c2) return;
          const p2 = (c2 in n3 ? n3[c2] : void 0) || e3.originalParams, m2 = te2(e3, i3), h2 = te2(e3, p2), f2 = e3.params.grabCursor, g2 = p2.grabCursor, v2 = i3.enabled;
          m2 && !h2 ? (r3.classList.remove(`${i3.containerModifierClass}grid`, `${i3.containerModifierClass}grid-column`), e3.emitContainerClasses()) : !m2 && h2 && (r3.classList.add(`${i3.containerModifierClass}grid`), (p2.grid.fill && "column" === p2.grid.fill || !p2.grid.fill && "column" === i3.grid.fill) && r3.classList.add(`${i3.containerModifierClass}grid-column`), e3.emitContainerClasses()), f2 && !g2 ? e3.unsetGrabCursor() : !f2 && g2 && e3.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((t4) => {
            if (void 0 === p2[t4]) return;
            const s4 = i3[t4] && i3[t4].enabled, a2 = p2[t4] && p2[t4].enabled;
            s4 && !a2 && e3[t4].disable(), !s4 && a2 && e3[t4].enable();
          });
          const w2 = p2.direction && p2.direction !== i3.direction, b2 = i3.loop && (p2.slidesPerView !== i3.slidesPerView || w2), y2 = i3.loop;
          w2 && s3 && e3.changeDirection(), u(e3.params, p2);
          const E2 = e3.params.enabled, x2 = e3.params.loop;
          Object.assign(e3, {
            allowTouchMove: e3.params.allowTouchMove,
            allowSlideNext: e3.params.allowSlideNext,
            allowSlidePrev: e3.params.allowSlidePrev
          }), v2 && !E2 ? e3.disable() : !v2 && E2 && e3.enable(), e3.currentBreakpoint = c2, e3.emit("_beforeBreakpoint", p2), s3 && (b2 ? (e3.loopDestroy(), e3.loopCreate(t3), e3.updateSlides()) : !y2 && x2 ? (e3.loopCreate(t3), e3.updateSlides()) : y2 && !x2 && e3.loopDestroy()), e3.emit("breakpoint", p2);
        },
        getBreakpoint: function(e3, t3 = "window", s3) {
          if (!e3 || "container" === t3 && !s3) return;
          let a2 = false;
          const i3 = r2(), n3 = "window" === t3 ? i3.innerHeight : s3.clientHeight, l3 = Object.keys(e3).map((e4) => {
            if ("string" == typeof e4 && 0 === e4.indexOf("@")) {
              const t4 = parseFloat(e4.substr(1));
              return { value: n3 * t4, point: e4 };
            }
            return { value: e4, point: e4 };
          });
          l3.sort((e4, t4) => parseInt(e4.value, 10) - parseInt(t4.value, 10));
          for (let e4 = 0; e4 < l3.length; e4 += 1) {
            const { point: r3, value: n4 } = l3[e4];
            "window" === t3 ? i3.matchMedia(`(min-width: ${n4}px)`).matches && (a2 = r3) : n4 <= s3.clientWidth && (a2 = r3);
          }
          return a2 || "max";
        }
      },
      checkOverflow: {
        checkOverflow: function() {
          const e3 = this, { isLocked: t3, params: s3 } = e3, { slidesOffsetBefore: a2 } = s3;
          if (a2) {
            const t4 = e3.slides.length - 1, s4 = e3.slidesGrid[t4] + e3.slidesSizesGrid[t4] + 2 * a2;
            e3.isLocked = e3.size > s4;
          } else e3.isLocked = 1 === e3.snapGrid.length;
          true === s3.allowSlideNext && (e3.allowSlideNext = !e3.isLocked), true === s3.allowSlidePrev && (e3.allowSlidePrev = !e3.isLocked), t3 && t3 !== e3.isLocked && (e3.isEnd = false), t3 !== e3.isLocked && e3.emit(e3.isLocked ? "lock" : "unlock");
        }
      },
      classes: {
        addClasses: function() {
          const e3 = this, { classNames: t3, params: s3, rtl: a2, el: i3, device: r3 } = e3, n3 = (function(e4, t4) {
            const s4 = [];
            return e4.forEach((e5) => {
              "object" == typeof e5 ? Object.keys(e5).forEach((a3) => {
                e5[a3] && s4.push(t4 + a3);
              }) : "string" == typeof e5 && s4.push(t4 + e5);
            }), s4;
          })(
            [
              "initialized",
              s3.direction,
              { "free-mode": e3.params.freeMode && s3.freeMode.enabled },
              { autoheight: s3.autoHeight },
              { rtl: a2 },
              { grid: s3.grid && s3.grid.rows > 1 },
              { "grid-column": s3.grid && s3.grid.rows > 1 && "column" === s3.grid.fill },
              { android: r3.android },
              { ios: r3.ios },
              { "css-mode": s3.cssMode },
              { centered: s3.cssMode && s3.centeredSlides },
              { "watch-progress": s3.watchSlidesProgress }
            ],
            s3.containerModifierClass
          );
          t3.push(...n3), i3.classList.add(...t3), e3.emitContainerClasses();
        },
        removeClasses: function() {
          const { el: e3, classNames: t3 } = this;
          e3 && "string" != typeof e3 && (e3.classList.remove(...t3), this.emitContainerClasses());
        }
      }
    }, re = {};
    class ne2 {
      constructor(...e3) {
        let t3, s3;
        1 === e3.length && e3[0].constructor && "Object" === Object.prototype.toString.call(e3[0]).slice(8, -1) ? s3 = e3[0] : [t3, s3] = e3, s3 || (s3 = {}), s3 = u({}, s3), t3 && !s3.el && (s3.el = t3);
        const i3 = a();
        if (s3.el && "string" == typeof s3.el && i3.querySelectorAll(s3.el).length > 1) {
          const e4 = [];
          return i3.querySelectorAll(s3.el).forEach((t4) => {
            const a2 = u({}, s3, { el: t4 });
            e4.push(new ne2(a2));
          }), e4;
        }
        const r3 = this;
        r3.__swiper__ = true, r3.support = A2(), r3.device = $({ userAgent: s3.userAgent }), r3.browser = k2(), r3.eventsListeners = {}, r3.eventsAnyListeners = [], r3.modules = [...r3.__modules__], s3.modules && Array.isArray(s3.modules) && r3.modules.push(...s3.modules);
        const n3 = {};
        r3.modules.forEach((e4) => {
          e4({
            params: s3,
            swiper: r3,
            extendParams: ae2(s3, n3),
            on: r3.on.bind(r3),
            once: r3.once.bind(r3),
            off: r3.off.bind(r3),
            emit: r3.emit.bind(r3)
          });
        });
        const l3 = u({}, se2, n3);
        return r3.params = u({}, l3, re, s3), r3.originalParams = u({}, r3.params), r3.passedParams = u({}, s3), r3.params && r3.params.on && Object.keys(r3.params.on).forEach((e4) => {
          r3.on(e4, r3.params.on[e4]);
        }), r3.params && r3.params.onAny && r3.onAny(r3.params.onAny), Object.assign(r3, {
          enabled: r3.params.enabled,
          el: t3,
          classNames: [],
          slides: [],
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: () => "horizontal" === r3.params.direction,
          isVertical: () => "vertical" === r3.params.direction,
          activeIndex: 0,
          realIndex: 0,
          isBeginning: true,
          isEnd: false,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: false,
          cssOverflowAdjustment() {
            return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
          },
          allowSlideNext: r3.params.allowSlideNext,
          allowSlidePrev: r3.params.allowSlidePrev,
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            focusableElements: r3.params.focusableElements,
            lastClickTime: 0,
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            startMoving: void 0,
            pointerId: null,
            touchId: null
          },
          allowClick: true,
          allowTouchMove: r3.params.allowTouchMove,
          touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
          imagesToLoad: [],
          imagesLoaded: 0
        }), r3.emit("_swiper"), r3.params.init && r3.init(), r3;
      }
      getDirectionLabel(e3) {
        return this.isHorizontal() ? e3 : {
          width: "height",
          "margin-top": "margin-left",
          "margin-bottom ": "margin-right",
          "margin-left": "margin-top",
          "margin-right": "margin-bottom",
          "padding-left": "padding-top",
          "padding-right": "padding-bottom",
          marginRight: "marginBottom"
        }[e3];
      }
      getSlideIndex(e3) {
        const { slidesEl: t3, params: s3 } = this, a2 = E(g(t3, `.${s3.slideClass}, swiper-slide`)[0]);
        return E(e3) - a2;
      }
      getSlideIndexByData(e3) {
        return this.getSlideIndex(this.slides.find((t3) => 1 * t3.getAttribute("data-swiper-slide-index") === e3));
      }
      getSlideIndexWhenGrid(e3) {
        return this.grid && this.params.grid && this.params.grid.rows > 1 && ("column" === this.params.grid.fill ? e3 = Math.floor(e3 / this.params.grid.rows) : "row" === this.params.grid.fill && (e3 %= Math.ceil(this.slides.length / this.params.grid.rows))), e3;
      }
      recalcSlides() {
        const { slidesEl: e3, params: t3 } = this;
        this.slides = g(e3, `.${t3.slideClass}, swiper-slide`);
      }
      enable() {
        const e3 = this;
        e3.enabled || (e3.enabled = true, e3.params.grabCursor && e3.setGrabCursor(), e3.emit("enable"));
      }
      disable() {
        const e3 = this;
        e3.enabled && (e3.enabled = false, e3.params.grabCursor && e3.unsetGrabCursor(), e3.emit("disable"));
      }
      setProgress(e3, t3) {
        const s3 = this;
        e3 = Math.min(Math.max(e3, 0), 1);
        const a2 = s3.minTranslate(), i3 = (s3.maxTranslate() - a2) * e3 + a2;
        s3.translateTo(i3, void 0 === t3 ? 0 : t3), s3.updateActiveIndex(), s3.updateSlidesClasses();
      }
      emitContainerClasses() {
        const e3 = this;
        if (!e3.params._emitClasses || !e3.el) return;
        const t3 = e3.el.className.split(" ").filter((t4) => 0 === t4.indexOf("swiper") || 0 === t4.indexOf(e3.params.containerModifierClass));
        e3.emit("_containerClasses", t3.join(" "));
      }
      getSlideClasses(e3) {
        const t3 = this;
        return t3.destroyed ? "" : e3.className.split(" ").filter((e4) => 0 === e4.indexOf("swiper-slide") || 0 === e4.indexOf(t3.params.slideClass)).join(" ");
      }
      emitSlidesClasses() {
        const e3 = this;
        if (!e3.params._emitClasses || !e3.el) return;
        const t3 = [];
        e3.slides.forEach((s3) => {
          const a2 = e3.getSlideClasses(s3);
          t3.push({ slideEl: s3, classNames: a2 }), e3.emit("_slideClass", s3, a2);
        }), e3.emit("_slideClasses", t3);
      }
      slidesPerViewDynamic(e3 = "current", t3 = false) {
        const { params: s3, slides: a2, slidesGrid: i3, slidesSizesGrid: r3, size: n3, activeIndex: l3 } = this;
        let o3 = 1;
        if ("number" == typeof s3.slidesPerView) return s3.slidesPerView;
        if (s3.centeredSlides) {
          let e4, t4 = a2[l3] ? Math.ceil(a2[l3].swiperSlideSize) : 0;
          for (let s4 = l3 + 1; s4 < a2.length; s4 += 1)
            a2[s4] && !e4 && (t4 += Math.ceil(a2[s4].swiperSlideSize), o3 += 1, t4 > n3 && (e4 = true));
          for (let s4 = l3 - 1; s4 >= 0; s4 -= 1) a2[s4] && !e4 && (t4 += a2[s4].swiperSlideSize, o3 += 1, t4 > n3 && (e4 = true));
        } else if ("current" === e3)
          for (let e4 = l3 + 1; e4 < a2.length; e4 += 1) {
            (t3 ? i3[e4] + r3[e4] - i3[l3] < n3 : i3[e4] - i3[l3] < n3) && (o3 += 1);
          }
        else
          for (let e4 = l3 - 1; e4 >= 0; e4 -= 1) {
            i3[l3] - i3[e4] < n3 && (o3 += 1);
          }
        return o3;
      }
      update() {
        const e3 = this;
        if (!e3 || e3.destroyed) return;
        const { snapGrid: t3, params: s3 } = e3;
        function a2() {
          const t4 = e3.rtlTranslate ? -1 * e3.translate : e3.translate, s4 = Math.min(Math.max(t4, e3.maxTranslate()), e3.minTranslate());
          e3.setTranslate(s4), e3.updateActiveIndex(), e3.updateSlidesClasses();
        }
        let i3;
        if (s3.breakpoints && e3.setBreakpoint(), [...e3.el.querySelectorAll('[loading="lazy"]')].forEach((t4) => {
          t4.complete && X3(e3, t4);
        }), e3.updateSize(), e3.updateSlides(), e3.updateProgress(), e3.updateSlidesClasses(), s3.freeMode && s3.freeMode.enabled && !s3.cssMode)
          a2(), s3.autoHeight && e3.updateAutoHeight();
        else {
          if (("auto" === s3.slidesPerView || s3.slidesPerView > 1) && e3.isEnd && !s3.centeredSlides) {
            const t4 = e3.virtual && s3.virtual.enabled ? e3.virtual.slides : e3.slides;
            i3 = e3.slideTo(t4.length - 1, 0, false, true);
          } else i3 = e3.slideTo(e3.activeIndex, 0, false, true);
          i3 || a2();
        }
        s3.watchOverflow && t3 !== e3.snapGrid && e3.checkOverflow(), e3.emit("update");
      }
      changeDirection(e3, t3 = true) {
        const s3 = this, a2 = s3.params.direction;
        return e3 || (e3 = "horizontal" === a2 ? "vertical" : "horizontal"), e3 === a2 || "horizontal" !== e3 && "vertical" !== e3 || (s3.el.classList.remove(`${s3.params.containerModifierClass}${a2}`), s3.el.classList.add(`${s3.params.containerModifierClass}${e3}`), s3.emitContainerClasses(), s3.params.direction = e3, s3.slides.forEach((t4) => {
          "vertical" === e3 ? t4.style.width = "" : t4.style.height = "";
        }), s3.emit("changeDirection"), t3 && s3.update()), s3;
      }
      changeLanguageDirection(e3) {
        const t3 = this;
        t3.rtl && "rtl" === e3 || !t3.rtl && "ltr" === e3 || (t3.rtl = "rtl" === e3, t3.rtlTranslate = "horizontal" === t3.params.direction && t3.rtl, t3.rtl ? (t3.el.classList.add(`${t3.params.containerModifierClass}rtl`), t3.el.dir = "rtl") : (t3.el.classList.remove(`${t3.params.containerModifierClass}rtl`), t3.el.dir = "ltr"), t3.update());
      }
      mount(e3) {
        const t3 = this;
        if (t3.mounted) return true;
        let s3 = e3 || t3.params.el;
        if ("string" == typeof s3 && (s3 = document.querySelector(s3)), !s3) return false;
        s3.swiper = t3, s3.parentNode && s3.parentNode.host && s3.parentNode.host.nodeName === t3.params.swiperElementNodeName.toUpperCase() && (t3.isElement = true);
        const a2 = () => `.${(t3.params.wrapperClass || "").trim().split(" ").join(".")}`;
        let i3 = (() => {
          if (s3 && s3.shadowRoot && s3.shadowRoot.querySelector) {
            return s3.shadowRoot.querySelector(a2());
          }
          return g(s3, a2())[0];
        })();
        return !i3 && t3.params.createElements && (i3 = w("div", t3.params.wrapperClass), s3.append(i3), g(s3, `.${t3.params.slideClass}`).forEach((e4) => {
          i3.append(e4);
        })), Object.assign(t3, {
          el: s3,
          wrapperEl: i3,
          slidesEl: t3.isElement && !s3.parentNode.host.slideSlots ? s3.parentNode.host : i3,
          hostEl: t3.isElement ? s3.parentNode.host : s3,
          mounted: true,
          rtl: "rtl" === s3.dir.toLowerCase() || "rtl" === y(s3, "direction"),
          rtlTranslate: "horizontal" === t3.params.direction && ("rtl" === s3.dir.toLowerCase() || "rtl" === y(s3, "direction")),
          wrongRTL: "-webkit-box" === y(i3, "display")
        }), true;
      }
      init(e3) {
        const t3 = this;
        if (t3.initialized) return t3;
        if (false === t3.mount(e3)) return t3;
        t3.emit("beforeInit"), t3.params.breakpoints && t3.setBreakpoint(), t3.addClasses(), t3.updateSize(), t3.updateSlides(), t3.params.watchOverflow && t3.checkOverflow(), t3.params.grabCursor && t3.enabled && t3.setGrabCursor(), t3.params.loop && t3.virtual && t3.params.virtual.enabled ? t3.slideTo(t3.params.initialSlide + t3.virtual.slidesBefore, 0, t3.params.runCallbacksOnInit, false, true) : t3.slideTo(t3.params.initialSlide, 0, t3.params.runCallbacksOnInit, false, true), t3.params.loop && t3.loopCreate(void 0, true), t3.attachEvents();
        const s3 = [...t3.el.querySelectorAll('[loading="lazy"]')];
        return t3.isElement && s3.push(...t3.hostEl.querySelectorAll('[loading="lazy"]')), s3.forEach((e4) => {
          e4.complete ? X3(t3, e4) : e4.addEventListener("load", (e5) => {
            X3(t3, e5.target);
          });
        }), Y2(t3), t3.initialized = true, Y2(t3), t3.emit("init"), t3.emit("afterInit"), t3;
      }
      destroy(e3 = true, t3 = true) {
        const s3 = this, { params: a2, el: i3, wrapperEl: r3, slides: n3 } = s3;
        return void 0 === s3.params || s3.destroyed || (s3.emit("beforeDestroy"), s3.initialized = false, s3.detachEvents(), a2.loop && s3.loopDestroy(), t3 && (s3.removeClasses(), i3 && "string" != typeof i3 && i3.removeAttribute("style"), r3 && r3.removeAttribute("style"), n3 && n3.length && n3.forEach((e4) => {
          e4.classList.remove(
            a2.slideVisibleClass,
            a2.slideFullyVisibleClass,
            a2.slideActiveClass,
            a2.slideNextClass,
            a2.slidePrevClass
          ), e4.removeAttribute("style"), e4.removeAttribute("data-swiper-slide-index");
        })), s3.emit("destroy"), Object.keys(s3.eventsListeners).forEach((e4) => {
          s3.off(e4);
        }), false !== e3 && (s3.el && "string" != typeof s3.el && (s3.el.swiper = null), (function(e4) {
          const t4 = e4;
          Object.keys(t4).forEach((e5) => {
            try {
              t4[e5] = null;
            } catch (e6) {
            }
            try {
              delete t4[e5];
            } catch (e6) {
            }
          });
        })(s3)), s3.destroyed = true), null;
      }
      static extendDefaults(e3) {
        u(re, e3);
      }
      static get extendedDefaults() {
        return re;
      }
      static get defaults() {
        return se2;
      }
      static installModule(e3) {
        ne2.prototype.__modules__ || (ne2.prototype.__modules__ = []);
        const t3 = ne2.prototype.__modules__;
        "function" == typeof e3 && t3.indexOf(e3) < 0 && t3.push(e3);
      }
      static use(e3) {
        return Array.isArray(e3) ? (e3.forEach((e4) => ne2.installModule(e4)), ne2) : (ne2.installModule(e3), ne2);
      }
    }
    function le2(e3, t3, s3, a2) {
      return e3.params.createElements && Object.keys(a2).forEach((i3) => {
        if (!s3[i3] && true === s3.auto) {
          let r3 = g(e3.el, `.${a2[i3]}`)[0];
          r3 || (r3 = w("div", a2[i3]), r3.className = a2[i3], e3.el.append(r3)), s3[i3] = r3, t3[i3] = r3;
        }
      }), s3;
    }
    Object.keys(ie).forEach((e3) => {
      Object.keys(ie[e3]).forEach((t3) => {
        ne2.prototype[t3] = ie[e3][t3];
      });
    }), ne2.use([
      function({ swiper: e3, on: t3, emit: s3 }) {
        const a2 = r2();
        let i3 = null, n3 = null;
        const l3 = () => {
          e3 && !e3.destroyed && e3.initialized && (s3("beforeResize"), s3("resize"));
        }, o3 = () => {
          e3 && !e3.destroyed && e3.initialized && s3("orientationchange");
        };
        t3("init", () => {
          e3.params.resizeObserver && void 0 !== a2.ResizeObserver ? e3 && !e3.destroyed && e3.initialized && (i3 = new ResizeObserver((t4) => {
            n3 = a2.requestAnimationFrame(() => {
              const { width: s4, height: a3 } = e3;
              let i4 = s4, r3 = a3;
              t4.forEach(({ contentBoxSize: t5, contentRect: s5, target: a4 }) => {
                a4 && a4 !== e3.el || (i4 = s5 ? s5.width : (t5[0] || t5).inlineSize, r3 = s5 ? s5.height : (t5[0] || t5).blockSize);
              }), i4 === s4 && r3 === a3 || l3();
            });
          }), i3.observe(e3.el)) : (a2.addEventListener("resize", l3), a2.addEventListener("orientationchange", o3));
        }), t3("destroy", () => {
          n3 && a2.cancelAnimationFrame(n3), i3 && i3.unobserve && e3.el && (i3.unobserve(e3.el), i3 = null), a2.removeEventListener("resize", l3), a2.removeEventListener("orientationchange", o3);
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3, emit: a2 }) {
        const i3 = [], n3 = r2(), l3 = (t4, s4 = {}) => {
          const r3 = new (n3.MutationObserver || n3.WebkitMutationObserver)((t5) => {
            if (e3.__preventObserver__) return;
            if (1 === t5.length) return void a2("observerUpdate", t5[0]);
            const s5 = function() {
              a2("observerUpdate", t5[0]);
            };
            n3.requestAnimationFrame ? n3.requestAnimationFrame(s5) : n3.setTimeout(s5, 0);
          });
          r3.observe(t4, {
            attributes: void 0 === s4.attributes || s4.attributes,
            childList: e3.isElement || (void 0 === s4.childList || s4).childList,
            characterData: void 0 === s4.characterData || s4.characterData
          }), i3.push(r3);
        };
        t3({ observer: false, observeParents: false, observeSlideChildren: false }), s3("init", () => {
          if (e3.params.observer) {
            if (e3.params.observeParents) {
              const t4 = x(e3.hostEl);
              for (let e4 = 0; e4 < t4.length; e4 += 1) l3(t4[e4]);
            }
            l3(e3.hostEl, { childList: e3.params.observeSlideChildren }), l3(e3.wrapperEl, { attributes: false });
          }
        }), s3("destroy", () => {
          i3.forEach((e4) => {
            e4.disconnect();
          }), i3.splice(0, i3.length);
        });
      }
    ]);
    const oe2 = '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
    function de2(e3 = "") {
      return `.${e3.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, "\\$1").replace(/ /g, ".")}`;
    }
    function ce(e3) {
      const t3 = this, { params: s3, slidesEl: a2 } = t3;
      s3.loop && t3.loopDestroy();
      const i3 = (e4) => {
        if ("string" == typeof e4) {
          const t4 = document.createElement("div");
          P(t4, e4), a2.append(t4.children[0]), P(t4, "");
        } else a2.append(e4);
      };
      if ("object" == typeof e3 && "length" in e3) for (let t4 = 0; t4 < e3.length; t4 += 1) e3[t4] && i3(e3[t4]);
      else i3(e3);
      t3.recalcSlides(), s3.loop && t3.loopCreate(), s3.observer && !t3.isElement || t3.update();
    }
    function pe2(e3) {
      const t3 = this, { params: s3, activeIndex: a2, slidesEl: i3 } = t3;
      s3.loop && t3.loopDestroy();
      let r3 = a2 + 1;
      const n3 = (e4) => {
        if ("string" == typeof e4) {
          const t4 = document.createElement("div");
          P(t4, e4), i3.prepend(t4.children[0]), P(t4, "");
        } else i3.prepend(e4);
      };
      if ("object" == typeof e3 && "length" in e3) {
        for (let t4 = 0; t4 < e3.length; t4 += 1) e3[t4] && n3(e3[t4]);
        r3 = a2 + e3.length;
      } else n3(e3);
      t3.recalcSlides(), s3.loop && t3.loopCreate(), s3.observer && !t3.isElement || t3.update(), t3.slideTo(r3, 0, false);
    }
    function ue2(e3, t3) {
      const s3 = this, { params: a2, activeIndex: i3, slidesEl: r3 } = s3;
      let n3 = i3;
      a2.loop && (n3 -= s3.loopedSlides, s3.loopDestroy(), s3.recalcSlides());
      const l3 = s3.slides.length;
      if (e3 <= 0) return void s3.prependSlide(t3);
      if (e3 >= l3) return void s3.appendSlide(t3);
      let o3 = n3 > e3 ? n3 + 1 : n3;
      const d3 = [];
      for (let t4 = l3 - 1; t4 >= e3; t4 -= 1) {
        const e4 = s3.slides[t4];
        e4.remove(), d3.unshift(e4);
      }
      if ("object" == typeof t3 && "length" in t3) {
        for (let e4 = 0; e4 < t3.length; e4 += 1) t3[e4] && r3.append(t3[e4]);
        o3 = n3 > e3 ? n3 + t3.length : n3;
      } else r3.append(t3);
      for (let e4 = 0; e4 < d3.length; e4 += 1) r3.append(d3[e4]);
      s3.recalcSlides(), a2.loop && s3.loopCreate(), a2.observer && !s3.isElement || s3.update(), a2.loop ? s3.slideTo(o3 + s3.loopedSlides, 0, false) : s3.slideTo(o3, 0, false);
    }
    function me2(e3) {
      const t3 = this, { params: s3, activeIndex: a2 } = t3;
      let i3 = a2;
      s3.loop && (i3 -= t3.loopedSlides, t3.loopDestroy());
      let r3, n3 = i3;
      if ("object" == typeof e3 && "length" in e3) {
        for (let s4 = 0; s4 < e3.length; s4 += 1) r3 = e3[s4], t3.slides[r3] && t3.slides[r3].remove(), r3 < n3 && (n3 -= 1);
        n3 = Math.max(n3, 0);
      } else r3 = e3, t3.slides[r3] && t3.slides[r3].remove(), r3 < n3 && (n3 -= 1), n3 = Math.max(n3, 0);
      t3.recalcSlides(), s3.loop && t3.loopCreate(), s3.observer && !t3.isElement || t3.update(), s3.loop ? t3.slideTo(n3 + t3.loopedSlides, 0, false) : t3.slideTo(n3, 0, false);
    }
    function he2() {
      const e3 = this, t3 = [];
      for (let s3 = 0; s3 < e3.slides.length; s3 += 1) t3.push(s3);
      e3.removeSlide(t3);
    }
    function fe(e3) {
      const {
        effect: t3,
        swiper: s3,
        on: a2,
        setTranslate: i3,
        setTransition: r3,
        overwriteParams: n3,
        perspective: l3,
        recreateShadows: o3,
        getEffectParams: d3
      } = e3;
      let c2;
      a2("beforeInit", () => {
        if (s3.params.effect !== t3) return;
        s3.classNames.push(`${s3.params.containerModifierClass}${t3}`), l3 && l3() && s3.classNames.push(`${s3.params.containerModifierClass}3d`);
        const e4 = n3 ? n3() : {};
        Object.assign(s3.params, e4), Object.assign(s3.originalParams, e4);
      }), a2("setTranslate _virtualUpdated", () => {
        s3.params.effect === t3 && i3();
      }), a2("setTransition", (e4, a3) => {
        s3.params.effect === t3 && r3(a3);
      }), a2("transitionEnd", () => {
        if (s3.params.effect === t3 && o3) {
          if (!d3 || !d3().slideShadows) return;
          s3.slides.forEach((e4) => {
            e4.querySelectorAll(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            ).forEach((e5) => e5.remove());
          }), o3();
        }
      }), a2("virtualUpdate", () => {
        s3.params.effect === t3 && (s3.slides.length || (c2 = true), requestAnimationFrame(() => {
          c2 && s3.slides && s3.slides.length && (i3(), c2 = false);
        }));
      });
    }
    function ge2(e3, t3) {
      const s3 = f(t3);
      return s3 !== t3 && (s3.style.backfaceVisibility = "hidden", s3.style["-webkit-backface-visibility"] = "hidden"), s3;
    }
    function ve2({ swiper: e3, duration: t3, transformElements: s3, allSlides: a2 }) {
      const { activeIndex: i3 } = e3;
      if (e3.params.virtualTranslate && 0 !== t3) {
        let t4, r3 = false;
        t4 = a2 ? s3 : s3.filter((t5) => {
          const s4 = t5.classList.contains("swiper-slide-transform") ? ((t6) => {
            if (!t6.parentElement) return e3.slides.find((e4) => e4.shadowRoot && e4.shadowRoot === t6.parentNode);
            return t6.parentElement;
          })(t5) : t5;
          return e3.getSlideIndex(s4) === i3;
        }), t4.forEach((t5) => {
          S(t5, () => {
            if (r3) return;
            if (!e3 || e3.destroyed) return;
            r3 = true, e3.animating = false;
            const t6 = new window.CustomEvent("transitionend", { bubbles: true, cancelable: true });
            e3.wrapperEl.dispatchEvent(t6);
          });
        });
      }
    }
    function we2(e3, t3, s3) {
      const a2 = `swiper-slide-shadow${s3 ? `-${s3}` : ""}${e3 ? ` swiper-slide-shadow-${e3}` : ""}`, i3 = f(t3);
      let r3 = i3.querySelector(`.${a2.split(" ").join(".")}`);
      return r3 || (r3 = w("div", a2.split(" ")), i3.append(r3)), r3;
    }
    const be2 = [
      function({ swiper: e3, extendParams: t3, on: s3, emit: i3 }) {
        let r3;
        t3({
          virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
          }
        });
        const n3 = a();
        e3.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] };
        const l3 = n3.createElement("div");
        function o3(t4, s4) {
          const a2 = e3.params.virtual;
          if (a2.cache && e3.virtual.cache[s4]) return e3.virtual.cache[s4];
          let i4;
          return a2.renderSlide ? (i4 = a2.renderSlide.call(e3, t4, s4), "string" == typeof i4 && (P(l3, i4), i4 = l3.children[0])) : i4 = e3.isElement ? w("swiper-slide") : w("div", e3.params.slideClass), i4.setAttribute("data-swiper-slide-index", s4), a2.renderSlide || P(i4, t4), a2.cache && (e3.virtual.cache[s4] = i4), i4;
        }
        function d3(t4, s4, a2) {
          const { slidesPerGroup: r4, centeredSlides: n4, slidesPerView: l4, loop: d4, initialSlide: c2 } = e3.params;
          if (s4 && !d4 && c2 > 0) return;
          const { addSlidesBefore: p2, addSlidesAfter: u2, slidesPerViewAutoSlideSize: m2 } = e3.params.virtual, { from: h2, to: f2, slides: v2, slidesGrid: w2, offset: b2 } = e3.virtual;
          e3.params.cssMode || e3.updateActiveIndex();
          const y2 = void 0 === a2 ? e3.activeIndex || 0 : a2;
          let E2, x2, S2, T3;
          if (E2 = e3.rtlTranslate ? "right" : e3.isHorizontal() ? "left" : "top", "auto" === l4)
            if (m2) {
              let t5 = e3.size;
              t5 || (t5 = e3.isHorizontal() ? e3.el.getBoundingClientRect().width : e3.el.getBoundingClientRect().height), x2 = Math.max(1, Math.ceil(t5 / m2));
            } else x2 = 1;
          else x2 = l4;
          n4 ? (S2 = Math.floor(x2 / 2) + r4 + u2, T3 = Math.floor(x2 / 2) + r4 + p2) : (S2 = x2 + (r4 - 1) + u2, T3 = (d4 ? x2 : r4) + p2);
          let M3 = y2 - T3, C3 = y2 + S2;
          d4 || (M3 = Math.max(M3, 0), C3 = Math.min(C3, v2.length - 1));
          let P2 = (e3.slidesGrid[M3] || 0) - (e3.slidesGrid[0] || 0);
          function L3() {
            e3.updateSlides(), e3.updateProgress(), e3.updateSlidesClasses(), i3("virtualUpdate");
          }
          if (d4 && y2 >= T3 ? (M3 -= T3, n4 || (P2 += e3.slidesGrid[0])) : d4 && y2 < T3 && (M3 = -T3, n4 && (P2 += e3.slidesGrid[0])), Object.assign(e3.virtual, {
            from: M3,
            to: C3,
            offset: P2,
            slidesGrid: e3.slidesGrid,
            slidesBefore: T3,
            slidesAfter: S2
          }), h2 === M3 && f2 === C3 && !t4)
            return e3.slidesGrid !== w2 && P2 !== b2 && e3.slides.forEach((t5) => {
              t5.style[E2] = P2 - Math.abs(e3.cssOverflowAdjustment()) + "px";
            }), e3.updateProgress(), void i3("virtualUpdate");
          if (e3.params.virtual.renderExternal)
            return e3.params.virtual.renderExternal.call(e3, {
              offset: P2,
              from: M3,
              to: C3,
              slides: (function() {
                const e4 = [];
                for (let t5 = M3; t5 <= C3; t5 += 1) e4.push(v2[t5]);
                return e4;
              })()
            }), void (e3.params.virtual.renderExternalUpdate ? L3() : i3("virtualUpdate"));
          const z3 = [], I3 = [], A3 = (e4) => {
            let t5 = e4;
            return e4 < 0 ? t5 = v2.length + e4 : t5 >= v2.length && (t5 -= v2.length), t5;
          };
          if (t4)
            e3.slides.filter((t5) => t5.matches(`.${e3.params.slideClass}, swiper-slide`)).forEach((e4) => {
              e4.remove();
            });
          else
            for (let t5 = h2; t5 <= f2; t5 += 1)
              if (t5 < M3 || t5 > C3) {
                const s5 = A3(t5);
                e3.slides.filter(
                  (t6) => t6.matches(
                    `.${e3.params.slideClass}[data-swiper-slide-index="${s5}"], swiper-slide[data-swiper-slide-index="${s5}"]`
                  )
                ).forEach((e4) => {
                  e4.remove();
                });
              }
          const $2 = d4 ? -v2.length : 0, k3 = d4 ? 2 * v2.length : v2.length;
          for (let e4 = $2; e4 < k3; e4 += 1)
            if (e4 >= M3 && e4 <= C3) {
              const s5 = A3(e4);
              void 0 === f2 || t4 ? I3.push(s5) : (e4 > f2 && I3.push(s5), e4 < h2 && z3.push(s5));
            }
          if (I3.forEach((t5) => {
            e3.slidesEl.append(o3(v2[t5], t5));
          }), d4)
            for (let t5 = z3.length - 1; t5 >= 0; t5 -= 1) {
              const s5 = z3[t5];
              e3.slidesEl.prepend(o3(v2[s5], s5));
            }
          else
            z3.sort((e4, t5) => t5 - e4), z3.forEach((t5) => {
              e3.slidesEl.prepend(o3(v2[t5], t5));
            });
          g(e3.slidesEl, ".swiper-slide, swiper-slide").forEach((t5) => {
            t5.style[E2] = P2 - Math.abs(e3.cssOverflowAdjustment()) + "px";
          }), L3();
        }
        s3("beforeInit", () => {
          if (!e3.params.virtual.enabled) return;
          let t4;
          if (void 0 === e3.passedParams.virtual.slides) {
            const s4 = [...e3.slidesEl.children].filter((t5) => t5.matches(`.${e3.params.slideClass}, swiper-slide`));
            s4 && s4.length && (e3.virtual.slides = [...s4], t4 = true, s4.forEach((t5, s5) => {
              t5.setAttribute("data-swiper-slide-index", s5), e3.virtual.cache[s5] = t5, t5.remove();
            }));
          }
          t4 || (e3.virtual.slides = e3.params.virtual.slides), e3.classNames.push(`${e3.params.containerModifierClass}virtual`), e3.params.watchSlidesProgress = true, e3.originalParams.watchSlidesProgress = true, d3(false, true);
        }), s3("setTranslate", () => {
          e3.params.virtual.enabled && (e3.params.cssMode && !e3._immediateVirtual ? (clearTimeout(r3), r3 = setTimeout(() => {
            d3();
          }, 100)) : d3());
        }), s3("init update resize", () => {
          e3.params.virtual.enabled && e3.params.cssMode && m(e3.wrapperEl, "--swiper-virtual-size", `${e3.virtualSize}px`);
        }), Object.assign(e3.virtual, {
          appendSlide: function(t4) {
            if ("object" == typeof t4 && "length" in t4)
              for (let s4 = 0; s4 < t4.length; s4 += 1) t4[s4] && e3.virtual.slides.push(t4[s4]);
            else e3.virtual.slides.push(t4);
            d3(true);
          },
          prependSlide: function(t4) {
            const s4 = e3.activeIndex;
            let a2 = s4 + 1, i4 = 1;
            if (Array.isArray(t4)) {
              for (let s5 = 0; s5 < t4.length; s5 += 1) t4[s5] && e3.virtual.slides.unshift(t4[s5]);
              a2 = s4 + t4.length, i4 = t4.length;
            } else e3.virtual.slides.unshift(t4);
            if (e3.params.virtual.cache) {
              const t5 = e3.virtual.cache, s5 = {};
              Object.keys(t5).forEach((e4) => {
                const a3 = t5[e4], r4 = a3.getAttribute("data-swiper-slide-index");
                r4 && a3.setAttribute("data-swiper-slide-index", parseInt(r4, 10) + i4), s5[parseInt(e4, 10) + i4] = a3;
              }), e3.virtual.cache = s5;
            }
            d3(true), e3.slideTo(a2, 0);
          },
          removeSlide: function(t4) {
            if (null == t4) return;
            let s4 = e3.activeIndex;
            if (Array.isArray(t4))
              for (let a2 = t4.length - 1; a2 >= 0; a2 -= 1)
                e3.params.virtual.cache && (delete e3.virtual.cache[t4[a2]], Object.keys(e3.virtual.cache).forEach((s5) => {
                  s5 > t4 && (e3.virtual.cache[s5 - 1] = e3.virtual.cache[s5], e3.virtual.cache[s5 - 1].setAttribute("data-swiper-slide-index", s5 - 1), delete e3.virtual.cache[s5]);
                })), e3.virtual.slides.splice(t4[a2], 1), t4[a2] < s4 && (s4 -= 1), s4 = Math.max(s4, 0);
            else
              e3.params.virtual.cache && (delete e3.virtual.cache[t4], Object.keys(e3.virtual.cache).forEach((s5) => {
                s5 > t4 && (e3.virtual.cache[s5 - 1] = e3.virtual.cache[s5], e3.virtual.cache[s5 - 1].setAttribute("data-swiper-slide-index", s5 - 1), delete e3.virtual.cache[s5]);
              })), e3.virtual.slides.splice(t4, 1), t4 < s4 && (s4 -= 1), s4 = Math.max(s4, 0);
            d3(true), e3.slideTo(s4, 0);
          },
          removeAllSlides: function() {
            e3.virtual.slides = [], e3.params.virtual.cache && (e3.virtual.cache = {}), d3(true), e3.slideTo(0, 0);
          },
          update: d3
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3, emit: i3 }) {
        const n3 = a(), l3 = r2();
        function o3(t4) {
          if (!e3.enabled) return;
          const { rtlTranslate: s4 } = e3;
          let a2 = t4;
          a2.originalEvent && (a2 = a2.originalEvent);
          const r3 = a2.keyCode || a2.charCode, o4 = e3.params.keyboard.pageUpDown, d4 = o4 && 33 === r3, c3 = o4 && 34 === r3, p2 = 37 === r3, u2 = 39 === r3, m2 = 38 === r3, h2 = 40 === r3;
          if (!e3.allowSlideNext && (e3.isHorizontal() && u2 || e3.isVertical() && h2 || c3)) return false;
          if (!e3.allowSlidePrev && (e3.isHorizontal() && p2 || e3.isVertical() && m2 || d4)) return false;
          if (a2.shiftKey || a2.altKey || a2.ctrlKey || a2.metaKey) return;
          if (n3.activeElement && (n3.activeElement.isContentEditable || n3.activeElement.nodeName && ("input" === n3.activeElement.nodeName.toLowerCase() || "textarea" === n3.activeElement.nodeName.toLowerCase())))
            return;
          if (e3.params.keyboard.onlyInViewport && (d4 || c3 || p2 || u2 || m2 || h2)) {
            let t5 = false;
            if (x(e3.el, `.${e3.params.slideClass}, swiper-slide`).length > 0 && 0 === x(e3.el, `.${e3.params.slideActiveClass}`).length)
              return;
            const a3 = e3.el, i4 = a3.clientWidth, r4 = a3.clientHeight, n4 = l3.innerWidth, o5 = l3.innerHeight, d5 = b(a3);
            s4 && (d5.left -= a3.scrollLeft);
            const c4 = [
              [d5.left, d5.top],
              [d5.left + i4, d5.top],
              [d5.left, d5.top + r4],
              [d5.left + i4, d5.top + r4]
            ];
            for (let e4 = 0; e4 < c4.length; e4 += 1) {
              const s5 = c4[e4];
              if (s5[0] >= 0 && s5[0] <= n4 && s5[1] >= 0 && s5[1] <= o5) {
                if (0 === s5[0] && 0 === s5[1]) continue;
                t5 = true;
              }
            }
            if (!t5) return;
          }
          const f2 = e3.params.keyboard.speed;
          e3.isHorizontal() ? ((d4 || c3 || p2 || u2) && (a2.preventDefault ? a2.preventDefault() : a2.returnValue = false), ((c3 || u2) && !s4 || (d4 || p2) && s4) && e3.slideNext(f2), ((d4 || p2) && !s4 || (c3 || u2) && s4) && e3.slidePrev(f2)) : ((d4 || c3 || m2 || h2) && (a2.preventDefault ? a2.preventDefault() : a2.returnValue = false), (c3 || h2) && e3.slideNext(f2), (d4 || m2) && e3.slidePrev(f2)), i3("keyPress", r3);
        }
        function d3() {
          e3.keyboard.enabled || (n3.addEventListener("keydown", o3), e3.keyboard.enabled = true);
        }
        function c2() {
          e3.keyboard.enabled && (n3.removeEventListener("keydown", o3), e3.keyboard.enabled = false);
        }
        e3.keyboard = { enabled: false }, t3({ keyboard: { enabled: false, onlyInViewport: true, pageUpDown: true, speed: void 0 } }), s3("init", () => {
          e3.params.keyboard.enabled && d3();
        }), s3("destroy", () => {
          e3.keyboard.enabled && c2();
        }), Object.assign(e3.keyboard, { enable: d3, disable: c2 });
      },
      function({ swiper: e3, extendParams: t3, on: s3, emit: a2 }) {
        const i3 = r2();
        let n3;
        t3({
          mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
          }
        }), e3.mousewheel = { enabled: false };
        let d3, c2 = o2();
        const p2 = [];
        function u2() {
          e3.enabled && (e3.mouseEntered = true);
        }
        function m2() {
          e3.enabled && (e3.mouseEntered = false);
        }
        function h2(t4) {
          return !(e3.params.mousewheel.thresholdDelta && t4.delta < e3.params.mousewheel.thresholdDelta) && !(e3.params.mousewheel.thresholdTime && o2() - c2 < e3.params.mousewheel.thresholdTime) && (t4.delta >= 6 && o2() - c2 < 60 || (t4.direction < 0 ? e3.isEnd && !e3.params.loop || e3.animating || (e3.slideNext(), a2("scroll", t4.raw)) : e3.isBeginning && !e3.params.loop || e3.animating || (e3.slidePrev(), a2("scroll", t4.raw)), c2 = new i3.Date().getTime(), false));
        }
        function f2(t4) {
          let s4 = t4, i4 = true;
          if (!e3.enabled) return;
          if (t4.target.closest(`.${e3.params.mousewheel.noMousewheelClass}`)) return;
          const r3 = e3.params.mousewheel;
          e3.params.cssMode && s4.preventDefault();
          let c3 = e3.el;
          "container" !== e3.params.mousewheel.eventsTarget && (c3 = document.querySelector(e3.params.mousewheel.eventsTarget));
          const u3 = c3 && c3.contains(s4.target);
          if (!e3.mouseEntered && !u3 && !r3.releaseOnEdges) return true;
          s4.originalEvent && (s4 = s4.originalEvent);
          let m3 = 0;
          const f3 = e3.rtlTranslate ? -1 : 1, g3 = (function(e4) {
            let t5 = 0, s5 = 0, a3 = 0, i5 = 0;
            return "detail" in e4 && (s5 = e4.detail), "wheelDelta" in e4 && (s5 = -e4.wheelDelta / 120), "wheelDeltaY" in e4 && (s5 = -e4.wheelDeltaY / 120), "wheelDeltaX" in e4 && (t5 = -e4.wheelDeltaX / 120), "axis" in e4 && e4.axis === e4.HORIZONTAL_AXIS && (t5 = s5, s5 = 0), a3 = 10 * t5, i5 = 10 * s5, "deltaY" in e4 && (i5 = e4.deltaY), "deltaX" in e4 && (a3 = e4.deltaX), e4.shiftKey && !a3 && (a3 = i5, i5 = 0), (a3 || i5) && e4.deltaMode && (1 === e4.deltaMode ? (a3 *= 40, i5 *= 40) : (a3 *= 800, i5 *= 800)), a3 && !t5 && (t5 = a3 < 1 ? -1 : 1), i5 && !s5 && (s5 = i5 < 1 ? -1 : 1), { spinX: t5, spinY: s5, pixelX: a3, pixelY: i5 };
          })(s4);
          if (r3.forceToAxis)
            if (e3.isHorizontal()) {
              if (!(Math.abs(g3.pixelX) > Math.abs(g3.pixelY))) return true;
              m3 = -g3.pixelX * f3;
            } else {
              if (!(Math.abs(g3.pixelY) > Math.abs(g3.pixelX))) return true;
              m3 = -g3.pixelY;
            }
          else m3 = Math.abs(g3.pixelX) > Math.abs(g3.pixelY) ? -g3.pixelX * f3 : -g3.pixelY;
          if (0 === m3) return true;
          r3.invert && (m3 = -m3);
          let v3 = e3.getTranslate() + m3 * r3.sensitivity;
          if (v3 >= e3.minTranslate() && (v3 = e3.minTranslate()), v3 <= e3.maxTranslate() && (v3 = e3.maxTranslate()), i4 = !!e3.params.loop || !(v3 === e3.minTranslate() || v3 === e3.maxTranslate()), i4 && e3.params.nested && s4.stopPropagation(), e3.params.freeMode && e3.params.freeMode.enabled) {
            const t5 = { time: o2(), delta: Math.abs(m3), direction: Math.sign(m3) }, i5 = d3 && t5.time < d3.time + 500 && t5.delta <= d3.delta && t5.direction === d3.direction;
            if (!i5) {
              d3 = void 0;
              let o3 = e3.getTranslate() + m3 * r3.sensitivity;
              const c4 = e3.isBeginning, u4 = e3.isEnd;
              if (o3 >= e3.minTranslate() && (o3 = e3.minTranslate()), o3 <= e3.maxTranslate() && (o3 = e3.maxTranslate()), e3.setTransition(0), e3.setTranslate(o3), e3.updateProgress(), e3.updateActiveIndex(), e3.updateSlidesClasses(), (!c4 && e3.isBeginning || !u4 && e3.isEnd) && e3.updateSlidesClasses(), e3.params.loop && e3.loopFix({ direction: t5.direction < 0 ? "next" : "prev", byMousewheel: true }), e3.params.freeMode.sticky) {
                clearTimeout(n3), n3 = void 0, p2.length >= 15 && p2.shift();
                const s5 = p2.length ? p2[p2.length - 1] : void 0, a3 = p2[0];
                if (p2.push(t5), s5 && (t5.delta > s5.delta || t5.direction !== s5.direction)) p2.splice(0);
                else if (p2.length >= 15 && t5.time - a3.time < 500 && a3.delta - t5.delta >= 1 && t5.delta <= 6) {
                  const s6 = m3 > 0 ? 0.8 : 0.2;
                  d3 = t5, p2.splice(0), n3 = l2(() => {
                    !e3.destroyed && e3.params && e3.slideToClosest(e3.params.speed, true, void 0, s6);
                  }, 0);
                }
                n3 || (n3 = l2(() => {
                  if (e3.destroyed || !e3.params) return;
                  d3 = t5, p2.splice(0), e3.slideToClosest(e3.params.speed, true, void 0, 0.5);
                }, 500));
              }
              if (i5 || a2("scroll", s4), e3.params.autoplay && e3.params.autoplay.disableOnInteraction && e3.autoplay.stop(), r3.releaseOnEdges && (o3 === e3.minTranslate() || o3 === e3.maxTranslate()))
                return true;
            }
          } else {
            const s5 = { time: o2(), delta: Math.abs(m3), direction: Math.sign(m3), raw: t4 };
            p2.length >= 2 && p2.shift();
            const a3 = p2.length ? p2[p2.length - 1] : void 0;
            if (p2.push(s5), a3 ? (s5.direction !== a3.direction || s5.delta > a3.delta || s5.time > a3.time + 150) && h2(s5) : h2(s5), (function(t5) {
              const s6 = e3.params.mousewheel;
              if (t5.direction < 0) {
                if (e3.isEnd && !e3.params.loop && s6.releaseOnEdges) return true;
              } else if (e3.isBeginning && !e3.params.loop && s6.releaseOnEdges) return true;
              return false;
            })(s5))
              return true;
          }
          return s4.preventDefault ? s4.preventDefault() : s4.returnValue = false, false;
        }
        function g2(t4) {
          let s4 = e3.el;
          "container" !== e3.params.mousewheel.eventsTarget && (s4 = document.querySelector(e3.params.mousewheel.eventsTarget)), s4[t4]("mouseenter", u2), s4[t4]("mouseleave", m2), s4[t4]("wheel", f2);
        }
        function v2() {
          return e3.params.cssMode ? (e3.wrapperEl.removeEventListener("wheel", f2), true) : !e3.mousewheel.enabled && (g2("addEventListener"), e3.mousewheel.enabled = true, true);
        }
        function w2() {
          return e3.params.cssMode ? (e3.wrapperEl.addEventListener(event, f2), true) : !!e3.mousewheel.enabled && (g2("removeEventListener"), e3.mousewheel.enabled = false, true);
        }
        s3("init", () => {
          !e3.params.mousewheel.enabled && e3.params.cssMode && w2(), e3.params.mousewheel.enabled && v2();
        }), s3("destroy", () => {
          e3.params.cssMode && v2(), e3.mousewheel.enabled && w2();
        }), Object.assign(e3.mousewheel, { enable: v2, disable: w2 });
      },
      function({ swiper: e3, extendParams: t3, on: s3, emit: a2 }) {
        function i3(t4) {
          let s4;
          return t4 && "string" == typeof t4 && e3.isElement && (s4 = e3.el.querySelector(t4) || e3.hostEl.querySelector(t4), s4) ? s4 : (t4 && ("string" == typeof t4 && (s4 = [...document.querySelectorAll(t4)]), e3.params.uniqueNavElements && "string" == typeof t4 && s4 && s4.length > 1 && 1 === e3.el.querySelectorAll(t4).length ? s4 = e3.el.querySelector(t4) : s4 && 1 === s4.length && (s4 = s4[0])), t4 && !s4 ? t4 : s4);
        }
        function r3(t4, s4) {
          const a3 = e3.params.navigation;
          (t4 = M2(t4)).forEach((t5) => {
            t5 && (t5.classList[s4 ? "add" : "remove"](...a3.disabledClass.split(" ")), "BUTTON" === t5.tagName && (t5.disabled = s4), e3.params.watchOverflow && e3.enabled && t5.classList[e3.isLocked ? "add" : "remove"](a3.lockClass));
          });
        }
        function n3() {
          const { nextEl: t4, prevEl: s4 } = e3.navigation;
          if (e3.params.loop) return r3(s4, false), void r3(t4, false);
          r3(s4, e3.isBeginning && !e3.params.rewind), r3(t4, e3.isEnd && !e3.params.rewind);
        }
        function l3(t4) {
          t4.preventDefault(), (!e3.isBeginning || e3.params.loop || e3.params.rewind) && (e3.slidePrev(), a2("navigationPrev"));
        }
        function o3(t4) {
          t4.preventDefault(), (!e3.isEnd || e3.params.loop || e3.params.rewind) && (e3.slideNext(), a2("navigationNext"));
        }
        function d3() {
          const t4 = e3.params.navigation;
          if (e3.params.navigation = le2(e3, e3.originalParams.navigation, e3.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
          }), !t4.nextEl && !t4.prevEl)
            return;
          let s4 = i3(t4.nextEl), a3 = i3(t4.prevEl);
          Object.assign(e3.navigation, { nextEl: s4, prevEl: a3 }), s4 = M2(s4), a3 = M2(a3);
          const r4 = (s5, a4) => {
            if (s5) {
              if (t4.addIcons && s5.matches(".swiper-button-next,.swiper-button-prev") && !s5.querySelector("svg")) {
                const e4 = document.createElement("div");
                P(e4, oe2), s5.appendChild(e4.querySelector("svg")), e4.remove();
              }
              s5.addEventListener("click", "next" === a4 ? o3 : l3);
            }
            !e3.enabled && s5 && s5.classList.add(...t4.lockClass.split(" "));
          };
          s4.forEach((e4) => r4(e4, "next")), a3.forEach((e4) => r4(e4, "prev"));
        }
        function c2() {
          let { nextEl: t4, prevEl: s4 } = e3.navigation;
          t4 = M2(t4), s4 = M2(s4);
          const a3 = (t5, s5) => {
            t5.removeEventListener("click", "next" === s5 ? o3 : l3), t5.classList.remove(...e3.params.navigation.disabledClass.split(" "));
          };
          t4.forEach((e4) => a3(e4, "next")), s4.forEach((e4) => a3(e4, "prev"));
        }
        t3({
          navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
          }
        }), e3.navigation = { nextEl: null, prevEl: null, arrowSvg: oe2 }, s3("init", () => {
          false === e3.params.navigation.enabled ? p2() : (d3(), n3());
        }), s3("toEdge fromEdge lock unlock", () => {
          n3();
        }), s3("destroy", () => {
          c2();
        }), s3("enable disable", () => {
          let { nextEl: t4, prevEl: s4 } = e3.navigation;
          t4 = M2(t4), s4 = M2(s4), e3.enabled ? n3() : [...t4, ...s4].filter((e4) => !!e4).forEach((t5) => t5.classList.add(e3.params.navigation.lockClass));
        }), s3("click", (t4, s4) => {
          let { nextEl: i4, prevEl: r4 } = e3.navigation;
          i4 = M2(i4), r4 = M2(r4);
          const n4 = s4.target;
          let l4 = r4.includes(n4) || i4.includes(n4);
          if (e3.isElement && !l4) {
            const e4 = s4.path || s4.composedPath && s4.composedPath();
            e4 && (l4 = e4.find((e5) => i4.includes(e5) || r4.includes(e5)));
          }
          if (e3.params.navigation.hideOnClick && !l4) {
            if (e3.pagination && e3.params.pagination && e3.params.pagination.clickable && (e3.pagination.el === n4 || e3.pagination.el.contains(n4)))
              return;
            let t5;
            i4.length ? t5 = i4[0].classList.contains(e3.params.navigation.hiddenClass) : r4.length && (t5 = r4[0].classList.contains(e3.params.navigation.hiddenClass)), a2(true === t5 ? "navigationShow" : "navigationHide"), [...i4, ...r4].filter((e4) => !!e4).forEach((t6) => t6.classList.toggle(e3.params.navigation.hiddenClass));
          }
        });
        const p2 = () => {
          e3.el.classList.add(...e3.params.navigation.navigationDisabledClass.split(" ")), c2();
        };
        Object.assign(e3.navigation, {
          enable: () => {
            e3.el.classList.remove(...e3.params.navigation.navigationDisabledClass.split(" ")), d3(), n3();
          },
          disable: p2,
          update: n3,
          init: d3,
          destroy: c2
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3, emit: a2 }) {
        const i3 = "swiper-pagination";
        let r3;
        t3({
          pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (e4) => e4,
            formatFractionTotal: (e4) => e4,
            bulletClass: `${i3}-bullet`,
            bulletActiveClass: `${i3}-bullet-active`,
            modifierClass: `${i3}-`,
            currentClass: `${i3}-current`,
            totalClass: `${i3}-total`,
            hiddenClass: `${i3}-hidden`,
            progressbarFillClass: `${i3}-progressbar-fill`,
            progressbarOppositeClass: `${i3}-progressbar-opposite`,
            clickableClass: `${i3}-clickable`,
            lockClass: `${i3}-lock`,
            horizontalClass: `${i3}-horizontal`,
            verticalClass: `${i3}-vertical`,
            paginationDisabledClass: `${i3}-disabled`
          }
        }), e3.pagination = { el: null, bullets: [] };
        let n3 = 0;
        function l3() {
          return !e3.params.pagination.el || !e3.pagination.el || Array.isArray(e3.pagination.el) && 0 === e3.pagination.el.length;
        }
        function o3(t4, s4) {
          const { bulletActiveClass: a3 } = e3.params.pagination;
          t4 && (t4 = t4[("prev" === s4 ? "previous" : "next") + "ElementSibling"]) && (t4.classList.add(`${a3}-${s4}`), (t4 = t4[("prev" === s4 ? "previous" : "next") + "ElementSibling"]) && t4.classList.add(`${a3}-${s4}-${s4}`));
        }
        function d3(t4) {
          const s4 = t4.target.closest(de2(e3.params.pagination.bulletClass));
          if (!s4) return;
          t4.preventDefault();
          const a3 = E(s4) * e3.params.slidesPerGroup;
          if (e3.params.loop) {
            if (e3.realIndex === a3) return;
            const t5 = (i4 = e3.realIndex, r4 = a3, n4 = e3.slides.length, (r4 %= n4) === 1 + (i4 %= n4) ? "next" : r4 === i4 - 1 ? "previous" : void 0);
            "next" === t5 ? e3.slideNext() : "previous" === t5 ? e3.slidePrev() : e3.slideToLoop(a3);
          } else e3.slideTo(a3);
          var i4, r4, n4;
        }
        function c2() {
          const t4 = e3.rtl, s4 = e3.params.pagination;
          if (l3()) return;
          let i4, d4, c3 = e3.pagination.el;
          c3 = M2(c3);
          const p3 = e3.virtual && e3.params.virtual.enabled ? e3.virtual.slides.length : e3.slides.length, u3 = e3.params.loop ? Math.ceil(p3 / e3.params.slidesPerGroup) : e3.snapGrid.length;
          if (e3.params.loop ? (d4 = e3.previousRealIndex || 0, i4 = e3.params.slidesPerGroup > 1 ? Math.floor(e3.realIndex / e3.params.slidesPerGroup) : e3.realIndex) : void 0 !== e3.snapIndex ? (i4 = e3.snapIndex, d4 = e3.previousSnapIndex) : (d4 = e3.previousIndex || 0, i4 = e3.activeIndex || 0), "bullets" === s4.type && e3.pagination.bullets && e3.pagination.bullets.length > 0) {
            const a3 = e3.pagination.bullets;
            let l4, p4, u4;
            if (s4.dynamicBullets && (r3 = T2(a3[0], e3.isHorizontal() ? "width" : "height", true), c3.forEach((t5) => {
              t5.style[e3.isHorizontal() ? "width" : "height"] = r3 * (s4.dynamicMainBullets + 4) + "px";
            }), s4.dynamicMainBullets > 1 && void 0 !== d4 && (n3 += i4 - (d4 || 0), n3 > s4.dynamicMainBullets - 1 ? n3 = s4.dynamicMainBullets - 1 : n3 < 0 && (n3 = 0)), l4 = Math.max(i4 - n3, 0), p4 = l4 + (Math.min(a3.length, s4.dynamicMainBullets) - 1), u4 = (p4 + l4) / 2), a3.forEach((e4) => {
              const t5 = [
                ...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((e5) => `${s4.bulletActiveClass}${e5}`)
              ].map((e5) => "string" == typeof e5 && e5.includes(" ") ? e5.split(" ") : e5).flat();
              e4.classList.remove(...t5);
            }), c3.length > 1)
              a3.forEach((t5) => {
                const a4 = E(t5);
                a4 === i4 ? t5.classList.add(...s4.bulletActiveClass.split(" ")) : e3.isElement && t5.setAttribute("part", "bullet"), s4.dynamicBullets && (a4 >= l4 && a4 <= p4 && t5.classList.add(...`${s4.bulletActiveClass}-main`.split(" ")), a4 === l4 && o3(t5, "prev"), a4 === p4 && o3(t5, "next"));
              });
            else {
              const t5 = a3[i4];
              if (t5 && t5.classList.add(...s4.bulletActiveClass.split(" ")), e3.isElement && a3.forEach((e4, t6) => {
                e4.setAttribute("part", t6 === i4 ? "bullet-active" : "bullet");
              }), s4.dynamicBullets) {
                const e4 = a3[l4], t6 = a3[p4];
                for (let e5 = l4; e5 <= p4; e5 += 1) a3[e5] && a3[e5].classList.add(...`${s4.bulletActiveClass}-main`.split(" "));
                o3(e4, "prev"), o3(t6, "next");
              }
            }
            if (s4.dynamicBullets) {
              const i5 = Math.min(a3.length, s4.dynamicMainBullets + 4), n4 = (r3 * i5 - r3) / 2 - u4 * r3, l5 = t4 ? "right" : "left";
              a3.forEach((t5) => {
                t5.style[e3.isHorizontal() ? l5 : "top"] = `${n4}px`;
              });
            }
          }
          c3.forEach((t5, r4) => {
            if ("fraction" === s4.type && (t5.querySelectorAll(de2(s4.currentClass)).forEach((e4) => {
              e4.textContent = s4.formatFractionCurrent(i4 + 1);
            }), t5.querySelectorAll(de2(s4.totalClass)).forEach((e4) => {
              e4.textContent = s4.formatFractionTotal(u3);
            })), "progressbar" === s4.type) {
              let a3;
              a3 = s4.progressbarOpposite ? e3.isHorizontal() ? "vertical" : "horizontal" : e3.isHorizontal() ? "horizontal" : "vertical";
              const r5 = (i4 + 1) / u3;
              let n4 = 1, l4 = 1;
              "horizontal" === a3 ? n4 = r5 : l4 = r5, t5.querySelectorAll(de2(s4.progressbarFillClass)).forEach((t6) => {
                t6.style.transform = `translate3d(0,0,0) scaleX(${n4}) scaleY(${l4})`, t6.style.transitionDuration = `${e3.params.speed}ms`;
              });
            }
            "custom" === s4.type && s4.renderCustom ? (P(t5, s4.renderCustom(e3, i4 + 1, u3)), 0 === r4 && a2("paginationRender", t5)) : (0 === r4 && a2("paginationRender", t5), a2("paginationUpdate", t5)), e3.params.watchOverflow && e3.enabled && t5.classList[e3.isLocked ? "add" : "remove"](s4.lockClass);
          });
        }
        function p2() {
          const t4 = e3.params.pagination;
          if (l3()) return;
          const s4 = e3.virtual && e3.params.virtual.enabled ? e3.virtual.slides.length : e3.grid && e3.params.grid.rows > 1 ? e3.slides.length / Math.ceil(e3.params.grid.rows) : e3.slides.length;
          let i4 = e3.pagination.el;
          i4 = M2(i4);
          let r4 = "";
          if ("bullets" === t4.type) {
            let a3 = e3.params.loop ? Math.ceil(s4 / e3.params.slidesPerGroup) : e3.snapGrid.length;
            e3.params.freeMode && e3.params.freeMode.enabled && a3 > s4 && (a3 = s4);
            for (let s5 = 0; s5 < a3; s5 += 1)
              t4.renderBullet ? r4 += t4.renderBullet.call(e3, s5, t4.bulletClass) : r4 += `<${t4.bulletElement} ${e3.isElement ? 'part="bullet"' : ""} class="${t4.bulletClass}"></${t4.bulletElement}>`;
          }
          "fraction" === t4.type && (r4 = t4.renderFraction ? t4.renderFraction.call(e3, t4.currentClass, t4.totalClass) : `<span class="${t4.currentClass}"></span> / <span class="${t4.totalClass}"></span>`), "progressbar" === t4.type && (r4 = t4.renderProgressbar ? t4.renderProgressbar.call(e3, t4.progressbarFillClass) : `<span class="${t4.progressbarFillClass}"></span>`), e3.pagination.bullets = [], i4.forEach((s5) => {
            "custom" !== t4.type && P(s5, r4 || ""), "bullets" === t4.type && e3.pagination.bullets.push(...s5.querySelectorAll(de2(t4.bulletClass)));
          }), "custom" !== t4.type && a2("paginationRender", i4[0]);
        }
        function u2() {
          e3.params.pagination = le2(e3, e3.originalParams.pagination, e3.params.pagination, { el: "swiper-pagination" });
          const t4 = e3.params.pagination;
          if (!t4.el) return;
          let s4;
          "string" == typeof t4.el && e3.isElement && (s4 = e3.el.querySelector(t4.el)), s4 || "string" != typeof t4.el || (s4 = [...document.querySelectorAll(t4.el)]), s4 || (s4 = t4.el), s4 && 0 !== s4.length && (e3.params.uniqueNavElements && "string" == typeof t4.el && Array.isArray(s4) && s4.length > 1 && (s4 = [...e3.el.querySelectorAll(t4.el)], s4.length > 1 && (s4 = s4.find((t5) => x(t5, ".swiper")[0] === e3.el))), Array.isArray(s4) && 1 === s4.length && (s4 = s4[0]), Object.assign(e3.pagination, { el: s4 }), s4 = M2(s4), s4.forEach((s5) => {
            "bullets" === t4.type && t4.clickable && s5.classList.add(...(t4.clickableClass || "").split(" ")), s5.classList.add(t4.modifierClass + t4.type), s5.classList.add(e3.isHorizontal() ? t4.horizontalClass : t4.verticalClass), "bullets" === t4.type && t4.dynamicBullets && (s5.classList.add(`${t4.modifierClass}${t4.type}-dynamic`), n3 = 0, t4.dynamicMainBullets < 1 && (t4.dynamicMainBullets = 1)), "progressbar" === t4.type && t4.progressbarOpposite && s5.classList.add(t4.progressbarOppositeClass), t4.clickable && s5.addEventListener("click", d3), e3.enabled || s5.classList.add(t4.lockClass);
          }));
        }
        function m2() {
          const t4 = e3.params.pagination;
          if (l3()) return;
          let s4 = e3.pagination.el;
          s4 && (s4 = M2(s4), s4.forEach((s5) => {
            s5.classList.remove(t4.hiddenClass), s5.classList.remove(t4.modifierClass + t4.type), s5.classList.remove(e3.isHorizontal() ? t4.horizontalClass : t4.verticalClass), t4.clickable && (s5.classList.remove(...(t4.clickableClass || "").split(" ")), s5.removeEventListener("click", d3));
          })), e3.pagination.bullets && e3.pagination.bullets.forEach((e4) => e4.classList.remove(...t4.bulletActiveClass.split(" ")));
        }
        s3("changeDirection", () => {
          if (!e3.pagination || !e3.pagination.el) return;
          const t4 = e3.params.pagination;
          let { el: s4 } = e3.pagination;
          s4 = M2(s4), s4.forEach((s5) => {
            s5.classList.remove(t4.horizontalClass, t4.verticalClass), s5.classList.add(e3.isHorizontal() ? t4.horizontalClass : t4.verticalClass);
          });
        }), s3("init", () => {
          false === e3.params.pagination.enabled ? h2() : (u2(), p2(), c2());
        }), s3("activeIndexChange", () => {
          void 0 === e3.snapIndex && c2();
        }), s3("snapIndexChange", () => {
          c2();
        }), s3("snapGridLengthChange", () => {
          p2(), c2();
        }), s3("destroy", () => {
          m2();
        }), s3("enable disable", () => {
          let { el: t4 } = e3.pagination;
          t4 && (t4 = M2(t4), t4.forEach((t5) => t5.classList[e3.enabled ? "remove" : "add"](e3.params.pagination.lockClass)));
        }), s3("lock unlock", () => {
          c2();
        }), s3("click", (t4, s4) => {
          const i4 = s4.target, r4 = M2(e3.pagination.el);
          if (e3.params.pagination.el && e3.params.pagination.hideOnClick && r4 && r4.length > 0 && !i4.classList.contains(e3.params.pagination.bulletClass)) {
            if (e3.navigation && (e3.navigation.nextEl && i4 === e3.navigation.nextEl || e3.navigation.prevEl && i4 === e3.navigation.prevEl))
              return;
            const t5 = r4[0].classList.contains(e3.params.pagination.hiddenClass);
            a2(true === t5 ? "paginationShow" : "paginationHide"), r4.forEach((t6) => t6.classList.toggle(e3.params.pagination.hiddenClass));
          }
        });
        const h2 = () => {
          e3.el.classList.add(e3.params.pagination.paginationDisabledClass);
          let { el: t4 } = e3.pagination;
          t4 && (t4 = M2(t4), t4.forEach((t5) => t5.classList.add(e3.params.pagination.paginationDisabledClass))), m2();
        };
        Object.assign(e3.pagination, {
          enable: () => {
            e3.el.classList.remove(e3.params.pagination.paginationDisabledClass);
            let { el: t4 } = e3.pagination;
            t4 && (t4 = M2(t4), t4.forEach((t5) => t5.classList.remove(e3.params.pagination.paginationDisabledClass))), u2(), p2(), c2();
          },
          disable: h2,
          render: p2,
          update: c2,
          init: u2,
          destroy: m2
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3, emit: i3 }) {
        const r3 = a();
        let o3, d3, c2, p2, u2 = false, m2 = null, h2 = null;
        function f2() {
          if (!e3.params.scrollbar.el || !e3.scrollbar.el) return;
          const { scrollbar: t4, rtlTranslate: s4 } = e3, { dragEl: a2, el: i4 } = t4, r4 = e3.params.scrollbar, n3 = e3.params.loop ? e3.progressLoop : e3.progress;
          let l3 = d3, o4 = (c2 - d3) * n3;
          s4 ? (o4 = -o4, o4 > 0 ? (l3 = d3 - o4, o4 = 0) : -o4 + d3 > c2 && (l3 = c2 + o4)) : o4 < 0 ? (l3 = d3 + o4, o4 = 0) : o4 + d3 > c2 && (l3 = c2 - o4), e3.isHorizontal() ? (a2.style.transform = `translate3d(${o4}px, 0, 0)`, a2.style.width = `${l3}px`) : (a2.style.transform = `translate3d(0px, ${o4}px, 0)`, a2.style.height = `${l3}px`), r4.hide && (clearTimeout(m2), i4.style.opacity = 1, m2 = setTimeout(() => {
            i4.style.opacity = 0, i4.style.transitionDuration = "400ms";
          }, 1e3));
        }
        function g2() {
          if (!e3.params.scrollbar.el || !e3.scrollbar.el) return;
          const { scrollbar: t4 } = e3, { dragEl: s4, el: a2 } = t4;
          s4.style.width = "", s4.style.height = "", c2 = e3.isHorizontal() ? a2.offsetWidth : a2.offsetHeight, p2 = e3.size / (e3.virtualSize + e3.params.slidesOffsetBefore - (e3.params.centeredSlides ? e3.snapGrid[0] : 0)), d3 = "auto" === e3.params.scrollbar.dragSize ? c2 * p2 : parseInt(e3.params.scrollbar.dragSize, 10), e3.isHorizontal() ? s4.style.width = `${d3}px` : s4.style.height = `${d3}px`, a2.style.display = p2 >= 1 ? "none" : "", e3.params.scrollbar.hide && (a2.style.opacity = 0), e3.params.watchOverflow && e3.enabled && t4.el.classList[e3.isLocked ? "add" : "remove"](e3.params.scrollbar.lockClass);
        }
        function v2(t4) {
          return e3.isHorizontal() ? t4.clientX : t4.clientY;
        }
        function y2(t4) {
          const { scrollbar: s4, rtlTranslate: a2 } = e3, { el: i4 } = s4;
          let r4;
          r4 = (v2(t4) - b(i4)[e3.isHorizontal() ? "left" : "top"] - (null !== o3 ? o3 : d3 / 2)) / (c2 - d3), r4 = Math.max(Math.min(r4, 1), 0), a2 && (r4 = 1 - r4);
          const n3 = e3.minTranslate() + (e3.maxTranslate() - e3.minTranslate()) * r4;
          e3.updateProgress(n3), e3.setTranslate(n3), e3.updateActiveIndex(), e3.updateSlidesClasses();
        }
        function E2(t4) {
          const s4 = e3.params.scrollbar, { scrollbar: a2, wrapperEl: r4 } = e3, { el: n3, dragEl: l3 } = a2;
          u2 = true, o3 = t4.target === l3 ? v2(t4) - t4.target.getBoundingClientRect()[e3.isHorizontal() ? "left" : "top"] : null, t4.preventDefault(), t4.stopPropagation(), r4.style.transitionDuration = "100ms", l3.style.transitionDuration = "100ms", y2(t4), clearTimeout(h2), n3.style.transitionDuration = "0ms", s4.hide && (n3.style.opacity = 1), e3.params.cssMode && (e3.wrapperEl.style["scroll-snap-type"] = "none"), i3("scrollbarDragStart", t4);
        }
        function x2(t4) {
          const { scrollbar: s4, wrapperEl: a2 } = e3, { el: r4, dragEl: n3 } = s4;
          u2 && (t4.preventDefault && t4.cancelable ? t4.preventDefault() : t4.returnValue = false, y2(t4), a2.style.transitionDuration = "0ms", r4.style.transitionDuration = "0ms", n3.style.transitionDuration = "0ms", i3("scrollbarDragMove", t4));
        }
        function S2(t4) {
          const s4 = e3.params.scrollbar, { scrollbar: a2, wrapperEl: r4 } = e3, { el: n3 } = a2;
          u2 && (u2 = false, e3.params.cssMode && (e3.wrapperEl.style["scroll-snap-type"] = "", r4.style.transitionDuration = ""), s4.hide && (clearTimeout(h2), h2 = l2(() => {
            n3.style.opacity = 0, n3.style.transitionDuration = "400ms";
          }, 1e3)), i3("scrollbarDragEnd", t4), s4.snapOnRelease && e3.slideToClosest());
        }
        function T3(t4) {
          const { scrollbar: s4, params: a2 } = e3, i4 = s4.el;
          if (!i4) return;
          const n3 = i4, l3 = !!a2.passiveListeners && { passive: false, capture: false }, o4 = !!a2.passiveListeners && { passive: true, capture: false };
          if (!n3) return;
          const d4 = "on" === t4 ? "addEventListener" : "removeEventListener";
          n3[d4]("pointerdown", E2, l3), r3[d4]("pointermove", x2, l3), r3[d4]("pointerup", S2, o4);
        }
        function C3() {
          const { scrollbar: t4, el: s4 } = e3;
          e3.params.scrollbar = le2(e3, e3.originalParams.scrollbar, e3.params.scrollbar, { el: "swiper-scrollbar" });
          const a2 = e3.params.scrollbar;
          if (!a2.el) return;
          let i4, l3;
          if ("string" == typeof a2.el && e3.isElement && (i4 = e3.el.querySelector(a2.el)), i4 || "string" != typeof a2.el)
            i4 || (i4 = a2.el);
          else if (i4 = r3.querySelectorAll(a2.el), !i4.length) return;
          e3.params.uniqueNavElements && "string" == typeof a2.el && i4.length > 1 && 1 === s4.querySelectorAll(a2.el).length && (i4 = s4.querySelector(a2.el)), i4.length > 0 && (i4 = i4[0]), i4.classList.add(e3.isHorizontal() ? a2.horizontalClass : a2.verticalClass), i4 && (l3 = i4.querySelector(de2(e3.params.scrollbar.dragClass)), l3 || (l3 = w("div", e3.params.scrollbar.dragClass), i4.append(l3))), Object.assign(t4, { el: i4, dragEl: l3 }), a2.draggable && e3.params.scrollbar.el && e3.scrollbar.el && T3("on"), i4 && i4.classList[e3.enabled ? "remove" : "add"](...n2(e3.params.scrollbar.lockClass));
        }
        function P2() {
          const t4 = e3.params.scrollbar, s4 = e3.scrollbar.el;
          s4 && s4.classList.remove(...n2(e3.isHorizontal() ? t4.horizontalClass : t4.verticalClass)), e3.params.scrollbar.el && e3.scrollbar.el && T3("off");
        }
        t3({
          scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical"
          }
        }), e3.scrollbar = { el: null, dragEl: null }, s3("changeDirection", () => {
          if (!e3.scrollbar || !e3.scrollbar.el) return;
          const t4 = e3.params.scrollbar;
          let { el: s4 } = e3.scrollbar;
          s4 = M2(s4), s4.forEach((s5) => {
            s5.classList.remove(t4.horizontalClass, t4.verticalClass), s5.classList.add(e3.isHorizontal() ? t4.horizontalClass : t4.verticalClass);
          });
        }), s3("init", () => {
          false === e3.params.scrollbar.enabled ? L3() : (C3(), g2(), f2());
        }), s3("update resize observerUpdate lock unlock changeDirection", () => {
          g2();
        }), s3("setTranslate", () => {
          f2();
        }), s3("setTransition", (t4, s4) => {
          !(function(t5) {
            e3.params.scrollbar.el && e3.scrollbar.el && (e3.scrollbar.dragEl.style.transitionDuration = `${t5}ms`);
          })(s4);
        }), s3("enable disable", () => {
          const { el: t4 } = e3.scrollbar;
          t4 && t4.classList[e3.enabled ? "remove" : "add"](...n2(e3.params.scrollbar.lockClass));
        }), s3("destroy", () => {
          P2();
        });
        const L3 = () => {
          e3.el.classList.add(...n2(e3.params.scrollbar.scrollbarDisabledClass)), e3.scrollbar.el && e3.scrollbar.el.classList.add(...n2(e3.params.scrollbar.scrollbarDisabledClass)), P2();
        };
        Object.assign(e3.scrollbar, {
          enable: () => {
            e3.el.classList.remove(...n2(e3.params.scrollbar.scrollbarDisabledClass)), e3.scrollbar.el && e3.scrollbar.el.classList.remove(...n2(e3.params.scrollbar.scrollbarDisabledClass)), C3(), g2(), f2();
          },
          disable: L3,
          updateSize: g2,
          setTranslate: f2,
          init: C3,
          destroy: P2
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        t3({ parallax: { enabled: false } });
        const a2 = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", i3 = (t4, s4) => {
          const { rtl: a3 } = e3, i4 = a3 ? -1 : 1, r4 = t4.getAttribute("data-swiper-parallax") || "0";
          let n3 = t4.getAttribute("data-swiper-parallax-x"), l3 = t4.getAttribute("data-swiper-parallax-y");
          const o3 = t4.getAttribute("data-swiper-parallax-scale"), d3 = t4.getAttribute("data-swiper-parallax-opacity"), c2 = t4.getAttribute("data-swiper-parallax-rotate");
          if (n3 || l3 ? (n3 = n3 || "0", l3 = l3 || "0") : e3.isHorizontal() ? (n3 = r4, l3 = "0") : (l3 = r4, n3 = "0"), n3 = n3.indexOf("%") >= 0 ? parseInt(n3, 10) * s4 * i4 + "%" : n3 * s4 * i4 + "px", l3 = l3.indexOf("%") >= 0 ? parseInt(l3, 10) * s4 + "%" : l3 * s4 + "px", null != d3) {
            const e4 = d3 - (d3 - 1) * (1 - Math.abs(s4));
            t4.style.opacity = e4;
          }
          let p2 = `translate3d(${n3}, ${l3}, 0px)`;
          if (null != o3) {
            p2 += ` scale(${o3 - (o3 - 1) * (1 - Math.abs(s4))})`;
          }
          if (c2 && null != c2) {
            p2 += ` rotate(${c2 * s4 * -1}deg)`;
          }
          t4.style.transform = p2;
        }, r3 = () => {
          const { el: t4, slides: s4, progress: r4, snapGrid: n3, isElement: l3 } = e3, o3 = g(t4, a2);
          e3.isElement && o3.push(...g(e3.hostEl, a2)), o3.forEach((e4) => {
            i3(e4, r4);
          }), s4.forEach((t5, s5) => {
            let l4 = t5.progress;
            e3.params.slidesPerGroup > 1 && "auto" !== e3.params.slidesPerView && (l4 += Math.ceil(s5 / 2) - r4 * (n3.length - 1)), l4 = Math.min(Math.max(l4, -1), 1), t5.querySelectorAll(`${a2}, [data-swiper-parallax-rotate]`).forEach((e4) => {
              i3(e4, l4);
            });
          });
        };
        s3("beforeInit", () => {
          e3.params.parallax.enabled && (e3.params.watchSlidesProgress = true, e3.originalParams.watchSlidesProgress = true);
        }), s3("init", () => {
          e3.params.parallax.enabled && r3();
        }), s3("setTranslate", () => {
          e3.params.parallax.enabled && r3();
        }), s3("setTransition", (t4, s4) => {
          e3.params.parallax.enabled && ((t5 = e3.params.speed) => {
            const { el: s5, hostEl: i4 } = e3, r4 = [...s5.querySelectorAll(a2)];
            e3.isElement && r4.push(...i4.querySelectorAll(a2)), r4.forEach((e4) => {
              let s6 = parseInt(e4.getAttribute("data-swiper-parallax-duration"), 10) || t5;
              0 === t5 && (s6 = 0), e4.style.transitionDuration = `${s6}ms`;
            });
          })(s4);
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3, emit: a2 }) {
        const i3 = r2();
        t3({
          zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
          }
        }), e3.zoom = { enabled: false };
        let n3, l3, o3 = 1, c2 = false, p2 = false, u2 = { x: 0, y: 0 };
        const m2 = [], h2 = {
          originX: 0,
          originY: 0,
          slideEl: void 0,
          slideWidth: void 0,
          slideHeight: void 0,
          imageEl: void 0,
          imageWrapEl: void 0,
          maxRatio: 3
        }, f2 = {
          isTouched: void 0,
          isMoved: void 0,
          currentX: void 0,
          currentY: void 0,
          minX: void 0,
          minY: void 0,
          maxX: void 0,
          maxY: void 0,
          width: void 0,
          height: void 0,
          startX: void 0,
          startY: void 0,
          touchesStart: {},
          touchesCurrent: {}
        }, v2 = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
        let w2, y2 = 1;
        function E2() {
          if (m2.length < 2) return 1;
          const e4 = m2[0].pageX, t4 = m2[0].pageY, s4 = m2[1].pageX, a3 = m2[1].pageY;
          return Math.sqrt((s4 - e4) ** 2 + (a3 - t4) ** 2);
        }
        function S2() {
          const t4 = e3.params.zoom, s4 = h2.imageWrapEl.getAttribute("data-swiper-zoom") || t4.maxRatio;
          if (t4.limitToOriginalSize && h2.imageEl && h2.imageEl.naturalWidth) {
            const e4 = h2.imageEl.naturalWidth / h2.imageEl.offsetWidth;
            return Math.min(e4, s4);
          }
          return s4;
        }
        function T3(t4) {
          const s4 = e3.isElement ? "swiper-slide" : `.${e3.params.slideClass}`;
          return !!t4.target.matches(s4) || e3.slides.filter((e4) => e4.contains(t4.target)).length > 0;
        }
        function M3(t4) {
          const s4 = `.${e3.params.zoom.containerClass}`;
          return !!t4.target.matches(s4) || [...e3.hostEl.querySelectorAll(s4)].filter((e4) => e4.contains(t4.target)).length > 0;
        }
        function C3(t4) {
          if ("mouse" === t4.pointerType && m2.splice(0, m2.length), !T3(t4)) return;
          const s4 = e3.params.zoom;
          if (n3 = false, l3 = false, m2.push(t4), !(m2.length < 2)) {
            if (n3 = true, h2.scaleStart = E2(), !h2.slideEl) {
              h2.slideEl = t4.target.closest(`.${e3.params.slideClass}, swiper-slide`), h2.slideEl || (h2.slideEl = e3.slides[e3.activeIndex]);
              let a3 = h2.slideEl.querySelector(`.${s4.containerClass}`);
              if (a3 && (a3 = a3.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), h2.imageEl = a3, h2.imageWrapEl = a3 ? x(h2.imageEl, `.${s4.containerClass}`)[0] : void 0, !h2.imageWrapEl)
                return void (h2.imageEl = void 0);
              h2.maxRatio = S2();
            }
            if (h2.imageEl) {
              const [e4, t5] = (function() {
                if (m2.length < 2) return { x: null, y: null };
                const e5 = h2.imageEl.getBoundingClientRect();
                return [
                  (m2[0].pageX + (m2[1].pageX - m2[0].pageX) / 2 - e5.x - i3.scrollX) / o3,
                  (m2[0].pageY + (m2[1].pageY - m2[0].pageY) / 2 - e5.y - i3.scrollY) / o3
                ];
              })();
              h2.originX = e4, h2.originY = t5, h2.imageEl.style.transitionDuration = "0ms";
            }
            c2 = true;
          }
        }
        function P2(t4) {
          if (!T3(t4)) return;
          const s4 = e3.params.zoom, a3 = e3.zoom, i4 = m2.findIndex((e4) => e4.pointerId === t4.pointerId);
          i4 >= 0 && (m2[i4] = t4), m2.length < 2 || (l3 = true, h2.scaleMove = E2(), h2.imageEl && (a3.scale = h2.scaleMove / h2.scaleStart * o3, a3.scale > h2.maxRatio && (a3.scale = h2.maxRatio - 1 + (a3.scale - h2.maxRatio + 1) ** 0.5), a3.scale < s4.minRatio && (a3.scale = s4.minRatio + 1 - (s4.minRatio - a3.scale + 1) ** 0.5), h2.imageEl.style.transform = `translate3d(0,0,0) scale(${a3.scale})`));
        }
        function L3(t4) {
          if (!T3(t4)) return;
          if ("mouse" === t4.pointerType && "pointerout" === t4.type) return;
          const s4 = e3.params.zoom, a3 = e3.zoom, i4 = m2.findIndex((e4) => e4.pointerId === t4.pointerId);
          i4 >= 0 && m2.splice(i4, 1), n3 && l3 && (n3 = false, l3 = false, h2.imageEl && (a3.scale = Math.max(Math.min(a3.scale, h2.maxRatio), s4.minRatio), h2.imageEl.style.transitionDuration = `${e3.params.speed}ms`, h2.imageEl.style.transform = `translate3d(0,0,0) scale(${a3.scale})`, o3 = a3.scale, c2 = false, a3.scale > 1 && h2.slideEl ? h2.slideEl.classList.add(`${s4.zoomedSlideClass}`) : a3.scale <= 1 && h2.slideEl && h2.slideEl.classList.remove(`${s4.zoomedSlideClass}`), 1 === a3.scale && (h2.originX = 0, h2.originY = 0, h2.slideEl = void 0)));
        }
        function z3() {
          e3.touchEventsData.preventTouchMoveFromPointerMove = false;
        }
        function I3(t4) {
          const s4 = "mouse" === t4.pointerType && e3.params.zoom.panOnMouseMove;
          if (!T3(t4) || !M3(t4)) return;
          const a3 = e3.zoom;
          if (!h2.imageEl) return;
          if (!f2.isTouched || !h2.slideEl) return void (s4 && $2(t4));
          if (s4) return void $2(t4);
          f2.isMoved || (f2.width = h2.imageEl.offsetWidth || h2.imageEl.clientWidth, f2.height = h2.imageEl.offsetHeight || h2.imageEl.clientHeight, f2.startX = d2(h2.imageWrapEl, "x") || 0, f2.startY = d2(h2.imageWrapEl, "y") || 0, h2.slideWidth = h2.slideEl.offsetWidth, h2.slideHeight = h2.slideEl.offsetHeight, h2.imageWrapEl.style.transitionDuration = "0ms");
          const i4 = f2.width * a3.scale, r3 = f2.height * a3.scale;
          f2.minX = Math.min(h2.slideWidth / 2 - i4 / 2, 0), f2.maxX = -f2.minX, f2.minY = Math.min(h2.slideHeight / 2 - r3 / 2, 0), f2.maxY = -f2.minY, f2.touchesCurrent.x = m2.length > 0 ? m2[0].pageX : t4.pageX, f2.touchesCurrent.y = m2.length > 0 ? m2[0].pageY : t4.pageY;
          if (Math.max(Math.abs(f2.touchesCurrent.x - f2.touchesStart.x), Math.abs(f2.touchesCurrent.y - f2.touchesStart.y)) > 5 && (e3.allowClick = false), !f2.isMoved && !c2) {
            if (e3.isHorizontal() && (Math.floor(f2.minX) === Math.floor(f2.startX) && f2.touchesCurrent.x < f2.touchesStart.x || Math.floor(f2.maxX) === Math.floor(f2.startX) && f2.touchesCurrent.x > f2.touchesStart.x))
              return f2.isTouched = false, void z3();
            if (!e3.isHorizontal() && (Math.floor(f2.minY) === Math.floor(f2.startY) && f2.touchesCurrent.y < f2.touchesStart.y || Math.floor(f2.maxY) === Math.floor(f2.startY) && f2.touchesCurrent.y > f2.touchesStart.y))
              return f2.isTouched = false, void z3();
          }
          t4.cancelable && t4.preventDefault(), t4.stopPropagation(), clearTimeout(w2), e3.touchEventsData.preventTouchMoveFromPointerMove = true, w2 = setTimeout(() => {
            e3.destroyed || z3();
          }), f2.isMoved = true;
          const n4 = (a3.scale - o3) / (h2.maxRatio - e3.params.zoom.minRatio), { originX: l4, originY: p3 } = h2;
          f2.currentX = f2.touchesCurrent.x - f2.touchesStart.x + f2.startX + n4 * (f2.width - 2 * l4), f2.currentY = f2.touchesCurrent.y - f2.touchesStart.y + f2.startY + n4 * (f2.height - 2 * p3), f2.currentX < f2.minX && (f2.currentX = f2.minX + 1 - (f2.minX - f2.currentX + 1) ** 0.8), f2.currentX > f2.maxX && (f2.currentX = f2.maxX - 1 + (f2.currentX - f2.maxX + 1) ** 0.8), f2.currentY < f2.minY && (f2.currentY = f2.minY + 1 - (f2.minY - f2.currentY + 1) ** 0.8), f2.currentY > f2.maxY && (f2.currentY = f2.maxY - 1 + (f2.currentY - f2.maxY + 1) ** 0.8), v2.prevPositionX || (v2.prevPositionX = f2.touchesCurrent.x), v2.prevPositionY || (v2.prevPositionY = f2.touchesCurrent.y), v2.prevTime || (v2.prevTime = Date.now()), v2.x = (f2.touchesCurrent.x - v2.prevPositionX) / (Date.now() - v2.prevTime) / 2, v2.y = (f2.touchesCurrent.y - v2.prevPositionY) / (Date.now() - v2.prevTime) / 2, Math.abs(f2.touchesCurrent.x - v2.prevPositionX) < 2 && (v2.x = 0), Math.abs(f2.touchesCurrent.y - v2.prevPositionY) < 2 && (v2.y = 0), v2.prevPositionX = f2.touchesCurrent.x, v2.prevPositionY = f2.touchesCurrent.y, v2.prevTime = Date.now(), h2.imageWrapEl.style.transform = `translate3d(${f2.currentX}px, ${f2.currentY}px,0)`;
        }
        function A3() {
          const t4 = e3.zoom;
          h2.slideEl && e3.activeIndex !== e3.slides.indexOf(h2.slideEl) && (h2.imageEl && (h2.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), h2.imageWrapEl && (h2.imageWrapEl.style.transform = "translate3d(0,0,0)"), h2.slideEl.classList.remove(`${e3.params.zoom.zoomedSlideClass}`), t4.scale = 1, o3 = 1, h2.slideEl = void 0, h2.imageEl = void 0, h2.imageWrapEl = void 0, h2.originX = 0, h2.originY = 0);
        }
        function $2(e4) {
          if (o3 <= 1 || !h2.imageWrapEl) return;
          if (!T3(e4) || !M3(e4)) return;
          const t4 = i3.getComputedStyle(h2.imageWrapEl).transform, s4 = new i3.DOMMatrix(t4);
          if (!p2)
            return p2 = true, u2.x = e4.clientX, u2.y = e4.clientY, f2.startX = s4.e, f2.startY = s4.f, f2.width = h2.imageEl.offsetWidth || h2.imageEl.clientWidth, f2.height = h2.imageEl.offsetHeight || h2.imageEl.clientHeight, h2.slideWidth = h2.slideEl.offsetWidth, void (h2.slideHeight = h2.slideEl.offsetHeight);
          const a3 = -3 * (e4.clientX - u2.x), r3 = -3 * (e4.clientY - u2.y), n4 = f2.width * o3, l4 = f2.height * o3, d3 = h2.slideWidth, c3 = h2.slideHeight, m3 = Math.min(d3 / 2 - n4 / 2, 0), g2 = -m3, v3 = Math.min(c3 / 2 - l4 / 2, 0), w3 = -v3, b2 = Math.max(Math.min(f2.startX + a3, g2), m3), y3 = Math.max(Math.min(f2.startY + r3, w3), v3);
          h2.imageWrapEl.style.transitionDuration = "0ms", h2.imageWrapEl.style.transform = `translate3d(${b2}px, ${y3}px, 0)`, u2.x = e4.clientX, u2.y = e4.clientY, f2.startX = b2, f2.startY = y3, f2.currentX = b2, f2.currentY = y3;
        }
        function k3(t4) {
          const s4 = e3.zoom, a3 = e3.params.zoom;
          if (!h2.slideEl) {
            t4 && t4.target && (h2.slideEl = t4.target.closest(`.${e3.params.slideClass}, swiper-slide`)), h2.slideEl || (e3.params.virtual && e3.params.virtual.enabled && e3.virtual ? h2.slideEl = g(e3.slidesEl, `.${e3.params.slideActiveClass}`)[0] : h2.slideEl = e3.slides[e3.activeIndex]);
            let s5 = h2.slideEl.querySelector(`.${a3.containerClass}`);
            s5 && (s5 = s5.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), h2.imageEl = s5, h2.imageWrapEl = s5 ? x(h2.imageEl, `.${a3.containerClass}`)[0] : void 0;
          }
          if (!h2.imageEl || !h2.imageWrapEl) return;
          let r3, n4, l4, d3, c3, p3, u3, m3, v3, w3, y3, E3, T4, M4, C4, P3, L4, z4;
          h2.maxRatio = S2(), e3.params.cssMode && (e3.wrapperEl.style.overflow = "hidden", e3.wrapperEl.style.touchAction = "none"), h2.slideEl.classList.add(`${a3.zoomedSlideClass}`), void 0 === f2.touchesStart.x && t4 ? (r3 = t4.pageX, n4 = t4.pageY) : (r3 = f2.touchesStart.x, n4 = f2.touchesStart.y);
          const I4 = o3, A4 = "number" == typeof t4 ? t4 : null;
          1 === o3 && A4 && (r3 = void 0, n4 = void 0, f2.touchesStart.x = void 0, f2.touchesStart.y = void 0);
          const $3 = S2();
          s4.scale = A4 || $3, o3 = A4 || $3, !t4 || 1 === o3 && A4 ? (u3 = 0, m3 = 0) : (L4 = h2.slideEl.offsetWidth, z4 = h2.slideEl.offsetHeight, l4 = b(h2.slideEl).left + i3.scrollX, d3 = b(h2.slideEl).top + i3.scrollY, c3 = l4 + L4 / 2 - r3, p3 = d3 + z4 / 2 - n4, v3 = h2.imageEl.offsetWidth || h2.imageEl.clientWidth, w3 = h2.imageEl.offsetHeight || h2.imageEl.clientHeight, y3 = v3 * s4.scale, E3 = w3 * s4.scale, T4 = Math.min(L4 / 2 - y3 / 2, 0), M4 = Math.min(z4 / 2 - E3 / 2, 0), C4 = -T4, P3 = -M4, I4 > 0 && A4 && "number" == typeof f2.currentX && "number" == typeof f2.currentY ? (u3 = f2.currentX * s4.scale / I4, m3 = f2.currentY * s4.scale / I4) : (u3 = c3 * s4.scale, m3 = p3 * s4.scale), u3 < T4 && (u3 = T4), u3 > C4 && (u3 = C4), m3 < M4 && (m3 = M4), m3 > P3 && (m3 = P3)), A4 && 1 === s4.scale && (h2.originX = 0, h2.originY = 0), f2.currentX = u3, f2.currentY = m3, h2.imageWrapEl.style.transitionDuration = "300ms", h2.imageWrapEl.style.transform = `translate3d(${u3}px, ${m3}px,0)`, h2.imageEl.style.transitionDuration = "300ms", h2.imageEl.style.transform = `translate3d(0,0,0) scale(${s4.scale})`;
        }
        function O3() {
          const t4 = e3.zoom, s4 = e3.params.zoom;
          if (!h2.slideEl) {
            e3.params.virtual && e3.params.virtual.enabled && e3.virtual ? h2.slideEl = g(e3.slidesEl, `.${e3.params.slideActiveClass}`)[0] : h2.slideEl = e3.slides[e3.activeIndex];
            let t5 = h2.slideEl.querySelector(`.${s4.containerClass}`);
            t5 && (t5 = t5.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), h2.imageEl = t5, h2.imageWrapEl = t5 ? x(h2.imageEl, `.${s4.containerClass}`)[0] : void 0;
          }
          h2.imageEl && h2.imageWrapEl && (h2.maxRatio = S2(), e3.params.cssMode && (e3.wrapperEl.style.overflow = "", e3.wrapperEl.style.touchAction = ""), t4.scale = 1, o3 = 1, f2.currentX = void 0, f2.currentY = void 0, f2.touchesStart.x = void 0, f2.touchesStart.y = void 0, h2.imageWrapEl.style.transitionDuration = "300ms", h2.imageWrapEl.style.transform = "translate3d(0,0,0)", h2.imageEl.style.transitionDuration = "300ms", h2.imageEl.style.transform = "translate3d(0,0,0) scale(1)", h2.slideEl.classList.remove(`${s4.zoomedSlideClass}`), h2.slideEl = void 0, h2.originX = 0, h2.originY = 0, e3.params.zoom.panOnMouseMove && (u2 = { x: 0, y: 0 }, p2 && (p2 = false, f2.startX = 0, f2.startY = 0)));
        }
        function D2(t4) {
          const s4 = e3.zoom;
          s4.scale && 1 !== s4.scale ? O3() : k3(t4);
        }
        function G3() {
          return {
            passiveListener: !!e3.params.passiveListeners && { passive: true, capture: false },
            activeListenerWithCapture: !e3.params.passiveListeners || { passive: false, capture: true }
          };
        }
        function X4() {
          const t4 = e3.zoom;
          if (t4.enabled) return;
          t4.enabled = true;
          const { passiveListener: s4, activeListenerWithCapture: a3 } = G3();
          e3.wrapperEl.addEventListener("pointerdown", C3, s4), e3.wrapperEl.addEventListener("pointermove", P2, a3), ["pointerup", "pointercancel", "pointerout"].forEach((t5) => {
            e3.wrapperEl.addEventListener(t5, L3, s4);
          }), e3.wrapperEl.addEventListener("pointermove", I3, a3);
        }
        function B3() {
          const t4 = e3.zoom;
          if (!t4.enabled) return;
          t4.enabled = false;
          const { passiveListener: s4, activeListenerWithCapture: a3 } = G3();
          e3.wrapperEl.removeEventListener("pointerdown", C3, s4), e3.wrapperEl.removeEventListener("pointermove", P2, a3), ["pointerup", "pointercancel", "pointerout"].forEach((t5) => {
            e3.wrapperEl.removeEventListener(t5, L3, s4);
          }), e3.wrapperEl.removeEventListener("pointermove", I3, a3);
        }
        Object.defineProperty(e3.zoom, "scale", {
          get: () => y2,
          set(e4) {
            if (y2 !== e4) {
              const t4 = h2.imageEl, s4 = h2.slideEl;
              a2("zoomChange", e4, t4, s4);
            }
            y2 = e4;
          }
        }), s3("init", () => {
          e3.params.zoom.enabled && X4();
        }), s3("destroy", () => {
          B3();
        }), s3("touchStart", (t4, s4) => {
          e3.zoom.enabled && (function(t5) {
            const s5 = e3.device;
            if (!h2.imageEl) return;
            if (f2.isTouched) return;
            s5.android && t5.cancelable && t5.preventDefault(), f2.isTouched = true;
            const a3 = m2.length > 0 ? m2[0] : t5;
            f2.touchesStart.x = a3.pageX, f2.touchesStart.y = a3.pageY;
          })(s4);
        }), s3("touchEnd", (t4, s4) => {
          e3.zoom.enabled && (function() {
            const t5 = e3.zoom;
            if (m2.length = 0, !h2.imageEl) return;
            if (!f2.isTouched || !f2.isMoved) return f2.isTouched = false, void (f2.isMoved = false);
            f2.isTouched = false, f2.isMoved = false;
            let s5 = 300, a3 = 300;
            const i4 = v2.x * s5, r3 = f2.currentX + i4, n4 = v2.y * a3, l4 = f2.currentY + n4;
            0 !== v2.x && (s5 = Math.abs((r3 - f2.currentX) / v2.x)), 0 !== v2.y && (a3 = Math.abs((l4 - f2.currentY) / v2.y));
            const o4 = Math.max(s5, a3);
            f2.currentX = r3, f2.currentY = l4;
            const d3 = f2.width * t5.scale, c3 = f2.height * t5.scale;
            f2.minX = Math.min(h2.slideWidth / 2 - d3 / 2, 0), f2.maxX = -f2.minX, f2.minY = Math.min(h2.slideHeight / 2 - c3 / 2, 0), f2.maxY = -f2.minY, f2.currentX = Math.max(Math.min(f2.currentX, f2.maxX), f2.minX), f2.currentY = Math.max(Math.min(f2.currentY, f2.maxY), f2.minY), h2.imageWrapEl.style.transitionDuration = `${o4}ms`, h2.imageWrapEl.style.transform = `translate3d(${f2.currentX}px, ${f2.currentY}px,0)`;
          })();
        }), s3("doubleTap", (t4, s4) => {
          !e3.animating && e3.params.zoom.enabled && e3.zoom.enabled && e3.params.zoom.toggle && D2(s4);
        }), s3("transitionEnd", () => {
          e3.zoom.enabled && e3.params.zoom.enabled && A3();
        }), s3("slideChange", () => {
          e3.zoom.enabled && e3.params.zoom.enabled && e3.params.cssMode && A3();
        }), Object.assign(e3.zoom, { enable: X4, disable: B3, in: k3, out: O3, toggle: D2 });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        function a2(e4, t4) {
          const s4 = /* @__PURE__ */ (function() {
            let e5, t5, s5;
            return (a4, i5) => {
              for (t5 = -1, e5 = a4.length; e5 - t5 > 1; ) s5 = e5 + t5 >> 1, a4[s5] <= i5 ? t5 = s5 : e5 = s5;
              return e5;
            };
          })();
          let a3, i4;
          return this.x = e4, this.y = t4, this.lastIndex = e4.length - 1, this.interpolate = function(e5) {
            return e5 ? (i4 = s4(this.x, e5), a3 = i4 - 1, (e5 - this.x[a3]) * (this.y[i4] - this.y[a3]) / (this.x[i4] - this.x[a3]) + this.y[a3]) : 0;
          }, this;
        }
        function i3() {
          e3.controller.control && e3.controller.spline && (e3.controller.spline = void 0, delete e3.controller.spline);
        }
        t3({ controller: { control: void 0, inverse: false, by: "slide" } }), e3.controller = { control: void 0 }, s3("beforeInit", () => {
          if ("undefined" != typeof window && ("string" == typeof e3.params.controller.control || e3.params.controller.control instanceof HTMLElement)) {
            return void ("string" == typeof e3.params.controller.control ? [...document.querySelectorAll(e3.params.controller.control)] : [e3.params.controller.control]).forEach((t4) => {
              if (e3.controller.control || (e3.controller.control = []), t4 && t4.swiper)
                e3.controller.control.push(t4.swiper);
              else if (t4) {
                const s4 = `${e3.params.eventsPrefix}init`, a3 = (i4) => {
                  e3.controller.control.push(i4.detail[0]), e3.update(), t4.removeEventListener(s4, a3);
                };
                t4.addEventListener(s4, a3);
              }
            });
          }
          e3.controller.control = e3.params.controller.control;
        }), s3("update", () => {
          i3();
        }), s3("resize", () => {
          i3();
        }), s3("observerUpdate", () => {
          i3();
        }), s3("setTranslate", (t4, s4, a3) => {
          e3.controller.control && !e3.controller.control.destroyed && e3.controller.setTranslate(s4, a3);
        }), s3("setTransition", (t4, s4, a3) => {
          e3.controller.control && !e3.controller.control.destroyed && e3.controller.setTransition(s4, a3);
        }), Object.assign(e3.controller, {
          setTranslate: function(t4, s4) {
            const i4 = e3.controller.control;
            let r3, n3;
            const l3 = e3.constructor;
            function o3(t5) {
              if (t5.destroyed) return;
              const s5 = e3.rtlTranslate ? -e3.translate : e3.translate;
              "slide" === e3.params.controller.by && (!(function(t6) {
                e3.controller.spline = e3.params.loop ? new a2(e3.slidesGrid, t6.slidesGrid) : new a2(e3.snapGrid, t6.snapGrid);
              })(t5), n3 = -e3.controller.spline.interpolate(-s5)), n3 && "container" !== e3.params.controller.by || (r3 = (t5.maxTranslate() - t5.minTranslate()) / (e3.maxTranslate() - e3.minTranslate()), !Number.isNaN(r3) && Number.isFinite(r3) || (r3 = 1), n3 = (s5 - e3.minTranslate()) * r3 + t5.minTranslate()), e3.params.controller.inverse && (n3 = t5.maxTranslate() - n3), t5.updateProgress(n3), t5.setTranslate(n3, e3), t5.updateActiveIndex(), t5.updateSlidesClasses();
            }
            if (Array.isArray(i4)) for (let e4 = 0; e4 < i4.length; e4 += 1) i4[e4] !== s4 && i4[e4] instanceof l3 && o3(i4[e4]);
            else i4 instanceof l3 && s4 !== i4 && o3(i4);
          },
          setTransition: function(t4, s4) {
            const a3 = e3.constructor, i4 = e3.controller.control;
            let r3;
            function n3(s5) {
              s5.destroyed || (s5.setTransition(t4, e3), 0 !== t4 && (s5.transitionStart(), s5.params.autoHeight && l2(() => {
                s5.updateAutoHeight();
              }), S(s5.wrapperEl, () => {
                i4 && s5.transitionEnd();
              })));
            }
            if (Array.isArray(i4)) for (r3 = 0; r3 < i4.length; r3 += 1) i4[r3] !== s4 && i4[r3] instanceof a3 && n3(i4[r3]);
            else i4 instanceof a3 && s4 !== i4 && n3(i4);
          }
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        t3({
          a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
          }
        }), e3.a11y = { clicked: false };
        let i3, r3, n3 = null, l3 = (/* @__PURE__ */ new Date()).getTime();
        function o3(e4) {
          const t4 = n3;
          0 !== t4.length && P(t4, e4);
        }
        function d3(e4) {
          (e4 = M2(e4)).forEach((e5) => {
            e5.setAttribute("tabIndex", "0");
          });
        }
        function c2(e4) {
          (e4 = M2(e4)).forEach((e5) => {
            e5.setAttribute("tabIndex", "-1");
          });
        }
        function p2(e4, t4) {
          (e4 = M2(e4)).forEach((e5) => {
            e5.setAttribute("role", t4);
          });
        }
        function u2(e4, t4) {
          (e4 = M2(e4)).forEach((e5) => {
            e5.setAttribute("aria-roledescription", t4);
          });
        }
        function m2(e4, t4) {
          (e4 = M2(e4)).forEach((e5) => {
            e5.setAttribute("aria-label", t4);
          });
        }
        function h2(e4) {
          (e4 = M2(e4)).forEach((e5) => {
            e5.setAttribute("aria-disabled", true);
          });
        }
        function f2(e4) {
          (e4 = M2(e4)).forEach((e5) => {
            e5.setAttribute("aria-disabled", false);
          });
        }
        function g2(t4) {
          if (13 !== t4.keyCode && 32 !== t4.keyCode) return;
          const s4 = e3.params.a11y, a2 = t4.target;
          if (!e3.pagination || !e3.pagination.el || a2 !== e3.pagination.el && !e3.pagination.el.contains(t4.target) || t4.target.matches(de2(e3.params.pagination.bulletClass))) {
            if (e3.navigation && e3.navigation.prevEl && e3.navigation.nextEl) {
              const t5 = M2(e3.navigation.prevEl);
              M2(e3.navigation.nextEl).includes(a2) && (e3.isEnd && !e3.params.loop || e3.slideNext(), e3.isEnd ? o3(s4.lastSlideMessage) : o3(s4.nextSlideMessage)), t5.includes(a2) && (e3.isBeginning && !e3.params.loop || e3.slidePrev(), e3.isBeginning ? o3(s4.firstSlideMessage) : o3(s4.prevSlideMessage));
            }
            e3.pagination && a2.matches(de2(e3.params.pagination.bulletClass)) && a2.click();
          }
        }
        function v2() {
          return e3.pagination && e3.pagination.bullets && e3.pagination.bullets.length;
        }
        function b2() {
          return v2() && e3.params.pagination.clickable;
        }
        const y2 = (e4, t4, s4) => {
          d3(e4), "BUTTON" !== e4.tagName && (p2(e4, "button"), e4.addEventListener("keydown", g2)), m2(e4, s4), (function(e5, t5) {
            (e5 = M2(e5)).forEach((e6) => {
              e6.setAttribute("aria-controls", t5);
            });
          })(e4, t4);
        }, x2 = (t4) => {
          r3 && r3 !== t4.target && !r3.contains(t4.target) && (i3 = true), e3.a11y.clicked = true;
        }, S2 = () => {
          i3 = false, requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              e3.destroyed || (e3.a11y.clicked = false);
            });
          });
        }, T3 = (e4) => {
          l3 = (/* @__PURE__ */ new Date()).getTime();
        }, C3 = (t4) => {
          if (e3.a11y.clicked || !e3.params.a11y.scrollOnFocus) return;
          if ((/* @__PURE__ */ new Date()).getTime() - l3 < 100) return;
          const s4 = t4.target.closest(`.${e3.params.slideClass}, swiper-slide`);
          if (!s4 || !e3.slides.includes(s4)) return;
          r3 = s4;
          const a2 = e3.slides.indexOf(s4) === e3.activeIndex, n4 = e3.params.watchSlidesProgress && e3.visibleSlides && e3.visibleSlides.includes(s4);
          a2 || n4 || t4.sourceCapabilities && t4.sourceCapabilities.firesTouchEvents || (e3.isHorizontal() ? e3.el.scrollLeft = 0 : e3.el.scrollTop = 0, requestAnimationFrame(() => {
            i3 || (e3.params.loop ? e3.slideToLoop(e3.getSlideIndexWhenGrid(parseInt(s4.getAttribute("data-swiper-slide-index"))), 0) : e3.slideTo(e3.getSlideIndexWhenGrid(e3.slides.indexOf(s4)), 0), i3 = false);
          }));
        }, L3 = () => {
          const t4 = e3.params.a11y;
          t4.itemRoleDescriptionMessage && u2(e3.slides, t4.itemRoleDescriptionMessage), t4.slideRole && p2(e3.slides, t4.slideRole);
          const s4 = e3.slides.length;
          t4.slideLabelMessage && e3.slides.forEach((a2, i4) => {
            const r4 = e3.params.loop ? parseInt(a2.getAttribute("data-swiper-slide-index"), 10) : i4;
            m2(a2, t4.slideLabelMessage.replace(/\{\{index\}\}/, r4 + 1).replace(/\{\{slidesLength\}\}/, s4));
          });
        }, z3 = () => {
          const t4 = e3.params.a11y;
          e3.el.append(n3);
          const s4 = e3.el;
          t4.containerRoleDescriptionMessage && u2(s4, t4.containerRoleDescriptionMessage), t4.containerMessage && m2(s4, t4.containerMessage), t4.containerRole && p2(s4, t4.containerRole);
          const i4 = e3.wrapperEl, r4 = t4.id || i4.getAttribute("id") || `swiper-wrapper-${(function(e4 = 16) {
            return "x".repeat(e4).replace(/x/g, () => Math.round(16 * Math.random()).toString(16));
          })(16)}`;
          var l4;
          if (l4 = r4, M2(i4).forEach((e4) => {
            e4.setAttribute("id", l4);
          }), t4.wrapperLiveRegion) {
            !(function(e4, t5) {
              (e4 = M2(e4)).forEach((e5) => {
                e5.setAttribute("aria-live", t5);
              });
            })(i4, e3.params.autoplay && e3.params.autoplay.enabled ? "off" : "polite");
          }
          L3();
          let { nextEl: o4, prevEl: d4 } = e3.navigation ? e3.navigation : {};
          if (o4 = M2(o4), d4 = M2(d4), o4 && o4.forEach((e4) => y2(e4, r4, t4.nextSlideMessage)), d4 && d4.forEach((e4) => y2(e4, r4, t4.prevSlideMessage)), b2()) {
            M2(e3.pagination.el).forEach((e4) => {
              e4.addEventListener("keydown", g2);
            });
          }
          a().addEventListener("visibilitychange", T3), e3.el.addEventListener("focus", C3, true), e3.el.addEventListener("pointerdown", x2, true), e3.el.addEventListener("pointerup", S2, true);
        };
        s3("beforeInit", () => {
          n3 = w("span", e3.params.a11y.notificationClass), n3.setAttribute("aria-live", "assertive"), n3.setAttribute("aria-atomic", "true");
        }), s3("afterInit", () => {
          e3.params.a11y.enabled && z3();
        }), s3("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
          e3.params.a11y.enabled && L3();
        }), s3("fromEdge toEdge afterInit lock unlock", () => {
          e3.params.a11y.enabled && (function() {
            if (e3.params.loop || e3.params.rewind || !e3.navigation) return;
            const { nextEl: t4, prevEl: s4 } = e3.navigation;
            s4 && (e3.isBeginning ? (h2(s4), c2(s4)) : (f2(s4), d3(s4))), t4 && (e3.isEnd ? (h2(t4), c2(t4)) : (f2(t4), d3(t4)));
          })();
        }), s3("paginationUpdate", () => {
          e3.params.a11y.enabled && (function() {
            const t4 = e3.params.a11y;
            v2() && e3.pagination.bullets.forEach((s4) => {
              e3.params.pagination.clickable && (d3(s4), e3.params.pagination.renderBullet || (p2(s4, "button"), m2(s4, t4.paginationBulletMessage.replace(/\{\{index\}\}/, E(s4) + 1)))), s4.matches(de2(e3.params.pagination.bulletActiveClass)) ? s4.setAttribute("aria-current", "true") : s4.removeAttribute("aria-current");
            });
          })();
        }), s3("destroy", () => {
          e3.params.a11y.enabled && (function() {
            n3 && n3.remove();
            let { nextEl: t4, prevEl: s4 } = e3.navigation ? e3.navigation : {};
            t4 = M2(t4), s4 = M2(s4), t4 && t4.forEach((e4) => e4.removeEventListener("keydown", g2)), s4 && s4.forEach((e4) => e4.removeEventListener("keydown", g2)), b2() && M2(e3.pagination.el).forEach((e4) => {
              e4.removeEventListener("keydown", g2);
            });
            a().removeEventListener("visibilitychange", T3), e3.el && "string" != typeof e3.el && (e3.el.removeEventListener("focus", C3, true), e3.el.removeEventListener("pointerdown", x2, true), e3.el.removeEventListener("pointerup", S2, true));
          })();
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        t3({ history: { enabled: false, root: "", replaceState: false, key: "slides", keepQuery: false } });
        let a2 = false, i3 = {};
        const n3 = (e4) => e4.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), l3 = (e4) => {
          const t4 = r2();
          let s4;
          s4 = e4 ? new URL(e4) : t4.location;
          const a3 = s4.pathname.slice(1).split("/").filter((e5) => "" !== e5), i4 = a3.length;
          return { key: a3[i4 - 2], value: a3[i4 - 1] };
        }, o3 = (t4, s4) => {
          const i4 = r2();
          if (!a2 || !e3.params.history.enabled) return;
          let l4;
          l4 = e3.params.url ? new URL(e3.params.url) : i4.location;
          const o4 = e3.virtual && e3.params.virtual.enabled ? e3.slidesEl.querySelector(`[data-swiper-slide-index="${s4}"]`) : e3.slides[s4];
          let d4 = n3(o4.getAttribute("data-history"));
          if (e3.params.history.root.length > 0) {
            let s5 = e3.params.history.root;
            "/" === s5[s5.length - 1] && (s5 = s5.slice(0, s5.length - 1)), d4 = `${s5}/${t4 ? `${t4}/` : ""}${d4}`;
          } else l4.pathname.includes(t4) || (d4 = `${t4 ? `${t4}/` : ""}${d4}`);
          e3.params.history.keepQuery && (d4 += l4.search);
          const c3 = i4.history.state;
          c3 && c3.value === d4 || (e3.params.history.replaceState ? i4.history.replaceState({ value: d4 }, null, d4) : i4.history.pushState({ value: d4 }, null, d4));
        }, d3 = (t4, s4, a3) => {
          if (s4)
            for (let i4 = 0, r3 = e3.slides.length; i4 < r3; i4 += 1) {
              const r4 = e3.slides[i4];
              if (n3(r4.getAttribute("data-history")) === s4) {
                const s5 = e3.getSlideIndex(r4);
                e3.slideTo(s5, t4, a3);
              }
            }
          else e3.slideTo(0, t4, a3);
        }, c2 = () => {
          i3 = l3(e3.params.url), d3(e3.params.speed, i3.value, false);
        };
        s3("init", () => {
          e3.params.history.enabled && (() => {
            const t4 = r2();
            if (e3.params.history) {
              if (!t4.history || !t4.history.pushState)
                return e3.params.history.enabled = false, void (e3.params.hashNavigation.enabled = true);
              a2 = true, i3 = l3(e3.params.url), i3.key || i3.value ? (d3(0, i3.value, e3.params.runCallbacksOnInit), e3.params.history.replaceState || t4.addEventListener("popstate", c2)) : e3.params.history.replaceState || t4.addEventListener("popstate", c2);
            }
          })();
        }), s3("destroy", () => {
          e3.params.history.enabled && (() => {
            const t4 = r2();
            e3.params.history.replaceState || t4.removeEventListener("popstate", c2);
          })();
        }), s3("transitionEnd _freeModeNoMomentumRelease", () => {
          a2 && o3(e3.params.history.key, e3.activeIndex);
        }), s3("slideChange", () => {
          a2 && e3.params.cssMode && o3(e3.params.history.key, e3.activeIndex);
        });
      },
      function({ swiper: e3, extendParams: t3, emit: s3, on: i3 }) {
        let n3 = false;
        const l3 = a(), o3 = r2();
        t3({
          hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex(t4, s4) {
              if (e3.virtual && e3.params.virtual.enabled) {
                const t5 = e3.slides.find((e4) => e4.getAttribute("data-hash") === s4);
                if (!t5) return 0;
                return parseInt(t5.getAttribute("data-swiper-slide-index"), 10);
              }
              return e3.getSlideIndex(
                g(e3.slidesEl, `.${e3.params.slideClass}[data-hash="${s4}"], swiper-slide[data-hash="${s4}"]`)[0]
              );
            }
          }
        });
        const d3 = () => {
          s3("hashChange");
          const t4 = l3.location.hash.replace("#", ""), a2 = e3.virtual && e3.params.virtual.enabled ? e3.slidesEl.querySelector(`[data-swiper-slide-index="${e3.activeIndex}"]`) : e3.slides[e3.activeIndex];
          if (t4 !== (a2 ? a2.getAttribute("data-hash") : "")) {
            const s4 = e3.params.hashNavigation.getSlideIndex(e3, t4);
            if (void 0 === s4 || Number.isNaN(s4)) return;
            e3.slideTo(s4);
          }
        }, c2 = () => {
          if (!n3 || !e3.params.hashNavigation.enabled) return;
          const t4 = e3.virtual && e3.params.virtual.enabled ? e3.slidesEl.querySelector(`[data-swiper-slide-index="${e3.activeIndex}"]`) : e3.slides[e3.activeIndex], a2 = t4 ? t4.getAttribute("data-hash") || t4.getAttribute("data-history") : "";
          e3.params.hashNavigation.replaceState && o3.history && o3.history.replaceState ? (o3.history.replaceState(null, null, `#${a2}` || ""), s3("hashSet")) : (l3.location.hash = a2 || "", s3("hashSet"));
        };
        i3("init", () => {
          e3.params.hashNavigation.enabled && (() => {
            if (!e3.params.hashNavigation.enabled || e3.params.history && e3.params.history.enabled) return;
            n3 = true;
            const t4 = l3.location.hash.replace("#", "");
            if (t4) {
              const s4 = 0, a2 = e3.params.hashNavigation.getSlideIndex(e3, t4);
              e3.slideTo(a2 || 0, s4, e3.params.runCallbacksOnInit, true);
            }
            e3.params.hashNavigation.watchState && o3.addEventListener("hashchange", d3);
          })();
        }), i3("destroy", () => {
          e3.params.hashNavigation.enabled && e3.params.hashNavigation.watchState && o3.removeEventListener("hashchange", d3);
        }), i3("transitionEnd _freeModeNoMomentumRelease", () => {
          n3 && c2();
        }), i3("slideChange", () => {
          n3 && e3.params.cssMode && c2();
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3, emit: i3, params: r3 }) {
        let n3, l3;
        e3.autoplay = { running: false, paused: false, timeLeft: 0 }, t3({
          autoplay: {
            enabled: false,
            delay: 3e3,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
          }
        });
        let o3, d3, c2, p2, u2, m2, h2, f2 = r3 && r3.autoplay ? r3.autoplay.delay : 3e3, g2 = r3 && r3.autoplay ? r3.autoplay.delay : 3e3, v2 = (/* @__PURE__ */ new Date()).getTime();
        function w2(t4) {
          e3 && !e3.destroyed && e3.wrapperEl && t4.target === e3.wrapperEl && (e3.wrapperEl.removeEventListener("transitionend", w2), h2 || t4.detail && t4.detail.bySwiperTouchMove || M3());
        }
        const b2 = () => {
          if (e3.destroyed || !e3.autoplay.running) return;
          e3.autoplay.paused ? d3 = true : d3 && (g2 = o3, d3 = false);
          const t4 = e3.autoplay.paused ? o3 : v2 + g2 - (/* @__PURE__ */ new Date()).getTime();
          e3.autoplay.timeLeft = t4, i3("autoplayTimeLeft", t4, t4 / f2), l3 = requestAnimationFrame(() => {
            b2();
          });
        }, y2 = () => {
          let t4 = e3.params.autoplay.delay;
          const s4 = (() => {
            let t5;
            if (t5 = e3.virtual && e3.params.virtual.enabled ? e3.slides.find((e4) => e4.classList.contains("swiper-slide-active")) : e3.slides[e3.activeIndex], !t5)
              return;
            return parseInt(t5.getAttribute("data-swiper-autoplay"), 10);
          })();
          return !Number.isNaN(s4) && s4 > 0 && (t4 = s4), t4;
        }, E2 = (t4) => {
          if (e3.destroyed || !e3.autoplay.running) return;
          cancelAnimationFrame(l3), b2();
          let s4 = t4;
          void 0 === s4 && (s4 = y2(), f2 = s4, g2 = s4), o3 = s4;
          const a2 = e3.params.speed, r4 = () => {
            e3 && !e3.destroyed && (e3.params.autoplay.reverseDirection ? !e3.isBeginning || e3.params.loop || e3.params.rewind ? (e3.slidePrev(a2, true, true), i3("autoplay")) : e3.params.autoplay.stopOnLastSlide || (e3.slideTo(e3.slides.length - 1, a2, true, true), i3("autoplay")) : !e3.isEnd || e3.params.loop || e3.params.rewind ? (e3.slideNext(a2, true, true), i3("autoplay")) : e3.params.autoplay.stopOnLastSlide || (e3.slideTo(0, a2, true, true), i3("autoplay")), e3.params.cssMode && (v2 = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
              E2();
            })));
          };
          return s4 > 0 ? (clearTimeout(n3), n3 = setTimeout(() => {
            r4();
          }, s4)) : requestAnimationFrame(() => {
            r4();
          }), s4;
        }, x2 = () => {
          v2 = (/* @__PURE__ */ new Date()).getTime(), e3.autoplay.running = true, E2(), i3("autoplayStart");
        }, S2 = () => {
          e3.autoplay.running = false, clearTimeout(n3), cancelAnimationFrame(l3), i3("autoplayStop");
        }, T3 = (t4, s4) => {
          if (e3.destroyed || !e3.autoplay.running) return;
          clearTimeout(n3), t4 || (m2 = true);
          const a2 = () => {
            i3("autoplayPause"), e3.params.autoplay.waitForTransition ? e3.wrapperEl.addEventListener("transitionend", w2) : M3();
          };
          if (e3.autoplay.paused = true, s4) return void a2();
          const r4 = o3 || e3.params.autoplay.delay;
          o3 = r4 - ((/* @__PURE__ */ new Date()).getTime() - v2), e3.isEnd && o3 < 0 && !e3.params.loop || (o3 < 0 && (o3 = 0), a2());
        }, M3 = () => {
          e3.isEnd && o3 < 0 && !e3.params.loop || e3.destroyed || !e3.autoplay.running || (v2 = (/* @__PURE__ */ new Date()).getTime(), m2 ? (m2 = false, E2(o3)) : E2(), e3.autoplay.paused = false, i3("autoplayResume"));
        }, C3 = () => {
          if (e3.destroyed || !e3.autoplay.running) return;
          const t4 = a();
          "hidden" === t4.visibilityState && (m2 = true, T3(true)), "visible" === t4.visibilityState && M3();
        }, P2 = (t4) => {
          "mouse" === t4.pointerType && (m2 = true, h2 = true, e3.animating || e3.autoplay.paused || T3(true));
        }, L3 = (t4) => {
          "mouse" === t4.pointerType && (h2 = false, e3.autoplay.paused && M3());
        };
        s3("init", () => {
          e3.params.autoplay.enabled && (e3.params.autoplay.pauseOnMouseEnter && (e3.el.addEventListener("pointerenter", P2), e3.el.addEventListener("pointerleave", L3)), a().addEventListener("visibilitychange", C3), x2());
        }), s3("destroy", () => {
          e3.el && "string" != typeof e3.el && (e3.el.removeEventListener("pointerenter", P2), e3.el.removeEventListener("pointerleave", L3)), a().removeEventListener("visibilitychange", C3), e3.autoplay.running && S2();
        }), s3("_freeModeStaticRelease", () => {
          (p2 || m2) && M3();
        }), s3("_freeModeNoMomentumRelease", () => {
          e3.params.autoplay.disableOnInteraction ? S2() : T3(true, true);
        }), s3("beforeTransitionStart", (t4, s4, a2) => {
          !e3.destroyed && e3.autoplay.running && (a2 || !e3.params.autoplay.disableOnInteraction ? T3(true, true) : S2());
        }), s3("sliderFirstMove", () => {
          !e3.destroyed && e3.autoplay.running && (e3.params.autoplay.disableOnInteraction ? S2() : (c2 = true, p2 = false, m2 = false, u2 = setTimeout(() => {
            m2 = true, p2 = true, T3(true);
          }, 200)));
        }), s3("touchEnd", () => {
          if (!e3.destroyed && e3.autoplay.running && c2) {
            if (clearTimeout(u2), clearTimeout(n3), e3.params.autoplay.disableOnInteraction)
              return p2 = false, void (c2 = false);
            p2 && e3.params.cssMode && M3(), p2 = false, c2 = false;
          }
        }), s3("slideChange", () => {
          !e3.destroyed && e3.autoplay.running && e3.autoplay.paused && (o3 = y2(), f2 = y2());
        }), Object.assign(e3.autoplay, { start: x2, stop: S2, pause: T3, resume: M3 });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        t3({
          thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
          }
        });
        let i3 = false, r3 = false;
        function n3() {
          const t4 = e3.thumbs.swiper;
          return !(!t4 || t4.destroyed) && t4.params.virtual && t4.params.virtual.enabled;
        }
        function l3() {
          const t4 = e3.thumbs.swiper;
          if (!t4 || t4.destroyed) return;
          const s4 = t4.clickedIndex, a2 = t4.clickedSlide;
          if (a2 && a2.classList.contains(e3.params.thumbs.slideThumbActiveClass)) return;
          if (null == s4) return;
          let i4;
          i4 = t4.params.loop ? parseInt(t4.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : s4, e3.params.loop ? e3.slideToLoop(i4) : e3.slideTo(i4);
        }
        function o3() {
          const { thumbs: t4 } = e3.params;
          if (i3) return false;
          i3 = true;
          const s4 = e3.constructor;
          if (t4.swiper instanceof s4) {
            if (t4.swiper.destroyed) return i3 = false, false;
            e3.thumbs.swiper = t4.swiper, Object.assign(e3.thumbs.swiper.originalParams, { watchSlidesProgress: true, slideToClickedSlide: false }), Object.assign(e3.thumbs.swiper.params, { watchSlidesProgress: true, slideToClickedSlide: false }), e3.thumbs.swiper.update();
          } else if (c(t4.swiper)) {
            const a2 = Object.assign({}, t4.swiper);
            Object.assign(a2, { watchSlidesProgress: true, slideToClickedSlide: false }), e3.thumbs.swiper = new s4(a2), r3 = true;
          }
          return e3.thumbs.swiper.el.classList.add(e3.params.thumbs.thumbsContainerClass), e3.thumbs.swiper.on("tap", l3), n3() && e3.thumbs.swiper.on("virtualUpdate", () => {
            d3(false, { autoScroll: false });
          }), true;
        }
        function d3(t4, s4) {
          const a2 = e3.thumbs.swiper;
          if (!a2 || a2.destroyed) return;
          let i4 = 1;
          const r4 = e3.params.thumbs.slideThumbActiveClass;
          if (e3.params.slidesPerView > 1 && !e3.params.centeredSlides && (i4 = e3.params.slidesPerView), e3.params.thumbs.multipleActiveThumbs || (i4 = 1), i4 = Math.floor(i4), a2.slides.forEach((e4) => e4.classList.remove(r4)), a2.params.loop || n3())
            for (let t5 = 0; t5 < i4; t5 += 1)
              g(a2.slidesEl, `[data-swiper-slide-index="${e3.realIndex + t5}"]`).forEach((e4) => {
                e4.classList.add(r4);
              });
          else for (let t5 = 0; t5 < i4; t5 += 1) a2.slides[e3.realIndex + t5] && a2.slides[e3.realIndex + t5].classList.add(r4);
          (s4?.autoScroll ?? 1) && (function(t5) {
            const s5 = e3.thumbs.swiper;
            if (!s5 || s5.destroyed) return;
            const a3 = "auto" === s5.params.slidesPerView ? s5.slidesPerViewDynamic() : s5.params.slidesPerView, i5 = e3.params.thumbs.autoScrollOffset, r5 = i5 && !s5.params.loop;
            if (e3.realIndex !== s5.realIndex || r5) {
              const n4 = s5.activeIndex;
              let l4, o4;
              if (s5.params.loop) {
                const t6 = s5.slides.find((t7) => t7.getAttribute("data-swiper-slide-index") === `${e3.realIndex}`);
                l4 = s5.slides.indexOf(t6), o4 = e3.activeIndex > e3.previousIndex ? "next" : "prev";
              } else l4 = e3.realIndex, o4 = l4 > e3.previousIndex ? "next" : "prev";
              r5 && (l4 += "next" === o4 ? i5 : -1 * i5), s5.visibleSlidesIndexes && s5.visibleSlidesIndexes.indexOf(l4) < 0 && (s5.params.centeredSlides ? l4 = l4 > n4 ? l4 - Math.floor(a3 / 2) + 1 : l4 + Math.floor(a3 / 2) - 1 : l4 > n4 && s5.params.slidesPerGroup, s5.slideTo(l4, t5));
            }
          })(t4 ? 0 : void 0);
        }
        e3.thumbs = { swiper: null }, s3("beforeInit", () => {
          const { thumbs: t4 } = e3.params;
          if (t4 && t4.swiper)
            if ("string" == typeof t4.swiper || t4.swiper instanceof HTMLElement) {
              const s4 = a(), i4 = () => {
                const a2 = "string" == typeof t4.swiper ? s4.querySelector(t4.swiper) : t4.swiper;
                if (a2 && a2.swiper) t4.swiper = a2.swiper, o3(), d3(true);
                else if (a2) {
                  const s5 = `${e3.params.eventsPrefix}init`, i5 = (r5) => {
                    t4.swiper = r5.detail[0], a2.removeEventListener(s5, i5), o3(), d3(true), t4.swiper.update(), e3.update();
                  };
                  a2.addEventListener(s5, i5);
                }
                return a2;
              }, r4 = () => {
                if (e3.destroyed) return;
                i4() || requestAnimationFrame(r4);
              };
              requestAnimationFrame(r4);
            } else o3(), d3(true);
        }), s3("slideChange update resize observerUpdate", () => {
          d3();
        }), s3("setTransition", (t4, s4) => {
          const a2 = e3.thumbs.swiper;
          a2 && !a2.destroyed && a2.setTransition(s4);
        }), s3("beforeDestroy", () => {
          const t4 = e3.thumbs.swiper;
          t4 && !t4.destroyed && r3 && t4.destroy();
        }), Object.assign(e3.thumbs, { init: o3, update: d3 });
      },
      function({ swiper: e3, extendParams: t3, emit: s3, once: a2 }) {
        t3({
          freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
          }
        }), Object.assign(e3, {
          freeMode: {
            onTouchStart: function() {
              if (e3.params.cssMode) return;
              const t4 = e3.getTranslate();
              e3.setTranslate(t4), e3.setTransition(0), e3.touchEventsData.velocities.length = 0, e3.freeMode.onTouchEnd({ currentPos: e3.rtl ? e3.translate : -e3.translate });
            },
            onTouchMove: function() {
              if (e3.params.cssMode) return;
              const { touchEventsData: t4, touches: s4 } = e3;
              0 === t4.velocities.length && t4.velocities.push({ position: s4[e3.isHorizontal() ? "startX" : "startY"], time: t4.touchStartTime }), t4.velocities.push({ position: s4[e3.isHorizontal() ? "currentX" : "currentY"], time: o2() });
            },
            onTouchEnd: function({ currentPos: t4 }) {
              if (e3.params.cssMode) return;
              const { params: i3, wrapperEl: r3, rtlTranslate: n3, snapGrid: l3, touchEventsData: d3 } = e3, c2 = o2() - d3.touchStartTime;
              if (t4 < -e3.minTranslate()) e3.slideTo(e3.activeIndex);
              else if (t4 > -e3.maxTranslate())
                e3.slides.length < l3.length ? e3.slideTo(l3.length - 1) : e3.slideTo(e3.slides.length - 1);
              else {
                if (i3.freeMode.momentum) {
                  if (d3.velocities.length > 1) {
                    const t6 = d3.velocities.pop(), s4 = d3.velocities.pop(), a3 = t6.position - s4.position, r4 = t6.time - s4.time;
                    e3.velocity = a3 / r4, e3.velocity /= 2, Math.abs(e3.velocity) < i3.freeMode.minimumVelocity && (e3.velocity = 0), (r4 > 150 || o2() - t6.time > 300) && (e3.velocity = 0);
                  } else e3.velocity = 0;
                  e3.velocity *= i3.freeMode.momentumVelocityRatio, d3.velocities.length = 0;
                  let t5 = 1e3 * i3.freeMode.momentumRatio;
                  const c3 = e3.velocity * t5;
                  let p2 = e3.translate + c3;
                  n3 && (p2 = -p2);
                  let u2, m2 = false;
                  const h2 = 20 * Math.abs(e3.velocity) * i3.freeMode.momentumBounceRatio;
                  let f2;
                  if (p2 < e3.maxTranslate())
                    i3.freeMode.momentumBounce ? (p2 + e3.maxTranslate() < -h2 && (p2 = e3.maxTranslate() - h2), u2 = e3.maxTranslate(), m2 = true, d3.allowMomentumBounce = true) : p2 = e3.maxTranslate(), i3.loop && i3.centeredSlides && (f2 = true);
                  else if (p2 > e3.minTranslate())
                    i3.freeMode.momentumBounce ? (p2 - e3.minTranslate() > h2 && (p2 = e3.minTranslate() + h2), u2 = e3.minTranslate(), m2 = true, d3.allowMomentumBounce = true) : p2 = e3.minTranslate(), i3.loop && i3.centeredSlides && (f2 = true);
                  else if (i3.freeMode.sticky) {
                    let t6;
                    for (let e4 = 0; e4 < l3.length; e4 += 1)
                      if (l3[e4] > -p2) {
                        t6 = e4;
                        break;
                      }
                    p2 = Math.abs(l3[t6] - p2) < Math.abs(l3[t6 - 1] - p2) || "next" === e3.swipeDirection ? l3[t6] : l3[t6 - 1], p2 = -p2;
                  }
                  if (f2 && a2("transitionEnd", () => {
                    e3.loopFix();
                  }), 0 !== e3.velocity) {
                    if (t5 = n3 ? Math.abs((-p2 - e3.translate) / e3.velocity) : Math.abs((p2 - e3.translate) / e3.velocity), i3.freeMode.sticky) {
                      const s4 = Math.abs((n3 ? -p2 : p2) - e3.translate), a3 = e3.slidesSizesGrid[e3.activeIndex];
                      t5 = s4 < a3 ? i3.speed : s4 < 2 * a3 ? 1.5 * i3.speed : 2.5 * i3.speed;
                    }
                  } else if (i3.freeMode.sticky) return void e3.slideToClosest();
                  i3.freeMode.momentumBounce && m2 ? (e3.updateProgress(u2), e3.setTransition(t5), e3.setTranslate(p2), e3.transitionStart(true, e3.swipeDirection), e3.animating = true, S(r3, () => {
                    e3 && !e3.destroyed && d3.allowMomentumBounce && (s3("momentumBounce"), e3.setTransition(i3.speed), setTimeout(() => {
                      e3.setTranslate(u2), S(r3, () => {
                        e3 && !e3.destroyed && e3.transitionEnd();
                      });
                    }, 0));
                  })) : e3.velocity ? (s3("_freeModeNoMomentumRelease"), e3.updateProgress(p2), e3.setTransition(t5), e3.setTranslate(p2), e3.transitionStart(true, e3.swipeDirection), e3.animating || (e3.animating = true, S(r3, () => {
                    e3 && !e3.destroyed && e3.transitionEnd();
                  }))) : e3.updateProgress(p2), e3.updateActiveIndex(), e3.updateSlidesClasses();
                } else {
                  if (i3.freeMode.sticky) return void e3.slideToClosest();
                  i3.freeMode && s3("_freeModeNoMomentumRelease");
                }
                (!i3.freeMode.momentum || c2 >= i3.longSwipesMs) && (s3("_freeModeStaticRelease"), e3.updateProgress(), e3.updateActiveIndex(), e3.updateSlidesClasses());
              }
            }
          }
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        let a2, i3, r3, n3;
        t3({ grid: { rows: 1, fill: "column" } });
        const l3 = () => {
          let t4 = e3.params.spaceBetween;
          return "string" == typeof t4 && t4.indexOf("%") >= 0 ? t4 = parseFloat(t4.replace("%", "")) / 100 * e3.size : "string" == typeof t4 && (t4 = parseFloat(t4)), t4;
        };
        s3("init", () => {
          n3 = e3.params.grid && e3.params.grid.rows > 1;
        }), s3("update", () => {
          const { params: t4, el: s4 } = e3, a3 = t4.grid && t4.grid.rows > 1;
          n3 && !a3 ? (s4.classList.remove(`${t4.containerModifierClass}grid`, `${t4.containerModifierClass}grid-column`), r3 = 1, e3.emitContainerClasses()) : !n3 && a3 && (s4.classList.add(`${t4.containerModifierClass}grid`), "column" === t4.grid.fill && s4.classList.add(`${t4.containerModifierClass}grid-column`), e3.emitContainerClasses()), n3 = a3;
        }), e3.grid = {
          initSlides: (t4) => {
            const { slidesPerView: s4 } = e3.params, { rows: n4, fill: l4 } = e3.params.grid, o3 = e3.virtual && e3.params.virtual.enabled ? e3.virtual.slides.length : t4.length;
            r3 = Math.floor(o3 / n4), a2 = Math.floor(o3 / n4) === o3 / n4 ? o3 : Math.ceil(o3 / n4) * n4, "auto" !== s4 && "row" === l4 && (a2 = Math.max(a2, s4 * n4)), i3 = a2 / n4;
          },
          unsetSlides: () => {
            e3.slides && e3.slides.forEach((t4) => {
              t4.swiperSlideGridSet && (t4.style.height = "", t4.style[e3.getDirectionLabel("margin-top")] = "");
            });
          },
          updateSlide: (t4, s4, n4) => {
            const { slidesPerGroup: o3 } = e3.params, d3 = l3(), { rows: c2, fill: p2 } = e3.params.grid, u2 = e3.virtual && e3.params.virtual.enabled ? e3.virtual.slides.length : n4.length;
            let m2, h2, f2;
            if ("row" === p2 && o3 > 1) {
              const e4 = Math.floor(t4 / (o3 * c2)), i4 = t4 - c2 * o3 * e4, r4 = 0 === e4 ? o3 : Math.min(Math.ceil((u2 - e4 * c2 * o3) / c2), o3);
              f2 = Math.floor(i4 / r4), h2 = i4 - f2 * r4 + e4 * o3, m2 = h2 + f2 * a2 / c2, s4.style.order = m2;
            } else
              "column" === p2 ? (h2 = Math.floor(t4 / c2), f2 = t4 - h2 * c2, (h2 > r3 || h2 === r3 && f2 === c2 - 1) && (f2 += 1, f2 >= c2 && (f2 = 0, h2 += 1))) : (f2 = Math.floor(t4 / i3), h2 = t4 - f2 * i3);
            s4.row = f2, s4.column = h2, s4.style.height = `calc((100% - ${(c2 - 1) * d3}px) / ${c2})`, s4.style[e3.getDirectionLabel("margin-top")] = 0 !== f2 ? d3 && `${d3}px` : "", s4.swiperSlideGridSet = true;
          },
          updateWrapperSize: (t4, s4) => {
            const { centeredSlides: i4, roundLengths: r4 } = e3.params, n4 = l3(), { rows: o3 } = e3.params.grid;
            if (e3.virtualSize = (t4 + n4) * a2, e3.virtualSize = Math.ceil(e3.virtualSize / o3) - n4, e3.params.cssMode || (e3.wrapperEl.style[e3.getDirectionLabel("width")] = `${e3.virtualSize + n4}px`), i4) {
              const t5 = [];
              for (let a3 = 0; a3 < s4.length; a3 += 1) {
                let i5 = s4[a3];
                r4 && (i5 = Math.floor(i5)), s4[a3] < e3.virtualSize + s4[0] && t5.push(i5);
              }
              s4.splice(0, s4.length), s4.push(...t5);
            }
          }
        };
      },
      function({ swiper: e3 }) {
        Object.assign(e3, {
          appendSlide: ce.bind(e3),
          prependSlide: pe2.bind(e3),
          addSlide: ue2.bind(e3),
          removeSlide: me2.bind(e3),
          removeAllSlides: he2.bind(e3)
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        t3({ fadeEffect: { crossFade: false } }), fe({
          effect: "fade",
          swiper: e3,
          on: s3,
          setTranslate: () => {
            const { slides: t4 } = e3;
            e3.params.fadeEffect;
            for (let s4 = 0; s4 < t4.length; s4 += 1) {
              const t5 = e3.slides[s4];
              let a2 = -t5.swiperSlideOffset;
              e3.params.virtualTranslate || (a2 -= e3.translate);
              let i3 = 0;
              e3.isHorizontal() || (i3 = a2, a2 = 0);
              const r3 = e3.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(t5.progress), 0) : 1 + Math.min(Math.max(t5.progress, -1), 0), n3 = ge2(0, t5);
              n3.style.opacity = r3, n3.style.transform = `translate3d(${a2}px, ${i3}px, 0px)`;
            }
          },
          setTransition: (t4) => {
            const s4 = e3.slides.map((e4) => f(e4));
            s4.forEach((e4) => {
              e4.style.transitionDuration = `${t4}ms`;
            }), ve2({ swiper: e3, duration: t4, transformElements: s4, allSlides: true });
          },
          overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: !e3.params.cssMode
          })
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        t3({ cubeEffect: { slideShadows: true, shadow: true, shadowOffset: 20, shadowScale: 0.94 } });
        const a2 = (e4, t4, s4) => {
          let a3 = s4 ? e4.querySelector(".swiper-slide-shadow-left") : e4.querySelector(".swiper-slide-shadow-top"), i3 = s4 ? e4.querySelector(".swiper-slide-shadow-right") : e4.querySelector(".swiper-slide-shadow-bottom");
          a3 || (a3 = w("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (s4 ? "left" : "top")).split(" ")), e4.append(a3)), i3 || (i3 = w("div", ("swiper-slide-shadow-cube swiper-slide-shadow-" + (s4 ? "right" : "bottom")).split(" ")), e4.append(i3)), a3 && (a3.style.opacity = Math.max(-t4, 0)), i3 && (i3.style.opacity = Math.max(t4, 0));
        };
        fe({
          effect: "cube",
          swiper: e3,
          on: s3,
          setTranslate: () => {
            const { el: t4, wrapperEl: s4, slides: i3, width: r3, height: n3, rtlTranslate: l3, size: o3, browser: d3 } = e3, c2 = C2(e3), p2 = e3.params.cubeEffect, u2 = e3.isHorizontal(), m2 = e3.virtual && e3.params.virtual.enabled;
            let h2, f2 = 0;
            p2.shadow && (u2 ? (h2 = e3.wrapperEl.querySelector(".swiper-cube-shadow"), h2 || (h2 = w("div", "swiper-cube-shadow"), e3.wrapperEl.append(h2)), h2.style.height = `${r3}px`) : (h2 = t4.querySelector(".swiper-cube-shadow"), h2 || (h2 = w("div", "swiper-cube-shadow"), t4.append(h2))));
            for (let e4 = 0; e4 < i3.length; e4 += 1) {
              const t5 = i3[e4];
              let s5 = e4;
              m2 && (s5 = parseInt(t5.getAttribute("data-swiper-slide-index"), 10));
              let r4 = 90 * s5, n4 = Math.floor(r4 / 360);
              l3 && (r4 = -r4, n4 = Math.floor(-r4 / 360));
              const d4 = Math.max(Math.min(t5.progress, 1), -1);
              let h3 = 0, g3 = 0, v2 = 0;
              s5 % 4 == 0 ? (h3 = 4 * -n4 * o3, v2 = 0) : (s5 - 1) % 4 == 0 ? (h3 = 0, v2 = 4 * -n4 * o3) : (s5 - 2) % 4 == 0 ? (h3 = o3 + 4 * n4 * o3, v2 = o3) : (s5 - 3) % 4 == 0 && (h3 = -o3, v2 = 3 * o3 + 4 * o3 * n4), l3 && (h3 = -h3), u2 || (g3 = h3, h3 = 0);
              const w2 = `rotateX(${c2(u2 ? 0 : -r4)}deg) rotateY(${c2(u2 ? r4 : 0)}deg) translate3d(${h3}px, ${g3}px, ${v2}px)`;
              d4 <= 1 && d4 > -1 && (f2 = 90 * s5 + 90 * d4, l3 && (f2 = 90 * -s5 - 90 * d4)), t5.style.transform = w2, p2.slideShadows && a2(t5, d4, u2);
            }
            if (s4.style.transformOrigin = `50% 50% -${o3 / 2}px`, s4.style["-webkit-transform-origin"] = `50% 50% -${o3 / 2}px`, p2.shadow)
              if (u2)
                h2.style.transform = `translate3d(0px, ${r3 / 2 + p2.shadowOffset}px, ${-r3 / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${p2.shadowScale})`;
              else {
                const e4 = Math.abs(f2) - 90 * Math.floor(Math.abs(f2) / 90), t5 = 1.5 - (Math.sin(2 * e4 * Math.PI / 360) / 2 + Math.cos(2 * e4 * Math.PI / 360) / 2), s5 = p2.shadowScale, a3 = p2.shadowScale / t5, i4 = p2.shadowOffset;
                h2.style.transform = `scale3d(${s5}, 1, ${a3}) translate3d(0px, ${n3 / 2 + i4}px, ${-n3 / 2 / a3}px) rotateX(-89.99deg)`;
              }
            const g2 = (d3.isSafari || d3.isWebView) && d3.needPerspectiveFix ? -o3 / 2 : 0;
            s4.style.transform = `translate3d(0px,0,${g2}px) rotateX(${c2(e3.isHorizontal() ? 0 : f2)}deg) rotateY(${c2(e3.isHorizontal() ? -f2 : 0)}deg)`, s4.style.setProperty("--swiper-cube-translate-z", `${g2}px`);
          },
          setTransition: (t4) => {
            const { el: s4, slides: a3 } = e3;
            if (a3.forEach((e4) => {
              e4.style.transitionDuration = `${t4}ms`, e4.querySelectorAll(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              ).forEach((e5) => {
                e5.style.transitionDuration = `${t4}ms`;
              });
            }), e3.params.cubeEffect.shadow && !e3.isHorizontal()) {
              const e4 = s4.querySelector(".swiper-cube-shadow");
              e4 && (e4.style.transitionDuration = `${t4}ms`);
            }
          },
          recreateShadows: () => {
            const t4 = e3.isHorizontal();
            e3.slides.forEach((e4) => {
              const s4 = Math.max(Math.min(e4.progress, 1), -1);
              a2(e4, s4, t4);
            });
          },
          getEffectParams: () => e3.params.cubeEffect,
          perspective: () => true,
          overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            resistanceRatio: 0,
            spaceBetween: 0,
            centeredSlides: false,
            virtualTranslate: true
          })
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        t3({ flipEffect: { slideShadows: true, limitRotation: true } });
        const a2 = (t4, s4) => {
          let a3 = e3.isHorizontal() ? t4.querySelector(".swiper-slide-shadow-left") : t4.querySelector(".swiper-slide-shadow-top"), i3 = e3.isHorizontal() ? t4.querySelector(".swiper-slide-shadow-right") : t4.querySelector(".swiper-slide-shadow-bottom");
          a3 || (a3 = we2("flip", t4, e3.isHorizontal() ? "left" : "top")), i3 || (i3 = we2("flip", t4, e3.isHorizontal() ? "right" : "bottom")), a3 && (a3.style.opacity = Math.max(-s4, 0)), i3 && (i3.style.opacity = Math.max(s4, 0));
        };
        fe({
          effect: "flip",
          swiper: e3,
          on: s3,
          setTranslate: () => {
            const { slides: t4, rtlTranslate: s4 } = e3, i3 = e3.params.flipEffect, r3 = C2(e3);
            for (let n3 = 0; n3 < t4.length; n3 += 1) {
              const l3 = t4[n3];
              let o3 = l3.progress;
              e3.params.flipEffect.limitRotation && (o3 = Math.max(Math.min(l3.progress, 1), -1));
              const d3 = l3.swiperSlideOffset;
              let c2 = -180 * o3, p2 = 0, u2 = e3.params.cssMode ? -d3 - e3.translate : -d3, m2 = 0;
              e3.isHorizontal() ? s4 && (c2 = -c2) : (m2 = u2, u2 = 0, p2 = -c2, c2 = 0), l3.style.zIndex = -Math.abs(Math.round(o3)) + t4.length, i3.slideShadows && a2(l3, o3);
              const h2 = `translate3d(${u2}px, ${m2}px, 0px) rotateX(${r3(p2)}deg) rotateY(${r3(c2)}deg)`;
              ge2(0, l3).style.transform = h2;
            }
          },
          setTransition: (t4) => {
            const s4 = e3.slides.map((e4) => f(e4));
            s4.forEach((e4) => {
              e4.style.transitionDuration = `${t4}ms`, e4.querySelectorAll(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              ).forEach((e5) => {
                e5.style.transitionDuration = `${t4}ms`;
              });
            }), ve2({ swiper: e3, duration: t4, transformElements: s4 });
          },
          recreateShadows: () => {
            e3.params.flipEffect, e3.slides.forEach((t4) => {
              let s4 = t4.progress;
              e3.params.flipEffect.limitRotation && (s4 = Math.max(Math.min(t4.progress, 1), -1)), a2(t4, s4);
            });
          },
          getEffectParams: () => e3.params.flipEffect,
          perspective: () => true,
          overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: !e3.params.cssMode
          })
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        t3({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: true } }), fe({
          effect: "coverflow",
          swiper: e3,
          on: s3,
          setTranslate: () => {
            const { width: t4, height: s4, slides: a2, slidesSizesGrid: i3 } = e3, r3 = e3.params.coverflowEffect, n3 = e3.isHorizontal(), l3 = e3.translate, o3 = n3 ? t4 / 2 - l3 : s4 / 2 - l3, d3 = n3 ? r3.rotate : -r3.rotate, c2 = r3.depth, p2 = C2(e3);
            for (let e4 = 0, t5 = a2.length; e4 < t5; e4 += 1) {
              const t6 = a2[e4], s5 = i3[e4], l4 = (o3 - t6.swiperSlideOffset - s5 / 2) / s5, u2 = "function" == typeof r3.modifier ? r3.modifier(l4) : l4 * r3.modifier;
              let m2 = n3 ? d3 * u2 : 0, h2 = n3 ? 0 : d3 * u2, f2 = -c2 * Math.abs(u2), g2 = r3.stretch;
              "string" == typeof g2 && -1 !== g2.indexOf("%") && (g2 = parseFloat(r3.stretch) / 100 * s5);
              let v2 = n3 ? 0 : g2 * u2, w2 = n3 ? g2 * u2 : 0, b2 = 1 - (1 - r3.scale) * Math.abs(u2);
              Math.abs(w2) < 1e-3 && (w2 = 0), Math.abs(v2) < 1e-3 && (v2 = 0), Math.abs(f2) < 1e-3 && (f2 = 0), Math.abs(m2) < 1e-3 && (m2 = 0), Math.abs(h2) < 1e-3 && (h2 = 0), Math.abs(b2) < 1e-3 && (b2 = 0);
              const y2 = `translate3d(${w2}px,${v2}px,${f2}px)  rotateX(${p2(h2)}deg) rotateY(${p2(m2)}deg) scale(${b2})`;
              if (ge2(0, t6).style.transform = y2, t6.style.zIndex = 1 - Math.abs(Math.round(u2)), r3.slideShadows) {
                let e5 = n3 ? t6.querySelector(".swiper-slide-shadow-left") : t6.querySelector(".swiper-slide-shadow-top"), s6 = n3 ? t6.querySelector(".swiper-slide-shadow-right") : t6.querySelector(".swiper-slide-shadow-bottom");
                e5 || (e5 = we2("coverflow", t6, n3 ? "left" : "top")), s6 || (s6 = we2("coverflow", t6, n3 ? "right" : "bottom")), e5 && (e5.style.opacity = u2 > 0 ? u2 : 0), s6 && (s6.style.opacity = -u2 > 0 ? -u2 : 0);
              }
            }
          },
          setTransition: (t4) => {
            e3.slides.map((e4) => f(e4)).forEach((e4) => {
              e4.style.transitionDuration = `${t4}ms`, e4.querySelectorAll(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              ).forEach((e5) => {
                e5.style.transitionDuration = `${t4}ms`;
              });
            });
          },
          perspective: () => true,
          overwriteParams: () => ({ watchSlidesProgress: true })
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        t3({
          creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 },
            next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 }
          }
        });
        const a2 = (e4) => "string" == typeof e4 ? e4 : `${e4}px`;
        fe({
          effect: "creative",
          swiper: e3,
          on: s3,
          setTranslate: () => {
            const { slides: t4, wrapperEl: s4, slidesSizesGrid: i3 } = e3, r3 = e3.params.creativeEffect, { progressMultiplier: n3 } = r3, l3 = e3.params.centeredSlides, o3 = C2(e3);
            if (l3) {
              const t5 = i3[0] / 2 - e3.params.slidesOffsetBefore || 0;
              s4.style.transform = `translateX(calc(50% - ${t5}px))`;
            }
            for (let s5 = 0; s5 < t4.length; s5 += 1) {
              const i4 = t4[s5], d3 = i4.progress, c2 = Math.min(Math.max(i4.progress, -r3.limitProgress), r3.limitProgress);
              let p2 = c2;
              l3 || (p2 = Math.min(Math.max(i4.originalProgress, -r3.limitProgress), r3.limitProgress));
              const u2 = i4.swiperSlideOffset, m2 = [e3.params.cssMode ? -u2 - e3.translate : -u2, 0, 0], h2 = [0, 0, 0];
              let f2 = false;
              e3.isHorizontal() || (m2[1] = m2[0], m2[0] = 0);
              let g2 = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
              c2 < 0 ? (g2 = r3.next, f2 = true) : c2 > 0 && (g2 = r3.prev, f2 = true), m2.forEach((e4, t5) => {
                m2[t5] = `calc(${e4}px + (${a2(g2.translate[t5])} * ${Math.abs(c2 * n3)}))`;
              }), h2.forEach((e4, t5) => {
                let s6 = g2.rotate[t5] * Math.abs(c2 * n3);
                h2[t5] = s6;
              }), i4.style.zIndex = -Math.abs(Math.round(d3)) + t4.length;
              const v2 = m2.join(", "), w2 = `rotateX(${o3(h2[0])}deg) rotateY(${o3(h2[1])}deg) rotateZ(${o3(h2[2])}deg)`, b2 = p2 < 0 ? `scale(${1 + (1 - g2.scale) * p2 * n3})` : `scale(${1 - (1 - g2.scale) * p2 * n3})`, y2 = p2 < 0 ? 1 + (1 - g2.opacity) * p2 * n3 : 1 - (1 - g2.opacity) * p2 * n3, E2 = `translate3d(${v2}) ${w2} ${b2}`;
              if (f2 && g2.shadow || !f2) {
                let e4 = i4.querySelector(".swiper-slide-shadow");
                if (!e4 && g2.shadow && (e4 = we2("creative", i4)), e4) {
                  const t5 = r3.shadowPerProgress ? c2 * (1 / r3.limitProgress) : c2;
                  e4.style.opacity = Math.min(Math.max(Math.abs(t5), 0), 1);
                }
              }
              const x2 = ge2(0, i4);
              x2.style.transform = E2, x2.style.opacity = y2, g2.origin && (x2.style.transformOrigin = g2.origin);
            }
          },
          setTransition: (t4) => {
            const s4 = e3.slides.map((e4) => f(e4));
            s4.forEach((e4) => {
              e4.style.transitionDuration = `${t4}ms`, e4.querySelectorAll(".swiper-slide-shadow").forEach((e5) => {
                e5.style.transitionDuration = `${t4}ms`;
              });
            }), ve2({ swiper: e3, duration: t4, transformElements: s4, allSlides: true });
          },
          perspective: () => e3.params.creativeEffect.perspective,
          overwriteParams: () => ({ watchSlidesProgress: true, virtualTranslate: !e3.params.cssMode })
        });
      },
      function({ swiper: e3, extendParams: t3, on: s3 }) {
        t3({ cardsEffect: { slideShadows: true, rotate: true, perSlideRotate: 2, perSlideOffset: 8 } }), fe({
          effect: "cards",
          swiper: e3,
          on: s3,
          setTranslate: () => {
            const { slides: t4, activeIndex: s4, rtlTranslate: a2 } = e3, i3 = e3.params.cardsEffect, { startTranslate: r3, isTouched: n3 } = e3.touchEventsData, l3 = a2 ? -e3.translate : e3.translate;
            for (let o3 = 0; o3 < t4.length; o3 += 1) {
              const d3 = t4[o3], c2 = d3.progress, p2 = Math.min(Math.max(c2, -4), 4);
              let u2 = d3.swiperSlideOffset;
              e3.params.centeredSlides && !e3.params.cssMode && (e3.wrapperEl.style.transform = `translateX(${e3.minTranslate()}px)`), e3.params.centeredSlides && e3.params.cssMode && (u2 -= t4[0].swiperSlideOffset);
              let m2 = e3.params.cssMode ? -u2 - e3.translate : -u2, h2 = 0;
              const f2 = -100 * Math.abs(p2);
              let g2 = 1, v2 = -i3.perSlideRotate * p2, w2 = i3.perSlideOffset - 0.75 * Math.abs(p2);
              const b2 = e3.virtual && e3.params.virtual.enabled ? e3.virtual.from + o3 : o3, y2 = (b2 === s4 || b2 === s4 - 1) && p2 > 0 && p2 < 1 && (n3 || e3.params.cssMode) && l3 < r3, E2 = (b2 === s4 || b2 === s4 + 1) && p2 < 0 && p2 > -1 && (n3 || e3.params.cssMode) && l3 > r3;
              if (y2 || E2) {
                const t5 = (1 - Math.abs((Math.abs(p2) - 0.5) / 0.5)) ** 0.5;
                v2 += -28 * p2 * t5, g2 += -0.5 * t5, w2 += 96 * t5, h2 = (i3.rotate || e3.isHorizontal() ? -25 : 0) * t5 * Math.abs(p2) + "%";
              }
              if (m2 = p2 < 0 ? `calc(${m2}px ${a2 ? "-" : "+"} (${w2 * Math.abs(p2)}%))` : p2 > 0 ? `calc(${m2}px ${a2 ? "-" : "+"} (-${w2 * Math.abs(p2)}%))` : `${m2}px`, !e3.isHorizontal()) {
                const e4 = h2;
                h2 = m2, m2 = e4;
              }
              const x2 = p2 < 0 ? "" + (1 + (1 - g2) * p2) : "" + (1 - (1 - g2) * p2), S2 = `
        translate3d(${m2}, ${h2}, ${f2}px)
        rotateZ(${i3.rotate ? a2 ? -v2 : v2 : 0}deg)
        scale(${x2})
      `;
              if (i3.slideShadows) {
                let e4 = d3.querySelector(".swiper-slide-shadow");
                e4 || (e4 = we2("cards", d3)), e4 && (e4.style.opacity = Math.min(Math.max((Math.abs(p2) - 0.5) / 0.5, 0), 1));
              }
              d3.style.zIndex = -Math.abs(Math.round(c2)) + t4.length;
              ge2(0, d3).style.transform = S2;
            }
          },
          setTransition: (t4) => {
            const s4 = e3.slides.map((e4) => f(e4));
            s4.forEach((e4) => {
              e4.style.transitionDuration = `${t4}ms`, e4.querySelectorAll(".swiper-slide-shadow").forEach((e5) => {
                e5.style.transitionDuration = `${t4}ms`;
              });
            }), ve2({ swiper: e3, duration: t4, transformElements: s4 });
          },
          perspective: () => true,
          overwriteParams: () => ({
            _loopSwapReset: false,
            watchSlidesProgress: true,
            loopAdditionalSlides: e3.params.cardsEffect.rotate ? 3 : 2,
            centeredSlides: true,
            virtualTranslate: !e3.params.cssMode
          })
        });
      }
    ];
    return ne2.use(be2), ne2;
  })();
  if (typeof window !== "undefined") {
    window.Swiper = Swiper2;
  }

  // assets-src/js/_sec_service-group.js
  var SchedulingLocationTabs = function(element) {
    this.element = element;
    this.controls = this.element.querySelector(".tab-controls");
    this.contents = this.element.querySelector(".tab-contents");
    this.marker = this.element.querySelector(".tab-marker");
    if (this.element.classList.contains("tabs-initialized")) return;
    initTabs2(this);
    function initTabs2(tabs) {
      var activeControl = tabs.controls.querySelector('.tab-control[aria-selected="true"]');
      if (!activeControl) {
        activeControl = tabs.controls.querySelector(".tab-control");
        activeControl.setAttribute("aria-selected", "true");
      }
      if (activeControl) {
        var activeControlId = activeControl.getAttribute("aria-controls");
        showTab(tabs, activeControl, activeControlId, false);
      }
      tabs.controls.addEventListener("click", function(event2) {
        var selectedControl = event2.target.closest(".tab-control");
        var selectedContentId = selectedControl ? selectedControl.getAttribute("aria-controls") : null;
        if (selectedControl && selectedContentId) {
          tabs.controls.querySelectorAll(".tab-control").forEach(function(control) {
            control.setAttribute("aria-selected", "false");
            control.setAttribute("tabindex", "-1");
          });
          tabs.contents.querySelectorAll(".tab-content").forEach(function(content) {
            content.setAttribute("hidden", "true");
          });
          showTab(tabs, selectedControl, selectedContentId);
        }
      });
      window.addEventListener("resize", function() {
        var activeControl2 = tabs.controls.querySelector('.tab-control[aria-selected="true"]');
        if (activeControl2) {
          placeTabMarker(tabs, activeControl2, false);
        }
      });
      tabs.element.classList.add("tabs-initialized");
    }
    function showTab(tabs, control, contentId, animate = true) {
      control.setAttribute("aria-selected", "true");
      control.setAttribute("tabindex", "0");
      var content = tabs.contents.querySelector("#" + contentId);
      if (content) {
        content.removeAttribute("hidden");
        if (animate) {
          gsap.set(content, { opacity: 0, x: -20 });
          gsap.to(content, {
            opacity: 1,
            x: 0,
            duration: 0.3,
            ease: "power2.out"
          });
        }
        placeTabMarker(tabs, control, animate);
      }
    }
    function placeTabMarker(tabs, selectedControl, animate = true) {
      if (tabs.marker.length == 0 || !selectedControl) return;
      if (animate) {
        tabs.marker.style.transition = "all 0.3s ease-in-out";
      } else {
        tabs.marker.style.transition = "none";
      }
      tabs.marker.style.width = selectedControl.offsetWidth + "px";
      tabs.marker.style.height = selectedControl.offsetHeight + "px";
      tabs.marker.style.transform = "translateX(" + (selectedControl.getBoundingClientRect().left - tabs.controls.getBoundingClientRect().left) + "px)";
    }
  };
  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".scheduling-location-tabs").forEach(function(tabs) {
      if (!tabs.closest("dialog")) {
        new SchedulingLocationTabs(tabs);
      }
    });
    document.querySelectorAll(".service-drawer-button").forEach(function(button) {
      button.addEventListener("click", function() {
        var targetId = this.getAttribute("commandfor");
        var dialog = document.getElementById(targetId);
        if (dialog) {
          setTimeout(function() {
            dialog.querySelectorAll(".scheduling-location-tabs").forEach(function(tabs) {
              new SchedulingLocationTabs(tabs);
            });
          }, 100);
        }
      });
    });
  });
  var initMoreServicesAccordions = () => {
    const accordions = document.querySelectorAll(".more-services-button");
    accordions.forEach((accordion) => {
      accordion.addEventListener("click", function() {
        const icon = this.querySelector(".button-icon > svg");
        if (icon) {
          const currentRotation = gsap.getProperty(icon, "rotation");
          gsap.to(icon, {
            rotation: currentRotation === 180 ? 0 : 180,
            duration: 0.3,
            ease: "power2.out"
          });
        }
        const isExpanded = this.getAttribute("aria-expanded") === "true";
        this.setAttribute("aria-expanded", !isExpanded);
        const controlledId = this.getAttribute("aria-controls");
        if (controlledId) {
          const controlledElement = document.getElementById(controlledId);
          if (controlledElement) {
            if (controlledElement.hasAttribute("hidden")) {
              controlledElement.removeAttribute("hidden");
              gsap.fromTo(
                controlledElement,
                { height: 0, opacity: 0 },
                { height: "auto", opacity: 1, duration: 0.3, ease: "power2.out" }
              );
            } else {
              gsap.to(controlledElement, {
                height: 0,
                opacity: 0,
                duration: 0.3,
                ease: "power2.out",
                onComplete: () => {
                  controlledElement.setAttribute("hidden", "");
                  gsap.set(controlledElement, { height: "auto", opacity: 1 });
                }
              });
            }
          }
        }
      });
    });
  };

  // assets-src/js/_p_service-drawer.js
  document.addEventListener("DOMContentLoaded", () => {
    const accordions = document.querySelectorAll(".parent-accordion");
    const isMobileScreen = window.innerWidth <= 640;
    accordions.forEach((accordion) => {
      const toggles = accordion.querySelectorAll(".parent-accordion-toggle");
      toggles.forEach((toggle) => {
        if (isMobileScreen) {
          toggle.addEventListener("click", () => {
            const parent = toggle.parentElement;
            const status = parent.dataset.parentAccordionStatus;
            if (status == "active") {
              parent.dataset.parentAccordionStatus = "not-active";
            } else {
              parent.dataset.parentAccordionStatus = "active";
            }
          });
        } else {
          const parent = toggle.parentElement;
          parent.dataset.parentAccordionStatus = "active";
        }
      });
    });
  });

  // assets-src/js/_p_cerbo-scheduling-embed.js
  document.addEventListener("DOMContentLoaded", () => {
    const embedElements = document.querySelectorAll(".cerbo-embed-container");
    embedElements?.forEach((embedElement) => {
      const showBtn = embedElement.querySelector(".cerbo-embed-show");
      const content = embedElement.querySelector(".cerbo-embed-content");
      const hideBtn = embedElement.querySelector(".cerbo-embed-hide");
      if (content) {
        if (showBtn) {
          showBtn.addEventListener("click", () => {
            content.classList.remove("hidden");
          });
        }
        if (hideBtn) {
          hideBtn.addEventListener("click", () => {
            content.classList.add("hidden");
          });
        }
      }
    });
  });

  // assets-src/js/_c_video-modal.js
  document.addEventListener("DOMContentLoaded", () => {
    const videoModalButtons = document.querySelectorAll(".video-modal-button");
    videoModalButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const targetId = button.getAttribute("commandfor");
        const targetElement = document.getElementById(targetId);
        const video = targetElement?.querySelector("video");
        const command = button.getAttribute("command");
        console.log(targetId);
        if (command === "show-modal" && video) {
          video.play();
        } else if (video) {
          video.pause();
        }
      });
    });
  });

  // assets-src/js/_sec_footer.js
  document.addEventListener("DOMContentLoaded", () => {
    const cookieBtn = document.getElementById("cookie-preferences");
    if (cookieBtn) {
      cookieBtn.addEventListener("click", () => {
        privacyBanner.showPreferences();
      });
    }
  });

  // assets-src/js/_c_add-to-cart.js
  init_c_cart();
  function initAddToCart() {
    const forms = document.querySelectorAll(".add-to-cart-form");
    forms.forEach((form) => {
      form.addEventListener("submit", handleAddToCart);
    });
  }
  async function handleAddToCart(event2) {
    event2.preventDefault();
    const form = event2.target;
    const formData = new FormData(form);
    const button = form.querySelector('button[type="submit"]');
    const originalHTML = button.innerHTML;
    button.disabled = true;
    button.innerHTML = "Adding...";
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData
      });
      if (response.ok) {
        const data = await response.json();
        console.log("Added to cart:", data);
        const cartResponse = await fetch("/cart.js");
        const cartData = await cartResponse.json();
        await updateCartUI(cartData);
        openCartDrawer();
        button.innerHTML = "Added!";
        setTimeout(() => {
          button.innerHTML = originalHTML;
          button.disabled = false;
        }, 1500);
      } else {
        const error = await response.json();
        console.error("Failed to add to cart:", error);
        alert(error.description || "Failed to add product to cart");
        button.innerHTML = originalHTML;
        button.disabled = false;
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      alert("Error adding product to cart");
      button.innerHTML = originalHTML;
      button.disabled = false;
    }
  }
  function openCartDrawer() {
    const drawer = document.getElementById("cart-drawer");
    if (drawer) {
      drawer.showModal();
    }
  }

  // assets-src/js/_c_cart-bxgy.js
  init_c_cart();
  init_c_lucide_icons();

  // assets-src/js/_c_cart-variant-editor.js
  init_c_cart();
  var isUpdatingVariant = false;
  function isVariantUpdateInProgress() {
    return isUpdatingVariant;
  }
  function findVariantByOptions(product, selectedOptions) {
    return product.variants.find((variant) => {
      return variant.options.every((option, index) => {
        return option === selectedOptions[index];
      });
    });
  }
  async function updateCartItemVariant(oldKey, newVariantId, quantity, properties = {}) {
    isUpdatingVariant = true;
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: oldKey,
          quantity: 0
        })
      });
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: newVariantId, quantity, properties }]
        })
      });
      if (!response.ok) throw new Error("Failed to add new variant");
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();
      await updateCartUI(cartData);
      return true;
    } catch (error) {
      console.error("Error updating cart variant:", error);
      alert("Unable to update variant. Please try again.");
      return false;
    } finally {
      isUpdatingVariant = false;
    }
  }
  function initCartVariantEditor() {
    document.addEventListener("click", async (e2) => {
      if (e2.target.matches(".cart-edit-variant")) {
        const itemKey = e2.target.dataset.itemKey;
        const variantSelector = document.querySelector(`.cart-variant-selector[data-item-key="${itemKey}"]`);
        const variantDisplay = e2.target.closest(".flex.items-center.gap-2");
        if (variantSelector) {
          variantSelector.classList.remove("hidden");
          if (variantDisplay) variantDisplay.classList.add("hidden");
        }
      }
      if (e2.target.matches(".cart-variant-cancel")) {
        const itemKey = e2.target.dataset.itemKey;
        const variantSelector = document.querySelector(`.cart-variant-selector[data-item-key="${itemKey}"]`);
        const variantDisplay = variantSelector?.previousElementSibling;
        if (variantSelector) {
          variantSelector.classList.add("hidden");
          if (variantDisplay) variantDisplay.classList.remove("hidden");
        }
      }
      if (e2.target.matches(".cart-variant-update")) {
        const updateButton = e2.target;
        const itemKey = updateButton.dataset.itemKey;
        const productHandle = updateButton.dataset.productHandle;
        const variantSelector = document.querySelector(`.cart-variant-selector[data-item-key="${itemKey}"]`);
        if (!variantSelector) return;
        const cancelButton = variantSelector.querySelector(".cart-variant-cancel");
        const originalText = updateButton.textContent;
        updateButton.textContent = "Updating...";
        updateButton.disabled = true;
        if (cancelButton) cancelButton.disabled = true;
        const optionSelects = variantSelector.querySelectorAll(".cart-variant-option");
        const selectedOptions = Array.from(optionSelects).map((select) => select.value);
        try {
          const cartResponse = await fetch("/cart.js");
          if (!cartResponse.ok) throw new Error("Failed to fetch cart");
          const cartData = await cartResponse.json();
          const currentItem = cartData.items.find((item) => item.key === itemKey);
          if (!currentItem) {
            console.error("Current item not found in cart");
            updateButton.textContent = originalText;
            updateButton.disabled = false;
            if (cancelButton) cancelButton.disabled = false;
            return;
          }
          const properties = currentItem.properties || {};
          const productResponse = await fetch(`/products/${productHandle}.js`);
          if (!productResponse.ok) throw new Error("Failed to fetch product data");
          const productData = await productResponse.json();
          const newVariant = findVariantByOptions(productData, selectedOptions);
          if (!newVariant) {
            alert("This variant combination is not available.");
            updateButton.textContent = originalText;
            updateButton.disabled = false;
            if (cancelButton) cancelButton.disabled = false;
            return;
          }
          if (newVariant.id === currentItem.variant_id) {
            variantSelector.classList.add("hidden");
            const variantDisplay = variantSelector.previousElementSibling;
            if (variantDisplay) variantDisplay.classList.remove("hidden");
            updateButton.textContent = originalText;
            updateButton.disabled = false;
            if (cancelButton) cancelButton.disabled = false;
            return;
          }
          const success = await updateCartItemVariant(itemKey, newVariant.id, currentItem.quantity, properties);
          if (success) {
            console.log("Variant updated successfully");
          }
        } catch (error) {
          console.error("Error in variant update:", error);
          alert("Unable to update variant. Please try again.");
          updateButton.textContent = originalText;
          updateButton.disabled = false;
          if (cancelButton) cancelButton.disabled = false;
        }
      }
    });
  }

  // assets-src/js/_c_cart-bxgy.js
  var bxgyConfigs = [];
  var isProcessing = false;
  function isPromotionActive(startDate, endDate) {
    if (!startDate && !endDate) return true;
    const now2 = /* @__PURE__ */ new Date();
    const estTime = new Date(now2.toLocaleString("en-US", { timeZone: "America/New_York" }));
    if (startDate) {
      const start = /* @__PURE__ */ new Date(startDate + " EST");
      if (estTime < start) return false;
    }
    if (endDate) {
      const end = /* @__PURE__ */ new Date(endDate + " EST");
      if (estTime > end) return false;
    }
    return true;
  }
  function loadBxgyConfigs() {
    const configElements = document.querySelectorAll(".bxgy-config");
    const configs = [];
    configElements.forEach((element, index) => {
      if (element.dataset.bxgyEnabled === "true") {
        const startDate = element.dataset.discountStart || "";
        const endDate = element.dataset.discountEnd || "";
        if (isPromotionActive(startDate, endDate)) {
          configs.push({
            id: `bxgy-${index}`,
            enabled: true,
            discountCode: element.dataset.discountCode || "",
            startDate,
            endDate,
            qualifyingVariants: element.dataset.qualifyingVariants.split(",").map((id) => parseInt(id, 10)),
            giftVariants: element.dataset.giftVariants.split(",").map((id) => parseInt(id, 10)),
            minQuantity: parseInt(element.dataset.minQuantity, 10) || 1,
            buyQuantity: parseInt(element.dataset.buyQuantity, 10) || 1,
            getQuantity: parseInt(element.dataset.getQuantity, 10) || 1,
            maxGifts: parseInt(element.dataset.maxGifts, 10) || 999,
            autoOpenCart: element.dataset.autoOpenCart === "true",
            showNotification: element.dataset.showNotification === "true",
            notificationMessage: element.dataset.notificationMessage || "Free gift added to your cart!"
          });
        }
      }
    });
    return configs;
  }
  function getQualifyingQuantity(cartData, config) {
    let totalQty = 0;
    cartData.items?.forEach((item) => {
      if (item.properties?._bxgy_gift === "true") return;
      if (config.qualifyingVariants.includes(item.variant_id)) {
        totalQty += item.quantity;
      }
    });
    return totalQty;
  }
  function getGiftQuantity(cartData, config) {
    let totalQty = 0;
    cartData.items?.forEach((item) => {
      if (item.properties?._bxgy_gift !== "true" || item.properties?._bxgy_promo_id !== config.id) return;
      if (config.giftVariants.includes(item.variant_id)) {
        totalQty += item.quantity;
      }
    });
    return totalQty;
  }
  function calculateRequiredGifts(qualifyingQty, config) {
    if (qualifyingQty < config.minQuantity) {
      return 0;
    }
    const eligibleSets = Math.floor(qualifyingQty / config.buyQuantity);
    const calculatedGifts = eligibleSets * config.getQuantity;
    return Math.min(calculatedGifts, config.maxGifts);
  }
  async function addGiftToCart(variantId, quantity, promoId) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity,
              properties: {
                _bxgy_gift: "true",
                _bxgy_promo_id: promoId
              }
            }
          ]
        })
      });
      if (!response.ok) {
        throw new Error("Failed to add gift to cart");
      }
      return await response.json();
    } catch (error) {
      console.error("Error adding gift to cart:", error);
      throw error;
    }
  }
  async function updateGiftQuantity(giftItem, newQuantity) {
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: newQuantity
        })
      });
      if (!response.ok) {
        throw new Error("Failed to update gift quantity");
      }
      return await response.json();
    } catch (error) {
      console.error("Error updating gift quantity:", error);
      throw error;
    }
  }
  function showGiftNotification(config) {
    if (!config?.showNotification) return;
    const cartPanel = document.querySelector("el-dialog-panel");
    if (!cartPanel) return;
    const notification = document.createElement("div");
    notification.className = "absolute top-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 rounded-lg bg-emerald-600 px-5 py-2.5 text-white shadow-lg transition-all duration-300 ease-in-out max-w-xl";
    notification.style.transform = "translateY(-100px)";
    notification.style.opacity = "0";
    notification.innerHTML = `
    <i class="size-5 shrink-0" data-lucide="gift"></i>
    <span class="font-medium">${config.notificationMessage}</span>
  `;
    cartPanel.appendChild(notification);
    initLucide();
    requestAnimationFrame(() => {
      notification.style.transform = "translateY(0) translateX(-50%)";
      notification.style.opacity = "1";
    });
    setTimeout(() => {
      notification.style.opacity = "0";
      notification.style.transform = "translateY(-100px) translateX(-50%)";
      setTimeout(() => notification.remove(), 300);
    }, 5e3);
  }
  async function processPromotion(cartData, config) {
    const qualifyingQty = getQualifyingQuantity(cartData, config);
    const currentGiftQty = getGiftQuantity(cartData, config);
    const requiredGiftQty = calculateRequiredGifts(qualifyingQty, config);
    if (currentGiftQty === requiredGiftQty) {
      return { changed: false, added: false };
    }
    const giftItem = cartData.items?.find(
      (item) => item.properties?._bxgy_gift === "true" && item.properties?._bxgy_promo_id === config.id && config.giftVariants.includes(item.variant_id)
    );
    let giftAdded = false;
    let cartChanged = false;
    if (requiredGiftQty === 0) {
      if (giftItem) {
        await updateGiftQuantity(giftItem, 0);
        cartChanged = true;
      }
    } else if (giftItem) {
      await updateGiftQuantity(giftItem, requiredGiftQty);
      cartChanged = true;
      if (requiredGiftQty > currentGiftQty) {
        giftAdded = true;
      }
    } else {
      const giftVariantId = config.giftVariants[0];
      await addGiftToCart(giftVariantId, requiredGiftQty, config.id);
      cartChanged = true;
      giftAdded = true;
    }
    return { changed: cartChanged, added: giftAdded, config };
  }
  async function processBxgy(cartData) {
    if (bxgyConfigs.length === 0 || isProcessing || isVariantUpdateInProgress()) {
      return;
    }
    isProcessing = true;
    try {
      const results = await Promise.all(bxgyConfigs.map((config) => processPromotion(cartData, config)));
      const anyChanged = results.some((r2) => r2.changed);
      const addedPromotions = results.filter((r2) => r2.added);
      if (anyChanged) {
        isProcessing = false;
        const freshCartResponse = await fetch("/cart.js");
        const freshCartData = await freshCartResponse.json();
        await updateCartUI(freshCartData);
        if (addedPromotions.length > 0) {
          addedPromotions.forEach((result, index) => {
            setTimeout(() => showGiftNotification(result.config), index * 200);
          });
          const shouldOpenCart = addedPromotions.some((r2) => r2.config.autoOpenCart);
          if (shouldOpenCart) {
            const cartDrawer = document.getElementById("cart-drawer");
            if (cartDrawer) {
              cartDrawer.showModal();
            }
          }
        }
      } else {
        isProcessing = false;
      }
    } catch (error) {
      console.error("Error processing BXGY:", error);
      isProcessing = false;
    }
  }
  function initBxgy() {
    bxgyConfigs = loadBxgyConfigs();
    if (bxgyConfigs.length === 0) {
      return;
    }
    document.addEventListener("cart:updated", async (event2) => {
      const cartData = event2.detail;
      await processBxgy(cartData);
    });
    fetch("/cart.js").then((response) => response.json()).then((cartData) => processBxgy(cartData)).catch((error) => console.error("Error loading cart for BXGY:", error));
  }

  // assets-src/js/input.js
  init_c_cart();

  // assets-src/js/_c_cart-drawer.js
  init_c_cart_discounts();
  function initCartDrawer() {
    const cartDialog = document.getElementById("cart-el-dialog");
    const cartDrawer = document.getElementById("cart-drawer");
    const relatedDrawer = document.getElementById("related-drawer");
    let isClosing = false;
    if (!cartDrawer) return;
    cartDrawer.addEventListener("toggle", async () => {
      if (cartDrawer.open) {
        try {
          const response = await fetch("/cart.js");
          const cartData = await response.json();
          updateDiscountDisplay(cartData);
        } catch (error) {
          console.error("Error fetching cart data for discounts:", error);
        }
      }
    });
    if (cartDialog) {
      cartDialog.addEventListener("cancel", (event2) => {
        event2.preventDefault();
      });
    }
    function handleClose(e2) {
      if (cartDrawer.open && !isClosing) {
        e2.preventDefault();
        e2.stopPropagation();
        isClosing = true;
        if (relatedDrawer && relatedDrawer.classList.contains("animate-slide-in-from-right")) {
          relatedDrawer.classList.remove("animate-slide-in-from-right");
          relatedDrawer.classList.add("animate-slide-out-to-right");
          setTimeout(() => {
            relatedDrawer.classList.remove("animate-slide-out-to-right");
            cartDrawer.close();
            isClosing = false;
          }, 300);
        } else {
          cartDrawer.close();
          isClosing = false;
        }
      }
    }
    const closeButtons = cartDrawer.querySelectorAll('[command="close"]');
    closeButtons.forEach((btn) => {
      btn.addEventListener("click", handleClose, true);
    });
    const containerDiv = cartDrawer.querySelector('div[tabindex="0"]');
    if (containerDiv) {
      containerDiv.addEventListener("click", function(e2) {
        if (e2.target === containerDiv) {
          handleClose(e2);
        }
      });
    }
    cartDrawer.addEventListener(
      "keydown",
      function(e2) {
        if (e2.key === "Escape" && cartDrawer.open && !isClosing) {
          handleClose(e2);
        }
      },
      true
    );
  }

  // assets-src/js/_c_cart-related-products.js
  var CartRelatedProducts = class {
    constructor() {
      this.container = document.querySelector("#related-drawer-products");
      this.limit = this.container ? parseInt(this.container.dataset.limit) || 6 : 6;
      this.defaultCollections = this.container?.dataset.defaultCollections ? this.container.dataset.defaultCollections.split(",").filter(Boolean) : ["all"];
    }
    /**
     * Initialize - fetch cart and get recommendations
     */
    async init() {
      if (!this.container) return;
      try {
        const cart = await this.fetchCart();
        await this.updateRelatedProducts(cart);
      } catch (error) {
        console.error("Error initializing related products:", error);
      }
    }
    /**
     * Fetch current cart
     */
    async fetchCart() {
      const response = await fetch("/cart.js");
      return response.json();
    }
    /**
     * Get recommendations for all products in cart
     * Aggregates and deduplicates recommendations
     * Falls back to featured/newest products if cart is empty
     */
    async getRecommendations(cart, intent = "related", limit = 6) {
      if (!cart.items.length) {
        return this.getFeaturedProducts(limit);
      }
      const productIds = [...new Set(cart.items.map((item) => item.product_id))];
      const recommendationPromises = productIds.map(
        (productId) => fetch(
          `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`
        ).then((res) => res.json()).catch(() => ({ products: [] }))
      );
      const results = await Promise.all(recommendationPromises);
      const allProducts = results.flatMap((result) => result.products || []);
      const uniqueProducts = this.deduplicateProducts(allProducts, cart);
      return uniqueProducts.slice(0, limit);
    }
    /**
     * Get featured products when cart is empty
     * Uses collections from data-default-collections attribute
     * Normalizes data to match recommendations API format
     */
    async getFeaturedProducts(limit = 6) {
      try {
        const collectionPromises = this.defaultCollections.map(
          (collection) => fetch(`${window.Shopify.routes.root}collections/${collection}/products.json?limit=${limit}`).then((res) => res.json()).catch(() => ({ products: [] }))
        );
        const results = await Promise.all(collectionPromises);
        const allProducts = results.flatMap((data) => data.products || []);
        const products = allProducts.map((product) => ({
          id: product.id,
          title: product.title,
          handle: product.handle,
          price: parseFloat(product.variants[0]?.price || 0) * 100,
          // Convert to cents
          compare_at_price: product.variants[0]?.compare_at_price ? parseFloat(product.variants[0].compare_at_price) * 100 : null,
          featured_image: product.images[0]?.src || "",
          url: `/products/${product.handle}`,
          variants: product.variants
        }));
        const uniqueProducts = this.deduplicateByProductId(products);
        return uniqueProducts.slice(0, limit);
      } catch (error) {
        console.error("Error fetching featured products:", error);
        return [];
      }
    }
    /**
     * Remove duplicates by product ID only
     */
    deduplicateByProductId(products) {
      const seen = /* @__PURE__ */ new Set();
      return products.filter((product) => {
        if (seen.has(product.id)) {
          return false;
        }
        seen.add(product.id);
        return true;
      });
    }
    /**
     * Remove duplicates and products already in cart
     */
    deduplicateProducts(products, cart) {
      const cartProductIds = new Set(cart.items.map((item) => item.product_id));
      const seen = /* @__PURE__ */ new Set();
      return products.filter((product) => {
        if (seen.has(product.id) || cartProductIds.has(product.id)) {
          return false;
        }
        seen.add(product.id);
        return true;
      });
    }
    /**
     * Update related products display
     */
    async updateRelatedProducts(cart) {
      if (!this.container) return;
      try {
        const relatedProducts = await this.getRecommendations(cart, "related", this.limit);
        if (relatedProducts.length > 0) {
          this.renderProducts(relatedProducts, this.container);
        } else {
          this.renderEmpty(this.container);
        }
      } catch (error) {
        console.error("Error updating related products:", error);
        this.renderEmpty(this.container);
      }
    }
    /**
     * Render products using Shopify Section Rendering API (server-side rendering)
     * This is more efficient and maintains consistency with theme styling
     */
    async renderProducts(products, container) {
      const productIds = products.map((p) => p.id).join(",");
      try {
        const html = await this.renderProductCards(products);
        container.innerHTML = html;
        this.attachAddToCartListeners(container);
      } catch (error) {
        console.error("Error rendering products:", error);
      }
    }
    /**
     * Client-side render with Tailwind classes
     */
    renderProductCards(products) {
      return products.map((product) => {
        const price = (product.price / 100).toFixed(2);
        const compareAtPrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
        const onSale = compareAtPrice && product.compare_at_price > product.price;
        return `
        <div class="group relative flex flex-col pb-6" data-product-id="${product.id}">
          <a href="${product.url}" class="block">
            <div class="aspect-square w-full overflow-hidden rounded-lg bg-neutral-100">
              <img 
                src="${product.featured_image}" 
                alt="${product.title}"
                class="size-full object-cover object-center transition-transform duration-300 group-hover:scale-105"
              >
            </div>
            <div class="mt-3">
              <h3 class="text-sm font-medium text-neutral-900">${product.title}</h3>
              <div class="mt-1 flex items-baseline gap-2">
                <span class="text-sm font-semibold text-neutral-900">$${price}</span>
                ${onSale ? `<span class="text-xs text-neutral-500 line-through">$${compareAtPrice}</span>` : ""}
              </div>
            </div>
          </a>
          <button
            class="add-to-cart mt-2 w-full rounded-md bg-emerald-600 px-3 py-2 text-sm font-semibold text-emerald-50 shadow-xs transition-colors duration-300 hover:bg-emerald-500"
            data-variant-id="${product.variants[0].id}"
          >
            Add to Cart
          </button>
        </div>
      `;
      }).join("");
    }
    /**
     * Render empty state
     */
    renderEmpty(container) {
      container.innerHTML = `
      <div class="py-12 text-center">
        <p class="text-sm text-neutral-500">No recommendations available</p>
      </div>
    `;
    }
    /**
     * Attach add to cart event listeners
     */
    attachAddToCartListeners(container) {
      const buttons = container.querySelectorAll(".add-to-cart");
      buttons.forEach((button) => {
        button.addEventListener("click", (e2) => this.handleAddToCart(e2));
      });
    }
    /**
     * Handle add to cart
     */
    async handleAddToCart(e2) {
      e2.preventDefault();
      const button = e2.currentTarget;
      const variantId = button.dataset.variantId;
      const productCard = button.closest("[data-product-id]");
      try {
        button.disabled = true;
        button.textContent = "Adding...";
        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", 1);
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" }
        });
        if (!response.ok) throw new Error("Failed to add to cart");
        const cart = await this.fetchCart();
        const { updateCartUI: updateCartUI2 } = await Promise.resolve().then(() => (init_c_cart(), c_cart_exports));
        await updateCartUI2(cart);
        if (productCard) {
          productCard.style.transition = "opacity 300ms ease-out";
          productCard.style.opacity = "0";
          setTimeout(() => {
            productCard.remove();
            const remainingProducts = this.container.querySelectorAll("[data-product-id]");
            if (remainingProducts.length === 0) {
              this.updateRelatedProducts(cart);
            }
          }, 300);
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
        button.textContent = "Error";
        setTimeout(() => {
          button.textContent = "Add to Cart";
          button.disabled = false;
        }, 2e3);
      }
    }
  };
  function initCartRelatedProducts() {
    const cartDrawer = document.getElementById("cart-drawer");
    let relatedProducts;
    if (cartDrawer) {
      cartDrawer.addEventListener("toggle", () => {
        if (cartDrawer.open) {
          if (!relatedProducts) {
            relatedProducts = new CartRelatedProducts();
          }
          relatedProducts.init();
        }
      });
    }
    document.addEventListener("cart:updated", async () => {
      if (relatedProducts && cartDrawer?.open) {
        const cart = await relatedProducts.fetchCart();
        relatedProducts.updateRelatedProducts(cart);
      }
    });
  }

  // assets-src/js/_sec_service-categories.js
  function initServiceCategoryCarousel(element) {
    if (element.swiper) {
      element.swiper.destroy(true, true);
    }
    const next = element.querySelector(".service-categories-btn-next");
    const prev = element.querySelector(".service-categories-btn-prev");
    const pagination = element.querySelector(".swiper-pagination-service-categories");
    const serviceCategoryCarousel = new Swiper(element, {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 8,
      breakpoints: {
        1040: {
          slidesPerView: 3,
          spaceBetween: 18
        }
      },
      pagination: {
        el: pagination,
        type: "fraction"
      },
      navigation: {
        nextEl: next,
        prevEl: prev
      }
    });
  }
  var ServiceCategoryTabs = function(element) {
    this.element = element;
    this.controls = this.element.querySelector(".tab-controls");
    this.contents = this.element.querySelector(".tab-contents");
    this.marker = this.element.querySelector(".tab-marker");
    initServiceCategoryTabs2(this);
    function initServiceCategoryTabs2(tabs) {
      tabs.controls.querySelectorAll(".tab-control").forEach(function(control, index) {
        var controlContentId = control.getAttribute("aria-controls");
        var content = tabs.contents.querySelector("#" + controlContentId);
        if (index === 0) {
          control.setAttribute("aria-selected", "true");
          control.setAttribute("tabindex", "0");
          if (content) {
            content.removeAttribute("hidden");
            const swiper = content.querySelector(".swiper");
            initServiceCategoryCarousel(swiper);
          }
          placeTabMarker(tabs, control, false);
        } else {
          control.setAttribute("aria-selected", "false");
          control.setAttribute("tabindex", "-1");
          if (content) {
            content.setAttribute("hidden", "true");
          }
        }
      });
      tabs.controls.addEventListener("click", function(event2) {
        var selectedControl = event2.target.closest(".tab-control");
        var selectedContentId = selectedControl ? selectedControl.getAttribute("aria-controls") : null;
        if (selectedControl && selectedContentId) {
          tabs.controls.querySelectorAll(".tab-control").forEach(function(control) {
            control.setAttribute("aria-selected", "false");
            control.setAttribute("tabindex", "-1");
          });
          tabs.contents.querySelectorAll(".tab-content").forEach(function(content) {
            content.setAttribute("hidden", "true");
          });
          selectedControl.setAttribute("aria-selected", "true");
          selectedControl.setAttribute("tabindex", "0");
          var selectedContent = tabs.contents.querySelector("#" + selectedContentId);
          if (selectedContent) {
            selectedContent.removeAttribute("hidden");
            const swiper = selectedContent.querySelector(".swiper");
            initServiceCategoryCarousel(swiper);
          }
          placeTabMarker(tabs, selectedControl);
        }
        var selectedContent = tabs.contents.querySelector("#" + selectedContentId);
        if (selectedContent) {
          gsap.set(selectedContent, { opacity: 0, x: -20 });
          selectedContent.removeAttribute("hidden");
          gsap.to(selectedContent, {
            opacity: 1,
            x: 0,
            duration: 0.3,
            ease: "power2.out"
          });
        }
      });
      window.addEventListener("resize", function() {
        var activeControl = tabs.controls.querySelector('.tab-control[aria-selected="true"]');
        if (activeControl) {
          placeTabMarker(tabs, activeControl, false);
        }
      });
    }
    function placeTabMarker(tabs, selectedControl, animate = true) {
      if (tabs.marker.length == 0 || !selectedControl) return;
      if (animate) {
        tabs.marker.style.transition = "all 0.3s ease-in-out";
      } else {
        tabs.marker.style.transition = "none";
      }
      tabs.marker.style.width = selectedControl.offsetWidth + "px";
      tabs.marker.style.height = selectedControl.offsetHeight + "px";
      tabs.marker.style.transform = "translateX(" + (selectedControl.getBoundingClientRect().left - tabs.controls.getBoundingClientRect().left) + "px)";
    }
  };
  function initServiceCategoryTabs() {
    const tabsElements = document.querySelectorAll(".service-category-tabs");
    tabsElements.forEach((tabsElement) => {
      new ServiceCategoryTabs(tabsElement);
    });
  }

  // assets-src/js/_sec_gallery-carousel.js
  function initGalleryCarousel() {
    const galleryCarousel = new Swiper(".gallery-carousel .swiper", {
      loop: false,
      slidesPerView: 1,
      slidesOffsetAfter: 0,
      spaceBetween: 16,
      pagination: {
        el: "#swiper-pagination-gallery-carousel",
        type: "fraction"
      },
      // classes added to the 'swiper-prev-next-buttons' render
      navigation: {
        nextEl: ".gallery-carousel-btn-next",
        prevEl: ".gallery-carousel-btn-prev"
      }
    });
  }

  // assets-src/js/_sec_layout-grid-flip.js
  function initGridLayoutFlip() {
    const Flip = window.Flip;
    if (!Flip) {
      console.warn("GSAP Flip plugin not loaded");
      return;
    }
    const groups = document.querySelectorAll("[data-layout-group]");
    const ACTIVE_CLASS = "is--active";
    groups.forEach((group) => {
      let activeTween = null;
      const buttons = group.querySelectorAll("[data-layout-button]");
      const grid = group.querySelector("[data-layout-grid]");
      const collection = group.querySelector("[data-layout-grid-collection]");
      if (!buttons.length || !grid || !collection) {
        console.warn("Missing required HTML elements. Check the Osmo resoure documentation!");
        return;
      }
      buttons.forEach((b) => b.setAttribute("aria-pressed", String(b.classList.contains(ACTIVE_CLASS))));
      buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
          const targetLayout = btn.getAttribute("data-layout-button");
          const currentLayout = group.getAttribute("data-layout-status");
          if (currentLayout === targetLayout) return;
          if (activeTween) {
            activeTween.kill();
            activeTween = null;
          }
          if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            group.setAttribute("data-layout-status", targetLayout);
            buttons.forEach((b) => {
              const isActive = b === btn;
              b.classList.toggle(ACTIVE_CLASS, isActive);
              b.setAttribute("aria-pressed", String(isActive));
            });
            window.ScrollTrigger?.refresh?.();
            if (window.lenis?.resize) window.lenis.resize();
            return;
          }
          const items = grid.querySelectorAll("[data-layout-grid-item]");
          const state = Flip.getState(items, { simple: true });
          collection.getBoundingClientRect();
          const prevH = collection.offsetHeight;
          group.setAttribute("data-layout-status", targetLayout);
          buttons.forEach((b) => {
            const isActive = b === btn;
            b.classList.toggle(ACTIVE_CLASS, isActive);
            b.setAttribute("aria-pressed", String(isActive));
          });
          collection.getBoundingClientRect();
          const nextH = collection.offsetHeight;
          gsap.set(collection, { height: prevH });
          const tl = gsap.timeline({
            onStart: () => {
              group.setAttribute("data-transitioning", "true");
            },
            onInterrupt: () => {
              group.removeAttribute("data-transitioning");
              gsap.set(collection, { clearProps: "height" });
            },
            onComplete: () => {
              group.removeAttribute("data-transitioning");
              gsap.set(collection, { clearProps: "height" });
              window.ScrollTrigger?.refresh?.();
              if (window.lenis?.resize) window.lenis.resize();
              activeTween = null;
            }
          });
          tl.add(
            Flip.from(state, {
              duration: 0.65,
              ease: "power4.inOut",
              absolute: true,
              nested: true,
              prune: true,
              stagger: targetLayout === "large" ? { each: 0.03, from: "end" } : { each: 0.03, from: "start" }
            }),
            0
          ).to(
            collection,
            {
              height: nextH,
              duration: 0.65,
              ease: "power4.inOut"
            },
            0
          );
          activeTween = tl;
        });
      });
    });
  }

  // assets-src/js/_sec_hero-tabs.js
  function initHeroTabs() {
    const tabButtons = document.querySelectorAll("[data-tab-link]");
    const tabContents = document.querySelectorAll("[data-tab-content]");
    if (tabButtons.length === 0 || tabContents.length === 0) return;
    function switchTab(targetId) {
      tabButtons.forEach((btn) => {
        if (btn.getAttribute("data-tab-link") === targetId) {
          btn.setAttribute("data-current", "true");
        } else {
          btn.removeAttribute("data-current");
        }
      });
      tabContents.forEach((content) => {
        const contentId = content.getAttribute("id");
        if (contentId === targetId) {
          content.classList.add("active");
          setTimeout(() => {
            content.classList.add("show-children");
          }, 50);
        } else {
          content.classList.remove("active", "show-children");
        }
      });
    }
    const firstTab = tabButtons[0];
    if (firstTab) {
      const firstTargetId = firstTab.getAttribute("data-tab-link");
      switchTab(firstTargetId);
    }
    tabButtons.forEach((button) => {
      button.addEventListener("click", (e2) => {
        e2.preventDefault();
        const targetId = button.getAttribute("data-tab-link");
        switchTab(targetId);
      });
    });
  }

  // assets-src/js/_sec_highlight-text-hero.js
  function initHighlightText() {
    let splitHeadingTargets = document.querySelectorAll("[data-highlight-text]");
    if (splitHeadingTargets.length === 0) return;
    splitHeadingTargets.forEach((heading) => {
      const scrollStart = heading.getAttribute("data-highlight-scroll-start") || "top 90%";
      const scrollEnd = heading.getAttribute("data-highlight-scroll-end") || "center 40%";
      const fadedValue = heading.getAttribute("data-highlight-fade") || 0.2;
      const staggerValue = heading.getAttribute("data-highlight-stagger") || 0.1;
      new SplitText(heading, {
        type: "words, chars",
        autoSplit: true,
        onSplit(self2) {
          gsap.set(self2.chars, { autoAlpha: fadedValue });
          let ctx = gsap.context(() => {
            let tl = gsap.timeline({
              scrollTrigger: {
                scrub: true,
                trigger: heading,
                start: scrollStart,
                end: scrollEnd,
                invalidateOnRefresh: true
              }
            });
            tl.to(self2.chars, {
              autoAlpha: 1,
              stagger: staggerValue,
              ease: "linear"
            });
          });
          return ctx;
        }
      });
    });
  }

  // assets-src/js/input.js
  init_c_lucide_icons();

  // assets-src/js/_sec_marquee-w-scroll-direction.js
  function initMarqueeScrollDirection() {
    document.querySelectorAll("[data-marquee-scroll-direction-target]").forEach((marquee) => {
      const marqueeContent = marquee.querySelector("[data-marquee-collection-target]");
      const marqueeScroll = marquee.querySelector("[data-marquee-scroll-target]");
      if (!marqueeContent || !marqueeScroll) return;
      const {
        marqueeSpeed: speed,
        marqueeDirection: direction,
        marqueeDuplicate: duplicate,
        marqueeScrollSpeed: scrollSpeed
      } = marquee.dataset;
      const marqueeSpeedAttr = parseFloat(speed);
      const marqueeDirectionAttr = direction === "right" ? 1 : -1;
      const duplicateAmount = parseInt(duplicate || 0);
      const scrollSpeedAttr = parseFloat(scrollSpeed);
      const speedMultiplier = window.innerWidth < 479 ? 0.25 : window.innerWidth < 991 ? 0.5 : 1;
      let marqueeSpeed = marqueeSpeedAttr * (marqueeContent.offsetWidth / window.innerWidth) * speedMultiplier;
      marqueeScroll.style.marginLeft = `${scrollSpeedAttr * -1}%`;
      marqueeScroll.style.width = `${scrollSpeedAttr * 2 + 100}%`;
      if (duplicateAmount > 0) {
        const fragment = document.createDocumentFragment();
        for (let i2 = 0; i2 < duplicateAmount; i2++) {
          fragment.appendChild(marqueeContent.cloneNode(true));
        }
        marqueeScroll.appendChild(fragment);
      }
      const marqueeItems = marquee.querySelectorAll("[data-marquee-collection-target]");
      const animation = gsap.to(marqueeItems, {
        xPercent: -100,
        // Move completely out of view
        repeat: -1,
        duration: marqueeSpeed,
        ease: "linear"
      }).totalProgress(0.5);
      gsap.set(marqueeItems, { xPercent: marqueeDirectionAttr === 1 ? 100 : -100 });
      animation.timeScale(marqueeDirectionAttr);
      animation.play();
      marquee.setAttribute("data-marquee-status", "normal");
      ScrollTrigger.create({
        trigger: marquee,
        start: "top bottom",
        end: "bottom top",
        invalidateOnRefresh: true,
        onUpdate: (self2) => {
          const isInverted = self2.direction === 1;
          const currentDirection = isInverted ? -marqueeDirectionAttr : marqueeDirectionAttr;
          animation.timeScale(currentDirection);
          marquee.setAttribute("data-marquee-status", isInverted ? "normal" : "inverted");
        }
      });
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: marquee,
          start: "0% 100%",
          end: "100% 0%",
          scrub: 0.5,
          invalidateOnRefresh: true
        }
      });
      const scrollStart = marqueeDirectionAttr === -1 ? scrollSpeedAttr : -scrollSpeedAttr;
      const scrollEnd = -scrollStart;
      tl.fromTo(marqueeScroll, { x: `${scrollStart}vw` }, { x: `${scrollEnd}vw`, ease: "none" });
    });
  }

  // assets-src/js/_c_text-animation.js
  function initMaskedTextReveal() {
    document.fonts.ready.then(function() {
      let headings = document.querySelectorAll('[data-split="heading"]');
      headings.forEach((heading) => {
        gsap.set(heading, { autoAlpha: 1 });
        SplitText.create(heading, {
          type: "lines",
          autoSplit: true,
          mask: "lines",
          onSplit(instance) {
            return gsap.from(instance.lines, {
              duration: 0.8,
              yPercent: 125,
              stagger: 0.1,
              ease: "expo.out",
              onComplete: () => {
                heading.dataset.splitRevealed = "true";
              },
              scrollTrigger: {
                trigger: heading,
                start: "top 80%",
                once: true
              }
            });
          }
        });
      });
    });
  }
  function forceRevealHeadings(container = document) {
    container.querySelectorAll('[data-split="heading"]:not([data-split-revealed])').forEach((heading) => {
      gsap.killTweensOf(heading);
      heading.querySelectorAll("*").forEach((child) => gsap.killTweensOf(child));
      gsap.set(heading, { autoAlpha: 1 });
      heading.querySelectorAll("*").forEach((child) => gsap.set(child, { yPercent: 0 }));
      heading.dataset.splitRevealed = "true";
    });
  }

  // assets-src/js/_c_animation--gsap--parallax-image.js
  function initParallaxImg() {
    const plaxImages = document.querySelectorAll(".plax-img");
    if (plaxImages.length === 0) return;
    plaxImages.forEach((img) => {
      const trigger = img.closest(".relative");
      if (!trigger) return;
      gsap.fromTo(
        img,
        {
          yPercent: -20
        },
        {
          yPercent: 0,
          ease: "none",
          scrollTrigger: {
            trigger,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        }
      );
    });
  }

  // assets-src/js/_sec_nav-bar.js
  function initNavBar() {
    const navbar = document.querySelector("[data-navbar-sticky]");
    if (navbar) {
      const header = document.querySelector(".header-section");
      const headerNavBar = navbar.cloneNode(true);
      header.appendChild(headerNavBar);
      headerNavBar.setAttribute("hidden", "true");
      headerNavBar.classList.add("fixed", "top-[72px]", "md:top-[72px]", "left-0", "right-0", "z-50");
      headerNavBar.removeAttribute("data-navbar-sticky");
      const HEADER_OFFSET = 72;
      if (navbar) {
        let handleScroll = function() {
          if (navbarTop === null) {
            navbarTop = navbar.offsetTop;
          }
          if (window.pageYOffset >= navbarTop - HEADER_OFFSET) {
            headerNavBar.removeAttribute("hidden");
          } else {
            headerNavBar.setAttribute("hidden", "true");
          }
        };
        let navbarTop = null;
        window.addEventListener("scroll", handleScroll);
        handleScroll();
      }
      document.querySelectorAll(".sub-nav-mobile").forEach((dropdown) => {
        const button = dropdown.querySelector("button");
        const buttonText = button.querySelector(".button-text");
        dropdown.querySelectorAll("[role=menuitem]").forEach((option) => {
          option.addEventListener("click", (event2) => {
            var text = option.innerHTML;
            if (buttonText) buttonText.innerHTML = text;
            const singleAccordion = option.closest("[data-accordion-status]");
            if (!singleAccordion) return;
            const isActive = singleAccordion.getAttribute("data-accordion-status") === "active";
            singleAccordion.setAttribute("data-accordion-status", isActive ? "not-active" : "active");
          });
          const href = option.getAttribute("href");
          if (href && href.startsWith("#")) {
            const targetElement = document.querySelector(href);
            if (targetElement) {
              window.addEventListener("scroll", () => {
                const rect = targetElement.getBoundingClientRect();
                if (rect.top <= 0) {
                  var text = option.innerHTML;
                  if (buttonText) buttonText.innerHTML = text;
                }
              });
            }
          }
        });
      });
    }
  }

  // assets-src/js/_sec_multilevel-navigation.js
  function initNavigation() {
    if (!initNavigation._hasResizeListener) {
      initNavigation._hasResizeListener = true;
      window.addEventListener("resize", debounce(initNavigation, 200));
    }
    const isMobile = window.innerWidth < 768;
    if (isMobile && initNavigation._lastMode === "desktop") {
      clearDesktopMode();
    } else if (!isMobile && initNavigation._lastMode === "mobile") {
      clearMobileMode();
    }
    if (isMobile && initNavigation._lastMode !== "mobile") {
      initMobileMenu();
      initNavigation._lastMode = "mobile";
    } else if (!isMobile && initNavigation._lastMode !== "desktop") {
      initDesktopDropdowns();
      initNavigation._lastMode = "desktop";
    }
  }
  function clearMobileMode() {
    Array.from(document.querySelectorAll("[data-dropdown-toggle]")).forEach((toggle) => {
      delete toggle._mobileDropdownInit;
      delete toggle._mobileClick;
    });
    const btn = document.querySelector("[data-menu-button]");
    if (btn) delete btn._mobileClick;
  }
  function clearDesktopMode() {
    Array.from(document.querySelectorAll("[data-dropdown-toggle]")).forEach((toggle) => {
      delete toggle._desktopInit;
    });
  }
  function debounce(fn2, delay) {
    let timer;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(fn2, delay);
    };
  }
  function initMobileMenu() {
    const btn = document.querySelector("[data-menu-button]");
    const nav = document.querySelector("[data-menu-status]");
    if (!btn || !nav) return;
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-controls", "mobile-navigation");
    nav.setAttribute("id", "mobile-navigation");
    nav.setAttribute("role", "navigation");
    nav.setAttribute("aria-label", "Main navigation");
    if (!btn._mobileClick) {
      btn._mobileClick = true;
      btn.addEventListener("click", () => {
        const open = nav.dataset.menuStatus === "open";
        nav.dataset.menuStatus = open ? "closed" : "open";
        btn.setAttribute("aria-expanded", !open);
        if (open) {
          Array.from(document.querySelectorAll("[data-dropdown-toggle]")).forEach((toggle) => {
            toggle.dataset.dropdownToggle = "closed";
            toggle.setAttribute("aria-expanded", "false");
          });
        }
      });
    }
    Array.from(document.querySelectorAll("[data-dropdown-toggle]")).forEach((toggle, i2) => {
      const dd = toggle.nextElementSibling;
      if (!dd || !dd.classList.contains("nav-dropdown")) return;
      if (toggle._mobileDropdownInit) return;
      toggle._mobileDropdownInit = true;
      toggle.dataset.dropdownToggle = "closed";
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-haspopup", "true");
      toggle.setAttribute("aria-controls", `dropdown-${i2}`);
      dd.setAttribute("id", `dropdown-${i2}`);
      dd.setAttribute("role", "menu");
      dd.querySelectorAll(".nav-dropdown__link").forEach((link) => link.setAttribute("role", "menuitem"));
      toggle.addEventListener("click", () => {
        const open = toggle.dataset.dropdownToggle === "open";
        Array.from(document.querySelectorAll("[data-dropdown-toggle]")).forEach((other) => {
          if (other !== toggle) {
            other.dataset.dropdownToggle = "closed";
            other.setAttribute("aria-expanded", "false");
            if (other === document.activeElement) other.blur();
          }
        });
        toggle.dataset.dropdownToggle = open ? "closed" : "open";
        toggle.setAttribute("aria-expanded", !open);
        if (open && toggle === document.activeElement) toggle.blur();
      });
    });
  }
  function initDesktopDropdowns() {
    const nav = document.querySelector("[data-menu-status]");
    const toggles = Array.from(document.querySelectorAll("[data-dropdown-toggle]"));
    const links = Array.from(document.querySelectorAll(".nav-link:not([data-dropdown-toggle])"));
    toggles.forEach((toggle, i2) => {
      const dd = toggle.nextElementSibling;
      if (!dd || !dd.classList.contains("nav-dropdown") || toggle._desktopInit) return;
      toggle._desktopInit = true;
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-haspopup", "true");
      toggle.setAttribute("aria-controls", `desktop-dropdown-${i2}`);
      dd.setAttribute("id", `desktop-dropdown-${i2}`);
      dd.setAttribute("role", "menu");
      dd.setAttribute("aria-hidden", "true");
      dd.querySelectorAll(".nav-dropdown__link").forEach((link) => link.setAttribute("role", "menuitem"));
      toggle.addEventListener("click", (e2) => {
        e2.preventDefault();
        e2.stopPropagation();
        toggle.blur();
      });
      toggle.addEventListener("mouseenter", () => {
        const anyOpen = toggles.some((x) => x.dataset.dropdownToggle === "open");
        toggles.forEach((other) => {
          if (other !== toggle) {
            other.dataset.dropdownToggle = "closed";
            other.setAttribute("aria-expanded", "false");
            const otherDropdown = other.nextElementSibling;
            if (otherDropdown) otherDropdown.setAttribute("aria-hidden", "true");
          }
        });
        if (anyOpen) {
          setTimeout(() => {
            toggle.dataset.dropdownToggle = "open";
            toggle.setAttribute("aria-expanded", "true");
            dd.setAttribute("aria-hidden", "false");
          }, 20);
        } else {
          toggle.dataset.dropdownToggle = "open";
          toggle.setAttribute("aria-expanded", "true");
          dd.setAttribute("aria-hidden", "false");
        }
      });
      dd.addEventListener("mouseleave", () => {
        toggle.dataset.dropdownToggle = "closed";
        toggle.setAttribute("aria-expanded", "false");
        dd.setAttribute("aria-hidden", "true");
      });
      toggle.addEventListener("keydown", (e2) => {
        if (e2.key === "Enter" || e2.key === " ") {
          e2.preventDefault();
          toggle.click();
        } else if (e2.key === "Escape") {
          toggle.dataset.dropdownToggle = "closed";
          toggle.setAttribute("aria-expanded", "false");
          dd.setAttribute("aria-hidden", "true");
          toggle.focus();
        }
      });
      dd.addEventListener("keydown", (e2) => {
        const items = Array.from(dd.querySelectorAll(".nav-dropdown__link"));
        const idx = items.indexOf(document.activeElement);
        if (e2.key === "ArrowDown") {
          e2.preventDefault();
          items[(idx + 1) % items.length].focus();
        } else if (e2.key === "ArrowUp") {
          e2.preventDefault();
          items[(idx - 1 + items.length) % items.length].focus();
        } else if (e2.key === "Escape") {
          e2.preventDefault();
          toggle.dataset.dropdownToggle = "closed";
          toggle.setAttribute("aria-expanded", "false");
          dd.setAttribute("aria-hidden", "true");
          toggle.focus();
        } else if (e2.key === "Tab" && !dd.contains(e2.relatedTarget)) {
          toggle.dataset.dropdownToggle = "closed";
          toggle.setAttribute("aria-expanded", "false");
          dd.setAttribute("aria-hidden", "true");
        }
      });
    });
    links.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        toggles.forEach((toggle) => {
          toggle.dataset.dropdownToggle = "closed";
          toggle.setAttribute("aria-expanded", "false");
          const dd = toggle.nextElementSibling;
          if (dd) dd.setAttribute("aria-hidden", "true");
        });
      });
    });
    document.addEventListener("click", (e2) => {
      const inside = toggles.some((toggle) => {
        const dd = toggle.nextElementSibling;
        return toggle.contains(e2.target) || dd && dd.contains(e2.target);
      });
      if (!inside) {
        toggles.forEach((toggle) => {
          toggle.dataset.dropdownToggle = "closed";
          toggle.setAttribute("aria-expanded", "false");
          const dd = toggle.nextElementSibling;
          if (dd) dd.setAttribute("aria-hidden", "true");
        });
      }
    });
  }

  // assets-src/js/_sec_parallax-gallery.js
  function initSlideShow(el) {
    const gsap2 = window.gsap;
    if (!gsap2) {
      console.warn("GSAP not loaded");
      return;
    }
    const Observer2 = window.Observer2;
    const CustomEase = window.CustomEase;
    if (!Observer2 || !CustomEase) {
      console.warn("GSAP Observer or CustomEase not loaded");
      return;
    }
    gsap2.registerPlugin(Observer2, CustomEase);
    CustomEase.create("slideshow-wipe", "0.6, 0.08, 0.02, 0.99");
    const ui = {
      el,
      slides: Array.from(el.querySelectorAll('[data-slideshow="slide"]')),
      inner: Array.from(el.querySelectorAll('[data-slideshow="parallax"]')),
      thumbs: Array.from(el.querySelectorAll('[data-slideshow="thumb"]'))
    };
    let current = 0;
    const length = ui.slides.length;
    let animating = false;
    let observer;
    let animationDuration = 0.9;
    ui.slides.forEach((slide2, index) => {
      slide2.setAttribute("data-index", index);
    });
    ui.thumbs.forEach((thumb, index) => {
      thumb.setAttribute("data-index", index);
    });
    ui.slides[current].classList.add("is--current");
    ui.thumbs[current].classList.add("is--current");
    function navigate(direction, targetIndex = null) {
      if (animating) return;
      animating = true;
      observer.disable();
      const previous = current;
      current = targetIndex !== null && targetIndex !== void 0 ? targetIndex : direction === 1 ? current < length - 1 ? current + 1 : 0 : current > 0 ? current - 1 : length - 1;
      const currentSlide = ui.slides[previous];
      const currentInner = ui.inner[previous];
      const upcomingSlide = ui.slides[current];
      const upcomingInner = ui.inner[current];
      gsap2.timeline({
        defaults: {
          duration: animationDuration,
          ease: "slideshow-wipe"
        },
        onStart: function() {
          upcomingSlide.classList.add("is--current");
          ui.thumbs[previous].classList.remove("is--current");
          ui.thumbs[current].classList.add("is--current");
        },
        onComplete: function() {
          currentSlide.classList.remove("is--current");
          animating = false;
          setTimeout(() => observer.enable(), animationDuration);
        }
      }).to(currentSlide, { xPercent: -direction * 100 }, 0).to(currentInner, { xPercent: direction * 50 }, 0).fromTo(upcomingSlide, { xPercent: direction * 100 }, { xPercent: 0 }, 0).fromTo(upcomingInner, { xPercent: -direction * 50 }, { xPercent: 0 }, 0);
    }
    function onClick2(event2) {
      const targetIndex = parseInt(event2.currentTarget.getAttribute("data-index"), 10);
      if (targetIndex === current || animating) return;
      const direction = targetIndex > current ? 1 : -1;
      navigate(direction, targetIndex);
    }
    ui.thumbs.forEach((thumb) => {
      thumb.addEventListener("click", onClick2);
    });
    observer = Observer2.create({
      target: el,
      type: "wheel,touch,pointer",
      // Drag events to go left/right
      onLeft: () => {
        if (!animating) navigate(1);
      },
      onRight: () => {
        if (!animating) navigate(-1);
      },
      // For wheel events, check horizontal movement
      onWheel: (event2) => {
        if (animating) return;
        if (Math.abs(event2.deltaX) > Math.abs(event2.deltaY)) {
          if (event2.deltaX > 50) {
            navigate(1);
          } else if (event2.deltaX < -50) {
            navigate(-1);
          }
        }
      },
      wheelSpeed: -1,
      tolerance: 10
    });
    return {
      destroy: function() {
        if (observer) observer.kill();
        ui.thumbs.forEach((thumb) => {
          thumb.removeEventListener("click", onClick2);
        });
      }
    };
  }
  function initParallaxImageGalleryThumbnails() {
    let wrappers = document.querySelectorAll('[data-slideshow="wrap"]');
    wrappers.forEach((wrap) => initSlideShow(wrap));
  }

  // assets-src/js/_p_location-filter.js
  function initLocationFilter(group_name) {
    const groups = [...document.querySelectorAll(`[data-filter-group=${group_name}]`)];
    if (groups.length === 0) return;
    const transitionDelay = 300;
    groups.forEach((group) => {
      const buttons = [...group.querySelectorAll("[data-filter-target]")];
      const items = [...group.querySelectorAll("[data-filter-name]")];
      items.forEach((item) => {
        const cs = item.querySelectorAll("[data-filter-name-collect]");
        if (!cs.length) return;
        const seen = /* @__PURE__ */ new Set(), out = [];
        cs.forEach((c) => {
          const v = (c.getAttribute("data-filter-name-collect") || "").trim().toLowerCase();
          if (v && !seen.has(v)) {
            seen.add(v);
            out.push(v);
          }
        });
        if (out.length) item.setAttribute("data-filter-name", out.join(" "));
      });
      const itemTokens = /* @__PURE__ */ new Map();
      items.forEach((el) => {
        const tokens = (el.getAttribute("data-filter-name") || "").trim().toLowerCase().split(/\s+/).filter(Boolean);
        itemTokens.set(el, new Set(tokens));
      });
      buttons.forEach((btn) => {
        const target = (btn.getAttribute("data-filter-target") || "").trim().toLowerCase();
        const hasMatch = target === "all" || [...itemTokens.values()].some((tokens) => tokens.has(target));
        btn.style.display = hasMatch ? "" : "none";
      });
      const setItemState = (el, on2) => {
        const next = on2 ? "active" : "not-active";
        if (el.getAttribute("data-filter-status") !== next) {
          el.setAttribute("data-filter-status", next);
          el.setAttribute("aria-hidden", on2 ? "false" : "true");
        }
      };
      const setButtonState = (btn, on2) => {
        const next = on2 ? "active" : "not-active";
        if (btn.getAttribute("data-filter-status") !== next) {
          btn.setAttribute("data-filter-status", next);
          btn.setAttribute("aria-pressed", on2 ? "true" : "false");
        }
      };
      let activeTarget = null;
      const itemMatches = (el) => {
        if (!activeTarget || activeTarget === "all") return true;
        return itemTokens.get(el).has(activeTarget);
      };
      const paint = (rawTarget) => {
        const target = (rawTarget || "").trim().toLowerCase();
        activeTarget = !target || target === "all" ? "all" : target;
        items.forEach((el) => {
          if (el._ft) clearTimeout(el._ft);
          const next = itemMatches(el);
          const cur = el.getAttribute("data-filter-status");
          if (cur === "active" && transitionDelay > 0) {
            el.setAttribute("data-filter-status", "transition-out");
            el._ft = setTimeout(() => {
              setItemState(el, next);
              el._ft = null;
            }, transitionDelay);
          } else if (transitionDelay > 0) {
            el._ft = setTimeout(() => {
              setItemState(el, next);
              el._ft = null;
            }, transitionDelay);
          } else {
            setItemState(el, next);
          }
        });
        buttons.forEach((btn) => {
          const t2 = (btn.getAttribute("data-filter-target") || "").trim().toLowerCase();
          setButtonState(btn, activeTarget === "all" && t2 === "all" || t2 && t2 === activeTarget);
        });
      };
      const visibleButtons = buttons.filter((b) => b.style.display !== "none");
      const initialBtn = visibleButtons.find((b) => b.getAttribute("data-filter-status") === "active") || visibleButtons[0];
      if (initialBtn) {
        const target = (initialBtn.getAttribute("data-filter-target") || "").trim().toLowerCase();
        activeTarget = !target || target === "all" ? "all" : target;
        items.forEach((el) => setItemState(el, itemMatches(el)));
        buttons.forEach((btn) => {
          const t2 = (btn.getAttribute("data-filter-target") || "").trim().toLowerCase();
          setButtonState(btn, activeTarget === "all" && t2 === "all" || t2 && t2 === activeTarget);
        });
      }
      group.addEventListener("click", (e2) => {
        const btn = e2.target.closest("[data-filter-target]");
        if (btn && group.contains(btn)) paint(btn.getAttribute("data-filter-target"));
      });
    });
  }

  // assets-src/js/_c_lenis-smooth-scroll.js
  function initScrollToAnchorLenis() {
    document.querySelectorAll("[data-anchor-target]").forEach((element) => {
      element.addEventListener("click", function() {
        const targetScrollToAnchorLenis = this.getAttribute("data-anchor-target");
        window.lenis.scrollTo(targetScrollToAnchorLenis, {
          easing: (x) => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
          duration: 1.2,
          offset: -80
        });
      });
    });
    document.querySelectorAll("[data-anchor-select]").forEach((select) => {
      select.addEventListener("change", function() {
        const targetScrollToAnchorLenis = this.value;
        window.lenis.scrollTo(targetScrollToAnchorLenis, {
          easing: (x) => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
          duration: 1.2,
          offset: -160
          // Negative offset to account for 72px fixed header
        });
      });
    });
  }

  // assets-src/js/_c_search.js
  init_c_lucide_icons();
  var searchTimeout;
  var DEBOUNCE_DELAY = 300;
  function initSearch() {
    const searchDialog = document.getElementById("search-dialog");
    const searchInput = document.getElementById("search-input");
    const searchForm = searchDialog?.querySelector("form");
    if (!searchDialog || !searchInput || !searchForm) return;
    searchForm.addEventListener("submit", (e2) => {
      const query = searchInput.value.trim();
      if (!query) {
        e2.preventDefault();
        return;
      }
      searchDialog.close();
    });
    searchDialog.addEventListener("toggle", () => {
      if (searchDialog.open) {
        setTimeout(() => searchInput.focus(), 100);
      } else {
        searchInput.value = "";
        showEmptyState();
      }
    });
    searchInput.addEventListener("input", (e2) => {
      const query = e2.target.value.trim();
      clearTimeout(searchTimeout);
      if (query.length < 2) {
        showEmptyState();
        return;
      }
      searchTimeout = setTimeout(() => {
        performSearch(query);
      }, DEBOUNCE_DELAY);
    });
    searchInput.addEventListener("keydown", (e2) => {
      if (e2.key === "Escape") {
        searchDialog.close();
      }
    });
  }
  async function performSearch(query) {
    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=5`
      );
      const data = await response.json();
      renderResults(data.resources.results, query);
    } catch (error) {
      console.error("Search error:", error);
      showNoResults();
    }
  }
  function renderResults(results, query) {
    const productsContainer = document.getElementById("search-results-products");
    const collectionsContainer = document.getElementById("search-results-collections");
    const pagesContainer = document.getElementById("search-results-pages");
    const emptyState = document.getElementById("search-empty-state");
    const noResults = document.getElementById("search-no-results");
    const footer = document.getElementById("search-footer");
    emptyState.classList.add("hidden");
    noResults.classList.add("hidden");
    const hasProducts = results.products && results.products.length > 0;
    const hasCollections = results.collections && results.collections.length > 0;
    const hasPages = results.pages && results.pages.length > 0;
    if (!hasProducts && !hasCollections && !hasPages) {
      showNoResults();
      return;
    }
    if (hasProducts) {
      productsContainer.innerHTML = `
      <h3 class="mb-2 px-3 text-sm font-semibold uppercase tracking-wide text-neutral-500">Products</h3>
      <ul class="space-y-1">
        ${results.products.map(
        (product) => `
          <li>
            <a href="${product.url}" class="group flex items-center gap-3 rounded-lg px-3 py-2 hover:bg-neutral-50">
              ${product.image ? `<img src="${product.image}" alt="${product.title}" class="size-10 shrink-0 rounded object-cover" />` : '<div class="size-10 shrink-0 rounded bg-neutral-100"></div>'}
              <div class="min-w-0 flex-1">
                <p class="truncate text-sm font-medium text-neutral-900">${product.title}</p>
                <p class="text-xs text-neutral-500">${formatMoney(product.price)}</p>
              </div>
            </a>
          </li>
        `
      ).join("")}
      </ul>
    `;
      productsContainer.classList.remove("hidden");
    } else {
      productsContainer.classList.add("hidden");
    }
    if (hasCollections) {
      collectionsContainer.innerHTML = `
      <h3 class="mb-2 mt-4 px-3 text-xs font-semibold uppercase tracking-wide text-neutral-500">Collections</h3>
      <ul class="space-y-1">
        ${results.collections.map(
        (collection) => `
          <li>
            <a href="${collection.url}" class="group flex items-center gap-3 rounded-lg px-3 py-2 hover:bg-neutral-50">
              ${collection.image ? `<img src="${collection.image}" alt="${collection.title}" class="size-10 shrink-0 rounded object-cover" />` : '<div class="size-10 shrink-0 rounded bg-neutral-100"></div>'}
              <div class="min-w-0 flex-1">
                <p class="truncate text-sm font-medium text-neutral-900">${collection.title}</p>
              </div>
              <i class="size-4 text-neutral-400" data-lucide="arrow-right"></i>
            </a>
          </li>
        `
      ).join("")}
      </ul>
    `;
      collectionsContainer.classList.remove("hidden");
    } else {
      collectionsContainer.classList.add("hidden");
    }
    if (hasPages) {
      pagesContainer.innerHTML = `
      <h3 class="mb-2 mt-4 px-3 text-xs font-semibold uppercase tracking-wide text-neutral-500">Pages</h3>
      <ul class="space-y-1">
        ${results.pages.map(
        (page) => `
          <li>
            <a href="${page.url}" class="group flex items-center gap-3 rounded-lg px-3 py-2 hover:bg-neutral-50">
              <div class="flex size-10 shrink-0 items-center justify-center rounded bg-emerald-100">
                <i class="size-5 text-emerald-600" data-lucide="file-text"></i>
              </div>
              <div class="min-w-0 flex-1">
                <p class="truncate text-sm font-medium text-neutral-900">${page.title}</p>
              </div>
              <i class="size-4 text-neutral-400" data-lucide="arrow-right"></i>
            </a>
          </li>
        `
      ).join("")}
      </ul>
    `;
      pagesContainer.classList.remove("hidden");
    } else {
      pagesContainer.classList.add("hidden");
    }
    footer.classList.remove("hidden");
    initLucide();
  }
  function showEmptyState() {
    document.getElementById("search-empty-state").classList.remove("hidden");
    document.getElementById("search-no-results").classList.add("hidden");
    document.getElementById("search-results-products").classList.add("hidden");
    document.getElementById("search-results-collections").classList.add("hidden");
    document.getElementById("search-results-pages").classList.add("hidden");
    document.getElementById("search-footer").classList.add("hidden");
  }
  function showNoResults() {
    document.getElementById("search-empty-state").classList.add("hidden");
    document.getElementById("search-no-results").classList.remove("hidden");
    document.getElementById("search-results-products").classList.add("hidden");
    document.getElementById("search-results-collections").classList.add("hidden");
    document.getElementById("search-results-pages").classList.add("hidden");
    document.getElementById("search-footer").classList.add("hidden");
    initLucide();
  }
  function formatMoney(cents) {
    return (cents / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD"
    });
  }

  // assets-src/js/_c_cart-spend-x-get-y.js
  init_c_cart();
  init_c_lucide_icons();
  var spendXGetYConfigs = [];
  var isProcessing2 = false;
  function isPromotionActive2(startDate, endDate) {
    if (!startDate && !endDate) return true;
    const now2 = /* @__PURE__ */ new Date();
    const estTime = new Date(now2.toLocaleString("en-US", { timeZone: "America/New_York" }));
    if (startDate) {
      const start = /* @__PURE__ */ new Date(startDate + " EST");
      if (estTime < start) return false;
    }
    if (endDate) {
      const end = /* @__PURE__ */ new Date(endDate + " EST");
      if (estTime > end) return false;
    }
    return true;
  }
  function loadSpendXGetYConfigs() {
    const configElements = document.querySelectorAll(".spend-x-get-y-config");
    const configs = [];
    configElements.forEach((element, index) => {
      if (element.dataset.spendXGetYEnabled === "true") {
        const giftVariants = element.dataset.giftVariants;
        if (!giftVariants || giftVariants.trim() === "") {
          console.warn(`Spend X Get Y promotion ${index} is enabled but has no gift products configured!`);
          return;
        }
        const startDate = element.dataset.discountStart || "";
        const endDate = element.dataset.discountEnd || "";
        const isActive = isPromotionActive2(startDate, endDate);
        if (isActive) {
          configs.push({
            id: `spend-x-get-y-${index}`,
            enabled: true,
            discountCode: element.dataset.discountCode || "",
            startDate,
            endDate,
            spendThreshold: parseInt(element.dataset.spendThreshold, 10) || 0,
            giftVariants: element.dataset.giftVariants.split(",").map((id) => parseInt(id, 10)),
            getQuantity: parseInt(element.dataset.getQuantity, 10) || 1,
            maxGifts: parseInt(element.dataset.maxGifts, 10) || 999,
            autoOpenCart: element.dataset.autoOpenCart === "true",
            showNotification: element.dataset.showNotification === "true",
            notificationMessage: element.dataset.notificationMessage || "Free gift added to your cart!"
          });
        }
      }
    });
    return configs;
  }
  function getCartSubtotal(cartData) {
    let subtotal = 0;
    cartData.items?.forEach((item) => {
      if (item.properties?._spend_x_get_y_gift === "true" || item.properties?._bxgy_gift === "true") {
        return;
      }
      subtotal += item.final_line_price;
    });
    return subtotal;
  }
  function getGiftQuantity2(cartData, config) {
    let totalQty = 0;
    cartData.items?.forEach((item) => {
      if (item.properties?._spend_x_get_y_gift !== "true" || item.properties?._spend_x_promo_id !== config.id) {
        return;
      }
      if (config.giftVariants.includes(item.variant_id)) {
        totalQty += item.quantity;
      }
    });
    return totalQty;
  }
  function calculateRequiredGifts2(cartSubtotal, config) {
    if (cartSubtotal < config.spendThreshold) {
      return 0;
    }
    return Math.min(config.getQuantity, config.maxGifts);
  }
  async function addGiftToCart2(variantId, quantity, promoId) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity,
              properties: {
                _spend_x_get_y_gift: "true",
                _spend_x_promo_id: promoId
              }
            }
          ]
        })
      });
      if (!response.ok) {
        throw new Error("Failed to add gift to cart");
      }
      return await response.json();
    } catch (error) {
      console.error("Error adding gift to cart:", error);
      throw error;
    }
  }
  async function updateGiftQuantity2(giftItem, newQuantity) {
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: newQuantity
        })
      });
      if (!response.ok) {
        throw new Error("Failed to update gift quantity");
      }
      return await response.json();
    } catch (error) {
      console.error("Error updating gift quantity:", error);
      throw error;
    }
  }
  function showGiftNotification2(config) {
    if (!config?.showNotification) return;
    const cartPanel = document.querySelector("el-dialog-panel");
    if (!cartPanel) return;
    const notification = document.createElement("div");
    notification.className = "absolute top-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 rounded-lg bg-emerald-600 px-5 py-2.5 text-white shadow-lg transition-all duration-300 ease-in-out max-w-xl";
    notification.style.transform = "translateY(-100px)";
    notification.style.opacity = "0";
    notification.innerHTML = `
    <i class="size-5 shrink-0" data-lucide="gift"></i>
    <span class="font-medium">${config.notificationMessage}</span>
  `;
    cartPanel.appendChild(notification);
    initLucide();
    requestAnimationFrame(() => {
      notification.style.transform = "translateY(0) translateX(-50%)";
      notification.style.opacity = "1";
    });
    setTimeout(() => {
      notification.style.opacity = "0";
      notification.style.transform = "translateY(-100px) translateX(-50%)";
      setTimeout(() => notification.remove(), 300);
    }, 5e3);
  }
  async function processPromotion2(cartData, config) {
    const cartSubtotal = getCartSubtotal(cartData);
    const currentGiftQty = getGiftQuantity2(cartData, config);
    const requiredGiftQty = calculateRequiredGifts2(cartSubtotal, config);
    if (currentGiftQty === requiredGiftQty) {
      return { changed: false, added: false };
    }
    const giftItem = cartData.items?.find(
      (item) => item.properties?._spend_x_get_y_gift === "true" && item.properties?._spend_x_promo_id === config.id && config.giftVariants.includes(item.variant_id)
    );
    let giftAdded = false;
    let cartChanged = false;
    if (requiredGiftQty === 0) {
      if (giftItem) {
        await updateGiftQuantity2(giftItem, 0);
        cartChanged = true;
      }
    } else if (giftItem) {
      await updateGiftQuantity2(giftItem, requiredGiftQty);
      cartChanged = true;
      if (requiredGiftQty > currentGiftQty) {
        giftAdded = true;
      }
    } else {
      const giftVariantId = config.giftVariants[0];
      await addGiftToCart2(giftVariantId, requiredGiftQty, config.id);
      cartChanged = true;
      giftAdded = true;
    }
    return { changed: cartChanged, added: giftAdded, config };
  }
  async function processSpendXGetY(cartData) {
    if (spendXGetYConfigs.length === 0 || isProcessing2 || isVariantUpdateInProgress()) {
      return;
    }
    isProcessing2 = true;
    try {
      const results = await Promise.all(spendXGetYConfigs.map((config) => processPromotion2(cartData, config)));
      const anyChanged = results.some((r2) => r2.changed);
      const addedPromotions = results.filter((r2) => r2.added);
      if (anyChanged) {
        isProcessing2 = false;
        const freshCartResponse = await fetch("/cart.js");
        const freshCartData = await freshCartResponse.json();
        await updateCartUI(freshCartData);
        if (addedPromotions.length > 0) {
          addedPromotions.forEach((result, index) => {
            setTimeout(() => showGiftNotification2(result.config), index * 200);
          });
          const shouldOpenCart = addedPromotions.some((r2) => r2.config.autoOpenCart);
          if (shouldOpenCart) {
            const cartDrawer = document.getElementById("cart-drawer");
            if (cartDrawer) {
              cartDrawer.showModal();
            }
          }
        }
      } else {
        isProcessing2 = false;
      }
    } catch (error) {
      console.error("Error processing Spend X Get Y:", error);
      isProcessing2 = false;
    }
  }
  function initSpendXGetY() {
    spendXGetYConfigs = loadSpendXGetYConfigs();
    if (spendXGetYConfigs.length === 0) {
      return;
    }
    document.addEventListener("cart:updated", async (event2) => {
      const cartData = event2.detail;
      await processSpendXGetY(cartData);
    });
    fetch("/cart.js").then((response) => response.json()).then((cartData) => processSpendXGetY(cartData)).catch((error) => console.error("Error loading cart for Spend X Get Y:", error));
  }

  // assets-src/js/_sec_spotlight-scrolling-media.js
  function initSpotlightScrollingMedia() {
    const spotlightImages = document.querySelectorAll(".spotlight-img");
    if (spotlightImages.length === 0) return;
    ScrollTrigger.create({
      trigger: ".spotlight",
      start: "top top",
      end: `+${window.innerHeight * 2}px`,
      pin: true,
      pinSpacing: true,
      scrub: 1,
      invalidateOnRefresh: true,
      refreshPriority: 1,
      onUpdate: (self2) => {
        const progress = self2.progress;
        const initialRotations = [5, -3, 3.5, -1];
        const phaseOneStartOffsets = [0, 0.25, 0.45, 0.65];
        spotlightImages.forEach((img, index) => {
          const initialRotation = initialRotations[index];
          const phase1Start = phaseOneStartOffsets[index];
          const phase1End = Math.min(phase1Start + (1 - phase1Start) * 0.9, 1);
          let y, rotation;
          if (progress < phase1Start) {
            y = 200;
            rotation = initialRotation;
          } else if (progress <= 1) {
            let phase1Progress;
            if (progress >= phase1End) {
              phase1Progress = 1;
            } else {
              const linearProgress = (progress - phase1Start) / (phase1End - phase1Start);
              phase1Progress = 1 - Math.pow(1 - linearProgress, 3);
            }
            y = 200 - phase1Progress * 250;
            rotation = initialRotation;
          } else {
            y = -50;
            rotation = initialRotation;
          }
          gsap.set(img, {
            xPercent: -50,
            yPercent: y + 5,
            rotation
          });
        });
      }
    });
  }

  // assets-src/js/_1_ticker.js
  function initTicker() {
    const Util = {};
    Util.addClass = function(el, className) {
      var classList = className.split(" ");
      el.classList.add(classList[0]);
      if (classList.length > 1) Util.addClass(el, classList.slice(1).join(" "));
    };
    Util.removeClass = function(el, className) {
      var classList = className.split(" ");
      el.classList.remove(classList[0]);
      if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(" "));
    };
    Util.osHasReducedMotion = function() {
      if (!window.matchMedia) return false;
      var matchMediaObj = window.matchMedia("(prefers-reduced-motion: reduce)");
      if (matchMediaObj) return matchMediaObj.matches;
      return false;
    };
    (function() {
      var Ticker = function(element) {
        this.element = element;
        this.list = this.element.getElementsByTagName("ul")[0];
        this.items = this.list.children;
        this.paused = false;
        this.clones = this.list.innerHTML;
        this.clonesNumber = 1;
        this.itemsLength = this.items.length;
        this.animationDuration = parseInt(
          getComputedStyle(document.documentElement).getPropertyValue("--ticker-animation-duration")
        );
        initTicker2(this);
      };
      function initTicker2(ticker) {
        setTickerWidth(ticker);
        cloneItems(ticker);
        initAnimation(ticker);
        ticker.element.addEventListener("update-ticker", function(event2) {
          setTickerWidth(ticker);
          cloneItems(ticker);
        });
        ticker.element.addEventListener("anim-ticker", function(event2) {
          ticker.paused = false;
          Util.removeClass(ticker.element, "ticker--paused");
        });
        ticker.element.addEventListener("pause-ticker", function(event2) {
          ticker.paused = true;
          Util.addClass(ticker.element, "ticker--paused");
        });
        Util.addClass(ticker.element, "ticker--loaded");
      }
      function setTickerWidth(ticker) {
        var width = 0;
        for (var i3 = 0; i3 < ticker.itemsLength; i3++) {
          width = width + getItemWidth(ticker.items[i3]);
        }
        if (width < window.innerWidth) {
          ticker.clonesNumber = Math.ceil(window.innerWidth / width) * 2 - 1;
        } else {
          ticker.clonesNumber = 1;
        }
        ticker.list.style.width = (ticker.clonesNumber + 1) * width + "px";
      }
      function getItemWidth(item) {
        var style = window.getComputedStyle(item);
        return parseFloat(style.marginRight) + parseFloat(style.marginLeft) + item.offsetWidth;
      }
      function cloneItems(ticker) {
        ticker.list.innerHTML = ticker.clones;
        for (var i3 = 0; i3 < ticker.clonesNumber; i3++) {
          ticker.list.insertAdjacentHTML("beforeend", ticker.clones);
        }
        ticker.element.style.setProperty(
          "--ticker-animation-duration",
          ticker.animationDuration * (ticker.clonesNumber + 1) + "s"
        );
      }
      function initAnimation(ticker) {
        var observer = new IntersectionObserver(tickerObserve.bind(ticker));
        observer.observe(ticker.element);
      }
      function tickerObserve(entries) {
        if (entries[0].isIntersecting) {
          if (!this.paused) Util.addClass(this.element, "ticker--animate");
        } else {
          Util.removeClass(this.element, "ticker--animate");
        }
      }
      function initTickerController(controller) {
        var tickerContainer = document.getElementById(controller.getAttribute("aria-controls"));
        if (!tickerContainer) return;
        var tickerList = tickerContainer.getElementsByClassName("js-ticker");
        if (tickerList.length < 1) tickerList = [tickerContainer];
        controller.addEventListener("click", function(event2) {
          var playAnimation = controller.getAttribute("aria-pressed") == "true";
          var animEvent = playAnimation ? "anim-ticker" : "pause-ticker";
          playAnimation ? controller.setAttribute("aria-pressed", "false") : controller.setAttribute("aria-pressed", "true");
          for (var i3 = 0; i3 < tickerList.length; i3++) {
            tickerList[i3].dispatchEvent(new CustomEvent(animEvent));
          }
        });
      }
      var tickers = document.getElementsByClassName("js-ticker"), requestAnimationFrameSupported = window.requestAnimationFrame, reducedMotion = Util.osHasReducedMotion(), intersectionObserverSupported = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype;
      if (tickers.length > 0) {
        var tickersArray = [];
        for (var i2 = 0; i2 < tickers.length; i2++) {
          if (!requestAnimationFrameSupported || reducedMotion || !intersectionObserverSupported) {
            Util.addClass(tickers[i2], "ticker--anim-off");
          } else {
            (function(i3) {
              tickersArray.push(new Ticker(tickers[i3]));
            })(i2);
          }
        }
        if (tickersArray.length > 0) {
          let doneResizing = function() {
            for (var i3 = 0; i3 < tickersArray.length; i3++) {
              (function(i4) {
                tickersArray[i4].element.dispatchEvent(customEvent);
              })(i3);
            }
          };
          var resizingId = false, customEvent = new CustomEvent("update-ticker");
          window.addEventListener("resize", function() {
            clearTimeout(resizingId);
            resizingId = setTimeout(doneResizing, 500);
          });
          if (document.fonts) {
            document.fonts.onloadingdone = function(fontFaceSetEvent) {
              doneResizing();
            };
          }
          var tickerControl = document.getElementsByClassName("js-ticker-control");
          if (tickerControl.length > 0) {
            for (var i2 = 0; i2 < tickerControl.length; i2++) {
              if (!requestAnimationFrameSupported || reducedMotion || !intersectionObserverSupported) {
                Util.addClass(tickerControl[i2], "hidden");
              } else {
                (function(i3) {
                  initTickerController(tickerControl[i3]);
                })(i2);
              }
            }
          }
        }
      }
    })();
  }

  // assets-src/js/_p_variant-selector.js
  function initVariantSelector() {
    const forms = document.querySelectorAll(".product-form");
    forms.forEach((form) => {
      const variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput) return;
      const productData = getProductData(form);
      if (!productData) return;
      const optionInputs = form.querySelectorAll('input[name^="options["]');
      optionInputs.forEach((input) => {
        input.addEventListener("change", () => {
          updateVariant(form, productData, variantIdInput);
        });
      });
      updateVariant(form, productData, variantIdInput);
    });
  }
  function getProductData(form) {
    const section = form.closest("[data-product-json]");
    if (!section) {
      console.warn("Product data not found. Add data-product-json attribute to section.");
      return null;
    }
    try {
      return JSON.parse(section.getAttribute("data-product-json"));
    } catch (e2) {
      console.error("Failed to parse product JSON:", e2);
      return null;
    }
  }
  function updateVariant(form, productData, variantIdInput) {
    const selectedOptions = getSelectedOptions(form);
    const matchedVariant = findVariantByOptions2(productData.variants, selectedOptions);
    if (matchedVariant) {
      variantIdInput.value = matchedVariant.id;
      form.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: { variant: matchedVariant }
        })
      );
    }
  }
  function getSelectedOptions(form) {
    const options = {};
    const optionInputs = form.querySelectorAll('input[name^="options["]:checked');
    optionInputs.forEach((input) => {
      const match = input.name.match(/options\[(.+?)\]/);
      if (match) {
        options[match[1]] = input.value;
      }
    });
    return options;
  }
  function findVariantByOptions2(variants, selectedOptions) {
    return variants.find((variant) => {
      return Object.entries(selectedOptions).every(([optionName, optionValue]) => {
        if (optionName === "Color" || optionName === "Colour") {
          return variant.option1 === optionValue;
        } else if (optionName === "Size") {
          return variant.option2 === optionValue;
        } else if (optionName === "Style" || optionName === "Material") {
          return variant.option3 === optionValue;
        }
        return false;
      });
    });
  }

  // node_modules/swiper/shared/ssr-window.esm.mjs
  function isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
  }
  function extend(target = {}, src = {}) {
    const noExtend = ["__proto__", "constructor", "prototype"];
    Object.keys(src).filter((key) => noExtend.indexOf(key) < 0).forEach((key) => {
      if (typeof target[key] === "undefined") target[key] = src[key];
      else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
        extend(target[key], src[key]);
      }
    });
  }
  var ssrDocument = {
    body: {},
    addEventListener() {
    },
    removeEventListener() {
    },
    activeElement: {
      blur() {
      },
      nodeName: ""
    },
    querySelector() {
      return null;
    },
    querySelectorAll() {
      return [];
    },
    getElementById() {
      return null;
    },
    createEvent() {
      return {
        initEvent() {
        }
      };
    },
    createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute() {
        },
        getElementsByTagName() {
          return [];
        }
      };
    },
    createElementNS() {
      return {};
    },
    importNode() {
      return null;
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    }
  };
  function getDocument() {
    const doc = typeof document !== "undefined" ? document : {};
    extend(doc, ssrDocument);
    return doc;
  }
  var ssrWindow = {
    document: ssrDocument,
    navigator: {
      userAgent: ""
    },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: ""
    },
    history: {
      replaceState() {
      },
      pushState() {
      },
      go() {
      },
      back() {
      }
    },
    CustomEvent: function CustomEvent2() {
      return this;
    },
    addEventListener() {
    },
    removeEventListener() {
    },
    getComputedStyle() {
      return {
        getPropertyValue() {
          return "";
        }
      };
    },
    Image() {
    },
    Date() {
    },
    screen: {},
    setTimeout() {
    },
    clearTimeout() {
    },
    matchMedia() {
      return {};
    },
    requestAnimationFrame(callback) {
      if (typeof setTimeout === "undefined") {
        callback();
        return null;
      }
      return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
      if (typeof setTimeout === "undefined") {
        return;
      }
      clearTimeout(id);
    }
  };
  function getWindow() {
    const win = typeof window !== "undefined" ? window : {};
    extend(win, ssrWindow);
    return win;
  }

  // node_modules/swiper/shared/utils.mjs
  function classesToTokens(classes2 = "") {
    return classes2.trim().split(" ").filter((c) => !!c.trim());
  }
  function deleteProps(obj) {
    const object = obj;
    Object.keys(object).forEach((key) => {
      try {
        object[key] = null;
      } catch (e2) {
      }
      try {
        delete object[key];
      } catch (e2) {
      }
    });
  }
  function nextTick(callback, delay = 0) {
    return setTimeout(callback, delay);
  }
  function now() {
    return Date.now();
  }
  function getComputedStyle2(el) {
    const window2 = getWindow();
    let style;
    if (window2.getComputedStyle) {
      style = window2.getComputedStyle(el, null);
    }
    if (!style && el.currentStyle) {
      style = el.currentStyle;
    }
    if (!style) {
      style = el.style;
    }
    return style;
  }
  function getTranslate(el, axis = "x") {
    const window2 = getWindow();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = getComputedStyle2(el);
    if (window2.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;
      if (curTransform.split(",").length > 6) {
        curTransform = curTransform.split(", ").map((a) => a.replace(",", ".")).join(", ");
      }
      transformMatrix = new window2.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
      matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
      if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m41;
      else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
      else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
      if (window2.WebKitCSSMatrix) curTransform = transformMatrix.m42;
      else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
      else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
  }
  function isObject2(o2) {
    return typeof o2 === "object" && o2 !== null && o2.constructor && Object.prototype.toString.call(o2).slice(8, -1) === "Object";
  }
  function isNode(node) {
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") {
      return node instanceof HTMLElement;
    }
    return node && (node.nodeType === 1 || node.nodeType === 11);
  }
  function extend2(...args) {
    const to = Object(args[0]);
    const noExtend = ["__proto__", "constructor", "prototype"];
    for (let i2 = 1; i2 < args.length; i2 += 1) {
      const nextSource = args[i2];
      if (nextSource !== void 0 && nextSource !== null && !isNode(nextSource)) {
        const keysArray = Object.keys(Object(nextSource)).filter((key) => noExtend.indexOf(key) < 0);
        for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          const nextKey = keysArray[nextIndex];
          const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== void 0 && desc.enumerable) {
            if (isObject2(to[nextKey]) && isObject2(nextSource[nextKey])) {
              if (nextSource[nextKey].__swiper__) {
                to[nextKey] = nextSource[nextKey];
              } else {
                extend2(to[nextKey], nextSource[nextKey]);
              }
            } else if (!isObject2(to[nextKey]) && isObject2(nextSource[nextKey])) {
              to[nextKey] = {};
              if (nextSource[nextKey].__swiper__) {
                to[nextKey] = nextSource[nextKey];
              } else {
                extend2(to[nextKey], nextSource[nextKey]);
              }
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }
    return to;
  }
  function setCSSProperty(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
  }
  function animateCSSModeScroll({
    swiper,
    targetPosition,
    side
  }) {
    const window2 = getWindow();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window2.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target) => {
      return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = () => {
      time = (/* @__PURE__ */ new Date()).getTime();
      if (startTime === null) {
        startTime = time;
      }
      const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
      let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
      if (isOutOfBound(currentPosition, targetPosition)) {
        currentPosition = targetPosition;
      }
      swiper.wrapperEl.scrollTo({
        [side]: currentPosition
      });
      if (isOutOfBound(currentPosition, targetPosition)) {
        swiper.wrapperEl.style.overflow = "hidden";
        swiper.wrapperEl.style.scrollSnapType = "";
        setTimeout(() => {
          swiper.wrapperEl.style.overflow = "";
          swiper.wrapperEl.scrollTo({
            [side]: currentPosition
          });
        });
        window2.cancelAnimationFrame(swiper.cssModeFrameID);
        return;
      }
      swiper.cssModeFrameID = window2.requestAnimationFrame(animate);
    };
    animate();
  }
  function elementChildren(element, selector = "") {
    const window2 = getWindow();
    const children = [...element.children];
    if (window2.HTMLSlotElement && element instanceof HTMLSlotElement) {
      children.push(...element.assignedElements());
    }
    if (!selector) {
      return children;
    }
    return children.filter((el) => el.matches(selector));
  }
  function elementIsChildOfSlot(el, slot) {
    const elementsQueue = [slot];
    while (elementsQueue.length > 0) {
      const elementToCheck = elementsQueue.shift();
      if (el === elementToCheck) {
        return true;
      }
      elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
  }
  function elementIsChildOf(el, parent) {
    const window2 = getWindow();
    let isChild = parent.contains(el);
    if (!isChild && window2.HTMLSlotElement && parent instanceof HTMLSlotElement) {
      const children = [...parent.assignedElements()];
      isChild = children.includes(el);
      if (!isChild) {
        isChild = elementIsChildOfSlot(el, parent);
      }
    }
    return isChild;
  }
  function showWarning(text) {
    try {
      console.warn(text);
      return;
    } catch (err) {
    }
  }
  function createElement2(tag, classes2 = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes2) ? classes2 : classesToTokens(classes2));
    return el;
  }
  function elementPrevAll(el, selector) {
    const prevEls = [];
    while (el.previousElementSibling) {
      const prev = el.previousElementSibling;
      if (selector) {
        if (prev.matches(selector)) prevEls.push(prev);
      } else prevEls.push(prev);
      el = prev;
    }
    return prevEls;
  }
  function elementNextAll(el, selector) {
    const nextEls = [];
    while (el.nextElementSibling) {
      const next = el.nextElementSibling;
      if (selector) {
        if (next.matches(selector)) nextEls.push(next);
      } else nextEls.push(next);
      el = next;
    }
    return nextEls;
  }
  function elementStyle(el, prop) {
    const window2 = getWindow();
    return window2.getComputedStyle(el, null).getPropertyValue(prop);
  }
  function elementIndex(el) {
    let child = el;
    let i2;
    if (child) {
      i2 = 0;
      while ((child = child.previousSibling) !== null) {
        if (child.nodeType === 1) i2 += 1;
      }
      return i2;
    }
    return void 0;
  }
  function elementParents(el, selector) {
    const parents = [];
    let parent = el.parentElement;
    while (parent) {
      if (selector) {
        if (parent.matches(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }
      parent = parent.parentElement;
    }
    return parents;
  }
  function elementOuterSize(el, size, includeMargins) {
    const window2 = getWindow();
    if (includeMargins) {
      return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window2.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    }
    return el.offsetWidth;
  }
  function makeElementsArray(el) {
    return (Array.isArray(el) ? el : [el]).filter((e2) => !!e2);
  }
  function setInnerHTML(el, html = "") {
    if (typeof trustedTypes !== "undefined") {
      el.innerHTML = trustedTypes.createPolicy("html", {
        createHTML: (s2) => s2
      }).createHTML(html);
    } else {
      el.innerHTML = html;
    }
  }

  // node_modules/swiper/shared/swiper-core.mjs
  var support;
  function calcSupport() {
    const window2 = getWindow();
    const document2 = getDocument();
    return {
      smoothScroll: document2.documentElement && document2.documentElement.style && "scrollBehavior" in document2.documentElement.style,
      touch: !!("ontouchstart" in window2 || window2.DocumentTouch && document2 instanceof window2.DocumentTouch)
    };
  }
  function getSupport() {
    if (!support) {
      support = calcSupport();
    }
    return support;
  }
  var deviceCached;
  function calcDevice({
    userAgent
  } = {}) {
    const support2 = getSupport();
    const window2 = getWindow();
    const platform = window2.navigator.platform;
    const ua = userAgent || window2.navigator.userAgent;
    const device = {
      ios: false,
      android: false
    };
    const screenWidth = window2.screen.width;
    const screenHeight = window2.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
    let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    const iPadScreens = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
    if (!ipad && macos && support2.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
      ipad = ua.match(/(Version)\/([\d.]+)/);
      if (!ipad) ipad = [0, 1, "13_0_0"];
      macos = false;
    }
    if (android && !windows) {
      device.os = "android";
      device.android = true;
    }
    if (ipad || iphone || ipod) {
      device.os = "ios";
      device.ios = true;
    }
    return device;
  }
  function getDevice(overrides = {}) {
    if (!deviceCached) {
      deviceCached = calcDevice(overrides);
    }
    return deviceCached;
  }
  var browser;
  function calcBrowser() {
    const window2 = getWindow();
    const device = getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
      const ua = window2.navigator.userAgent.toLowerCase();
      return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
      const ua = String(window2.navigator.userAgent);
      if (ua.includes("Version/")) {
        const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num) => Number(num));
        needPerspectiveFix = major < 16 || major === 16 && minor < 2;
      }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window2.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
      isSafari: needPerspectiveFix || isSafariBrowser,
      needPerspectiveFix,
      need3dFix,
      isWebView
    };
  }
  function getBrowser() {
    if (!browser) {
      browser = calcBrowser();
    }
    return browser;
  }
  function Resize({
    swiper,
    on: on2,
    emit
  }) {
    const window2 = getWindow();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized) return;
      emit("beforeResize");
      emit("resize");
    };
    const createObserver = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized) return;
      observer = new ResizeObserver((entries) => {
        animationFrame = window2.requestAnimationFrame(() => {
          const {
            width,
            height
          } = swiper;
          let newWidth = width;
          let newHeight = height;
          entries.forEach(({
            contentBoxSize,
            contentRect,
            target
          }) => {
            if (target && target !== swiper.el) return;
            newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
            newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
          });
          if (newWidth !== width || newHeight !== height) {
            resizeHandler();
          }
        });
      });
      observer.observe(swiper.el);
    };
    const removeObserver = () => {
      if (animationFrame) {
        window2.cancelAnimationFrame(animationFrame);
      }
      if (observer && observer.unobserve && swiper.el) {
        observer.unobserve(swiper.el);
        observer = null;
      }
    };
    const orientationChangeHandler = () => {
      if (!swiper || swiper.destroyed || !swiper.initialized) return;
      emit("orientationchange");
    };
    on2("init", () => {
      if (swiper.params.resizeObserver && typeof window2.ResizeObserver !== "undefined") {
        createObserver();
        return;
      }
      window2.addEventListener("resize", resizeHandler);
      window2.addEventListener("orientationchange", orientationChangeHandler);
    });
    on2("destroy", () => {
      removeObserver();
      window2.removeEventListener("resize", resizeHandler);
      window2.removeEventListener("orientationchange", orientationChangeHandler);
    });
  }
  function Observer({
    swiper,
    extendParams,
    on: on2,
    emit
  }) {
    const observers = [];
    const window2 = getWindow();
    const attach = (target, options = {}) => {
      const ObserverFunc = window2.MutationObserver || window2.WebkitMutationObserver;
      const observer = new ObserverFunc((mutations) => {
        if (swiper.__preventObserver__) return;
        if (mutations.length === 1) {
          emit("observerUpdate", mutations[0]);
          return;
        }
        const observerUpdate = function observerUpdate2() {
          emit("observerUpdate", mutations[0]);
        };
        if (window2.requestAnimationFrame) {
          window2.requestAnimationFrame(observerUpdate);
        } else {
          window2.setTimeout(observerUpdate, 0);
        }
      });
      observer.observe(target, {
        attributes: typeof options.attributes === "undefined" ? true : options.attributes,
        childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
        characterData: typeof options.characterData === "undefined" ? true : options.characterData
      });
      observers.push(observer);
    };
    const init = () => {
      if (!swiper.params.observer) return;
      if (swiper.params.observeParents) {
        const containerParents = elementParents(swiper.hostEl);
        for (let i2 = 0; i2 < containerParents.length; i2 += 1) {
          attach(containerParents[i2]);
        }
      }
      attach(swiper.hostEl, {
        childList: swiper.params.observeSlideChildren
      });
      attach(swiper.wrapperEl, {
        attributes: false
      });
    };
    const destroy = () => {
      observers.forEach((observer) => {
        observer.disconnect();
      });
      observers.splice(0, observers.length);
    };
    extendParams({
      observer: false,
      observeParents: false,
      observeSlideChildren: false
    });
    on2("init", init);
    on2("destroy", destroy);
  }
  var eventsEmitter = {
    on(events2, handler, priority) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (typeof handler !== "function") return self2;
      const method = priority ? "unshift" : "push";
      events2.split(" ").forEach((event2) => {
        if (!self2.eventsListeners[event2]) self2.eventsListeners[event2] = [];
        self2.eventsListeners[event2][method](handler);
      });
      return self2;
    },
    once(events2, handler, priority) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (typeof handler !== "function") return self2;
      function onceHandler(...args) {
        self2.off(events2, onceHandler);
        if (onceHandler.__emitterProxy) {
          delete onceHandler.__emitterProxy;
        }
        handler.apply(self2, args);
      }
      onceHandler.__emitterProxy = handler;
      return self2.on(events2, onceHandler, priority);
    },
    onAny(handler, priority) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (typeof handler !== "function") return self2;
      const method = priority ? "unshift" : "push";
      if (self2.eventsAnyListeners.indexOf(handler) < 0) {
        self2.eventsAnyListeners[method](handler);
      }
      return self2;
    },
    offAny(handler) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (!self2.eventsAnyListeners) return self2;
      const index = self2.eventsAnyListeners.indexOf(handler);
      if (index >= 0) {
        self2.eventsAnyListeners.splice(index, 1);
      }
      return self2;
    },
    off(events2, handler) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (!self2.eventsListeners) return self2;
      events2.split(" ").forEach((event2) => {
        if (typeof handler === "undefined") {
          self2.eventsListeners[event2] = [];
        } else if (self2.eventsListeners[event2]) {
          self2.eventsListeners[event2].forEach((eventHandler, index) => {
            if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
              self2.eventsListeners[event2].splice(index, 1);
            }
          });
        }
      });
      return self2;
    },
    emit(...args) {
      const self2 = this;
      if (!self2.eventsListeners || self2.destroyed) return self2;
      if (!self2.eventsListeners) return self2;
      let events2;
      let data;
      let context;
      if (typeof args[0] === "string" || Array.isArray(args[0])) {
        events2 = args[0];
        data = args.slice(1, args.length);
        context = self2;
      } else {
        events2 = args[0].events;
        data = args[0].data;
        context = args[0].context || self2;
      }
      data.unshift(context);
      const eventsArray = Array.isArray(events2) ? events2 : events2.split(" ");
      eventsArray.forEach((event2) => {
        if (self2.eventsAnyListeners && self2.eventsAnyListeners.length) {
          self2.eventsAnyListeners.forEach((eventHandler) => {
            eventHandler.apply(context, [event2, ...data]);
          });
        }
        if (self2.eventsListeners && self2.eventsListeners[event2]) {
          self2.eventsListeners[event2].forEach((eventHandler) => {
            eventHandler.apply(context, data);
          });
        }
      });
      return self2;
    }
  };
  function updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) {
      width = swiper.params.width;
    } else {
      width = el.clientWidth;
    }
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) {
      height = swiper.params.height;
    } else {
      height = el.clientHeight;
    }
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
      return;
    }
    width = width - parseInt(elementStyle(el, "padding-left") || 0, 10) - parseInt(elementStyle(el, "padding-right") || 0, 10);
    height = height - parseInt(elementStyle(el, "padding-top") || 0, 10) - parseInt(elementStyle(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
      width,
      height,
      size: swiper.isHorizontal() ? width : height
    });
  }
  function updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
      return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const {
      wrapperEl,
      slidesEl,
      rtlTranslate: rtl,
      wrongRTL
    } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = elementChildren(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") {
      offsetBefore = params.slidesOffsetBefore.call(swiper);
    }
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") {
      offsetAfter = params.slidesOffsetAfter.call(swiper);
    }
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") {
      return;
    }
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    } else if (typeof spaceBetween === "string") {
      spaceBetween = parseFloat(spaceBetween);
    }
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    slides.forEach((slideEl) => {
      if (rtl) {
        slideEl.style.marginLeft = "";
      } else {
        slideEl.style.marginRight = "";
      }
      slideEl.style.marginBottom = "";
      slideEl.style.marginTop = "";
    });
    if (params.centeredSlides && params.cssMode) {
      setCSSProperty(wrapperEl, "--swiper-centered-offset-before", "");
      setCSSProperty(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) {
      swiper.grid.initSlides(slides);
    } else if (swiper.grid) {
      swiper.grid.unsetSlides();
    }
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key) => {
      return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for (let i2 = 0; i2 < slidesLength; i2 += 1) {
      slideSize = 0;
      const slide2 = slides[i2];
      if (slide2) {
        if (gridEnabled) {
          swiper.grid.updateSlide(i2, slide2, slides);
        }
        if (elementStyle(slide2, "display") === "none") continue;
      }
      if (isVirtual && params.slidesPerView === "auto") {
        if (params.virtual.slidesPerViewAutoSlideSize) {
          slideSize = params.virtual.slidesPerViewAutoSlideSize;
        }
        if (slideSize && slide2) {
          if (params.roundLengths) slideSize = Math.floor(slideSize);
          slide2.style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
      } else if (params.slidesPerView === "auto") {
        if (shouldResetSlideSize) {
          slide2.style[swiper.getDirectionLabel("width")] = ``;
        }
        const slideStyles = getComputedStyle(slide2);
        const currentTransform = slide2.style.transform;
        const currentWebKitTransform = slide2.style.webkitTransform;
        if (currentTransform) {
          slide2.style.transform = "none";
        }
        if (currentWebKitTransform) {
          slide2.style.webkitTransform = "none";
        }
        if (params.roundLengths) {
          slideSize = swiper.isHorizontal() ? elementOuterSize(slide2, "width", true) : elementOuterSize(slide2, "height", true);
        } else {
          const width = getDirectionPropertyValue(slideStyles, "width");
          const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
          const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
          const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
          const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
          const boxSizing = slideStyles.getPropertyValue("box-sizing");
          if (boxSizing && boxSizing === "border-box") {
            slideSize = width + marginLeft + marginRight;
          } else {
            const {
              clientWidth,
              offsetWidth
            } = slide2;
            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
          }
        }
        if (currentTransform) {
          slide2.style.transform = currentTransform;
        }
        if (currentWebKitTransform) {
          slide2.style.webkitTransform = currentWebKitTransform;
        }
        if (params.roundLengths) slideSize = Math.floor(slideSize);
      } else {
        slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
        if (params.roundLengths) slideSize = Math.floor(slideSize);
        if (slide2) {
          slide2.style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
      }
      if (slide2) {
        slide2.swiperSlideSize = slideSize;
      }
      slidesSizesGrid.push(slideSize);
      if (params.centeredSlides) {
        slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
        if (prevSlideSize === 0 && i2 !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (i2 === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
        if (Math.abs(slidePosition) < 1 / 1e3) slidePosition = 0;
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
      } else {
        if (params.roundLengths) slidePosition = Math.floor(slidePosition);
        if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
        slidesGrid.push(slidePosition);
        slidePosition = slidePosition + slideSize + spaceBetween;
      }
      swiper.virtualSize += slideSize + spaceBetween;
      prevSlideSize = slideSize;
      index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) {
      wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    }
    if (params.setWrapperSize) {
      wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    }
    if (gridEnabled) {
      swiper.grid.updateWrapperSize(slideSize, snapGrid);
    }
    if (!params.centeredSlides) {
      const newSlidesGrid = [];
      for (let i2 = 0; i2 < snapGrid.length; i2 += 1) {
        let slidesGridItem = snapGrid[i2];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[i2] <= swiper.virtualSize - swiperSize) {
          newSlidesGrid.push(slidesGridItem);
        }
      }
      snapGrid = newSlidesGrid;
      if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
        snapGrid.push(swiper.virtualSize - swiperSize);
      }
    }
    if (isVirtual && params.loop) {
      const size = slidesSizesGrid[0] + spaceBetween;
      if (params.slidesPerGroup > 1) {
        const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
        const groupSize = size * params.slidesPerGroup;
        for (let i2 = 0; i2 < groups; i2 += 1) {
          snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
      }
      for (let i2 = 0; i2 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i2 += 1) {
        if (params.slidesPerGroup === 1) {
          snapGrid.push(snapGrid[snapGrid.length - 1] + size);
        }
        slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
        swiper.virtualSize += size;
      }
    }
    if (snapGrid.length === 0) snapGrid = [0];
    if (spaceBetween !== 0) {
      const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
      slides.filter((_, slideIndex) => {
        if (!params.cssMode || params.loop) return true;
        if (slideIndex === slides.length - 1) {
          return false;
        }
        return true;
      }).forEach((slideEl) => {
        slideEl.style[key] = `${spaceBetween}px`;
      });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
      let allSlidesSize = 0;
      slidesSizesGrid.forEach((slideSizeValue) => {
        allSlidesSize += slideSizeValue + (spaceBetween || 0);
      });
      allSlidesSize -= spaceBetween;
      const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
      snapGrid = snapGrid.map((snap) => {
        if (snap <= 0) return -offsetBefore;
        if (snap > maxSnap) return maxSnap + offsetAfter;
        return snap;
      });
    }
    if (params.centerInsufficientSlides) {
      let allSlidesSize = 0;
      slidesSizesGrid.forEach((slideSizeValue) => {
        allSlidesSize += slideSizeValue + (spaceBetween || 0);
      });
      allSlidesSize -= spaceBetween;
      const offsetSize = (offsetBefore || 0) + (offsetAfter || 0);
      if (allSlidesSize + offsetSize < swiperSize) {
        const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
        snapGrid.forEach((snap, snapIndex) => {
          snapGrid[snapIndex] = snap - allSlidesOffset;
        });
        slidesGrid.forEach((snap, snapIndex) => {
          slidesGrid[snapIndex] = snap + allSlidesOffset;
        });
      }
    }
    Object.assign(swiper, {
      slides,
      snapGrid,
      slidesGrid,
      slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
      setCSSProperty(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
      setCSSProperty(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
      const addToSnapGrid = -swiper.snapGrid[0];
      const addToSlidesGrid = -swiper.slidesGrid[0];
      swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid);
      swiper.slidesGrid = swiper.slidesGrid.map((v) => v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) {
      swiper.emit("slidesLengthChange");
    }
    if (snapGrid.length !== previousSnapGridLength) {
      if (swiper.params.watchOverflow) swiper.checkOverflow();
      swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
      swiper.emit("slidesGridLengthChange");
    }
    if (params.watchSlidesProgress) {
      swiper.updateSlidesOffset();
    }
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
      const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
      const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
      if (slidesLength <= params.maxBackfaceHiddenSlides) {
        if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
      } else if (hasClassBackfaceClassAdded) {
        swiper.el.classList.remove(backFaceHiddenClass);
      }
    }
  }
  function updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i2;
    if (typeof speed === "number") {
      swiper.setTransition(speed);
    } else if (speed === true) {
      swiper.setTransition(swiper.params.speed);
    }
    const getSlideByIndex = (index) => {
      if (isVirtual) {
        return swiper.slides[swiper.getSlideIndexByData(index)];
      }
      return swiper.slides[index];
    };
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
      if (swiper.params.centeredSlides) {
        (swiper.visibleSlides || []).forEach((slide2) => {
          activeSlides.push(slide2);
        });
      } else {
        for (i2 = 0; i2 < Math.ceil(swiper.params.slidesPerView); i2 += 1) {
          const index = swiper.activeIndex + i2;
          if (index > swiper.slides.length && !isVirtual) break;
          activeSlides.push(getSlideByIndex(index));
        }
      }
    } else {
      activeSlides.push(getSlideByIndex(swiper.activeIndex));
    }
    for (i2 = 0; i2 < activeSlides.length; i2 += 1) {
      if (typeof activeSlides[i2] !== "undefined") {
        const height = activeSlides[i2].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
      }
    }
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
  }
  function updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for (let i2 = 0; i2 < slides.length; i2 += 1) {
      slides[i2].swiperSlideOffset = (swiper.isHorizontal() ? slides[i2].offsetLeft : slides[i2].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
    }
  }
  var toggleSlideClasses$1 = (slideEl, condition, className) => {
    if (condition && !slideEl.classList.contains(className)) {
      slideEl.classList.add(className);
    } else if (!condition && slideEl.classList.contains(className)) {
      slideEl.classList.remove(className);
    }
  };
  function updateSlidesProgress(translate2 = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const {
      slides,
      rtlTranslate: rtl,
      snapGrid
    } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate2;
    if (rtl) offsetCenter = translate2;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
      spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    } else if (typeof spaceBetween === "string") {
      spaceBetween = parseFloat(spaceBetween);
    }
    for (let i2 = 0; i2 < slides.length; i2 += 1) {
      const slide2 = slides[i2];
      let slideOffset = slide2.swiperSlideOffset;
      if (params.cssMode && params.centeredSlides) {
        slideOffset -= slides[0].swiperSlideOffset;
      }
      const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
      const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide2.swiperSlideSize + spaceBetween);
      const slideBefore = -(offsetCenter - slideOffset);
      const slideAfter = slideBefore + swiper.slidesSizesGrid[i2];
      const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i2];
      const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
      if (isVisible) {
        swiper.visibleSlides.push(slide2);
        swiper.visibleSlidesIndexes.push(i2);
      }
      toggleSlideClasses$1(slide2, isVisible, params.slideVisibleClass);
      toggleSlideClasses$1(slide2, isFullyVisible, params.slideFullyVisibleClass);
      slide2.progress = rtl ? -slideProgress : slideProgress;
      slide2.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
  }
  function updateProgress(translate2) {
    const swiper = this;
    if (typeof translate2 === "undefined") {
      const multiplier = swiper.rtlTranslate ? -1 : 1;
      translate2 = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let {
      progress,
      isBeginning,
      isEnd,
      progressLoop
    } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
      progress = 0;
      isBeginning = true;
      isEnd = true;
    } else {
      progress = (translate2 - swiper.minTranslate()) / translatesDiff;
      const isBeginningRounded = Math.abs(translate2 - swiper.minTranslate()) < 1;
      const isEndRounded = Math.abs(translate2 - swiper.maxTranslate()) < 1;
      isBeginning = isBeginningRounded || progress <= 0;
      isEnd = isEndRounded || progress >= 1;
      if (isBeginningRounded) progress = 0;
      if (isEndRounded) progress = 1;
    }
    if (params.loop) {
      const firstSlideIndex = swiper.getSlideIndexByData(0);
      const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
      const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
      const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
      const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
      const translateAbs = Math.abs(translate2);
      if (translateAbs >= firstSlideTranslate) {
        progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
      } else {
        progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
      }
      if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
      progress,
      progressLoop,
      isBeginning,
      isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate2);
    if (isBeginning && !wasBeginning) {
      swiper.emit("reachBeginning toEdge");
    }
    if (isEnd && !wasEnd) {
      swiper.emit("reachEnd toEdge");
    }
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
      swiper.emit("fromEdge");
    }
    swiper.emit("progress", progress);
  }
  var toggleSlideClasses = (slideEl, condition, className) => {
    if (condition && !slideEl.classList.contains(className)) {
      slideEl.classList.add(className);
    } else if (!condition && slideEl.classList.contains(className)) {
      slideEl.classList.remove(className);
    }
  };
  function updateSlidesClasses() {
    const swiper = this;
    const {
      slides,
      params,
      slidesEl,
      activeIndex
    } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector) => {
      return elementChildren(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
      if (params.loop) {
        let slideIndex = activeIndex - swiper.virtual.slidesBefore;
        if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
        if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
        activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
      } else {
        activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
      }
    } else {
      if (gridEnabled) {
        activeSlide = slides.find((slideEl) => slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl) => slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl) => slideEl.column === activeIndex - 1);
      } else {
        activeSlide = slides[activeIndex];
      }
    }
    if (activeSlide) {
      if (!gridEnabled) {
        nextSlide = elementNextAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        if (params.loop && !nextSlide) {
          nextSlide = slides[0];
        }
        prevSlide = elementPrevAll(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        if (params.loop && !prevSlide === 0) {
          prevSlide = slides[slides.length - 1];
        }
      }
    }
    slides.forEach((slideEl) => {
      toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
      toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
      toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
  }
  var processLazyPreloader = (swiper, imageEl) => {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = () => swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
      let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
      if (!lazyEl && swiper.isElement) {
        if (slideEl.shadowRoot) {
          lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        } else {
          requestAnimationFrame(() => {
            if (slideEl.shadowRoot) {
              lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
              if (lazyEl) lazyEl.remove();
            }
          });
        }
      }
      if (lazyEl) lazyEl.remove();
    }
  };
  var unlazy = (swiper, index) => {
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
  };
  var preload = (swiper) => {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
      const activeColumn = activeIndex;
      const preloadColumns = [activeColumn - amount];
      preloadColumns.push(...Array.from({
        length: amount
      }).map((_, i2) => {
        return activeColumn + slidesPerView + i2;
      }));
      swiper.slides.forEach((slideEl, i2) => {
        if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i2);
      });
      return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) {
      for (let i2 = activeIndex - amount; i2 <= slideIndexLastInView + amount; i2 += 1) {
        const realIndex = (i2 % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
      }
    } else {
      for (let i2 = Math.max(activeIndex - amount, 0); i2 <= Math.min(slideIndexLastInView + amount, len - 1); i2 += 1) {
        if (i2 !== activeIndex && (i2 > slideIndexLastInView || i2 < activeIndex)) {
          unlazy(swiper, i2);
        }
      }
    }
  };
  function getActiveIndexByTranslate(swiper) {
    const {
      slidesGrid,
      params
    } = swiper;
    const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for (let i2 = 0; i2 < slidesGrid.length; i2 += 1) {
      if (typeof slidesGrid[i2 + 1] !== "undefined") {
        if (translate2 >= slidesGrid[i2] && translate2 < slidesGrid[i2 + 1] - (slidesGrid[i2 + 1] - slidesGrid[i2]) / 2) {
          activeIndex = i2;
        } else if (translate2 >= slidesGrid[i2] && translate2 < slidesGrid[i2 + 1]) {
          activeIndex = i2 + 1;
        }
      } else if (translate2 >= slidesGrid[i2]) {
        activeIndex = i2;
      }
    }
    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
  }
  function updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const {
      snapGrid,
      params,
      activeIndex: previousIndex,
      realIndex: previousRealIndex,
      snapIndex: previousSnapIndex
    } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex) => {
      let realIndex2 = aIndex - swiper.virtual.slidesBefore;
      if (realIndex2 < 0) {
        realIndex2 = swiper.virtual.slides.length + realIndex2;
      }
      if (realIndex2 >= swiper.virtual.slides.length) {
        realIndex2 -= swiper.virtual.slides.length;
      }
      return realIndex2;
    };
    if (typeof activeIndex === "undefined") {
      activeIndex = getActiveIndexByTranslate(swiper);
    }
    if (snapGrid.indexOf(translate2) >= 0) {
      snapIndex = snapGrid.indexOf(translate2);
    } else {
      const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
      snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
      if (snapIndex !== previousSnapIndex) {
        swiper.snapIndex = snapIndex;
        swiper.emit("snapIndexChange");
      }
      return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
      swiper.realIndex = getVirtualRealIndex(activeIndex);
      return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) {
      realIndex = getVirtualRealIndex(activeIndex);
    } else if (gridEnabled) {
      const firstSlideInColumn = swiper.slides.find((slideEl) => slideEl.column === activeIndex);
      let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
      if (Number.isNaN(activeSlideIndex)) {
        activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
      }
      realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
      const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
      if (slideIndex) {
        realIndex = parseInt(slideIndex, 10);
      } else {
        realIndex = activeIndex;
      }
    } else {
      realIndex = activeIndex;
    }
    Object.assign(swiper, {
      previousSnapIndex,
      snapIndex,
      previousRealIndex,
      realIndex,
      previousIndex,
      activeIndex
    });
    if (swiper.initialized) {
      preload(swiper);
    }
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
      if (previousRealIndex !== realIndex) {
        swiper.emit("realIndexChange");
      }
      swiper.emit("slideChange");
    }
  }
  function updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide2 = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide2 && swiper.isElement && path && path.length > 1 && path.includes(el)) {
      [...path.slice(path.indexOf(el) + 1, path.length)].forEach((pathEl) => {
        if (!slide2 && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
          slide2 = pathEl;
        }
      });
    }
    let slideFound = false;
    let slideIndex;
    if (slide2) {
      for (let i2 = 0; i2 < swiper.slides.length; i2 += 1) {
        if (swiper.slides[i2] === slide2) {
          slideFound = true;
          slideIndex = i2;
          break;
        }
      }
    }
    if (slide2 && slideFound) {
      swiper.clickedSlide = slide2;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        swiper.clickedIndex = parseInt(slide2.getAttribute("data-swiper-slide-index"), 10);
      } else {
        swiper.clickedIndex = slideIndex;
      }
    } else {
      swiper.clickedSlide = void 0;
      swiper.clickedIndex = void 0;
      return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== void 0 && swiper.clickedIndex !== swiper.activeIndex) {
      swiper.slideToClickedSlide();
    }
  }
  var update = {
    updateSize,
    updateSlides,
    updateAutoHeight,
    updateSlidesOffset,
    updateSlidesProgress,
    updateProgress,
    updateSlidesClasses,
    updateActiveIndex,
    updateClickedSlide
  };
  function getSwiperTranslate(axis = this.isHorizontal() ? "x" : "y") {
    const swiper = this;
    const {
      params,
      rtlTranslate: rtl,
      translate: translate2,
      wrapperEl
    } = swiper;
    if (params.virtualTranslate) {
      return rtl ? -translate2 : translate2;
    }
    if (params.cssMode) {
      return translate2;
    }
    let currentTranslate = getTranslate(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
  }
  function setTranslate(translate2, byController) {
    const swiper = this;
    const {
      rtlTranslate: rtl,
      params,
      wrapperEl,
      progress
    } = swiper;
    let x = 0;
    let y = 0;
    const z2 = 0;
    if (swiper.isHorizontal()) {
      x = rtl ? -translate2 : translate2;
    } else {
      y = translate2;
    }
    if (params.roundLengths) {
      x = Math.floor(x);
      y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) {
      wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    } else if (!params.virtualTranslate) {
      if (swiper.isHorizontal()) {
        x -= swiper.cssOverflowAdjustment();
      } else {
        y -= swiper.cssOverflowAdjustment();
      }
      wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z2}px)`;
    }
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (translate2 - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== progress) {
      swiper.updateProgress(translate2);
    }
    swiper.emit("setTranslate", swiper.translate, byController);
  }
  function minTranslate() {
    return -this.snapGrid[0];
  }
  function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }
  function translateTo(translate2 = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const {
      params,
      wrapperEl
    } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }
    const minTranslate2 = swiper.minTranslate();
    const maxTranslate2 = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate2 > minTranslate2) newTranslate = minTranslate2;
    else if (translateBounds && translate2 < maxTranslate2) newTranslate = maxTranslate2;
    else newTranslate = translate2;
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
      const isH = swiper.isHorizontal();
      if (speed === 0) {
        wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
      } else {
        if (!swiper.support.smoothScroll) {
          animateCSSModeScroll({
            swiper,
            targetPosition: -newTranslate,
            side: isH ? "left" : "top"
          });
          return true;
        }
        wrapperEl.scrollTo({
          [isH ? "left" : "top"]: -newTranslate,
          behavior: "smooth"
        });
      }
      return true;
    }
    if (speed === 0) {
      swiper.setTransition(0);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.emit("transitionEnd");
      }
    } else {
      swiper.setTransition(speed);
      swiper.setTranslate(newTranslate);
      if (runCallbacks) {
        swiper.emit("beforeTransitionStart", speed, internal);
        swiper.emit("transitionStart");
      }
      if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onTranslateToWrapperTransitionEnd) {
          swiper.onTranslateToWrapperTransitionEnd = function transitionEnd2(e2) {
            if (!swiper || swiper.destroyed) return;
            if (e2.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
            swiper.onTranslateToWrapperTransitionEnd = null;
            delete swiper.onTranslateToWrapperTransitionEnd;
            swiper.animating = false;
            if (runCallbacks) {
              swiper.emit("transitionEnd");
            }
          };
        }
        swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
      }
    }
    return true;
  }
  var translate = {
    getTranslate: getSwiperTranslate,
    setTranslate,
    minTranslate,
    maxTranslate,
    translateTo
  };
  function setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
      swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
      swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
  }
  function transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step
  }) {
    const {
      activeIndex,
      previousIndex
    } = swiper;
    let dir = direction;
    if (!dir) {
      if (activeIndex > previousIndex) dir = "next";
      else if (activeIndex < previousIndex) dir = "prev";
      else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === "reset") {
      swiper.emit(`slideResetTransition${step}`);
    } else if (runCallbacks && activeIndex !== previousIndex) {
      swiper.emit(`slideChangeTransition${step}`);
      if (dir === "next") {
        swiper.emit(`slideNextTransition${step}`);
      } else {
        swiper.emit(`slidePrevTransition${step}`);
      }
    }
  }
  function transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const {
      params
    } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    transitionEmit({
      swiper,
      runCallbacks,
      direction,
      step: "Start"
    });
  }
  function transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const {
      params
    } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    transitionEmit({
      swiper,
      runCallbacks,
      direction,
      step: "End"
    });
  }
  var transition = {
    setTransition,
    transitionStart,
    transitionEnd
  };
  function slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === "string") {
      index = parseInt(index, 10);
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const {
      params,
      snapGrid,
      slidesGrid,
      previousIndex,
      activeIndex,
      rtlTranslate: rtl,
      wrapperEl,
      enabled
    } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) {
      return false;
    }
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate2 = -snapGrid[snapIndex];
    if (params.normalizeSlideIndex) {
      for (let i2 = 0; i2 < slidesGrid.length; i2 += 1) {
        const normalizedTranslate = -Math.floor(translate2 * 100);
        const normalizedGrid = Math.floor(slidesGrid[i2] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i2 + 1] * 100);
        if (typeof slidesGrid[i2 + 1] !== "undefined") {
          if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
            slideIndex = i2;
          } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
            slideIndex = i2 + 1;
          }
        } else if (normalizedTranslate >= normalizedGrid) {
          slideIndex = i2;
        }
      }
    }
    if (swiper.initialized && slideIndex !== activeIndex) {
      if (!swiper.allowSlideNext && (rtl ? translate2 > swiper.translate && translate2 > swiper.minTranslate() : translate2 < swiper.translate && translate2 < swiper.minTranslate())) {
        return false;
      }
      if (!swiper.allowSlidePrev && translate2 > swiper.translate && translate2 > swiper.maxTranslate()) {
        if ((activeIndex || 0) !== slideIndex) {
          return false;
        }
      }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) {
      swiper.emit("beforeSlideChangeStart");
    }
    swiper.updateProgress(translate2);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    if (!isInitialVirtual && (rtl && -translate2 === swiper.translate || !rtl && translate2 === swiper.translate)) {
      swiper.updateActiveIndex(slideIndex);
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      swiper.updateSlidesClasses();
      if (params.effect !== "slide") {
        swiper.setTranslate(translate2);
      }
      if (direction !== "reset") {
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      }
      return false;
    }
    if (params.cssMode) {
      const isH = swiper.isHorizontal();
      const t2 = rtl ? translate2 : -translate2;
      if (speed === 0) {
        if (isVirtual) {
          swiper.wrapperEl.style.scrollSnapType = "none";
          swiper._immediateVirtual = true;
        }
        if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
          swiper._cssModeVirtualInitialSet = true;
          requestAnimationFrame(() => {
            wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t2;
          });
        } else {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t2;
        }
        if (isVirtual) {
          requestAnimationFrame(() => {
            swiper.wrapperEl.style.scrollSnapType = "";
            swiper._immediateVirtual = false;
          });
        }
      } else {
        if (!swiper.support.smoothScroll) {
          animateCSSModeScroll({
            swiper,
            targetPosition: t2,
            side: isH ? "left" : "top"
          });
          return true;
        }
        wrapperEl.scrollTo({
          [isH ? "left" : "top"]: t2,
          behavior: "smooth"
        });
      }
      return true;
    }
    const browser2 = getBrowser();
    const isSafari = browser2.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) {
      swiper.virtual.update(false, false, slideIndex);
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate2);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) {
      swiper.transitionEnd(runCallbacks, direction);
    } else if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd2(e2) {
          if (!swiper || swiper.destroyed) return;
          if (e2.target !== this) return;
          swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }
      swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
  }
  function slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === "string") {
      const indexAsNumber = parseInt(index, 10);
      index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
      if (swiper.virtual && swiper.params.virtual.enabled) {
        newIndex = newIndex + swiper.virtual.slidesBefore;
      } else {
        let targetSlideIndex;
        if (gridEnabled) {
          const slideIndex = newIndex * swiper.params.grid.rows;
          targetSlideIndex = swiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
        } else {
          targetSlideIndex = swiper.getSlideIndexByData(newIndex);
        }
        const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
        const {
          centeredSlides,
          slidesOffsetBefore,
          slidesOffsetAfter
        } = swiper.params;
        const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
        let slidesPerView = swiper.params.slidesPerView;
        if (slidesPerView === "auto") {
          slidesPerView = swiper.slidesPerViewDynamic();
        } else {
          slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
          if (bothDirections && slidesPerView % 2 === 0) {
            slidesPerView = slidesPerView + 1;
          }
        }
        let needLoopFix = cols - targetSlideIndex < slidesPerView;
        if (bothDirections) {
          needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
        }
        if (internal && bothDirections && swiper.params.slidesPerView !== "auto" && !gridEnabled) {
          needLoopFix = false;
        }
        if (needLoopFix) {
          const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
          swiper.loopFix({
            direction,
            slideTo: true,
            activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
            slideRealIndex: direction === "next" ? swiper.realIndex : void 0
          });
        }
        if (gridEnabled) {
          const slideIndex = newIndex * swiper.params.grid.rows;
          newIndex = swiper.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex).column;
        } else {
          newIndex = swiper.getSlideIndexByData(newIndex);
        }
      }
    }
    requestAnimationFrame(() => {
      swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
  }
  function slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const {
      enabled,
      params,
      animating
    } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    }
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
      if (animating && !isVirtual && params.loopPreventsSliding) return false;
      swiper.loopFix({
        direction: "next"
      });
      swiper._clientLeft = swiper.wrapperEl.clientLeft;
      if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
        requestAnimationFrame(() => {
          swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
        });
        return true;
      }
    }
    if (params.rewind && swiper.isEnd) {
      return swiper.slideTo(0, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
  }
  function slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const {
      params,
      snapGrid,
      slidesGrid,
      rtlTranslate,
      enabled,
      animating
    } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
      if (animating && !isVirtual && params.loopPreventsSliding) return false;
      swiper.loopFix({
        direction: "prev"
      });
      swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate2 = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
      if (val < 0) return -Math.floor(Math.abs(val));
      return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate2);
    const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && (params.cssMode || isFreeMode)) {
      let prevSnapIndex;
      snapGrid.forEach((snap, snapIndex) => {
        if (normalizedTranslate >= snap) {
          prevSnapIndex = snapIndex;
        }
      });
      if (typeof prevSnapIndex !== "undefined") {
        prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
      }
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
      prevIndex = slidesGrid.indexOf(prevSnap);
      if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
      if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
        prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
        prevIndex = Math.max(prevIndex, 0);
      }
    }
    if (params.rewind && swiper.isBeginning) {
      const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
      return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
      requestAnimationFrame(() => {
        swiper.slideTo(prevIndex, speed, runCallbacks, internal);
      });
      return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
  }
  function slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
  }
  function slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") {
      speed = swiper.params.speed;
    }
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate2 = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate2 >= swiper.snapGrid[snapIndex]) {
      const currentSnap = swiper.snapGrid[snapIndex];
      const nextSnap = swiper.snapGrid[snapIndex + 1];
      if (translate2 - currentSnap > (nextSnap - currentSnap) * threshold) {
        index += swiper.params.slidesPerGroup;
      }
    } else {
      const prevSnap = swiper.snapGrid[snapIndex - 1];
      const currentSnap = swiper.snapGrid[snapIndex];
      if (translate2 - prevSnap <= (currentSnap - prevSnap) * threshold) {
        index -= swiper.params.slidesPerGroup;
      }
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
  }
  function slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const {
      params,
      slidesEl
    } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
      if (swiper.animating) return;
      realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
      if (params.centeredSlides) {
        swiper.slideToLoop(realIndex);
      } else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex(elementChildren(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else {
      swiper.slideTo(slideToIndex);
    }
  }
  var slide = {
    slideTo,
    slideToLoop,
    slideNext,
    slidePrev,
    slideReset,
    slideToClosest,
    slideToClickedSlide
  };
  function loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const {
      params,
      slidesEl
    } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = () => {
      const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
      slides.forEach((el, index) => {
        el.setAttribute("data-swiper-slide-index", index);
      });
    };
    const clearBlankSlides = () => {
      const slides = elementChildren(slidesEl, `.${params.slideBlankClass}`);
      slides.forEach((el) => {
        el.remove();
      });
      if (slides.length > 0) {
        swiper.recalcSlides();
        swiper.updateSlides();
      }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) {
      clearBlankSlides();
    }
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides) => {
      for (let i2 = 0; i2 < amountOfSlides; i2 += 1) {
        const slideEl = swiper.isElement ? createElement2("swiper-slide", [params.slideBlankClass]) : createElement2("div", [params.slideClass, params.slideBlankClass]);
        swiper.slidesEl.append(slideEl);
      }
    };
    if (shouldFillGroup) {
      if (params.loopAddBlankSlides) {
        const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
        addBlankSlides(slidesToAdd);
        swiper.recalcSlides();
        swiper.updateSlides();
      } else {
        showWarning("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      }
      initSlides();
    } else if (shouldFillGrid) {
      if (params.loopAddBlankSlides) {
        const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
        addBlankSlides(slidesToAdd);
        swiper.recalcSlides();
        swiper.updateSlides();
      } else {
        showWarning("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      }
      initSlides();
    } else {
      initSlides();
    }
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
      slideRealIndex,
      direction: bothDirections ? void 0 : "next",
      initial
    });
  }
  function loopFix({
    slideRealIndex,
    slideTo: slideTo2 = true,
    direction,
    setTranslate: setTranslate2,
    activeSlideIndex,
    initial,
    byController,
    byMousewheel
  } = {}) {
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const {
      slides,
      allowSlidePrev,
      allowSlideNext,
      slidesEl,
      params
    } = swiper;
    const {
      centeredSlides,
      slidesOffsetBefore,
      slidesOffsetAfter,
      initialSlide
    } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
      if (slideTo2) {
        if (!bothDirections && swiper.snapIndex === 0) {
          swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
        } else if (bothDirections && swiper.snapIndex < params.slidesPerView) {
          swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
        } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
          swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
      }
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      swiper.emit("loopFix");
      return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") {
      slidesPerView = swiper.slidesPerViewDynamic();
    } else {
      slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
      if (bothDirections && slidesPerView % 2 === 0) {
        slidesPerView = slidesPerView + 1;
      }
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) {
      loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    }
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
      showWarning("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    } else if (gridEnabled && params.grid.fill === "row") {
      showWarning("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    }
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") {
      activeSlideIndex = swiper.getSlideIndex(slides.find((el) => el.classList.contains(params.slideActiveClass)));
    } else {
      activeIndex = activeSlideIndex;
    }
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate2 === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    if (activeColIndexWithShift < loopedSlides) {
      slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
      for (let i2 = 0; i2 < loopedSlides - activeColIndexWithShift; i2 += 1) {
        const index = i2 - Math.floor(i2 / cols) * cols;
        if (gridEnabled) {
          const colIndexToPrepend = cols - index - 1;
          for (let i3 = slides.length - 1; i3 >= 0; i3 -= 1) {
            if (slides[i3].column === colIndexToPrepend) prependSlidesIndexes.push(i3);
          }
        } else {
          prependSlidesIndexes.push(cols - index - 1);
        }
      }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
      slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
      if (isInitialOverflow) {
        slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
      }
      for (let i2 = 0; i2 < slidesAppended; i2 += 1) {
        const index = i2 - Math.floor(i2 / cols) * cols;
        if (gridEnabled) {
          slides.forEach((slide2, slideIndex) => {
            if (slide2.column === index) appendSlidesIndexes.push(slideIndex);
          });
        } else {
          appendSlidesIndexes.push(index);
        }
      }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === "cards" && slides.length < slidesPerView + loopedSlides * 2) {
      if (appendSlidesIndexes.includes(activeSlideIndex)) {
        appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
      }
      if (prependSlidesIndexes.includes(activeSlideIndex)) {
        prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
      }
    }
    if (isPrev) {
      prependSlidesIndexes.forEach((index) => {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
      });
    }
    if (isNext) {
      appendSlidesIndexes.forEach((index) => {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
      });
    }
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") {
      swiper.updateSlides();
    } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
      swiper.slides.forEach((slide2, slideIndex) => {
        swiper.grid.updateSlide(slideIndex, slide2, swiper.slides);
      });
    }
    if (params.watchSlidesProgress) {
      swiper.updateSlidesOffset();
    }
    if (slideTo2) {
      if (prependSlidesIndexes.length > 0 && isPrev) {
        if (typeof slideRealIndex === "undefined") {
          const currentSlideTranslate = swiper.slidesGrid[activeIndex];
          const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
          const diff = newSlideTranslate - currentSlideTranslate;
          if (byMousewheel) {
            swiper.setTranslate(swiper.translate - diff);
          } else {
            swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
            if (setTranslate2) {
              swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
              swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
            }
          }
        } else {
          if (setTranslate2) {
            const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
            swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
            swiper.touchEventsData.currentTranslate = swiper.translate;
          }
        }
      } else if (appendSlidesIndexes.length > 0 && isNext) {
        if (typeof slideRealIndex === "undefined") {
          const currentSlideTranslate = swiper.slidesGrid[activeIndex];
          const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
          const diff = newSlideTranslate - currentSlideTranslate;
          if (byMousewheel) {
            swiper.setTranslate(swiper.translate - diff);
          } else {
            swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
            if (setTranslate2) {
              swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
              swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
            }
          }
        } else {
          const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
        }
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
      const loopParams = {
        slideRealIndex,
        direction,
        setTranslate: setTranslate2,
        activeSlideIndex,
        byController: true
      };
      if (Array.isArray(swiper.controller.control)) {
        swiper.controller.control.forEach((c) => {
          if (!c.destroyed && c.params.loop) c.loopFix({
            ...loopParams,
            slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo2 : false
          });
        });
      } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
        swiper.controller.control.loopFix({
          ...loopParams,
          slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo2 : false
        });
      }
    }
    swiper.emit("loopFix");
  }
  function loopDestroy() {
    const swiper = this;
    const {
      params,
      slidesEl
    } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl) => {
      const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
      newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl) => {
      slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl) => {
      slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
  }
  var loop = {
    loopCreate,
    loopFix,
    loopDestroy
  };
  function setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) {
      swiper.__preventObserver__ = true;
    }
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) {
      requestAnimationFrame(() => {
        swiper.__preventObserver__ = false;
      });
    }
  }
  function unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
      return;
    }
    if (swiper.isElement) {
      swiper.__preventObserver__ = true;
    }
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) {
      requestAnimationFrame(() => {
        swiper.__preventObserver__ = false;
      });
    }
  }
  var grabCursor = {
    setGrabCursor,
    unsetGrabCursor
  };
  function closestElement(selector, base = this) {
    function __closestFrom(el) {
      if (!el || el === getDocument() || el === getWindow()) return null;
      if (el.assignedSlot) el = el.assignedSlot;
      const found = el.closest(selector);
      if (!found && !el.getRootNode) {
        return null;
      }
      return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
  }
  function preventEdgeSwipe(swiper, event2, startX) {
    const window2 = getWindow();
    const {
      params
    } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window2.innerWidth - edgeSwipeThreshold)) {
      if (edgeSwipeDetection === "prevent") {
        event2.preventDefault();
        return true;
      }
      return false;
    }
    return true;
  }
  function onTouchStart(event2) {
    const swiper = this;
    const document2 = getDocument();
    let e2 = event2;
    if (e2.originalEvent) e2 = e2.originalEvent;
    const data = swiper.touchEventsData;
    if (e2.type === "pointerdown") {
      if (data.pointerId !== null && data.pointerId !== e2.pointerId) {
        return;
      }
      data.pointerId = e2.pointerId;
    } else if (e2.type === "touchstart" && e2.targetTouches.length === 1) {
      data.touchId = e2.targetTouches[0].identifier;
    }
    if (e2.type === "touchstart") {
      preventEdgeSwipe(swiper, e2, e2.targetTouches[0].pageX);
      return;
    }
    const {
      params,
      touches,
      enabled
    } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e2.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) {
      return;
    }
    if (!swiper.animating && params.cssMode && params.loop) {
      swiper.loopFix();
    }
    let targetEl = e2.target;
    if (params.touchEventsTarget === "wrapper") {
      if (!elementIsChildOf(targetEl, swiper.wrapperEl)) return;
    }
    if ("which" in e2 && e2.which === 3) return;
    if ("button" in e2 && e2.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    const eventPath = e2.composedPath ? e2.composedPath() : e2.path;
    if (swipingClassHasValue && e2.target && e2.target.shadowRoot && eventPath) {
      targetEl = eventPath[0];
    }
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e2.target && e2.target.shadowRoot);
    if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
      swiper.allowClick = true;
      return;
    }
    if (params.swipeHandler) {
      if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e2.pageX;
    touches.currentY = e2.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    if (!preventEdgeSwipe(swiper, e2, startX)) {
      return;
    }
    Object.assign(data, {
      isTouched: true,
      isMoved: false,
      allowTouchCallbacks: true,
      isScrolling: void 0,
      startMoving: void 0
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = now();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = void 0;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
      preventDefault = false;
      if (targetEl.nodeName === "SELECT") {
        data.isTouched = false;
      }
    }
    if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== targetEl && (e2.pointerType === "mouse" || e2.pointerType !== "mouse" && !targetEl.matches(data.focusableElements))) {
      document2.activeElement.blur();
    }
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
      e2.preventDefault();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
      swiper.freeMode.onTouchStart();
    }
    swiper.emit("touchStart", e2);
  }
  function onTouchMove(event2) {
    const document2 = getDocument();
    const swiper = this;
    const data = swiper.touchEventsData;
    const {
      params,
      touches,
      rtlTranslate: rtl,
      enabled
    } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event2.pointerType === "mouse") return;
    let e2 = event2;
    if (e2.originalEvent) e2 = e2.originalEvent;
    if (e2.type === "pointermove") {
      if (data.touchId !== null) return;
      const id = e2.pointerId;
      if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e2.type === "touchmove") {
      targetTouch = [...e2.changedTouches].find((t2) => t2.identifier === data.touchId);
      if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else {
      targetTouch = e2;
    }
    if (!data.isTouched) {
      if (data.startMoving && data.isScrolling) {
        swiper.emit("touchMoveOpposite", e2);
      }
      return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e2.preventedByNestedSwiper) {
      touches.startX = pageX;
      touches.startY = pageY;
      return;
    }
    if (!swiper.allowTouchMove) {
      if (!e2.target.matches(data.focusableElements)) {
        swiper.allowClick = false;
      }
      if (data.isTouched) {
        Object.assign(touches, {
          startX: pageX,
          startY: pageY,
          currentX: pageX,
          currentY: pageY
        });
        data.touchStartTime = now();
      }
      return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
      if (swiper.isVertical()) {
        if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
          data.isTouched = false;
          data.isMoved = false;
          return;
        }
      } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) {
        return;
      } else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) {
        return;
      }
    }
    if (document2.activeElement && document2.activeElement.matches(data.focusableElements) && document2.activeElement !== e2.target && e2.pointerType !== "mouse") {
      document2.activeElement.blur();
    }
    if (document2.activeElement) {
      if (e2.target === document2.activeElement && e2.target.matches(data.focusableElements)) {
        data.isMoved = true;
        swiper.allowClick = false;
        return;
      }
    }
    if (data.allowTouchCallbacks) {
      swiper.emit("touchMove", e2);
    }
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
      let touchAngle;
      if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
        data.isScrolling = false;
      } else {
        if (diffX * diffX + diffY * diffY >= 25) {
          touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
          data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
      }
    }
    if (data.isScrolling) {
      swiper.emit("touchMoveOpposite", e2);
    }
    if (typeof data.startMoving === "undefined") {
      if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
        data.startMoving = true;
      }
    }
    if (data.isScrolling || e2.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
      data.isTouched = false;
      return;
    }
    if (!data.startMoving) {
      return;
    }
    swiper.allowClick = false;
    if (!params.cssMode && e2.cancelable) {
      e2.preventDefault();
    }
    if (params.touchMoveStopPropagation && !params.nested) {
      e2.stopPropagation();
    }
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
      diff = Math.abs(diff) * (rtl ? 1 : -1);
      touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
      diff = -diff;
      touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
      if (isLoop && allowLoopFix) {
        swiper.loopFix({
          direction: swiper.swipeDirection
        });
      }
      data.startTranslate = swiper.getTranslate();
      swiper.setTransition(0);
      if (swiper.animating) {
        const evt = new window.CustomEvent("transitionend", {
          bubbles: true,
          cancelable: true,
          detail: {
            bySwiperTouchMove: true
          }
        });
        swiper.wrapperEl.dispatchEvent(evt);
      }
      data.allowMomentumBounce = false;
      if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(true);
      }
      swiper.emit("sliderFirstMove", e2);
    }
    let loopFixed;
    (/* @__PURE__ */ new Date()).getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY,
        startTranslate: data.currentTranslate
      });
      data.loopSwapReset = true;
      data.startTranslate = data.currentTranslate;
      return;
    }
    swiper.emit("sliderMove", e2);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
      resistanceRatio = 0;
    }
    if (diff > 0) {
      if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) {
        swiper.loopFix({
          direction: "prev",
          setTranslate: true,
          activeSlideIndex: 0
        });
      }
      if (data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) {
          data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
      }
    } else if (diff < 0) {
      if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) {
        swiper.loopFix({
          direction: "next",
          setTranslate: true,
          activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
      }
      if (data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) {
          data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
      }
    }
    if (disableParentSwiper) {
      e2.preventedByNestedSwiper = true;
    }
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) {
      data.currentTranslate = data.startTranslate;
    }
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
      data.currentTranslate = data.startTranslate;
    }
    if (params.threshold > 0) {
      if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
        if (!data.allowThresholdMove) {
          data.allowThresholdMove = true;
          touches.startX = touches.currentX;
          touches.startY = touches.currentY;
          data.currentTranslate = data.startTranslate;
          touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
          return;
        }
      } else {
        data.currentTranslate = data.startTranslate;
        return;
      }
    }
    if (!params.followFinger || params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
      swiper.freeMode.onTouchMove();
    }
    swiper.updateProgress(data.currentTranslate);
    swiper.setTranslate(data.currentTranslate);
  }
  function onTouchEnd(event2) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e2 = event2;
    if (e2.originalEvent) e2 = e2.originalEvent;
    let targetTouch;
    const isTouchEvent = e2.type === "touchend" || e2.type === "touchcancel";
    if (!isTouchEvent) {
      if (data.touchId !== null) return;
      if (e2.pointerId !== data.pointerId) return;
      targetTouch = e2;
    } else {
      targetTouch = [...e2.changedTouches].find((t2) => t2.identifier === data.touchId);
      if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(e2.type)) {
      const proceed = ["pointercancel", "contextmenu"].includes(e2.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
      if (!proceed) {
        return;
      }
    }
    data.pointerId = null;
    data.touchId = null;
    const {
      params,
      touches,
      rtlTranslate: rtl,
      slidesGrid,
      enabled
    } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e2.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) {
      swiper.emit("touchEnd", e2);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
      if (data.isMoved && params.grabCursor) {
        swiper.setGrabCursor(false);
      }
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(false);
    }
    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;
    if (swiper.allowClick) {
      const pathTree = e2.path || e2.composedPath && e2.composedPath();
      swiper.updateClickedSlide(pathTree && pathTree[0] || e2.target, pathTree);
      swiper.emit("tap click", e2);
      if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
        swiper.emit("doubleTap doubleClick", e2);
      }
    }
    data.lastClickTime = now();
    nextTick(() => {
      if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) {
      currentPos = rtl ? swiper.translate : -swiper.translate;
    } else {
      currentPos = -data.currentTranslate;
    }
    if (params.cssMode) {
      return;
    }
    if (params.freeMode && params.freeMode.enabled) {
      swiper.freeMode.onTouchEnd({
        currentPos
      });
      return;
    }
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for (let i2 = 0; i2 < slidesGrid.length; i2 += i2 < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
      const increment2 = i2 < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
      if (typeof slidesGrid[i2 + increment2] !== "undefined") {
        if (swipeToLast || currentPos >= slidesGrid[i2] && currentPos < slidesGrid[i2 + increment2]) {
          stopIndex = i2;
          groupSize = slidesGrid[i2 + increment2] - slidesGrid[i2];
        }
      } else if (swipeToLast || currentPos >= slidesGrid[i2]) {
        stopIndex = i2;
        groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
      }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
      if (swiper.isBeginning) {
        rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
      } else if (swiper.isEnd) {
        rewindFirstIndex = 0;
      }
    }
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
      if (!params.longSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      if (swiper.swipeDirection === "next") {
        if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
        else swiper.slideTo(stopIndex);
      }
      if (swiper.swipeDirection === "prev") {
        if (ratio > 1 - params.longSwipesRatio) {
          swiper.slideTo(stopIndex + increment);
        } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
          swiper.slideTo(rewindLastIndex);
        } else {
          swiper.slideTo(stopIndex);
        }
      }
    } else {
      if (!params.shortSwipes) {
        swiper.slideTo(swiper.activeIndex);
        return;
      }
      const isNavButtonTarget = swiper.navigation && (e2.target === swiper.navigation.nextEl || e2.target === swiper.navigation.prevEl);
      if (!isNavButtonTarget) {
        if (swiper.swipeDirection === "next") {
          swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
        }
        if (swiper.swipeDirection === "prev") {
          swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        }
      } else if (e2.target === swiper.navigation.nextEl) {
        swiper.slideTo(stopIndex + increment);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  }
  function onResize() {
    const swiper = this;
    const {
      params,
      el
    } = swiper;
    if (el && el.offsetWidth === 0) return;
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    const {
      allowSlideNext,
      allowSlidePrev,
      snapGrid
    } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      if (swiper.params.loop && !isVirtual) {
        swiper.slideToLoop(swiper.realIndex, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
      clearTimeout(swiper.autoplay.resizeTimeout);
      swiper.autoplay.resizeTimeout = setTimeout(() => {
        if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
          swiper.autoplay.resume();
        }
      }, 500);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
  }
  function onClick(e2) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
      if (swiper.params.preventClicks) e2.preventDefault();
      if (swiper.params.preventClicksPropagation && swiper.animating) {
        e2.stopPropagation();
        e2.stopImmediatePropagation();
      }
    }
  }
  function onScroll() {
    const swiper = this;
    const {
      wrapperEl,
      rtlTranslate,
      enabled
    } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) {
      swiper.translate = -wrapperEl.scrollLeft;
    } else {
      swiper.translate = -wrapperEl.scrollTop;
    }
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
      newProgress = 0;
    } else {
      newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== swiper.progress) {
      swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    }
    swiper.emit("setTranslate", swiper.translate, false);
  }
  function onLoad(e2) {
    const swiper = this;
    processLazyPreloader(swiper, e2.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) {
      return;
    }
    swiper.update();
  }
  function onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) {
      swiper.el.style.touchAction = "auto";
    }
  }
  var events = (swiper, method) => {
    const document2 = getDocument();
    const {
      params,
      el,
      wrapperEl,
      device
    } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    if (!el || typeof el === "string") return;
    document2[domMethod]("touchstart", swiper.onDocumentTouchStart, {
      passive: false,
      capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
      passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
      passive: false
    });
    document2[domMethod]("touchmove", swiper.onTouchMove, {
      passive: false,
      capture
    });
    document2[domMethod]("pointermove", swiper.onTouchMove, {
      passive: false,
      capture
    });
    document2[domMethod]("touchend", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointerup", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointercancel", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("touchcancel", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointerout", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("pointerleave", swiper.onTouchEnd, {
      passive: true
    });
    document2[domMethod]("contextmenu", swiper.onTouchEnd, {
      passive: true
    });
    if (params.preventClicks || params.preventClicksPropagation) {
      el[domMethod]("click", swiper.onClick, true);
    }
    if (params.cssMode) {
      wrapperEl[domMethod]("scroll", swiper.onScroll);
    }
    if (params.updateOnWindowResize) {
      swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", onResize, true);
    } else {
      swiper[swiperMethod]("observerUpdate", onResize, true);
    }
    el[domMethod]("load", swiper.onLoad, {
      capture: true
    });
  };
  function attachEvents() {
    const swiper = this;
    const {
      params
    } = swiper;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
    if (params.cssMode) {
      swiper.onScroll = onScroll.bind(swiper);
    }
    swiper.onClick = onClick.bind(swiper);
    swiper.onLoad = onLoad.bind(swiper);
    events(swiper, "on");
  }
  function detachEvents() {
    const swiper = this;
    events(swiper, "off");
  }
  var events$1 = {
    attachEvents,
    detachEvents
  };
  var isGridEnabled = (swiper, params) => {
    return swiper.grid && params.grid && params.grid.rows > 1;
  };
  function setBreakpoint() {
    const swiper = this;
    const {
      realIndex,
      initialized,
      params,
      el
    } = swiper;
    const breakpoints2 = params.breakpoints;
    if (!breakpoints2 || breakpoints2 && Object.keys(breakpoints2).length === 0) return;
    const document2 = getDocument();
    const breakpointsBase = params.breakpointsBase === "window" || !params.breakpointsBase ? params.breakpointsBase : "container";
    const breakpointContainer = ["window", "container"].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document2.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints2, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints2 ? breakpoints2[breakpoint] : void 0;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = isGridEnabled(swiper, params);
    const isMultiRow = isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
      el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
      swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
      el.classList.add(`${params.containerModifierClass}grid`);
      if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") {
        el.classList.add(`${params.containerModifierClass}grid-column`);
      }
      swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) {
      swiper.unsetGrabCursor();
    } else if (!wasGrabCursor && isGrabCursor) {
      swiper.setGrabCursor();
    }
    ["navigation", "pagination", "scrollbar"].forEach((prop) => {
      if (typeof breakpointParams[prop] === "undefined") return;
      const wasModuleEnabled = params[prop] && params[prop].enabled;
      const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
      if (wasModuleEnabled && !isModuleEnabled) {
        swiper[prop].disable();
      }
      if (!wasModuleEnabled && isModuleEnabled) {
        swiper[prop].enable();
      }
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) {
      swiper.changeDirection();
    }
    extend2(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) {
      swiper.disable();
    } else if (!wasEnabled && isEnabled) {
      swiper.enable();
    }
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
      if (needsReLoop) {
        swiper.loopDestroy();
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
      } else if (!wasLoop && hasLoop) {
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
      } else if (wasLoop && !hasLoop) {
        swiper.loopDestroy();
      }
    }
    swiper.emit("breakpoint", breakpointParams);
  }
  function getBreakpoint(breakpoints2, base = "window", containerEl) {
    if (!breakpoints2 || base === "container" && !containerEl) return void 0;
    let breakpoint = false;
    const window2 = getWindow();
    const currentHeight = base === "window" ? window2.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints2).map((point) => {
      if (typeof point === "string" && point.indexOf("@") === 0) {
        const minRatio = parseFloat(point.substr(1));
        const value = currentHeight * minRatio;
        return {
          value,
          point
        };
      }
      return {
        value: point,
        point
      };
    });
    points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
    for (let i2 = 0; i2 < points.length; i2 += 1) {
      const {
        point,
        value
      } = points[i2];
      if (base === "window") {
        if (window2.matchMedia(`(min-width: ${value}px)`).matches) {
          breakpoint = point;
        }
      } else if (value <= containerEl.clientWidth) {
        breakpoint = point;
      }
    }
    return breakpoint || "max";
  }
  var breakpoints = {
    setBreakpoint,
    getBreakpoint
  };
  function prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item) => {
      if (typeof item === "object") {
        Object.keys(item).forEach((classNames) => {
          if (item[classNames]) {
            resultClasses.push(prefix + classNames);
          }
        });
      } else if (typeof item === "string") {
        resultClasses.push(prefix + item);
      }
    });
    return resultClasses;
  }
  function addClasses() {
    const swiper = this;
    const {
      classNames,
      params,
      rtl,
      el,
      device
    } = swiper;
    const suffixes = prepareClasses(["initialized", params.direction, {
      "free-mode": swiper.params.freeMode && params.freeMode.enabled
    }, {
      "autoheight": params.autoHeight
    }, {
      "rtl": rtl
    }, {
      "grid": params.grid && params.grid.rows > 1
    }, {
      "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
    }, {
      "android": device.android
    }, {
      "ios": device.ios
    }, {
      "css-mode": params.cssMode
    }, {
      "centered": params.cssMode && params.centeredSlides
    }, {
      "watch-progress": params.watchSlidesProgress
    }], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
  }
  function removeClasses() {
    const swiper = this;
    const {
      el,
      classNames
    } = swiper;
    if (!el || typeof el === "string") return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
  }
  var classes = {
    addClasses,
    removeClasses
  };
  function checkOverflow() {
    const swiper = this;
    const {
      isLocked: wasLocked,
      params
    } = swiper;
    const {
      slidesOffsetBefore
    } = params;
    if (slidesOffsetBefore) {
      const lastSlideIndex = swiper.slides.length - 1;
      const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
      swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else {
      swiper.isLocked = swiper.snapGrid.length === 1;
    }
    if (params.allowSlideNext === true) {
      swiper.allowSlideNext = !swiper.isLocked;
    }
    if (params.allowSlidePrev === true) {
      swiper.allowSlidePrev = !swiper.isLocked;
    }
    if (wasLocked && wasLocked !== swiper.isLocked) {
      swiper.isEnd = false;
    }
    if (wasLocked !== swiper.isLocked) {
      swiper.emit(swiper.isLocked ? "lock" : "unlock");
    }
  }
  var checkOverflow$1 = {
    checkOverflow
  };
  var defaults = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: void 0,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
  };
  function moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
      const moduleParamName = Object.keys(obj)[0];
      const moduleParams = obj[moduleParamName];
      if (typeof moduleParams !== "object" || moduleParams === null) {
        extend2(allModulesParams, obj);
        return;
      }
      if (params[moduleParamName] === true) {
        params[moduleParamName] = {
          enabled: true
        };
      }
      if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
        params[moduleParamName].auto = true;
      }
      if (["pagination", "scrollbar"].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
        params[moduleParamName].auto = true;
      }
      if (!(moduleParamName in params && "enabled" in moduleParams)) {
        extend2(allModulesParams, obj);
        return;
      }
      if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) {
        params[moduleParamName].enabled = true;
      }
      if (!params[moduleParamName]) params[moduleParamName] = {
        enabled: false
      };
      extend2(allModulesParams, obj);
    };
  }
  var prototypes = {
    eventsEmitter,
    update,
    translate,
    transition,
    slide,
    loop,
    grabCursor,
    events: events$1,
    breakpoints,
    checkOverflow: checkOverflow$1,
    classes
  };
  var extendedDefaults = {};
  var Swiper3 = class _Swiper {
    constructor(...args) {
      let el;
      let params;
      if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") {
        params = args[0];
      } else {
        [el, params] = args;
      }
      if (!params) params = {};
      params = extend2({}, params);
      if (el && !params.el) params.el = el;
      const document2 = getDocument();
      if (params.el && typeof params.el === "string" && document2.querySelectorAll(params.el).length > 1) {
        const swipers = [];
        document2.querySelectorAll(params.el).forEach((containerEl) => {
          const newParams = extend2({}, params, {
            el: containerEl
          });
          swipers.push(new _Swiper(newParams));
        });
        return swipers;
      }
      const swiper = this;
      swiper.__swiper__ = true;
      swiper.support = getSupport();
      swiper.device = getDevice({
        userAgent: params.userAgent
      });
      swiper.browser = getBrowser();
      swiper.eventsListeners = {};
      swiper.eventsAnyListeners = [];
      swiper.modules = [...swiper.__modules__];
      if (params.modules && Array.isArray(params.modules)) {
        swiper.modules.push(...params.modules);
      }
      const allModulesParams = {};
      swiper.modules.forEach((mod) => {
        mod({
          params,
          swiper,
          extendParams: moduleExtendParams(params, allModulesParams),
          on: swiper.on.bind(swiper),
          once: swiper.once.bind(swiper),
          off: swiper.off.bind(swiper),
          emit: swiper.emit.bind(swiper)
        });
      });
      const swiperParams = extend2({}, defaults, allModulesParams);
      swiper.params = extend2({}, swiperParams, extendedDefaults, params);
      swiper.originalParams = extend2({}, swiper.params);
      swiper.passedParams = extend2({}, params);
      if (swiper.params && swiper.params.on) {
        Object.keys(swiper.params.on).forEach((eventName) => {
          swiper.on(eventName, swiper.params.on[eventName]);
        });
      }
      if (swiper.params && swiper.params.onAny) {
        swiper.onAny(swiper.params.onAny);
      }
      Object.assign(swiper, {
        enabled: swiper.params.enabled,
        el,
        // Classes
        classNames: [],
        // Slides
        slides: [],
        slidesGrid: [],
        snapGrid: [],
        slidesSizesGrid: [],
        // isDirection
        isHorizontal() {
          return swiper.params.direction === "horizontal";
        },
        isVertical() {
          return swiper.params.direction === "vertical";
        },
        // Indexes
        activeIndex: 0,
        realIndex: 0,
        //
        isBeginning: true,
        isEnd: false,
        // Props
        translate: 0,
        previousTranslate: 0,
        progress: 0,
        velocity: 0,
        animating: false,
        cssOverflowAdjustment() {
          return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
        },
        // Locks
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
        // Touch Events
        touchEventsData: {
          isTouched: void 0,
          isMoved: void 0,
          allowTouchCallbacks: void 0,
          touchStartTime: void 0,
          isScrolling: void 0,
          currentTranslate: void 0,
          startTranslate: void 0,
          allowThresholdMove: void 0,
          // Form elements to match
          focusableElements: swiper.params.focusableElements,
          // Last click time
          lastClickTime: 0,
          clickTimeout: void 0,
          // Velocities
          velocities: [],
          allowMomentumBounce: void 0,
          startMoving: void 0,
          pointerId: null,
          touchId: null
        },
        // Clicks
        allowClick: true,
        // Touches
        allowTouchMove: swiper.params.allowTouchMove,
        touches: {
          startX: 0,
          startY: 0,
          currentX: 0,
          currentY: 0,
          diff: 0
        },
        // Images
        imagesToLoad: [],
        imagesLoaded: 0
      });
      swiper.emit("_swiper");
      if (swiper.params.init) {
        swiper.init();
      }
      return swiper;
    }
    getDirectionLabel(property) {
      if (this.isHorizontal()) {
        return property;
      }
      return {
        "width": "height",
        "margin-top": "margin-left",
        "margin-bottom ": "margin-right",
        "margin-left": "margin-top",
        "margin-right": "margin-bottom",
        "padding-left": "padding-top",
        "padding-right": "padding-bottom",
        "marginRight": "marginBottom"
      }[property];
    }
    getSlideIndex(slideEl) {
      const {
        slidesEl,
        params
      } = this;
      const slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
      const firstSlideIndex = elementIndex(slides[0]);
      return elementIndex(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
      return this.getSlideIndex(this.slides.find((slideEl) => slideEl.getAttribute("data-swiper-slide-index") * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
      if (this.grid && this.params.grid && this.params.grid.rows > 1) {
        if (this.params.grid.fill === "column") {
          index = Math.floor(index / this.params.grid.rows);
        } else if (this.params.grid.fill === "row") {
          index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
      }
      return index;
    }
    recalcSlides() {
      const swiper = this;
      const {
        slidesEl,
        params
      } = swiper;
      swiper.slides = elementChildren(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
      const swiper = this;
      if (swiper.enabled) return;
      swiper.enabled = true;
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }
      swiper.emit("enable");
    }
    disable() {
      const swiper = this;
      if (!swiper.enabled) return;
      swiper.enabled = false;
      if (swiper.params.grabCursor) {
        swiper.unsetGrabCursor();
      }
      swiper.emit("disable");
    }
    setProgress(progress, speed) {
      const swiper = this;
      progress = Math.min(Math.max(progress, 0), 1);
      const min = swiper.minTranslate();
      const max = swiper.maxTranslate();
      const current = (max - min) * progress + min;
      swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
      const swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      const cls = swiper.el.className.split(" ").filter((className) => {
        return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
      });
      swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
      const swiper = this;
      if (swiper.destroyed) return "";
      return slideEl.className.split(" ").filter((className) => {
        return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
      }).join(" ");
    }
    emitSlidesClasses() {
      const swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      const updates = [];
      swiper.slides.forEach((slideEl) => {
        const classNames = swiper.getSlideClasses(slideEl);
        updates.push({
          slideEl,
          classNames
        });
        swiper.emit("_slideClass", slideEl, classNames);
      });
      swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view = "current", exact = false) {
      const swiper = this;
      const {
        params,
        slides,
        slidesGrid,
        slidesSizesGrid,
        size: swiperSize,
        activeIndex
      } = swiper;
      let spv = 1;
      if (typeof params.slidesPerView === "number") return params.slidesPerView;
      if (params.centeredSlides) {
        let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
        let breakLoop;
        for (let i2 = activeIndex + 1; i2 < slides.length; i2 += 1) {
          if (slides[i2] && !breakLoop) {
            slideSize += Math.ceil(slides[i2].swiperSlideSize);
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
        for (let i2 = activeIndex - 1; i2 >= 0; i2 -= 1) {
          if (slides[i2] && !breakLoop) {
            slideSize += slides[i2].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        if (view === "current") {
          for (let i2 = activeIndex + 1; i2 < slides.length; i2 += 1) {
            const slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        } else {
          for (let i2 = activeIndex - 1; i2 >= 0; i2 -= 1) {
            const slideInView = slidesGrid[activeIndex] - slidesGrid[i2] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        }
      }
      return spv;
    }
    update() {
      const swiper = this;
      if (!swiper || swiper.destroyed) return;
      const {
        snapGrid,
        params
      } = swiper;
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
        if (imageEl.complete) {
          processLazyPreloader(swiper, imageEl);
        }
      });
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      function setTranslate2() {
        const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      let translated;
      if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
        setTranslate2();
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
          const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
          translated = swiper.slideTo(slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate2();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate = true) {
      const swiper = this;
      const currentDirection = swiper.params.direction;
      if (!newDirection) {
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
      }
      if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") {
        return swiper;
      }
      swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
      swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
      swiper.emitContainerClasses();
      swiper.params.direction = newDirection;
      swiper.slides.forEach((slideEl) => {
        if (newDirection === "vertical") {
          slideEl.style.width = "";
        } else {
          slideEl.style.height = "";
        }
      });
      swiper.emit("changeDirection");
      if (needUpdate) swiper.update();
      return swiper;
    }
    changeLanguageDirection(direction) {
      const swiper = this;
      if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
      swiper.rtl = direction === "rtl";
      swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
      if (swiper.rtl) {
        swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
        swiper.el.dir = "rtl";
      } else {
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
        swiper.el.dir = "ltr";
      }
      swiper.update();
    }
    mount(element) {
      const swiper = this;
      if (swiper.mounted) return true;
      let el = element || swiper.params.el;
      if (typeof el === "string") {
        el = document.querySelector(el);
      }
      if (!el) {
        return false;
      }
      el.swiper = swiper;
      if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
        swiper.isElement = true;
      }
      const getWrapperSelector = () => {
        return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
      };
      const getWrapper = () => {
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          const res = el.shadowRoot.querySelector(getWrapperSelector());
          return res;
        }
        return elementChildren(el, getWrapperSelector())[0];
      };
      let wrapperEl = getWrapper();
      if (!wrapperEl && swiper.params.createElements) {
        wrapperEl = createElement2("div", swiper.params.wrapperClass);
        el.append(wrapperEl);
        elementChildren(el, `.${swiper.params.slideClass}`).forEach((slideEl) => {
          wrapperEl.append(slideEl);
        });
      }
      Object.assign(swiper, {
        el,
        wrapperEl,
        slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
        hostEl: swiper.isElement ? el.parentNode.host : el,
        mounted: true,
        // RTL
        rtl: el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl",
        rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || elementStyle(el, "direction") === "rtl"),
        wrongRTL: elementStyle(wrapperEl, "display") === "-webkit-box"
      });
      return true;
    }
    init(el) {
      const swiper = this;
      if (swiper.initialized) return swiper;
      const mounted = swiper.mount(el);
      if (mounted === false) return swiper;
      swiper.emit("beforeInit");
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.addClasses();
      swiper.updateSize();
      swiper.updateSlides();
      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }
      if (swiper.params.grabCursor && swiper.enabled) {
        swiper.setGrabCursor();
      }
      if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
      }
      if (swiper.params.loop) {
        swiper.loopCreate(void 0, true);
      }
      swiper.attachEvents();
      const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
      if (swiper.isElement) {
        lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
      }
      lazyElements.forEach((imageEl) => {
        if (imageEl.complete) {
          processLazyPreloader(swiper, imageEl);
        } else {
          imageEl.addEventListener("load", (e2) => {
            processLazyPreloader(swiper, e2.target);
          });
        }
      });
      preload(swiper);
      swiper.initialized = true;
      preload(swiper);
      swiper.emit("init");
      swiper.emit("afterInit");
      return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
      const swiper = this;
      const {
        params,
        el,
        wrapperEl,
        slides
      } = swiper;
      if (typeof swiper.params === "undefined" || swiper.destroyed) {
        return null;
      }
      swiper.emit("beforeDestroy");
      swiper.initialized = false;
      swiper.detachEvents();
      if (params.loop) {
        swiper.loopDestroy();
      }
      if (cleanStyles) {
        swiper.removeClasses();
        if (el && typeof el !== "string") {
          el.removeAttribute("style");
        }
        if (wrapperEl) {
          wrapperEl.removeAttribute("style");
        }
        if (slides && slides.length) {
          slides.forEach((slideEl) => {
            slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
            slideEl.removeAttribute("style");
            slideEl.removeAttribute("data-swiper-slide-index");
          });
        }
      }
      swiper.emit("destroy");
      Object.keys(swiper.eventsListeners).forEach((eventName) => {
        swiper.off(eventName);
      });
      if (deleteInstance !== false) {
        if (swiper.el && typeof swiper.el !== "string") {
          swiper.el.swiper = null;
        }
        deleteProps(swiper);
      }
      swiper.destroyed = true;
      return null;
    }
    static extendDefaults(newDefaults) {
      extend2(extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
      return extendedDefaults;
    }
    static get defaults() {
      return defaults;
    }
    static installModule(mod) {
      if (!_Swiper.prototype.__modules__) _Swiper.prototype.__modules__ = [];
      const modules = _Swiper.prototype.__modules__;
      if (typeof mod === "function" && modules.indexOf(mod) < 0) {
        modules.push(mod);
      }
    }
    static use(module) {
      if (Array.isArray(module)) {
        module.forEach((m) => _Swiper.installModule(m));
        return _Swiper;
      }
      _Swiper.installModule(module);
      return _Swiper;
    }
  };
  Object.keys(prototypes).forEach((prototypeGroup) => {
    Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
      Swiper3.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
  });
  Swiper3.use([Resize, Observer]);

  // node_modules/swiper/shared/create-element-if-not-defined.mjs
  function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) {
      Object.keys(checkProps).forEach((key) => {
        if (!params[key] && params.auto === true) {
          let element = elementChildren(swiper.el, `.${checkProps[key]}`)[0];
          if (!element) {
            element = createElement2("div", checkProps[key]);
            element.className = checkProps[key];
            swiper.el.append(element);
          }
          params[key] = element;
          originalParams[key] = element;
        }
      });
    }
    return params;
  }

  // node_modules/swiper/modules/navigation.mjs
  var arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
  function Navigation({
    swiper,
    extendParams,
    on: on2,
    emit
  }) {
    extendParams({
      navigation: {
        nextEl: null,
        prevEl: null,
        addIcons: true,
        hideOnClick: false,
        disabledClass: "swiper-button-disabled",
        hiddenClass: "swiper-button-hidden",
        lockClass: "swiper-button-lock",
        navigationDisabledClass: "swiper-navigation-disabled"
      }
    });
    swiper.navigation = {
      nextEl: null,
      prevEl: null,
      arrowSvg
    };
    function getEl(el) {
      let res;
      if (el && typeof el === "string" && swiper.isElement) {
        res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
        if (res) return res;
      }
      if (el) {
        if (typeof el === "string") res = [...document.querySelectorAll(el)];
        if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) {
          res = swiper.el.querySelector(el);
        } else if (res && res.length === 1) {
          res = res[0];
        }
      }
      if (el && !res) return el;
      return res;
    }
    function toggleEl(el, disabled) {
      const params = swiper.params.navigation;
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        if (subEl) {
          subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
          if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
          if (swiper.params.watchOverflow && swiper.enabled) {
            subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
          }
        }
      });
    }
    function update2() {
      const {
        nextEl,
        prevEl
      } = swiper.navigation;
      if (swiper.params.loop) {
        toggleEl(prevEl, false);
        toggleEl(nextEl, false);
        return;
      }
      toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
      toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e2) {
      e2.preventDefault();
      if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
      swiper.slidePrev();
      emit("navigationPrev");
    }
    function onNextClick(e2) {
      e2.preventDefault();
      if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
      swiper.slideNext();
      emit("navigationNext");
    }
    function init() {
      const params = swiper.params.navigation;
      swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
        nextEl: "swiper-button-next",
        prevEl: "swiper-button-prev"
      });
      if (!(params.nextEl || params.prevEl)) return;
      let nextEl = getEl(params.nextEl);
      let prevEl = getEl(params.prevEl);
      Object.assign(swiper.navigation, {
        nextEl,
        prevEl
      });
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      const initButton = (el, dir) => {
        if (el) {
          if (params.addIcons && el.matches(".swiper-button-next,.swiper-button-prev") && !el.querySelector("svg")) {
            const tempEl = document.createElement("div");
            setInnerHTML(tempEl, arrowSvg);
            el.appendChild(tempEl.querySelector("svg"));
            tempEl.remove();
          }
          el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
        }
        if (!swiper.enabled && el) {
          el.classList.add(...params.lockClass.split(" "));
        }
      };
      nextEl.forEach((el) => initButton(el, "next"));
      prevEl.forEach((el) => initButton(el, "prev"));
    }
    function destroy() {
      let {
        nextEl,
        prevEl
      } = swiper.navigation;
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      const destroyButton = (el, dir) => {
        el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
        el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
      };
      nextEl.forEach((el) => destroyButton(el, "next"));
      prevEl.forEach((el) => destroyButton(el, "prev"));
    }
    on2("init", () => {
      if (swiper.params.navigation.enabled === false) {
        disable();
      } else {
        init();
        update2();
      }
    });
    on2("toEdge fromEdge lock unlock", () => {
      update2();
    });
    on2("destroy", () => {
      destroy();
    });
    on2("enable disable", () => {
      let {
        nextEl,
        prevEl
      } = swiper.navigation;
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      if (swiper.enabled) {
        update2();
        return;
      }
      [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.add(swiper.params.navigation.lockClass));
    });
    on2("click", (_s, e2) => {
      let {
        nextEl,
        prevEl
      } = swiper.navigation;
      nextEl = makeElementsArray(nextEl);
      prevEl = makeElementsArray(prevEl);
      const targetEl = e2.target;
      let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
      if (swiper.isElement && !targetIsButton) {
        const path = e2.path || e2.composedPath && e2.composedPath();
        if (path) {
          targetIsButton = path.find((pathEl) => nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
      }
      if (swiper.params.navigation.hideOnClick && !targetIsButton) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        let isHidden;
        if (nextEl.length) {
          isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
        } else if (prevEl.length) {
          isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
        }
        if (isHidden === true) {
          emit("navigationShow");
        } else {
          emit("navigationHide");
        }
        [...nextEl, ...prevEl].filter((el) => !!el).forEach((el) => el.classList.toggle(swiper.params.navigation.hiddenClass));
      }
    });
    const enable = () => {
      swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
      init();
      update2();
    };
    const disable = () => {
      swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
      destroy();
    };
    Object.assign(swiper.navigation, {
      enable,
      disable,
      update: update2,
      init,
      destroy
    });
  }

  // node_modules/swiper/shared/classes-to-selector.mjs
  function classesToSelector(classes2 = "") {
    return `.${classes2.trim().replace(/([\.:!+\/()[\]])/g, "\\$1").replace(/ /g, ".")}`;
  }

  // node_modules/swiper/modules/pagination.mjs
  function Pagination({
    swiper,
    extendParams,
    on: on2,
    emit
  }) {
    const pfx = "swiper-pagination";
    extendParams({
      pagination: {
        el: null,
        bulletElement: "span",
        clickable: false,
        hideOnClick: false,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: false,
        type: "bullets",
        // 'bullets' or 'progressbar' or 'fraction' or 'custom'
        dynamicBullets: false,
        dynamicMainBullets: 1,
        formatFractionCurrent: (number) => number,
        formatFractionTotal: (number) => number,
        bulletClass: `${pfx}-bullet`,
        bulletActiveClass: `${pfx}-bullet-active`,
        modifierClass: `${pfx}-`,
        currentClass: `${pfx}-current`,
        totalClass: `${pfx}-total`,
        hiddenClass: `${pfx}-hidden`,
        progressbarFillClass: `${pfx}-progressbar-fill`,
        progressbarOppositeClass: `${pfx}-progressbar-opposite`,
        clickableClass: `${pfx}-clickable`,
        lockClass: `${pfx}-lock`,
        horizontalClass: `${pfx}-horizontal`,
        verticalClass: `${pfx}-vertical`,
        paginationDisabledClass: `${pfx}-disabled`
      }
    });
    swiper.pagination = {
      el: null,
      bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
      return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
      const {
        bulletActiveClass
      } = swiper.params.pagination;
      if (!bulletEl) return;
      bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
      if (bulletEl) {
        bulletEl.classList.add(`${bulletActiveClass}-${position}`);
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
          bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
      }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
      prevIndex = prevIndex % length;
      nextIndex = nextIndex % length;
      if (nextIndex === prevIndex + 1) {
        return "next";
      } else if (nextIndex === prevIndex - 1) {
        return "previous";
      }
      return;
    }
    function onBulletClick(e2) {
      const bulletEl = e2.target.closest(classesToSelector(swiper.params.pagination.bulletClass));
      if (!bulletEl) {
        return;
      }
      e2.preventDefault();
      const index = elementIndex(bulletEl) * swiper.params.slidesPerGroup;
      if (swiper.params.loop) {
        if (swiper.realIndex === index) return;
        const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
        if (moveDirection === "next") {
          swiper.slideNext();
        } else if (moveDirection === "previous") {
          swiper.slidePrev();
        } else {
          swiper.slideToLoop(index);
        }
      } else {
        swiper.slideTo(index);
      }
    }
    function update2() {
      const rtl = swiper.rtl;
      const params = swiper.params.pagination;
      if (isPaginationDisabled()) return;
      let el = swiper.pagination.el;
      el = makeElementsArray(el);
      let current;
      let previousIndex;
      const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
      const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      if (swiper.params.loop) {
        previousIndex = swiper.previousRealIndex || 0;
        current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
      } else if (typeof swiper.snapIndex !== "undefined") {
        current = swiper.snapIndex;
        previousIndex = swiper.previousSnapIndex;
      } else {
        previousIndex = swiper.previousIndex || 0;
        current = swiper.activeIndex || 0;
      }
      if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
        const bullets = swiper.pagination.bullets;
        let firstIndex;
        let lastIndex;
        let midIndex;
        if (params.dynamicBullets) {
          bulletSize = elementOuterSize(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
          el.forEach((subEl) => {
            subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
          });
          if (params.dynamicMainBullets > 1 && previousIndex !== void 0) {
            dynamicBulletIndex += current - (previousIndex || 0);
            if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
              dynamicBulletIndex = params.dynamicMainBullets - 1;
            } else if (dynamicBulletIndex < 0) {
              dynamicBulletIndex = 0;
            }
          }
          firstIndex = Math.max(current - dynamicBulletIndex, 0);
          lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
          midIndex = (lastIndex + firstIndex) / 2;
        }
        bullets.forEach((bulletEl) => {
          const classesToRemove = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((suffix) => `${params.bulletActiveClass}${suffix}`)].map((s2) => typeof s2 === "string" && s2.includes(" ") ? s2.split(" ") : s2).flat();
          bulletEl.classList.remove(...classesToRemove);
        });
        if (el.length > 1) {
          bullets.forEach((bullet) => {
            const bulletIndex = elementIndex(bullet);
            if (bulletIndex === current) {
              bullet.classList.add(...params.bulletActiveClass.split(" "));
            } else if (swiper.isElement) {
              bullet.setAttribute("part", "bullet");
            }
            if (params.dynamicBullets) {
              if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
              }
              if (bulletIndex === firstIndex) {
                setSideBullets(bullet, "prev");
              }
              if (bulletIndex === lastIndex) {
                setSideBullets(bullet, "next");
              }
            }
          });
        } else {
          const bullet = bullets[current];
          if (bullet) {
            bullet.classList.add(...params.bulletActiveClass.split(" "));
          }
          if (swiper.isElement) {
            bullets.forEach((bulletEl, bulletIndex) => {
              bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
            });
          }
          if (params.dynamicBullets) {
            const firstDisplayedBullet = bullets[firstIndex];
            const lastDisplayedBullet = bullets[lastIndex];
            for (let i2 = firstIndex; i2 <= lastIndex; i2 += 1) {
              if (bullets[i2]) {
                bullets[i2].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
              }
            }
            setSideBullets(firstDisplayedBullet, "prev");
            setSideBullets(lastDisplayedBullet, "next");
          }
        }
        if (params.dynamicBullets) {
          const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
          const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
          const offsetProp = rtl ? "right" : "left";
          bullets.forEach((bullet) => {
            bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
          });
        }
      }
      el.forEach((subEl, subElIndex) => {
        if (params.type === "fraction") {
          subEl.querySelectorAll(classesToSelector(params.currentClass)).forEach((fractionEl) => {
            fractionEl.textContent = params.formatFractionCurrent(current + 1);
          });
          subEl.querySelectorAll(classesToSelector(params.totalClass)).forEach((totalEl) => {
            totalEl.textContent = params.formatFractionTotal(total);
          });
        }
        if (params.type === "progressbar") {
          let progressbarDirection;
          if (params.progressbarOpposite) {
            progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
          } else {
            progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
          }
          const scale = (current + 1) / total;
          let scaleX = 1;
          let scaleY = 1;
          if (progressbarDirection === "horizontal") {
            scaleX = scale;
          } else {
            scaleY = scale;
          }
          subEl.querySelectorAll(classesToSelector(params.progressbarFillClass)).forEach((progressEl) => {
            progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
            progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
          });
        }
        if (params.type === "custom" && params.renderCustom) {
          setInnerHTML(subEl, params.renderCustom(swiper, current + 1, total));
          if (subElIndex === 0) emit("paginationRender", subEl);
        } else {
          if (subElIndex === 0) emit("paginationRender", subEl);
          emit("paginationUpdate", subEl);
        }
        if (swiper.params.watchOverflow && swiper.enabled) {
          subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        }
      });
    }
    function render() {
      const params = swiper.params.pagination;
      if (isPaginationDisabled()) return;
      const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
      let el = swiper.pagination.el;
      el = makeElementsArray(el);
      let paginationHTML = "";
      if (params.type === "bullets") {
        let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) {
          numberOfBullets = slidesLength;
        }
        for (let i2 = 0; i2 < numberOfBullets; i2 += 1) {
          if (params.renderBullet) {
            paginationHTML += params.renderBullet.call(swiper, i2, params.bulletClass);
          } else {
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
          }
        }
      }
      if (params.type === "fraction") {
        if (params.renderFraction) {
          paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
        } else {
          paginationHTML = `<span class="${params.currentClass}"></span> / <span class="${params.totalClass}"></span>`;
        }
      }
      if (params.type === "progressbar") {
        if (params.renderProgressbar) {
          paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
        } else {
          paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
      }
      swiper.pagination.bullets = [];
      el.forEach((subEl) => {
        if (params.type !== "custom") {
          setInnerHTML(subEl, paginationHTML || "");
        }
        if (params.type === "bullets") {
          swiper.pagination.bullets.push(...subEl.querySelectorAll(classesToSelector(params.bulletClass)));
        }
      });
      if (params.type !== "custom") {
        emit("paginationRender", el[0]);
      }
    }
    function init() {
      swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
        el: "swiper-pagination"
      });
      const params = swiper.params.pagination;
      if (!params.el) return;
      let el;
      if (typeof params.el === "string" && swiper.isElement) {
        el = swiper.el.querySelector(params.el);
      }
      if (!el && typeof params.el === "string") {
        el = [...document.querySelectorAll(params.el)];
      }
      if (!el) {
        el = params.el;
      }
      if (!el || el.length === 0) return;
      if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
        el = [...swiper.el.querySelectorAll(params.el)];
        if (el.length > 1) {
          el = el.find((subEl) => {
            if (elementParents(subEl, ".swiper")[0] !== swiper.el) return false;
            return true;
          });
        }
      }
      if (Array.isArray(el) && el.length === 1) el = el[0];
      Object.assign(swiper.pagination, {
        el
      });
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        if (params.type === "bullets" && params.clickable) {
          subEl.classList.add(...(params.clickableClass || "").split(" "));
        }
        subEl.classList.add(params.modifierClass + params.type);
        subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === "bullets" && params.dynamicBullets) {
          subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
          dynamicBulletIndex = 0;
          if (params.dynamicMainBullets < 1) {
            params.dynamicMainBullets = 1;
          }
        }
        if (params.type === "progressbar" && params.progressbarOpposite) {
          subEl.classList.add(params.progressbarOppositeClass);
        }
        if (params.clickable) {
          subEl.addEventListener("click", onBulletClick);
        }
        if (!swiper.enabled) {
          subEl.classList.add(params.lockClass);
        }
      });
    }
    function destroy() {
      const params = swiper.params.pagination;
      if (isPaginationDisabled()) return;
      let el = swiper.pagination.el;
      if (el) {
        el = makeElementsArray(el);
        el.forEach((subEl) => {
          subEl.classList.remove(params.hiddenClass);
          subEl.classList.remove(params.modifierClass + params.type);
          subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
          if (params.clickable) {
            subEl.classList.remove(...(params.clickableClass || "").split(" "));
            subEl.removeEventListener("click", onBulletClick);
          }
        });
      }
      if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl) => subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on2("changeDirection", () => {
      if (!swiper.pagination || !swiper.pagination.el) return;
      const params = swiper.params.pagination;
      let {
        el
      } = swiper.pagination;
      el = makeElementsArray(el);
      el.forEach((subEl) => {
        subEl.classList.remove(params.horizontalClass, params.verticalClass);
        subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
      });
    });
    on2("init", () => {
      if (swiper.params.pagination.enabled === false) {
        disable();
      } else {
        init();
        render();
        update2();
      }
    });
    on2("activeIndexChange", () => {
      if (typeof swiper.snapIndex === "undefined") {
        update2();
      }
    });
    on2("snapIndexChange", () => {
      update2();
    });
    on2("snapGridLengthChange", () => {
      render();
      update2();
    });
    on2("destroy", () => {
      destroy();
    });
    on2("enable disable", () => {
      let {
        el
      } = swiper.pagination;
      if (el) {
        el = makeElementsArray(el);
        el.forEach((subEl) => subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
      }
    });
    on2("lock unlock", () => {
      update2();
    });
    on2("click", (_s, e2) => {
      const targetEl = e2.target;
      const el = makeElementsArray(swiper.pagination.el);
      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
        const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
        if (isHidden === true) {
          emit("paginationShow");
        } else {
          emit("paginationHide");
        }
        el.forEach((subEl) => subEl.classList.toggle(swiper.params.pagination.hiddenClass));
      }
    });
    const enable = () => {
      swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
      let {
        el
      } = swiper.pagination;
      if (el) {
        el = makeElementsArray(el);
        el.forEach((subEl) => subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
      }
      init();
      render();
      update2();
    };
    const disable = () => {
      swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
      let {
        el
      } = swiper.pagination;
      if (el) {
        el = makeElementsArray(el);
        el.forEach((subEl) => subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
      }
      destroy();
    };
    Object.assign(swiper.pagination, {
      enable,
      disable,
      render,
      update: update2,
      init,
      destroy
    });
  }

  // node_modules/swiper/modules/autoplay.mjs
  function Autoplay({
    swiper,
    extendParams,
    on: on2,
    emit,
    params
  }) {
    swiper.autoplay = {
      running: false,
      paused: false,
      timeLeft: 0
    };
    extendParams({
      autoplay: {
        enabled: false,
        delay: 3e3,
        waitForTransition: true,
        disableOnInteraction: false,
        stopOnLastSlide: false,
        reverseDirection: false,
        pauseOnMouseEnter: false
      }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3e3;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3e3;
    let autoplayTimeLeft;
    let autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e2) {
      if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
      if (e2.target !== swiper.wrapperEl) return;
      swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
      if (pausedByPointerEnter || e2.detail && e2.detail.bySwiperTouchMove) {
        return;
      }
      resume();
    }
    const calcTimeLeft = () => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      if (swiper.autoplay.paused) {
        wasPaused = true;
      } else if (wasPaused) {
        autoplayDelayCurrent = autoplayTimeLeft;
        wasPaused = false;
      }
      const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - (/* @__PURE__ */ new Date()).getTime();
      swiper.autoplay.timeLeft = timeLeft;
      emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
      raf = requestAnimationFrame(() => {
        calcTimeLeft();
      });
    };
    const getSlideDelay = () => {
      let activeSlideEl;
      if (swiper.virtual && swiper.params.virtual.enabled) {
        activeSlideEl = swiper.slides.find((slideEl) => slideEl.classList.contains("swiper-slide-active"));
      } else {
        activeSlideEl = swiper.slides[swiper.activeIndex];
      }
      if (!activeSlideEl) return void 0;
      const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
      return currentSlideDelay;
    };
    const run = (delayForce) => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      cancelAnimationFrame(raf);
      calcTimeLeft();
      let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
      autoplayDelayTotal = swiper.params.autoplay.delay;
      autoplayDelayCurrent = swiper.params.autoplay.delay;
      const currentSlideDelay = getSlideDelay();
      if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
        delay = currentSlideDelay;
        autoplayDelayTotal = currentSlideDelay;
        autoplayDelayCurrent = currentSlideDelay;
      }
      autoplayTimeLeft = delay;
      const speed = swiper.params.speed;
      const proceed = () => {
        if (!swiper || swiper.destroyed) return;
        if (swiper.params.autoplay.reverseDirection) {
          if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
            swiper.slidePrev(speed, true, true);
            emit("autoplay");
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(swiper.slides.length - 1, speed, true, true);
            emit("autoplay");
          }
        } else {
          if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
            swiper.slideNext(speed, true, true);
            emit("autoplay");
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(0, speed, true, true);
            emit("autoplay");
          }
        }
        if (swiper.params.cssMode) {
          autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
          requestAnimationFrame(() => {
            run();
          });
        }
      };
      if (delay > 0) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          proceed();
        }, delay);
      } else {
        requestAnimationFrame(() => {
          proceed();
        });
      }
      return delay;
    };
    const start = () => {
      autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
      swiper.autoplay.running = true;
      run();
      emit("autoplayStart");
    };
    const stop = () => {
      swiper.autoplay.running = false;
      clearTimeout(timeout);
      cancelAnimationFrame(raf);
      emit("autoplayStop");
    };
    const pause = (internal, reset) => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      clearTimeout(timeout);
      if (!internal) {
        pausedByInteraction = true;
      }
      const proceed = () => {
        emit("autoplayPause");
        if (swiper.params.autoplay.waitForTransition) {
          swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
        } else {
          resume();
        }
      };
      swiper.autoplay.paused = true;
      if (reset) {
        if (slideChanged) {
          autoplayTimeLeft = swiper.params.autoplay.delay;
        }
        slideChanged = false;
        proceed();
        return;
      }
      const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
      autoplayTimeLeft = delay - ((/* @__PURE__ */ new Date()).getTime() - autoplayStartTime);
      if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
      if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
      proceed();
    };
    const resume = () => {
      if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
      autoplayStartTime = (/* @__PURE__ */ new Date()).getTime();
      if (pausedByInteraction) {
        pausedByInteraction = false;
        run(autoplayTimeLeft);
      } else {
        run();
      }
      swiper.autoplay.paused = false;
      emit("autoplayResume");
    };
    const onVisibilityChange = () => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      const document2 = getDocument();
      if (document2.visibilityState === "hidden") {
        pausedByInteraction = true;
        pause(true);
      }
      if (document2.visibilityState === "visible") {
        resume();
      }
    };
    const onPointerEnter = (e2) => {
      if (e2.pointerType !== "mouse") return;
      pausedByInteraction = true;
      pausedByPointerEnter = true;
      if (swiper.animating || swiper.autoplay.paused) return;
      pause(true);
    };
    const onPointerLeave = (e2) => {
      if (e2.pointerType !== "mouse") return;
      pausedByPointerEnter = false;
      if (swiper.autoplay.paused) {
        resume();
      }
    };
    const attachMouseEvents = () => {
      if (swiper.params.autoplay.pauseOnMouseEnter) {
        swiper.el.addEventListener("pointerenter", onPointerEnter);
        swiper.el.addEventListener("pointerleave", onPointerLeave);
      }
    };
    const detachMouseEvents = () => {
      if (swiper.el && typeof swiper.el !== "string") {
        swiper.el.removeEventListener("pointerenter", onPointerEnter);
        swiper.el.removeEventListener("pointerleave", onPointerLeave);
      }
    };
    const attachDocumentEvents = () => {
      const document2 = getDocument();
      document2.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = () => {
      const document2 = getDocument();
      document2.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on2("init", () => {
      if (swiper.params.autoplay.enabled) {
        attachMouseEvents();
        attachDocumentEvents();
        start();
      }
    });
    on2("destroy", () => {
      detachMouseEvents();
      detachDocumentEvents();
      if (swiper.autoplay.running) {
        stop();
      }
    });
    on2("_freeModeStaticRelease", () => {
      if (pausedByTouch || pausedByInteraction) {
        resume();
      }
    });
    on2("_freeModeNoMomentumRelease", () => {
      if (!swiper.params.autoplay.disableOnInteraction) {
        pause(true, true);
      } else {
        stop();
      }
    });
    on2("beforeTransitionStart", (_s, speed, internal) => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      if (internal || !swiper.params.autoplay.disableOnInteraction) {
        pause(true, true);
      } else {
        stop();
      }
    });
    on2("sliderFirstMove", () => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      if (swiper.params.autoplay.disableOnInteraction) {
        stop();
        return;
      }
      isTouched = true;
      pausedByTouch = false;
      pausedByInteraction = false;
      touchStartTimeout = setTimeout(() => {
        pausedByInteraction = true;
        pausedByTouch = true;
        pause(true);
      }, 200);
    });
    on2("touchEnd", () => {
      if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
      clearTimeout(touchStartTimeout);
      clearTimeout(timeout);
      if (swiper.params.autoplay.disableOnInteraction) {
        pausedByTouch = false;
        isTouched = false;
        return;
      }
      if (pausedByTouch && swiper.params.cssMode) resume();
      pausedByTouch = false;
      isTouched = false;
    });
    on2("slideChange", () => {
      if (swiper.destroyed || !swiper.autoplay.running) return;
      slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
      start,
      stop,
      pause,
      resume
    });
  }

  // assets-src/js/_c_carousel.js
  function initCarouselSwipers() {
    const swipers = document.querySelectorAll(".carousel-swiper");
    swipers.forEach((swiperEl) => {
      const nextEl = swiperEl.querySelector(".carousel-swiper-button-next");
      const prevEl = swiperEl.querySelector(".carousel-swiper-button-prev");
      const paginationEl = swiperEl.querySelector(".carousel-swiper-pagination");
      new Swiper3(swiperEl, {
        modules: [Navigation, Pagination, Autoplay],
        direction: "horizontal",
        loop: true,
        watchOverflow: true,
        autoplay: {
          delay: 6e3,
          disableOnInteraction: false
        },
        navigation: {
          nextEl,
          prevEl
        },
        pagination: {
          el: paginationEl,
          clickable: true,
          type: "fraction"
        },
        breakpoints: {
          slidesPerView: 1,
          spaceBetween: 8,
          870: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24
          }
        }
      });
    });
  }

  // assets-src/js/_c_dialog.js
  function initDialogs() {
    const dialogs = document.querySelectorAll("dialog");
    if (dialogs.length === 0) return;
    dialogs.forEach((dialog) => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "open") {
            if (dialog.hasAttribute("open")) {
              document.body.style.overflow = "hidden";
              if (window.lenis) {
                window.lenis.destroy();
                window.lenis = null;
              }
            } else {
              document.body.style.overflow = "";
              if (!window.lenis && typeof Lenis !== "undefined") {
                window.lenis = new Lenis();
                if (typeof ScrollTrigger !== "undefined") {
                  window.lenis.on("scroll", ScrollTrigger.update);
                }
              }
            }
          }
        });
      });
      observer.observe(dialog, {
        attributes: true,
        attributeFilter: ["open"]
      });
      if (dialog.hasAttribute("open")) {
        document.body.style.overflow = "hidden";
        if (window.lenis) {
          window.lenis.destroy();
          window.lenis = null;
        }
      }
    });
  }

  // assets-src/js/_blk_accordion.js
  function initAccordionCSS() {
    document.querySelectorAll("[data-accordion-css-init]").forEach((accordion) => {
      const closeSiblings = accordion.getAttribute("data-accordion-close-siblings") === "true";
      accordion.addEventListener("click", (event2) => {
        const toggle = event2.target.closest("[data-accordion-toggle]");
        if (!toggle) return;
        const singleAccordion = toggle.closest("[data-accordion-status]");
        if (!singleAccordion) return;
        const isActive = singleAccordion.getAttribute("data-accordion-status") === "active";
        singleAccordion.setAttribute("data-accordion-status", isActive ? "not-active" : "active");
        if (closeSiblings && !isActive) {
          accordion.querySelectorAll('[data-accordion-status="active"]').forEach((sibling) => {
            if (sibling !== singleAccordion) sibling.setAttribute("data-accordion-status", "not-active");
          });
        }
      });
    });
  }

  // assets-src/js/_sec_testimonials.js
  function initTestimonialSwipers() {
    const swipers = document.querySelectorAll(".testimonial-swiper");
    swipers.forEach((swiperEl) => {
      const nextEl = swiperEl.parentElement.querySelector(".testimonial-swiper-button-next");
      const prevEl = swiperEl.parentElement.querySelector(".testimonial-swiper-button-prev");
      const paginationEl = swiperEl.parentElement.querySelector("#testimonial-swiper-pagination");
      new Swiper3(swiperEl, {
        modules: [Navigation, Pagination, Autoplay],
        direction: "horizontal",
        loop: true,
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 8,
        autoplay: {
          delay: 6e3,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        navigation: {
          nextEl,
          prevEl
        },
        pagination: {
          el: paginationEl,
          type: "fraction"
        },
        breakpoints: {
          1040: {
            slidesPerView: 3,
            spaceBetween: 18
          }
        }
      });
    });
  }

  // assets-src/js/_sec_service-filter.js
  function initServiceFilter() {
    const groups = [...document.querySelectorAll("[data-filter-group=service]")];
    if (groups.length === 0) return;
    const transitionDelay = 300;
    groups.forEach((group) => {
      const buttons = [...group.querySelectorAll("[data-filter-target]")];
      const items = [...group.querySelectorAll(".service-card")];
      const search = group.querySelector("#service-search");
      const locationTokens = /* @__PURE__ */ new Map();
      const categoryTokens = /* @__PURE__ */ new Map();
      const searchTokens = /* @__PURE__ */ new Map();
      items.forEach((el) => {
        const locations = (el.getAttribute("data-filter-location") || "").trim().toLowerCase().split(/\s+/).filter(Boolean);
        locationTokens.set(el, new Set(locations));
        const categories = (el.getAttribute("data-filter-category") || "").trim().toLowerCase().split(/\s+/).filter(Boolean);
        categoryTokens.set(el, new Set(categories));
        let searchTerms = "";
        let nameEl = el.querySelector(".service-name > .heading");
        if (nameEl) {
          searchTerms += (nameEl.innerHTML || "").trim().toLowerCase();
        }
        let descriptionEl = el.querySelector(".service-description > .richtext");
        if (descriptionEl) {
          searchTerms += (" " + (descriptionEl.innerHTML || "")).trim().toLowerCase();
        }
        let tagsEl = el.querySelector(".service-tags");
        if (tagsEl) {
          searchTerms += (" " + (searchTerms.innerHTML || "")).trim().toLowerCase();
        }
        searchTerms = searchTerms.trim().toLowerCase();
        searchTokens.set(el, searchTerms);
      });
      const setItemState = (el, on2) => {
        const next = on2 ? "active" : "not-active";
        if (el.getAttribute("data-filter-status") !== next) {
          el.setAttribute("data-filter-status", next);
          el.setAttribute("aria-hidden", on2 ? "false" : "true");
        }
      };
      const setButtonState = (btn, on2) => {
        const next = on2 ? "active" : "not-active";
        if (btn.getAttribute("data-filter-status") !== next) {
          btn.setAttribute("data-filter-status", next);
          btn.setAttribute("aria-pressed", on2 ? "true" : "false");
        }
      };
      const itemMatches = (el) => {
        return matchesLocation(el) && matchesCategory(el) && matchesSearch(el);
      };
      let activeLocationTarget = null;
      const matchesLocation = (el) => {
        if (!activeLocationTarget || activeLocationTarget === "all") return true;
        return locationTokens.get(el).has(activeLocationTarget);
      };
      let activeCategoryTarget = null;
      const matchesCategory = (el) => {
        if (!activeCategoryTarget || activeCategoryTarget === "all") return true;
        return categoryTokens.get(el).has(activeCategoryTarget);
      };
      let activeSearchTerm = null;
      const matchesSearch = (el) => {
        if (!activeSearchTerm || activeSearchTerm === "") return true;
        return searchTokens.get(el).includes(activeSearchTerm);
      };
      const paint = (rawTarget, rawType) => {
        const target = (rawTarget || "").trim().toLowerCase();
        const type = (rawType || "").trim().toLowerCase();
        if (type === "location") {
          activeLocationTarget = !target || target === "all" ? "all" : target;
        }
        if (type === "category") {
          activeCategoryTarget = !target || target === "all" ? "all" : target;
        }
        if (type === "search") {
          activeSearchTerm = !target || target === "" ? "" : target;
        }
        items.forEach((el) => {
          if (el._ft) clearTimeout(el._ft);
          const next = itemMatches(el);
          const cur = el.getAttribute("data-filter-status");
          if (cur === "active" && transitionDelay > 0) {
            el.setAttribute("data-filter-status", "transition-out");
            el._ft = setTimeout(() => {
              setItemState(el, next);
              if (next) forceRevealHeadings(el);
              el._ft = null;
            }, transitionDelay);
          } else if (transitionDelay > 0) {
            el._ft = setTimeout(() => {
              setItemState(el, next);
              if (next) forceRevealHeadings(el);
              el._ft = null;
            }, transitionDelay);
          } else {
            setItemState(el, next);
            if (next) forceRevealHeadings(el);
          }
        });
        buttons.forEach((btn) => {
          const value = (btn.getAttribute("data-filter-target") || "").trim().toLowerCase();
          const type2 = (btn.getAttribute("data-filter-type") || "").trim().toLowerCase();
          const activeTarget = type2 === "location" ? activeLocationTarget : type2 === "category" ? activeCategoryTarget : null;
          setButtonState(btn, activeTarget === "all" && value === "all" || value && value === activeTarget);
        });
      };
      group.addEventListener("click", (e2) => {
        const btn = e2.target.closest("[data-filter-target]");
        if (btn && group.contains(btn))
          paint(btn.getAttribute("data-filter-target"), btn.getAttribute("data-filter-type"));
      });
      search.addEventListener("keydown", (e2) => {
        if (e2.key === "Enter") {
          applySearchtTerm(e2);
        }
      });
      search.addEventListener("blur", (e2) => {
        applySearchtTerm(e2);
      });
      const applySearchtTerm = (e2) => {
        searchTerm = e2.target.value.trim().toLowerCase();
        if (searchTerm != activeSearchTerm) {
          paint(searchTerm, "search");
        }
      };
      paint("all", "location");
    });
  }

  // assets-src/js/_sec_faqs-section.js
  var FaqTabs = function(element) {
    this.element = element;
    this.controls = this.element.querySelector(".tab-controls");
    this.contents = this.element.querySelector(".tab-contents");
    this.marker = this.element.querySelector(".tab-marker");
    initTabs2(this);
    function initTabs2(tabs) {
      const initializedContent = [];
      tabs.controls.querySelectorAll(".tab-control").forEach(function(control, index) {
        var controlContentId = control.getAttribute("aria-controls");
        var content = tabs.contents.querySelector("#" + controlContentId);
        if (!initializedContent.includes(controlContentId)) {
          initializedContent.push(controlContentId);
          if (index === 0) {
            control.setAttribute("aria-selected", "true");
            control.setAttribute("tabindex", "0");
            if (content) {
              content.removeAttribute("hidden");
            }
            placeTabMarker(tabs, control, false);
          } else {
            control.setAttribute("aria-selected", "false");
            control.setAttribute("tabindex", "-1");
            if (content) {
              content.setAttribute("hidden", "true");
            }
          }
        }
      });
      tabs.controls.addEventListener("click", function(event2) {
        var selectedControl = event2.target.closest(".tab-control");
        var selectedContentId = selectedControl ? selectedControl.getAttribute("aria-controls") : null;
        if (selectedControl && selectedContentId) {
          tabs.controls.querySelectorAll(".tab-control").forEach(function(control) {
            control.setAttribute("aria-selected", "false");
            control.setAttribute("tabindex", "-1");
          });
          tabs.contents.querySelectorAll(".tab-content").forEach(function(content) {
            content.setAttribute("hidden", "true");
          });
          selectedControl.setAttribute("aria-selected", "true");
          selectedControl.setAttribute("tabindex", "0");
          var selectedContent = tabs.contents.querySelector("#" + selectedContentId);
          if (selectedContent) {
            selectedContent.removeAttribute("hidden");
            const swiper = selectedContent.querySelector(".swiper");
          }
          placeTabMarker(tabs, selectedControl);
        }
        var selectedContent = tabs.contents.querySelector("#" + selectedContentId);
        if (selectedContent) {
          gsap.set(selectedContent, { opacity: 0, x: -20 });
          selectedContent.removeAttribute("hidden");
          gsap.to(selectedContent, {
            opacity: 1,
            x: 0,
            duration: 0.3,
            ease: "power2.out"
          });
        }
      });
      window.addEventListener("resize", function() {
        var activeControl = tabs.controls.querySelector('.tab-control[aria-selected="true"]');
        if (activeControl) {
          placeTabMarker(tabs, activeControl, false);
        }
      });
    }
    function placeTabMarker(tabs, selectedControl, animate = true) {
      if (tabs.marker.length == 0 || !selectedControl) return;
      if (animate) {
        tabs.marker.style.transition = "all 0.3s ease-in-out";
      } else {
        tabs.marker.style.transition = "none";
      }
      const controlRect = selectedControl.getBoundingClientRect();
      const controlsRect = tabs.controls.getBoundingClientRect();
      const offsetTop = controlRect.top - controlsRect.top + tabs.marker.offsetHeight / 2;
      tabs.marker.style.transform = `translateY(${offsetTop}px)`;
    }
  };
  function initFaqTabs() {
    const tabsElements = document.querySelectorAll(".faq-tabs");
    tabsElements.forEach((tabsElement) => {
      new FaqTabs(tabsElement);
    });
  }

  // assets-src/js/_sec_post-filter.js
  function initPostFilter() {
    const groups = [...document.querySelectorAll("[data-filter-group=post]")];
    if (groups.length === 0) return;
    const transitionDelay = 300;
    groups.forEach((group) => {
      const buttons = [...group.querySelectorAll("[data-filter-target]")];
      const items = [...group.querySelectorAll(".post-card")];
      const search = group.querySelector("#post-search");
      const tagTokens = /* @__PURE__ */ new Map();
      const categoryTokens = /* @__PURE__ */ new Map();
      const searchTokens = /* @__PURE__ */ new Map();
      items.forEach((el) => {
        const tagList = el.getAttribute("data-filter-tag");
        const tags = (tagList || "").trim().toLowerCase().split(/\s+/).filter(Boolean);
        tagTokens.set(el, new Set(tags));
        const categories = (el.getAttribute("data-filter-category") || "").trim().toLowerCase().split(/\s+/).filter(Boolean);
        categoryTokens.set(el, new Set(categories));
        let searchTerms = "";
        let nameEl = el.querySelector(".post-info > .post-title");
        if (nameEl) {
          searchTerms += (nameEl.innerHTML || "").trim().toLowerCase();
        }
        let descriptionEl = el.querySelector(".post-info > .post-excerpt");
        if (descriptionEl) {
          searchTerms += (" " + (descriptionEl.innerHTML || "")).trim().toLowerCase();
        }
        if (tagList) {
          searchTerms += (" " + tagList).trim().toLowerCase();
        }
        searchTerms = searchTerms.trim().toLowerCase();
        searchTokens.set(el, searchTerms);
      });
      console.log("Category Tokens:");
      console.log(categoryTokens);
      const setItemState = (el, on2) => {
        const next = on2 ? "active" : "not-active";
        if (el.getAttribute("data-filter-status") !== next) {
          el.setAttribute("data-filter-status", next);
          el.setAttribute("aria-hidden", on2 ? "false" : "true");
        }
      };
      const setButtonState = (btn, on2) => {
        const next = on2 ? "active" : "not-active";
        if (btn.getAttribute("data-filter-status") !== next) {
          btn.setAttribute("data-filter-status", next);
          btn.setAttribute("aria-pressed", on2 ? "true" : "false");
        }
      };
      const itemMatches = (el) => {
        return matchesTag(el) && matchesCategory(el) && matchesSearch(el);
      };
      let activeTagTarget = null;
      const matchesTag = (el) => {
        console.log("Active Tag Target: " + activeTagTarget);
        if (!activeTagTarget || activeTagTarget === "all") return true;
        return tagTokens.get(el).has(activeTagTarget);
      };
      let activeCategoryTarget = null;
      const matchesCategory = (el) => {
        if (!activeCategoryTarget || activeCategoryTarget === "all") return true;
        return categoryTokens.get(el).has(activeCategoryTarget);
      };
      let activeSearchTerm = null;
      const matchesSearch = (el) => {
        if (!activeSearchTerm || activeSearchTerm === "") return true;
        return searchTokens.get(el).includes(activeSearchTerm);
      };
      const paint = (rawTarget, rawType) => {
        const target = (rawTarget || "").trim().toLowerCase();
        const type = (rawType || "").trim().toLowerCase();
        console.log("Painting");
        console.log("Type: " + type);
        console.log("Target: " + target);
        if (type === "tag") {
          console.log("Setting active tag target.");
          activeTagTarget = !target || target === "all" ? "all" : target;
        }
        if (type === "category") {
          console.log("Setting active category target.");
          activeCategoryTarget = !target || target === "all" ? "all" : target;
        }
        if (type === "search") {
          console.log("Setting active search term.");
          activeSearchTerm = !target || target === "" ? "" : target;
        }
        items.forEach((el) => {
          if (el._ft) clearTimeout(el._ft);
          const next = itemMatches(el);
          const cur = el.getAttribute("data-filter-status");
          if (cur === "active" && transitionDelay > 0) {
            el.setAttribute("data-filter-status", "transition-out");
            el._ft = setTimeout(() => {
              setItemState(el, next);
              el._ft = null;
            }, transitionDelay);
          } else if (transitionDelay > 0) {
            el._ft = setTimeout(() => {
              setItemState(el, next);
              el._ft = null;
            }, transitionDelay);
          } else {
            setItemState(el, next);
          }
        });
        buttons.forEach((btn) => {
          const value = (btn.getAttribute("data-filter-target") || "").trim().toLowerCase();
          const type2 = (btn.getAttribute("data-filter-type") || "").trim().toLowerCase();
          const activeTarget = type2 === "tag" ? activeTagTarget : type2 === "category" ? activeCategoryTarget : null;
          setButtonState(btn, activeTarget === "all" && value === "all" || value && value === activeTarget);
        });
      };
      group.addEventListener("click", (e2) => {
        const btn = e2.target.closest("[data-filter-target]");
        if (btn && group.contains(btn))
          paint(btn.getAttribute("data-filter-target"), btn.getAttribute("data-filter-type"));
      });
      search.addEventListener("keydown", (e2) => {
        if (e2.key === "Enter") {
          applySearchtTerm(e2);
        }
      });
      search.addEventListener("blur", (e2) => {
        applySearchtTerm(e2);
      });
      const applySearchtTerm = (e2) => {
        searchTerm = e2.target.value.trim().toLowerCase();
        if (searchTerm != activeSearchTerm) {
          paint(searchTerm, "search");
        }
      };
      paint("all", "category");
    });
  }

  // assets-src/js/_p_dropdown.js
  function initDropDowns() {
    document.querySelectorAll("el-dropdown").forEach((dropdown) => {
      const button = dropdown.querySelector("button");
      const buttonText = button.querySelector(".button-text");
      dropdown.setAttribute("data-default-text", buttonText.innerHTML);
      dropdown.querySelectorAll("[role=menuitem]").forEach((option) => {
        option.addEventListener("click", () => {
          var text = option.innerHTML;
          if (option.hasAttribute("data-filter-target")) {
            if (option.getAttribute("data-filter-target") == "all") {
              text = dropdown.getAttribute("data-default-text");
              button.classList.remove("selection");
            } else {
              button.classList.add("selection");
            }
          }
          if (buttonText) buttonText.innerHTML = text;
        });
      });
    });
  }

  // assets-src/js/_p_mobile-menu.js
  function initMobileMenu2() {
    const dialogs = document.querySelectorAll("#mobile-navigation");
    if (dialogs.length === 0) return;
    dialogs.forEach((dialog) => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "data-menu-status") {
            const menu_status = dialog.getAttribute("data-menu-status");
            if (menu_status == "open") {
              document.body.style.overflow = "hidden";
              if (window.lenis) {
                window.lenis.destroy();
                window.lenis = null;
              }
            } else {
              document.body.style.overflow = "";
              if (!window.lenis && typeof Lenis !== "undefined") {
                window.lenis = new Lenis({ anchors: true });
                if (typeof ScrollTrigger !== "undefined") {
                  window.lenis.on("scroll", ScrollTrigger.update);
                }
              }
            }
          }
        });
      });
      observer.observe(dialog, {
        attributes: true,
        attributeFilter: ["data-menu-status"]
      });
      const initial_status = dialog.getAttribute("data-menu-status");
      if (initial_status == "open") {
        document.body.style.overflow = "hidden";
        if (window.lenis) {
          window.lenis.destroy();
          window.lenis = null;
        }
      }
    });
  }

  // assets-src/js/_sec_tabs.js
  function initTabs() {
    const tabs = new Swiper(".tab-selector .swiper", {
      centeredSlides: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        disabledClass: "hidden!"
      },
      slidesPerView: 1,
      slidesOffsetAfter: 0,
      spaceBetween: 16,
      pagination: {
        el: "#swiper-pagination-tab-selector",
        enabled: true,
        clickable: true,
        renderBullet: function(index, className) {
          const slides = document.querySelectorAll(".tab-selector .swiper-slide");
          const slideTitle = slides[index]?.getAttribute("data-swiper-slide-title") || index + 1;
          return '<span class="' + className + '">' + slideTitle + "</span>";
        }
      }
    });
  }

  // assets-src/js/_sec_post-content.js
  function applyPlaxToBlogContent() {
    const postContent = document.querySelector(".post-content");
    const images = postContent?.querySelectorAll("img");
    images?.forEach((img) => {
      const wrapper = document.createElement("div");
      wrapper.className = "relative overflow-hidden h-full w-full";
      img.parentNode.insertBefore(wrapper, img);
      wrapper.appendChild(img);
      img.className = img.className + " size-full rounded-inherit plax-img object-cover";
      wrapper.parentElement.className = "h-full w-full";
    });
  }

  // assets-src/js/input.js
  function initAll() {
    initAddToCart();
    initBxgy();
    initCart();
    initCartDrawer();
    initCartRelatedProducts();
    initCartVariantEditor();
    initDialogs();
    initGalleryCarousel();
    initGridLayoutFlip();
    initHeroTabs();
    initHighlightText();
    initLucide();
    initMarqueeScrollDirection();
    initMaskedTextReveal();
    applyPlaxToBlogContent();
    initParallaxImg();
    initNavBar();
    initAccordionCSS();
    initNavigation();
    initParallaxImageGalleryThumbnails();
    initLocationFilter("provider");
    initLocationFilter("membership");
    initScrollToAnchorLenis();
    initSearch();
    initSpendXGetY();
    initSpotlightScrollingMedia();
    initTicker();
    initVariantSelector();
    initCarouselSwipers();
    initServiceCategoryTabs();
    initTestimonialSwipers();
    initServiceFilter();
    initMoreServicesAccordions();
    initFaqTabs();
    initPostFilter();
    initDropDowns();
    initMobileMenu2();
    initTabs();
  }
  window.initCart = initCart;
  document.addEventListener("DOMContentLoaded", () => {
    console.log("Bundle loaded successfully!");
    initAll();
  });
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
      console.log("Shopify shopify:section:load initAll()");
      initAll();
    });
    document.addEventListener("shopify:section:reorder", () => {
      console.log("Shopify shopify:section:reorder initAll()");
      initAll();
    });
  }
})();
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle, jack@greensock.com
 */
/*!
 * ScrollTrigger 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle, jack@greensock.com
 */
/*!
 * Observer 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle, jack@greensock.com
 */
/*!
 * Physics2DPlugin 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle, jack@greensock.com
 */
/*!
 * InertiaPlugin 3.14.1
 * https://gsap.com
 *
 * @license Copyright 2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle, jack@greensock.com
 */
/*!
 * CustomEase 3.12.7
 * https://gsap.com
 *
 * @license Copyright 2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license or for Club GSAP members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */
/*!
 * Flip 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle, jack@greensock.com
 */
/*!
 * SplitText 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2025, GreenSock. All rights reserved. Subject to the terms at https://gsap.com/standard-license.
 * @author: Jack Doyle
 */
/*! Bundled license information:

lucide/dist/esm/defaultAttributes.js:
lucide/dist/esm/createElement.js:
lucide/dist/esm/replaceElement.js:
lucide/dist/esm/icons/arrow-left.js:
lucide/dist/esm/icons/arrow-right.js:
lucide/dist/esm/icons/check.js:
lucide/dist/esm/icons/chevron-down.js:
lucide/dist/esm/icons/chevron-left.js:
lucide/dist/esm/icons/chevron-right.js:
lucide/dist/esm/icons/circle-alert.js:
lucide/dist/esm/icons/circle-check.js:
lucide/dist/esm/icons/gift.js:
lucide/dist/esm/icons/grid-2x2.js:
lucide/dist/esm/icons/grid-3x3.js:
lucide/dist/esm/icons/image.js:
lucide/dist/esm/icons/info.js:
lucide/dist/esm/icons/menu.js:
lucide/dist/esm/icons/move-left.js:
lucide/dist/esm/icons/move-right.js:
lucide/dist/esm/icons/search-x.js:
lucide/dist/esm/icons/search.js:
lucide/dist/esm/icons/shopping-bag.js:
lucide/dist/esm/icons/tag.js:
lucide/dist/esm/icons/trash-2.js:
lucide/dist/esm/icons/truck.js:
lucide/dist/esm/icons/user.js:
lucide/dist/esm/icons/x.js:
lucide/dist/esm/lucide.js:
  (**
   * @license lucide v0.556.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   *)

@tailwindplus/elements/dist/index.js:
  (*! @tailwindplus/elements v1.0.19 | Proprietary License | https://tailwindcss.com/plus/license *)
*/
